/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/pre/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(291);
	module.exports = __webpack_require__(321);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(29);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(11);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 4 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 5 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var DOMProperty = __webpack_require__(26);
	var ReactDOMComponentFlags = __webpack_require__(114);
	
	var invariant = __webpack_require__(2);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(366);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 9 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	// bufferish.js
	
	var Buffer = exports.global = __webpack_require__(186);
	var hasBuffer = exports.hasBuffer = Buffer && !!Buffer.isBuffer;
	var hasArrayBuffer = exports.hasArrayBuffer = ("undefined" !== typeof ArrayBuffer);
	
	var isArray = exports.isArray = __webpack_require__(56);
	exports.isArrayBuffer = hasArrayBuffer ? isArrayBuffer : _false;
	var isBuffer = exports.isBuffer = hasBuffer ? Buffer.isBuffer : _false;
	var isView = exports.isView = hasArrayBuffer ? (ArrayBuffer.isView || _is("ArrayBuffer", "buffer")) : _false;
	
	exports.alloc = alloc;
	exports.concat = concat;
	exports.from = from;
	
	var BufferArray = exports.Array = __webpack_require__(188);
	var BufferBuffer = exports.Buffer = __webpack_require__(189);
	var BufferUint8Array = exports.Uint8Array = __webpack_require__(190);
	var BufferProto = exports.prototype = __webpack_require__(58);
	
	/**
	 * @param value {Array|ArrayBuffer|Buffer|String}
	 * @returns {Buffer|Uint8Array|Array}
	 */
	
	function from(value) {
	  if (typeof value === "string") {
	    return fromString.call(this, value);
	  } else {
	    return auto(this).from(value);
	  }
	}
	
	/**
	 * @param size {Number}
	 * @returns {Buffer|Uint8Array|Array}
	 */
	
	function alloc(size) {
	  return auto(this).alloc(size);
	}
	
	/**
	 * @param list {Array} array of (Buffer|Uint8Array|Array)s
	 * @param [length]
	 * @returns {Buffer|Uint8Array|Array}
	 */
	
	function concat(list, length) {
	  if (!length) {
	    length = 0;
	    Array.prototype.forEach.call(list, dryrun);
	  }
	  var ref = (this !== exports) && this || list[0];
	  var result = alloc.call(ref, length);
	  var offset = 0;
	  Array.prototype.forEach.call(list, append);
	  return result;
	
	  function dryrun(buffer) {
	    length += buffer.length;
	  }
	
	  function append(buffer) {
	    offset += BufferProto.copy.call(buffer, result, offset);
	  }
	}
	
	var _isArrayBuffer = _is("ArrayBuffer");
	
	function isArrayBuffer(value) {
	  return (value instanceof ArrayBuffer) || _isArrayBuffer(value);
	}
	
	/**
	 * @private
	 */
	
	function fromString(value) {
	  var expected = value.length * 3;
	  var that = alloc.call(this, expected);
	  var actual = BufferProto.write.call(that, value);
	  if (expected !== actual) {
	    that = BufferProto.slice.call(that, 0, actual);
	  }
	  return that;
	}
	
	function auto(that) {
	  return isBuffer(that) ? BufferBuffer
	    : isView(that) ? BufferUint8Array
	    : isArray(that) ? BufferArray
	    : hasBuffer ? BufferBuffer
	    : hasArrayBuffer ? BufferUint8Array
	    : BufferArray;
	}
	
	function _false() {
	  return false;
	}
	
	function _is(name, key) {
	  /* jshint eqnull:true */
	  name = "[object " + name + "]";
	  return function(value) {
	    return (value != null) && {}.toString.call(key ? value[key] : value) === name;
	  };
	}

/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(5);
	
	var CallbackQueue = __webpack_require__(112);
	var PooledClass = __webpack_require__(21);
	var ReactFeatureFlags = __webpack_require__(117);
	var ReactReconciler = __webpack_require__(27);
	var Transaction = __webpack_require__(44);
	
	var invariant = __webpack_require__(2);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.1.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(89)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$1 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb$1 = ((function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	}))(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = d3Color.rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	var array = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(nb),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var number = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var string = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var value = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	      : b instanceof d3Color.color ? rgb$1
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : isNaN(b) ? object
	      : number)(a, b);
	};
	
	var round = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var zoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb$1;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var PooledClass = __webpack_require__(21);
	
	var emptyFunction = __webpack_require__(11);
	var warning = __webpack_require__(3);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 17 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(array, f) {
	  var n = array.length,
	      m = 0,
	      a,
	      d,
	      s = 0,
	      i = -1,
	      j = 0;
	
	  if (f == null) {
	    while (++i < n) {
	      if (!isNaN(a = number(array[i]))) {
	        d = a - m;
	        m += d / ++j;
	        s += d * (a - m);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(a = number(f(array[i], i, array)))) {
	        d = a - m;
	        m += d / ++j;
	        s += d * (a - m);
	      }
	    }
	  }
	
	  if (j > 1) return s / (j - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(array, f) {
	  var i = -1,
	      n = array.length,
	      a,
	      b,
	      c;
	
	  if (f == null) {
	    while (++i < n) if ((b = array[i]) != null && b >= b) { a = c = b; break; }
	    while (++i < n) if ((b = array[i]) != null) {
	      if (a > b) a = b;
	      if (c < b) c = b;
	    }
	  }
	
	  else {
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = c = b; break; }
	    while (++i < n) if ((b = f(array[i], i, array)) != null) {
	      if (a > b) a = b;
	      if (c < b) c = b;
	    }
	  }
	
	  return [a, c];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var step = tickStep(start, stop, count);
	  return range(
	    Math.ceil(start / step) * step,
	    Math.floor(stop / step) * step + step / 2, // inclusive
	    step
	  );
	};
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) tz = ticks(x0, x1, tz);
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] >= x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var quantile = function(array, p, f) {
	  if (f == null) f = number;
	  if (!(n = array.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +f(array[0], 0, array);
	  if (p >= 1) return +f(array[n - 1], n - 1, array);
	  var n,
	      h = (n - 1) * p,
	      i = Math.floor(h),
	      a = +f(array[i], i, array),
	      b = +f(array[i + 1], i + 1, array);
	  return a + (b - a) * (h - i);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(array, f) {
	  var i = -1,
	      n = array.length,
	      a,
	      b;
	
	  if (f == null) {
	    while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	  }
	
	  else {
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b > a) a = b;
	  }
	
	  return a;
	};
	
	var mean = function(array, f) {
	  var s = 0,
	      n = array.length,
	      a,
	      i = -1,
	      j = n;
	
	  if (f == null) {
	    while (++i < n) if (!isNaN(a = number(array[i]))) s += a; else --j;
	  }
	
	  else {
	    while (++i < n) if (!isNaN(a = number(f(array[i], i, array)))) s += a; else --j;
	  }
	
	  if (j) return s / j;
	};
	
	var median = function(array, f) {
	  var numbers = [],
	      n = array.length,
	      a,
	      i = -1;
	
	  if (f == null) {
	    while (++i < n) if (!isNaN(a = number(array[i]))) numbers.push(a);
	  }
	
	  else {
	    while (++i < n) if (!isNaN(a = number(f(array[i], i, array)))) numbers.push(a);
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(array, f) {
	  var i = -1,
	      n = array.length,
	      a,
	      b;
	
	  if (f == null) {
	    while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	  }
	
	  else {
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = f(array[i], i, array)) != null && a > b) a = b;
	  }
	
	  return a;
	};
	
	var pairs = function(array) {
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = [p, p = array[++i]];
	  return pairs;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(array, compare) {
	  if (!(n = array.length)) return;
	  var i = 0,
	      n,
	      j = 0,
	      xi,
	      xj = array[j];
	
	  if (!compare) compare = ascending;
	
	  while (++i < n) if (compare(xi = array[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(array, f) {
	  var s = 0,
	      n = array.length,
	      a,
	      i = -1;
	
	  if (f == null) {
	    while (++i < n) if (a = +array[i]) s += a; // Note: zero and null are equivalent.
	  }
	
	  else {
	    while (++i < n) if (a = +f(array[i], i, array)) s += a;
	  }
	
	  return s;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(13);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ },
/* 21 */
[367, 4],
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  // Computes the decimal coefficient and exponent of the specified number x with
	  // significant digits p, where x is positive and p is in [1, 21] or undefined.
	  // For example, formatDecimal(1.23) returns ["123", 0].
	  function formatDecimal(x, p) {
	    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	    var i, coefficient = x.slice(0, i);
	
	    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	    return [
	      coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	      +x.slice(i + 1)
	    ];
	  }
	
	  function exponent(x) {
	    return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	  }
	
	  function formatGroup(grouping, thousands) {
	    return function(value, width) {
	      var i = value.length,
	          t = [],
	          j = 0,
	          g = grouping[0],
	          length = 0;
	
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = grouping[j = (j + 1) % grouping.length];
	      }
	
	      return t.reverse().join(thousands);
	    };
	  }
	
	  function formatDefault(x, p) {
	    x = x.toPrecision(p);
	
	    out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	      switch (x[i]) {
	        case ".": i0 = i1 = i; break;
	        case "0": if (i0 === 0) i0 = i; i1 = i; break;
	        case "e": break out;
	        default: if (i0 > 0) i0 = 0; break;
	      }
	    }
	
	    return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	  }
	
	  var prefixExponent;
	
	  function formatPrefixAuto(x, p) {
	    var d = formatDecimal(x, p);
	    if (!d) return x + "";
	    var coefficient = d[0],
	        exponent = d[1],
	        i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	        n = coefficient.length;
	    return i === n ? coefficient
	        : i > n ? coefficient + new Array(i - n + 1).join("0")
	        : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	        : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	  }
	
	  function formatRounded(x, p) {
	    var d = formatDecimal(x, p);
	    if (!d) return x + "";
	    var coefficient = d[0],
	        exponent = d[1];
	    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	        : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	        : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	  }
	
	  var formatTypes = {
	    "": formatDefault,
	    "%": function(x, p) { return (x * 100).toFixed(p); },
	    "b": function(x) { return Math.round(x).toString(2); },
	    "c": function(x) { return x + ""; },
	    "d": function(x) { return Math.round(x).toString(10); },
	    "e": function(x, p) { return x.toExponential(p); },
	    "f": function(x, p) { return x.toFixed(p); },
	    "g": function(x, p) { return x.toPrecision(p); },
	    "o": function(x) { return Math.round(x).toString(8); },
	    "p": function(x, p) { return formatRounded(x * 100, p); },
	    "r": formatRounded,
	    "s": formatPrefixAuto,
	    "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	    "x": function(x) { return Math.round(x).toString(16); }
	  };
	
	  // [[fill]align][sign][symbol][0][width][,][.precision][type]
	  var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	  function formatSpecifier(specifier) {
	    return new FormatSpecifier(specifier);
	  }
	
	  function FormatSpecifier(specifier) {
	    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	    var match,
	        fill = match[1] || " ",
	        align = match[2] || ">",
	        sign = match[3] || "-",
	        symbol = match[4] || "",
	        zero = !!match[5],
	        width = match[6] && +match[6],
	        comma = !!match[7],
	        precision = match[8] && +match[8].slice(1),
	        type = match[9] || "";
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // Map invalid types to the default format.
	    else if (!formatTypes[type]) type = "";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    this.fill = fill;
	    this.align = align;
	    this.sign = sign;
	    this.symbol = symbol;
	    this.zero = zero;
	    this.width = width;
	    this.comma = comma;
	    this.precision = precision;
	    this.type = type;
	  }
	
	  FormatSpecifier.prototype.toString = function() {
	    return this.fill
	        + this.align
	        + this.sign
	        + this.symbol
	        + (this.zero ? "0" : "")
	        + (this.width == null ? "" : Math.max(1, this.width | 0))
	        + (this.comma ? "," : "")
	        + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	        + this.type;
	  };
	
	  var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	  function identity(x) {
	    return x;
	  }
	
	  function formatLocale(locale) {
	    var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	        currency = locale.currency,
	        decimal = locale.decimal;
	
	    function newFormat(specifier) {
	      specifier = formatSpecifier(specifier);
	
	      var fill = specifier.fill,
	          align = specifier.align,
	          sign = specifier.sign,
	          symbol = specifier.symbol,
	          zero = specifier.zero,
	          width = specifier.width,
	          comma = specifier.comma,
	          precision = specifier.precision,
	          type = specifier.type;
	
	      // Compute the prefix and suffix.
	      // For SI-prefix, the suffix is lazily computed.
	      var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	          suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? "%" : "";
	
	      // What format function should we use?
	      // Is this an integer type?
	      // Can this type generate exponential notation?
	      var formatType = formatTypes[type],
	          maybeSuffix = !type || /[defgprs%]/.test(type);
	
	      // Set the default precision if not specified,
	      // or clamp the specified precision to the supported range.
	      // For significant precision, it must be in [1, 21].
	      // For fixed precision, it must be in [0, 20].
	      precision = precision == null ? (type ? 6 : 12)
	          : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	          : Math.max(0, Math.min(20, precision));
	
	      function format(value) {
	        var valuePrefix = prefix,
	            valueSuffix = suffix,
	            i, n, c;
	
	        if (type === "c") {
	          valueSuffix = formatType(value) + valueSuffix;
	          value = "";
	        } else {
	          value = +value;
	
	          // Convert negative to positive, and compute the prefix.
	          // Note that -0 is not less than 0, but 1 / -0 is!
	          var valueNegative = (value < 0 || 1 / value < 0) && (value *= -1, true);
	
	          // Perform the initial formatting.
	          value = formatType(value, precision);
	
	          // If the original value was negative, it may be rounded to zero during
	          // formatting; treat this as (positive) zero.
	          if (valueNegative) {
	            i = -1, n = value.length;
	            valueNegative = false;
	            while (++i < n) {
	              if (c = value.charCodeAt(i), (48 < c && c < 58)
	                  || (type === "x" && 96 < c && c < 103)
	                  || (type === "X" && 64 < c && c < 71)) {
	                valueNegative = true;
	                break;
	              }
	            }
	          }
	
	          // Compute the prefix and suffix.
	          valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	          valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");
	
	          // Break the formatted value into the integer “value” part that can be
	          // grouped, and fractional or exponential “suffix” part that is not.
	          if (maybeSuffix) {
	            i = -1, n = value.length;
	            while (++i < n) {
	              if (c = value.charCodeAt(i), 48 > c || c > 57) {
	                valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	                value = value.slice(0, i);
	                break;
	              }
	            }
	          }
	        }
	
	        // If the fill character is not "0", grouping is applied before padding.
	        if (comma && !zero) value = group(value, Infinity);
	
	        // Compute the padding.
	        var length = valuePrefix.length + value.length + valueSuffix.length,
	            padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	        // If the fill character is "0", grouping is applied after padding.
	        if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	        // Reconstruct the final output based on the desired alignment.
	        switch (align) {
	          case "<": return valuePrefix + value + valueSuffix + padding;
	          case "=": return valuePrefix + padding + value + valueSuffix;
	          case "^": return padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
	        }
	        return padding + valuePrefix + value + valueSuffix;
	      }
	
	      format.toString = function() {
	        return specifier + "";
	      };
	
	      return format;
	    }
	
	    function formatPrefix(specifier, value) {
	      var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	          e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	          k = Math.pow(10, -e),
	          prefix = prefixes[8 + e / 3];
	      return function(value) {
	        return f(k * value) + prefix;
	      };
	    }
	
	    return {
	      format: newFormat,
	      formatPrefix: formatPrefix
	    };
	  }
	
	  var locale;
	  defaultLocale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [3],
	    currency: ["$", ""]
	  });
	
	  function defaultLocale(definition) {
	    locale = formatLocale(definition);
	    exports.format = locale.format;
	    exports.formatPrefix = locale.formatPrefix;
	    return locale;
	  }
	
	  function precisionFixed(step) {
	    return Math.max(0, -exponent(Math.abs(step)));
	  }
	
	  function precisionPrefix(step, value) {
	    return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	  }
	
	  function precisionRound(step, max) {
	    step = Math.abs(step), max = Math.abs(max) - step;
	    return Math.max(0, exponent(max) - exponent(step)) + 1;
	  }
	
	  exports.formatDefaultLocale = defaultLocale;
	  exports.formatLocale = formatLocale;
	  exports.formatSpecifier = formatSpecifier;
	  exports.precisionFixed = precisionFixed;
	  exports.precisionPrefix = precisionPrefix;
	  exports.precisionRound = precisionRound;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 24 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(63);
	var setInnerHTML = __webpack_require__(46);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(71);
	var setTextContent = __webpack_require__(129);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(2);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(238);
	var ReactInstrumentation = __webpack_require__(12);
	
	var warning = __webpack_require__(3);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var ReactChildren = __webpack_require__(344);
	var ReactComponent = __webpack_require__(86);
	var ReactPureComponent = __webpack_require__(349);
	var ReactClass = __webpack_require__(345);
	var ReactDOMFactories = __webpack_require__(346);
	var ReactElement = __webpack_require__(30);
	var ReactPropTypes = __webpack_require__(347);
	var ReactVersion = __webpack_require__(350);
	
	var onlyChild = __webpack_require__(351);
	var warning = __webpack_require__(3);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(17);
	
	var warning = __webpack_require__(3);
	var canDefineProperty = __webpack_require__(145);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(143);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 31 */
4,
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var EventPluginRegistry = __webpack_require__(64);
	var EventPluginUtils = __webpack_require__(65);
	var ReactErrorUtils = __webpack_require__(69);
	
	var accumulateInto = __webpack_require__(123);
	var forEachAccumulated = __webpack_require__(124);
	var invariant = __webpack_require__(2);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(33);
	var EventPluginUtils = __webpack_require__(65);
	
	var accumulateInto = __webpack_require__(123);
	var forEachAccumulated = __webpack_require__(124);
	var warning = __webpack_require__(3);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 35 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	var getEventTarget = __webpack_require__(74);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-axis/ Version 1.0.4. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var slice = Array.prototype.slice;
	
	var identity = function(x) {
	  return x;
	};
	
	var top = 1;
	var right = 2;
	var bottom = 3;
	var left = 4;
	var epsilon = 1e-6;
	
	function translateX(scale0, scale1, d) {
	  var x = scale0(d);
	  return "translate(" + (isFinite(x) ? x : scale1(d)) + ",0)";
	}
	
	function translateY(scale0, scale1, d) {
	  var y = scale0(d);
	  return "translate(0," + (isFinite(y) ? y : scale1(d)) + ")";
	}
	
	function center(scale) {
	  var offset = scale.bandwidth() / 2;
	  if (scale.round()) offset = Math.round(offset);
	  return function(d) {
	    return scale(d) + offset;
	  };
	}
	
	function entering() {
	  return !this.__axis;
	}
	
	function axis(orient, scale) {
	  var tickArguments = [],
	      tickValues = null,
	      tickFormat = null,
	      tickSizeInner = 6,
	      tickSizeOuter = 6,
	      tickPadding = 3;
	
	  function axis(context) {
	    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
	        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity) : tickFormat,
	        spacing = Math.max(tickSizeInner, 0) + tickPadding,
	        transform = orient === top || orient === bottom ? translateX : translateY,
	        range = scale.range(),
	        range0 = range[0] + 0.5,
	        range1 = range[range.length - 1] + 0.5,
	        position = (scale.bandwidth ? center : identity)(scale.copy()),
	        selection = context.selection ? context.selection() : context,
	        path = selection.selectAll(".domain").data([null]),
	        tick = selection.selectAll(".tick").data(values, scale).order(),
	        tickExit = tick.exit(),
	        tickEnter = tick.enter().append("g").attr("class", "tick"),
	        line = tick.select("line"),
	        text = tick.select("text"),
	        k = orient === top || orient === left ? -1 : 1,
	        x, y = orient === left || orient === right ? (x = "x", "y") : (x = "y", "x");
	
	    path = path.merge(path.enter().insert("path", ".tick")
	        .attr("class", "domain")
	        .attr("stroke", "#000"));
	
	    tick = tick.merge(tickEnter);
	
	    line = line.merge(tickEnter.append("line")
	        .attr("stroke", "#000")
	        .attr(x + "2", k * tickSizeInner)
	        .attr(y + "1", 0.5)
	        .attr(y + "2", 0.5));
	
	    text = text.merge(tickEnter.append("text")
	        .attr("fill", "#000")
	        .attr(x, k * spacing)
	        .attr(y, 0.5)
	        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
	
	    if (context !== selection) {
	      path = path.transition(context);
	      tick = tick.transition(context);
	      line = line.transition(context);
	      text = text.transition(context);
	
	      tickExit = tickExit.transition(context)
	          .attr("opacity", epsilon)
	          .attr("transform", function(d) { return transform(position, this.parentNode.__axis || position, d); });
	
	      tickEnter
	          .attr("opacity", epsilon)
	          .attr("transform", function(d) { return transform(this.parentNode.__axis || position, position, d); });
	    }
	
	    tickExit.remove();
	
	    path
	        .attr("d", orient === left || orient == right
	            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
	            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);
	
	    tick
	        .attr("opacity", 1)
	        .attr("transform", function(d) { return transform(position, position, d); });
	
	    line
	        .attr(x + "2", k * tickSizeInner);
	
	    text
	        .attr(x, k * spacing)
	        .text(format);
	
	    selection.filter(entering)
	        .attr("fill", "none")
	        .attr("font-size", 10)
	        .attr("font-family", "sans-serif")
	        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
	
	    selection
	        .each(function() { this.__axis = position; });
	  }
	
	  axis.scale = function(_) {
	    return arguments.length ? (scale = _, axis) : scale;
	  };
	
	  axis.ticks = function() {
	    return tickArguments = slice.call(arguments), axis;
	  };
	
	  axis.tickArguments = function(_) {
	    return arguments.length ? (tickArguments = _ == null ? [] : slice.call(_), axis) : tickArguments.slice();
	  };
	
	  axis.tickValues = function(_) {
	    return arguments.length ? (tickValues = _ == null ? null : slice.call(_), axis) : tickValues && tickValues.slice();
	  };
	
	  axis.tickFormat = function(_) {
	    return arguments.length ? (tickFormat = _, axis) : tickFormat;
	  };
	
	  axis.tickSize = function(_) {
	    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeInner = function(_) {
	    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeOuter = function(_) {
	    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
	  };
	
	  axis.tickPadding = function(_) {
	    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
	  };
	
	  return axis;
	}
	
	function axisTop(scale) {
	  return axis(top, scale);
	}
	
	function axisRight(scale) {
	  return axis(right, scale);
	}
	
	function axisBottom(scale) {
	  return axis(bottom, scale);
	}
	
	function axisLeft(scale) {
	  return axis(left, scale);
	}
	
	exports.axisTop = axisTop;
	exports.axisRight = axisRight;
	exports.axisBottom = axisBottom;
	exports.axisLeft = axisLeft;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-selection/ Version 1.0.3. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var xhtml = "http://www.w3.org/1999/xhtml";
	
	var namespaces = {
	  svg: "http://www.w3.org/2000/svg",
	  xhtml: xhtml,
	  xlink: "http://www.w3.org/1999/xlink",
	  xml: "http://www.w3.org/XML/1998/namespace",
	  xmlns: "http://www.w3.org/2000/xmlns/"
	};
	
	var namespace = function(name) {
	  var prefix = name += "", i = prefix.indexOf(":");
	  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
	};
	
	function creatorInherit(name) {
	  return function() {
	    var document = this.ownerDocument,
	        uri = this.namespaceURI;
	    return uri === xhtml && document.documentElement.namespaceURI === xhtml
	        ? document.createElement(name)
	        : document.createElementNS(uri, name);
	  };
	}
	
	function creatorFixed(fullname) {
	  return function() {
	    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
	  };
	}
	
	var creator = function(name) {
	  var fullname = namespace(name);
	  return (fullname.local
	      ? creatorFixed
	      : creatorInherit)(fullname);
	};
	
	var nextId = 0;
	
	function local() {
	  return new Local;
	}
	
	function Local() {
	  this._ = "@" + (++nextId).toString(36);
	}
	
	Local.prototype = local.prototype = {
	  constructor: Local,
	  get: function(node) {
	    var id = this._;
	    while (!(id in node)) if (!(node = node.parentNode)) return;
	    return node[id];
	  },
	  set: function(node, value) {
	    return node[this._] = value;
	  },
	  remove: function(node) {
	    return this._ in node && delete node[this._];
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	var matcher = function(selector) {
	  return function() {
	    return this.matches(selector);
	  };
	};
	
	if (typeof document !== "undefined") {
	  var element = document.documentElement;
	  if (!element.matches) {
	    var vendorMatches = element.webkitMatchesSelector
	        || element.msMatchesSelector
	        || element.mozMatchesSelector
	        || element.oMatchesSelector;
	    matcher = function(selector) {
	      return function() {
	        return vendorMatches.call(this, selector);
	      };
	    };
	  }
	}
	
	var matcher$1 = matcher;
	
	var filterEvents = {};
	
	exports.event = null;
	
	if (typeof document !== "undefined") {
	  var element$1 = document.documentElement;
	  if (!("onmouseenter" in element$1)) {
	    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
	  }
	}
	
	function filterContextListener(listener, index, group) {
	  listener = contextListener(listener, index, group);
	  return function(event) {
	    var related = event.relatedTarget;
	    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
	      listener.call(this, event);
	    }
	  };
	}
	
	function contextListener(listener, index, group) {
	  return function(event1) {
	    var event0 = exports.event; // Events can be reentrant (e.g., focus).
	    exports.event = event1;
	    try {
	      listener.call(this, this.__data__, index, group);
	    } finally {
	      exports.event = event0;
	    }
	  };
	}
	
	function parseTypenames(typenames) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    return {type: t, name: name};
	  });
	}
	
	function onRemove(typename) {
	  return function() {
	    var on = this.__on;
	    if (!on) return;
	    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
	      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	      } else {
	        on[++i] = o;
	      }
	    }
	    if (++i) on.length = i;
	    else delete this.__on;
	  };
	}
	
	function onAdd(typename, value, capture) {
	  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
	  return function(d, i, group) {
	    var on = this.__on, o, listener = wrap(value, i, group);
	    if (on) for (var j = 0, m = on.length; j < m; ++j) {
	      if ((o = on[j]).type === typename.type && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
	        o.value = value;
	        return;
	      }
	    }
	    this.addEventListener(typename.type, listener, capture);
	    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
	    if (!on) this.__on = [o];
	    else on.push(o);
	  };
	}
	
	var selection_on = function(typename, value, capture) {
	  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
	
	  if (arguments.length < 2) {
	    var on = this.node().__on;
	    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
	      for (i = 0, o = on[j]; i < n; ++i) {
	        if ((t = typenames[i]).type === o.type && t.name === o.name) {
	          return o.value;
	        }
	      }
	    }
	    return;
	  }
	
	  on = value ? onAdd : onRemove;
	  if (capture == null) capture = false;
	  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
	  return this;
	};
	
	function customEvent(event1, listener, that, args) {
	  var event0 = exports.event;
	  event1.sourceEvent = exports.event;
	  exports.event = event1;
	  try {
	    return listener.apply(that, args);
	  } finally {
	    exports.event = event0;
	  }
	}
	
	var sourceEvent = function() {
	  var current = exports.event, source;
	  while (source = current.sourceEvent) current = source;
	  return current;
	};
	
	var point = function(node, event) {
	  var svg = node.ownerSVGElement || node;
	
	  if (svg.createSVGPoint) {
	    var point = svg.createSVGPoint();
	    point.x = event.clientX, point.y = event.clientY;
	    point = point.matrixTransform(node.getScreenCTM().inverse());
	    return [point.x, point.y];
	  }
	
	  var rect = node.getBoundingClientRect();
	  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
	};
	
	var mouse = function(node) {
	  var event = sourceEvent();
	  if (event.changedTouches) event = event.changedTouches[0];
	  return point(node, event);
	};
	
	function none() {}
	
	var selector = function(selector) {
	  return selector == null ? none : function() {
	    return this.querySelector(selector);
	  };
	};
	
	var selection_select = function(select) {
	  if (typeof select !== "function") select = selector(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	};
	
	function empty() {
	  return [];
	}
	
	var selectorAll = function(selector) {
	  return selector == null ? empty : function() {
	    return this.querySelectorAll(selector);
	  };
	};
	
	var selection_selectAll = function(select) {
	  if (typeof select !== "function") select = selectorAll(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        subgroups.push(select.call(node, node.__data__, i, group));
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, parents);
	};
	
	var selection_filter = function(match) {
	  if (typeof match !== "function") match = matcher$1(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	};
	
	var sparse = function(update) {
	  return new Array(update.length);
	};
	
	var selection_enter = function() {
	  return new Selection(this._enter || this._groups.map(sparse), this._parents);
	};
	
	function EnterNode(parent, datum) {
	  this.ownerDocument = parent.ownerDocument;
	  this.namespaceURI = parent.namespaceURI;
	  this._next = null;
	  this._parent = parent;
	  this.__data__ = datum;
	}
	
	EnterNode.prototype = {
	  constructor: EnterNode,
	  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
	  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
	  querySelector: function(selector) { return this._parent.querySelector(selector); },
	  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var keyPrefix = "$"; // Protect against keys like “__proto__”.
	
	function bindIndex(parent, group, enter, update, exit, data) {
	  var i = 0,
	      node,
	      groupLength = group.length,
	      dataLength = data.length;
	
	  // Put any non-null nodes that fit into update.
	  // Put any null nodes into enter.
	  // Put any remaining data into enter.
	  for (; i < dataLength; ++i) {
	    if (node = group[i]) {
	      node.__data__ = data[i];
	      update[i] = node;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Put any non-null nodes that don’t fit into exit.
	  for (; i < groupLength; ++i) {
	    if (node = group[i]) {
	      exit[i] = node;
	    }
	  }
	}
	
	function bindKey(parent, group, enter, update, exit, data, key) {
	  var i,
	      node,
	      nodeByKeyValue = {},
	      groupLength = group.length,
	      dataLength = data.length,
	      keyValues = new Array(groupLength),
	      keyValue;
	
	  // Compute the key for each node.
	  // If multiple nodes have the same key, the duplicates are added to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if (node = group[i]) {
	      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
	      if (keyValue in nodeByKeyValue) {
	        exit[i] = node;
	      } else {
	        nodeByKeyValue[keyValue] = node;
	      }
	    }
	  }
	
	  // Compute the key for each datum.
	  // If there a node associated with this key, join and add it to update.
	  // If there is not (or the key is a duplicate), add it to enter.
	  for (i = 0; i < dataLength; ++i) {
	    keyValue = keyPrefix + key.call(parent, data[i], i, data);
	    if (node = nodeByKeyValue[keyValue]) {
	      update[i] = node;
	      node.__data__ = data[i];
	      nodeByKeyValue[keyValue] = null;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Add any remaining nodes that were not bound to data to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
	      exit[i] = node;
	    }
	  }
	}
	
	var selection_data = function(value, key) {
	  if (!value) {
	    data = new Array(this.size()), j = -1;
	    this.each(function(d) { data[++j] = d; });
	    return data;
	  }
	
	  var bind = key ? bindKey : bindIndex,
	      parents = this._parents,
	      groups = this._groups;
	
	  if (typeof value !== "function") value = constant(value);
	
	  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
	    var parent = parents[j],
	        group = groups[j],
	        groupLength = group.length,
	        data = value.call(parent, parent && parent.__data__, j, parents),
	        dataLength = data.length,
	        enterGroup = enter[j] = new Array(dataLength),
	        updateGroup = update[j] = new Array(dataLength),
	        exitGroup = exit[j] = new Array(groupLength);
	
	    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
	
	    // Now connect the enter nodes to their following update node, such that
	    // appendChild can insert the materialized enter node before this node,
	    // rather than at the end of the parent node.
	    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
	      if (previous = enterGroup[i0]) {
	        if (i0 >= i1) i1 = i0 + 1;
	        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
	        previous._next = next || null;
	      }
	    }
	  }
	
	  update = new Selection(update, parents);
	  update._enter = enter;
	  update._exit = exit;
	  return update;
	};
	
	var selection_exit = function() {
	  return new Selection(this._exit || this._groups.map(sparse), this._parents);
	};
	
	var selection_merge = function(selection) {
	
	  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Selection(merges, this._parents);
	};
	
	var selection_order = function() {
	
	  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
	    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
	      if (node = group[i]) {
	        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	        next = node;
	      }
	    }
	  }
	
	  return this;
	};
	
	var selection_sort = function(compare) {
	  if (!compare) compare = ascending;
	
	  function compareNode(a, b) {
	    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
	  }
	
	  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        sortgroup[i] = node;
	      }
	    }
	    sortgroup.sort(compareNode);
	  }
	
	  return new Selection(sortgroups, this._parents).order();
	};
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	var selection_call = function() {
	  var callback = arguments[0];
	  arguments[0] = this;
	  callback.apply(null, arguments);
	  return this;
	};
	
	var selection_nodes = function() {
	  var nodes = new Array(this.size()), i = -1;
	  this.each(function() { nodes[++i] = this; });
	  return nodes;
	};
	
	var selection_node = function() {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
	      var node = group[i];
	      if (node) return node;
	    }
	  }
	
	  return null;
	};
	
	var selection_size = function() {
	  var size = 0;
	  this.each(function() { ++size; });
	  return size;
	};
	
	var selection_empty = function() {
	  return !this.node();
	};
	
	var selection_each = function(callback) {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
	      if (node = group[i]) callback.call(node, node.__data__, i, group);
	    }
	  }
	
	  return this;
	};
	
	function attrRemove(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant(name, value) {
	  return function() {
	    this.setAttribute(name, value);
	  };
	}
	
	function attrConstantNS(fullname, value) {
	  return function() {
	    this.setAttributeNS(fullname.space, fullname.local, value);
	  };
	}
	
	function attrFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttribute(name);
	    else this.setAttribute(name, v);
	  };
	}
	
	function attrFunctionNS(fullname, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
	    else this.setAttributeNS(fullname.space, fullname.local, v);
	  };
	}
	
	var selection_attr = function(name, value) {
	  var fullname = namespace(name);
	
	  if (arguments.length < 2) {
	    var node = this.node();
	    return fullname.local
	        ? node.getAttributeNS(fullname.space, fullname.local)
	        : node.getAttribute(fullname);
	  }
	
	  return this.each((value == null
	      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
	      ? (fullname.local ? attrFunctionNS : attrFunction)
	      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
	};
	
	var defaultView = function(node) {
	  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
	      || (node.document && node) // node is a Window
	      || node.defaultView; // node is a Document
	};
	
	function styleRemove(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant(name, value, priority) {
	  return function() {
	    this.style.setProperty(name, value, priority);
	  };
	}
	
	function styleFunction(name, value, priority) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.style.removeProperty(name);
	    else this.style.setProperty(name, v, priority);
	  };
	}
	
	var selection_style = function(name, value, priority) {
	  var node;
	  return arguments.length > 1
	      ? this.each((value == null
	            ? styleRemove : typeof value === "function"
	            ? styleFunction
	            : styleConstant)(name, value, priority == null ? "" : priority))
	      : defaultView(node = this.node())
	          .getComputedStyle(node, null)
	          .getPropertyValue(name);
	};
	
	function propertyRemove(name) {
	  return function() {
	    delete this[name];
	  };
	}
	
	function propertyConstant(name, value) {
	  return function() {
	    this[name] = value;
	  };
	}
	
	function propertyFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) delete this[name];
	    else this[name] = v;
	  };
	}
	
	var selection_property = function(name, value) {
	  return arguments.length > 1
	      ? this.each((value == null
	          ? propertyRemove : typeof value === "function"
	          ? propertyFunction
	          : propertyConstant)(name, value))
	      : this.node()[name];
	};
	
	function classArray(string) {
	  return string.trim().split(/^|\s+/);
	}
	
	function classList(node) {
	  return node.classList || new ClassList(node);
	}
	
	function ClassList(node) {
	  this._node = node;
	  this._names = classArray(node.getAttribute("class") || "");
	}
	
	ClassList.prototype = {
	  add: function(name) {
	    var i = this._names.indexOf(name);
	    if (i < 0) {
	      this._names.push(name);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  remove: function(name) {
	    var i = this._names.indexOf(name);
	    if (i >= 0) {
	      this._names.splice(i, 1);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  contains: function(name) {
	    return this._names.indexOf(name) >= 0;
	  }
	};
	
	function classedAdd(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.add(names[i]);
	}
	
	function classedRemove(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.remove(names[i]);
	}
	
	function classedTrue(names) {
	  return function() {
	    classedAdd(this, names);
	  };
	}
	
	function classedFalse(names) {
	  return function() {
	    classedRemove(this, names);
	  };
	}
	
	function classedFunction(names, value) {
	  return function() {
	    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
	  };
	}
	
	var selection_classed = function(name, value) {
	  var names = classArray(name + "");
	
	  if (arguments.length < 2) {
	    var list = classList(this.node()), i = -1, n = names.length;
	    while (++i < n) if (!list.contains(names[i])) return false;
	    return true;
	  }
	
	  return this.each((typeof value === "function"
	      ? classedFunction : value
	      ? classedTrue
	      : classedFalse)(names, value));
	};
	
	function textRemove() {
	  this.textContent = "";
	}
	
	function textConstant(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.textContent = v == null ? "" : v;
	  };
	}
	
	var selection_text = function(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? textRemove : (typeof value === "function"
	          ? textFunction
	          : textConstant)(value))
	      : this.node().textContent;
	};
	
	function htmlRemove() {
	  this.innerHTML = "";
	}
	
	function htmlConstant(value) {
	  return function() {
	    this.innerHTML = value;
	  };
	}
	
	function htmlFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.innerHTML = v == null ? "" : v;
	  };
	}
	
	var selection_html = function(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? htmlRemove : (typeof value === "function"
	          ? htmlFunction
	          : htmlConstant)(value))
	      : this.node().innerHTML;
	};
	
	function raise() {
	  if (this.nextSibling) this.parentNode.appendChild(this);
	}
	
	var selection_raise = function() {
	  return this.each(raise);
	};
	
	function lower() {
	  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
	}
	
	var selection_lower = function() {
	  return this.each(lower);
	};
	
	var selection_append = function(name) {
	  var create = typeof name === "function" ? name : creator(name);
	  return this.select(function() {
	    return this.appendChild(create.apply(this, arguments));
	  });
	};
	
	function constantNull() {
	  return null;
	}
	
	var selection_insert = function(name, before) {
	  var create = typeof name === "function" ? name : creator(name),
	      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
	  return this.select(function() {
	    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
	  });
	};
	
	function remove() {
	  var parent = this.parentNode;
	  if (parent) parent.removeChild(this);
	}
	
	var selection_remove = function() {
	  return this.each(remove);
	};
	
	var selection_datum = function(value) {
	  return arguments.length
	      ? this.property("__data__", value)
	      : this.node().__data__;
	};
	
	function dispatchEvent(node, type, params) {
	  var window = defaultView(node),
	      event = window.CustomEvent;
	
	  if (event) {
	    event = new event(type, params);
	  } else {
	    event = window.document.createEvent("Event");
	    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
	    else event.initEvent(type, false, false);
	  }
	
	  node.dispatchEvent(event);
	}
	
	function dispatchConstant(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params);
	  };
	}
	
	function dispatchFunction(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params.apply(this, arguments));
	  };
	}
	
	var selection_dispatch = function(type, params) {
	  return this.each((typeof params === "function"
	      ? dispatchFunction
	      : dispatchConstant)(type, params));
	};
	
	var root = [null];
	
	function Selection(groups, parents) {
	  this._groups = groups;
	  this._parents = parents;
	}
	
	function selection() {
	  return new Selection([[document.documentElement]], root);
	}
	
	Selection.prototype = selection.prototype = {
	  constructor: Selection,
	  select: selection_select,
	  selectAll: selection_selectAll,
	  filter: selection_filter,
	  data: selection_data,
	  enter: selection_enter,
	  exit: selection_exit,
	  merge: selection_merge,
	  order: selection_order,
	  sort: selection_sort,
	  call: selection_call,
	  nodes: selection_nodes,
	  node: selection_node,
	  size: selection_size,
	  empty: selection_empty,
	  each: selection_each,
	  attr: selection_attr,
	  style: selection_style,
	  property: selection_property,
	  classed: selection_classed,
	  text: selection_text,
	  html: selection_html,
	  raise: selection_raise,
	  lower: selection_lower,
	  append: selection_append,
	  insert: selection_insert,
	  remove: selection_remove,
	  datum: selection_datum,
	  on: selection_on,
	  dispatch: selection_dispatch
	};
	
	var select = function(selector) {
	  return typeof selector === "string"
	      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
	      : new Selection([[selector]], root);
	};
	
	var selectAll = function(selector) {
	  return typeof selector === "string"
	      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
	      : new Selection([selector == null ? [] : selector], root);
	};
	
	var touch = function(node, touches, identifier) {
	  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;
	
	  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
	    if ((touch = touches[i]).identifier === identifier) {
	      return point(node, touch);
	    }
	  }
	
	  return null;
	};
	
	var touches = function(node, touches) {
	  if (touches == null) touches = sourceEvent().touches;
	
	  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
	    points[i] = point(node, touches[i]);
	  }
	
	  return points;
	};
	
	exports.creator = creator;
	exports.local = local;
	exports.matcher = matcher$1;
	exports.mouse = mouse;
	exports.namespace = namespace;
	exports.namespaces = namespaces;
	exports.select = select;
	exports.selectAll = selectAll;
	exports.selection = selection;
	exports.selector = selector;
	exports.selectorAll = selectorAll;
	exports.touch = touch;
	exports.touches = touches;
	exports.window = defaultView;
	exports.customEvent = customEvent;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 39 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(13);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(200);
	
	var _runTransitionHook = __webpack_require__(54);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(20);
	
	var _deprecate = __webpack_require__(53);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	// codec-base.js
	
	var IS_ARRAY = __webpack_require__(56);
	
	exports.createCodec = createCodec;
	exports.install = install;
	exports.filter = filter;
	
	var Bufferish = __webpack_require__(10);
	
	function Codec(options) {
	  if (!(this instanceof Codec)) return new Codec(options);
	  this.options = options;
	  this.init();
	}
	
	Codec.prototype.init = function() {
	  var options = this.options;
	
	  if (options && options.uint8array) {
	    this.bufferish = Bufferish.Uint8Array;
	  }
	
	  return this;
	};
	
	function install(props) {
	  for (var key in props) {
	    Codec.prototype[key] = add(Codec.prototype[key], props[key]);
	  }
	}
	
	function add(a, b) {
	  return (a && b) ? ab : (a || b);
	
	  function ab() {
	    a.apply(this, arguments);
	    return b.apply(this, arguments);
	  }
	}
	
	function join(filters) {
	  filters = filters.slice();
	
	  return function(value) {
	    return filters.reduce(iterator, value);
	  };
	
	  function iterator(value, filter) {
	    return filter(value);
	  }
	}
	
	function filter(filter) {
	  return IS_ARRAY(filter) ? join(filter) : filter;
	}
	
	// @public
	// msgpack.createCodec()
	
	function createCodec(options) {
	  return new Codec(options);
	}
	
	// default shared codec
	
	exports.preset = createCodec({preset: true});


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var EventPluginRegistry = __webpack_require__(64);
	var ReactEventEmitterMixin = __webpack_require__(230);
	var ViewportMetrics = __webpack_require__(122);
	
	var getVendorPrefixedEventName = __webpack_require__(263);
	var isEventSupported = __webpack_require__(75);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(36);
	var ViewportMetrics = __webpack_require__(122);
	
	var getEventModifierState = __webpack_require__(73);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(2);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 45 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	var DOMNamespaces = __webpack_require__(63);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(71);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(48);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(284);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(18);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(18);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(79);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(28);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(277);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(134);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(271);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(290);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(272);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(273);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(135);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(275);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(270);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(274);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(276);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(289);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(47);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(278);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(287);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(140);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(280);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(281);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(285);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(137);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(328)
	var ieee754 = __webpack_require__(333)
	var isArray = __webpack_require__(334)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50).Buffer, (function() { return this; }())))

/***/ },
/* 51 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 52 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(13);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(13);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// int64-buffer.js
	
	/*jshint -W018 */ // Confusing use of '!'.
	/*jshint -W030 */ // Expected an assignment or function call and instead saw an expression.
	/*jshint -W093 */ // Did you mean to return a conditional instead of an assignment?
	
	var Uint64BE, Int64BE, Uint64LE, Int64LE;
	
	!function(exports) {
	  // constants
	
	  var UNDEFINED = "undefined";
	  var BUFFER = (UNDEFINED !== typeof Buffer) && Buffer;
	  var UINT8ARRAY = (UNDEFINED !== typeof Uint8Array) && Uint8Array;
	  var ARRAYBUFFER = (UNDEFINED !== typeof ArrayBuffer) && ArrayBuffer;
	  var ZERO = [0, 0, 0, 0, 0, 0, 0, 0];
	  var isArray = Array.isArray || _isArray;
	  var BIT32 = 4294967296;
	  var BIT24 = 16777216;
	
	  // storage class
	
	  var storage; // Array;
	
	  // generate classes
	
	  Uint64BE = factory("Uint64BE", true, true);
	  Int64BE = factory("Int64BE", true, false);
	  Uint64LE = factory("Uint64LE", false, true);
	  Int64LE = factory("Int64LE", false, false);
	
	  // class factory
	
	  function factory(name, bigendian, unsigned) {
	    var posH = bigendian ? 0 : 4;
	    var posL = bigendian ? 4 : 0;
	    var pos0 = bigendian ? 0 : 3;
	    var pos1 = bigendian ? 1 : 2;
	    var pos2 = bigendian ? 2 : 1;
	    var pos3 = bigendian ? 3 : 0;
	    var fromPositive = bigendian ? fromPositiveBE : fromPositiveLE;
	    var fromNegative = bigendian ? fromNegativeBE : fromNegativeLE;
	    var proto = Int64.prototype;
	    var isName = "is" + name;
	    var _isInt64 = "_" + isName;
	
	    // properties
	    proto.buffer = void 0;
	    proto.offset = 0;
	    proto[_isInt64] = true;
	
	    // methods
	    proto.toNumber = toNumber;
	    proto.toString = toString;
	    proto.toJSON = toNumber;
	    proto.toArray = toArray;
	
	    // add .toBuffer() method only when Buffer available
	    if (BUFFER) proto.toBuffer = toBuffer;
	
	    // add .toArrayBuffer() method only when Uint8Array available
	    if (UINT8ARRAY) proto.toArrayBuffer = toArrayBuffer;
	
	    // isUint64BE, isInt64BE
	    Int64[isName] = isInt64;
	
	    // CommonJS
	    exports[name] = Int64;
	
	    return Int64;
	
	    // constructor
	    function Int64(buffer, offset, value, raddix) {
	      if (!(this instanceof Int64)) return new Int64(buffer, offset, value, raddix);
	      return init(this, buffer, offset, value, raddix);
	    }
	
	    // isUint64BE, isInt64BE
	    function isInt64(b) {
	      return !!(b && b[_isInt64]);
	    }
	
	    // initializer
	    function init(that, buffer, offset, value, raddix) {
	      if (UINT8ARRAY && ARRAYBUFFER) {
	        if (buffer instanceof ARRAYBUFFER) buffer = new UINT8ARRAY(buffer);
	        if (value instanceof ARRAYBUFFER) value = new UINT8ARRAY(value);
	      }
	
	      // Int64BE() style
	      if (!buffer && !offset && !value && !storage) {
	        // shortcut to initialize with zero
	        that.buffer = newArray(ZERO, 0);
	        return;
	      }
	
	      // Int64BE(value, raddix) style
	      if (!isValidBuffer(buffer, offset)) {
	        var _storage = storage || Array;
	        raddix = offset;
	        value = buffer;
	        offset = 0;
	        buffer = new _storage(8);
	      }
	
	      that.buffer = buffer;
	      that.offset = offset |= 0;
	
	      // Int64BE(buffer, offset) style
	      if (UNDEFINED === typeof value) return;
	
	      // Int64BE(buffer, offset, value, raddix) style
	      if ("string" === typeof value) {
	        fromString(buffer, offset, value, raddix || 10);
	      } else if (isValidBuffer(value, raddix)) {
	        fromArray(buffer, offset, value, raddix);
	      } else if ("number" === typeof raddix) {
	        writeInt32(buffer, offset + posH, value); // high
	        writeInt32(buffer, offset + posL, raddix); // low
	      } else if (value > 0) {
	        fromPositive(buffer, offset, value); // positive
	      } else if (value < 0) {
	        fromNegative(buffer, offset, value); // negative
	      } else {
	        fromArray(buffer, offset, ZERO, 0); // zero, NaN and others
	      }
	    }
	
	    function fromString(buffer, offset, str, raddix) {
	      var pos = 0;
	      var len = str.length;
	      var high = 0;
	      var low = 0;
	      if (str[0] === "-") pos++;
	      var sign = pos;
	      while (pos < len) {
	        var chr = parseInt(str[pos++], raddix);
	        if (!(chr >= 0)) break; // NaN
	        low = low * raddix + chr;
	        high = high * raddix + Math.floor(low / BIT32);
	        low %= BIT32;
	      }
	      if (sign) {
	        high = ~high;
	        if (low) {
	          low = BIT32 - low;
	        } else {
	          high++;
	        }
	      }
	      writeInt32(buffer, offset + posH, high);
	      writeInt32(buffer, offset + posL, low);
	    }
	
	    function toNumber() {
	      var buffer = this.buffer;
	      var offset = this.offset;
	      var high = readInt32(buffer, offset + posH);
	      var low = readInt32(buffer, offset + posL);
	      if (!unsigned) high |= 0; // a trick to get signed
	      return high ? (high * BIT32 + low) : low;
	    }
	
	    function toString(radix) {
	      var buffer = this.buffer;
	      var offset = this.offset;
	      var high = readInt32(buffer, offset + posH);
	      var low = readInt32(buffer, offset + posL);
	      var str = "";
	      var sign = !unsigned && (high & 0x80000000);
	      if (sign) {
	        high = ~high;
	        low = BIT32 - low;
	      }
	      radix = radix || 10;
	      while (1) {
	        var mod = (high % radix) * BIT32 + low;
	        high = Math.floor(high / radix);
	        low = Math.floor(mod / radix);
	        str = (mod % radix).toString(radix) + str;
	        if (!high && !low) break;
	      }
	      if (sign) {
	        str = "-" + str;
	      }
	      return str;
	    }
	
	    function writeInt32(buffer, offset, value) {
	      buffer[offset + pos3] = value & 255;
	      value = value >> 8;
	      buffer[offset + pos2] = value & 255;
	      value = value >> 8;
	      buffer[offset + pos1] = value & 255;
	      value = value >> 8;
	      buffer[offset + pos0] = value & 255;
	    }
	
	    function readInt32(buffer, offset) {
	      return (buffer[offset + pos0] * BIT24) +
	        (buffer[offset + pos1] << 16) +
	        (buffer[offset + pos2] << 8) +
	        buffer[offset + pos3];
	    }
	  }
	
	  function toArray(raw) {
	    var buffer = this.buffer;
	    var offset = this.offset;
	    storage = null; // Array
	    if (raw !== false && offset === 0 && buffer.length === 8 && isArray(buffer)) return buffer;
	    return newArray(buffer, offset);
	  }
	
	  function toBuffer(raw) {
	    var buffer = this.buffer;
	    var offset = this.offset;
	    storage = BUFFER;
	    if (raw !== false && offset === 0 && buffer.length === 8 && Buffer.isBuffer(buffer)) return buffer;
	    var dest = new BUFFER(8);
	    fromArray(dest, 0, buffer, offset);
	    return dest;
	  }
	
	  function toArrayBuffer(raw) {
	    var buffer = this.buffer;
	    var offset = this.offset;
	    var arrbuf = buffer.buffer;
	    storage = UINT8ARRAY;
	    if (raw !== false && offset === 0 && (arrbuf instanceof ARRAYBUFFER) && arrbuf.byteLength === 8) return arrbuf;
	    var dest = new UINT8ARRAY(8);
	    fromArray(dest, 0, buffer, offset);
	    return dest.buffer;
	  }
	
	  function isValidBuffer(buffer, offset) {
	    var len = buffer && buffer.length;
	    offset |= 0;
	    return len && (offset + 8 <= len) && ("string" !== typeof buffer[offset]);
	  }
	
	  function fromArray(destbuf, destoff, srcbuf, srcoff) {
	    destoff |= 0;
	    srcoff |= 0;
	    for (var i = 0; i < 8; i++) {
	      destbuf[destoff++] = srcbuf[srcoff++] & 255;
	    }
	  }
	
	  function newArray(buffer, offset) {
	    return Array.prototype.slice.call(buffer, offset, offset + 8);
	  }
	
	  function fromPositiveBE(buffer, offset, value) {
	    var pos = offset + 8;
	    while (pos > offset) {
	      buffer[--pos] = value & 255;
	      value /= 256;
	    }
	  }
	
	  function fromNegativeBE(buffer, offset, value) {
	    var pos = offset + 8;
	    value++;
	    while (pos > offset) {
	      buffer[--pos] = ((-value) & 255) ^ 255;
	      value /= 256;
	    }
	  }
	
	  function fromPositiveLE(buffer, offset, value) {
	    var end = offset + 8;
	    while (offset < end) {
	      buffer[offset++] = value & 255;
	      value /= 256;
	    }
	  }
	
	  function fromNegativeLE(buffer, offset, value) {
	    var end = offset + 8;
	    value++;
	    while (offset < end) {
	      buffer[offset++] = ((-value) & 255) ^ 255;
	      value /= 256;
	    }
	  }
	
	  // https://github.com/retrofox/is-array
	  function _isArray(val) {
	    return !!val && "[object Array]" == Object.prototype.toString.call(val);
	  }
	
	}(typeof exports === 'object' && typeof exports.nodeName !== 'string' ? exports : (this || {}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50).Buffer))

/***/ },
/* 56 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(177),
	    getPrototype = __webpack_require__(179),
	    isObjectLike = __webpack_require__(184);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	// bufferish-proto.js
	
	/* jshint eqnull:true */
	
	var BufferLite = __webpack_require__(187);
	
	exports.copy = copy;
	exports.slice = slice;
	exports.toString = toString;
	exports.write = gen("write");
	
	var Bufferish = __webpack_require__(10);
	var Buffer = Bufferish.global;
	
	var isBufferShim = Bufferish.hasBuffer && ("TYPED_ARRAY_SUPPORT" in Buffer);
	var brokenTypedArray = isBufferShim && !Buffer.TYPED_ARRAY_SUPPORT;
	
	/**
	 * @param target {Buffer|Uint8Array|Array}
	 * @param [targetStart] {Number}
	 * @param [start] {Number}
	 * @param [end] {Number}
	 * @returns {Buffer|Uint8Array|Array}
	 */
	
	function copy(target, targetStart, start, end) {
	  var thisIsBuffer = Bufferish.isBuffer(this);
	  var targetIsBuffer = Bufferish.isBuffer(target);
	  if (thisIsBuffer && targetIsBuffer) {
	    // Buffer to Buffer
	    return this.copy(target, targetStart, start, end);
	  } else if (!brokenTypedArray && !thisIsBuffer && !targetIsBuffer &&
	    Bufferish.isView(this) && Bufferish.isView(target)) {
	    // Uint8Array to Uint8Array (except for minor some browsers)
	    var buffer = (start || end != null) ? slice.call(this, start, end) : this;
	    target.set(buffer, targetStart);
	    return buffer.length;
	  } else {
	    // other cases
	    return BufferLite.copy.call(this, target, targetStart, start, end);
	  }
	}
	
	/**
	 * @param [start] {Number}
	 * @param [end] {Number}
	 * @returns {Buffer|Uint8Array|Array}
	 */
	
	function slice(start, end) {
	  // for Buffer, Uint8Array (except for minor some browsers) and Array
	  var f = this.slice || (!brokenTypedArray && this.subarray);
	  if (f) return f.call(this, start, end);
	
	  // Uint8Array (for minor some browsers)
	  var target = Bufferish.alloc.call(this, end - start);
	  copy.call(this, target, 0, start, end);
	  return target;
	}
	
	/**
	 * Buffer.prototype.toString()
	 *
	 * @param [encoding] {String} ignored
	 * @param [start] {Number}
	 * @param [end] {Number}
	 * @returns {String}
	 */
	
	function toString(encoding, start, end) {
	  var f = (!isBufferShim && Bufferish.isBuffer(this)) ? this.toString : BufferLite.toString;
	  return f.apply(this, arguments);
	}
	
	/**
	 * @private
	 */
	
	function gen(method) {
	  return wrap;
	
	  function wrap() {
	    var f = this[method] || BufferLite[method];
	    return f.apply(this, arguments);
	  }
	}


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	// ext-buffer.js
	
	exports.ExtBuffer = ExtBuffer;
	
	var Bufferish = __webpack_require__(10);
	
	function ExtBuffer(buffer, type) {
	  if (!(this instanceof ExtBuffer)) return new ExtBuffer(buffer, type);
	  this.buffer = Bufferish.from(buffer);
	  this.type = type;
	}


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	// read-core.js
	
	var ExtBuffer = __webpack_require__(59).ExtBuffer;
	var ExtUnpacker = __webpack_require__(195);
	var readUint8 = __webpack_require__(109).readUint8;
	var ReadToken = __webpack_require__(197);
	var CodecBase = __webpack_require__(41);
	
	CodecBase.install({
	  addExtUnpacker: addExtUnpacker,
	  getExtUnpacker: getExtUnpacker,
	  init: init
	});
	
	exports.preset = init.call(CodecBase.preset);
	
	function getDecoder(options) {
	  var readToken = ReadToken.getReadToken(options);
	  return decode;
	
	  function decode(decoder) {
	    var type = readUint8(decoder);
	    var func = readToken[type];
	    if (!func) throw new Error("Invalid type: " + (type ? ("0x" + type.toString(16)) : type));
	    return func(decoder);
	  }
	}
	
	function init() {
	  var options = this.options;
	  this.decode = getDecoder(options);
	
	  if (options && options.preset) {
	    ExtUnpacker.setExtUnpackers(this);
	  }
	
	  return this;
	}
	
	function addExtUnpacker(etype, unpacker) {
	  var unpackers = this.extUnpackers || (this.extUnpackers = []);
	  unpackers[etype] = CodecBase.filter(unpacker);
	}
	
	function getExtUnpacker(type) {
	  var unpackers = this.extUnpackers || (this.extUnpackers = []);
	  return unpackers[type] || extUnpacker;
	
	  function extUnpacker(buffer) {
	    return new ExtBuffer(buffer, type);
	  }
	}


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	// write-core.js
	
	var ExtBuffer = __webpack_require__(59).ExtBuffer;
	var ExtPacker = __webpack_require__(194);
	var WriteType = __webpack_require__(199);
	var CodecBase = __webpack_require__(41);
	
	CodecBase.install({
	  addExtPacker: addExtPacker,
	  getExtPacker: getExtPacker,
	  init: init
	});
	
	exports.preset = init.call(CodecBase.preset);
	
	function getEncoder(options) {
	  var writeType = WriteType.getWriteType(options);
	  return encode;
	
	  function encode(encoder, value) {
	    var func = writeType[typeof value];
	    if (!func) throw new Error("Unsupported type \"" + (typeof value) + "\": " + value);
	    func(encoder, value);
	  }
	}
	
	function init() {
	  var options = this.options;
	  this.encode = getEncoder(options);
	
	  if (options && options.preset) {
	    ExtPacker.setExtPackers(this);
	  }
	
	  return this;
	}
	
	function addExtPacker(etype, Class, packer) {
	  packer = CodecBase.filter(packer);
	  var name = Class.name;
	  if (name && name !== "Object") {
	    var packers = this.extPackers || (this.extPackers = {});
	    packers[name] = extPacker;
	  } else {
	    // fallback for IE
	    var list = this.extEncoderList || (this.extEncoderList = []);
	    list.unshift([Class, extPacker]);
	  }
	
	  function extPacker(value) {
	    if (packer) value = packer(value);
	    return new ExtBuffer(value, etype);
	  }
	}
	
	function getExtPacker(value) {
	  var packers = this.extPackers || (this.extPackers = {});
	  var c = value.constructor;
	  var e = c && c.name && packers[c.name];
	  if (e) return e;
	
	  // fallback for IE
	  var list = this.extEncoderList || (this.extEncoderList = []);
	  var len = list.length;
	  for (var i = 0; i < len; i++) {
	    var pair = list[i];
	    if (c === pair[0]) return pair[1];
	  }
	}


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(25);
	var Danger = __webpack_require__(207);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactInstrumentation = __webpack_require__(12);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(71);
	var setInnerHTML = __webpack_require__(46);
	var setTextContent = __webpack_require__(129);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 63 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactErrorUtils = __webpack_require__(69);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 66 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var React = __webpack_require__(29);
	var ReactPropTypesSecret = __webpack_require__(236);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: React.PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(2);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      // $FlowFixMe https://github.com/facebook/flow/issues/2336
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactInstanceMap = __webpack_require__(35);
	var ReactInstrumentation = __webpack_require__(12);
	var ReactUpdates = __webpack_require__(14);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 71 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 72 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 73 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 74 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 76 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var emptyFunction = __webpack_require__(11);
	var warning = __webpack_require__(3);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 78 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _deprecateObjectProperties = __webpack_require__(48);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(22);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(282);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(279);
	
	var _isActive2 = __webpack_require__(286);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(283);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(288);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BoroughFilter = function BoroughFilter(_ref) {
	  var borough_filter = _ref.borough_filter;
	  var setBoroughFilter = _ref.setBoroughFilter;
	
	  var borough_values = ['brooklyn', 'bronx', 'manhattan', 'queens', 'staten island'];
	  var borough_display = ['Brooklyn', 'Bronx', 'Manhattan', 'Queens', 'Staten Isl.'];
	
	  var handleBoroughClick = function handleBoroughClick(index) {
	    var borough = borough_values[index];
	    if (borough === borough_filter) {
	      setBoroughFilter(false);
	    } else {
	      setBoroughFilter(borough);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'h6 mt2 px2 uppercase flex space-between' },
	      _react2.default.createElement(
	        'div',
	        null,
	        'Filter by Borough'
	      ),
	      borough_filter ? _react2.default.createElement(
	        'div',
	        { className: 'pointer blue hover-underline', onClick: handleBoroughClick.bind(undefined, false) },
	        'Clear Filter'
	      ) : null
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex h5 py1 center' },
	      borough_display.map(function (borough, i) {
	        return _react2.default.createElement(
	          'div',
	          {
	            key: borough,
	            className: "BoroughFilterItem hover px1 bg-light-gray py1 pointer grow-1 " + (borough_values[i] === borough_filter ? 'active' : ''),
	            onClick: handleBoroughClick.bind(undefined, i)
	          },
	          borough
	        );
	      })
	    )
	  );
	};
	
	exports.default = BoroughFilter;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Array = __webpack_require__(19);
	
	var _d3Scale = __webpack_require__(90);
	
	var _DistributionXAxis = __webpack_require__(296);
	
	var _DistributionXAxis2 = _interopRequireDefault(_DistributionXAxis);
	
	var _DistributionYAxis = __webpack_require__(297);
	
	var _DistributionYAxis2 = _interopRequireDefault(_DistributionYAxis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DistributionGraph = function DistributionGraph(_ref) {
	  var active_neighborhood = _ref.active_neighborhood;
	  var active_year = _ref.active_year;
	  var active_price = _ref.active_price;
	  var active_mode = _ref.active_mode;
	  var formatters = _ref.formatters;
	  var active_probability = _ref.active_probability;
	  var interpolators = _ref.interpolators;
	  var browser_width = _ref.browser_width;
	
	
	  var priceRoundhundthou = function priceRoundhundthou(value) {
	    if (active_probability === 1) {
	      return Math.ceil(value / 100000) * 100000;
	    } else if (active_probability === 0) {
	      return Math.floor(value / 100000) * 100000;
	    } else {
	      return Math.round(value / 100000) * 100000;
	    }
	  };
	
	  var years = [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018];
	
	  var svg_width = 360;
	  if (browser_width < 451) svg_width = browser_width;
	
	  var svg_height = 200;
	
	  var margins = {
	    top: 20,
	    right: 30,
	    bottom: 30,
	    left: 40
	  };
	
	  var inner_width = svg_width - margins.left - margins.right;
	  var inner_height = svg_height - margins.top - margins.bottom;
	
	  var year_index = years.indexOf(active_year);
	  var samples = active_neighborhood.samples[year_index];
	  // Round sample max up to nearest thousand, then add 200000 to offset low end of graph
	  var samples_max = Math.ceil((0, _d3Array.max)(samples) / 100000) * 100000 + 200000;
	  var each_sample_max = years.map(function (year, i) {
	    return (0, _d3Array.max)(active_neighborhood.samples[i]);
	  });
	  var all_samples_max = (0, _d3Array.max)(each_sample_max);
	  // const set_max = 4000000;
	  var step_number = samples_max / 100000;
	  // const samples_step = Math.floor(samples_max/step_number);
	  var samples_step = 100000;
	  var x_range = (0, _d3Array.range)(0, samples_max, samples_step);
	
	  var x = (0, _d3Scale.scaleLinear)()
	  // .domain([0,all_samples_max])
	  // .domain([0,samples_max])
	  .domain([0, 8000000]).range([0, inner_width]);
	
	  var bins = (0, _d3Array.histogram)().domain([0, samples_max]).thresholds(x_range)(samples);
	
	  var y = (0, _d3Scale.scaleLinear)()
	  // .domain([0, (max(bins, function(d) { return d.length; }) * 1.1)/samples.length])
	  .domain([0, 0.4]).range([inner_height, 0]).nice();
	
	  var cumulative_count = 0;
	  var cumulative_array = bins.map(function (bin) {
	    cumulative_count += bin.length;
	    return cumulative_count;
	  });
	
	  var range_map = x_range.map(function (value, i) {
	    var adjusted_value = cumulative_array[i] / samples.length;
	    if (active_mode === 'Price') {
	      adjusted_value = value / 2000000;
	    }
	    return interpolators.chance(adjusted_value);
	  });
	
	  var bin_plots = bins.map(function (bin) {
	    var x = bin.x0;
	    var width = bin.x1 - bin.x0;
	    var height = bin.length / samples.length;
	    return { x: x, width: width, height: height };
	  });
	
	  var price_line_x = x(active_price);
	  if (active_mode === 'Price') price_line_x = x(priceRoundhundthou(active_neighborhood.properties.price));
	  var bin_plots_x1s = bins.map(function (bin) {
	    return bin.x1;
	  });
	  var bin_x_max = (0, _d3Array.max)(bin_plots_x1s);
	
	  var bars = bin_plots.map(function (plot) {
	    var color = '#ccc';
	    if (x(plot.x) < price_line_x) {
	      color = '#777';
	    }
	    var bar_rect = _react2.default.createElement(
	      'g',
	      {
	        key: plot.x,
	        transform: 'translate(' + x(plot.x) + ',' + y(plot.height) + ')'
	      },
	      _react2.default.createElement('rect', {
	        className: 'ComboGraphBar',
	        x: '0',
	        width: x(plot.width),
	        height: inner_height - y(plot.height),
	        fill: color,
	        stroke: color
	      })
	    );
	    return bar_rect;
	  });
	
	  var price_lines = void 0;
	  if (active_mode === 'Price') {
	    price_lines = _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement('rect', {
	        x: x(active_neighborhood.year_all_prices[year_index][0]),
	        width: x(active_neighborhood.year_all_prices[year_index][2] - active_neighborhood.year_all_prices[year_index][0]),
	        height: inner_height,
	        fill: 'rgba(0,0,0,0.1)'
	      }),
	      _react2.default.createElement('line', {
	        x1: x(active_neighborhood.properties.price),
	        x2: x(active_neighborhood.properties.price),
	        y1: '0',
	        y2: inner_height,
	        stroke: '#222'
	      })
	    );
	  } else {
	    price_lines = _react2.default.createElement('line', {
	      x1: price_line_x,
	      x2: price_line_x,
	      y1: '0',
	      y2: inner_height,
	      stroke: 'black',
	      opacity: '0.8'
	    });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: '',
	      style: {
	        height: svg_height
	      }
	    },
	    _react2.default.createElement(
	      'svg',
	      {
	        style: {
	          width: svg_width,
	          height: svg_height
	        }
	      },
	      _react2.default.createElement(
	        'defs',
	        null,
	        _react2.default.createElement(
	          'clipPath',
	          { id: 'clipPath' },
	          _react2.default.createElement('rect', { x: '0', y: '0', width: inner_width + 12, height: inner_height })
	        )
	      ),
	      _react2.default.createElement(
	        'g',
	        { transform: 'translate(' + margins.left + ',' + margins.top + ')' },
	        _react2.default.createElement('rect', {
	          x: '0',
	          y: '0',
	          width: inner_width + 12,
	          height: inner_height,
	          fill: '#fafafa'
	        }),
	        _react2.default.createElement(_DistributionXAxis2.default, {
	          x: x,
	          formatters: formatters,
	          inner_height: inner_height,
	          svg_height: svg_height,
	          margins: margins
	        }),
	        _react2.default.createElement(_DistributionYAxis2.default, {
	          y: y,
	          formatters: formatters,
	          svg_width: svg_width,
	          margins: margins
	        }),
	        _react2.default.createElement(
	          'g',
	          { className: 'DistributionGraphBars',
	            style: {
	              clipPath: 'url(#clipPath)'
	            }
	          },
	          bars
	        ),
	        price_lines
	      )
	    )
	  );
	};
	
	exports.default = DistributionGraph;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Interpolate = __webpack_require__(15);
	
	var _d3Array = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SimilarNeighborhoodsList = function SimilarNeighborhoodsList(_ref) {
	  var active_mode = _ref.active_mode;
	  var active_neighborhood = _ref.active_neighborhood;
	  var neighborhoods = _ref.neighborhoods;
	  var neighborhoods_samples = _ref.neighborhoods_samples;
	  var formatters = _ref.formatters;
	  var active_price = _ref.active_price;
	  var active_probability = _ref.active_probability;
	  var active_year = _ref.active_year;
	  var setActiveNeighborhood = _ref.setActiveNeighborhood;
	
	
	  var handleClick = function handleClick(neighborhood) {
	    setActiveNeighborhood(neighborhood.properties.neighborhood);
	  };
	
	  var neighborhoods_with = void 0,
	      neighborhoods_for_display = void 0,
	      title = void 0,
	      neighborhood_item = void 0;
	  if (active_mode === 'Chance') {
	    (function () {
	      var interpolate = function interpolate(value) {
	        if (value < 0.5) {
	          return (0, _d3Interpolate.interpolateRgb)('#d01c8b', '#f7f7f7')(value * 2);
	        } else if (value > 1) {
	          return '#4dac26';
	        } else {
	          return (0, _d3Interpolate.interpolateRgb)('#f7f7f7', '#4dac26')((value - 0.5) * 2);
	        }
	      };
	
	      title = _react2.default.createElement(
	        'div',
	        null,
	        'Similar Neighborhoods (within 5%)'
	      );
	      neighborhoods_with = neighborhoods.map(function (neighborhood, i) {
	        var year_samples = neighborhoods_samples[i];
	        var below_price_counter = 0;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = year_samples[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var sample = _step.value;
	
	            if (sample <= active_price) {
	              below_price_counter++;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        var probability = below_price_counter / year_samples.length;
	        var neighborhood_probability = probability;
	        var ranking_difference = Math.abs(neighborhood_probability - active_neighborhood.properties.probability);
	        neighborhood.properties.list_probability = neighborhood_probability;
	        neighborhood.properties.ranking_difference = ranking_difference;
	        return neighborhood;
	      });
	      neighborhoods_with.sort(function (a, b) {
	        if (a.properties.ranking_difference <= b.properties.ranking_difference) return -1;
	        if (a.properties.ranking_difference > b.properties.ranking_difference) return 1;
	        return 0;
	      });
	
	      neighborhoods_for_display = neighborhoods_with.filter(function (neighborhood) {
	        return neighborhood.properties.ranking_difference < 0.05 ? true : false;
	      });
	      neighborhoods_for_display.splice(0, 1);
	
	      neighborhood_item = function neighborhood_item(neighborhood) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'clearfix SideListItem tnum h6 col-12 px1',
	            key: neighborhood.properties.neighborhood,
	            style: { background: interpolate(neighborhood.properties.list_probability) },
	            onClick: handleClick.bind(undefined, neighborhood)
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'relative' },
	            _react2.default.createElement(
	              'div',
	              { className: '' },
	              neighborhood.properties.neighborhood,
	              ', ',
	              _react2.default.createElement(
	                'span',
	                { className: 'capitalize' },
	                neighborhood.properties.borough
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'absolute right-0 top-0' },
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'rgba(0,0,0,0.5)' } },
	                formatters.percentFormat(neighborhood.properties.list_probability - active_neighborhood.properties.probability)
	              ),
	              ' ',
	              formatters.percentFormat(neighborhood.properties.list_probability)
	            )
	          )
	        );
	      };
	    })();
	  } else {
	    (function () {
	      var interpolate = function interpolate(value) {
	        if (value < 0.5) {
	          return (0, _d3Interpolate.interpolateRgb)('#5e3c99', '#f7f7f7')(value * 2);
	        } else if (value > 1) {
	          return '#e66101';
	        } else {
	          return (0, _d3Interpolate.interpolateRgb)('#f7f7f7', '#e66101')((value - 0.5) * 2);
	        }
	      };
	
	      title = _react2.default.createElement(
	        'div',
	        null,
	        'Similar Neighborhoods'
	      );
	      neighborhoods_with = neighborhoods.map(function (neighborhood, i) {
	        var year_samples = neighborhoods_samples[i];
	        var price = Math.round((0, _d3Array.quantile)(year_samples, active_probability));
	        var neighborhood_price = price;
	        var ranking_difference = Math.abs(neighborhood_price - active_neighborhood.properties.price);
	        neighborhood.properties.list_price = neighborhood_price;
	        neighborhood.properties.ranking_difference = ranking_difference;
	        return neighborhood;
	      });
	      neighborhoods_with.sort(function (a, b) {
	        if (a.properties.ranking_difference <= b.properties.ranking_difference) return -1;
	        if (a.properties.ranking_difference > b.properties.ranking_difference) return 1;
	        return 0;
	      });
	
	      neighborhoods_for_display = neighborhoods_with.filter(function (neighborhood) {
	        return neighborhood.properties.ranking_difference < 100000 ? true : false;
	      });
	      neighborhoods_for_display.splice(0, 1);
	
	      neighborhood_item = function neighborhood_item(neighborhood) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'clearfix SideListItem tnum h6 col-12 px1',
	            key: neighborhood.properties.neighborhood,
	            style: { background: interpolate(neighborhood.properties.list_price / 2000000) },
	            onClick: handleClick.bind(undefined, neighborhood)
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'relative' },
	            _react2.default.createElement(
	              'div',
	              { className: '' },
	              neighborhood.properties.neighborhood,
	              ', ',
	              _react2.default.createElement(
	                'span',
	                { className: 'capitalize' },
	                neighborhood.properties.borough
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'absolute right-0 top-0' },
	              _react2.default.createElement(
	                'span',
	                { style: { color: 'rgba(0,0,0,0.5)' } },
	                formatters.dollarShort(neighborhood.properties.list_price - active_neighborhood.properties.price)
	              ),
	              ' ',
	              formatters.dollarShort(neighborhood.properties.list_price)
	            )
	          )
	        );
	      };
	    })();
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'h5 relative clearfix' },
	      _react2.default.createElement(
	        'div',
	        { className: 'left px2' },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'right' },
	        neighborhoods_for_display.length
	      )
	    ),
	    neighborhoods_for_display.map(function (neighborhood) {
	      return neighborhood_item(neighborhood);
	    })
	  );
	};
	
	exports.default = SimilarNeighborhoodsList;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Array = __webpack_require__(19);
	
	var _d3Scale = __webpack_require__(90);
	
	var _d3Shape = __webpack_require__(156);
	
	var _YearXAxis = __webpack_require__(316);
	
	var _YearXAxis2 = _interopRequireDefault(_YearXAxis);
	
	var _YearYAxis = __webpack_require__(317);
	
	var _YearYAxis2 = _interopRequireDefault(_YearYAxis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YearGraph = function YearGraph(_ref) {
	  var active_neighborhood = _ref.active_neighborhood;
	  var formatters = _ref.formatters;
	  var active_mode = _ref.active_mode;
	  var active_year = _ref.active_year;
	  var browser_width = _ref.browser_width;
	
	
	  var svg_width = 360;
	  if (browser_width < 451) svg_width = browser_width;
	  var svg_height = 200;
	
	  var margins = {
	    top: 20,
	    right: 60,
	    bottom: 30,
	    left: 40
	  };
	
	  var inner_width = svg_width - margins.left - margins.right;
	  var inner_height = svg_height - margins.top - margins.bottom;
	
	  var years = [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018];
	
	  var x = (0, _d3Scale.scaleLinear)().domain([years[0], years[years.length - 1]]).range([0, inner_width]);
	
	  var y = false;
	  var y_value = false;
	  var test_dots = false;
	
	  // Price graph stuff
	  if (active_mode === 'Price') {
	    var price_max = (0, _d3Array.max)(active_neighborhood.year_prices);
	    var year_index = years.indexOf(active_year);
	    var samples_year_max = active_neighborhood.samples.map(function (year_samples) {
	      return (0, _d3Array.max)(year_samples);
	    });
	    var samples_max = Math.ceil((0, _d3Array.max)(samples_year_max) / 100000) * 100000 + 200000;
	
	    y = (0, _d3Scale.scaleLinear)().domain([0, 8000000]).range([inner_height, 0]);
	
	    var liner = (0, _d3Shape.line)().x(function (d, i) {
	      return x(years[i] + 0.5);
	    }).y(function (d) {
	      return y(d);
	    });
	    var main_line = liner(active_neighborhood.year_prices);
	
	    var arear = (0, _d3Shape.area)().x(function (d, i) {
	      return x(years[i] + 0.5);
	    }).y0(function (d) {
	      return y(d[0]);
	    }).y1(function (d) {
	      return y(d[2]);
	    });
	
	    var main_area = arear(active_neighborhood.year_all_prices);
	
	    test_dots = _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement('path', {
	        d: main_area,
	        fill: '#ccc'
	      }),
	      _react2.default.createElement('path', {
	        d: main_line,
	        stroke: '#222',
	        fill: 'transparent',
	        strokeWidth: '1'
	      }),
	      _react2.default.createElement('line', {
	        x1: x(active_year + 0.5),
	        x2: x(active_year + 0.5),
	        y1: '0',
	        y2: inner_height,
	        stroke: '#666',
	        strokeWidth: '1',
	        strokeDasharray: '2,2'
	      })
	    );
	  } else {
	    y = (0, _d3Scale.scaleLinear)().domain([0, 1]).range([inner_height, 0]);
	
	    test_dots = active_neighborhood.year_probabilities.map(function (probability, i) {
	      var fill = '#ccc';
	      if (years[i] === active_year) {
	        fill = '#666';
	      }
	      return _react2.default.createElement('rect', {
	        key: years[i],
	        x: x(years[i] + 0.225),
	        y: y(probability),
	        width: x(2010.6),
	        height: inner_height - y(probability),
	        fill: fill
	      });
	    });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: '',
	      style: {
	        height: svg_height
	      }
	    },
	    _react2.default.createElement(
	      'svg',
	      {
	        style: {
	          width: svg_width,
	          height: svg_height
	        }
	      },
	      _react2.default.createElement(
	        'defs',
	        null,
	        _react2.default.createElement(
	          'clipPath',
	          { id: 'clipPath' },
	          _react2.default.createElement('rect', { x: '0', y: '0', width: inner_width + 40, height: inner_height })
	        )
	      ),
	      _react2.default.createElement(
	        'g',
	        { transform: 'translate(' + margins.left + ',' + margins.top + ')' },
	        _react2.default.createElement('rect', {
	          x: '0',
	          y: '0',
	          width: inner_width + 40,
	          height: inner_height,
	          fill: '#fafafa'
	        }),
	        _react2.default.createElement(_YearXAxis2.default, {
	          x: x,
	          formatters: formatters,
	          inner_height: inner_height,
	          svg_height: svg_height,
	          margins: margins
	        }),
	        _react2.default.createElement(_YearYAxis2.default, {
	          y: y,
	          formatters: formatters,
	          svg_width: svg_width,
	          margins: margins,
	          active_mode: active_mode
	        }),
	        _react2.default.createElement(
	          'g',
	          {
	            style: {
	              clipPath: 'url(#clipPath)'
	            }
	          },
	          test_dots
	        )
	      )
	    )
	  );
	};
	
	exports.default = YearGraph;

/***/ },
/* 85 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(31);
	
	var ReactNoopUpdateQueue = __webpack_require__(87);
	
	var canDefineProperty = __webpack_require__(145);
	var emptyObject = __webpack_require__(32);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(3);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(149);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(355);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(354);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(353);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(148);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(150);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	var Kn = 18;
	var Xn = 0.950470;
	var Yn = 1;
	var Zn = 1.088830;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var b = rgb2xyz(o.r),
	      a = rgb2xyz(o.g),
	      l = rgb2xyz(o.b),
	      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    y = Yn * lab2xyz(y);
	    x = Xn * lab2xyz(x);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function xyz2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2xyz(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.4. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(19), __webpack_require__(154), __webpack_require__(15), __webpack_require__(23), __webpack_require__(91), __webpack_require__(157), __webpack_require__(89)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    var d = domain(),
	        i = d.length - 1,
	        n = count == null ? 10 : count,
	        start = d[0],
	        stop = d[i],
	        step = d3Array.tickStep(start, stop, n);
	
	    if (step) {
	      step = d3Array.tickStep(Math.floor(start / step) * step, Math.ceil(stop / step) * step, n);
	      d[0] = Math.floor(start / step) * step;
	      d[i] = Math.ceil(stop / step) * step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = d3Array.tickStep(start, stop, interval);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ Version 1.0.4. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date;
	var t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [];
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) while (--step >= 0) while (offseti(date, 1), !test(date)) {} // eslint-disable-line no-empty
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * event-lite.js - Light-weight EventEmitter (less than 1KB when gzipped)
	 *
	 * @copyright Yusuke Kawasaki
	 * @license MIT
	 * @constructor
	 * @see https://github.com/kawanet/event-lite
	 * @see http://kawanet.github.io/event-lite/EventLite.html
	 * @example
	 * var EventLite = require("event-lite");
	 *
	 * function MyClass() {...}             // your class
	 *
	 * EventLite.mixin(MyClass.prototype);  // import event methods
	 *
	 * var obj = new MyClass();
	 * obj.on("foo", function() {...});     // add event listener
	 * obj.once("bar", function() {...});   // add one-time event listener
	 * obj.emit("foo");                     // dispatch event
	 * obj.emit("bar");                     // dispatch another event
	 * obj.off("foo");                      // remove event listener
	 */
	
	function EventLite() {
	  if (!(this instanceof EventLite)) return new EventLite();
	}
	
	(function(EventLite) {
	  // export the class for node.js
	  if (true) module.exports = EventLite;
	
	  // property name to hold listeners
	  var LISTENERS = "listeners";
	
	  // methods to export
	  var methods = {
	    on: on,
	    once: once,
	    off: off,
	    emit: emit
	  };
	
	  // mixin to self
	  mixin(EventLite.prototype);
	
	  // export mixin function
	  EventLite.mixin = mixin;
	
	  /**
	   * Import on(), once(), off() and emit() methods into target object.
	   *
	   * @function EventLite.mixin
	   * @param target {Prototype}
	   */
	
	  function mixin(target) {
	    for (var key in methods) {
	      target[key] = methods[key];
	    }
	    return target;
	  }
	
	  /**
	   * Add an event listener.
	   *
	   * @function EventLite.prototype.on
	   * @param type {string}
	   * @param func {Function}
	   * @returns {EventLite} Self for method chaining
	   */
	
	  function on(type, func) {
	    getListeners(this, type).push(func);
	    return this;
	  }
	
	  /**
	   * Add one-time event listener.
	   *
	   * @function EventLite.prototype.once
	   * @param type {string}
	   * @param func {Function}
	   * @returns {EventLite} Self for method chaining
	   */
	
	  function once(type, func) {
	    var that = this;
	    wrap.originalListener = func;
	    getListeners(that, type).push(wrap);
	    return that;
	
	    function wrap() {
	      off.call(that, type, wrap);
	      func.apply(this, arguments);
	    }
	  }
	
	  /**
	   * Remove an event listener.
	   *
	   * @function EventLite.prototype.off
	   * @param [type] {string}
	   * @param [func] {Function}
	   * @returns {EventLite} Self for method chaining
	   */
	
	  function off(type, func) {
	    var that = this;
	    var listners;
	    if (!arguments.length) {
	      delete that[LISTENERS];
	    } else if (!func) {
	      listners = that[LISTENERS];
	      if (listners) {
	        delete listners[type];
	        if (!Object.keys(listners).length) return off.call(that);
	      }
	    } else {
	      listners = getListeners(that, type, true);
	      if (listners) {
	        listners = listners.filter(ne);
	        if (!listners.length) return off.call(that, type);
	        that[LISTENERS][type] = listners;
	      }
	    }
	    return that;
	
	    function ne(test) {
	      return test !== func && test.originalListener !== func;
	    }
	  }
	
	  /**
	   * Dispatch (trigger) an event.
	   *
	   * @function EventLite.prototype.emit
	   * @param type {string}
	   * @param [value] {*}
	   * @returns {boolean} True when a listener received the event
	   */
	
	  function emit(type, value) {
	    var that = this;
	    var listeners = getListeners(that, type, true);
	    if (!listeners) return false;
	    var arglen = arguments.length;
	    if (arglen === 1) {
	      listeners.forEach(zeroarg);
	    } else if (arglen === 2) {
	      listeners.forEach(onearg);
	    } else {
	      var args = Array.prototype.slice.call(arguments, 1);
	      listeners.forEach(moreargs);
	    }
	    return !!listeners.length;
	
	    function zeroarg(func) {
	      func.call(that);
	    }
	
	    function onearg(func) {
	      func.call(that, value);
	    }
	
	    function moreargs(func) {
	      func.apply(that, args);
	    }
	  }
	
	  /**
	   * @ignore
	   */
	
	  function getListeners(that, type, readonly) {
	    if (readonly && !that[LISTENERS]) return;
	    var listeners = that[LISTENERS] || (that[LISTENERS] = {});
	    return listeners[type] || (listeners[type] = []);
	  }
	
	})(EventLite);


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(11);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 94 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 95 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(13);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(39);
	
	var _DOMUtils = __webpack_require__(52);
	
	var _createHistory = __webpack_require__(99);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(13);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(24);
	
	var _PathUtils = __webpack_require__(20);
	
	var _ExecutionEnvironment = __webpack_require__(39);
	
	var _DOMUtils = __webpack_require__(52);
	
	var _DOMStateStorage = __webpack_require__(96);
	
	var _createDOMHistory = __webpack_require__(97);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(13);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(158);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(20);
	
	var _AsyncUtils = __webpack_require__(173);
	
	var _Actions = __webpack_require__(24);
	
	var _createLocation2 = __webpack_require__(175);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(54);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(53);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(13);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(39);
	
	var _PathUtils = __webpack_require__(20);
	
	var _runTransitionHook = __webpack_require__(54);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(53);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 101 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 102 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(183);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	// decode-buffer.js
	
	exports.DecodeBuffer = DecodeBuffer;
	
	var preset = __webpack_require__(60).preset;
	
	var FlexDecoder = __webpack_require__(108).FlexDecoder;
	
	FlexDecoder.mixin(DecodeBuffer.prototype);
	
	function DecodeBuffer(options) {
	  if (!(this instanceof DecodeBuffer)) return new DecodeBuffer(options);
	
	  if (options) {
	    this.options = options;
	    if (options.codec) {
	      var codec = this.codec = options.codec;
	      if (codec.bufferish) this.bufferish = codec.bufferish;
	    }
	  }
	}
	
	DecodeBuffer.prototype.codec = preset;
	
	DecodeBuffer.prototype.fetch = function() {
	  return this.codec.decode(this);
	};


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	// decode.js
	
	exports.decode = decode;
	
	var DecodeBuffer = __webpack_require__(104).DecodeBuffer;
	
	function decode(input, options) {
	  var decoder = new DecodeBuffer(options);
	  decoder.write(input);
	  return decoder.read();
	}

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	// encode-buffer.js
	
	exports.EncodeBuffer = EncodeBuffer;
	
	var preset = __webpack_require__(61).preset;
	
	var FlexEncoder = __webpack_require__(108).FlexEncoder;
	
	FlexEncoder.mixin(EncodeBuffer.prototype);
	
	function EncodeBuffer(options) {
	  if (!(this instanceof EncodeBuffer)) return new EncodeBuffer(options);
	
	  if (options) {
	    this.options = options;
	    if (options.codec) {
	      var codec = this.codec = options.codec;
	      if (codec.bufferish) this.bufferish = codec.bufferish;
	    }
	  }
	}
	
	EncodeBuffer.prototype.codec = preset;
	
	EncodeBuffer.prototype.write = function(input) {
	  this.codec.encode(this, input);
	};


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	// encode.js
	
	exports.encode = encode;
	
	var EncodeBuffer = __webpack_require__(106).EncodeBuffer;
	
	function encode(input, options) {
	  var encoder = new EncodeBuffer(options);
	  encoder.write(input);
	  return encoder.read();
	}


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	// flex-buffer.js
	
	exports.FlexDecoder = FlexDecoder;
	exports.FlexEncoder = FlexEncoder;
	
	var Bufferish = __webpack_require__(10);
	
	var MIN_BUFFER_SIZE = 2048;
	var MAX_BUFFER_SIZE = 65536;
	var BUFFER_SHORTAGE = "BUFFER_SHORTAGE";
	
	function FlexDecoder() {
	  if (!(this instanceof FlexDecoder)) return new FlexDecoder();
	}
	
	function FlexEncoder() {
	  if (!(this instanceof FlexEncoder)) return new FlexEncoder();
	}
	
	FlexDecoder.mixin = mixinFactory(getDecoderMethods());
	FlexDecoder.mixin(FlexDecoder.prototype);
	
	FlexEncoder.mixin = mixinFactory(getEncoderMethods());
	FlexEncoder.mixin(FlexEncoder.prototype);
	
	function getDecoderMethods() {
	  return {
	    bufferish: Bufferish,
	    write: write,
	    fetch: fetch,
	    flush: flush,
	    push: push,
	    pull: pull,
	    read: read,
	    reserve: reserve,
	    offset: 0
	  };
	
	  function write(chunk) {
	    var prev = this.offset ? Bufferish.prototype.slice.call(this.buffer, this.offset) : this.buffer;
	    this.buffer = prev ? (chunk ? this.bufferish.concat([prev, chunk]) : prev) : chunk;
	    this.offset = 0;
	  }
	
	  function flush() {
	    while (this.offset < this.buffer.length) {
	      var start = this.offset;
	      var value;
	      try {
	        value = this.fetch();
	      } catch (e) {
	        if (e && e.message != BUFFER_SHORTAGE) throw e;
	        // rollback
	        this.offset = start;
	        break;
	      }
	      this.push(value);
	    }
	  }
	
	  function reserve(length) {
	    var start = this.offset;
	    var end = start + length;
	    if (end > this.buffer.length) throw new Error(BUFFER_SHORTAGE);
	    this.offset = end;
	    return start;
	  }
	}
	
	function getEncoderMethods() {
	  return {
	    bufferish: Bufferish,
	    write: write,
	    fetch: fetch,
	    flush: flush,
	    push: push,
	    pull: pull,
	    read: read,
	    reserve: reserve,
	    send: send,
	    maxBufferSize: MAX_BUFFER_SIZE,
	    minBufferSize: MIN_BUFFER_SIZE,
	    offset: 0,
	    start: 0
	  };
	
	  function fetch() {
	    var start = this.start;
	    if (start < this.offset) {
	      var end = this.start = this.offset;
	      return Bufferish.prototype.slice.call(this.buffer, start, end);
	    }
	  }
	
	  function flush() {
	    while (this.start < this.offset) {
	      var value = this.fetch();
	      if (value) this.push(value);
	    }
	  }
	
	  function pull() {
	    var buffers = this.buffers || (this.buffers = []);
	    var chunk = buffers.length > 1 ? this.bufferish.concat(buffers) : buffers[0];
	    buffers.length = 0; // buffer exhausted
	    return chunk;
	  }
	
	  function reserve(length) {
	    var req = length | 0;
	
	    if (this.buffer) {
	      var size = this.buffer.length;
	      var start = this.offset | 0;
	      var end = start + req;
	
	      // is it long enough?
	      if (end < size) {
	        this.offset = end;
	        return start;
	      }
	
	      // flush current buffer
	      this.flush();
	
	      // resize it to 2x current length
	      length = Math.max(length, Math.min(size * 2, this.maxBufferSize));
	    }
	
	    // minimum buffer size
	    length = Math.max(length, this.minBufferSize);
	
	    // allocate new buffer
	    this.buffer = this.bufferish.alloc(length);
	    this.start = 0;
	    this.offset = req;
	    return 0;
	  }
	
	  function send(buffer) {
	    var length = buffer.length;
	    if (length > this.minBufferSize) {
	      this.flush();
	      this.push(buffer);
	    } else {
	      var offset = this.reserve(length);
	      Bufferish.prototype.copy.call(buffer, this.buffer, offset);
	    }
	  }
	}
	
	// common methods
	
	function write() {
	  throw new Error("method not implemented: write()");
	}
	
	function fetch() {
	  throw new Error("method not implemented: fetch()");
	}
	
	function read() {
	  var length = this.buffers && this.buffers.length;
	
	  // fetch the first result
	  if (!length) return this.fetch();
	
	  // flush current buffer
	  this.flush();
	
	  // read from the results
	  return this.pull();
	}
	
	function push(chunk) {
	  var buffers = this.buffers || (this.buffers = []);
	  buffers.push(chunk);
	}
	
	function pull() {
	  var buffers = this.buffers || (this.buffers = []);
	  return buffers.shift();
	}
	
	function mixinFactory(source) {
	  return mixin;
	
	  function mixin(target) {
	    for (var key in source) {
	      target[key] = source[key];
	    }
	    return target;
	  }
	}


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	// read-format.js
	
	var ieee754 = __webpack_require__(102);
	var Int64Buffer = __webpack_require__(55);
	var Uint64BE = Int64Buffer.Uint64BE;
	var Int64BE = Int64Buffer.Int64BE;
	
	exports.getReadFormat = getReadFormat;
	exports.readUint8 = uint8;
	
	var Bufferish = __webpack_require__(10);
	var BufferProto = __webpack_require__(58);
	
	var HAS_MAP = ("undefined" !== typeof Map);
	var NO_ASSERT = true;
	
	function getReadFormat(options) {
	  var binarraybuffer = Bufferish.hasArrayBuffer && options && options.binarraybuffer;
	  var int64 = options && options.int64;
	  var usemap = HAS_MAP && options && options.usemap;
	
	  var readFormat = {
	    map: (usemap ? map_to_map : map_to_obj),
	    array: array,
	    str: str,
	    bin: (binarraybuffer ? bin_arraybuffer : bin_buffer),
	    ext: ext,
	    uint8: uint8,
	    uint16: uint16,
	    uint32: uint32,
	    uint64: read(8, int64 ? readUInt64BE_int64 : readUInt64BE),
	    int8: int8,
	    int16: int16,
	    int32: int32,
	    int64: read(8, int64 ? readInt64BE_int64 : readInt64BE),
	    float32: read(4, readFloatBE),
	    float64: read(8, readDoubleBE)
	  };
	
	  return readFormat;
	}
	
	function map_to_obj(decoder, len) {
	  var value = {};
	  var i;
	  var k = new Array(len);
	  var v = new Array(len);
	
	  var decode = decoder.codec.decode;
	  for (i = 0; i < len; i++) {
	    k[i] = decode(decoder);
	    v[i] = decode(decoder);
	  }
	  for (i = 0; i < len; i++) {
	    value[k[i]] = v[i];
	  }
	  return value;
	}
	
	function map_to_map(decoder, len) {
	  var value = new Map();
	  var i;
	  var k = new Array(len);
	  var v = new Array(len);
	
	  var decode = decoder.codec.decode;
	  for (i = 0; i < len; i++) {
	    k[i] = decode(decoder);
	    v[i] = decode(decoder);
	  }
	  for (i = 0; i < len; i++) {
	    value.set(k[i], v[i]);
	  }
	  return value;
	}
	
	function array(decoder, len) {
	  var value = new Array(len);
	  var decode = decoder.codec.decode;
	  for (var i = 0; i < len; i++) {
	    value[i] = decode(decoder);
	  }
	  return value;
	}
	
	function str(decoder, len) {
	  var start = decoder.reserve(len);
	  var end = start + len;
	  return BufferProto.toString.call(decoder.buffer, "utf-8", start, end);
	}
	
	function bin_buffer(decoder, len) {
	  var start = decoder.reserve(len);
	  var end = start + len;
	  var buf = BufferProto.slice.call(decoder.buffer, start, end);
	  return Bufferish.from(buf);
	}
	
	function bin_arraybuffer(decoder, len) {
	  var start = decoder.reserve(len);
	  var end = start + len;
	  var buf = BufferProto.slice.call(decoder.buffer, start, end);
	  return Bufferish.Uint8Array.from(buf).buffer;
	}
	
	function ext(decoder, len) {
	  var start = decoder.reserve(len+1);
	  var type = decoder.buffer[start++];
	  var end = start + len;
	  var unpack = decoder.codec.getExtUnpacker(type);
	  if (!unpack) throw new Error("Invalid ext type: " + (type ? ("0x" + type.toString(16)) : type));
	  var buf = BufferProto.slice.call(decoder.buffer, start, end);
	  return unpack(buf);
	}
	
	function uint8(decoder) {
	  var start = decoder.reserve(1);
	  return decoder.buffer[start];
	}
	
	function int8(decoder) {
	  var start = decoder.reserve(1);
	  var value = decoder.buffer[start];
	  return (value & 0x80) ? value - 0x100 : value;
	}
	
	function uint16(decoder) {
	  var start = decoder.reserve(2);
	  var buffer = decoder.buffer;
	  return (buffer[start++] << 8) | buffer[start];
	}
	
	function int16(decoder) {
	  var start = decoder.reserve(2);
	  var buffer = decoder.buffer;
	  var value = (buffer[start++] << 8) | buffer[start];
	  return (value & 0x8000) ? value - 0x10000 : value;
	}
	
	function uint32(decoder) {
	  var start = decoder.reserve(4);
	  var buffer = decoder.buffer;
	  return (buffer[start++] * 16777216) + (buffer[start++] << 16) + (buffer[start++] << 8) + buffer[start];
	}
	
	function int32(decoder) {
	  var start = decoder.reserve(4);
	  var buffer = decoder.buffer;
	  return (buffer[start++] << 24) | (buffer[start++] << 16) | (buffer[start++] << 8) | buffer[start];
	}
	
	function read(len, method) {
	  return function(decoder) {
	    var start = decoder.reserve(len);
	    return method.call(decoder.buffer, start, NO_ASSERT);
	  };
	}
	
	function readUInt64BE(start) {
	  return new Uint64BE(this, start).toNumber();
	}
	
	function readInt64BE(start) {
	  return new Int64BE(this, start).toNumber();
	}
	
	function readUInt64BE_int64(start) {
	  return new Uint64BE(this, start);
	}
	
	function readInt64BE_int64(start) {
	  return new Int64BE(this, start);
	}
	
	function readFloatBE(start) {
	  return ieee754.read(this, start, false, 23, 4);
	}
	
	function readDoubleBE(start) {
	  return ieee754.read(this, start, false, 52, 8);
	}

/***/ },
/* 110 */
/***/ function(module, exports) {

	// write-unit8.js
	
	var constant = exports.uint8 = new Array(256);
	
	for (var i = 0x00; i <= 0xFF; i++) {
	  constant[i] = write0(i);
	}
	
	function write0(type) {
	  return function(encoder) {
	    var offset = encoder.reserve(1);
	    encoder.buffer[offset] = type;
	  };
	}


/***/ },
/* 111 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(21);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(26);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactInstrumentation = __webpack_require__(12);
	
	var quoteAttributeValueForBrowser = __webpack_require__(264);
	var warning = __webpack_require__(3);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 114 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var LinkedValueUtils = __webpack_require__(67);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(14);
	
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 116 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 117 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(2);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(223);
	
	var containsNode = __webpack_require__(163);
	var focusNode = __webpack_require__(94);
	var getActiveElement = __webpack_require__(95);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(25);
	var DOMProperty = __webpack_require__(26);
	var React = __webpack_require__(29);
	var ReactBrowserEventEmitter = __webpack_require__(42);
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMContainerInfo = __webpack_require__(217);
	var ReactDOMFeatureFlags = __webpack_require__(219);
	var ReactFeatureFlags = __webpack_require__(117);
	var ReactInstanceMap = __webpack_require__(35);
	var ReactInstrumentation = __webpack_require__(12);
	var ReactMarkupChecksum = __webpack_require__(233);
	var ReactReconciler = __webpack_require__(27);
	var ReactUpdateQueue = __webpack_require__(70);
	var ReactUpdates = __webpack_require__(14);
	
	var emptyObject = __webpack_require__(32);
	var instantiateReactComponent = __webpack_require__(127);
	var invariant = __webpack_require__(2);
	var setInnerHTML = __webpack_require__(46);
	var shouldUpdateReactComponent = __webpack_require__(76);
	var warning = __webpack_require__(3);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var React = __webpack_require__(29);
	
	var invariant = __webpack_require__(2);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 122 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 124 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(121);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(5);
	
	var ReactCompositeComponent = __webpack_require__(214);
	var ReactEmptyComponent = __webpack_require__(116);
	var ReactHostComponent = __webpack_require__(118);
	
	var getNextDebugID = __webpack_require__(261);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 128 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	var escapeTextContentForBrowser = __webpack_require__(45);
	var setInnerHTML = __webpack_require__(46);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var REACT_ELEMENT_TYPE = __webpack_require__(229);
	
	var getIteratorFn = __webpack_require__(260);
	var invariant = __webpack_require__(2);
	var KeyEscapeUtils = __webpack_require__(66);
	var warning = __webpack_require__(3);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(266);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(267);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	exports["default"] = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ },
/* 133 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(18);
	
	var _PatternUtils = __webpack_require__(28);
	
	var _InternalPropTypes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(48);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(40);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(100);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(176);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(140);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(48);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(40);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(100);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(292);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(31);
	
	var ReactCurrentOwner = __webpack_require__(17);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 143 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 146 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 147 */
/***/ function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1);
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		// local imports
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		var _utilCreateResponsiveStateReducer = __webpack_require__(2);
		
		var _utilCreateResponsiveStateReducer2 = _interopRequireDefault(_utilCreateResponsiveStateReducer);
		
		var _utilCreateResponsiveStoreEnhancer = __webpack_require__(123);
		
		var _utilCreateResponsiveStoreEnhancer2 = _interopRequireDefault(_utilCreateResponsiveStoreEnhancer);
		
		var _actionsTypes = __webpack_require__(131);
		
		Object.defineProperty(exports, 'CALCULATE_RESPONSIVE_STATE', {
		  enumerable: true,
		  get: function get() {
		    return _actionsTypes.CALCULATE_RESPONSIVE_STATE;
		  }
		});
		
		var _actionsCreators = __webpack_require__(133);
		
		Object.defineProperty(exports, 'calculateResponsiveState', {
		  enumerable: true,
		  get: function get() {
		    return _actionsCreators.calculateResponsiveState;
		  }
		});
		var createResponsiveStateReducer = _utilCreateResponsiveStateReducer2['default'];
		exports.createResponsiveStateReducer = createResponsiveStateReducer;
		var createResponsiveStoreEnhancer = _utilCreateResponsiveStoreEnhancer2['default'];
		exports.createResponsiveStoreEnhancer = createResponsiveStoreEnhancer;
		// provide default responsive state reducer
		var responsiveStateReducer = createResponsiveStateReducer();
		exports.responsiveStateReducer = responsiveStateReducer;
		// provide default responsive store enhancer
		var responsiveStoreEnhancer = createResponsiveStoreEnhancer();
		exports.responsiveStoreEnhancer = responsiveStoreEnhancer;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		// third party imports
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		    value: true
		});
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		var _mediaquery = __webpack_require__(3);
		
		var _mediaquery2 = _interopRequireDefault(_mediaquery);
		
		var _lodashTransform = __webpack_require__(5);
		
		var _lodashTransform2 = _interopRequireDefault(_lodashTransform);
		
		var _lodashReduce = __webpack_require__(117);
		
		var _lodashReduce2 = _interopRequireDefault(_lodashReduce);
		
		// local imports
		
		var _actionsTypesCALCULATE_RESPONSIVE_STATE = __webpack_require__(122);
		
		var _actionsTypesCALCULATE_RESPONSIVE_STATE2 = _interopRequireDefault(_actionsTypesCALCULATE_RESPONSIVE_STATE);
		
		// default breakpoints
		var defaultBreakpoints = {
		    extraSmall: 480,
		    small: 768,
		    medium: 992,
		    large: 1200
		};
		// media type to default to when no `window` present
		var defaultMediaType = 'infinity';
		// orientation to default to when no `window` present
		var defaultOrientation = null;
		
		/**
		 * Compute the `lessThan` object based on the browser width.
		 * @arg {number} browserWidth - Width of the browser.
		 * @arg {object} breakpoints - The breakpoints object.
		 * @returns {object} The `lessThan` object.  Its keys are the same as the
		 * keys of the breakpoints object.  The value for each key indicates whether
		 * or not the browser width is less than the breakpoint.
		 */
		function getLessThan(browserWidth, breakpoints, currentMediaType) {
		    return (0, _lodashTransform2['default'])(breakpoints, function (result, breakpoint, mediaType) {
		        // if the breakpoint is a number
		        if (typeof breakpoint === 'number') {
		            // store wether or not it is less than the breakpoint
		            result[mediaType] = browserWidth < breakpoint && mediaType !== currentMediaType;
		            // handle non numerical breakpoints specially
		        } else {
		                result[mediaType] = false;
		            }
		    });
		}
		
		/**
		 * Compute the `greaterThan` object based on the browser width.
		 * @arg {number} browserWidth - Width of the browser.
		 * @arg {object} breakpoints - The breakpoints object.
		 * @returns {object} The `greaterThan` object.  Its keys are the same as the
		 * keys of the breakpoints object.  The value for each key indicates whether
		 * or not the browser width is greater than the breakpoint.
		 */
		function getGreaterThan(browserWidth, breakpoints) {
		    return (0, _lodashTransform2['default'])(breakpoints, function (result, breakpoint, mediaType) {
		        // if the breakpoint is a number
		        if (typeof breakpoint === 'number') {
		            // store wether or not it is greater than the breakpoint
		            result[mediaType] = browserWidth > breakpoint;
		        } else {
		            result[mediaType] = false;
		        }
		    });
		}
		
		/**
		 * Gets the current media type from the global `window`.
		 * @arg {object} mediaQueries - The media queries object.
		 * @arg {string} infinityMediaType - The infinity media type.
		 * @returns {string} The window's current media type.  This is the key of the
		 * breakpoint that is the next breakpoint larger than the window.
		 */
		function getMediaType(matchMedia, mediaQueries, infinityMediaType) {
		    // if there's no window
		    if (typeof matchMedia === 'undefined') {
		        // return the infinity media type
		        return infinityMediaType;
		    }
		
		    // there is a window, so compute the true media type
		    return (0, _lodashReduce2['default'])(mediaQueries, function (result, query, type) {
		        // return the new type if the query matches otherwise the previous one
		        return matchMedia(query).matches ? type : result;
		        // use the infinity media type
		    }, infinityMediaType);
		}
		
		/**
		 * Gets the current media type from the global `window`.
		 * @arg {object} mediaQueries - The media queries object.
		 * @returns {string} The window's current media type.  This is the key of the
		 * breakpoint that is the next breakpoint larger than the window.
		 */
		function getOrientation(matchMedia) {
		    // if there's no window
		    if (typeof matchMedia === 'undefined') {
		        // return the default
		        return defaultOrientation;
		    }
		
		    var mediaQueries = {
		        portrait: '(orientation: portrait)',
		        landscape: '(orientation: landscape)'
		    };
		
		    // there is a window, so compute the true orientation
		    return (0, _lodashReduce2['default'])(mediaQueries, function (result, query, type) {
		        // return the new type if the query matches otherwise the previous one
		        return matchMedia(query).matches ? type : result;
		        // use the default orientation
		    }, defaultOrientation);
		}
		
		// export the reducer factory
		
		exports['default'] = function () {
		    var breakpoints = arguments.length <= 0 || arguments[0] === undefined ? defaultBreakpoints : arguments[0];
		    var infinityMediaType = arguments.length <= 1 || arguments[1] === undefined ? defaultMediaType : arguments[1];
		
		    // add `infinity` breakpoint for upper bound
		    breakpoints[infinityMediaType] = Infinity;
		    // media queries associated with the breakpoints
		    var mediaQueries = _mediaquery2['default'].asObject(breakpoints);
		
		    // return reducer for handling the responsive state
		    return function (state, _ref) {
		        var type = _ref.type;
		        var matchMedia = _ref.matchMedia;
		        var innerWidth = _ref.innerWidth;
		        var innerHeight = _ref.innerHeight;
		
		        // if told to recalculate state or state has not yet been initialized
		        if (type === _actionsTypesCALCULATE_RESPONSIVE_STATE2['default'] || typeof state === 'undefined') {
		            // the current media type
		            var mediaType = getMediaType(matchMedia, mediaQueries, infinityMediaType);
		            // the current orientation
		            var orientation = getOrientation(matchMedia);
		            // return calculated state
		            return {
		                _responsiveState: true,
		                width: innerWidth,
		                height: innerHeight,
		                lessThan: getLessThan(innerWidth, breakpoints, mediaType),
		                greaterThan: getGreaterThan(innerWidth, breakpoints),
		                mediaType: mediaType,
		                orientation: orientation,
		                breakpoints: breakpoints
		            };
		        }
		        // otherwise return the previous state
		        return state;
		    };
		};
		
		module.exports = exports['default'];
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports =  __webpack_require__(4);
		
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var MQ = {
		
		  asArray: function asArray(obj) {
		    var bp = this.getBreakPoints(obj);
		    var custom = this.getCustomQueries(obj);
		
		    return this._translate(this._makeSteps(this._toSortedArray(bp)))
		      .concat(this._objToArr(custom));
		  },
		
		  asObject: function asObject(obj) {
		    return this._arrToObj(this.asArray(obj));
		  },
		
		  getBreakPoints: function getBreakPoints(obj) {
		    return Object.keys(obj).reduce(function (prev, next) {
		      if (typeof obj[next] === 'number') {
		        prev[next] = obj[next];
		      }
		      return prev;
		    }, {});
		  },
		
		  getCustomQueries: function getCustomQueries(obj) {
		    return Object.keys(obj).reduce(function (prev, next) {
		      if (typeof obj[next] === 'string') {
		        prev[next] = obj[next];
		      }
		      return prev;
		    }, {});
		  },
		
		  _toSortedArray: function _toSortedArray(obj) {
		    return Object.keys(obj).map(function (el) {
		      return [el, obj[el]];
		    }).sort(function (a, b) {
		      return a[1] - b[1];
		    });
		  },
		
		  _makeSteps: function _makeSteps(arr) {
		    return (arr[arr.length - 1][1] === Infinity)?
		      arr
		      : arr.concat([Infinity]);
		  },
		
		  _translate: function _translate(arr) {
		    return arr.map(function (el, index) {
		      return (index === 0)?
		        [el[0], 'screen and (max-width: ' + el[1] + 'px)']
		        : (index === arr.length - 1)?
		          [(el[0] || 'default'), 'screen and (min-width: ' +
		            (arr[index - 1][1] + 1) + 'px)']
		          : [el[0], 'screen and (min-width: ' + (arr[index-1][1] + 1) +
		            'px) and (max-width: ' + el[1] + 'px)'];
		    });
		  },
		
		  _objToArr: function _objToArr(obj) {
		    return Object.keys(obj).map(function (el) {
		      return [el, obj[el]];
		    });
		  },
		
		  _arrToObj: function _arrToObj(arr) {
		    return arr.reduce(function (prev, next) {
		      prev[next[0]] = next[1];
		      return prev;
		    }, {});
		  }
		};
		
		if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
		    module.exports = MQ;
		} else {
		  if (true) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		      return MQ;
		    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		  }
		  else {
		    window.MQ = MQ;
		  }
		}
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		var arrayEach = __webpack_require__(6),
		    baseCreate = __webpack_require__(7),
		    baseForOwn = __webpack_require__(9),
		    baseIteratee = __webpack_require__(31),
		    getPrototype = __webpack_require__(14),
		    isArray = __webpack_require__(27),
		    isFunction = __webpack_require__(24),
		    isObject = __webpack_require__(8),
		    isTypedArray = __webpack_require__(92);
		
		/**
		 * An alternative to `_.reduce`; this method transforms `object` to a new
		 * `accumulator` object which is the result of running each of its own
		 * enumerable string keyed properties thru `iteratee`, with each invocation
		 * potentially mutating the `accumulator` object. If `accumulator` is not
		 * provided, a new object with the same `[[Prototype]]` will be used. The
		 * iteratee is invoked with four arguments: (accumulator, value, key, object).
		 * Iteratee functions may exit iteration early by explicitly returning `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 1.3.0
		 * @category Object
		 * @param {Object} object The object to iterate over.
		 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
		 * @param {*} [accumulator] The custom accumulator value.
		 * @returns {*} Returns the accumulated value.
		 * @example
		 *
		 * _.transform([2, 3, 4], function(result, n) {
		 *   result.push(n *= n);
		 *   return n % 2 == 0;
		 * }, []);
		 * // => [4, 9]
		 *
		 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
		 *   (result[value] || (result[value] = [])).push(key);
		 * }, {});
		 * // => { '1': ['a', 'c'], '2': ['b'] }
		 */
		function transform(object, iteratee, accumulator) {
		  var isArr = isArray(object) || isTypedArray(object);
		  iteratee = baseIteratee(iteratee, 4);
		
		  if (accumulator == null) {
		    if (isArr || isObject(object)) {
		      var Ctor = object.constructor;
		      if (isArr) {
		        accumulator = isArray(object) ? new Ctor : [];
		      } else {
		        accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
		      }
		    } else {
		      accumulator = {};
		    }
		  }
		  (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
		    return iteratee(accumulator, value, index, object);
		  });
		  return accumulator;
		}
		
		module.exports = transform;
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		/**
		 * A specialized version of `_.forEach` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns `array`.
		 */
		function arrayEach(array, iteratee) {
		  var index = -1,
		      length = array ? array.length : 0;
		
		  while (++index < length) {
		    if (iteratee(array[index], index, array) === false) {
		      break;
		    }
		  }
		  return array;
		}
		
		module.exports = arrayEach;
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(8);
		
		/** Built-in value references. */
		var objectCreate = Object.create;
		
		/**
		 * The base implementation of `_.create` without support for assigning
		 * properties to the created object.
		 *
		 * @private
		 * @param {Object} prototype The object to inherit from.
		 * @returns {Object} Returns the new object.
		 */
		function baseCreate(proto) {
		  return isObject(proto) ? objectCreate(proto) : {};
		}
		
		module.exports = baseCreate;
	
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */
		function isObject(value) {
		  var type = typeof value;
		  return !!value && (type == 'object' || type == 'function');
		}
		
		module.exports = isObject;
	
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseFor = __webpack_require__(10),
		    keys = __webpack_require__(12);
		
		/**
		 * The base implementation of `_.forOwn` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Object} Returns `object`.
		 */
		function baseForOwn(object, iteratee) {
		  return object && baseFor(object, iteratee, keys);
		}
		
		module.exports = baseForOwn;
	
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		var createBaseFor = __webpack_require__(11);
		
		/**
		 * The base implementation of `baseForOwn` which iterates over `object`
		 * properties returned by `keysFunc` and invokes `iteratee` for each property.
		 * Iteratee functions may exit iteration early by explicitly returning `false`.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @returns {Object} Returns `object`.
		 */
		var baseFor = createBaseFor();
		
		module.exports = baseFor;
	
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
		/**
		 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
		 *
		 * @private
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Function} Returns the new base function.
		 */
		function createBaseFor(fromRight) {
		  return function(object, iteratee, keysFunc) {
		    var index = -1,
		        iterable = Object(object),
		        props = keysFunc(object),
		        length = props.length;
		
		    while (length--) {
		      var key = props[fromRight ? length : ++index];
		      if (iteratee(iterable[key], key, iterable) === false) {
		        break;
		      }
		    }
		    return object;
		  };
		}
		
		module.exports = createBaseFor;
	
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseHas = __webpack_require__(13),
		    baseKeys = __webpack_require__(16),
		    indexKeys = __webpack_require__(17),
		    isArrayLike = __webpack_require__(21),
		    isIndex = __webpack_require__(29),
		    isPrototype = __webpack_require__(30);
		
		/**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */
		function keys(object) {
		  var isProto = isPrototype(object);
		  if (!(isProto || isArrayLike(object))) {
		    return baseKeys(object);
		  }
		  var indexes = indexKeys(object),
		      skipIndexes = !!indexes,
		      result = indexes || [],
		      length = result.length;
		
		  for (var key in object) {
		    if (baseHas(object, key) &&
		        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
		        !(isProto && key == 'constructor')) {
		      result.push(key);
		    }
		  }
		  return result;
		}
		
		module.exports = keys;
	
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getPrototype = __webpack_require__(14);
		
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
		
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
		
		/**
		 * The base implementation of `_.has` without support for deep paths.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {Array|string} key The key to check.
		 * @returns {boolean} Returns `true` if `key` exists, else `false`.
		 */
		function baseHas(object, key) {
		  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
		  // that are composed entirely of index properties, return `false` for
		  // `hasOwnProperty` checks of them.
		  return object != null &&
		    (hasOwnProperty.call(object, key) ||
		      (typeof object == 'object' && key in object && getPrototype(object) === null));
		}
		
		module.exports = baseHas;
	
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		var overArg = __webpack_require__(15);
		
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeGetPrototype = Object.getPrototypeOf;
		
		/**
		 * Gets the `[[Prototype]]` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {null|Object} Returns the `[[Prototype]]`.
		 */
		var getPrototype = overArg(nativeGetPrototype, Object);
		
		module.exports = getPrototype;
	
	
	/***/ },
	/* 15 */
	/***/ function(module, exports) {
	
		/**
		 * Creates a function that invokes `func` with its first argument transformed.
		 *
		 * @private
		 * @param {Function} func The function to wrap.
		 * @param {Function} transform The argument transform.
		 * @returns {Function} Returns the new function.
		 */
		function overArg(func, transform) {
		  return function(arg) {
		    return func(transform(arg));
		  };
		}
		
		module.exports = overArg;
	
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		var overArg = __webpack_require__(15);
		
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeKeys = Object.keys;
		
		/**
		 * The base implementation of `_.keys` which doesn't skip the constructor
		 * property of prototypes or treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		var baseKeys = overArg(nativeKeys, Object);
		
		module.exports = baseKeys;
	
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseTimes = __webpack_require__(18),
		    isArguments = __webpack_require__(19),
		    isArray = __webpack_require__(27),
		    isLength = __webpack_require__(25),
		    isString = __webpack_require__(28);
		
		/**
		 * Creates an array of index keys for `object` values of arrays,
		 * `arguments` objects, and strings, otherwise `null` is returned.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array|null} Returns index keys, else `null`.
		 */
		function indexKeys(object) {
		  var length = object ? object.length : undefined;
		  if (isLength(length) &&
		      (isArray(object) || isString(object) || isArguments(object))) {
		    return baseTimes(length, String);
		  }
		  return null;
		}
		
		module.exports = indexKeys;
	
	
	/***/ },
	/* 18 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */
		function baseTimes(n, iteratee) {
		  var index = -1,
		      result = Array(n);
		
		  while (++index < n) {
		    result[index] = iteratee(index);
		  }
		  return result;
		}
		
		module.exports = baseTimes;
	
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArrayLikeObject = __webpack_require__(20);
		
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]';
		
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
		
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
		
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
		
		/** Built-in value references. */
		var propertyIsEnumerable = objectProto.propertyIsEnumerable;
		
		/**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */
		function isArguments(value) {
		  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
		  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
		    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
		}
		
		module.exports = isArguments;
	
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArrayLike = __webpack_require__(21),
		    isObjectLike = __webpack_require__(26);
		
		/**
		 * This method is like `_.isArrayLike` except that it also checks if `value`
		 * is an object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array-like object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArrayLikeObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLikeObject(document.body.children);
		 * // => true
		 *
		 * _.isArrayLikeObject('abc');
		 * // => false
		 *
		 * _.isArrayLikeObject(_.noop);
		 * // => false
		 */
		function isArrayLikeObject(value) {
		  return isObjectLike(value) && isArrayLike(value);
		}
		
		module.exports = isArrayLikeObject;
	
	
	/***/ },
	/* 21 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getLength = __webpack_require__(22),
		    isFunction = __webpack_require__(24),
		    isLength = __webpack_require__(25);
		
		/**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */
		function isArrayLike(value) {
		  return value != null && isLength(getLength(value)) && !isFunction(value);
		}
		
		module.exports = isArrayLike;
	
	
	/***/ },
	/* 22 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseProperty = __webpack_require__(23);
		
		/**
		 * Gets the "length" property value of `object`.
		 *
		 * **Note:** This function is used to avoid a
		 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
		 * Safari on at least iOS 8.1-8.3 ARM64.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {*} Returns the "length" value.
		 */
		var getLength = baseProperty('length');
		
		module.exports = getLength;
	
	
	/***/ },
	/* 23 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.property` without support for deep paths.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 */
		function baseProperty(key) {
		  return function(object) {
		    return object == null ? undefined : object[key];
		  };
		}
		
		module.exports = baseProperty;
	
	
	/***/ },
	/* 24 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(8);
		
		/** `Object#toString` result references. */
		var funcTag = '[object Function]',
		    genTag = '[object GeneratorFunction]';
		
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
		
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
		
		/**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */
		function isFunction(value) {
		  // The use of `Object#toString` avoids issues with the `typeof` operator
		  // in Safari 8 which returns 'object' for typed array and weak map constructors,
		  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
		  var tag = isObject(value) ? objectToString.call(value) : '';
		  return tag == funcTag || tag == genTag;
		}
		
		module.exports = isFunction;
	
	
	/***/ },
	/* 25 */
	/***/ function(module, exports) {
	
		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;
		
		/**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This function is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length,
		 *  else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */
		function isLength(value) {
		  return typeof value == 'number' &&
		    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
		}
		
		module.exports = isLength;
	
	
	/***/ },
	/* 26 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */
		function isObjectLike(value) {
		  return !!value && typeof value == 'object';
		}
		
		module.exports = isObjectLike;
	
	
	/***/ },
	/* 27 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */
		var isArray = Array.isArray;
		
		module.exports = isArray;
	
	
	/***/ },
	/* 28 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArray = __webpack_require__(27),
		    isObjectLike = __webpack_require__(26);
		
		/** `Object#toString` result references. */
		var stringTag = '[object String]';
		
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
		
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
		
		/**
		 * Checks if `value` is classified as a `String` primitive or object.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
		 * @example
		 *
		 * _.isString('abc');
		 * // => true
		 *
		 * _.isString(1);
		 * // => false
		 */
		function isString(value) {
		  return typeof value == 'string' ||
		    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
		}
		
		module.exports = isString;
	
	
	/***/ },
	/* 29 */
	/***/ function(module, exports) {
	
		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;
		
		/** Used to detect unsigned integer values. */
		var reIsUint = /^(?:0|[1-9]\d*)$/;
		
		/**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */
		function isIndex(value, length) {
		  length = length == null ? MAX_SAFE_INTEGER : length;
		  return !!length &&
		    (typeof value == 'number' || reIsUint.test(value)) &&
		    (value > -1 && value % 1 == 0 && value < length);
		}
		
		module.exports = isIndex;
	
	
	/***/ },
	/* 30 */
	/***/ function(module, exports) {
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
		
		/**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */
		function isPrototype(value) {
		  var Ctor = value && value.constructor,
		      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
		
		  return value === proto;
		}
		
		module.exports = isPrototype;
	
	
	/***/ },
	/* 31 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseMatches = __webpack_require__(32),
		    baseMatchesProperty = __webpack_require__(100),
		    identity = __webpack_require__(114),
		    isArray = __webpack_require__(27),
		    property = __webpack_require__(115);
		
		/**
		 * The base implementation of `_.iteratee`.
		 *
		 * @private
		 * @param {*} [value=_.identity] The value to convert to an iteratee.
		 * @returns {Function} Returns the iteratee.
		 */
		function baseIteratee(value) {
		  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
		  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
		  if (typeof value == 'function') {
		    return value;
		  }
		  if (value == null) {
		    return identity;
		  }
		  if (typeof value == 'object') {
		    return isArray(value)
		      ? baseMatchesProperty(value[0], value[1])
		      : baseMatches(value);
		  }
		  return property(value);
		}
		
		module.exports = baseIteratee;
	
	
	/***/ },
	/* 32 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseIsMatch = __webpack_require__(33),
		    getMatchData = __webpack_require__(97),
		    matchesStrictComparable = __webpack_require__(99);
		
		/**
		 * The base implementation of `_.matches` which doesn't clone `source`.
		 *
		 * @private
		 * @param {Object} source The object of property values to match.
		 * @returns {Function} Returns the new spec function.
		 */
		function baseMatches(source) {
		  var matchData = getMatchData(source);
		  if (matchData.length == 1 && matchData[0][2]) {
		    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
		  }
		  return function(object) {
		    return object === source || baseIsMatch(object, source, matchData);
		  };
		}
		
		module.exports = baseMatches;
	
	
	/***/ },
	/* 33 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Stack = __webpack_require__(34),
		    baseIsEqual = __webpack_require__(73);
		
		/** Used to compose bitmasks for comparison styles. */
		var UNORDERED_COMPARE_FLAG = 1,
		    PARTIAL_COMPARE_FLAG = 2;
		
		/**
		 * The base implementation of `_.isMatch` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Object} object The object to inspect.
		 * @param {Object} source The object of property values to match.
		 * @param {Array} matchData The property names, values, and compare flags to match.
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
		 */
		function baseIsMatch(object, source, matchData, customizer) {
		  var index = matchData.length,
		      length = index,
		      noCustomizer = !customizer;
		
		  if (object == null) {
		    return !length;
		  }
		  object = Object(object);
		  while (index--) {
		    var data = matchData[index];
		    if ((noCustomizer && data[2])
		          ? data[1] !== object[data[0]]
		          : !(data[0] in object)
		        ) {
		      return false;
		    }
		  }
		  while (++index < length) {
		    data = matchData[index];
		    var key = data[0],
		        objValue = object[key],
		        srcValue = data[1];
		
		    if (noCustomizer && data[2]) {
		      if (objValue === undefined && !(key in object)) {
		        return false;
		      }
		    } else {
		      var stack = new Stack;
		      if (customizer) {
		        var result = customizer(objValue, srcValue, key, object, source, stack);
		      }
		      if (!(result === undefined
		            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
		            : result
		          )) {
		        return false;
		      }
		    }
		  }
		  return true;
		}
		
		module.exports = baseIsMatch;
	
	
	/***/ },
	/* 34 */
	/***/ function(module, exports, __webpack_require__) {
	
		var ListCache = __webpack_require__(35),
		    stackClear = __webpack_require__(43),
		    stackDelete = __webpack_require__(44),
		    stackGet = __webpack_require__(45),
		    stackHas = __webpack_require__(46),
		    stackSet = __webpack_require__(47);
		
		/**
		 * Creates a stack cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Stack(entries) {
		  this.__data__ = new ListCache(entries);
		}
		
		// Add methods to `Stack`.
		Stack.prototype.clear = stackClear;
		Stack.prototype['delete'] = stackDelete;
		Stack.prototype.get = stackGet;
		Stack.prototype.has = stackHas;
		Stack.prototype.set = stackSet;
		
		module.exports = Stack;
	
	
	/***/ },
	/* 35 */
	/***/ function(module, exports, __webpack_require__) {
	
		var listCacheClear = __webpack_require__(36),
		    listCacheDelete = __webpack_require__(37),
		    listCacheGet = __webpack_require__(40),
		    listCacheHas = __webpack_require__(41),
		    listCacheSet = __webpack_require__(42);
		
		/**
		 * Creates an list cache object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function ListCache(entries) {
		  var index = -1,
		      length = entries ? entries.length : 0;
		
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
		
		// Add methods to `ListCache`.
		ListCache.prototype.clear = listCacheClear;
		ListCache.prototype['delete'] = listCacheDelete;
		ListCache.prototype.get = listCacheGet;
		ListCache.prototype.has = listCacheHas;
		ListCache.prototype.set = listCacheSet;
		
		module.exports = ListCache;
	
	
	/***/ },
	/* 36 */
	/***/ function(module, exports) {
	
		/**
		 * Removes all key-value entries from the list cache.
		 *
		 * @private
		 * @name clear
		 * @memberOf ListCache
		 */
		function listCacheClear() {
		  this.__data__ = [];
		}
		
		module.exports = listCacheClear;
	
	
	/***/ },
	/* 37 */
	/***/ function(module, exports, __webpack_require__) {
	
		var assocIndexOf = __webpack_require__(38);
		
		/** Used for built-in method references. */
		var arrayProto = Array.prototype;
		
		/** Built-in value references. */
		var splice = arrayProto.splice;
		
		/**
		 * Removes `key` and its value from the list cache.
		 *
		 * @private
		 * @name delete
		 * @memberOf ListCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function listCacheDelete(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
		
		  if (index < 0) {
		    return false;
		  }
		  var lastIndex = data.length - 1;
		  if (index == lastIndex) {
		    data.pop();
		  } else {
		    splice.call(data, index, 1);
		  }
		  return true;
		}
		
		module.exports = listCacheDelete;
	
	
	/***/ },
	/* 38 */
	/***/ function(module, exports, __webpack_require__) {
	
		var eq = __webpack_require__(39);
		
		/**
		 * Gets the index at which the `key` is found in `array` of key-value pairs.
		 *
		 * @private
		 * @param {Array} array The array to search.
		 * @param {*} key The key to search for.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function assocIndexOf(array, key) {
		  var length = array.length;
		  while (length--) {
		    if (eq(array[length][0], key)) {
		      return length;
		    }
		  }
		  return -1;
		}
		
		module.exports = assocIndexOf;
	
	
	/***/ },
	/* 39 */
	/***/ function(module, exports) {
	
		/**
		 * Performs a
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
		 * comparison between two values to determine if they are equivalent.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.eq(object, object);
		 * // => true
		 *
		 * _.eq(object, other);
		 * // => false
		 *
		 * _.eq('a', 'a');
		 * // => true
		 *
		 * _.eq('a', Object('a'));
		 * // => false
		 *
		 * _.eq(NaN, NaN);
		 * // => true
		 */
		function eq(value, other) {
		  return value === other || (value !== value && other !== other);
		}
		
		module.exports = eq;
	
	
	/***/ },
	/* 40 */
	/***/ function(module, exports, __webpack_require__) {
	
		var assocIndexOf = __webpack_require__(38);
		
		/**
		 * Gets the list cache value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf ListCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function listCacheGet(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
		
		  return index < 0 ? undefined : data[index][1];
		}
		
		module.exports = listCacheGet;
	
	
	/***/ },
	/* 41 */
	/***/ function(module, exports, __webpack_require__) {
	
		var assocIndexOf = __webpack_require__(38);
		
		/**
		 * Checks if a list cache value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf ListCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function listCacheHas(key) {
		  return assocIndexOf(this.__data__, key) > -1;
		}
		
		module.exports = listCacheHas;
	
	
	/***/ },
	/* 42 */
	/***/ function(module, exports, __webpack_require__) {
	
		var assocIndexOf = __webpack_require__(38);
		
		/**
		 * Sets the list cache `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf ListCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the list cache instance.
		 */
		function listCacheSet(key, value) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
		
		  if (index < 0) {
		    data.push([key, value]);
		  } else {
		    data[index][1] = value;
		  }
		  return this;
		}
		
		module.exports = listCacheSet;
	
	
	/***/ },
	/* 43 */
	/***/ function(module, exports, __webpack_require__) {
	
		var ListCache = __webpack_require__(35);
		
		/**
		 * Removes all key-value entries from the stack.
		 *
		 * @private
		 * @name clear
		 * @memberOf Stack
		 */
		function stackClear() {
		  this.__data__ = new ListCache;
		}
		
		module.exports = stackClear;
	
	
	/***/ },
	/* 44 */
	/***/ function(module, exports) {
	
		/**
		 * Removes `key` and its value from the stack.
		 *
		 * @private
		 * @name delete
		 * @memberOf Stack
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function stackDelete(key) {
		  return this.__data__['delete'](key);
		}
		
		module.exports = stackDelete;
	
	
	/***/ },
	/* 45 */
	/***/ function(module, exports) {
	
		/**
		 * Gets the stack value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Stack
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function stackGet(key) {
		  return this.__data__.get(key);
		}
		
		module.exports = stackGet;
	
	
	/***/ },
	/* 46 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if a stack value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Stack
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function stackHas(key) {
		  return this.__data__.has(key);
		}
		
		module.exports = stackHas;
	
	
	/***/ },
	/* 47 */
	/***/ function(module, exports, __webpack_require__) {
	
		var ListCache = __webpack_require__(35),
		    Map = __webpack_require__(48),
		    MapCache = __webpack_require__(58);
		
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;
		
		/**
		 * Sets the stack `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Stack
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the stack cache instance.
		 */
		function stackSet(key, value) {
		  var cache = this.__data__;
		  if (cache instanceof ListCache) {
		    var pairs = cache.__data__;
		    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
		      pairs.push([key, value]);
		      return this;
		    }
		    cache = this.__data__ = new MapCache(pairs);
		  }
		  cache.set(key, value);
		  return this;
		}
		
		module.exports = stackSet;
	
	
	/***/ },
	/* 48 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(49),
		    root = __webpack_require__(54);
		
		/* Built-in method references that are verified to be native. */
		var Map = getNative(root, 'Map');
		
		module.exports = Map;
	
	
	/***/ },
	/* 49 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseIsNative = __webpack_require__(50),
		    getValue = __webpack_require__(57);
		
		/**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */
		function getNative(object, key) {
		  var value = getValue(object, key);
		  return baseIsNative(value) ? value : undefined;
		}
		
		module.exports = getNative;
	
	
	/***/ },
	/* 50 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isFunction = __webpack_require__(24),
		    isHostObject = __webpack_require__(51),
		    isMasked = __webpack_require__(52),
		    isObject = __webpack_require__(8),
		    toSource = __webpack_require__(56);
		
		/**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
		 */
		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
		
		/** Used to detect host constructors (Safari). */
		var reIsHostCtor = /^\[object .+?Constructor\]$/;
		
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
		
		/** Used to resolve the decompiled source of functions. */
		var funcToString = Function.prototype.toString;
		
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
		
		/** Used to detect if a method is native. */
		var reIsNative = RegExp('^' +
		  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
		  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
		);
		
		/**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */
		function baseIsNative(value) {
		  if (!isObject(value) || isMasked(value)) {
		    return false;
		  }
		  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
		  return pattern.test(toSource(value));
		}
		
		module.exports = baseIsNative;
	
	
	/***/ },
	/* 51 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is a host object in IE < 9.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
		 */
		function isHostObject(value) {
		  // Many host objects are `Object` objects that can coerce to strings
		  // despite having improperly defined `toString` methods.
		  var result = false;
		  if (value != null && typeof value.toString != 'function') {
		    try {
		      result = !!(value + '');
		    } catch (e) {}
		  }
		  return result;
		}
		
		module.exports = isHostObject;
	
	
	/***/ },
	/* 52 */
	/***/ function(module, exports, __webpack_require__) {
	
		var coreJsData = __webpack_require__(53);
		
		/** Used to detect methods masquerading as native. */
		var maskSrcKey = (function() {
		  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
		  return uid ? ('Symbol(src)_1.' + uid) : '';
		}());
		
		/**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */
		function isMasked(func) {
		  return !!maskSrcKey && (maskSrcKey in func);
		}
		
		module.exports = isMasked;
	
	
	/***/ },
	/* 53 */
	/***/ function(module, exports, __webpack_require__) {
	
		var root = __webpack_require__(54);
		
		/** Used to detect overreaching core-js shims. */
		var coreJsData = root['__core-js_shared__'];
		
		module.exports = coreJsData;
	
	
	/***/ },
	/* 54 */
	/***/ function(module, exports, __webpack_require__) {
	
		var freeGlobal = __webpack_require__(55);
		
		/** Detect free variable `self`. */
		var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
		
		/** Used as a reference to the global object. */
		var root = freeGlobal || freeSelf || Function('return this')();
		
		module.exports = root;
	
	
	/***/ },
	/* 55 */
	/***/ function(module, exports) {
	
		/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
		var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
		
		module.exports = freeGlobal;
		
		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))
	
	/***/ },
	/* 56 */
	/***/ function(module, exports) {
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = Function.prototype.toString;
		
		/**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to process.
		 * @returns {string} Returns the source code.
		 */
		function toSource(func) {
		  if (func != null) {
		    try {
		      return funcToString.call(func);
		    } catch (e) {}
		    try {
		      return (func + '');
		    } catch (e) {}
		  }
		  return '';
		}
		
		module.exports = toSource;
	
	
	/***/ },
	/* 57 */
	/***/ function(module, exports) {
	
		/**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */
		function getValue(object, key) {
		  return object == null ? undefined : object[key];
		}
		
		module.exports = getValue;
	
	
	/***/ },
	/* 58 */
	/***/ function(module, exports, __webpack_require__) {
	
		var mapCacheClear = __webpack_require__(59),
		    mapCacheDelete = __webpack_require__(67),
		    mapCacheGet = __webpack_require__(70),
		    mapCacheHas = __webpack_require__(71),
		    mapCacheSet = __webpack_require__(72);
		
		/**
		 * Creates a map cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function MapCache(entries) {
		  var index = -1,
		      length = entries ? entries.length : 0;
		
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
		
		// Add methods to `MapCache`.
		MapCache.prototype.clear = mapCacheClear;
		MapCache.prototype['delete'] = mapCacheDelete;
		MapCache.prototype.get = mapCacheGet;
		MapCache.prototype.has = mapCacheHas;
		MapCache.prototype.set = mapCacheSet;
		
		module.exports = MapCache;
	
	
	/***/ },
	/* 59 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Hash = __webpack_require__(60),
		    ListCache = __webpack_require__(35),
		    Map = __webpack_require__(48);
		
		/**
		 * Removes all key-value entries from the map.
		 *
		 * @private
		 * @name clear
		 * @memberOf MapCache
		 */
		function mapCacheClear() {
		  this.__data__ = {
		    'hash': new Hash,
		    'map': new (Map || ListCache),
		    'string': new Hash
		  };
		}
		
		module.exports = mapCacheClear;
	
	
	/***/ },
	/* 60 */
	/***/ function(module, exports, __webpack_require__) {
	
		var hashClear = __webpack_require__(61),
		    hashDelete = __webpack_require__(63),
		    hashGet = __webpack_require__(64),
		    hashHas = __webpack_require__(65),
		    hashSet = __webpack_require__(66);
		
		/**
		 * Creates a hash object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Hash(entries) {
		  var index = -1,
		      length = entries ? entries.length : 0;
		
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
		
		// Add methods to `Hash`.
		Hash.prototype.clear = hashClear;
		Hash.prototype['delete'] = hashDelete;
		Hash.prototype.get = hashGet;
		Hash.prototype.has = hashHas;
		Hash.prototype.set = hashSet;
		
		module.exports = Hash;
	
	
	/***/ },
	/* 61 */
	/***/ function(module, exports, __webpack_require__) {
	
		var nativeCreate = __webpack_require__(62);
		
		/**
		 * Removes all key-value entries from the hash.
		 *
		 * @private
		 * @name clear
		 * @memberOf Hash
		 */
		function hashClear() {
		  this.__data__ = nativeCreate ? nativeCreate(null) : {};
		}
		
		module.exports = hashClear;
	
	
	/***/ },
	/* 62 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(49);
		
		/* Built-in method references that are verified to be native. */
		var nativeCreate = getNative(Object, 'create');
		
		module.exports = nativeCreate;
	
	
	/***/ },
	/* 63 */
	/***/ function(module, exports) {
	
		/**
		 * Removes `key` and its value from the hash.
		 *
		 * @private
		 * @name delete
		 * @memberOf Hash
		 * @param {Object} hash The hash to modify.
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function hashDelete(key) {
		  return this.has(key) && delete this.__data__[key];
		}
		
		module.exports = hashDelete;
	
	
	/***/ },
	/* 64 */
	/***/ function(module, exports, __webpack_require__) {
	
		var nativeCreate = __webpack_require__(62);
		
		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';
		
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
		
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
		
		/**
		 * Gets the hash value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Hash
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function hashGet(key) {
		  var data = this.__data__;
		  if (nativeCreate) {
		    var result = data[key];
		    return result === HASH_UNDEFINED ? undefined : result;
		  }
		  return hasOwnProperty.call(data, key) ? data[key] : undefined;
		}
		
		module.exports = hashGet;
	
	
	/***/ },
	/* 65 */
	/***/ function(module, exports, __webpack_require__) {
	
		var nativeCreate = __webpack_require__(62);
		
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
		
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
		
		/**
		 * Checks if a hash value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Hash
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function hashHas(key) {
		  var data = this.__data__;
		  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
		}
		
		module.exports = hashHas;
	
	
	/***/ },
	/* 66 */
	/***/ function(module, exports, __webpack_require__) {
	
		var nativeCreate = __webpack_require__(62);
		
		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';
		
		/**
		 * Sets the hash `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Hash
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the hash instance.
		 */
		function hashSet(key, value) {
		  var data = this.__data__;
		  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
		  return this;
		}
		
		module.exports = hashSet;
	
	
	/***/ },
	/* 67 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getMapData = __webpack_require__(68);
		
		/**
		 * Removes `key` and its value from the map.
		 *
		 * @private
		 * @name delete
		 * @memberOf MapCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function mapCacheDelete(key) {
		  return getMapData(this, key)['delete'](key);
		}
		
		module.exports = mapCacheDelete;
	
	
	/***/ },
	/* 68 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isKeyable = __webpack_require__(69);
		
		/**
		 * Gets the data for `map`.
		 *
		 * @private
		 * @param {Object} map The map to query.
		 * @param {string} key The reference key.
		 * @returns {*} Returns the map data.
		 */
		function getMapData(map, key) {
		  var data = map.__data__;
		  return isKeyable(key)
		    ? data[typeof key == 'string' ? 'string' : 'hash']
		    : data.map;
		}
		
		module.exports = getMapData;
	
	
	/***/ },
	/* 69 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is suitable for use as unique object key.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
		 */
		function isKeyable(value) {
		  var type = typeof value;
		  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
		    ? (value !== '__proto__')
		    : (value === null);
		}
		
		module.exports = isKeyable;
	
	
	/***/ },
	/* 70 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getMapData = __webpack_require__(68);
		
		/**
		 * Gets the map value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf MapCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function mapCacheGet(key) {
		  return getMapData(this, key).get(key);
		}
		
		module.exports = mapCacheGet;
	
	
	/***/ },
	/* 71 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getMapData = __webpack_require__(68);
		
		/**
		 * Checks if a map value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf MapCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function mapCacheHas(key) {
		  return getMapData(this, key).has(key);
		}
		
		module.exports = mapCacheHas;
	
	
	/***/ },
	/* 72 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getMapData = __webpack_require__(68);
		
		/**
		 * Sets the map `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf MapCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the map cache instance.
		 */
		function mapCacheSet(key, value) {
		  getMapData(this, key).set(key, value);
		  return this;
		}
		
		module.exports = mapCacheSet;
	
	
	/***/ },
	/* 73 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseIsEqualDeep = __webpack_require__(74),
		    isObject = __webpack_require__(8),
		    isObjectLike = __webpack_require__(26);
		
		/**
		 * The base implementation of `_.isEqual` which supports partial comparisons
		 * and tracks traversed objects.
		 *
		 * @private
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @param {boolean} [bitmask] The bitmask of comparison flags.
		 *  The bitmask may be composed of the following flags:
		 *     1 - Unordered comparison
		 *     2 - Partial comparison
		 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 */
		function baseIsEqual(value, other, customizer, bitmask, stack) {
		  if (value === other) {
		    return true;
		  }
		  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
		    return value !== value && other !== other;
		  }
		  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
		}
		
		module.exports = baseIsEqual;
	
	
	/***/ },
	/* 74 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Stack = __webpack_require__(34),
		    equalArrays = __webpack_require__(75),
		    equalByTag = __webpack_require__(80),
		    equalObjects = __webpack_require__(85),
		    getTag = __webpack_require__(86),
		    isArray = __webpack_require__(27),
		    isHostObject = __webpack_require__(51),
		    isTypedArray = __webpack_require__(92);
		
		/** Used to compose bitmasks for comparison styles. */
		var PARTIAL_COMPARE_FLAG = 2;
		
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    objectTag = '[object Object]';
		
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
		
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
		
		/**
		 * A specialized version of `baseIsEqual` for arrays and objects which performs
		 * deep comparisons and tracks traversed objects enabling objects with circular
		 * references to be compared.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
		 *  for more details.
		 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
		  var objIsArr = isArray(object),
		      othIsArr = isArray(other),
		      objTag = arrayTag,
		      othTag = arrayTag;
		
		  if (!objIsArr) {
		    objTag = getTag(object);
		    objTag = objTag == argsTag ? objectTag : objTag;
		  }
		  if (!othIsArr) {
		    othTag = getTag(other);
		    othTag = othTag == argsTag ? objectTag : othTag;
		  }
		  var objIsObj = objTag == objectTag && !isHostObject(object),
		      othIsObj = othTag == objectTag && !isHostObject(other),
		      isSameTag = objTag == othTag;
		
		  if (isSameTag && !objIsObj) {
		    stack || (stack = new Stack);
		    return (objIsArr || isTypedArray(object))
		      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
		      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
		  }
		  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
		    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
		        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
		
		    if (objIsWrapped || othIsWrapped) {
		      var objUnwrapped = objIsWrapped ? object.value() : object,
		          othUnwrapped = othIsWrapped ? other.value() : other;
		
		      stack || (stack = new Stack);
		      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
		    }
		  }
		  if (!isSameTag) {
		    return false;
		  }
		  stack || (stack = new Stack);
		  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
		}
		
		module.exports = baseIsEqualDeep;
	
	
	/***/ },
	/* 75 */
	/***/ function(module, exports, __webpack_require__) {
	
		var SetCache = __webpack_require__(76),
		    arraySome = __webpack_require__(79);
		
		/** Used to compose bitmasks for comparison styles. */
		var UNORDERED_COMPARE_FLAG = 1,
		    PARTIAL_COMPARE_FLAG = 2;
		
		/**
		 * A specialized version of `baseIsEqualDeep` for arrays with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Array} array The array to compare.
		 * @param {Array} other The other array to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
		 *  for more details.
		 * @param {Object} stack Tracks traversed `array` and `other` objects.
		 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
		 */
		function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
		  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
		      arrLength = array.length,
		      othLength = other.length;
		
		  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
		    return false;
		  }
		  // Assume cyclic values are equal.
		  var stacked = stack.get(array);
		  if (stacked && stack.get(other)) {
		    return stacked == other;
		  }
		  var index = -1,
		      result = true,
		      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
		
		  stack.set(array, other);
		  stack.set(other, array);
		
		  // Ignore non-index properties.
		  while (++index < arrLength) {
		    var arrValue = array[index],
		        othValue = other[index];
		
		    if (customizer) {
		      var compared = isPartial
		        ? customizer(othValue, arrValue, index, other, array, stack)
		        : customizer(arrValue, othValue, index, array, other, stack);
		    }
		    if (compared !== undefined) {
		      if (compared) {
		        continue;
		      }
		      result = false;
		      break;
		    }
		    // Recursively compare arrays (susceptible to call stack limits).
		    if (seen) {
		      if (!arraySome(other, function(othValue, othIndex) {
		            if (!seen.has(othIndex) &&
		                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
		              return seen.add(othIndex);
		            }
		          })) {
		        result = false;
		        break;
		      }
		    } else if (!(
		          arrValue === othValue ||
		            equalFunc(arrValue, othValue, customizer, bitmask, stack)
		        )) {
		      result = false;
		      break;
		    }
		  }
		  stack['delete'](array);
		  stack['delete'](other);
		  return result;
		}
		
		module.exports = equalArrays;
	
	
	/***/ },
	/* 76 */
	/***/ function(module, exports, __webpack_require__) {
	
		var MapCache = __webpack_require__(58),
		    setCacheAdd = __webpack_require__(77),
		    setCacheHas = __webpack_require__(78);
		
		/**
		 *
		 * Creates an array cache object to store unique values.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [values] The values to cache.
		 */
		function SetCache(values) {
		  var index = -1,
		      length = values ? values.length : 0;
		
		  this.__data__ = new MapCache;
		  while (++index < length) {
		    this.add(values[index]);
		  }
		}
		
		// Add methods to `SetCache`.
		SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
		SetCache.prototype.has = setCacheHas;
		
		module.exports = SetCache;
	
	
	/***/ },
	/* 77 */
	/***/ function(module, exports) {
	
		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';
		
		/**
		 * Adds `value` to the array cache.
		 *
		 * @private
		 * @name add
		 * @memberOf SetCache
		 * @alias push
		 * @param {*} value The value to cache.
		 * @returns {Object} Returns the cache instance.
		 */
		function setCacheAdd(value) {
		  this.__data__.set(value, HASH_UNDEFINED);
		  return this;
		}
		
		module.exports = setCacheAdd;
	
	
	/***/ },
	/* 78 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is in the array cache.
		 *
		 * @private
		 * @name has
		 * @memberOf SetCache
		 * @param {*} value The value to search for.
		 * @returns {number} Returns `true` if `value` is found, else `false`.
		 */
		function setCacheHas(value) {
		  return this.__data__.has(value);
		}
		
		module.exports = setCacheHas;
	
	
	/***/ },
	/* 79 */
	/***/ function(module, exports) {
	
		/**
		 * A specialized version of `_.some` for arrays without support for iteratee
		 * shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {boolean} Returns `true` if any element passes the predicate check,
		 *  else `false`.
		 */
		function arraySome(array, predicate) {
		  var index = -1,
		      length = array ? array.length : 0;
		
		  while (++index < length) {
		    if (predicate(array[index], index, array)) {
		      return true;
		    }
		  }
		  return false;
		}
		
		module.exports = arraySome;
	
	
	/***/ },
	/* 80 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Symbol = __webpack_require__(81),
		    Uint8Array = __webpack_require__(82),
		    eq = __webpack_require__(39),
		    equalArrays = __webpack_require__(75),
		    mapToArray = __webpack_require__(83),
		    setToArray = __webpack_require__(84);
		
		/** Used to compose bitmasks for comparison styles. */
		var UNORDERED_COMPARE_FLAG = 1,
		    PARTIAL_COMPARE_FLAG = 2;
		
		/** `Object#toString` result references. */
		var boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    symbolTag = '[object Symbol]';
		
		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]';
		
		/** Used to convert symbols to primitives and strings. */
		var symbolProto = Symbol ? Symbol.prototype : undefined,
		    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
		
		/**
		 * A specialized version of `baseIsEqualDeep` for comparing objects of
		 * the same `toStringTag`.
		 *
		 * **Note:** This function only supports comparing values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {string} tag The `toStringTag` of the objects to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
		 *  for more details.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
		  switch (tag) {
		    case dataViewTag:
		      if ((object.byteLength != other.byteLength) ||
		          (object.byteOffset != other.byteOffset)) {
		        return false;
		      }
		      object = object.buffer;
		      other = other.buffer;
		
		    case arrayBufferTag:
		      if ((object.byteLength != other.byteLength) ||
		          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
		        return false;
		      }
		      return true;
		
		    case boolTag:
		    case dateTag:
		    case numberTag:
		      // Coerce booleans to `1` or `0` and dates to milliseconds.
		      // Invalid dates are coerced to `NaN`.
		      return eq(+object, +other);
		
		    case errorTag:
		      return object.name == other.name && object.message == other.message;
		
		    case regexpTag:
		    case stringTag:
		      // Coerce regexes to strings and treat strings, primitives and objects,
		      // as equal. See http://www.ecma-international.org/ecma-262/6.0/#sec-regexp.prototype.tostring
		      // for more details.
		      return object == (other + '');
		
		    case mapTag:
		      var convert = mapToArray;
		
		    case setTag:
		      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
		      convert || (convert = setToArray);
		
		      if (object.size != other.size && !isPartial) {
		        return false;
		      }
		      // Assume cyclic values are equal.
		      var stacked = stack.get(object);
		      if (stacked) {
		        return stacked == other;
		      }
		      bitmask |= UNORDERED_COMPARE_FLAG;
		
		      // Recursively compare objects (susceptible to call stack limits).
		      stack.set(object, other);
		      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
		      stack['delete'](object);
		      return result;
		
		    case symbolTag:
		      if (symbolValueOf) {
		        return symbolValueOf.call(object) == symbolValueOf.call(other);
		      }
		  }
		  return false;
		}
		
		module.exports = equalByTag;
	
	
	/***/ },
	/* 81 */
	/***/ function(module, exports, __webpack_require__) {
	
		var root = __webpack_require__(54);
		
		/** Built-in value references. */
		var Symbol = root.Symbol;
		
		module.exports = Symbol;
	
	
	/***/ },
	/* 82 */
	/***/ function(module, exports, __webpack_require__) {
	
		var root = __webpack_require__(54);
		
		/** Built-in value references. */
		var Uint8Array = root.Uint8Array;
		
		module.exports = Uint8Array;
	
	
	/***/ },
	/* 83 */
	/***/ function(module, exports) {
	
		/**
		 * Converts `map` to its key-value pairs.
		 *
		 * @private
		 * @param {Object} map The map to convert.
		 * @returns {Array} Returns the key-value pairs.
		 */
		function mapToArray(map) {
		  var index = -1,
		      result = Array(map.size);
		
		  map.forEach(function(value, key) {
		    result[++index] = [key, value];
		  });
		  return result;
		}
		
		module.exports = mapToArray;
	
	
	/***/ },
	/* 84 */
	/***/ function(module, exports) {
	
		/**
		 * Converts `set` to an array of its values.
		 *
		 * @private
		 * @param {Object} set The set to convert.
		 * @returns {Array} Returns the values.
		 */
		function setToArray(set) {
		  var index = -1,
		      result = Array(set.size);
		
		  set.forEach(function(value) {
		    result[++index] = value;
		  });
		  return result;
		}
		
		module.exports = setToArray;
	
	
	/***/ },
	/* 85 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseHas = __webpack_require__(13),
		    keys = __webpack_require__(12);
		
		/** Used to compose bitmasks for comparison styles. */
		var PARTIAL_COMPARE_FLAG = 2;
		
		/**
		 * A specialized version of `baseIsEqualDeep` for objects with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
		 *  for more details.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
		  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
		      objProps = keys(object),
		      objLength = objProps.length,
		      othProps = keys(other),
		      othLength = othProps.length;
		
		  if (objLength != othLength && !isPartial) {
		    return false;
		  }
		  var index = objLength;
		  while (index--) {
		    var key = objProps[index];
		    if (!(isPartial ? key in other : baseHas(other, key))) {
		      return false;
		    }
		  }
		  // Assume cyclic values are equal.
		  var stacked = stack.get(object);
		  if (stacked && stack.get(other)) {
		    return stacked == other;
		  }
		  var result = true;
		  stack.set(object, other);
		  stack.set(other, object);
		
		  var skipCtor = isPartial;
		  while (++index < objLength) {
		    key = objProps[index];
		    var objValue = object[key],
		        othValue = other[key];
		
		    if (customizer) {
		      var compared = isPartial
		        ? customizer(othValue, objValue, key, other, object, stack)
		        : customizer(objValue, othValue, key, object, other, stack);
		    }
		    // Recursively compare objects (susceptible to call stack limits).
		    if (!(compared === undefined
		          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
		          : compared
		        )) {
		      result = false;
		      break;
		    }
		    skipCtor || (skipCtor = key == 'constructor');
		  }
		  if (result && !skipCtor) {
		    var objCtor = object.constructor,
		        othCtor = other.constructor;
		
		    // Non `Object` object instances with different constructors are not equal.
		    if (objCtor != othCtor &&
		        ('constructor' in object && 'constructor' in other) &&
		        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
		          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
		      result = false;
		    }
		  }
		  stack['delete'](object);
		  stack['delete'](other);
		  return result;
		}
		
		module.exports = equalObjects;
	
	
	/***/ },
	/* 86 */
	/***/ function(module, exports, __webpack_require__) {
	
		var DataView = __webpack_require__(87),
		    Map = __webpack_require__(48),
		    Promise = __webpack_require__(88),
		    Set = __webpack_require__(89),
		    WeakMap = __webpack_require__(90),
		    baseGetTag = __webpack_require__(91),
		    toSource = __webpack_require__(56);
		
		/** `Object#toString` result references. */
		var mapTag = '[object Map]',
		    objectTag = '[object Object]',
		    promiseTag = '[object Promise]',
		    setTag = '[object Set]',
		    weakMapTag = '[object WeakMap]';
		
		var dataViewTag = '[object DataView]';
		
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
		
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
		
		/** Used to detect maps, sets, and weakmaps. */
		var dataViewCtorString = toSource(DataView),
		    mapCtorString = toSource(Map),
		    promiseCtorString = toSource(Promise),
		    setCtorString = toSource(Set),
		    weakMapCtorString = toSource(WeakMap);
		
		/**
		 * Gets the `toStringTag` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		var getTag = baseGetTag;
		
		// Fallback for data views, maps, sets, and weak maps in IE 11,
		// for data views in Edge, and promises in Node.js.
		if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
		    (Map && getTag(new Map) != mapTag) ||
		    (Promise && getTag(Promise.resolve()) != promiseTag) ||
		    (Set && getTag(new Set) != setTag) ||
		    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
		  getTag = function(value) {
		    var result = objectToString.call(value),
		        Ctor = result == objectTag ? value.constructor : undefined,
		        ctorString = Ctor ? toSource(Ctor) : undefined;
		
		    if (ctorString) {
		      switch (ctorString) {
		        case dataViewCtorString: return dataViewTag;
		        case mapCtorString: return mapTag;
		        case promiseCtorString: return promiseTag;
		        case setCtorString: return setTag;
		        case weakMapCtorString: return weakMapTag;
		      }
		    }
		    return result;
		  };
		}
		
		module.exports = getTag;
	
	
	/***/ },
	/* 87 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(49),
		    root = __webpack_require__(54);
		
		/* Built-in method references that are verified to be native. */
		var DataView = getNative(root, 'DataView');
		
		module.exports = DataView;
	
	
	/***/ },
	/* 88 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(49),
		    root = __webpack_require__(54);
		
		/* Built-in method references that are verified to be native. */
		var Promise = getNative(root, 'Promise');
		
		module.exports = Promise;
	
	
	/***/ },
	/* 89 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(49),
		    root = __webpack_require__(54);
		
		/* Built-in method references that are verified to be native. */
		var Set = getNative(root, 'Set');
		
		module.exports = Set;
	
	
	/***/ },
	/* 90 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(49),
		    root = __webpack_require__(54);
		
		/* Built-in method references that are verified to be native. */
		var WeakMap = getNative(root, 'WeakMap');
		
		module.exports = WeakMap;
	
	
	/***/ },
	/* 91 */
	/***/ function(module, exports) {
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
		
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
		
		/**
		 * The base implementation of `getTag`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		function baseGetTag(value) {
		  return objectToString.call(value);
		}
		
		module.exports = baseGetTag;
	
	
	/***/ },
	/* 92 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseIsTypedArray = __webpack_require__(93),
		    baseUnary = __webpack_require__(94),
		    nodeUtil = __webpack_require__(95);
		
		/* Node.js helper references. */
		var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
		
		/**
		 * Checks if `value` is classified as a typed array.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 * @example
		 *
		 * _.isTypedArray(new Uint8Array);
		 * // => true
		 *
		 * _.isTypedArray([]);
		 * // => false
		 */
		var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
		
		module.exports = isTypedArray;
	
	
	/***/ },
	/* 93 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isLength = __webpack_require__(25),
		    isObjectLike = __webpack_require__(26);
		
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    funcTag = '[object Function]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    objectTag = '[object Object]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    weakMapTag = '[object WeakMap]';
		
		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';
		
		/** Used to identify `toStringTag` values of typed arrays. */
		var typedArrayTags = {};
		typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
		typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
		typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
		typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
		typedArrayTags[uint32Tag] = true;
		typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
		typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
		typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
		typedArrayTags[errorTag] = typedArrayTags[funcTag] =
		typedArrayTags[mapTag] = typedArrayTags[numberTag] =
		typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
		typedArrayTags[setTag] = typedArrayTags[stringTag] =
		typedArrayTags[weakMapTag] = false;
		
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
		
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
		
		/**
		 * The base implementation of `_.isTypedArray` without Node.js optimizations.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 */
		function baseIsTypedArray(value) {
		  return isObjectLike(value) &&
		    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
		}
		
		module.exports = baseIsTypedArray;
	
	
	/***/ },
	/* 94 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.unary` without support for storing metadata.
		 *
		 * @private
		 * @param {Function} func The function to cap arguments for.
		 * @returns {Function} Returns the new capped function.
		 */
		function baseUnary(func) {
		  return function(value) {
		    return func(value);
		  };
		}
		
		module.exports = baseUnary;
	
	
	/***/ },
	/* 95 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(55);
		
		/** Detect free variable `exports`. */
		var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
		
		/** Detect free variable `module`. */
		var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
		
		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;
		
		/** Detect free variable `process` from Node.js. */
		var freeProcess = moduleExports && freeGlobal.process;
		
		/** Used to access faster Node.js helpers. */
		var nodeUtil = (function() {
		  try {
		    return freeProcess && freeProcess.binding('util');
		  } catch (e) {}
		}());
		
		module.exports = nodeUtil;
		
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))
	
	/***/ },
	/* 96 */
	/***/ function(module, exports) {
	
		module.exports = function(module) {
			if(!module.webpackPolyfill) {
				module.deprecate = function() {};
				module.paths = [];
				// module.parent = undefined by default
				module.children = [];
				module.webpackPolyfill = 1;
			}
			return module;
		}
	
	
	/***/ },
	/* 97 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isStrictComparable = __webpack_require__(98),
		    keys = __webpack_require__(12);
		
		/**
		 * Gets the property names, values, and compare flags of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the match data of `object`.
		 */
		function getMatchData(object) {
		  var result = keys(object),
		      length = result.length;
		
		  while (length--) {
		    var key = result[length],
		        value = object[key];
		
		    result[length] = [key, value, isStrictComparable(value)];
		  }
		  return result;
		}
		
		module.exports = getMatchData;
	
	
	/***/ },
	/* 98 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(8);
		
		/**
		 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` if suitable for strict
		 *  equality comparisons, else `false`.
		 */
		function isStrictComparable(value) {
		  return value === value && !isObject(value);
		}
		
		module.exports = isStrictComparable;
	
	
	/***/ },
	/* 99 */
	/***/ function(module, exports) {
	
		/**
		 * A specialized version of `matchesProperty` for source values suitable
		 * for strict equality comparisons, i.e. `===`.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @param {*} srcValue The value to match.
		 * @returns {Function} Returns the new spec function.
		 */
		function matchesStrictComparable(key, srcValue) {
		  return function(object) {
		    if (object == null) {
		      return false;
		    }
		    return object[key] === srcValue &&
		      (srcValue !== undefined || (key in Object(object)));
		  };
		}
		
		module.exports = matchesStrictComparable;
	
	
	/***/ },
	/* 100 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseIsEqual = __webpack_require__(73),
		    get = __webpack_require__(101),
		    hasIn = __webpack_require__(111),
		    isKey = __webpack_require__(109),
		    isStrictComparable = __webpack_require__(98),
		    matchesStrictComparable = __webpack_require__(99),
		    toKey = __webpack_require__(110);
		
		/** Used to compose bitmasks for comparison styles. */
		var UNORDERED_COMPARE_FLAG = 1,
		    PARTIAL_COMPARE_FLAG = 2;
		
		/**
		 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
		 *
		 * @private
		 * @param {string} path The path of the property to get.
		 * @param {*} srcValue The value to match.
		 * @returns {Function} Returns the new spec function.
		 */
		function baseMatchesProperty(path, srcValue) {
		  if (isKey(path) && isStrictComparable(srcValue)) {
		    return matchesStrictComparable(toKey(path), srcValue);
		  }
		  return function(object) {
		    var objValue = get(object, path);
		    return (objValue === undefined && objValue === srcValue)
		      ? hasIn(object, path)
		      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
		  };
		}
		
		module.exports = baseMatchesProperty;
	
	
	/***/ },
	/* 101 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseGet = __webpack_require__(102);
		
		/**
		 * Gets the value at `path` of `object`. If the resolved value is
		 * `undefined`, the `defaultValue` is returned in its place.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.7.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path of the property to get.
		 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
		 * @returns {*} Returns the resolved value.
		 * @example
		 *
		 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
		 *
		 * _.get(object, 'a[0].b.c');
		 * // => 3
		 *
		 * _.get(object, ['a', '0', 'b', 'c']);
		 * // => 3
		 *
		 * _.get(object, 'a.b.c', 'default');
		 * // => 'default'
		 */
		function get(object, path, defaultValue) {
		  var result = object == null ? undefined : baseGet(object, path);
		  return result === undefined ? defaultValue : result;
		}
		
		module.exports = get;
	
	
	/***/ },
	/* 102 */
	/***/ function(module, exports, __webpack_require__) {
	
		var castPath = __webpack_require__(103),
		    isKey = __webpack_require__(109),
		    toKey = __webpack_require__(110);
		
		/**
		 * The base implementation of `_.get` without support for default values.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path of the property to get.
		 * @returns {*} Returns the resolved value.
		 */
		function baseGet(object, path) {
		  path = isKey(path, object) ? [path] : castPath(path);
		
		  var index = 0,
		      length = path.length;
		
		  while (object != null && index < length) {
		    object = object[toKey(path[index++])];
		  }
		  return (index && index == length) ? object : undefined;
		}
		
		module.exports = baseGet;
	
	
	/***/ },
	/* 103 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArray = __webpack_require__(27),
		    stringToPath = __webpack_require__(104);
		
		/**
		 * Casts `value` to a path array if it's not one.
		 *
		 * @private
		 * @param {*} value The value to inspect.
		 * @returns {Array} Returns the cast property path array.
		 */
		function castPath(value) {
		  return isArray(value) ? value : stringToPath(value);
		}
		
		module.exports = castPath;
	
	
	/***/ },
	/* 104 */
	/***/ function(module, exports, __webpack_require__) {
	
		var memoize = __webpack_require__(105),
		    toString = __webpack_require__(106);
		
		/** Used to match property names within property paths. */
		var reLeadingDot = /^\./,
		    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
		
		/** Used to match backslashes in property paths. */
		var reEscapeChar = /\\(\\)?/g;
		
		/**
		 * Converts `string` to a property path array.
		 *
		 * @private
		 * @param {string} string The string to convert.
		 * @returns {Array} Returns the property path array.
		 */
		var stringToPath = memoize(function(string) {
		  string = toString(string);
		
		  var result = [];
		  if (reLeadingDot.test(string)) {
		    result.push('');
		  }
		  string.replace(rePropName, function(match, number, quote, string) {
		    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
		  });
		  return result;
		});
		
		module.exports = stringToPath;
	
	
	/***/ },
	/* 105 */
	/***/ function(module, exports, __webpack_require__) {
	
		var MapCache = __webpack_require__(58);
		
		/** Used as the `TypeError` message for "Functions" methods. */
		var FUNC_ERROR_TEXT = 'Expected a function';
		
		/**
		 * Creates a function that memoizes the result of `func`. If `resolver` is
		 * provided, it determines the cache key for storing the result based on the
		 * arguments provided to the memoized function. By default, the first argument
		 * provided to the memoized function is used as the map cache key. The `func`
		 * is invoked with the `this` binding of the memoized function.
		 *
		 * **Note:** The cache is exposed as the `cache` property on the memoized
		 * function. Its creation may be customized by replacing the `_.memoize.Cache`
		 * constructor with one whose instances implement the
		 * [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
		 * method interface of `delete`, `get`, `has`, and `set`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Function
		 * @param {Function} func The function to have its output memoized.
		 * @param {Function} [resolver] The function to resolve the cache key.
		 * @returns {Function} Returns the new memoized function.
		 * @example
		 *
		 * var object = { 'a': 1, 'b': 2 };
		 * var other = { 'c': 3, 'd': 4 };
		 *
		 * var values = _.memoize(_.values);
		 * values(object);
		 * // => [1, 2]
		 *
		 * values(other);
		 * // => [3, 4]
		 *
		 * object.a = 2;
		 * values(object);
		 * // => [1, 2]
		 *
		 * // Modify the result cache.
		 * values.cache.set(object, ['a', 'b']);
		 * values(object);
		 * // => ['a', 'b']
		 *
		 * // Replace `_.memoize.Cache`.
		 * _.memoize.Cache = WeakMap;
		 */
		function memoize(func, resolver) {
		  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
		    throw new TypeError(FUNC_ERROR_TEXT);
		  }
		  var memoized = function() {
		    var args = arguments,
		        key = resolver ? resolver.apply(this, args) : args[0],
		        cache = memoized.cache;
		
		    if (cache.has(key)) {
		      return cache.get(key);
		    }
		    var result = func.apply(this, args);
		    memoized.cache = cache.set(key, result);
		    return result;
		  };
		  memoized.cache = new (memoize.Cache || MapCache);
		  return memoized;
		}
		
		// Assign cache to `_.memoize`.
		memoize.Cache = MapCache;
		
		module.exports = memoize;
	
	
	/***/ },
	/* 106 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseToString = __webpack_require__(107);
		
		/**
		 * Converts `value` to a string. An empty string is returned for `null`
		 * and `undefined` values. The sign of `-0` is preserved.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to process.
		 * @returns {string} Returns the string.
		 * @example
		 *
		 * _.toString(null);
		 * // => ''
		 *
		 * _.toString(-0);
		 * // => '-0'
		 *
		 * _.toString([1, 2, 3]);
		 * // => '1,2,3'
		 */
		function toString(value) {
		  return value == null ? '' : baseToString(value);
		}
		
		module.exports = toString;
	
	
	/***/ },
	/* 107 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Symbol = __webpack_require__(81),
		    isSymbol = __webpack_require__(108);
		
		/** Used as references for various `Number` constants. */
		var INFINITY = 1 / 0;
		
		/** Used to convert symbols to primitives and strings. */
		var symbolProto = Symbol ? Symbol.prototype : undefined,
		    symbolToString = symbolProto ? symbolProto.toString : undefined;
		
		/**
		 * The base implementation of `_.toString` which doesn't convert nullish
		 * values to empty strings.
		 *
		 * @private
		 * @param {*} value The value to process.
		 * @returns {string} Returns the string.
		 */
		function baseToString(value) {
		  // Exit early for strings to avoid a performance hit in some environments.
		  if (typeof value == 'string') {
		    return value;
		  }
		  if (isSymbol(value)) {
		    return symbolToString ? symbolToString.call(value) : '';
		  }
		  var result = (value + '');
		  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
		}
		
		module.exports = baseToString;
	
	
	/***/ },
	/* 108 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObjectLike = __webpack_require__(26);
		
		/** `Object#toString` result references. */
		var symbolTag = '[object Symbol]';
		
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
		
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
		
		/**
		 * Checks if `value` is classified as a `Symbol` primitive or object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
		 * @example
		 *
		 * _.isSymbol(Symbol.iterator);
		 * // => true
		 *
		 * _.isSymbol('abc');
		 * // => false
		 */
		function isSymbol(value) {
		  return typeof value == 'symbol' ||
		    (isObjectLike(value) && objectToString.call(value) == symbolTag);
		}
		
		module.exports = isSymbol;
	
	
	/***/ },
	/* 109 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArray = __webpack_require__(27),
		    isSymbol = __webpack_require__(108);
		
		/** Used to match property names within property paths. */
		var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
		    reIsPlainProp = /^\w*$/;
		
		/**
		 * Checks if `value` is a property name and not a property path.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {Object} [object] The object to query keys on.
		 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
		 */
		function isKey(value, object) {
		  if (isArray(value)) {
		    return false;
		  }
		  var type = typeof value;
		  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
		      value == null || isSymbol(value)) {
		    return true;
		  }
		  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
		    (object != null && value in Object(object));
		}
		
		module.exports = isKey;
	
	
	/***/ },
	/* 110 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isSymbol = __webpack_require__(108);
		
		/** Used as references for various `Number` constants. */
		var INFINITY = 1 / 0;
		
		/**
		 * Converts `value` to a string key if it's not a string or symbol.
		 *
		 * @private
		 * @param {*} value The value to inspect.
		 * @returns {string|symbol} Returns the key.
		 */
		function toKey(value) {
		  if (typeof value == 'string' || isSymbol(value)) {
		    return value;
		  }
		  var result = (value + '');
		  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
		}
		
		module.exports = toKey;
	
	
	/***/ },
	/* 111 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseHasIn = __webpack_require__(112),
		    hasPath = __webpack_require__(113);
		
		/**
		 * Checks if `path` is a direct or inherited property of `object`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path to check.
		 * @returns {boolean} Returns `true` if `path` exists, else `false`.
		 * @example
		 *
		 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
		 *
		 * _.hasIn(object, 'a');
		 * // => true
		 *
		 * _.hasIn(object, 'a.b');
		 * // => true
		 *
		 * _.hasIn(object, ['a', 'b']);
		 * // => true
		 *
		 * _.hasIn(object, 'b');
		 * // => false
		 */
		function hasIn(object, path) {
		  return object != null && hasPath(object, path, baseHasIn);
		}
		
		module.exports = hasIn;
	
	
	/***/ },
	/* 112 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.hasIn` without support for deep paths.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {Array|string} key The key to check.
		 * @returns {boolean} Returns `true` if `key` exists, else `false`.
		 */
		function baseHasIn(object, key) {
		  return object != null && key in Object(object);
		}
		
		module.exports = baseHasIn;
	
	
	/***/ },
	/* 113 */
	/***/ function(module, exports, __webpack_require__) {
	
		var castPath = __webpack_require__(103),
		    isArguments = __webpack_require__(19),
		    isArray = __webpack_require__(27),
		    isIndex = __webpack_require__(29),
		    isKey = __webpack_require__(109),
		    isLength = __webpack_require__(25),
		    isString = __webpack_require__(28),
		    toKey = __webpack_require__(110);
		
		/**
		 * Checks if `path` exists on `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path to check.
		 * @param {Function} hasFunc The function to check properties.
		 * @returns {boolean} Returns `true` if `path` exists, else `false`.
		 */
		function hasPath(object, path, hasFunc) {
		  path = isKey(path, object) ? [path] : castPath(path);
		
		  var result,
		      index = -1,
		      length = path.length;
		
		  while (++index < length) {
		    var key = toKey(path[index]);
		    if (!(result = object != null && hasFunc(object, key))) {
		      break;
		    }
		    object = object[key];
		  }
		  if (result) {
		    return result;
		  }
		  var length = object ? object.length : 0;
		  return !!length && isLength(length) && isIndex(key, length) &&
		    (isArray(object) || isString(object) || isArguments(object));
		}
		
		module.exports = hasPath;
	
	
	/***/ },
	/* 114 */
	/***/ function(module, exports) {
	
		/**
		 * This method returns the first argument it receives.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Util
		 * @param {*} value Any value.
		 * @returns {*} Returns `value`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 *
		 * console.log(_.identity(object) === object);
		 * // => true
		 */
		function identity(value) {
		  return value;
		}
		
		module.exports = identity;
	
	
	/***/ },
	/* 115 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseProperty = __webpack_require__(23),
		    basePropertyDeep = __webpack_require__(116),
		    isKey = __webpack_require__(109),
		    toKey = __webpack_require__(110);
		
		/**
		 * Creates a function that returns the value at `path` of a given object.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.4.0
		 * @category Util
		 * @param {Array|string} path The path of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 * @example
		 *
		 * var objects = [
		 *   { 'a': { 'b': 2 } },
		 *   { 'a': { 'b': 1 } }
		 * ];
		 *
		 * _.map(objects, _.property('a.b'));
		 * // => [2, 1]
		 *
		 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
		 * // => [1, 2]
		 */
		function property(path) {
		  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
		}
		
		module.exports = property;
	
	
	/***/ },
	/* 116 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseGet = __webpack_require__(102);
		
		/**
		 * A specialized version of `baseProperty` which supports deep paths.
		 *
		 * @private
		 * @param {Array|string} path The path of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 */
		function basePropertyDeep(path) {
		  return function(object) {
		    return baseGet(object, path);
		  };
		}
		
		module.exports = basePropertyDeep;
	
	
	/***/ },
	/* 117 */
	/***/ function(module, exports, __webpack_require__) {
	
		var arrayReduce = __webpack_require__(118),
		    baseEach = __webpack_require__(119),
		    baseIteratee = __webpack_require__(31),
		    baseReduce = __webpack_require__(121),
		    isArray = __webpack_require__(27);
		
		/**
		 * Reduces `collection` to a value which is the accumulated result of running
		 * each element in `collection` thru `iteratee`, where each successive
		 * invocation is supplied the return value of the previous. If `accumulator`
		 * is not given, the first element of `collection` is used as the initial
		 * value. The iteratee is invoked with four arguments:
		 * (accumulator, value, index|key, collection).
		 *
		 * Many lodash methods are guarded to work as iteratees for methods like
		 * `_.reduce`, `_.reduceRight`, and `_.transform`.
		 *
		 * The guarded methods are:
		 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
		 * and `sortBy`
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Collection
		 * @param {Array|Object} collection The collection to iterate over.
		 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
		 * @param {*} [accumulator] The initial value.
		 * @returns {*} Returns the accumulated value.
		 * @see _.reduceRight
		 * @example
		 *
		 * _.reduce([1, 2], function(sum, n) {
		 *   return sum + n;
		 * }, 0);
		 * // => 3
		 *
		 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
		 *   (result[value] || (result[value] = [])).push(key);
		 *   return result;
		 * }, {});
		 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
		 */
		function reduce(collection, iteratee, accumulator) {
		  var func = isArray(collection) ? arrayReduce : baseReduce,
		      initAccum = arguments.length < 3;
		
		  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
		}
		
		module.exports = reduce;
	
	
	/***/ },
	/* 118 */
	/***/ function(module, exports) {
	
		/**
		 * A specialized version of `_.reduce` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @param {*} [accumulator] The initial value.
		 * @param {boolean} [initAccum] Specify using the first element of `array` as
		 *  the initial value.
		 * @returns {*} Returns the accumulated value.
		 */
		function arrayReduce(array, iteratee, accumulator, initAccum) {
		  var index = -1,
		      length = array ? array.length : 0;
		
		  if (initAccum && length) {
		    accumulator = array[++index];
		  }
		  while (++index < length) {
		    accumulator = iteratee(accumulator, array[index], index, array);
		  }
		  return accumulator;
		}
		
		module.exports = arrayReduce;
	
	
	/***/ },
	/* 119 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseForOwn = __webpack_require__(9),
		    createBaseEach = __webpack_require__(120);
		
		/**
		 * The base implementation of `_.forEach` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Array|Object} collection The collection to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array|Object} Returns `collection`.
		 */
		var baseEach = createBaseEach(baseForOwn);
		
		module.exports = baseEach;
	
	
	/***/ },
	/* 120 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArrayLike = __webpack_require__(21);
		
		/**
		 * Creates a `baseEach` or `baseEachRight` function.
		 *
		 * @private
		 * @param {Function} eachFunc The function to iterate over a collection.
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Function} Returns the new base function.
		 */
		function createBaseEach(eachFunc, fromRight) {
		  return function(collection, iteratee) {
		    if (collection == null) {
		      return collection;
		    }
		    if (!isArrayLike(collection)) {
		      return eachFunc(collection, iteratee);
		    }
		    var length = collection.length,
		        index = fromRight ? length : -1,
		        iterable = Object(collection);
		
		    while ((fromRight ? index-- : ++index < length)) {
		      if (iteratee(iterable[index], index, iterable) === false) {
		        break;
		      }
		    }
		    return collection;
		  };
		}
		
		module.exports = createBaseEach;
	
	
	/***/ },
	/* 121 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.reduce` and `_.reduceRight`, without support
		 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
		 *
		 * @private
		 * @param {Array|Object} collection The collection to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @param {*} accumulator The initial value.
		 * @param {boolean} initAccum Specify using the first or last element of
		 *  `collection` as the initial value.
		 * @param {Function} eachFunc The function to iterate over `collection`.
		 * @returns {*} Returns the accumulated value.
		 */
		function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
		  eachFunc(collection, function(value, index, collection) {
		    accumulator = initAccum
		      ? (initAccum = false, value)
		      : iteratee(accumulator, value, index, collection);
		  });
		  return accumulator;
		}
		
		module.exports = baseReduce;
	
	
	/***/ },
	/* 122 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		exports['default'] = 'redux-responsive/CALCULATE_RESPONSIVE_STATE';
		module.exports = exports['default'];
	
	/***/ },
	/* 123 */
	/***/ function(module, exports, __webpack_require__) {
	
		// local imports
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		    value: true
		});
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		var _addEventHandlers = __webpack_require__(124);
		
		var _addEventHandlers2 = _interopRequireDefault(_addEventHandlers);
		
		/**
		 * Creates a store enhancer based off an (optional) throttle time.
		 * @arg {object} [options={throttleTime,calculateStateInitially}] - Options object.
		 * @arg {number} [options.throttleTime=100] - Throttle time (in miliseconds) for
		 * the window resize event handler.
		 * @arg {boolean} [options.calculateStateInitially=true] - True if the responsive
		 * state must be calculated initially, false otherwise.
		 * @returns {function} - The store enhancer (which adds event listeners to
		 * dispatch actions on window resize).
		 */
		
		exports['default'] = function () {
		    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		
		    var _ref$throttleTime = _ref.throttleTime;
		    var throttleTime = _ref$throttleTime === undefined ? 100 : _ref$throttleTime;
		    var _ref$calculateStateInitially = _ref.calculateStateInitially;
		    var calculateStateInitially = _ref$calculateStateInitially === undefined ? true : _ref$calculateStateInitially;
		    var _ref$performanceMode = _ref.performanceMode;
		    var performanceMode = _ref$performanceMode === undefined ? false : _ref$performanceMode;
		
		    // return store enhancer
		    return function (createStore) {
		        return(
		            // return enhanced version of `createStore`
		            function () {
		                return(
		                    // return store after adding event handlers
		                    (0, _addEventHandlers2['default'])(createStore.apply(undefined, arguments), {
		                        throttleTime: throttleTime,
		                        calculateStateInitially: calculateStateInitially,
		                        performanceMode: performanceMode
		                    })
		                );
		            }
		        );
		    };
		};
		
		module.exports = exports['default'];
	
	/***/ },
	/* 124 */
	/***/ function(module, exports, __webpack_require__) {
	
		// local imports
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		    value: true
		});
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		var _addThrottledHandlers = __webpack_require__(125);
		
		var _addThrottledHandlers2 = _interopRequireDefault(_addThrottledHandlers);
		
		var _addPerformanceModeHandlers = __webpack_require__(132);
		
		var _addPerformanceModeHandlers2 = _interopRequireDefault(_addPerformanceModeHandlers);
		
		/**
		 * Dispatches an action to calculate the responsive state, then kicks of the
		 * (throttled) window resize event listener (which will dispatch further such
		 * actions).
		 * @arg {object} store - The redux store.  Really you only need to pass `{dispatch}`.
		 * @arg {object} options - Options.
		 * @arg {number} options.throttleTime - Throttle time (in miliseconds) for the
		 * window resize event handler.
		 * @arg {boolean} options.calculateStateInitially - True if the responsive state
		 * must be calculated initially, false otherwise.
		 */
		
		exports['default'] = function (store, _ref) {
		    var throttleTime = _ref.throttleTime;
		    var calculateStateInitially = _ref.calculateStateInitially;
		    var performanceMode = _ref.performanceMode;
		
		    // if there is a `window`
		    if (typeof window !== 'undefined') {
		        // if we need to enable performance mode
		        if (performanceMode) {
		            // add the handlers that only fire when the responsive state changes
		            (0, _addPerformanceModeHandlers2['default'])({ store: store, window: window, calculateStateInitially: calculateStateInitially });
		            // otherwise we should just add the throttled handlers
		        } else {
		                // add the throttled (continuously evaluated) handlers
		                (0, _addThrottledHandlers2['default'])({ store: store, window: window, throttleTime: throttleTime, calculateStateInitially: calculateStateInitially });
		            }
		    }
		
		    // return the store so that the call is transparent
		    return store;
		};
		
		module.exports = exports['default'];
	
	/***/ },
	/* 125 */
	/***/ function(module, exports, __webpack_require__) {
	
		// third party imports
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		    value: true
		});
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		var _lodashThrottle = __webpack_require__(126);
		
		var _lodashThrottle2 = _interopRequireDefault(_lodashThrottle);
		
		// local imports
		
		var _actionsCreatorsCalculateResponsiveState = __webpack_require__(130);
		
		var _actionsCreatorsCalculateResponsiveState2 = _interopRequireDefault(_actionsCreatorsCalculateResponsiveState);
		
		// this function adds throttled responsive handlers to the window
		
		exports['default'] = function (_ref) {
		    var store = _ref.store;
		    var window = _ref.window;
		    var throttleTime = _ref.throttleTime;
		    var calculateStateInitially = _ref.calculateStateInitially;
		
		    // throttled event handler for window resize
		    var throttledHandler = (0, _lodashThrottle2['default'])(
		    // just dispatch action to calculate responsive state
		    function () {
		        return store.dispatch((0, _actionsCreatorsCalculateResponsiveState2['default'])(window));
		    }, throttleTime);
		    // initialize the responsive state
		    if (calculateStateInitially) {
		        throttledHandler();
		    }
		    // add the resize event listener
		    window.addEventListener('resize', throttledHandler);
		};
		
		module.exports = exports['default'];
	
	/***/ },
	/* 126 */
	/***/ function(module, exports, __webpack_require__) {
	
		var debounce = __webpack_require__(127),
		    isObject = __webpack_require__(8);
		
		/** Used as the `TypeError` message for "Functions" methods. */
		var FUNC_ERROR_TEXT = 'Expected a function';
		
		/**
		 * Creates a throttled function that only invokes `func` at most once per
		 * every `wait` milliseconds. The throttled function comes with a `cancel`
		 * method to cancel delayed `func` invocations and a `flush` method to
		 * immediately invoke them. Provide `options` to indicate whether `func`
		 * should be invoked on the leading and/or trailing edge of the `wait`
		 * timeout. The `func` is invoked with the last arguments provided to the
		 * throttled function. Subsequent calls to the throttled function return the
		 * result of the last `func` invocation.
		 *
		 * **Note:** If `leading` and `trailing` options are `true`, `func` is
		 * invoked on the trailing edge of the timeout only if the throttled function
		 * is invoked more than once during the `wait` timeout.
		 *
		 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
		 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
		 *
		 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
		 * for details over the differences between `_.throttle` and `_.debounce`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Function
		 * @param {Function} func The function to throttle.
		 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
		 * @param {Object} [options={}] The options object.
		 * @param {boolean} [options.leading=true]
		 *  Specify invoking on the leading edge of the timeout.
		 * @param {boolean} [options.trailing=true]
		 *  Specify invoking on the trailing edge of the timeout.
		 * @returns {Function} Returns the new throttled function.
		 * @example
		 *
		 * // Avoid excessively updating the position while scrolling.
		 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
		 *
		 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
		 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
		 * jQuery(element).on('click', throttled);
		 *
		 * // Cancel the trailing throttled invocation.
		 * jQuery(window).on('popstate', throttled.cancel);
		 */
		function throttle(func, wait, options) {
		  var leading = true,
		      trailing = true;
		
		  if (typeof func != 'function') {
		    throw new TypeError(FUNC_ERROR_TEXT);
		  }
		  if (isObject(options)) {
		    leading = 'leading' in options ? !!options.leading : leading;
		    trailing = 'trailing' in options ? !!options.trailing : trailing;
		  }
		  return debounce(func, wait, {
		    'leading': leading,
		    'maxWait': wait,
		    'trailing': trailing
		  });
		}
		
		module.exports = throttle;
	
	
	/***/ },
	/* 127 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(8),
		    now = __webpack_require__(128),
		    toNumber = __webpack_require__(129);
		
		/** Used as the `TypeError` message for "Functions" methods. */
		var FUNC_ERROR_TEXT = 'Expected a function';
		
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeMax = Math.max,
		    nativeMin = Math.min;
		
		/**
		 * Creates a debounced function that delays invoking `func` until after `wait`
		 * milliseconds have elapsed since the last time the debounced function was
		 * invoked. The debounced function comes with a `cancel` method to cancel
		 * delayed `func` invocations and a `flush` method to immediately invoke them.
		 * Provide `options` to indicate whether `func` should be invoked on the
		 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
		 * with the last arguments provided to the debounced function. Subsequent
		 * calls to the debounced function return the result of the last `func`
		 * invocation.
		 *
		 * **Note:** If `leading` and `trailing` options are `true`, `func` is
		 * invoked on the trailing edge of the timeout only if the debounced function
		 * is invoked more than once during the `wait` timeout.
		 *
		 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
		 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
		 *
		 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
		 * for details over the differences between `_.debounce` and `_.throttle`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Function
		 * @param {Function} func The function to debounce.
		 * @param {number} [wait=0] The number of milliseconds to delay.
		 * @param {Object} [options={}] The options object.
		 * @param {boolean} [options.leading=false]
		 *  Specify invoking on the leading edge of the timeout.
		 * @param {number} [options.maxWait]
		 *  The maximum time `func` is allowed to be delayed before it's invoked.
		 * @param {boolean} [options.trailing=true]
		 *  Specify invoking on the trailing edge of the timeout.
		 * @returns {Function} Returns the new debounced function.
		 * @example
		 *
		 * // Avoid costly calculations while the window size is in flux.
		 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
		 *
		 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
		 * jQuery(element).on('click', _.debounce(sendMail, 300, {
		 *   'leading': true,
		 *   'trailing': false
		 * }));
		 *
		 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
		 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
		 * var source = new EventSource('/stream');
		 * jQuery(source).on('message', debounced);
		 *
		 * // Cancel the trailing debounced invocation.
		 * jQuery(window).on('popstate', debounced.cancel);
		 */
		function debounce(func, wait, options) {
		  var lastArgs,
		      lastThis,
		      maxWait,
		      result,
		      timerId,
		      lastCallTime,
		      lastInvokeTime = 0,
		      leading = false,
		      maxing = false,
		      trailing = true;
		
		  if (typeof func != 'function') {
		    throw new TypeError(FUNC_ERROR_TEXT);
		  }
		  wait = toNumber(wait) || 0;
		  if (isObject(options)) {
		    leading = !!options.leading;
		    maxing = 'maxWait' in options;
		    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
		    trailing = 'trailing' in options ? !!options.trailing : trailing;
		  }
		
		  function invokeFunc(time) {
		    var args = lastArgs,
		        thisArg = lastThis;
		
		    lastArgs = lastThis = undefined;
		    lastInvokeTime = time;
		    result = func.apply(thisArg, args);
		    return result;
		  }
		
		  function leadingEdge(time) {
		    // Reset any `maxWait` timer.
		    lastInvokeTime = time;
		    // Start the timer for the trailing edge.
		    timerId = setTimeout(timerExpired, wait);
		    // Invoke the leading edge.
		    return leading ? invokeFunc(time) : result;
		  }
		
		  function remainingWait(time) {
		    var timeSinceLastCall = time - lastCallTime,
		        timeSinceLastInvoke = time - lastInvokeTime,
		        result = wait - timeSinceLastCall;
		
		    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
		  }
		
		  function shouldInvoke(time) {
		    var timeSinceLastCall = time - lastCallTime,
		        timeSinceLastInvoke = time - lastInvokeTime;
		
		    // Either this is the first call, activity has stopped and we're at the
		    // trailing edge, the system time has gone backwards and we're treating
		    // it as the trailing edge, or we've hit the `maxWait` limit.
		    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
		      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
		  }
		
		  function timerExpired() {
		    var time = now();
		    if (shouldInvoke(time)) {
		      return trailingEdge(time);
		    }
		    // Restart the timer.
		    timerId = setTimeout(timerExpired, remainingWait(time));
		  }
		
		  function trailingEdge(time) {
		    timerId = undefined;
		
		    // Only invoke if we have `lastArgs` which means `func` has been
		    // debounced at least once.
		    if (trailing && lastArgs) {
		      return invokeFunc(time);
		    }
		    lastArgs = lastThis = undefined;
		    return result;
		  }
		
		  function cancel() {
		    if (timerId !== undefined) {
		      clearTimeout(timerId);
		    }
		    lastInvokeTime = 0;
		    lastArgs = lastCallTime = lastThis = timerId = undefined;
		  }
		
		  function flush() {
		    return timerId === undefined ? result : trailingEdge(now());
		  }
		
		  function debounced() {
		    var time = now(),
		        isInvoking = shouldInvoke(time);
		
		    lastArgs = arguments;
		    lastThis = this;
		    lastCallTime = time;
		
		    if (isInvoking) {
		      if (timerId === undefined) {
		        return leadingEdge(lastCallTime);
		      }
		      if (maxing) {
		        // Handle invocations in a tight loop.
		        timerId = setTimeout(timerExpired, wait);
		        return invokeFunc(lastCallTime);
		      }
		    }
		    if (timerId === undefined) {
		      timerId = setTimeout(timerExpired, wait);
		    }
		    return result;
		  }
		  debounced.cancel = cancel;
		  debounced.flush = flush;
		  return debounced;
		}
		
		module.exports = debounce;
	
	
	/***/ },
	/* 128 */
	/***/ function(module, exports) {
	
		/**
		 * Gets the timestamp of the number of milliseconds that have elapsed since
		 * the Unix epoch (1 January 1970 00:00:00 UTC).
		 *
		 * @static
		 * @memberOf _
		 * @since 2.4.0
		 * @category Date
		 * @returns {number} Returns the timestamp.
		 * @example
		 *
		 * _.defer(function(stamp) {
		 *   console.log(_.now() - stamp);
		 * }, _.now());
		 * // => Logs the number of milliseconds it took for the deferred invocation.
		 */
		function now() {
		  return Date.now();
		}
		
		module.exports = now;
	
	
	/***/ },
	/* 129 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isFunction = __webpack_require__(24),
		    isObject = __webpack_require__(8),
		    isSymbol = __webpack_require__(108);
		
		/** Used as references for various `Number` constants. */
		var NAN = 0 / 0;
		
		/** Used to match leading and trailing whitespace. */
		var reTrim = /^\s+|\s+$/g;
		
		/** Used to detect bad signed hexadecimal string values. */
		var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
		
		/** Used to detect binary string values. */
		var reIsBinary = /^0b[01]+$/i;
		
		/** Used to detect octal string values. */
		var reIsOctal = /^0o[0-7]+$/i;
		
		/** Built-in method references without a dependency on `root`. */
		var freeParseInt = parseInt;
		
		/**
		 * Converts `value` to a number.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to process.
		 * @returns {number} Returns the number.
		 * @example
		 *
		 * _.toNumber(3.2);
		 * // => 3.2
		 *
		 * _.toNumber(Number.MIN_VALUE);
		 * // => 5e-324
		 *
		 * _.toNumber(Infinity);
		 * // => Infinity
		 *
		 * _.toNumber('3.2');
		 * // => 3.2
		 */
		function toNumber(value) {
		  if (typeof value == 'number') {
		    return value;
		  }
		  if (isSymbol(value)) {
		    return NAN;
		  }
		  if (isObject(value)) {
		    var other = isFunction(value.valueOf) ? value.valueOf() : value;
		    value = isObject(other) ? (other + '') : other;
		  }
		  if (typeof value != 'string') {
		    return value === 0 ? value : +value;
		  }
		  value = value.replace(reTrim, '');
		  var isBinary = reIsBinary.test(value);
		  return (isBinary || reIsOctal.test(value))
		    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
		    : (reIsBadHex.test(value) ? NAN : +value);
		}
		
		module.exports = toNumber;
	
	
	/***/ },
	/* 130 */
	/***/ function(module, exports, __webpack_require__) {
	
		// action type
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		
		var _types = __webpack_require__(131);
		
		/**
		 * Action creator taking window-like object and returning action to calculate
		 * responsive state.
		 * @arg {object} window - Any window-like object (has keys `innerWidth` and
		 * `matchMedia`).
		 * @arg {number} window.innerWidth - The value for the browser width (to pass to
		 * the responsive state reducer logic).  See browser global `window.innerWidth`.
		 * @arg {function} window.matchMedia - The method with which to match media
		 * queries (to pass to the responsive sate reducer logic).  See global
		 * `window.matchMedia`.
		 * @returns {object} The resulting action.  Action will have type
		 * `CALCULATE_RESPONSIVE_STATE`, and will be directly given the two keys taken
		 * from the `window` argument.
		 */
		
		exports['default'] = function () {
		  var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		
		  var innerWidth = _ref.innerWidth;
		  var innerHeight = _ref.innerHeight;
		  var matchMedia = _ref.matchMedia;
		  return {
		    type: _types.CALCULATE_RESPONSIVE_STATE,
		    innerWidth: innerWidth,
		    innerHeight: innerHeight,
		    matchMedia: matchMedia
		  };
		};
		
		module.exports = exports['default'];
	
	/***/ },
	/* 131 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		var _CALCULATE_RESPONSIVE_STATE2 = __webpack_require__(122);
		
		var _CALCULATE_RESPONSIVE_STATE3 = _interopRequireDefault(_CALCULATE_RESPONSIVE_STATE2);
		
		exports.CALCULATE_RESPONSIVE_STATE = _CALCULATE_RESPONSIVE_STATE3['default'];
	
	/***/ },
	/* 132 */
	/***/ function(module, exports, __webpack_require__) {
	
		// see: https://developer.mozilla.org/en-US/docs/Web/CSS/Media_Queries/Testing_media_queries
		
		// external imports
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		    value: true
		});
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		var _mediaquery = __webpack_require__(3);
		
		var _mediaquery2 = _interopRequireDefault(_mediaquery);
		
		// local imports
		
		var _actionsCreatorsCalculateResponsiveState = __webpack_require__(130);
		
		var _actionsCreatorsCalculateResponsiveState2 = _interopRequireDefault(_actionsCreatorsCalculateResponsiveState);
		
		// this function adds event handlers to the window that only tirgger
		// when the responsive state changes
		
		exports['default'] = function (_ref) {
		    var store = _ref.store;
		    var window = _ref.window;
		    var calculateStateInitially = _ref.calculateStateInitially;
		
		    // the function to call when calculating the new responsive state
		    function refreshResponsiveState() {
		        store.dispatch((0, _actionsCreatorsCalculateResponsiveState2['default'])(window));
		    }
		
		    // grab the current state of the store
		    var storeState = store.getState();
		
		    var responsiveStateKey = undefined;
		    // if the redux state root is an Immutable.js Iterable
		    if (storeState['@@__IMMUTABLE_ITERABLE__@@'] === true) {
		        responsiveStateKey = storeState.findKey(function (stateBranch) {
		            return stateBranch._responsiveState;
		        });
		    } else {
		        // go through every reducer at the root of the project
		        responsiveStateKey = Object.keys(storeState).reduce(function (prev, current) {
		            return(
		                // if the reducer contains the responsive state marker then keep it
		                storeState[current] && storeState[current]._responsiveState ? current : prev
		                // otherwise the value should be at least falsey
		
		            );
		        }, false);
		    }
		
		    // if we couldn't find a responsive reducer at the root of the project
		    if (!responsiveStateKey) {
		        throw new Error('Could not find responsive state reducer - Performance mode can only ' + 'be used if the responsive reducer is at the root of your reducer tree.');
		    }
		
		    // get the object of breakpoints
		    var breakpoints = storeState['@@__IMMUTABLE_ITERABLE__@@'] ? storeState.get(responsiveStateKey).breakpoints : storeState[responsiveStateKey].breakpoints;
		    // get the object of media queries
		    var mediaQueries = _mediaquery2['default'].asObject(breakpoints);
		
		    // for every breakpoint range
		    Object.keys(mediaQueries).forEach(function (breakpoint) {
		        // create a media query list for the breakpoint
		        var mediaQueryList = window.matchMedia(mediaQueries[breakpoint]);
		
		        /* eslint-disable no-loop-func */
		
		        // whenever any of the media query lists status changes
		        mediaQueryList.addListener(function (query) {
		            // if a new query was matched
		            if (query.matches) {
		                // recaulate the state
		                refreshResponsiveState();
		            }
		        });
		    });
		
		    // if we are supposed to calculate the initial state
		    if (calculateStateInitially) {
		        // then do so
		        refreshResponsiveState();
		    }
		};
		
		module.exports = exports['default'];
	
	/***/ },
	/* 133 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		var _calculateResponsiveState2 = __webpack_require__(130);
		
		var _calculateResponsiveState3 = _interopRequireDefault(_calculateResponsiveState2);
		
		exports.calculateResponsiveState = _calculateResponsiveState3['default'];
	
	/***/ }
	/******/ ]);

/***/ },
/* 148 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  var rest = funcs.slice(0, -1);
	  return function () {
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(57);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(361);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 150 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 151 */
/***/ function(module, exports) {

	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null !== obj && 'object' === typeof obj;
	}
	
	module.exports = isObject;


/***/ },
/* 152 */
/***/ function(module, exports) {

	
	/**
	 * slice() reference.
	 */
	
	var slice = Array.prototype.slice;
	
	/**
	 * Expose `co`.
	 */
	
	module.exports = co['default'] = co.co = co;
	
	/**
	 * Wrap the given generator `fn` into a
	 * function that returns a promise.
	 * This is a separate function so that
	 * every `co()` call doesn't create a new,
	 * unnecessary closure.
	 *
	 * @param {GeneratorFunction} fn
	 * @return {Function}
	 * @api public
	 */
	
	co.wrap = function (fn) {
	  createPromise.__generatorFunction__ = fn;
	  return createPromise;
	  function createPromise() {
	    return co.call(this, fn.apply(this, arguments));
	  }
	};
	
	/**
	 * Execute the generator function or a generator
	 * and return a promise.
	 *
	 * @param {Function} fn
	 * @return {Promise}
	 * @api public
	 */
	
	function co(gen) {
	  var ctx = this;
	  var args = slice.call(arguments, 1)
	
	  // we wrap everything in a promise to avoid promise chaining,
	  // which leads to memory leak errors.
	  // see https://github.com/tj/co/issues/180
	  return new Promise(function(resolve, reject) {
	    if (typeof gen === 'function') gen = gen.apply(ctx, args);
	    if (!gen || typeof gen.next !== 'function') return resolve(gen);
	
	    onFulfilled();
	
	    /**
	     * @param {Mixed} res
	     * @return {Promise}
	     * @api private
	     */
	
	    function onFulfilled(res) {
	      var ret;
	      try {
	        ret = gen.next(res);
	      } catch (e) {
	        return reject(e);
	      }
	      next(ret);
	    }
	
	    /**
	     * @param {Error} err
	     * @return {Promise}
	     * @api private
	     */
	
	    function onRejected(err) {
	      var ret;
	      try {
	        ret = gen.throw(err);
	      } catch (e) {
	        return reject(e);
	      }
	      next(ret);
	    }
	
	    /**
	     * Get the next value in the generator,
	     * return a promise.
	     *
	     * @param {Object} ret
	     * @return {Promise}
	     * @api private
	     */
	
	    function next(ret) {
	      if (ret.done) return resolve(ret.value);
	      var value = toPromise.call(ctx, ret.value);
	      if (value && isPromise(value)) return value.then(onFulfilled, onRejected);
	      return onRejected(new TypeError('You may only yield a function, promise, generator, array, or object, '
	        + 'but the following object was passed: "' + String(ret.value) + '"'));
	    }
	  });
	}
	
	/**
	 * Convert a `yield`ed value into a promise.
	 *
	 * @param {Mixed} obj
	 * @return {Promise}
	 * @api private
	 */
	
	function toPromise(obj) {
	  if (!obj) return obj;
	  if (isPromise(obj)) return obj;
	  if (isGeneratorFunction(obj) || isGenerator(obj)) return co.call(this, obj);
	  if ('function' == typeof obj) return thunkToPromise.call(this, obj);
	  if (Array.isArray(obj)) return arrayToPromise.call(this, obj);
	  if (isObject(obj)) return objectToPromise.call(this, obj);
	  return obj;
	}
	
	/**
	 * Convert a thunk to a promise.
	 *
	 * @param {Function}
	 * @return {Promise}
	 * @api private
	 */
	
	function thunkToPromise(fn) {
	  var ctx = this;
	  return new Promise(function (resolve, reject) {
	    fn.call(ctx, function (err, res) {
	      if (err) return reject(err);
	      if (arguments.length > 2) res = slice.call(arguments, 1);
	      resolve(res);
	    });
	  });
	}
	
	/**
	 * Convert an array of "yieldables" to a promise.
	 * Uses `Promise.all()` internally.
	 *
	 * @param {Array} obj
	 * @return {Promise}
	 * @api private
	 */
	
	function arrayToPromise(obj) {
	  return Promise.all(obj.map(toPromise, this));
	}
	
	/**
	 * Convert an object of "yieldables" to a promise.
	 * Uses `Promise.all()` internally.
	 *
	 * @param {Object} obj
	 * @return {Promise}
	 * @api private
	 */
	
	function objectToPromise(obj){
	  var results = new obj.constructor();
	  var keys = Object.keys(obj);
	  var promises = [];
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var promise = toPromise.call(this, obj[key]);
	    if (promise && isPromise(promise)) defer(promise, key);
	    else results[key] = obj[key];
	  }
	  return Promise.all(promises).then(function () {
	    return results;
	  });
	
	  function defer(promise, key) {
	    // predefine the key in the result
	    results[key] = undefined;
	    promises.push(promise.then(function (res) {
	      results[key] = res;
	    }));
	  }
	}
	
	/**
	 * Check if `obj` is a promise.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isPromise(obj) {
	  return 'function' == typeof obj.then;
	}
	
	/**
	 * Check if `obj` is a generator.
	 *
	 * @param {Mixed} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isGenerator(obj) {
	  return 'function' == typeof obj.next && 'function' == typeof obj.throw;
	}
	
	/**
	 * Check if `obj` is a generator function.
	 *
	 * @param {Mixed} obj
	 * @return {Boolean}
	 * @api private
	 */
	function isGeneratorFunction(obj) {
	  var constructor = obj.constructor;
	  if (!constructor) return false;
	  if ('GeneratorFunction' === constructor.name || 'GeneratorFunction' === constructor.displayName) return true;
	  return isGenerator(constructor.prototype);
	}
	
	/**
	 * Check for plain object.
	 *
	 * @param {Mixed} val
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(val) {
	  return Object == val.constructor;
	}


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) return rollup != null
	        ? rollup(array) : (sortValues != null
	        ? array.sort(sortValues)
	        : array);
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ Version 1.0.3. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI;
	var tau = 2 * pi;
	var epsilon = 1e-6;
	var tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon)) {}
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      if (da < 0) da = da % tau + tau;
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ Version 1.0.4. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(155)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	var constant$1 = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant$1(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = Math.abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * Math.cos(a0), r1 * Math.sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * Math.cos(a1), r0 * Math.sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : Math.sqrt(r0 * r0 + r1 * r1)),
	          rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * Math.sin(ap)),
	            p1 = asin(rp / r1 * Math.sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * Math.cos(a01),
	          y01 = r1 * Math.sin(a01),
	          x10 = r0 * Math.cos(a10),
	          y10 = r0 * Math.sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * Math.cos(a11),
	            y11 = r1 * Math.sin(a11),
	            x00 = r0 * Math.cos(a00),
	            y00 = r0 * Math.sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi) {
	          var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2),
	              lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [Math.cos(a) * r, Math.sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant$1(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$1(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$1(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant$1(0),
	      y1 = y,
	      defined = constant$1(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant$1(0),
	      endAngle = constant$1(tau),
	      padAngle = constant$1(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function radialLine(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var radialLine$1 = function() {
	  return radialLine(line().curve(curveRadialLinear));
	};
	
	var radialArea = function() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return radialLine(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return radialLine(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return radialLine(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return radialLine(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10);
	var kx = Math.sin(tau / 10) * kr;
	var ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant$1(circle),
	      size = constant$1(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant$1(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant$1(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var slice = Array.prototype.slice;
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (var j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant$1([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$1(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant$1(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending = function(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$1 = function(series) {
	  return ascending(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.radialArea = radialArea;
	exports.radialLine = radialLine$1;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.0.3. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(91)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "S": formatSeconds,
	    "U": formatWeekNumberSunday,
	    "w": formatWeekdayNumber,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "S": formatUTCSeconds,
	    "U": formatUTCWeekNumberSunday,
	    "w": formatUTCWeekdayNumber,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "S": parseSeconds,
	    "U": parseWeekNumberSunday,
	    "w": parseWeekdayNumber,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0);
	      if (i != string.length) return null;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	        var day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekdayNumber(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekdayNumber(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	var locale$1;
	
	
	
	
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale$1 = formatLocale(definition);
	  exports.timeFormat = locale$1.format;
	  exports.timeParse = locale$1.parse;
	  exports.utcFormat = locale$1.utcFormat;
	  exports.utcParse = locale$1.utcParse;
	  return locale$1;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(160);
	var isArguments = __webpack_require__(159);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 159 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 160 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 161 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(161);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(171);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var createArrayFromMixed = __webpack_require__(164);
	var getMarkupWrap = __webpack_require__(166);
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 167 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 168 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(168);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 170 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(170);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 172 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 173 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(24);
	
	var _PathUtils = __webpack_require__(20);
	
	var _ExecutionEnvironment = __webpack_require__(39);
	
	var _DOMUtils = __webpack_require__(52);
	
	var _DOMStateStorage = __webpack_require__(96);
	
	var _createDOMHistory = __webpack_require__(97);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(13);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(24);
	
	var _PathUtils = __webpack_require__(20);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(13);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(20);
	
	var _Actions = __webpack_require__(24);
	
	var _createHistory = __webpack_require__(99);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(103),
	    getRawTag = __webpack_require__(180),
	    objectToString = __webpack_require__(181);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 178 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(182);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(103);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 181 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 182 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(178);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 184 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	// browser.js
	
	exports.encode = __webpack_require__(107).encode;
	exports.decode = __webpack_require__(105).decode;
	
	exports.Encoder = __webpack_require__(193).Encoder;
	exports.Decoder = __webpack_require__(192).Decoder;
	
	exports.createCodec = __webpack_require__(196).createCodec;
	exports.codec = __webpack_require__(191).codec;


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/* globals Buffer */
	
	module.exports =
	  c(("undefined" !== typeof Buffer) && Buffer) ||
	  c(this.Buffer) ||
	  c(("undefined" !== typeof window) && window.Buffer) ||
	  this.Buffer;
	
	function c(B) {
	  return B && B.isBuffer && B;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50).Buffer))

/***/ },
/* 187 */
/***/ function(module, exports) {

	// buffer-lite.js
	
	var MAXBUFLEN = 8192;
	
	exports.copy = copy;
	exports.toString = toString;
	exports.write = write;
	
	/**
	 * Buffer.prototype.write()
	 *
	 * @param string {String}
	 * @param [offset] {Number}
	 * @returns {Number}
	 */
	
	function write(string, offset) {
	  var buffer = this;
	  var index = offset || (offset |= 0);
	  var length = string.length;
	  var chr = 0;
	  var i = 0;
	  while (i < length) {
	    chr = string.charCodeAt(i++);
	
	    if (chr < 128) {
	      buffer[index++] = chr;
	    } else if (chr < 0x800) {
	      // 2 bytes
	      buffer[index++] = 0xC0 | (chr >>> 6);
	      buffer[index++] = 0x80 | (chr & 0x3F);
	    } else if (chr < 0xD800 || chr > 0xDFFF) {
	      // 3 bytes
	      buffer[index++] = 0xE0 | (chr  >>> 12);
	      buffer[index++] = 0x80 | ((chr >>> 6)  & 0x3F);
	      buffer[index++] = 0x80 | (chr          & 0x3F);
	    } else {
	      // 4 bytes - surrogate pair
	      chr = (((chr - 0xD800) << 10) | (string.charCodeAt(i++) - 0xDC00)) + 0x10000;
	      buffer[index++] = 0xF0 | (chr >>> 18);
	      buffer[index++] = 0x80 | ((chr >>> 12) & 0x3F);
	      buffer[index++] = 0x80 | ((chr >>> 6)  & 0x3F);
	      buffer[index++] = 0x80 | (chr          & 0x3F);
	    }
	  }
	  return index - offset;
	}
	
	/**
	 * Buffer.prototype.toString()
	 *
	 * @param [encoding] {String} ignored
	 * @param [start] {Number}
	 * @param [end] {Number}
	 * @returns {String}
	 */
	
	function toString(encoding, start, end) {
	  var buffer = this;
	  var index = start|0;
	  if (!end) end = buffer.length;
	  var string = '';
	  var chr = 0;
	
	  while (index < end) {
	    chr = buffer[index++];
	    if (chr < 128) {
	      string += String.fromCharCode(chr);
	      continue;
	    }
	
	    if ((chr & 0xE0) === 0xC0) {
	      // 2 bytes
	      chr = (chr & 0x1F) << 6 |
	            (buffer[index++] & 0x3F);
	
	    } else if ((chr & 0xF0) === 0xE0) {
	      // 3 bytes
	      chr = (chr & 0x0F)             << 12 |
	            (buffer[index++] & 0x3F) << 6  |
	            (buffer[index++] & 0x3F);
	
	    } else if ((chr & 0xF8) === 0xF0) {
	      // 4 bytes
	      chr = (chr & 0x07)             << 18 |
	            (buffer[index++] & 0x3F) << 12 |
	            (buffer[index++] & 0x3F) << 6  |
	            (buffer[index++] & 0x3F);
	    }
	
	    if (chr >= 0x010000) {
	      // A surrogate pair
	      chr -= 0x010000;
	
	      string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
	    } else {
	      string += String.fromCharCode(chr);
	    }
	  }
	
	  return string;
	}
	
	/**
	 * Buffer.prototype.copy()
	 *
	 * @param target {Buffer}
	 * @param [targetStart] {Number}
	 * @param [start] {Number}
	 * @param [end] {Number}
	 * @returns {number}
	 */
	
	function copy(target, targetStart, start, end) {
	  var i;
	  if (!start) start = 0;
	  if (!end && end !== 0) end = this.length;
	  if (!targetStart) targetStart = 0;
	  var len = end - start;
	
	  if (target === this && start < targetStart && targetStart < end) {
	    // descending
	    for (i = len - 1; i >= 0; i--) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else {
	    // ascending
	    for (i = 0; i < len; i++) {
	      target[i + targetStart] = this[i + start];
	    }
	  }
	
	  return len;
	}


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	// bufferish-array.js
	
	var Bufferish = __webpack_require__(10);
	
	var exports = module.exports = alloc(0);
	
	exports.alloc = alloc;
	exports.concat = Bufferish.concat;
	exports.from = from;
	
	/**
	 * @param size {Number}
	 * @returns {Buffer|Uint8Array|Array}
	 */
	
	function alloc(size) {
	  return new Array(size);
	}
	
	/**
	 * @param value {Array|ArrayBuffer|Buffer|String}
	 * @returns {Array}
	 */
	
	function from(value) {
	  if (!Bufferish.isBuffer(value) && Bufferish.isView(value)) {
	    // TypedArray to Uint8Array
	    value = Bufferish.Uint8Array.from(value);
	  } else if (Bufferish.isArrayBuffer(value)) {
	    // ArrayBuffer to Uint8Array
	    value = new Uint8Array(value);
	  } else if (typeof value === "string") {
	    // String to Array
	    return Bufferish.from.call(exports, value);
	  } else if (typeof value === "number") {
	    throw new TypeError('"value" argument must not be a number');
	  }
	
	  // Array-like to Array
	  return Array.prototype.slice.call(value);
	}


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	// bufferish-buffer.js
	
	var Bufferish = __webpack_require__(10);
	var Buffer = Bufferish.global;
	
	var exports = module.exports = Bufferish.hasBuffer ? alloc(0) : [];
	
	exports.alloc = Bufferish.hasBuffer && Buffer.alloc || alloc;
	exports.concat = Bufferish.concat;
	exports.from = from;
	
	/**
	 * @param size {Number}
	 * @returns {Buffer|Uint8Array|Array}
	 */
	
	function alloc(size) {
	  return new Buffer(size);
	}
	
	/**
	 * @param value {Array|ArrayBuffer|Buffer|String}
	 * @returns {Buffer}
	 */
	
	function from(value) {
	  if (!Bufferish.isBuffer(value) && Bufferish.isView(value)) {
	    // TypedArray to Uint8Array
	    value = Bufferish.Uint8Array.from(value);
	  } else if (Bufferish.isArrayBuffer(value)) {
	    // ArrayBuffer to Uint8Array
	    value = new Uint8Array(value);
	  } else if (typeof value === "string") {
	    // String to Buffer
	    return Bufferish.from.call(exports, value);
	  } else if (typeof value === "number") {
	    throw new TypeError('"value" argument must not be a number');
	  }
	
	  // Array-like to Buffer
	  if (Buffer.from && Buffer.from.length !== 1) {
	    return Buffer.from(value); // node v6+
	  } else {
	    return new Buffer(value); // node v4
	  }
	}


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	// bufferish-uint8array.js
	
	var Bufferish = __webpack_require__(10);
	
	var exports = module.exports = Bufferish.hasArrayBuffer ? alloc(0) : [];
	
	exports.alloc = alloc;
	exports.concat = Bufferish.concat;
	exports.from = from;
	
	/**
	 * @param size {Number}
	 * @returns {Buffer|Uint8Array|Array}
	 */
	
	function alloc(size) {
	  return new Uint8Array(size);
	}
	
	/**
	 * @param value {Array|ArrayBuffer|Buffer|String}
	 * @returns {Uint8Array}
	 */
	
	function from(value) {
	  if (Bufferish.isView(value)) {
	    // TypedArray to ArrayBuffer
	    var byteOffset = value.byteOffset;
	    var byteLength = value.byteLength;
	    value = value.buffer;
	    if (value.byteLength !== byteLength) {
	      if (value.slice) {
	        value = value.slice(byteOffset, byteOffset + byteLength);
	      } else {
	        // Android 4.1 does not have ArrayBuffer.prototype.slice
	        value = new Uint8Array(value);
	        if (value.byteLength !== byteLength) {
	          // TypedArray to ArrayBuffer to Uint8Array to Array
	          value = Array.prototype.slice.call(value, byteOffset, byteOffset + byteLength);
	        }
	      }
	    }
	  } else if (typeof value === "string") {
	    // String to Uint8Array
	    return Bufferish.from.call(exports, value);
	  } else if (typeof value === "number") {
	    throw new TypeError('"value" argument must not be a number');
	  }
	
	  return new Uint8Array(value);
	}


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	// codec.js
	
	// load both interfaces
	__webpack_require__(60);
	__webpack_require__(61);
	
	// @public
	// msgpack.codec.preset
	
	exports.codec = {
	  preset: __webpack_require__(41).preset
	};


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	// decoder.js
	
	exports.Decoder = Decoder;
	
	var EventLite = __webpack_require__(92);
	var DecodeBuffer = __webpack_require__(104).DecodeBuffer;
	
	function Decoder(options) {
	  if (!(this instanceof Decoder)) return new Decoder(options);
	  DecodeBuffer.call(this, options);
	}
	
	Decoder.prototype = new DecodeBuffer();
	
	EventLite.mixin(Decoder.prototype);
	
	Decoder.prototype.decode = function(chunk) {
	  if (arguments.length) this.write(chunk);
	  this.flush();
	};
	
	Decoder.prototype.push = function(chunk) {
	  this.emit("data", chunk);
	};
	
	Decoder.prototype.end = function(chunk) {
	  this.decode(chunk);
	  this.emit("end");
	};


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	// encoder.js
	
	exports.Encoder = Encoder;
	
	var EventLite = __webpack_require__(92);
	var EncodeBuffer = __webpack_require__(106).EncodeBuffer;
	
	function Encoder(options) {
	  if (!(this instanceof Encoder)) return new Encoder(options);
	  EncodeBuffer.call(this, options);
	}
	
	Encoder.prototype = new EncodeBuffer();
	
	EventLite.mixin(Encoder.prototype);
	
	Encoder.prototype.encode = function(chunk) {
	  this.write(chunk);
	  this.emit("data", this.read());
	};
	
	Encoder.prototype.end = function(chunk) {
	  if (arguments.length) this.encode(chunk);
	  this.flush();
	  this.emit("end");
	};


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	// ext-packer.js
	
	exports.setExtPackers = setExtPackers;
	
	var Bufferish = __webpack_require__(10);
	var Buffer = Bufferish.global;
	var packTypedArray = Bufferish.Uint8Array.from;
	var _encode;
	
	var ERROR_COLUMNS = {name: 1, message: 1, stack: 1, columnNumber: 1, fileName: 1, lineNumber: 1};
	
	function setExtPackers(codec) {
	  codec.addExtPacker(0x0E, Error, [packError, encode]);
	  codec.addExtPacker(0x01, EvalError, [packError, encode]);
	  codec.addExtPacker(0x02, RangeError, [packError, encode]);
	  codec.addExtPacker(0x03, ReferenceError, [packError, encode]);
	  codec.addExtPacker(0x04, SyntaxError, [packError, encode]);
	  codec.addExtPacker(0x05, TypeError, [packError, encode]);
	  codec.addExtPacker(0x06, URIError, [packError, encode]);
	
	  codec.addExtPacker(0x0A, RegExp, [packRegExp, encode]);
	  codec.addExtPacker(0x0B, Boolean, [packValueOf, encode]);
	  codec.addExtPacker(0x0C, String, [packValueOf, encode]);
	  codec.addExtPacker(0x0D, Date, [Number, encode]);
	  codec.addExtPacker(0x0F, Number, [packValueOf, encode]);
	
	  if ("undefined" !== typeof Uint8Array) {
	    codec.addExtPacker(0x11, Int8Array, packTypedArray);
	    codec.addExtPacker(0x12, Uint8Array, packTypedArray);
	    codec.addExtPacker(0x13, Int16Array, packTypedArray);
	    codec.addExtPacker(0x14, Uint16Array, packTypedArray);
	    codec.addExtPacker(0x15, Int32Array, packTypedArray);
	    codec.addExtPacker(0x16, Uint32Array, packTypedArray);
	    codec.addExtPacker(0x17, Float32Array, packTypedArray);
	
	    // PhantomJS/1.9.7 doesn't have Float64Array
	    if ("undefined" !== typeof Float64Array) {
	      codec.addExtPacker(0x18, Float64Array, packTypedArray);
	    }
	
	    // IE10 doesn't have Uint8ClampedArray
	    if ("undefined" !== typeof Uint8ClampedArray) {
	      codec.addExtPacker(0x19, Uint8ClampedArray, packTypedArray);
	    }
	
	    codec.addExtPacker(0x1A, ArrayBuffer, packTypedArray);
	    codec.addExtPacker(0x1D, DataView, packTypedArray);
	  }
	
	  if (Bufferish.hasBuffer) {
	    codec.addExtPacker(0x1B, Buffer, Bufferish.from);
	  }
	}
	
	function encode(input) {
	  if (!_encode) _encode = __webpack_require__(107).encode; // lazy load
	  return _encode(input);
	}
	
	function packValueOf(value) {
	  return (value).valueOf();
	}
	
	function packRegExp(value) {
	  value = RegExp.prototype.toString.call(value).split("/");
	  value.shift();
	  var out = [value.pop()];
	  out.unshift(value.join("/"));
	  return out;
	}
	
	function packError(value) {
	  var out = {};
	  for (var key in ERROR_COLUMNS) {
	    out[key] = value[key];
	  }
	  return out;
	}


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	// ext-unpacker.js
	
	exports.setExtUnpackers = setExtUnpackers;
	
	var Bufferish = __webpack_require__(10);
	var Buffer = Bufferish.global;
	var _decode;
	
	var ERROR_COLUMNS = {name: 1, message: 1, stack: 1, columnNumber: 1, fileName: 1, lineNumber: 1};
	
	function setExtUnpackers(codec) {
	  codec.addExtUnpacker(0x0E, [decode, unpackError(Error)]);
	  codec.addExtUnpacker(0x01, [decode, unpackError(EvalError)]);
	  codec.addExtUnpacker(0x02, [decode, unpackError(RangeError)]);
	  codec.addExtUnpacker(0x03, [decode, unpackError(ReferenceError)]);
	  codec.addExtUnpacker(0x04, [decode, unpackError(SyntaxError)]);
	  codec.addExtUnpacker(0x05, [decode, unpackError(TypeError)]);
	  codec.addExtUnpacker(0x06, [decode, unpackError(URIError)]);
	
	  codec.addExtUnpacker(0x0A, [decode, unpackRegExp]);
	  codec.addExtUnpacker(0x0B, [decode, unpackClass(Boolean)]);
	  codec.addExtUnpacker(0x0C, [decode, unpackClass(String)]);
	  codec.addExtUnpacker(0x0D, [decode, unpackClass(Date)]);
	  codec.addExtUnpacker(0x0F, [decode, unpackClass(Number)]);
	
	  if ("undefined" !== typeof Uint8Array) {
	    codec.addExtUnpacker(0x11, unpackClass(Int8Array));
	    codec.addExtUnpacker(0x12, unpackClass(Uint8Array));
	    codec.addExtUnpacker(0x13, [unpackArrayBuffer, unpackClass(Int16Array)]);
	    codec.addExtUnpacker(0x14, [unpackArrayBuffer, unpackClass(Uint16Array)]);
	    codec.addExtUnpacker(0x15, [unpackArrayBuffer, unpackClass(Int32Array)]);
	    codec.addExtUnpacker(0x16, [unpackArrayBuffer, unpackClass(Uint32Array)]);
	    codec.addExtUnpacker(0x17, [unpackArrayBuffer, unpackClass(Float32Array)]);
	
	    // PhantomJS/1.9.7 doesn't have Float64Array
	    if ("undefined" !== typeof Float64Array) {
	      codec.addExtUnpacker(0x18, [unpackArrayBuffer, unpackClass(Float64Array)]);
	    }
	
	    // IE10 doesn't have Uint8ClampedArray
	    if ("undefined" !== typeof Uint8ClampedArray) {
	      codec.addExtUnpacker(0x19, unpackClass(Uint8ClampedArray));
	    }
	
	    codec.addExtUnpacker(0x1A, unpackArrayBuffer);
	    codec.addExtUnpacker(0x1D, [unpackArrayBuffer, unpackClass(DataView)]);
	  }
	
	  if (Bufferish.hasBuffer) {
	    codec.addExtUnpacker(0x1B, unpackClass(Buffer));
	  }
	}
	
	function decode(input) {
	  if (!_decode) _decode = __webpack_require__(105).decode; // lazy load
	  return _decode(input);
	}
	
	function unpackRegExp(value) {
	  return RegExp.apply(null, value);
	}
	
	function unpackError(Class) {
	  return function(value) {
	    var out = new Class();
	    for (var key in ERROR_COLUMNS) {
	      out[key] = value[key];
	    }
	    return out;
	  };
	}
	
	function unpackClass(Class) {
	  return function(value) {
	    return new Class(value);
	  };
	}
	
	function unpackArrayBuffer(value) {
	  return (new Uint8Array(value)).buffer;
	}


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	// ext.js
	
	// load both interfaces
	__webpack_require__(60);
	__webpack_require__(61);
	
	exports.createCodec = __webpack_require__(41).createCodec;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	// read-token.js
	
	var ReadFormat = __webpack_require__(109);
	
	exports.getReadToken = getReadToken;
	
	function getReadToken(options) {
	  var format = ReadFormat.getReadFormat(options);
	
	  if (options && options.useraw) {
	    return init_useraw(format);
	  } else {
	    return init_token(format);
	  }
	}
	
	function init_token(format) {
	  var i;
	  var token = new Array(256);
	
	  // positive fixint -- 0x00 - 0x7f
	  for (i = 0x00; i <= 0x7f; i++) {
	    token[i] = constant(i);
	  }
	
	  // fixmap -- 0x80 - 0x8f
	  for (i = 0x80; i <= 0x8f; i++) {
	    token[i] = fix(i - 0x80, format.map);
	  }
	
	  // fixarray -- 0x90 - 0x9f
	  for (i = 0x90; i <= 0x9f; i++) {
	    token[i] = fix(i - 0x90, format.array);
	  }
	
	  // fixstr -- 0xa0 - 0xbf
	  for (i = 0xa0; i <= 0xbf; i++) {
	    token[i] = fix(i - 0xa0, format.str);
	  }
	
	  // nil -- 0xc0
	  token[0xc0] = constant(null);
	
	  // (never used) -- 0xc1
	  token[0xc1] = null;
	
	  // false -- 0xc2
	  // true -- 0xc3
	  token[0xc2] = constant(false);
	  token[0xc3] = constant(true);
	
	  // bin 8 -- 0xc4
	  // bin 16 -- 0xc5
	  // bin 32 -- 0xc6
	  token[0xc4] = flex(format.uint8, format.bin);
	  token[0xc5] = flex(format.uint16, format.bin);
	  token[0xc6] = flex(format.uint32, format.bin);
	
	  // ext 8 -- 0xc7
	  // ext 16 -- 0xc8
	  // ext 32 -- 0xc9
	  token[0xc7] = flex(format.uint8, format.ext);
	  token[0xc8] = flex(format.uint16, format.ext);
	  token[0xc9] = flex(format.uint32, format.ext);
	
	  // float 32 -- 0xca
	  // float 64 -- 0xcb
	  token[0xca] = format.float32;
	  token[0xcb] = format.float64;
	
	  // uint 8 -- 0xcc
	  // uint 16 -- 0xcd
	  // uint 32 -- 0xce
	  // uint 64 -- 0xcf
	  token[0xcc] = format.uint8;
	  token[0xcd] = format.uint16;
	  token[0xce] = format.uint32;
	  token[0xcf] = format.uint64;
	
	  // int 8 -- 0xd0
	  // int 16 -- 0xd1
	  // int 32 -- 0xd2
	  // int 64 -- 0xd3
	  token[0xd0] = format.int8;
	  token[0xd1] = format.int16;
	  token[0xd2] = format.int32;
	  token[0xd3] = format.int64;
	
	  // fixext 1 -- 0xd4
	  // fixext 2 -- 0xd5
	  // fixext 4 -- 0xd6
	  // fixext 8 -- 0xd7
	  // fixext 16 -- 0xd8
	  token[0xd4] = fix(1, format.ext);
	  token[0xd5] = fix(2, format.ext);
	  token[0xd6] = fix(4, format.ext);
	  token[0xd7] = fix(8, format.ext);
	  token[0xd8] = fix(16, format.ext);
	
	  // str 8 -- 0xd9
	  // str 16 -- 0xda
	  // str 32 -- 0xdb
	  token[0xd9] = flex(format.uint8, format.str);
	  token[0xda] = flex(format.uint16, format.str);
	  token[0xdb] = flex(format.uint32, format.str);
	
	  // array 16 -- 0xdc
	  // array 32 -- 0xdd
	  token[0xdc] = flex(format.uint16, format.array);
	  token[0xdd] = flex(format.uint32, format.array);
	
	  // map 16 -- 0xde
	  // map 32 -- 0xdf
	  token[0xde] = flex(format.uint16, format.map);
	  token[0xdf] = flex(format.uint32, format.map);
	
	  // negative fixint -- 0xe0 - 0xff
	  for (i = 0xe0; i <= 0xff; i++) {
	    token[i] = constant(i - 0x100);
	  }
	
	  return token;
	}
	
	function init_useraw(format) {
	  var i;
	  var token = init_token(format).slice();
	
	  // raw 8 -- 0xd9
	  // raw 16 -- 0xda
	  // raw 32 -- 0xdb
	  token[0xd9] = token[0xc4];
	  token[0xda] = token[0xc5];
	  token[0xdb] = token[0xc6];
	
	  // fixraw -- 0xa0 - 0xbf
	  for (i = 0xa0; i <= 0xbf; i++) {
	    token[i] = fix(i - 0xa0, format.bin);
	  }
	
	  return token;
	}
	
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	function flex(lenFunc, decodeFunc) {
	  return function(decoder) {
	    var len = lenFunc(decoder);
	    return decodeFunc(decoder, len);
	  };
	}
	
	function fix(len, method) {
	  return function(decoder) {
	    return method(decoder, len);
	  };
	}


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	// write-token.js
	
	var ieee754 = __webpack_require__(102);
	var Int64Buffer = __webpack_require__(55);
	var Uint64BE = Int64Buffer.Uint64BE;
	var Int64BE = Int64Buffer.Int64BE;
	
	var uint8 = __webpack_require__(110).uint8;
	var Bufferish = __webpack_require__(10);
	var Buffer = Bufferish.global;
	var IS_BUFFER_SHIM = Bufferish.hasBuffer && ("TYPED_ARRAY_SUPPORT" in Buffer);
	var NO_TYPED_ARRAY = IS_BUFFER_SHIM && !Buffer.TYPED_ARRAY_SUPPORT;
	var Buffer_prototype = Bufferish.hasBuffer && Buffer.prototype || {};
	
	exports.getWriteToken = getWriteToken;
	
	function getWriteToken(options) {
	  if (options && options.uint8array) {
	    return init_uint8array();
	  } else if (NO_TYPED_ARRAY || (Bufferish.hasBuffer && options && options.safe)) {
	    return init_safe();
	  } else {
	    return init_token();
	  }
	}
	
	function init_uint8array() {
	  var token = init_token();
	
	  // float 32 -- 0xca
	  // float 64 -- 0xcb
	  token[0xca] = writeN(0xca, 4, writeFloatBE);
	  token[0xcb] = writeN(0xcb, 8, writeDoubleBE);
	
	  return token;
	}
	
	// Node.js and browsers with TypedArray
	
	function init_token() {
	  // (immediate values)
	  // positive fixint -- 0x00 - 0x7f
	  // nil -- 0xc0
	  // false -- 0xc2
	  // true -- 0xc3
	  // negative fixint -- 0xe0 - 0xff
	  var token = uint8.slice();
	
	  // bin 8 -- 0xc4
	  // bin 16 -- 0xc5
	  // bin 32 -- 0xc6
	  token[0xc4] = write1(0xc4);
	  token[0xc5] = write2(0xc5);
	  token[0xc6] = write4(0xc6);
	
	  // ext 8 -- 0xc7
	  // ext 16 -- 0xc8
	  // ext 32 -- 0xc9
	  token[0xc7] = write1(0xc7);
	  token[0xc8] = write2(0xc8);
	  token[0xc9] = write4(0xc9);
	
	  // float 32 -- 0xca
	  // float 64 -- 0xcb
	  token[0xca] = writeN(0xca, 4, (Buffer_prototype.writeFloatBE || writeFloatBE), true);
	  token[0xcb] = writeN(0xcb, 8, (Buffer_prototype.writeDoubleBE || writeDoubleBE), true);
	
	  // uint 8 -- 0xcc
	  // uint 16 -- 0xcd
	  // uint 32 -- 0xce
	  // uint 64 -- 0xcf
	  token[0xcc] = write1(0xcc);
	  token[0xcd] = write2(0xcd);
	  token[0xce] = write4(0xce);
	  token[0xcf] = writeN(0xcf, 8, writeUInt64BE);
	
	  // int 8 -- 0xd0
	  // int 16 -- 0xd1
	  // int 32 -- 0xd2
	  // int 64 -- 0xd3
	  token[0xd0] = write1(0xd0);
	  token[0xd1] = write2(0xd1);
	  token[0xd2] = write4(0xd2);
	  token[0xd3] = writeN(0xd3, 8, writeInt64BE);
	
	  // str 8 -- 0xd9
	  // str 16 -- 0xda
	  // str 32 -- 0xdb
	  token[0xd9] = write1(0xd9);
	  token[0xda] = write2(0xda);
	  token[0xdb] = write4(0xdb);
	
	  // array 16 -- 0xdc
	  // array 32 -- 0xdd
	  token[0xdc] = write2(0xdc);
	  token[0xdd] = write4(0xdd);
	
	  // map 16 -- 0xde
	  // map 32 -- 0xdf
	  token[0xde] = write2(0xde);
	  token[0xdf] = write4(0xdf);
	
	  return token;
	}
	
	// safe mode: for old browsers and who needs asserts
	
	function init_safe() {
	  // (immediate values)
	  // positive fixint -- 0x00 - 0x7f
	  // nil -- 0xc0
	  // false -- 0xc2
	  // true -- 0xc3
	  // negative fixint -- 0xe0 - 0xff
	  var token = uint8.slice();
	
	  // bin 8 -- 0xc4
	  // bin 16 -- 0xc5
	  // bin 32 -- 0xc6
	  token[0xc4] = writeN(0xc4, 1, Buffer.prototype.writeUInt8);
	  token[0xc5] = writeN(0xc5, 2, Buffer.prototype.writeUInt16BE);
	  token[0xc6] = writeN(0xc6, 4, Buffer.prototype.writeUInt32BE);
	
	  // ext 8 -- 0xc7
	  // ext 16 -- 0xc8
	  // ext 32 -- 0xc9
	  token[0xc7] = writeN(0xc7, 1, Buffer.prototype.writeUInt8);
	  token[0xc8] = writeN(0xc8, 2, Buffer.prototype.writeUInt16BE);
	  token[0xc9] = writeN(0xc9, 4, Buffer.prototype.writeUInt32BE);
	
	  // float 32 -- 0xca
	  // float 64 -- 0xcb
	  token[0xca] = writeN(0xca, 4, Buffer.prototype.writeFloatBE);
	  token[0xcb] = writeN(0xcb, 8, Buffer.prototype.writeDoubleBE);
	
	  // uint 8 -- 0xcc
	  // uint 16 -- 0xcd
	  // uint 32 -- 0xce
	  // uint 64 -- 0xcf
	  token[0xcc] = writeN(0xcc, 1, Buffer.prototype.writeUInt8);
	  token[0xcd] = writeN(0xcd, 2, Buffer.prototype.writeUInt16BE);
	  token[0xce] = writeN(0xce, 4, Buffer.prototype.writeUInt32BE);
	  token[0xcf] = writeN(0xcf, 8, writeUInt64BE);
	
	  // int 8 -- 0xd0
	  // int 16 -- 0xd1
	  // int 32 -- 0xd2
	  // int 64 -- 0xd3
	  token[0xd0] = writeN(0xd0, 1, Buffer.prototype.writeInt8);
	  token[0xd1] = writeN(0xd1, 2, Buffer.prototype.writeInt16BE);
	  token[0xd2] = writeN(0xd2, 4, Buffer.prototype.writeInt32BE);
	  token[0xd3] = writeN(0xd3, 8, writeInt64BE);
	
	  // str 8 -- 0xd9
	  // str 16 -- 0xda
	  // str 32 -- 0xdb
	  token[0xd9] = writeN(0xd9, 1, Buffer.prototype.writeUInt8);
	  token[0xda] = writeN(0xda, 2, Buffer.prototype.writeUInt16BE);
	  token[0xdb] = writeN(0xdb, 4, Buffer.prototype.writeUInt32BE);
	
	  // array 16 -- 0xdc
	  // array 32 -- 0xdd
	  token[0xdc] = writeN(0xdc, 2, Buffer.prototype.writeUInt16BE);
	  token[0xdd] = writeN(0xdd, 4, Buffer.prototype.writeUInt32BE);
	
	  // map 16 -- 0xde
	  // map 32 -- 0xdf
	  token[0xde] = writeN(0xde, 2, Buffer.prototype.writeUInt16BE);
	  token[0xdf] = writeN(0xdf, 4, Buffer.prototype.writeUInt32BE);
	
	  return token;
	}
	
	function write1(type) {
	  return function(encoder, value) {
	    var offset = encoder.reserve(2);
	    var buffer = encoder.buffer;
	    buffer[offset++] = type;
	    buffer[offset] = value;
	  };
	}
	
	function write2(type) {
	  return function(encoder, value) {
	    var offset = encoder.reserve(3);
	    var buffer = encoder.buffer;
	    buffer[offset++] = type;
	    buffer[offset++] = value >>> 8;
	    buffer[offset] = value;
	  };
	}
	
	function write4(type) {
	  return function(encoder, value) {
	    var offset = encoder.reserve(5);
	    var buffer = encoder.buffer;
	    buffer[offset++] = type;
	    buffer[offset++] = value >>> 24;
	    buffer[offset++] = value >>> 16;
	    buffer[offset++] = value >>> 8;
	    buffer[offset] = value;
	  };
	}
	
	function writeN(type, len, method, noAssert) {
	  return function(encoder, value) {
	    var offset = encoder.reserve(len + 1);
	    encoder.buffer[offset++] = type;
	    method.call(encoder.buffer, value, offset, noAssert);
	  };
	}
	
	function writeUInt64BE(value, offset) {
	  new Uint64BE(this, offset, value);
	}
	
	function writeInt64BE(value, offset) {
	  new Int64BE(this, offset, value);
	}
	
	function writeFloatBE(value, offset) {
	  ieee754.write(this, value, offset, false, 23, 4);
	}
	
	function writeDoubleBE(value, offset) {
	  ieee754.write(this, value, offset, false, 52, 8);
	}


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	// write-type.js
	
	var IS_ARRAY = __webpack_require__(56);
	var Int64Buffer = __webpack_require__(55);
	var Uint64BE = Int64Buffer.Uint64BE;
	var Int64BE = Int64Buffer.Int64BE;
	
	var Bufferish = __webpack_require__(10);
	var BufferProto = __webpack_require__(58);
	var WriteToken = __webpack_require__(198);
	var uint8 = __webpack_require__(110).uint8;
	var ExtBuffer = __webpack_require__(59).ExtBuffer;
	
	var HAS_UINT8ARRAY = ("undefined" !== typeof Uint8Array);
	var HAS_MAP = ("undefined" !== typeof Map);
	
	var extmap = [];
	extmap[1] = 0xd4;
	extmap[2] = 0xd5;
	extmap[4] = 0xd6;
	extmap[8] = 0xd7;
	extmap[16] = 0xd8;
	
	exports.getWriteType = getWriteType;
	
	function getWriteType(options) {
	  var token = WriteToken.getWriteToken(options);
	  var useraw = options && options.useraw;
	  var binarraybuffer = HAS_UINT8ARRAY && options && options.binarraybuffer;
	  var isBuffer = binarraybuffer ? Bufferish.isArrayBuffer : Bufferish.isBuffer;
	  var bin = binarraybuffer ? bin_arraybuffer : bin_buffer;
	  var usemap = HAS_MAP && options && options.usemap;
	  var map = usemap ? map_to_map : obj_to_map;
	
	  var writeType = {
	    "boolean": bool,
	    "function": nil,
	    "number": number,
	    "object": (useraw ? object_raw : object),
	    "string": _string(useraw ? raw_head_size : str_head_size),
	    "symbol": nil,
	    "undefined": nil
	  };
	
	  return writeType;
	
	  // false -- 0xc2
	  // true -- 0xc3
	  function bool(encoder, value) {
	    var type = value ? 0xc3 : 0xc2;
	    token[type](encoder, value);
	  }
	
	  function number(encoder, value) {
	    var ivalue = value | 0;
	    var type;
	    if (value !== ivalue) {
	      // float 64 -- 0xcb
	      type = 0xcb;
	      token[type](encoder, value);
	      return;
	    } else if (-0x20 <= ivalue && ivalue <= 0x7F) {
	      // positive fixint -- 0x00 - 0x7f
	      // negative fixint -- 0xe0 - 0xff
	      type = ivalue & 0xFF;
	    } else if (0 <= ivalue) {
	      // uint 8 -- 0xcc
	      // uint 16 -- 0xcd
	      // uint 32 -- 0xce
	      type = (ivalue <= 0xFF) ? 0xcc : (ivalue <= 0xFFFF) ? 0xcd : 0xce;
	    } else {
	      // int 8 -- 0xd0
	      // int 16 -- 0xd1
	      // int 32 -- 0xd2
	      type = (-0x80 <= ivalue) ? 0xd0 : (-0x8000 <= ivalue) ? 0xd1 : 0xd2;
	    }
	    token[type](encoder, ivalue);
	  }
	
	  // uint 64 -- 0xcf
	  function uint64(encoder, value) {
	    var type = 0xcf;
	    token[type](encoder, value.toArray());
	  }
	
	  // int 64 -- 0xd3
	  function int64(encoder, value) {
	    var type = 0xd3;
	    token[type](encoder, value.toArray());
	  }
	
	  // str 8 -- 0xd9
	  // str 16 -- 0xda
	  // str 32 -- 0xdb
	  // fixstr -- 0xa0 - 0xbf
	  function str_head_size(length) {
	    return (length < 32) ? 1 : (length <= 0xFF) ? 2 : (length <= 0xFFFF) ? 3 : 5;
	  }
	
	  // raw 16 -- 0xda
	  // raw 32 -- 0xdb
	  // fixraw -- 0xa0 - 0xbf
	  function raw_head_size(length) {
	    return (length < 32) ? 1 : (length <= 0xFFFF) ? 3 : 5;
	  }
	
	  function _string(head_size) {
	    return string;
	
	    function string(encoder, value) {
	      // prepare buffer
	      var length = value.length;
	      var maxsize = 5 + length * 3;
	      encoder.offset = encoder.reserve(maxsize);
	      var buffer = encoder.buffer;
	
	      // expected header size
	      var expected = head_size(length);
	
	      // expected start point
	      var start = encoder.offset + expected;
	
	      // write string
	      length = BufferProto.write.call(buffer, value, start);
	
	      // actual header size
	      var actual = head_size(length);
	
	      // move content when needed
	      if (expected !== actual) {
	        var targetStart = start + actual - expected;
	        var end = start + length;
	        BufferProto.copy.call(buffer, buffer, targetStart, start, end);
	      }
	
	      // write header
	      var type = (actual === 1) ? (0xa0 + length) : (actual <= 3) ? (0xd7 + actual) : 0xdb;
	      token[type](encoder, length);
	
	      // move cursor
	      encoder.offset += length;
	    }
	  }
	
	  function object(encoder, value) {
	    // null
	    if (value === null) return nil(encoder, value);
	
	    // Buffer
	    if (isBuffer(value)) return bin(encoder, value);
	
	    // Array
	    if (IS_ARRAY(value)) return array(encoder, value);
	
	    // int64-buffer objects
	    if (Uint64BE.isUint64BE(value)) return uint64(encoder, value);
	    if (Int64BE.isInt64BE(value)) return int64(encoder, value);
	
	    // ext formats
	    var packer = encoder.codec.getExtPacker(value);
	    if (packer) value = packer(value);
	    if (value instanceof ExtBuffer) return ext(encoder, value);
	
	    // plain old Objects or Map
	    map(encoder, value);
	  }
	
	  function object_raw(encoder, value) {
	    // Buffer
	    if (isBuffer(value)) return raw(encoder, value);
	
	    // others
	    object(encoder, value);
	  }
	
	  // nil -- 0xc0
	  function nil(encoder, value) {
	    var type = 0xc0;
	    token[type](encoder, value);
	  }
	
	  // fixarray -- 0x90 - 0x9f
	  // array 16 -- 0xdc
	  // array 32 -- 0xdd
	  function array(encoder, value) {
	    var length = value.length;
	    var type = (length < 16) ? (0x90 + length) : (length <= 0xFFFF) ? 0xdc : 0xdd;
	    token[type](encoder, length);
	
	    var encode = encoder.codec.encode;
	    for (var i = 0; i < length; i++) {
	      encode(encoder, value[i]);
	    }
	  }
	
	  // bin 8 -- 0xc4
	  // bin 16 -- 0xc5
	  // bin 32 -- 0xc6
	  function bin_buffer(encoder, value) {
	    var length = value.length;
	    var type = (length < 0xFF) ? 0xc4 : (length <= 0xFFFF) ? 0xc5 : 0xc6;
	    token[type](encoder, length);
	    encoder.send(value);
	  }
	
	  function bin_arraybuffer(encoder, value) {
	    bin_buffer(encoder, new Uint8Array(value));
	  }
	
	  // fixext 1 -- 0xd4
	  // fixext 2 -- 0xd5
	  // fixext 4 -- 0xd6
	  // fixext 8 -- 0xd7
	  // fixext 16 -- 0xd8
	  // ext 8 -- 0xc7
	  // ext 16 -- 0xc8
	  // ext 32 -- 0xc9
	  function ext(encoder, value) {
	    var buffer = value.buffer;
	    var length = buffer.length;
	    var type = extmap[length] || ((length < 0xFF) ? 0xc7 : (length <= 0xFFFF) ? 0xc8 : 0xc9);
	    token[type](encoder, length);
	    uint8[value.type](encoder);
	    encoder.send(buffer);
	  }
	
	  // fixmap -- 0x80 - 0x8f
	  // map 16 -- 0xde
	  // map 32 -- 0xdf
	  function obj_to_map(encoder, value) {
	    var keys = Object.keys(value);
	    var length = keys.length;
	    var type = (length < 16) ? (0x80 + length) : (length <= 0xFFFF) ? 0xde : 0xdf;
	    token[type](encoder, length);
	
	    var encode = encoder.codec.encode;
	    keys.forEach(function(key) {
	      encode(encoder, key);
	      encode(encoder, value[key]);
	    });
	  }
	
	  // fixmap -- 0x80 - 0x8f
	  // map 16 -- 0xde
	  // map 32 -- 0xdf
	  function map_to_map(encoder, value) {
	    if (!(value instanceof Map)) return obj_to_map(encoder, value);
	
	    var length = value.size;
	    var type = (length < 16) ? (0x80 + length) : (length <= 0xFFFF) ? 0xde : 0xdf;
	    token[type](encoder, length);
	
	    var encode = encoder.codec.encode;
	    value.forEach(function(val, key, m) {
	      encode(encoder, key);
	      encode(encoder, val);
	    });
	  }
	
	  // raw 16 -- 0xda
	  // raw 32 -- 0xdb
	  // fixraw -- 0xa0 - 0xbf
	  function raw(encoder, value) {
	    var length = value.length;
	    var type = (length < 32) ? (0xa0 + length) : (length <= 0xFFFF) ? 0xda : 0xdb;
	    token[type](encoder, length);
	    encoder.send(value);
	  }
	}


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(357);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(215);


/***/ },
/* 202 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(6);
	
	var focusNode = __webpack_require__(94);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(34);
	var ExecutionEnvironment = __webpack_require__(9);
	var FallbackCompositionState = __webpack_require__(210);
	var SyntheticCompositionEvent = __webpack_require__(247);
	var SyntheticInputEvent = __webpack_require__(250);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(111);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactInstrumentation = __webpack_require__(12);
	
	var camelizeStyleName = __webpack_require__(162);
	var dangerousStyleValue = __webpack_require__(256);
	var hyphenateStyleName = __webpack_require__(169);
	var memoizeStringOnly = __webpack_require__(172);
	var warning = __webpack_require__(3);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(33);
	var EventPropagators = __webpack_require__(34);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(14);
	var SyntheticEvent = __webpack_require__(16);
	
	var getEventTarget = __webpack_require__(74);
	var isEventSupported = __webpack_require__(75);
	var isTextInputElement = __webpack_require__(128);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(25);
	var ExecutionEnvironment = __webpack_require__(9);
	
	var createNodesFromMarkup = __webpack_require__(165);
	var emptyFunction = __webpack_require__(11);
	var invariant = __webpack_require__(2);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 208 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(34);
	var ReactDOMComponentTree = __webpack_require__(6);
	var SyntheticMouseEvent = __webpack_require__(43);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var PooledClass = __webpack_require__(21);
	
	var getTextContentAccessor = __webpack_require__(126);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(26);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(27);
	
	var instantiateReactComponent = __webpack_require__(127);
	var KeyEscapeUtils = __webpack_require__(66);
	var shouldUpdateReactComponent = __webpack_require__(76);
	var traverseAllChildren = __webpack_require__(130);
	var warning = __webpack_require__(3);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(142);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(85)))

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(62);
	var ReactDOMIDOperations = __webpack_require__(220);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(5);
	
	var React = __webpack_require__(29);
	var ReactComponentEnvironment = __webpack_require__(68);
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactErrorUtils = __webpack_require__(69);
	var ReactInstanceMap = __webpack_require__(35);
	var ReactInstrumentation = __webpack_require__(12);
	var ReactNodeTypes = __webpack_require__(121);
	var ReactReconciler = __webpack_require__(27);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(32);
	var invariant = __webpack_require__(2);
	var shallowEqual = __webpack_require__(51);
	var shouldUpdateReactComponent = __webpack_require__(76);
	var warning = __webpack_require__(3);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDefaultInjection = __webpack_require__(228);
	var ReactMount = __webpack_require__(120);
	var ReactReconciler = __webpack_require__(27);
	var ReactUpdates = __webpack_require__(14);
	var ReactVersion = __webpack_require__(241);
	
	var findDOMNode = __webpack_require__(257);
	var getHostComponentFromComposite = __webpack_require__(125);
	var renderSubtreeIntoContainer = __webpack_require__(265);
	var warning = __webpack_require__(3);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(5);
	
	var AutoFocusUtils = __webpack_require__(203);
	var CSSPropertyOperations = __webpack_require__(205);
	var DOMLazyTree = __webpack_require__(25);
	var DOMNamespaces = __webpack_require__(63);
	var DOMProperty = __webpack_require__(26);
	var DOMPropertyOperations = __webpack_require__(113);
	var EventPluginHub = __webpack_require__(33);
	var EventPluginRegistry = __webpack_require__(64);
	var ReactBrowserEventEmitter = __webpack_require__(42);
	var ReactDOMComponentFlags = __webpack_require__(114);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMInput = __webpack_require__(221);
	var ReactDOMOption = __webpack_require__(222);
	var ReactDOMSelect = __webpack_require__(115);
	var ReactDOMTextarea = __webpack_require__(225);
	var ReactInstrumentation = __webpack_require__(12);
	var ReactMultiChild = __webpack_require__(234);
	var ReactServerRenderingTransaction = __webpack_require__(239);
	
	var emptyFunction = __webpack_require__(11);
	var escapeTextContentForBrowser = __webpack_require__(45);
	var invariant = __webpack_require__(2);
	var isEventSupported = __webpack_require__(75);
	var shallowEqual = __webpack_require__(51);
	var validateDOMNesting = __webpack_require__(77);
	var warning = __webpack_require__(3);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(77);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var DOMLazyTree = __webpack_require__(25);
	var ReactDOMComponentTree = __webpack_require__(6);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 219 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(62);
	var ReactDOMComponentTree = __webpack_require__(6);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(5);
	
	var DOMPropertyOperations = __webpack_require__(113);
	var LinkedValueUtils = __webpack_require__(67);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(14);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var React = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMSelect = __webpack_require__(115);
	
	var warning = __webpack_require__(3);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var getNodeForCharacterOffset = __webpack_require__(262);
	var getTextContentAccessor = __webpack_require__(126);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(5);
	
	var DOMChildrenOperations = __webpack_require__(62);
	var DOMLazyTree = __webpack_require__(25);
	var ReactDOMComponentTree = __webpack_require__(6);
	
	var escapeTextContentForBrowser = __webpack_require__(45);
	var invariant = __webpack_require__(2);
	var validateDOMNesting = __webpack_require__(77);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(5);
	
	var LinkedValueUtils = __webpack_require__(67);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(14);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var ReactUpdates = __webpack_require__(14);
	var Transaction = __webpack_require__(44);
	
	var emptyFunction = __webpack_require__(11);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(202);
	var BeforeInputEventPlugin = __webpack_require__(204);
	var ChangeEventPlugin = __webpack_require__(206);
	var DefaultEventPluginOrder = __webpack_require__(208);
	var EnterLeaveEventPlugin = __webpack_require__(209);
	var HTMLDOMPropertyConfig = __webpack_require__(211);
	var ReactComponentBrowserEnvironment = __webpack_require__(213);
	var ReactDOMComponent = __webpack_require__(216);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMEmptyComponent = __webpack_require__(218);
	var ReactDOMTreeTraversal = __webpack_require__(226);
	var ReactDOMTextComponent = __webpack_require__(224);
	var ReactDefaultBatchingStrategy = __webpack_require__(227);
	var ReactEventListener = __webpack_require__(231);
	var ReactInjection = __webpack_require__(232);
	var ReactReconcileTransaction = __webpack_require__(237);
	var SVGDOMPropertyConfig = __webpack_require__(242);
	var SelectEventPlugin = __webpack_require__(243);
	var SimpleEventPlugin = __webpack_require__(244);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 229 */
143,
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(33);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var EventListener = __webpack_require__(93);
	var ExecutionEnvironment = __webpack_require__(9);
	var PooledClass = __webpack_require__(21);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(14);
	
	var getEventTarget = __webpack_require__(74);
	var getUnboundedScrollPosition = __webpack_require__(167);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(26);
	var EventPluginHub = __webpack_require__(33);
	var EventPluginUtils = __webpack_require__(65);
	var ReactComponentEnvironment = __webpack_require__(68);
	var ReactEmptyComponent = __webpack_require__(116);
	var ReactBrowserEventEmitter = __webpack_require__(42);
	var ReactHostComponent = __webpack_require__(118);
	var ReactUpdates = __webpack_require__(14);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(255);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactComponentEnvironment = __webpack_require__(68);
	var ReactInstanceMap = __webpack_require__(35);
	var ReactInstrumentation = __webpack_require__(12);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactReconciler = __webpack_require__(27);
	var ReactChildReconciler = __webpack_require__(212);
	
	var emptyFunction = __webpack_require__(11);
	var flattenChildren = __webpack_require__(258);
	var invariant = __webpack_require__(2);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 236 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var CallbackQueue = __webpack_require__(112);
	var PooledClass = __webpack_require__(21);
	var ReactBrowserEventEmitter = __webpack_require__(42);
	var ReactInputSelection = __webpack_require__(119);
	var ReactInstrumentation = __webpack_require__(12);
	var Transaction = __webpack_require__(44);
	var ReactUpdateQueue = __webpack_require__(70);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(235);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var PooledClass = __webpack_require__(21);
	var Transaction = __webpack_require__(44);
	var ReactInstrumentation = __webpack_require__(12);
	var ReactServerUpdateQueue = __webpack_require__(240);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(70);
	
	var warning = __webpack_require__(3);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 241 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.4.2';

/***/ },
/* 242 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(34);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactInputSelection = __webpack_require__(119);
	var SyntheticEvent = __webpack_require__(16);
	
	var getActiveElement = __webpack_require__(95);
	var isTextInputElement = __webpack_require__(128);
	var shallowEqual = __webpack_require__(51);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var EventListener = __webpack_require__(93);
	var EventPropagators = __webpack_require__(34);
	var ReactDOMComponentTree = __webpack_require__(6);
	var SyntheticAnimationEvent = __webpack_require__(245);
	var SyntheticClipboardEvent = __webpack_require__(246);
	var SyntheticEvent = __webpack_require__(16);
	var SyntheticFocusEvent = __webpack_require__(249);
	var SyntheticKeyboardEvent = __webpack_require__(251);
	var SyntheticMouseEvent = __webpack_require__(43);
	var SyntheticDragEvent = __webpack_require__(248);
	var SyntheticTouchEvent = __webpack_require__(252);
	var SyntheticTransitionEvent = __webpack_require__(253);
	var SyntheticUIEvent = __webpack_require__(36);
	var SyntheticWheelEvent = __webpack_require__(254);
	
	var emptyFunction = __webpack_require__(11);
	var getEventCharCode = __webpack_require__(72);
	var invariant = __webpack_require__(2);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(43);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(36);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(36);
	
	var getEventCharCode = __webpack_require__(72);
	var getEventKey = __webpack_require__(259);
	var getEventModifierState = __webpack_require__(73);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(36);
	
	var getEventModifierState = __webpack_require__(73);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(43);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 255 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(111);
	var warning = __webpack_require__(3);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactInstanceMap = __webpack_require__(35);
	
	var getHostComponentFromComposite = __webpack_require__(125);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(66);
	var traverseAllChildren = __webpack_require__(130);
	var warning = __webpack_require__(3);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(142);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(85)))

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(72);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 260 */
146,
/* 261 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 262 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(45);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(120);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(132);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(133);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(132);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(268);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(269);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(133);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(57);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(101);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 268 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(88);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(134);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(135);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(18);
	
	var _InternalPropTypes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(18);
	
	var _InternalPropTypes = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(98);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(40);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(80);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(22);
	
	var _RouterContext = __webpack_require__(47);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(18);
	
	var _RouterUtils = __webpack_require__(136);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(47);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(78);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(47);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(174);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(138);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(28);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(78);
	
	var _makeStateWithLocation = __webpack_require__(139);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(28);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(98);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(138);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(28);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(24);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(137);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(80);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(18);
	
	var _RouterUtils = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(78);
	
	var _makeStateWithLocation = __webpack_require__(139);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(28);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(40);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(80);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(101);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(337).enable();
	  window.Promise = __webpack_require__(336);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(341);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(335);


/***/ },
/* 292 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	var BrowserMutationObserver = global.MutationObserver || global.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Sidebar = __webpack_require__(314);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Map = __webpack_require__(302);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _d3Format = __webpack_require__(23);
	
	var _YearChanger = __webpack_require__(315);
	
	var _YearChanger2 = _interopRequireDefault(_YearChanger);
	
	var _Explainer = __webpack_require__(298);
	
	var _Explainer2 = _interopRequireDefault(_Explainer);
	
	var _Loader = __webpack_require__(301);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _d3Interpolate = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	// import Sidebar from './Sidebar'
	
	
	var Apper = function Apper(_ref) {
	  var _React$createElement;
	
	  var active_year = _ref.active_year;
	  var active_price = _ref.active_price;
	  var active_mode = _ref.active_mode;
	  var active_probability = _ref.active_probability;
	  var map = _ref.map;
	  var neighborhoods = _ref.neighborhoods;
	  var neighborhoods_samples = _ref.neighborhoods_samples;
	  var changeActiveYear = _ref.changeActiveYear;
	  var changeActivePrice = _ref.changeActivePrice;
	  var mapLoaded = _ref.mapLoaded;
	  var getNeighborhoodsSamples = _ref.getNeighborhoodsSamples;
	  var changeActiveMode = _ref.changeActiveMode;
	  var changeActiveProbability = _ref.changeActiveProbability;
	  var price_focus = _ref.price_focus;
	  var probability_focus = _ref.probability_focus;
	  var changePriceFocus = _ref.changePriceFocus;
	  var changeProbabilityFocus = _ref.changeProbabilityFocus;
	  var setActiveNeighborhood = _ref.setActiveNeighborhood;
	  var active_neighborhood = _ref.active_neighborhood;
	  var active_neighborhood_with_samples = _ref.active_neighborhood_with_samples;
	  var closeNeighborhoodFocus = _ref.closeNeighborhoodFocus;
	  var borough_filter = _ref.borough_filter;
	  var setBoroughFilter = _ref.setBoroughFilter;
	  var hexes = _ref.hexes;
	  var setActiveHex = _ref.setActiveHex;
	  var active_hex = _ref.active_hex;
	  var active_hex_with_samples = _ref.active_hex_with_samples;
	  var closeHexFocus = _ref.closeHexFocus;
	  var show_roads = _ref.show_roads;
	  var setShowRoads = _ref.setShowRoads;
	  var explainer = _ref.explainer;
	  var setExplainer = _ref.setExplainer;
	  var browser_width = _ref.browser_width;
	  var mobile_toggle = _ref.mobile_toggle;
	  var toggleMobile = _ref.toggleMobile;
	  var prospectHeights2010 = _ref.prospectHeights2010;
	  var prospectHeights2016 = _ref.prospectHeights2016;
	  var getNeighborhoodHexes = _ref.getNeighborhoodHexes;
	  var mobile_show = _ref.mobile_show;
	  var changeMobileShow = _ref.changeMobileShow;
	
	
	  var borough_abbreviations = {
	    brooklyn: 'BK',
	    bronx: 'BX',
	    manhattan: 'MN',
	    queens: 'QN',
	    'staten island': 'SI'
	  };
	
	  var formatters = {
	    percentFormat: (0, _d3Format.format)('.0%'),
	    dollarFormat: (0, _d3Format.format)('$,'),
	    dollarShort: (0, _d3Format.format)('$.2s'),
	    dollarThree: (0, _d3Format.format)('$.3s'),
	    commas: (0, _d3Format.format)(','),
	    borough_abbreviations: borough_abbreviations
	  };
	
	  var chanceInterpolator = function chanceInterpolator(value) {
	    if (value > 1) {
	      return '#866ff2';
	    } else {
	      return (0, _d3Interpolate.interpolateRgb)('#fff', '#866ff2')(value);
	    }
	  };
	
	  var moneyInterpolator = function moneyInterpolator(value) {
	    if (value > 1) {
	      return '#e66101';
	    } else {
	      return (0, _d3Interpolate.interpolateRgb)('#fff', '#e66101')(value);
	    }
	  };
	
	  var interpolators = {
	    chance: chanceInterpolator,
	    money: moneyInterpolator
	  };
	
	  var filtered_neighborhoods = neighborhoods;
	  if (borough_filter && neighborhoods) filtered_neighborhoods = neighborhoods.filter(function (neighborhood) {
	    return neighborhood.properties.borough === borough_filter ? true : false;
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Map2.default, {
	      active_year: active_year,
	      active_price: active_price,
	      map: map,
	      neighborhoods: neighborhoods,
	      price_focus: price_focus,
	      neighborhoods_samples: neighborhoods_samples,
	      mapLoaded: mapLoaded,
	      getNeighborhoodsSamples: getNeighborhoodsSamples,
	      active_mode: active_mode,
	      borough_filter: borough_filter,
	      formatters: formatters,
	      active_probability: active_probability,
	      active_neighborhood: active_neighborhood,
	      setActiveNeighborhood: setActiveNeighborhood,
	      getNeighborhoodHexes: getNeighborhoodHexes,
	      setActiveHex: setActiveHex,
	      interpolators: interpolators,
	      hexes: hexes,
	      active_hex: active_hex,
	      show_roads: show_roads,
	      browser_width: browser_width
	    }),
	    _react2.default.createElement(_Sidebar2.default, {
	      active_year: active_year,
	      active_price: active_price,
	      changeActiveYear: changeActiveYear,
	      changeActivePrice: changeActivePrice,
	      changeActiveMode: changeActiveMode,
	      changeActiveProbability: changeActiveProbability,
	      changePriceFocus: changePriceFocus,
	      neighborhoods: filtered_neighborhoods,
	      neighborhoods_samples: neighborhoods_samples,
	      formatters: formatters,
	      active_mode: active_mode,
	      active_probability: active_probability,
	      price_focus: price_focus,
	      active_neighborhood: active_neighborhood_with_samples,
	      probability_focus: probability_focus,
	      borough_filter: borough_filter,
	      changeProbabilityFocus: changeProbabilityFocus,
	      setActiveNeighborhood: setActiveNeighborhood,
	      getNeighborhoodHexes: getNeighborhoodHexes,
	      closeNeighborhoodFocus: closeNeighborhoodFocus,
	      closeHexFocus: closeHexFocus,
	      setBoroughFilter: setBoroughFilter,
	      interpolators: interpolators,
	      active_hex: active_hex_with_samples,
	      show_roads: show_roads,
	      setShowRoads: setShowRoads,
	      setExplainer: setExplainer,
	      browser_width: browser_width,
	      mobile_toggle: mobile_toggle,
	      toggleMobile: toggleMobile,
	      mobile_show: mobile_show,
	      changeMobileShow: changeMobileShow
	    }),
	    _react2.default.createElement(_YearChanger2.default, {
	      active_year: active_year,
	      changeActiveYear: changeActiveYear,
	      browser_width: browser_width
	    }),
	    _react2.default.createElement(_Loader2.default, {
	      neighborhoods_samples: neighborhoods_samples
	    }),
	    explainer ? _react2.default.createElement(_Explainer2.default, (_React$createElement = {
	      setExplainer: setExplainer,
	      browser_width: browser_width,
	      changeActiveYear: changeActiveYear,
	      changeActiveMode: changeActiveMode,
	      changeActivePrice: changeActivePrice,
	      changeActiveProbability: changeActiveProbability,
	      setActiveNeighborhood: setActiveNeighborhood
	    }, _defineProperty(_React$createElement, 'setExplainer', setExplainer), _defineProperty(_React$createElement, 'setBoroughFilter', setBoroughFilter), _defineProperty(_React$createElement, 'setActiveHex', setActiveHex), _defineProperty(_React$createElement, 'neighborhoods_samples', neighborhoods_samples), _React$createElement)) : null
	  );
	};
	
	exports.default = Apper;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChanceChanger = function ChanceChanger(_ref) {
	  var active_probability = _ref.active_probability;
	  var changeActiveProbability = _ref.changeActiveProbability;
	  var formatters = _ref.formatters;
	
	
	  var handleOnChange = function handleOnChange(e) {
	    changeActiveProbability(e.target.value);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "col-12 px2" },
	    _react2.default.createElement(
	      "div",
	      null,
	      "Chance: ",
	      formatters.percentFormat(active_probability)
	    ),
	    _react2.default.createElement("input", { onChange: handleOnChange, className: "col-12", type: "range", min: "0", value: active_probability, max: "1", step: "0.1" }),
	    _react2.default.createElement("div", { className: "mt1 border-bottom" })
	  );
	};
	
	exports.default = ChanceChanger;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Interpolate = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChanceNeighborhoodList = function ChanceNeighborhoodList(_ref) {
	  var neighborhoods = _ref.neighborhoods;
	  var formatters = _ref.formatters;
	  var probability_focus = _ref.probability_focus;
	
	  var interpolate = function interpolate(value) {
	    if (value < 0.5) {
	      return (0, _d3Interpolate.interpolateRgb)('#d01c8b', '#f7f7f7')(value * 2);
	    } else if (value > 1) {
	      return '#4dac26';
	    } else {
	      return (0, _d3Interpolate.interpolateRgb)('#f7f7f7', '#4dac26')((value - 0.5) * 2);
	    }
	  };
	  var top_neighborhoods = [];
	  var bottom_neighborhoods = [];
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = neighborhoods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var neighborhood = _step.value;
	
	      if (neighborhood.properties.probability < probability_focus) {
	        bottom_neighborhoods.push(neighborhood);
	      } else {
	        top_neighborhoods.push(neighborhood);
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  top_neighborhoods.reverse();
	
	  var neighborhood_item = function neighborhood_item(neighborhood) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'clearfix SideListItem tnum h6 col-12 px1',
	        key: neighborhood.properties.neighborhood,
	        style: { background: interpolate(neighborhood.properties.probability) }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'relative' },
	        _react2.default.createElement(
	          'div',
	          { className: '' },
	          neighborhood.properties.neighborhood,
	          ', ',
	          _react2.default.createElement(
	            'span',
	            { className: 'capitalize' },
	            neighborhood.properties.borough
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'absolute right-0 top-0' },
	          formatters.percentFormat(neighborhood.properties.probability)
	        )
	      )
	    );
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-6' },
	      _react2.default.createElement(
	        'div',
	        { className: 'h5 px1' },
	        'Below (',
	        bottom_neighborhoods.length,
	        ')'
	      ),
	      bottom_neighborhoods.map(function (neighborhood) {
	        return neighborhood_item(neighborhood);
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-6' },
	      _react2.default.createElement(
	        'div',
	        { className: 'h5 px1' },
	        'Above (',
	        top_neighborhoods.length,
	        ')'
	      ),
	      top_neighborhoods.map(function (neighborhood) {
	        return neighborhood_item(neighborhood);
	      })
	    )
	  );
	};
	
	exports.default = ChanceNeighborhoodList;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Axis = __webpack_require__(37);
	
	var _d3Format = __webpack_require__(23);
	
	var _d3Selection = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DistributionXAxis = function (_Component) {
	  _inherits(DistributionXAxis, _Component);
	
	  function DistributionXAxis() {
	    _classCallCheck(this, DistributionXAxis);
	
	    return _possibleConstructorReturn(this, (DistributionXAxis.__proto__ || Object.getPrototypeOf(DistributionXAxis)).apply(this, arguments));
	  }
	
	  _createClass(DistributionXAxis, [{
	    key: 'renderAxis',
	    value: function renderAxis() {
	      var _props = this.props;
	      var formatters = _props.formatters;
	      var x = _props.x;
	      var inner_height = _props.inner_height;
	      var svg_height = _props.svg_height;
	      var margins = _props.margins;
	
	      var xAxis = (0, _d3Axis.axisBottom)().scale(x).ticks(6).tickSize(-inner_height, 0, 0).tickFormat((0, _d3Format.format)("$.0s"));
	      var node = this.refs.axis;
	      var axis = (0, _d3Selection.select)(node).call(xAxis);
	      axis.selectAll("text").attr("y", 10);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderAxis();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderAxis();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var margins = this.props.margins;
	
	      return _react2.default.createElement('g', { className: 'Axis no-ticks', ref: 'axis', transform: 'translate(0,' + this.props.inner_height + ')' });
	    }
	  }]);
	
	  return DistributionXAxis;
	}(_react.Component);
	
	exports.default = DistributionXAxis;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Axis = __webpack_require__(37);
	
	var _d3Format = __webpack_require__(23);
	
	var _d3Selection = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DistributionYAxis = function (_Component) {
	  _inherits(DistributionYAxis, _Component);
	
	  function DistributionYAxis() {
	    _classCallCheck(this, DistributionYAxis);
	
	    return _possibleConstructorReturn(this, (DistributionYAxis.__proto__ || Object.getPrototypeOf(DistributionYAxis)).apply(this, arguments));
	  }
	
	  _createClass(DistributionYAxis, [{
	    key: 'renderAxis',
	    value: function renderAxis() {
	      var _props = this.props;
	      var formatters = _props.formatters;
	      var y = _props.y;
	      var svg_width = _props.svg_width;
	      var margins = _props.margins;
	
	      var yAxis = (0, _d3Axis.axisLeft)().scale(y).ticks(5).tickSize(-svg_width + margins.right + 28, 0, 0).tickFormat((0, _d3Format.format)('.0%'));
	      var node = this.refs.axis;
	      var axis = (0, _d3Selection.select)(node).call(yAxis);
	      axis.selectAll("text").attr("x", -8);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderAxis();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderAxis();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var margins = this.props.margins;
	
	      return _react2.default.createElement('g', { className: 'Axis', ref: 'axis', transform: 'translate(0,0)' });
	    }
	  }]);
	
	  return DistributionYAxis;
	}(_react.Component);
	
	exports.default = DistributionYAxis;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(49);
	
	var _modeToggleSmall = __webpack_require__(332);
	
	var _modeToggleSmall2 = _interopRequireDefault(_modeToggleSmall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Explainer = function Explainer(_ref) {
	  var setExplainer = _ref.setExplainer;
	  var changeActiveYear = _ref.changeActiveYear;
	  var changeActiveMode = _ref.changeActiveMode;
	  var changeActivePrice = _ref.changeActivePrice;
	  var changeActiveProbability = _ref.changeActiveProbability;
	  var setActiveNeighborhood = _ref.setActiveNeighborhood;
	  var setBoroughFilter = _ref.setBoroughFilter;
	  var setActiveHex = _ref.setActiveHex;
	  var neighborhoods_samples = _ref.neighborhoods_samples;
	
	
	  var handleCloseClick = function handleCloseClick() {
	    setExplainer(false);
	  };
	
	  var stopPropagation = function stopPropagation(e) {
	    e.stopPropagation();
	  };
	
	  var prospectHeights2010 = function prospectHeights2010() {
	    if (neighborhoods_samples) {
	      setExplainer(false);
	      setActiveNeighborhood('Prospect Heights');
	      changeActiveYear(2010);
	      changeActivePrice(1000000);
	      changeActiveMode('Chance');
	    }
	  };
	
	  var prospectHeights2016 = function prospectHeights2016() {
	    if (neighborhoods_samples) {
	      setExplainer(false);
	      setActiveNeighborhood('Prospect Heights');
	      changeActivePrice(1000000);
	      changeActiveMode('Chance');
	      changeActiveYear(2016);
	    }
	  };
	
	  var manhattan2016 = function manhattan2016() {
	    if (neighborhoods_samples) {
	      setExplainer(false);
	      setBoroughFilter('manhattan');
	      changeActivePrice(1500000);
	      changeActiveMode('Chance');
	      changeActiveYear(2016);
	    }
	  };
	
	  var cobble2016 = function cobble2016() {
	    if (neighborhoods_samples) {
	      setExplainer(false);
	      setBoroughFilter(false);
	      changeActivePrice(1500000);
	      changeActiveMode('Price');
	      setActiveNeighborhood('Brooklyn Heights-Cobble Hill');
	      changeActiveYear(2016);
	    }
	  };
	
	  var village2016 = function village2016() {
	    if (neighborhoods_samples) {
	      setExplainer(false);
	      setBoroughFilter(false);
	      changeActivePrice(1500000);
	      changeActiveMode('Price');
	      setActiveNeighborhood('West Village');
	      changeActiveYear(2016);
	    }
	  };
	
	  var astoria2016 = function astoria2016() {
	    if (neighborhoods_samples) {
	      setExplainer(false);
	      setBoroughFilter(false);
	      changeActivePrice(1000000);
	      changeActiveMode('Chance');
	      setActiveNeighborhood('Astoria');
	      changeActiveYear(2016);
	    }
	  };
	
	  var bedfor2018 = function bedfor2018() {
	    if (neighborhoods_samples) {
	      setExplainer(false);
	      setBoroughFilter(false);
	      changeActiveMode('Price');
	      setActiveNeighborhood('Bedford');
	      changeActiveYear(2018);
	    }
	  };
	
	  var map_ready = false;
	  if (neighborhoods_samples) map_ready = true;
	
	  return _react2.default.createElement(
	    'div',
	    { className: "ExplainBacker fixed left-0 top-0 right-0 bottom-0 " + (map_ready ? 'map_ready' : ''), onClick: handleCloseClick.bind(undefined) },
	    _react2.default.createElement(
	      'div',
	      { className: 'ExplainInner h4 relative', onClick: stopPropagation.bind(undefined) },
	      _react2.default.createElement(
	        'div',
	        { className: 'h2 mb1 bold', style: { paddingRight: '2rem' } },
	        'Probabilistic Real Estate'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'absolute center pointer',
	          style: {
	            right: '1.5rem',
	            top: '0.8rem',
	            height: '2rem',
	            lineHeight: '2rem',
	            fontSize: '2.5rem',
	            color: '#666'
	          },
	          onClick: handleCloseClick.bind(undefined)
	        },
	        '×'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Probabilistic Real Estate is a probabilistic programming prototype built by ',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://www.fastforwardlabs.com/' },
	          'Fast Forward Labs'
	        ),
	        ' to accompany ',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://blog.fastforwardlabs.com' },
	          'our report on probabilistic programming'
	        ),
	        '. This prototype predicts future real estate prices across the New York City boroughs. It enables you to input your housing budget and shows you the probability of finding properties in that price range across different neighborhoods and future time periods.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'h3 bold' },
	        'Questions it Can Answer'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'h5 italic', style: { margin: '0.5rem 0 -0.5rem' } },
	        'Click on a link below to view the visualization of the answer. You can return to these questions by clicking the question mark in the top right corner of the sidebar.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { marginBottom: '0' } },
	        'You can use the prototype to answer questions such as:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        { style: { marginTop: '0.5rem' } },
	        _react2.default.createElement(
	          'li',
	          null,
	          'What is the probability you could have afforded a property ',
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/probability/1000000-50/2010/all_boroughs/prospect_heights' },
	            'in Prospect Heights, Brooklyn in 2010 if you had $1m dollars'
	          ),
	          '? What is it ',
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/probability/1000000-50/2016/all_boroughs/prospect_heights' },
	            'in 2016'
	          ),
	          '?'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'If you have $1.5m in 2016, ',
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/probability/1500000-50/2016/manhattan/all_neighborhoods' },
	            'in what Manhattan neighborhood are you most likely to find a property you can afford'
	          ),
	          '?'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'How much money would you need to have an reasonable (medium) probability of affording a property ',
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/price/50-1000000/2010/all_boroughs/brooklyn_heights-cobble_hill' },
	            'in Brooklyn Heights-Cobble Hill, Brooklyn in 2016'
	          ),
	          '? How about ',
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/price/50-1000000/2010/all_boroughs/west_village' },
	            'in the West Village'
	          ),
	          '?'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'In what part of Astoria, Queens are you ',
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/probability/1000000-50/2016/all_boroughs/astoria/18966' },
	            'most likely to be able to find a property for $1m in 2016'
	          ),
	          '?'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'If current trends continue, how much would you need to have a reasonable (medium) chance of affording a property ',
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/price/50-1000000/2018/all_boroughs/bedford' },
	            'in Bedford, Brooklyn in 2018'
	          ),
	          '? How does that compare to past years?'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'h3 bold', style: { marginBottom: '-0.5rem' } },
	        'Feature Overview'
	      ),
	      _react2.default.createElement('img', { src: _modeToggleSmall2.default, className: 'col-12 mt2', style: { marginTop: '1.5rem' } }),
	      _react2.default.createElement(
	        'p',
	        { className: 'h5 italic mt2', style: { marginTop: '0.5rem' } },
	        'Use the mode toggle to switch between probability and price mode.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Probability mode'
	        ),
	        ' let\'s you input a price and see the likelihood that you will be able to afford a property in a neighborhood. Switching to ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'price mode'
	        ),
	        ' lets you choose a probability (low, medium or high) and see the price required for that probability in each neighborhood. You can click on a neighborhood to see more information about the probabilities and prices. Once you have chosen a neighborhood you can get an even more detailed view by choosing a hex area within that neighborhood.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The year selector in the bottom right lets you see how probabilities and prices have changed in the past and how our model predicts they will change in the future. Note that the predictions for 2016–2018 assume that past trends continue.'
	      )
	    )
	  );
	};
	
	exports.default = Explainer;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Interpolate = __webpack_require__(15);
	
	var _SimilarNeighborhoodsList = __webpack_require__(83);
	
	var _SimilarNeighborhoodsList2 = _interopRequireDefault(_SimilarNeighborhoodsList);
	
	var _DistributionGraph = __webpack_require__(82);
	
	var _DistributionGraph2 = _interopRequireDefault(_DistributionGraph);
	
	var _YearGraph = __webpack_require__(84);
	
	var _YearGraph2 = _interopRequireDefault(_YearGraph);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HexFocus = function (_Component) {
	  _inherits(HexFocus, _Component);
	
	  function HexFocus(props, context) {
	    _classCallCheck(this, HexFocus);
	
	    var _this = _possibleConstructorReturn(this, (HexFocus.__proto__ || Object.getPrototypeOf(HexFocus)).call(this, props, context));
	
	    _this.state = {
	      toggles: {
	        probability_1_toggle: false,
	        probability_2_toggle: false,
	        price_1_toggle: false,
	        price_2_toggle: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(HexFocus, [{
	    key: 'handleToggle',
	    value: function handleToggle(target, event) {
	      this.setState({ toggles: _extends({}, this.state.toggles, _defineProperty({}, target, !this.state.toggles[target])) });
	      event.stopPropagation();
	    }
	  }, {
	    key: 'clearToggles',
	    value: function clearToggles() {
	      var clear_state = {
	        probability_1_toggle: false,
	        probability_2_toggle: false,
	        price_1_toggle: false,
	        price_2_toggle: false
	      };
	      this.setState({ toggles: clear_state });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var active_neighborhood = _props.active_neighborhood;
	      var active_mode = _props.active_mode;
	      var active_price = _props.active_price;
	      var active_year = _props.active_year;
	      var active_probability = _props.active_probability;
	      var formatters = _props.formatters;
	      var closeNeighborhoodFocus = _props.closeNeighborhoodFocus;
	      var closeHexFocus = _props.closeHexFocus;
	      var neighborhoods = _props.neighborhoods;
	      var neighborhoods_samples = _props.neighborhoods_samples;
	      var setActiveNeighborhood = _props.setActiveNeighborhood;
	      var interpolators = _props.interpolators;
	      var top_space = _props.top_space;
	      var active_hex = _props.active_hex;
	      var browser_width = _props.browser_width;
	      var toggles = this.state.toggles;
	
	
	      var prob_categories = ['High', 'Medium', 'Low'];
	      var category_step = 1 / prob_categories.length;
	
	      var getLevel = function getLevel(value) {
	        var level = '';
	        if (value < category_step) {
	          level = 'low';
	        } else if (value < category_step * 2) {
	          level = 'medium';
	        } else {
	          level = 'high';
	        }
	        return level;
	      };
	
	      var getLevelPhrase = function getLevelPhrase(value) {
	        var phrase = void 0;
	        if (value < category_step) {
	          phrase = 'a low';
	        } else if (value < category_step * 2) {
	          phrase = 'a reasonable (medium)';
	        } else {
	          phrase = 'a high';
	        }
	        return phrase;
	      };
	
	      var getProbabilityIndex = function getProbabilityIndex(value) {
	        if (value === 0.25) {
	          return 0;
	        } else if (value === 0.5) {
	          return 1;
	        } else {
	          return 2;
	        }
	      };
	
	      var getPriceText = function getPriceText(value) {
	        if (value === 0.25) {
	          return 'a low';
	        } else if (value === 0.5) {
	          return 'a medium';
	        } else {
	          return 'a high';
	        }
	      };
	
	      var handleClose = function handleClose() {
	        closeHexFocus();
	      };
	
	      var handleNeighborhoodClose = function handleNeighborhoodClose() {
	        closeHexFocus();
	        closeNeighborhoodFocus();
	      };
	
	      var addPlus = function addPlus(string) {
	        var new_string = string;
	        if (string.indexOf('-') === -1) new_string = '+' + string;
	        return new_string;
	      };
	
	      var years = [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018];
	      var year_index = years.indexOf(active_year);
	
	      var active_year_probability_price = active_hex.year_all_prices[year_index][getProbabilityIndex(active_probability)];
	
	      var focus_spacer = 16;
	
	      var focus_background = interpolators.chance(active_neighborhood.properties.probability);
	      if (active_mode !== 'Chance') {
	        focus_background = interpolators.money(active_neighborhood.properties.price / 2000000);
	      }
	
	      var hex_focus_background = interpolators.chance(active_hex.properties.probability);
	      if (active_mode !== 'Chance') {
	        hex_focus_background = interpolators.money(active_hex.properties.price / 2000000);
	      }
	
	      var mobile = false;
	      if (browser_width < 451) mobile = true;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'tnum relative fixed bg-white',
	          style: {
	            width: mobile ? '100%' : '360px',
	            top: top_space,
	            height: 'calc(100% - ' + top_space + 'px',
	            overflowY: 'auto'
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { className: '' },
	          _react2.default.createElement(
	            'div',
	            { className: 'py1 bg-transparent-fafafa fixed',
	              style: {
	                top: top_space,
	                zIndex: 11,
	                width: mobile ? '100%' : '360px',
	                background: focus_background
	              },
	              onClick: handleClose
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'uppercase relative lh1 px2 h6' },
	              'neighborhood'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'absolute center lh1 right-0 light-hover top-0 h1 Closer',
	                onClick: handleNeighborhoodClose,
	                style: {
	                  width: '3rem',
	                  height: '1.75rem',
	                  top: '0px',
	                  lineHeight: '1.75rem'
	                } },
	              '×'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'py1 bg-transparent-fafafa fixed border-top',
	              style: {
	                top: top_space + 28,
	                zIndex: 11,
	                width: mobile ? '100%' : '360px',
	                background: hex_focus_background
	              }
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'uppercase relative lh1 px2 h6' },
	              'hex'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'absolute center lh1 right-0 light-hover top-0 h1 Closer', style: {
	                  width: '3rem',
	                  height: '1.75rem',
	                  top: '0px',
	                  lineHeight: '1.75rem'
	                }, onClick: handleClose },
	              '×'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'relative mt4 px2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'relative' },
	              _react2.default.createElement(
	                'div',
	                { className: 'h3 truncate', title: active_neighborhood.properties.neighborhood },
	                'Hex ',
	                active_hex.properties.hexid
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'h5 capitalize' },
	                active_neighborhood.properties.neighborhood,
	                ', ',
	                active_neighborhood.properties.borough
	              )
	            )
	          ),
	          active_mode === 'Chance' ? _react2.default.createElement(
	            'div',
	            { className: 'tnum mt1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'px2 h4' },
	              'You would have a ',
	              getLevel(active_hex.properties.probability),
	              ' (',
	              formatters.percentFormat(active_hex.properties.probability),
	              ') probability of being able to afford a property for ',
	              formatters.dollarShort(active_price),
	              ' in ',
	              active_year,
	              '.'
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'mt1 uppercase flex space-between h6 px2' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'Price by Probability'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'py1 px2 tnum flex' },
	              active_hex.year_all_prices[year_index].map(function (price, i) {
	                return _react2.default.createElement(
	                  'div',
	                  {
	                    className: "px2 py1 col-4 center",
	                    key: i,
	                    title: getLevel(0.25 + 0.25 * i).replace(/\b\w/g, function (l) {
	                      return l.toUpperCase();
	                    }) + (' (' + formatters.percentFormat(0.25 + 0.25 * i) + ')'),
	                    style: {
	                      background: price === active_year_probability_price ? '#222' : '#efefef',
	                      color: price === active_year_probability_price ? '#fff' : '#222'
	                    }
	                  },
	                  price === active_year_probability_price ? formatters.dollarThree(price) : addPlus(formatters.dollarShort(price - active_year_probability_price).replace('$', ''))
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'px2 h5' },
	              'You would need ',
	              formatters.dollarThree(active_hex.properties.price),
	              ' to have ',
	              getLevelPhrase(active_probability),
	              ' probability you could afford a property in ',
	              active_year,
	              '.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'relative' },
	            _react2.default.createElement(
	              'div',
	              { className: 'h6 mt2 px2 uppercase' },
	              'Probability Distribution for ',
	              active_year
	            ),
	            active_mode === 'Chance' ? _react2.default.createElement(
	              'div',
	              { className: 'graph-question-holder' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: "graph-question hover no-select " + (toggles['probability_1_toggle'] ? 'active' : null),
	                  onClick: this.handleToggle.bind(this, 'probability_1_toggle')
	                },
	                '?'
	              ),
	              toggles['probability_1_toggle'] ? _react2.default.createElement(
	                'div',
	                { className: 'graph-question-tip' },
	                'This graph shows the distribution of prices for 500 samples for ' + active_hex.properties.hexid + ' in ' + active_year + ' drawn from our model. The black line is the current price of ' + formatters.dollarShort(active_price) + ', set above. The probability you would be available to afford a property is the fraction of samples to the left of the line.'
	              ) : null
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'graph-question-holder' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: "graph-question hover no-select " + (toggles['price_1_toggle'] ? 'active' : null),
	                  onClick: this.handleToggle.bind(this, 'price_1_toggle')
	                },
	                '?'
	              ),
	              toggles['price_1_toggle'] ? _react2.default.createElement(
	                'div',
	                { className: 'graph-question-tip' },
	                'This graph shows the distribution of prices for 500 samples for ' + active_hex.properties.hexid + ' in ' + active_year + ' drawn from our model. The black line is the amount required to have a ' + getLevel(active_probability) + ' (' + formatters.percentFormat(active_probability) + ') chance of being able to afford a property. This probability is the fraction of samples to the left of the line. The gray band behind the line is the range between the low (25%) and high (75%) probability.'
	              ) : null
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: '' },
	            _react2.default.createElement(_DistributionGraph2.default, {
	              active_neighborhood: active_hex,
	              active_year: active_year,
	              active_price: active_price,
	              active_mode: active_mode,
	              active_probability: active_probability,
	              interpolators: interpolators,
	              formatters: formatters
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'relative' },
	            _react2.default.createElement(
	              'div',
	              { className: 'h6 mt1 px2 uppercase' },
	              'Probability by Year'
	            ),
	            active_mode === 'Chance' ? _react2.default.createElement(
	              'div',
	              { className: 'graph-question-holder' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: "graph-question hover no-select " + (toggles['probability_2_toggle'] ? 'active' : null),
	                  onClick: this.handleToggle.bind(this, 'probability_2_toggle')
	                },
	                '?'
	              ),
	              toggles['probability_2_toggle'] ? _react2.default.createElement(
	                'div',
	                { className: 'graph-question-tip' },
	                'This graph shows the probability by year that you would be able to afford a property at ' + formatters.dollarShort(active_price) + '.'
	              ) : null
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'graph-question-holder' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: "graph-question hover no-select " + (toggles['price_2_toggle'] ? 'active' : null),
	                  onClick: this.handleToggle.bind(this, 'price_2_toggle')
	                },
	                '?'
	              ),
	              toggles['price_2_toggle'] ? _react2.default.createElement(
	                'div',
	                { className: 'graph-question-tip' },
	                'This graph shows the amount you would need to be able to afford a property by year. The gray area is the range between the a low (25%) and high (75%) probability. The black line is the currently chosen probability: ' + getLevel(active_probability) + ' (' + formatters.percentFormat(active_probability) + ').'
	              ) : null
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: '' },
	            _react2.default.createElement(_YearGraph2.default, {
	              active_neighborhood: active_hex,
	              active_mode: active_mode,
	              formatters: formatters,
	              active_year: active_year
	            })
	          ),
	          _react2.default.createElement('div', { className: 'py1' })
	        )
	      );
	    }
	  }]);
	
	  return HexFocus;
	}(_react.Component);
	
	exports.default = HexFocus;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Interpolate = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HoverInfo = function HoverInfo(_ref) {
	  var active_mode = _ref.active_mode;
	  var hover_info = _ref.hover_info;
	  var formatters = _ref.formatters;
	  var interpolators = _ref.interpolators;
	  var browser_width = _ref.browser_width;
	
	  var y_adjust = 50;
	
	  var property_display = void 0;
	  var background = void 0;
	  if (active_mode === 'Price') {
	    background = interpolators.money(hover_info.properties.price / 2000000);
	    property_display = _react2.default.createElement(
	      'div',
	      {
	        className: 'py1',
	        style: {
	          border: 'solid 1px rgba(0,0,0,0.1)',
	          background: background
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        formatters.dollarShort(hover_info.properties.price)
	      )
	    );
	  } else {
	    background = interpolators.chance(hover_info.properties.probability);
	    property_display = _react2.default.createElement(
	      'div',
	      {
	        className: 'py1',
	        style: {
	          background: background
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        formatters.percentFormat(hover_info.properties.probability)
	      )
	    );
	  }
	
	  var title = hover_info.properties.neighborhood;
	  var title_class = 'mb1';
	  if (title === undefined && hover_info.active_neighborhood) {
	    title = 'Hex ' + hover_info.properties.hexid;
	    title_class = '';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    hover_info ? _react2.default.createElement(
	      'div',
	      { id: 'HoverInfo',
	        style: {
	          left: browser_width < 801 ? hover_info.point.x - 100 : hover_info.point.x - 100 + 360,
	          top: hover_info.point.y - y_adjust,
	          lineHeight: 1
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { id: 'HoverInner', className: 'p1 border h5 center' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'truncate mb1'
	          },
	          title
	        ),
	        property_display
	      )
	    ) : null
	  );
	};
	
	exports.default = HoverInfo;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Explainer = function Explainer(_ref) {
	  var neighborhoods_samples = _ref.neighborhoods_samples;
	
	
	  var ready = false;
	  if (neighborhoods_samples) ready = true;
	
	  return _react2.default.createElement(
	    'div',
	    { className: "fixed top-0 center h6 left-0 right-0 px2 py05 white " + (ready ? 'display-none' : ''),
	      style: {
	        background: '#6c5ecc',
	        zIndex: 6,
	        fontSize: '0.75rem'
	      }
	    },
	    'Loading samples...'
	  );
	};
	
	exports.default = Explainer;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _boroughs = __webpack_require__(324);
	
	var _boroughs2 = _interopRequireDefault(_boroughs);
	
	var _neighborhood_labels = __webpack_require__(325);
	
	var _neighborhood_labels2 = _interopRequireDefault(_neighborhood_labels);
	
	var _borough_labels = __webpack_require__(323);
	
	var _borough_labels2 = _interopRequireDefault(_borough_labels);
	
	var _HoverInfo = __webpack_require__(300);
	
	var _HoverInfo2 = _interopRequireDefault(_HoverInfo);
	
	var _d3Array = __webpack_require__(19);
	
	var _turfExtent = __webpack_require__(364);
	
	var _turfExtent2 = _interopRequireDefault(_turfExtent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Map = function (_Component) {
	  _inherits(Map, _Component);
	
	  function Map(props, context) {
	    _classCallCheck(this, Map);
	
	    var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props, context));
	
	    _this.state = {
	      hover_info: false,
	      map_ready: false
	    };
	    return _this;
	  }
	
	  _createClass(Map, [{
	    key: 'getBoundingBox',
	    value: function getBoundingBox(feature) {
	      var input = {
	        "type": "FeatureCollection",
	        "features": [feature]
	      };
	      var box = (0, _turfExtent2.default)(input);
	      return box;
	    }
	  }, {
	    key: 'setHoverInfo',
	    value: function setHoverInfo(hover_info) {
	      var active_neighborhood = this.props.active_neighborhood;
	
	      if (hover_info) {
	        hover_info.active_neighborhood = active_neighborhood;
	      }
	      this.setState({
	        hover_info: hover_info
	      });
	    }
	  }, {
	    key: 'addBoroughsLayer',
	    value: function addBoroughsLayer(map) {
	      map.addSource('boroughs', {
	        type: 'geojson',
	        data: _boroughs2.default
	      }).addLayer({
	        "id": "boroughs",
	        "type": "fill",
	        "source": "boroughs",
	        "paint": {
	          "fill-color": "#eee"
	        },
	        "layout": {
	          "visibility": "none"
	        }
	      }, 'landuse_overlay_national_park');
	    }
	  }, {
	    key: 'getPaint',
	    value: function getPaint(active_mode) {
	      var price_focus = parseFloat(this.props.price_focus);
	      var paint = void 0;
	      if (active_mode === 'Chance') {
	        paint = {
	          'property': 'probability',
	          stops: [
	          // [0, '#efefef'],
	          [0, '#fff'],
	          // [0, '#d01c8b'],
	          // [0.5, '#f7f7f7'],
	          // [1, '#4dac26']
	          // [1, '#6237ea']
	          [1, '#866ff2']]
	        };
	      } else if (active_mode === 'Price') {
	        paint = {
	          'property': 'price',
	          stops: [
	          // [0,'#5e3c99'],
	          // [1000000, '#f7f7f7'],
	          [0, '#ffffff'], [2000000, '#e66101']]
	        };
	      }
	      return paint;
	    }
	  }, {
	    key: 'handleMouseLeave',
	    value: function handleMouseLeave() {
	      var map = this.props.map;
	
	      if (map) {
	        this.setHoverInfo(false);
	        if (map.getSource('hover')) {
	          map.getSource('hover').setData({
	            type: 'FeatureCollection',
	            features: []
	          });
	        }
	      }
	    }
	  }, {
	    key: 'addHoverListener',
	    value: function addHoverListener(map) {
	      var _this2 = this;
	
	      map.on('mousemove', function (e) {
	        var features = map.queryRenderedFeatures(e.point, {
	          layers: ['neighborhoods_layer']
	        });
	        var hex_features = map.queryRenderedFeatures(e.point, {
	          layers: ['hexes_layer']
	        });
	        if (hex_features.length) {
	          map.getCanvas().style.cursor = 'pointer';
	          var hex_feature = hex_features[0];
	          _this2.setHoverInfo({
	            point: e.point,
	            properties: hex_feature.properties
	          });
	          map.getSource('hover').setData({
	            type: 'FeatureCollection',
	            features: []
	          });
	          map.getSource('hex_hover').setData({
	            type: 'FeatureCollection',
	            features: [hex_feature]
	          });
	        } else if (features.length) {
	          map.getCanvas().style.cursor = 'pointer';
	          var feature = features[0];
	          var neighborhood_names = _this2.props.neighborhoods.map(function (neighborhood) {
	            return neighborhood.properties.neighborhood;
	          });
	          var feature_index = neighborhood_names.indexOf(feature.properties.neighborhood);
	          var full_feature = _this2.props.neighborhoods[feature_index];
	          _this2.setHoverInfo({
	            point: e.point,
	            properties: feature.properties
	          });
	          map.getSource('hover').setData({
	            type: 'FeatureCollection',
	            features: [full_feature]
	          });
	          map.getSource('hex_hover').setData({
	            type: 'FeatureCollection',
	            features: []
	          });
	        } else {
	          _this2.setHoverInfo(false);
	          map.getSource('hover').setData({
	            type: 'FeatureCollection',
	            features: []
	          });
	          map.getSource('hex_hover').setData({
	            type: 'FeatureCollection',
	            features: []
	          });
	        }
	      });
	      map.on('click', function (e) {
	        var features = map.queryRenderedFeatures(e.point, {
	          layers: ['neighborhoods_layer']
	        });
	        var hex_features = map.queryRenderedFeatures(e.point, {
	          layers: ['hexes_layer']
	        });
	        if (hex_features.length) {
	          var hex_feature = hex_features[0];
	          _this2.props.setActiveHex(hex_feature.properties.hexid);
	        } else if (features.length) {
	          var feature = features[0];
	          _this2.props.setActiveHex(false);
	          if (_this2.props.active_neighborhood && _this2.props.active_neighborhood.properties.neighborhood === feature.properties.neighborhood) {
	            // Already active
	          } else {
	            _this2.props.setActiveNeighborhood(feature.properties.neighborhood);
	          }
	        } else {
	          _this2.props.setActiveHex(false);
	          _this2.props.setActiveNeighborhood(false);
	        }
	      });
	    }
	  }, {
	    key: 'addNeighborhoodsLayer',
	    value: function addNeighborhoodsLayer(map, browser_width) {
	      var _props = this.props;
	      var active_year = _props.active_year;
	      var active_mode = _props.active_mode;
	      var active_neighborhood = _props.active_neighborhood;
	      var borough_filter = _props.borough_filter;
	      var active_hex = _props.active_hex;
	      var neighborhoods = _props.neighborhoods;
	
	      var paint = this.getPaint(active_mode);
	      map.addSource('neighborhoods', {
	        type: 'geojson',
	        data: {
	          "type": "FeatureCollection",
	          "features": neighborhoods
	        }
	      }).addLayer({
	        id: 'neighborhoods_layer',
	        type: 'fill',
	        source: 'neighborhoods',
	        paint: {
	          'fill-color': paint,
	          'fill-outline-color': 'rgba(255,255,255,0.25)'
	        }
	      }, 'landuse_overlay_national_park');
	      map.addSource('hover', {
	        type: 'geojson',
	        data: {
	          "type": "FeatureCollection",
	          "features": []
	        }
	      }).addLayer({
	        'id': 'hover',
	        'source': 'hover',
	        'type': 'line',
	        'paint': {
	          'line-color': '#222',
	          'line-width': {
	            "stops": [[12, 1], [14, 6]]
	          }
	        }
	      });
	      this.addHoverListener(map);
	      map.addSource('borough_labels', {
	        type: 'geojson',
	        data: _borough_labels2.default
	      }).addLayer({
	        "id": "borough_labels",
	        "type": "symbol",
	        "maxzoom": 10,
	        "source": "borough_labels",
	        "layout": {
	          "visibility": "visible",
	          "text-field": "{name}",
	          "text-size": {
	            "base": 1,
	            "stops": [[0, 8], [12, 16], [22, 30]]
	          }
	        },
	        "paint": {
	          "text-halo-color": "rgba(255,255,255,0.75)",
	          "text-halo-width": 2
	        }
	      });
	      map.addSource('hexes', {
	        type: 'geojson',
	        data: {
	          "type": "FeatureCollection",
	          "features": []
	        }
	      }).addLayer({
	        id: "hexes_layer",
	        source: "hexes",
	        type: "fill",
	        paint: {
	          'fill-color': paint,
	          'fill-outline-color': '#222'
	        }
	      }, 'landuse_overlay_national_park');
	      map.addSource('hex_hover', {
	        type: 'geojson',
	        data: {
	          "type": "FeatureCollection",
	          "features": []
	        }
	      }).addLayer({
	        'id': 'hex_hover',
	        'source': 'hex_hover',
	        'type': 'line',
	        'paint': {
	          'line-color': '#222',
	          'line-width': {
	            "stops": [[12, 1], [14, 6]]
	          }
	        }
	      });
	      map.addSource('neighborhood_labels', {
	        type: 'geojson',
	        data: _neighborhood_labels2.default
	      }).addLayer({
	        "id": "neighborhood_labels",
	        "type": "symbol",
	        "source": "neighborhood_labels",
	        "minzoom": 10,
	        "layout": {
	          "visibility": "visible",
	          "text-field": "{name}",
	          "text-size": {
	            "base": 1,
	            "stops": [[0, 8], [10, 10.5], [22, 22]]
	          }
	        },
	        "paint": {
	          "text-color": "rgba(0,0,0,0.8)",
	          "text-halo-color": "rgba(255,255,255,0.75)",
	          "text-halo-width": 1
	        }
	      });
	      map.addSource('active_borough', {
	        type: 'geojson',
	        data: {
	          "type": "FeatureCollection",
	          "features": []
	        }
	      }).addLayer({
	        'id': 'active_borough',
	        'source': 'active_borough',
	        'type': 'line',
	        'paint': {
	          'line-color': '#222',
	          'line-width': {
	            "stops": [[11, 1], [14, 4]]
	          }
	        }
	      });
	      map.addSource('active', {
	        type: 'geojson',
	        data: {
	          "type": "FeatureCollection",
	          "features": []
	        }
	      }).addLayer({
	        'id': 'active',
	        'source': 'active',
	        'type': 'line',
	        'paint': {
	          'line-color': '#222',
	          'line-width': {
	            "stops": [[11, 2], [14, 8]]
	          }
	        }
	      });
	      map.addSource('active_hex', {
	        type: 'geojson',
	        data: {
	          "type": "FeatureCollection",
	          "features": []
	        }
	      }).addLayer({
	        'id': 'active_hex',
	        'source': 'active_hex',
	        'type': 'line',
	        'paint': {
	          'line-color': '#222',
	          'line-width': {
	            "stops": [[11, 2], [14, 6]]
	          }
	        }
	      });
	      if (active_neighborhood) {
	        this.renderActiveNeighborhood(map, active_neighborhood, browser_width);
	        this.props.getNeighborhoodHexes(active_neighborhood.properties.neighborhood);
	        this.renderActiveBorough(map, borough_filter, active_neighborhood);
	      } else if (borough_filter) {
	        this.renderActiveBorough(map, borough_filter, active_neighborhood);
	      } else {
	        var nyc_bounds = [[-74.27643833007856, 40.48198566721396], [-73.65160461861605, 40.92793497349999]];
	        map.fitBounds(nyc_bounds, { padding: 0 });
	      }
	    }
	  }, {
	    key: 'renderHexes',
	    value: function renderHexes(map, hexes) {
	      if (hexes) {
	        map.getSource('hexes').setData({
	          type: 'FeatureCollection',
	          features: hexes
	        });
	      } else {
	        map.getSource('hexes').setData({
	          type: 'FeatureCollection',
	          features: []
	        });
	      }
	    }
	  }, {
	    key: 'renderActiveBorough',
	    value: function renderActiveBorough(map, borough_filter, active_neighborhood) {
	      if (borough_filter) {
	        var borough_names = _boroughs2.default.features.map(function (borough) {
	          return borough.properties.borough;
	        });
	        var borough_index = borough_names.indexOf(borough_filter);
	        var borough_feature = _boroughs2.default.features[borough_index];
	        map.getSource('active_borough').setData({
	          type: 'FeatureCollection',
	          features: [borough_feature]
	        });
	        var input = {
	          "type": "FeatureCollection",
	          "features": [borough_feature]
	        };
	        if (!active_neighborhood) {
	          var box = (0, _turfExtent2.default)(input);
	          map.fitBounds(box, { padding: 100 });
	        }
	      } else {
	        map.getSource('active_borough').setData({
	          type: 'FeatureCollection',
	          features: []
	        });
	        if (!active_neighborhood) {
	          var nyc_bounds = [[-74.27643833007856, 40.48198566721396], [-73.65160461861605, 40.92793497349999]];
	          map.fitBounds(nyc_bounds, { padding: 0 });
	        }
	      }
	    }
	  }, {
	    key: 'renderActiveNeighborhood',
	    value: function renderActiveNeighborhood(map, active_neighborhood, browser_width) {
	      if (active_neighborhood) {
	        map.getSource('active').setData({
	          type: 'FeatureCollection',
	          features: [active_neighborhood]
	        });
	        var box = this.getBoundingBox(active_neighborhood);
	        if (browser_width < 451) {
	          map.fitBounds(box, { padding: 20 });
	        } else if (browser_width < 1000) {
	          map.fitBounds(box, { padding: 100 });
	        } else {
	          map.fitBounds(box, { padding: 200 });
	        }
	      } else {
	        map.getSource('active').setData({
	          type: 'FeatureCollection',
	          features: []
	        });
	        var nyc_bounds = [[-74.27643833007856, 40.48198566721396], [-73.65160461861605, 40.92793497349999]];
	        map.fitBounds(nyc_bounds, { padding: 0 });
	      }
	    }
	  }, {
	    key: 'renderActiveHex',
	    value: function renderActiveHex(map, active_hex) {
	      if (active_hex) {
	        map.getSource('active_hex').setData({
	          type: 'FeatureCollection',
	          features: [active_hex]
	        });
	      } else {
	        map.getSource('active_hex').setData({
	          type: 'FeatureCollection',
	          features: []
	        });
	      }
	    }
	  }, {
	    key: 'changeStyle',
	    value: function changeStyle(map, show_roads) {
	      if (show_roads) {
	        map.setLayoutProperty('road_major_label', 'visibility', 'visible');
	        map.setLayoutProperty('road_major', 'visibility', 'visible');
	        map.setLayoutProperty('road_minor', 'visibility', 'visible');
	        map.setLayoutProperty('water', 'visibility', 'visible');
	        map.setLayoutProperty('waterway', 'visibility', 'visible');
	        map.setLayoutProperty('landuse_park', 'visibility', 'visible');
	        map.setLayoutProperty('landuse_overlay_national_park', 'visibility', 'visible');
	        map.setLayoutProperty('boroughs', 'visibility', 'none');
	        map.setPaintProperty('background', 'background-color', '#fafafa');
	      } else {
	        map.setLayoutProperty('road_major_label', 'visibility', 'none');
	        map.setLayoutProperty('road_major', 'visibility', 'none');
	        map.setLayoutProperty('road_minor', 'visibility', 'none');
	        map.setLayoutProperty('water', 'visibility', 'none');
	        map.setLayoutProperty('waterway', 'visibility', 'none');
	        map.setLayoutProperty('landuse_park', 'visibility', 'none');
	        map.setLayoutProperty('landuse_overlay_national_park', 'visibility', 'none');
	        map.setLayoutProperty('landuse_overlay_national_park', 'visibility', 'none');
	        map.setLayoutProperty('boroughs', 'visibility', 'visible');
	        map.setPaintProperty('background', 'background-color', '#ddd');
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var _props2 = this.props;
	      var active_year = _props2.active_year;
	      var active_neighborhood = _props2.active_neighborhood;
	      var neighborhoods = _props2.neighborhoods;
	      var show_roads = _props2.show_roads;
	      var neighborhoods_samples = _props2.neighborhoods_samples;
	
	      mapboxgl.accessToken = 'pk.eyJ1IjoiZ3JhbnRjdXN0ZXIiLCJhIjoicWt3cWdQYyJ9.BK1_BsLvjxlLULMdWCnQuA';
	      ;
	      var style = 'mapbox://styles/grantcuster/cixrnpgmo000p2rkl0razqdxw';
	      if (show_roads) style = 'mapbox://styles/grantcuster/cipu6plcg0003bpmb5hq7ofro';
	      var map = new mapboxgl.Map({
	        container: 'Map',
	        style: style,
	        center: [-73.94616184082079, 40.710718089480224],
	        zoom: 9,
	        maxZoom: 15,
	        bearing: 0,
	        attributionControl: false,
	        maxBounds: [[-74.94, 40.11], [-72.94, 41.31]]
	      }).on('load', function () {
	        _this3.props.mapLoaded(map);
	        map.addControl(new mapboxgl.NavigationControl({ position: 'top-right' }));
	        map.addControl(new mapboxgl.AttributionControl());
	        _this3.addBoroughsLayer(map);
	        _this3.props.getNeighborhoodsSamples(active_year);
	      });
	      map.dragRotate.disable();
	      map.touchZoomRotate.disableRotation();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var p_neighborhoods_samples = prevProps.neighborhoods_samples;
	      var p_active_mode = prevProps.active_mode;
	      var p_active_price = prevProps.active_price;
	      var p_active_year = prevProps.active_year;
	      var p_active_probability = prevProps.active_probability;
	      var p_active_neighborhood = prevProps.active_neighborhood;
	      var p_hexes = prevProps.hexes;
	      var p_active_hex = prevProps.active_hex;
	      var p_show_roads = prevProps.show_roads;
	      var p_borough_filter = prevProps.borough_filter;
	      var _props3 = this.props;
	      var map = _props3.map;
	      var neighborhoods_samples = _props3.neighborhoods_samples;
	      var neighborhoods = _props3.neighborhoods;
	      var active_mode = _props3.active_mode;
	      var active_price = _props3.active_price;
	      var active_year = _props3.active_year;
	      var active_probability = _props3.active_probability;
	      var active_neighborhood = _props3.active_neighborhood;
	      var hexes = _props3.hexes;
	      var active_hex = _props3.active_hex;
	      var show_roads = _props3.show_roads;
	      var browser_width = _props3.browser_width;
	      var borough_filter = _props3.borough_filter;
	      // Init neighborhoods (add the layer) the first time we get them
	
	      if (p_neighborhoods_samples === false && neighborhoods_samples !== false) {
	        this.addNeighborhoodsLayer(map, browser_width);
	      }
	      if (neighborhoods_samples) {
	        // Change paint on mode change
	        if (p_active_mode !== active_mode) {
	          var paint = this.getPaint(active_mode);
	          map.setPaintProperty('neighborhoods_layer', 'fill-color', paint);
	          map.setPaintProperty('hexes_layer', 'fill-color', paint);
	        }
	        if (p_active_mode !== active_mode || p_active_price !== active_price || p_active_probability !== active_probability || p_active_year !== active_year) {
	          map.getSource('neighborhoods').setData({
	            type: 'FeatureCollection',
	            features: neighborhoods
	          });
	        }
	      }
	      if (p_active_neighborhood !== active_neighborhood) {
	        if (active_neighborhood) {
	          this.props.getNeighborhoodHexes(active_neighborhood.properties.neighborhood);
	        }
	        this.renderActiveNeighborhood(map, active_neighborhood, browser_width);
	      }
	      var mobile = false;
	      if (browser_width < 451) mobile = true;
	      if (p_hexes !== hexes) {
	        this.renderHexes(map, hexes);
	        if (active_hex) {
	          this.renderActiveHex(map, active_hex);
	        }
	      }
	      if (p_active_hex !== active_hex) {
	        this.renderActiveHex(map, active_hex);
	      }
	      if (p_show_roads !== show_roads) {
	        this.changeStyle(map, show_roads);
	      }
	      if (p_borough_filter !== borough_filter) {
	        this.renderActiveBorough(map, borough_filter, active_neighborhood);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props;
	      var map = _props4.map;
	      var neighborhoods = _props4.neighborhoods;
	      var formatters = _props4.formatters;
	      var active_mode = _props4.active_mode;
	      var interpolators = _props4.interpolators;
	      var browser_width = _props4.browser_width;
	      var hover_info = this.state.hover_info;
	
	      var mobile = false;
	      if (browser_width < 451) mobile = true;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { id: 'Map', onMouseLeave: this.handleMouseLeave.bind(this) }),
	        map && hover_info && !mobile ? _react2.default.createElement(_HoverInfo2.default, {
	          active_mode: active_mode,
	          hover_info: hover_info,
	          formatters: formatters,
	          interpolators: interpolators,
	          browser_width: browser_width
	        }) : null
	      );
	    }
	  }]);
	
	  return Map;
	}(_react.Component);
	
	exports.default = Map;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModeChanger = function ModeChanger(_ref) {
	  var active_mode = _ref.active_mode;
	  var changeActiveMode = _ref.changeActiveMode;
	
	
	  var modes = ['Price', 'Chance'];
	
	  var handleOnChange = function handleOnChange(e) {
	    changeActiveMode(e.target.value);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'flex' },
	      modes.map(function (mode) {
	        return _react2.default.createElement(
	          'div',
	          { key: mode, className: 'col-6 center' },
	          _react2.default.createElement(
	            'label',
	            null,
	            _react2.default.createElement('input', {
	              type: 'radio',
	              name: 'mode',
	              value: mode,
	              onChange: handleOnChange.bind(undefined),
	              checked: mode === active_mode
	            }),
	            ' ',
	            mode
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = ModeChanger;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Interpolate = __webpack_require__(15);
	
	var _SimilarNeighborhoodsList = __webpack_require__(83);
	
	var _SimilarNeighborhoodsList2 = _interopRequireDefault(_SimilarNeighborhoodsList);
	
	var _DistributionGraph = __webpack_require__(82);
	
	var _DistributionGraph2 = _interopRequireDefault(_DistributionGraph);
	
	var _YearGraph = __webpack_require__(84);
	
	var _YearGraph2 = _interopRequireDefault(_YearGraph);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NeighborhoodFocus = function (_Component) {
	  _inherits(NeighborhoodFocus, _Component);
	
	  function NeighborhoodFocus(props, context) {
	    _classCallCheck(this, NeighborhoodFocus);
	
	    var _this = _possibleConstructorReturn(this, (NeighborhoodFocus.__proto__ || Object.getPrototypeOf(NeighborhoodFocus)).call(this, props, context));
	
	    _this.state = {
	      toggles: {
	        probability_1_toggle: false,
	        probability_2_toggle: false,
	        price_1_toggle: false,
	        price_2_toggle: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(NeighborhoodFocus, [{
	    key: 'handleToggle',
	    value: function handleToggle(target, event) {
	      this.setState({ toggles: _extends({}, this.state.toggles, _defineProperty({}, target, !this.state.toggles[target])) });
	      event.stopPropagation();
	    }
	  }, {
	    key: 'clearToggles',
	    value: function clearToggles() {
	      var clear_state = {
	        probability_1_toggle: false,
	        probability_2_toggle: false,
	        price_1_toggle: false,
	        price_2_toggle: false
	      };
	      this.setState({ toggles: clear_state });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var active_neighborhood = _props.active_neighborhood;
	      var active_mode = _props.active_mode;
	      var active_price = _props.active_price;
	      var active_year = _props.active_year;
	      var active_probability = _props.active_probability;
	      var formatters = _props.formatters;
	      var closeNeighborhoodFocus = _props.closeNeighborhoodFocus;
	      var neighborhoods = _props.neighborhoods;
	      var neighborhoods_samples = _props.neighborhoods_samples;
	      var setActiveNeighborhood = _props.setActiveNeighborhood;
	      var interpolators = _props.interpolators;
	      var top_space = _props.top_space;
	      var browser_width = _props.browser_width;
	      var toggles = this.state.toggles;
	
	      var prob_categories = ['High', 'Medium', 'Low'];
	      var category_step = 1 / prob_categories.length;
	
	      var getLevel = function getLevel(value) {
	        var level = '';
	        if (value < category_step) {
	          level = 'low';
	        } else if (value < category_step * 2) {
	          level = 'medium';
	        } else {
	          level = 'high';
	        }
	        return level;
	      };
	
	      var getLevelPhrase = function getLevelPhrase(value) {
	        var phrase = void 0;
	        if (value < category_step) {
	          phrase = 'a low';
	        } else if (value < category_step * 2) {
	          phrase = 'a reasonable (medium)';
	        } else {
	          phrase = 'a high';
	        }
	        return phrase;
	      };
	
	      var getProbabilityIndex = function getProbabilityIndex(value) {
	        if (value === 0.25) {
	          return 0;
	        } else if (value === 0.5) {
	          return 1;
	        } else {
	          return 2;
	        }
	      };
	
	      var getPriceText = function getPriceText(value) {
	        if (value === 0.25) {
	          return 'a low';
	        } else if (value === 0.5) {
	          return 'a medium';
	        } else {
	          return 'a high';
	        }
	      };
	
	      var handleClose = function handleClose() {
	        closeNeighborhoodFocus();
	      };
	
	      var addPlus = function addPlus(string) {
	        var new_string = string;
	        if (string.indexOf('-') === -1) new_string = '+' + string;
	        return new_string;
	      };
	
	      var years = [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018];
	      var year_index = years.indexOf(active_year);
	
	      var active_year_probability_price = active_neighborhood.year_all_prices[year_index][getProbabilityIndex(active_probability)];
	
	      var focus_spacer = 16;
	
	      var focus_background = interpolators.chance(active_neighborhood.properties.probability);
	      if (active_mode !== 'Chance') {
	        focus_background = interpolators.money(active_neighborhood.properties.price / 2000000);
	      }
	
	      var mobile = false;
	      if (browser_width < 451) mobile = true;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'tnum relative bg-white fixed',
	          onClick: this.clearToggles.bind(this),
	          style: {
	            width: mobile ? '100%' : '360px',
	            top: top_space,
	            height: 'calc(100% - ' + top_space + 'px',
	            overflowY: 'auto'
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { className: '',
	            style: {
	              paddingBottom: mobile ? '4rem' : '0'
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'py1 fixed',
	              style: {
	                top: top_space,
	                zIndex: 11,
	                width: mobile ? '100%' : '360px',
	                background: focus_background
	              }
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'uppercase relative lh1 px2 h6' },
	              'neighborhood'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'absolute center lh1 right-0 light-hover top-0 h1 Closer', style: {
	                  width: '3rem',
	                  height: '1.75rem',
	                  top: '0px',
	                  lineHeight: '1.75rem'
	                }, onClick: handleClose },
	              '×'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'relative mt4 px2',
	              style: {
	                marginTop: '2.25rem'
	              }
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'relative' },
	              _react2.default.createElement(
	                'div',
	                { className: 'h3 truncate', title: active_neighborhood.properties.neighborhood },
	                active_neighborhood.properties.neighborhood
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'h5 capitalize' },
	                active_neighborhood.properties.borough
	              )
	            )
	          ),
	          active_mode === 'Chance' ? _react2.default.createElement(
	            'div',
	            { className: 'tnum mt1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'px2 h4' },
	              'You would have a ',
	              getLevel(active_neighborhood.properties.probability),
	              ' (',
	              formatters.percentFormat(active_neighborhood.properties.probability),
	              ') probability of being able to afford a property for ',
	              formatters.dollarShort(active_price),
	              ' in ',
	              active_year,
	              '.'
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'mt1 uppercase flex space-between h6 px2' },
	              _react2.default.createElement(
	                'div',
	                null,
	                'Price by Probability'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'py1 px2 tnum flex' },
	              active_neighborhood.year_all_prices[year_index].map(function (price, i) {
	                return _react2.default.createElement(
	                  'div',
	                  {
	                    className: "px2 py1 col-4 center",
	                    key: i,
	                    title: getLevel(0.25 + 0.25 * i).replace(/\b\w/g, function (l) {
	                      return l.toUpperCase();
	                    }) + (' (' + formatters.percentFormat(0.25 + 0.25 * i) + ')'),
	                    style: {
	                      background: price === active_year_probability_price ? '#222' : '#efefef',
	                      color: price === active_year_probability_price ? '#fff' : '#222'
	                    }
	                  },
	                  price === active_year_probability_price ? formatters.dollarThree(price) : addPlus(formatters.dollarShort(price - active_year_probability_price).replace('$', ''))
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'px2 h5' },
	              'You would need ',
	              formatters.dollarThree(active_neighborhood.properties.price),
	              ' to have ',
	              getLevelPhrase(active_probability),
	              ' probability you could afford a property in ',
	              active_year,
	              '.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'relative' },
	            _react2.default.createElement(
	              'div',
	              { className: 'h6 mt2 px2 uppercase' },
	              'Probability Distribution for ',
	              active_year,
	              active_mode === 'Chance' ? _react2.default.createElement(
	                'div',
	                { className: 'graph-question-holder' },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: "graph-question hover no-select " + (toggles['probability_1_toggle'] ? 'active' : null),
	                    onClick: this.handleToggle.bind(this, 'probability_1_toggle')
	                  },
	                  '?'
	                ),
	                toggles['probability_1_toggle'] ? _react2.default.createElement(
	                  'div',
	                  { className: 'graph-question-tip' },
	                  'This graph shows the distribution of prices for 500 samples for ' + active_neighborhood.properties.neighborhood + ' in ' + active_year + ' drawn from our model. The black line is the current price of ' + formatters.dollarShort(active_price) + ', set above. The probability you would be available to afford a property is the fraction of samples to the left of the line.'
	                ) : null
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'graph-question-holder' },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: "graph-question hover no-select " + (toggles['price_1_toggle'] ? 'active' : null),
	                    onClick: this.handleToggle.bind(this, 'price_1_toggle')
	                  },
	                  '?'
	                ),
	                toggles['price_1_toggle'] ? _react2.default.createElement(
	                  'div',
	                  { className: 'graph-question-tip' },
	                  'This graph shows the distribution of prices for 500 samples for ' + active_neighborhood.properties.neighborhood + ' in ' + active_year + ' drawn from our model. The black line is the amount required to have a ' + getLevel(active_probability) + ' (' + formatters.percentFormat(active_probability) + ') chance of being able to afford a property. This probability is the fraction of samples to the left of the line. The gray band behind the line is the range between the low (25%) and high (75%) probability.'
	                ) : null
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: '' },
	            _react2.default.createElement(_DistributionGraph2.default, {
	              active_neighborhood: active_neighborhood,
	              active_year: active_year,
	              active_price: active_price,
	              active_mode: active_mode,
	              active_probability: active_probability,
	              interpolators: interpolators,
	              formatters: formatters,
	              browser_width: browser_width
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'relative' },
	            _react2.default.createElement(
	              'div',
	              { className: 'h6 mt1 px2 uppercase' },
	              'Probability by Year',
	              active_mode === 'Chance' ? _react2.default.createElement(
	                'div',
	                { className: 'graph-question-holder' },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: "graph-question hover no-select " + (toggles['probability_2_toggle'] ? 'active' : null),
	                    onClick: this.handleToggle.bind(this, 'probability_2_toggle')
	                  },
	                  '?'
	                ),
	                toggles['probability_2_toggle'] ? _react2.default.createElement(
	                  'div',
	                  { className: 'graph-question-tip' },
	                  'This graph shows the probability by year that you would be able to afford a property at ' + formatters.dollarShort(active_price) + '.'
	                ) : null
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'graph-question-holder' },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: "graph-question hover no-select " + (toggles['price_2_toggle'] ? 'active' : null),
	                    onClick: this.handleToggle.bind(this, 'price_2_toggle')
	                  },
	                  '?'
	                ),
	                toggles['price_2_toggle'] ? _react2.default.createElement(
	                  'div',
	                  { className: 'graph-question-tip' },
	                  'This graph shows the amount you would need to be able to afford a property by year. The gray area is the range between the a low (25%) and high (75%) probability. The black line is the currently chosen probability: ' + getLevel(active_probability) + ' (' + formatters.percentFormat(active_probability) + ').'
	                ) : null
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: '' },
	            _react2.default.createElement(_YearGraph2.default, {
	              active_neighborhood: active_neighborhood,
	              active_mode: active_mode,
	              formatters: formatters,
	              active_year: active_year,
	              browser_width: browser_width
	            })
	          ),
	          _react2.default.createElement('div', { className: 'py1' })
	        )
	      );
	    }
	  }]);
	
	  return NeighborhoodFocus;
	}(_react.Component);
	
	exports.default = NeighborhoodFocus;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Interpolate = __webpack_require__(15);
	
	var _SimilarNeighborhoodsList = __webpack_require__(83);
	
	var _SimilarNeighborhoodsList2 = _interopRequireDefault(_SimilarNeighborhoodsList);
	
	var _DistributionGraph = __webpack_require__(82);
	
	var _DistributionGraph2 = _interopRequireDefault(_DistributionGraph);
	
	var _YearGraph = __webpack_require__(84);
	
	var _YearGraph2 = _interopRequireDefault(_YearGraph);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NeighborhoodFocus2 = function NeighborhoodFocus2(_ref) {
	  var active_neighborhood = _ref.active_neighborhood;
	  var active_mode = _ref.active_mode;
	  var active_price = _ref.active_price;
	  var active_year = _ref.active_year;
	  var active_probability = _ref.active_probability;
	  var formatters = _ref.formatters;
	  var closeNeighborhoodFocus = _ref.closeNeighborhoodFocus;
	  var neighborhoods = _ref.neighborhoods;
	  var neighborhoods_samples = _ref.neighborhoods_samples;
	  var setActiveNeighborhood = _ref.setActiveNeighborhood;
	  var interpolators = _ref.interpolators;
	
	
	  var handleClose = function handleClose() {
	    closeNeighborhoodFocus();
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: '' },
	    _react2.default.createElement(
	      'div',
	      { className: 'px2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'relative' },
	        _react2.default.createElement(
	          'div',
	          { className: 'absolute right-0 top-0 h1 Closer', onClick: handleClose },
	          '×'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'h3 truncate', title: active_neighborhood.properties.neighborhood },
	        active_neighborhood.properties.neighborhood
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'capitalize' },
	        active_neighborhood.properties.borough
	      ),
	      active_mode === 'Chance' ? _react2.default.createElement(
	        'div',
	        {
	          className: 'p1 mt1 center',
	          style: { background: interpolators.chance(active_neighborhood.properties.probability) }
	        },
	        formatters.percentFormat(active_neighborhood.properties.probability)
	      ) : _react2.default.createElement(
	        'div',
	        {
	          className: 'p1 mt1 center'
	        },
	        formatters.dollarShort(active_neighborhood.properties.price)
	      )
	    )
	  );
	};
	
	exports.default = NeighborhoodFocus2;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PriceChanger = function PriceChanger(_ref) {
	  var active_price = _ref.active_price;
	  var changeActivePrice = _ref.changeActivePrice;
	  var formatters = _ref.formatters;
	
	
	  var handleOnChange = function handleOnChange(e) {
	    changeActivePrice(e.target.value);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "col-12 px2" },
	    _react2.default.createElement(
	      "div",
	      null,
	      "Price: ",
	      formatters.dollarShort(active_price)
	    ),
	    _react2.default.createElement("input", { className: "col-12", type: "range", min: "0", max: "4000000", step: "100000", value: active_price, onChange: handleOnChange.bind(undefined) }),
	    _react2.default.createElement("div", { className: "mt1 border-bottom" })
	  );
	};
	
	exports.default = PriceChanger;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PriceFocusChanger = function PriceFocusChanger(_ref) {
	  var price_focus = _ref.price_focus;
	  var changePriceFocus = _ref.changePriceFocus;
	  var formatters = _ref.formatters;
	
	
	  var handleOnChange = function handleOnChange(e) {
	    changePriceFocus(e.target.value);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "col-12 mt2"
	    },
	    _react2.default.createElement(
	      "div",
	      { className: "px2" },
	      "Price Focus: ",
	      formatters.dollarShort(price_focus)
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "",
	        style: { background: 'linear-gradient(90deg, #5e3c99, #f7f7f7 50%, #e66101)' }
	      },
	      _react2.default.createElement("input", { className: "col-12", type: "range", min: "100000", max: "2000000", step: "100000", value: price_focus, onChange: handleOnChange.bind(undefined) })
	    )
	  );
	};
	
	exports.default = PriceFocusChanger;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Interpolate = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PriceNeighborhoodList = function PriceNeighborhoodList(_ref) {
	  var neighborhoods = _ref.neighborhoods;
	  var price_focus = _ref.price_focus;
	  var formatters = _ref.formatters;
	
	  var interpolate = function interpolate(value) {
	    if (value < 0.5) {
	      return (0, _d3Interpolate.interpolateRgb)('#5e3c99', '#f7f7f7')(value * 2);
	    } else if (value > 1) {
	      return '#e66101';
	    } else {
	      return (0, _d3Interpolate.interpolateRgb)('#f7f7f7', '#e66101')((value - 0.5) * 2);
	    }
	  };
	  var top_neighborhoods = [];
	  var bottom_neighborhoods = [];
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = neighborhoods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var neighborhood = _step.value;
	
	      if (neighborhood.properties.price / 2000000 < price_focus / 2000000) {
	        bottom_neighborhoods.push(neighborhood);
	      } else {
	        top_neighborhoods.push(neighborhood);
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  top_neighborhoods.reverse();
	
	  var neighborhood_item = function neighborhood_item(neighborhood) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'clearfix SideListItem tnum h6 col-12 px1',
	        key: neighborhood.properties.neighborhood,
	        style: { background: interpolate(neighborhood.properties.price / 2000000) }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'relative' },
	        _react2.default.createElement(
	          'div',
	          { className: '' },
	          neighborhood.properties.neighborhood,
	          ', ',
	          _react2.default.createElement(
	            'span',
	            { className: 'capitalize' },
	            neighborhood.properties.borough
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'absolute right-0 top-0' },
	          formatters.dollarShort(neighborhood.properties.price)
	        )
	      )
	    );
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-6' },
	      _react2.default.createElement(
	        'div',
	        { className: 'h5 px1' },
	        'Below (',
	        bottom_neighborhoods.length,
	        ')'
	      ),
	      bottom_neighborhoods.map(function (neighborhood) {
	        return neighborhood_item(neighborhood);
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-6' },
	      _react2.default.createElement(
	        'div',
	        { className: 'h5 px1' },
	        'Above (',
	        top_neighborhoods.length,
	        ')'
	      ),
	      top_neighborhoods.map(function (neighborhood) {
	        return neighborhood_item(neighborhood);
	      })
	    )
	  );
	};
	
	exports.default = PriceNeighborhoodList;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProbabilityFocusChanger = function ProbabilityFocusChanger(_ref) {
	  var probability_focus = _ref.probability_focus;
	  var changeProbabilityFocus = _ref.changeProbabilityFocus;
	  var formatters = _ref.formatters;
	
	
	  var handleOnChange = function handleOnChange(e) {
	    changeProbabilityFocus(e.target.value);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "col-12 mt2" },
	    _react2.default.createElement(
	      "div",
	      { className: "px2" },
	      "Probability Focus: ",
	      formatters.percentFormat(probability_focus)
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "",
	        style: { background: 'linear-gradient(90deg, #d01c8b, #f7f7f7 50%, #4dac26)' }
	      },
	      _react2.default.createElement("input", { className: "col-12", type: "range", min: "0", max: "1", step: "0.1", value: probability_focus, onChange: handleOnChange.bind(undefined) })
	    )
	  );
	};
	
	exports.default = ProbabilityFocusChanger;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuestionPrice = function QuestionPrice(_ref) {
	  var active_price = _ref.active_price;
	  var changeActivePrice = _ref.changeActivePrice;
	  var formatters = _ref.formatters;
	
	
	  var price_range = {
	    max: 8000000,
	    min: 0,
	    step_thresh: 2000000,
	    steps: [100000, 1000000]
	  };
	
	  var price_counter = price_range.min;
	  var price_range_array = [];
	  while (price_counter <= price_range.max) {
	    price_range_array.push(price_counter);
	    if (price_counter < price_range.step_thresh) {
	      price_counter += price_range.steps[0];
	    } else {
	      price_counter += price_range.steps[1];
	    }
	  }
	
	  var handleChange = function handleChange(e) {
	    changeActivePrice(e.target.value);
	  };
	
	  var handleCrement = function handleCrement(type) {
	    var current_index = price_range_array.indexOf(active_price);
	    var next_price = void 0;
	    if (type === 'increment') {
	      next_price = price_range_array[current_index + 1];
	      if (!next_price) next_price = price_range.max;
	    } else {
	      next_price = price_range_array[current_index - 1];
	      if (!next_price) next_price = price_range.min;
	    }
	    changeActivePrice(next_price);
	  };
	
	  var handlePriceContainerClick = function handlePriceContainerClick(e) {
	    // TDOD hard coding with here is probably a bad idea
	    var x = e.clientX;
	    var width = 326;
	    var x_ratio = x / width;
	    var sim_price = Math.round(x_ratio * price_range.max);
	    var first_above_i = void 0;
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = price_range_array.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var _step$value = _slicedToArray(_step.value, 2);
	
	        var i = _step$value[0];
	        var price = _step$value[1];
	
	        if (price > sim_price) {
	          first_above_i = i;
	          break;
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    var above = price_range_array[first_above_i];
	    var below = price_range_array[first_above_i - 1];
	    var above_diff = above - sim_price;
	    var below_diff = sim_price - below;
	    var new_i = void 0;
	    if (below_diff < above_diff) {
	      new_i = first_above_i - 1;
	    } else {
	      new_i = first_above_i;
	    }
	    var new_price = price_range_array[new_i];
	    changeActivePrice(new_price);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'py1 px2' },
	      'Where can I buy a property for'
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'PriceNumberContainer relative'
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'PriceContainer no-select border relative tnum py1',
	          onClick: handlePriceContainerClick.bind(undefined),
	          style: {
	            cursor: 'ew-resize',
	            paddingTop: '0.5rem',
	            paddingBottom: '0.5rem'
	          }
	        },
	        _react2.default.createElement('div', { className: 'PriceBar absolute left-0 top-0 height-100',
	          style: { background: '#fafafa', width: Math.round(active_price / price_range.max * 100) + '%' }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'PriceDisplayer relative center px2 h1' },
	          formatters.dollarFormat(active_price)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'PriceControls absolute right-0 h6 top-0 border-top border-bottom height-100'
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            onClick: handleCrement.bind(undefined, 'increment'),
	            className: 'PriceControl no-select absolute right-0 height-50 top-0 flex flex-align-center justify-center pointer col-12 border-bottom' },
	          '▲'
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            onClick: handleCrement.bind(undefined, 'decrement'),
	            className: 'PriceControl no-select absolute right-0 height-50 bottom-0 flex flex-align-center justify-center pointer col-12' },
	          '▼'
	        )
	      )
	    )
	  );
	};
	
	exports.default = QuestionPrice;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoroughFilter = __webpack_require__(81);
	
	var _BoroughFilter2 = _interopRequireDefault(_BoroughFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuestionPriceList = function QuestionPriceList(_ref) {
	  var neighborhoods = _ref.neighborhoods;
	  var interpolators = _ref.interpolators;
	  var formatters = _ref.formatters;
	  var changeProbabilityFocus = _ref.changeProbabilityFocus;
	  var probability_focus = _ref.probability_focus;
	  var setActiveNeighborhood = _ref.setActiveNeighborhood;
	  var top_space = _ref.top_space;
	  var borough_filter = _ref.borough_filter;
	  var setBoroughFilter = _ref.setBoroughFilter;
	  var browser_width = _ref.browser_width;
	
	
	  var prob_categories = ['Low', 'Medium', 'High'];
	  var prob_categories_title = ['0-33%', '33-66%', '66-100%'];
	  var category_step = 1 / prob_categories.length;
	
	  var prob_focus_index = false;
	  if (probability_focus) prob_focus_index = Math.round(probability_focus * prob_categories.length - 1);
	
	  var handleFocusClick = function handleFocusClick(value) {
	    if (value === probability_focus) {
	      changeProbabilityFocus(false);
	    } else {
	      changeProbabilityFocus(value);
	    }
	  };
	
	  var handleNeighborhoodClick = function handleNeighborhoodClick(neighborhood) {
	    setActiveNeighborhood(neighborhood.properties.neighborhood);
	  };
	
	  var neighborhood_item = function neighborhood_item(neighborhood) {
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'SideListItem h5 hover relative flex pointer',
	        onClick: handleNeighborhoodClick.bind(undefined, neighborhood),
	        style: {
	          background: interpolators.chance(neighborhood.properties.probability)
	        },
	        key: neighborhood.properties.neighborhood
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'relative small-caps center',
	          style: {
	            width: '1.5rem',
	            color: 'rgba(0,0,0,0.5)'
	          }
	        },
	        formatters.borough_abbreviations[neighborhood.properties.borough]
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'space-between flex grow-1' },
	        _react2.default.createElement(
	          'div',
	          { className: '',
	            style: {
	              paddingLeft: '0.25rem'
	            }
	          },
	          neighborhood.properties.neighborhood
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: '' },
	          formatters.percentFormat(neighborhood.properties.probability)
	        )
	      )
	    );
	  };
	
	  // TODO: this should be cleaned up
	  var poor_array = [];
	  var good_array = [];
	  var great_array = [];
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = neighborhoods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var neighborhood = _step.value;
	
	      if (neighborhood.properties.probability < 0.33) {
	        poor_array.push(neighborhood);
	      } else if (neighborhood.properties.probability < 0.66) {
	        good_array.push(neighborhood);
	      } else {
	        great_array.push(neighborhood);
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  var chance_arrays = [poor_array, good_array, great_array];
	
	  var focus_index = false;
	  var filtered_neighborhoods = neighborhoods;
	  if (probability_focus) {
	    focus_index = Math.round(probability_focus / category_step);
	    filtered_neighborhoods = neighborhoods.filter(function (neighborhood) {
	      return neighborhood.properties.probability <= probability_focus && neighborhood.properties.probability > probability_focus - category_step ? true : false;
	    });
	  }
	
	  var bar_height = 202;
	
	  var mobile = false;
	  if (browser_width < 451) mobile = true;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'no-select' },
	    _react2.default.createElement(
	      'div',
	      { style: { paddingTop: bar_height } },
	      _react2.default.createElement(
	        'div',
	        { className: 'fixed top-left bg-white',
	          style: {
	            top: top_space,
	            width: mobile ? '100%' : '360px',
	            zIndex: '9'
	          }
	        },
	        _react2.default.createElement(_BoroughFilter2.default, {
	          borough_filter: borough_filter,
	          setBoroughFilter: setBoroughFilter
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'h6 mt1 px2 flex space-between uppercase' },
	          'Filter List by Probability',
	          probability_focus ? _react2.default.createElement(
	            'div',
	            { className: 'pointer blue hover-underline', onClick: handleFocusClick.bind(undefined, false) },
	            'Clear Filter'
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex mt1 h5' },
	          prob_categories.map(function (name, i) {
	            return _react2.default.createElement(
	              'div',
	              {
	                title: prob_categories_title[i],
	                className: "ProbFilterItem hover flex space-between relative px2 pointer py1 " + (i === prob_focus_index ? 'active' : ''),
	                style: {
	                  flex: 1,
	                  background: interpolators.chance(category_step + category_step * i)
	                },
	                key: i,
	                onClick: handleFocusClick.bind(undefined, category_step + category_step * i)
	              },
	              _react2.default.createElement(
	                'div',
	                null,
	                name
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ProbNumber', style: { color: 'rgba(0,0,0,0.5)' } },
	                chance_arrays[i].length
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'h6 px1 space-between py1 px2 mt1 uppercase flex' },
	          _react2.default.createElement(
	            'div',
	            null,
	            'Neighborhoods'
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              style: { color: 'rgba(0,0,0,0.5)' }
	            },
	            filtered_neighborhoods.length
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'fixed left-0',
	          style: {
	            width: mobile ? '100%' : '360px',
	            top: top_space + bar_height,
	            height: 'calc(100% - ' + (top_space + bar_height) + 'px',
	            overflowY: 'auto'
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'tnum' },
	          filtered_neighborhoods.map(function (neighborhood) {
	            return neighborhood_item(neighborhood);
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = QuestionPriceList;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuestionProb = function QuestionProb(_ref) {
	  var active_probability = _ref.active_probability;
	  var changeActiveProbability = _ref.changeActiveProbability;
	  var formatters = _ref.formatters;
	
	
	  var probabilities_display = ['Low', 'Medium', 'High'];
	  var probabilities_value = [0.25, 0.5, 0.75];
	
	  var handleClick = function handleClick(value) {
	    changeActiveProbability(value);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'border-bottom' },
	    _react2.default.createElement(
	      'div',
	      { className: 'py1 px2',
	        style: {
	          paddingBottom: '0.25rem',
	          paddingTop: '0.25rem'
	        }
	      },
	      'How much money would I need to have a'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex h5' },
	      probabilities_display.map(function (word, i) {
	        return _react2.default.createElement(
	          'div',
	          {
	            key: i,
	            className: "QuestionProbItem col-4 py1 pointer bg-light-gray center hover " + (probabilities_value[i] === active_probability ? "active" : ""),
	            style: {
	              padding: '0.525rem 0'
	            },
	            onClick: handleClick.bind(undefined, probabilities_value[i])
	          },
	          _react2.default.createElement(
	            'div',
	            null,
	            word,
	            ' ',
	            _react2.default.createElement(
	              'span',
	              { className: 'gray h6' },
	              '(',
	              formatters.percentFormat(probabilities_value[i]),
	              ')'
	            )
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'py1 px2',
	        style: {
	          paddingTop: '0.25rem',
	          paddingBottom: '0.45rem'
	        }
	      },
	      'probability of being able to afford a property?'
	    )
	  );
	};
	
	exports.default = QuestionProb;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoroughFilter = __webpack_require__(81);
	
	var _BoroughFilter2 = _interopRequireDefault(_BoroughFilter);
	
	var _d3Array = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuestionProbList = function QuestionProbList(_ref) {
	  var neighborhoods = _ref.neighborhoods;
	  var interpolators = _ref.interpolators;
	  var formatters = _ref.formatters;
	  var changePriceFocus = _ref.changePriceFocus;
	  var price_focus = _ref.price_focus;
	  var setActiveNeighborhood = _ref.setActiveNeighborhood;
	  var top_space = _ref.top_space;
	  var borough_filter = _ref.borough_filter;
	  var setBoroughFilter = _ref.setBoroughFilter;
	  var browser_width = _ref.browser_width;
	
	
	  var bar_height = 202;
	
	  var price_categories = ['Top', 'Middle', 'Bottom'];
	
	  var neighborhoods_prices = neighborhoods.map(function (neighborhood) {
	    return neighborhood.properties.price;
	  });
	  var samples_max = (0, _d3Array.max)(neighborhoods_prices);
	
	  // TODO: bin ranges hacked bc I decided to stop using bin ranges
	  var bin_ranges = [{
	    string: '$0-1M',
	    bottom: 0,
	    top: 1000000,
	    neighborhoods: []
	  }, {
	    string: '$1-2M',
	    bottom: 1000000,
	    top: 2000000,
	    neighborhoods: []
	  }, {
	    string: '$2-8M+',
	    bottom: 2000000,
	    top: 8000000,
	    neighborhoods: []
	  }];
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = neighborhoods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var neighborhood = _step.value;
	
	      if (neighborhood.properties.price < bin_ranges[0].top) {
	        bin_ranges[0].neighborhoods.push(neighborhood);
	      } else if (neighborhood.properties.price < bin_ranges[1].top) {
	        bin_ranges[1].neighborhoods.push(neighborhood);
	      } else {
	        bin_ranges[2].neighborhoods.push(neighborhood);
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  var filtered_neighborhoods = neighborhoods;
	  var focus_value_array = bin_ranges.map(function (bin) {
	    return bin.top;
	  });
	  if (price_focus) {
	    var bin_index = focus_value_array.indexOf(price_focus);
	    filtered_neighborhoods = bin_ranges[bin_index].neighborhoods;
	  }
	
	  var handleNeighborhoodClick = function handleNeighborhoodClick(neighborhood) {
	    setActiveNeighborhood(neighborhood.properties.neighborhood);
	  };
	
	  var handlePriceFilterClick = function handlePriceFilterClick(value) {
	    if (price_focus === value) {
	      changePriceFocus(false);
	    } else {
	      changePriceFocus(value);
	    }
	  };
	
	  var neighborhood_item = function neighborhood_item(neighborhood) {
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'SideListItem h5 hover relative flex pointer',
	        onClick: handleNeighborhoodClick.bind(undefined, neighborhood),
	        style: {
	          background: interpolators.money(neighborhood.properties.price / 2000000)
	        },
	        key: neighborhood.properties.neighborhood
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'relative small-caps center',
	          style: {
	            width: '1.5rem',
	            color: 'rgba(0,0,0,0.5)'
	          }
	        },
	        formatters.borough_abbreviations[neighborhood.properties.borough]
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'space-between flex grow-1' },
	        _react2.default.createElement(
	          'div',
	          { className: '',
	            style: {
	              paddingLeft: '0.25rem'
	            }
	          },
	          neighborhood.properties.neighborhood
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: '' },
	          formatters.dollarShort(neighborhood.properties.price)
	        )
	      )
	    );
	  };
	
	  var mobile = false;
	  if (browser_width < 451) mobile = true;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'no-select', style: { paddingTop: bar_height } },
	    _react2.default.createElement(
	      'div',
	      { className: 'fixed top-left bg-white',
	        style: { top: top_space,
	          width: mobile ? '100%' : '360px',
	          zIndex: '9' }
	      },
	      _react2.default.createElement(_BoroughFilter2.default, {
	        borough_filter: borough_filter,
	        setBoroughFilter: setBoroughFilter
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'h6 mt1 px2 flex space-between uppercase' },
	        'Filter by Price',
	        price_focus ? _react2.default.createElement(
	          'div',
	          { className: 'pointer blue hover-underline', onClick: handlePriceFilterClick.bind(undefined, false) },
	          'Clear Filter'
	        ) : null
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex mt1 tnum h5' },
	        price_categories.map(function (name, i) {
	          return _react2.default.createElement(
	            'div',
	            {
	              key: i,
	              style: {
	                background: interpolators.money(((bin_ranges[i].top - bin_ranges[i].bottom) / 2 + bin_ranges[i].bottom) / 2000000)
	              },
	              className: "PriceFilterItem relative px2 pointer flex space-between py1 hover col-4 " + (price_focus === bin_ranges[i].top ? 'active' : ''),
	              onClick: handlePriceFilterClick.bind(undefined, bin_ranges[i].top)
	            },
	            _react2.default.createElement(
	              'div',
	              null,
	              bin_ranges[i].string
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'ProbNumber', style: { color: 'rgba(0,0,0,0.5)' } },
	              bin_ranges[i].neighborhoods.length
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'h6 px1 space-between py1 px2 mt1 uppercase flex' },
	        _react2.default.createElement(
	          'div',
	          null,
	          'Neighborhoods'
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: { color: 'rgba(0,0,0,0.5)' }
	          },
	          filtered_neighborhoods.length
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'fixed left-0',
	        style: {
	          width: mobile ? '100%' : '360px',
	          top: top_space + bar_height,
	          height: 'calc(100% - ' + (top_space + bar_height) + 'px',
	          overflowY: 'auto'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'tnum' },
	        filtered_neighborhoods.map(function (neighborhood) {
	          return neighborhood_item(neighborhood);
	        })
	      )
	    )
	  );
	};
	
	exports.default = QuestionProbList;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(49);
	
	var _PriceChanger = __webpack_require__(306);
	
	var _PriceChanger2 = _interopRequireDefault(_PriceChanger);
	
	var _ChanceChanger = __webpack_require__(294);
	
	var _ChanceChanger2 = _interopRequireDefault(_ChanceChanger);
	
	var _ModeChanger = __webpack_require__(303);
	
	var _ModeChanger2 = _interopRequireDefault(_ModeChanger);
	
	var _ChanceNeighborhoodList = __webpack_require__(295);
	
	var _ChanceNeighborhoodList2 = _interopRequireDefault(_ChanceNeighborhoodList);
	
	var _PriceNeighborhoodList = __webpack_require__(308);
	
	var _PriceNeighborhoodList2 = _interopRequireDefault(_PriceNeighborhoodList);
	
	var _PriceFocusChangerFix = __webpack_require__(307);
	
	var _PriceFocusChangerFix2 = _interopRequireDefault(_PriceFocusChangerFix);
	
	var _ProbabilityFocusChanger = __webpack_require__(309);
	
	var _ProbabilityFocusChanger2 = _interopRequireDefault(_ProbabilityFocusChanger);
	
	var _NeighborhoodFocus = __webpack_require__(304);
	
	var _NeighborhoodFocus2 = _interopRequireDefault(_NeighborhoodFocus);
	
	var _NeighborhoodFocus3 = __webpack_require__(305);
	
	var _NeighborhoodFocus4 = _interopRequireDefault(_NeighborhoodFocus3);
	
	var _QuestionPrice = __webpack_require__(310);
	
	var _QuestionPrice2 = _interopRequireDefault(_QuestionPrice);
	
	var _QuestionProb = __webpack_require__(312);
	
	var _QuestionProb2 = _interopRequireDefault(_QuestionProb);
	
	var _BoroughFilter = __webpack_require__(81);
	
	var _BoroughFilter2 = _interopRequireDefault(_BoroughFilter);
	
	var _QuestionPriceList = __webpack_require__(311);
	
	var _QuestionPriceList2 = _interopRequireDefault(_QuestionPriceList);
	
	var _QuestionProbList = __webpack_require__(313);
	
	var _QuestionProbList2 = _interopRequireDefault(_QuestionProbList);
	
	var _HexFocus = __webpack_require__(299);
	
	var _HexFocus2 = _interopRequireDefault(_HexFocus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sidebar2 = function Sidebar2(_ref) {
	  var neighborhoods = _ref.neighborhoods;
	  var neighborhoods_samples = _ref.neighborhoods_samples;
	  var active_year = _ref.active_year;
	  var changeActiveYear = _ref.changeActiveYear;
	  var active_price = _ref.active_price;
	  var active_probability = _ref.active_probability;
	  var changeActivePrice = _ref.changeActivePrice;
	  var formatters = _ref.formatters;
	  var active_mode = _ref.active_mode;
	  var changeActiveMode = _ref.changeActiveMode;
	  var changeActiveProbability = _ref.changeActiveProbability;
	  var changePriceFocus = _ref.changePriceFocus;
	  var price_focus = _ref.price_focus;
	  var active_neighborhood = _ref.active_neighborhood;
	  var probability_focus = _ref.probability_focus;
	  var changeProbabilityFocus = _ref.changeProbabilityFocus;
	  var setActiveNeighborhood = _ref.setActiveNeighborhood;
	  var closeHexFocus = _ref.closeHexFocus;
	  var closeNeighborhoodFocus = _ref.closeNeighborhoodFocus;
	  var interpolators = _ref.interpolators;
	  var setBoroughFilter = _ref.setBoroughFilter;
	  var borough_filter = _ref.borough_filter;
	  var active_hex = _ref.active_hex;
	  var show_roads = _ref.show_roads;
	  var setShowRoads = _ref.setShowRoads;
	  var setExplainer = _ref.setExplainer;
	  var browser_width = _ref.browser_width;
	  var mobile_toggle = _ref.mobile_toggle;
	  var toggleMobile = _ref.toggleMobile;
	  var mobile_show = _ref.mobile_show;
	  var changeMobileShow = _ref.changeMobileShow;
	
	
	  var filtered_neighborhoods = neighborhoods;
	  if (borough_filter) {
	    filtered_neighborhoods = neighborhoods.filter(function (n) {
	      return n.properties.borough === borough_filter ? true : false;
	    });
	  }
	
	  var top_space = 144;
	
	  var handleModeClick = function handleModeClick(new_mode) {
	    changeActiveMode(new_mode);
	  };
	
	  var handleRoadsClick = function handleRoadsClick() {
	    setShowRoads(!show_roads);
	  };
	
	  var handleExplainerClick = function handleExplainerClick() {
	    setExplainer(true);
	  };
	
	  var handleToggleClick = function handleToggleClick() {
	    toggleMobile(!mobile_toggle);
	  };
	
	  var handleMobileShowClick = function handleMobileShowClick(value) {
	    changeMobileShow(value);
	  };
	
	  var mobile = false;
	  if (browser_width < 451) mobile = true;
	
	  if (mobile) top_space = 144 + 35;
	
	  var toggle_tab = "";
	  var toggle_transform = "";
	  var toggle_text = "×";
	  if (browser_width < 801 && browser_width > 450) {
	    if (!mobile_toggle) {
	      toggle_transform = "translate(-360px,0)";
	      toggle_text = _react2.default.createElement(
	        'span',
	        { className: 'relative', style: { top: '-0.2rem' } },
	        '≡'
	      );
	    }
	    toggle_tab = _react2.default.createElement(
	      'div',
	      { className: 'absolute hover pointer center bg-white border-right border-bottom right-0 top-0',
	        title: 'Toggle sidebar',
	        style: {
	          width: '2.5rem',
	          right: '-2.5rem',
	          height: '2.4rem',
	          fontSize: '2rem',
	          lineHeight: '2.3rem'
	        },
	        onClick: handleToggleClick.bind(undefined)
	      },
	      toggle_text
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'flex ModeToggle nav-shadow' },
	      _react2.default.createElement(
	        'div',
	        { className: 'py1 px2 uppercase h6',
	          style: {
	            paddingTop: '0.7rem',
	            paddingBottom: '0.3rem',
	            paddingLeft: '0.75rem',
	            paddingRight: '0.75rem'
	          }
	        },
	        'Mode:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { onClick: handleModeClick.bind(undefined, 'Chance'), className: "ModeItem py1 px2 pointer hover border-right " + (active_mode === 'Chance' ? 'active' : '') },
	        'Probability'
	      ),
	      _react2.default.createElement(
	        'div',
	        { onClick: handleModeClick.bind(undefined, 'Price'), className: "ModeItem py1 pointer px2 hover " + (active_mode === 'Price' ? 'active' : '') },
	        'Price'
	      )
	    ),
	    !(mobile && active_neighborhood) ? _react2.default.createElement(
	      'div',
	      { className: 'StyleToggle py1 hover-light-gray px2 nav-shadow no-select', onClick: handleRoadsClick.bind(undefined) },
	      _react2.default.createElement('input', { type: 'checkbox', readOnly: true, checked: show_roads }),
	      ' Show Roads'
	    ) : null,
	    _react2.default.createElement(
	      'div',
	      { id: 'Sidebar',
	        style: {
	          paddingTop: top_space,
	          transform: toggle_transform
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'fixed left-0 top-0 bg-white sidebar-width',
	          style: {
	            zIndex: 11
	          }
	        },
	        toggle_tab,
	        _react2.default.createElement(
	          'div',
	          { className: 'h5 border-bottom flex relative space-between' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { className: 'block py1 bold px2 logo-link', to: '/probability/1000000-50/2016/all_boroughs/all_neighborhoods' },
	            'Probabilistic Real Estate'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'bg-white h5 center no-select hover pointer absolute',
	              onClick: handleExplainerClick.bind(undefined),
	              style: {
	                width: '1.25rem',
	                height: '1.25rem',
	                right: '0.5rem',
	                lineHeight: '1.25rem',
	                fontSize: '1rem',
	                fontWeight: '900',
	                borderRadius: '50%',
	                top: '0.5rem',
	                marginRight: '0.5rem',
	                background: '#efefef'
	              }
	            },
	            '?'
	          )
	        ),
	        active_mode === 'Price' ? _react2.default.createElement(_QuestionProb2.default, {
	          active_probability: active_probability,
	          changeActiveProbability: changeActiveProbability,
	          formatters: formatters
	        }) : _react2.default.createElement(_QuestionPrice2.default, {
	          active_price: active_price,
	          changeActivePrice: changeActivePrice,
	          formatters: formatters
	        }),
	        mobile ? _react2.default.createElement(
	          'div',
	          { className: 'h6 flex border-bottom' },
	          _react2.default.createElement(
	            'div',
	            { className: 'px2 py1 uppercase' },
	            'Show:'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: "center px2 py1 ButtonItem " + (mobile_show === 'map' ? 'active' : null), onClick: handleMobileShowClick.bind(undefined, 'map') },
	            'Map'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: "center px2 py1 ButtonItem " + (mobile_show === 'info' ? 'active' : null), onClick: handleMobileShowClick.bind(undefined, 'info') },
	            'Info'
	          )
	        ) : null
	      ),
	      active_hex && (!mobile || mobile_show === 'info') ? _react2.default.createElement(
	        'div',
	        { className: 'relative' },
	        _react2.default.createElement(_HexFocus2.default, {
	          active_neighborhood: active_neighborhood,
	          active_mode: active_mode,
	          formatters: formatters,
	          active_year: active_year,
	          active_price: active_price,
	          active_probability: active_probability,
	          closeNeighborhoodFocus: closeNeighborhoodFocus,
	          closeHexFocus: closeHexFocus,
	          neighborhoods: neighborhoods,
	          neighborhoods_samples: neighborhoods_samples,
	          setActiveNeighborhood: setActiveNeighborhood,
	          interpolators: interpolators,
	          top_space: top_space,
	          active_hex: active_hex,
	          browser_width: browser_width
	        })
	      ) : active_neighborhood && neighborhoods_samples && (!mobile || mobile_show === 'info') ? _react2.default.createElement(
	        'div',
	        { className: 'relative' },
	        _react2.default.createElement(_NeighborhoodFocus2.default, {
	          active_neighborhood: active_neighborhood,
	          active_mode: active_mode,
	          formatters: formatters,
	          active_year: active_year,
	          active_price: active_price,
	          active_probability: active_probability,
	          closeNeighborhoodFocus: closeNeighborhoodFocus,
	          neighborhoods: neighborhoods,
	          neighborhoods_samples: neighborhoods_samples,
	          setActiveNeighborhood: setActiveNeighborhood,
	          interpolators: interpolators,
	          top_space: top_space,
	          browser_width: browser_width
	        })
	      ) : !mobile || mobile && mobile_show === 'info' ? _react2.default.createElement(
	        'div',
	        null,
	        neighborhoods && neighborhoods_samples ? active_mode === 'Price' ? _react2.default.createElement(_QuestionProbList2.default, {
	          neighborhoods: neighborhoods,
	          interpolators: interpolators,
	          formatters: formatters,
	          setActiveNeighborhood: setActiveNeighborhood,
	          setBoroughFilter: setBoroughFilter,
	          borough_filter: borough_filter,
	          top_space: top_space,
	          changePriceFocus: changePriceFocus,
	          price_focus: price_focus,
	          browser_width: browser_width
	        }) : _react2.default.createElement(_QuestionPriceList2.default, {
	          neighborhoods: neighborhoods,
	          interpolators: interpolators,
	          formatters: formatters,
	          changeProbabilityFocus: changeProbabilityFocus,
	          probability_focus: probability_focus,
	          setActiveNeighborhood: setActiveNeighborhood,
	          setBoroughFilter: setBoroughFilter,
	          borough_filter: borough_filter,
	          top_space: top_space,
	          browser_width: browser_width
	        }) : null
	      ) : null,
	      _react2.default.createElement('div', { className: 'border-right top-0 bottom-0 fixed',
	        style: {
	          left: mobile ? '100%' : '360px',
	          width: '1px'
	        }
	      })
	    )
	  );
	};
	
	exports.default = Sidebar2;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YearChanger = function YearChanger(_ref) {
	  var active_year = _ref.active_year;
	  var changeActiveYear = _ref.changeActiveYear;
	
	
	  var years = [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018];
	
	  var handleOnClick = function handleOnClick(year) {
	    changeActiveYear(year);
	  };
	
	  var handleCrementClick = function handleCrementClick(type) {
	    var active_index = years.indexOf(active_year);
	    var next_index = void 0;
	    if (type === 'inc') {
	      next_index = active_index + 1;
	      if (next_index + 1 > years.length) next_index = 0;
	    } else {
	      next_index = active_index - 1;
	      if (next_index < 0) next_index = years.length - 1;
	    }
	    changeActiveYear(years[next_index]);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'YearChanger', className: 'bg-light-gray tnum nav-shadow no-select' },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex' },
	      years.map(function (year) {
	        return _react2.default.createElement(
	          'div',
	          {
	            key: year,
	            className: "YearItem pointer px1 py1 " + (active_year === year ? 'active' : ''),
	            style: { padding: '0.5rem 0.65rem 0.55rem' },
	            onClick: handleOnClick.bind(undefined, year)
	          },
	          year
	        );
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'center h5 no-select py1 hover-light-gray border-left pointer',
	          style: { paddingTop: '0.65rem', width: '2.5rem' },
	          onClick: handleCrementClick.bind(undefined, 'dec')
	        },
	        '◀'
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'center h5 no-select hover-light-gray py1 border-left pointer',
	          style: { paddingTop: '0.65rem', width: '2.5rem' },
	          onClick: handleCrementClick.bind(undefined, 'inc')
	        },
	        '▶'
	      )
	    )
	  );
	};
	
	exports.default = YearChanger;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Axis = __webpack_require__(37);
	
	var _d3Format = __webpack_require__(23);
	
	var _d3Selection = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YearXAxis = function (_Component) {
	  _inherits(YearXAxis, _Component);
	
	  function YearXAxis() {
	    _classCallCheck(this, YearXAxis);
	
	    return _possibleConstructorReturn(this, (YearXAxis.__proto__ || Object.getPrototypeOf(YearXAxis)).apply(this, arguments));
	  }
	
	  _createClass(YearXAxis, [{
	    key: 'renderAxis',
	    value: function renderAxis() {
	      var _props = this.props;
	      var formatters = _props.formatters;
	      var x = _props.x;
	      var inner_height = _props.inner_height;
	      var svg_height = _props.svg_height;
	      var margins = _props.margins;
	
	      var xAxis = (0, _d3Axis.axisBottom)().scale(x).ticks(6).tickSize(-inner_height, 0, 0).tickFormat((0, _d3Format.format)("d"));
	      var node = this.refs.axis;
	      var axis = (0, _d3Selection.select)(node).call(xAxis);
	      axis.selectAll("line").attr("transform", 'translate(' + x(2011) / 2 + ',0)');
	      axis.selectAll("text").attr("y", 10).attr("x", x(2011) / 2).attr("text-anchor", "middle");
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderAxis();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderAxis();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var margins = this.props.margins;
	
	      return _react2.default.createElement('g', { className: 'Axis no-ticks', ref: 'axis', transform: 'translate(0,' + this.props.inner_height + ')' });
	    }
	  }]);
	
	  return YearXAxis;
	}(_react.Component);
	
	exports.default = YearXAxis;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Axis = __webpack_require__(37);
	
	var _d3Format = __webpack_require__(23);
	
	var _d3Selection = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YearYAxis = function (_Component) {
	  _inherits(YearYAxis, _Component);
	
	  function YearYAxis() {
	    _classCallCheck(this, YearYAxis);
	
	    return _possibleConstructorReturn(this, (YearYAxis.__proto__ || Object.getPrototypeOf(YearYAxis)).apply(this, arguments));
	  }
	
	  _createClass(YearYAxis, [{
	    key: 'renderAxis',
	    value: function renderAxis() {
	      var _props = this.props;
	      var formatters = _props.formatters;
	      var y = _props.y;
	      var svg_width = _props.svg_width;
	      var margins = _props.margins;
	      var active_mode = _props.active_mode;
	
	      var yAxis = (0, _d3Axis.axisLeft)().scale(y).ticks(5).tickSize(-svg_width + margins.right, 0, 0);
	      if (active_mode === 'Price') {
	        yAxis.tickFormat((0, _d3Format.format)('$.1s'));
	      } else {
	        yAxis.tickFormat((0, _d3Format.format)('.0%'));
	      }
	      var node = this.refs.axis;
	      var axis = (0, _d3Selection.select)(node).call(yAxis);
	      axis.selectAll("text").attr("x", -4);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderAxis();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderAxis();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var margins = this.props.margins;
	
	      return _react2.default.createElement('g', { className: 'Axis', ref: 'axis', transform: 'translate(0,0)' });
	    }
	  }]);
	
	  return YearYAxis;
	}(_react.Component);
	
	exports.default = YearYAxis;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(329);
	
	__webpack_require__(331);
	
	__webpack_require__(330);
	
	var _ApperContainer = __webpack_require__(319);
	
	var _ApperContainer2 = _interopRequireDefault(_ApperContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Apper = function (_Component) {
	  _inherits(Apper, _Component);
	
	  function Apper() {
	    _classCallCheck(this, Apper);
	
	    return _possibleConstructorReturn(this, (Apper.__proto__ || Object.getPrototypeOf(Apper)).apply(this, arguments));
	  }
	
	  _createClass(Apper, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'App' },
	        _react2.default.createElement(_ApperContainer2.default, { params: this.props.params, search: this.props.location.search, path: this.props.location.pathname, query: this.props.location.query })
	      );
	    }
	  }]);
	
	  return Apper;
	}(_react.Component);
	
	exports.default = Apper;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(131);
	
	var _Apper = __webpack_require__(293);
	
	var _Apper2 = _interopRequireDefault(_Apper);
	
	var _d3Array = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getYearPrices = function getYearPrices(active_probability, samples) {
	  var year_prices = samples.map(function (year_samples) {
	    var price = Math.round((0, _d3Array.quantile)(year_samples, active_probability));
	    return price;
	  });
	  return year_prices;
	};
	
	var getYearProbabilities = function getYearProbabilities(active_price, samples) {
	  var year_probabilities = samples.map(function (year_samples) {
	    var below_price_counter = 0;
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = year_samples[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var sample = _step.value;
	
	        if (sample <= active_price) {
	          below_price_counter++;
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    var probability = below_price_counter / year_samples.length;
	    return probability;
	  });
	  return year_probabilities;
	};
	
	var getYearPricesAll = function getYearPricesAll(samples) {
	  var year_prices = samples.map(function (year_samples) {
	    // TODO: for the graphs, this is repetitive but will work for now
	    var bottom_price = Math.round((0, _d3Array.quantile)(year_samples, 0.25));
	    var median_price = Math.round((0, _d3Array.quantile)(year_samples, 0.5));
	    var top_price = Math.round((0, _d3Array.quantile)(year_samples, 0.75));
	    return [bottom_price, median_price, top_price];
	  });
	  return year_prices;
	};
	
	var setNeighborhoodProperties = function setNeighborhoodProperties(active_year, active_probability, active_price, neighborhoods, neighborhoods_samples) {
	  var new_neighborhoods = neighborhoods.map(function (neighborhood, i) {
	    var active_neighborhoods_samples = neighborhoods_samples[active_year][i];
	    var below_price_counter = 0;
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = active_neighborhoods_samples[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var sample = _step2.value;
	
	        if (sample <= active_price) {
	          below_price_counter++;
	        }
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	
	    var probability = below_price_counter / active_neighborhoods_samples.length;
	    var price = Math.round((0, _d3Array.quantile)(active_neighborhoods_samples, active_probability));
	    neighborhood.properties.price = price;
	    neighborhood.properties.probability = probability;
	    return neighborhood;
	  });
	  return new_neighborhoods;
	};
	
	var setHexProperties = function setHexProperties(active_year, active_probability, active_price, hex_arrays) {
	  var hexes = hex_arrays.hex_geojson.map(function (hex, i) {
	    var hex_samples = hex_arrays.hex_samples[active_year][i];
	    var below_price_counter = 0;
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	      for (var _iterator3 = hex_samples[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	        var sample = _step3.value;
	
	        if (sample <= active_price) {
	          below_price_counter++;
	        }
	      }
	    } catch (err) {
	      _didIteratorError3 = true;
	      _iteratorError3 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion3 && _iterator3.return) {
	          _iterator3.return();
	        }
	      } finally {
	        if (_didIteratorError3) {
	          throw _iteratorError3;
	        }
	      }
	    }
	
	    var probability = below_price_counter / hex_samples.length;
	    var price = Math.round((0, _d3Array.quantile)(hex_samples, active_probability));
	    hex.properties.price = price;
	    hex.properties.probability = probability;
	    return hex;
	  });
	  return hexes;
	};
	
	var ApperContainer = (0, _reactRedux.connect)(function mapStateToProps(full_state, ownProps) {
	
	  var params = ownProps.params;
	
	  var active_mode = void 0;
	  if (params.mode == 'price') active_mode = 'Price';
	  if (params.mode == 'probability') active_mode = 'Chance';
	
	  var active_price = void 0,
	      active_probability = void 0;
	  if (params.mode == 'probability') {
	    active_price = parseFloat(params.active_var.split('-')[0]);
	    active_probability = parseFloat(params.active_var.split('-')[1] / 100);
	  } else {
	    active_probability = parseFloat(params.active_var.split('-')[0] / 100);
	    active_price = parseFloat(params.active_var.split('-')[1]);
	  }
	
	  var active_year = parseFloat(params.year);
	
	  var borough_filter = void 0;
	  if (params.borough_filter == 'all_boroughs') {
	    borough_filter = false;
	  } else {
	    borough_filter = ownProps.params.borough_filter;
	  }
	
	  var capitalize = function capitalize(str) {
	    return str.replace(/\b\w/g, function (l) {
	      return l.toUpperCase();
	    });
	  };
	
	  var active_neighborhood = void 0;
	  if (params.neighborhood == 'all_neighborhoods') {
	    active_neighborhood = false;
	  } else {
	    active_neighborhood = capitalize(params.neighborhood.replace(/_/g, ' '));
	    if (active_neighborhood === 'Dumbo-Vinegar Hill-Downtown Brooklyn-Boerum Hill') active_neighborhood = 'DUMBO-Vinegar Hill-Downtown Brooklyn-Boerum Hill';
	    if (active_neighborhood === 'Soho-Tribeca-Civic Center-Little Italy') active_neighborhood = 'SoHo-TriBeCa-Civic Center-Little Italy';
	    if (active_neighborhood === 'Co-Op City') active_neighborhood = 'Co-op City';
	  }
	
	  var explainer = void 0;
	  if (ownProps.query.explainer && ownProps.query.explainer.toLowerCase() === 'true') {
	    explainer = true;
	  } else {
	    explainer = false;
	  }
	
	  var show_roads = true;
	  if (ownProps.query.show_roads && ownProps.query.show_roads.toLowerCase() === 'false') {
	    show_roads = false;
	  }
	
	  var active_hex = false;
	  if (params.hex) active_hex = parseFloat(params.hex);
	
	  var browser_width = full_state.browser.width;
	  var _full_state$app = full_state.app;
	  var neighborhoods = _full_state$app.neighborhoods;
	  var neighborhoods_samples = _full_state$app.neighborhoods_samples;
	  var map = _full_state$app.map;
	  var price_focus = _full_state$app.price_focus;
	  var probability_focus = _full_state$app.probability_focus;
	  var hex_arrays = _full_state$app.hex_arrays;
	  var mobile_toggle = _full_state$app.mobile_toggle;
	
	
	  var new_neighborhoods = neighborhoods;
	  if (neighborhoods_samples[active_year] !== undefined) {
	    new_neighborhoods = setNeighborhoodProperties(active_year, active_probability, active_price, neighborhoods, neighborhoods_samples);
	    if (active_mode === 'Chance') {
	      new_neighborhoods.sort(function (a, b) {
	        if (a.properties.probability === b.properties.probability) {
	          if (a.properties.neighborhood < b.properties.neighborhood) return -1;
	          if (a.properties.neighborhood > b.properties.neighborhood) return 1;
	          return 0;
	        }
	        if (a.properties.probability > b.properties.probability) return -1;
	        if (a.properties.probability < b.properties.probability) return 1;
	        return 0;
	      });
	    } else if (active_mode === 'Price') {
	      new_neighborhoods.sort(function (a, b) {
	        if (a.properties.price > b.properties.price) return -1;
	        if (a.properties.price < b.properties.price) return 1;
	        return 0;
	      });
	    }
	  }
	
	  var hexes = false;
	  var hex_samples = false;
	  if (hex_arrays) {
	    hexes = setHexProperties(active_year, active_probability, active_price, hex_arrays);
	  }
	
	  var active_neighborhood_with_samples = false;
	  if (active_neighborhood) {
	    (function () {
	      var neighborhood_names = neighborhoods.map(function (neighborhood) {
	        return neighborhood.properties.neighborhood;
	      });
	      var new_neighborhood_names = new_neighborhoods.map(function (neighborhood) {
	        return neighborhood.properties.neighborhood;
	      });
	      var active_index = neighborhood_names.indexOf(active_neighborhood);
	      var new_active_index = new_neighborhood_names.indexOf(active_neighborhood);
	      active_neighborhood = new_neighborhoods[new_active_index];
	      active_neighborhood_with_samples = Object.assign({}, active_neighborhood);
	      var neighborhood_samples = [];
	      Object.keys(neighborhoods_samples).forEach(function (key) {
	        neighborhood_samples.push(neighborhoods_samples[key][active_index]);
	      });
	      var year_prices = getYearPrices(active_probability, neighborhood_samples);
	      var year_all_prices = getYearPricesAll(neighborhood_samples);
	      var year_probabilities = getYearProbabilities(active_price, neighborhood_samples);
	      active_neighborhood_with_samples.samples = neighborhood_samples;
	      active_neighborhood_with_samples.year_prices = year_prices;
	      active_neighborhood_with_samples.year_all_prices = year_all_prices;
	      active_neighborhood_with_samples.year_probabilities = year_probabilities;
	    })();
	  }
	
	  var active_hex_with_samples = false;
	  if (active_hex && hexes) {
	    (function () {
	      var hexids = hexes.map(function (hex) {
	        return hex.properties.hexid;
	      });
	      var active_index = hexids.indexOf(active_hex);
	      active_hex = hexes[active_index];
	      var hex_samples_temp = hex_arrays.hex_samples;
	      active_hex_with_samples = Object.assign({}, active_hex);
	      var active_hex_samples = [];
	      Object.keys(hex_samples_temp).forEach(function (key) {
	        active_hex_samples.push(hex_samples_temp[key][active_index]);
	      });
	      var hex_year_prices = getYearPrices(active_probability, active_hex_samples);
	      var hex_year_all_prices = getYearPricesAll(active_hex_samples);
	      var hex_year_probabilities = getYearProbabilities(active_price, active_hex_samples);
	      active_hex_with_samples.samples = active_hex_samples;
	      active_hex_with_samples.year_prices = hex_year_prices;
	      active_hex_with_samples.year_all_prices = hex_year_all_prices;
	      active_hex_with_samples.year_probabilities = hex_year_probabilities;
	    })();
	  }
	
	  var paramsToString = function paramsToString(params) {
	    var string = '/' + params.mode + '/' + params.active_var + '/' + params.year + '/' + params.borough_filter + '/' + params.neighborhood;
	    if (params.hex) string = string + '/' + params.hex;
	    return { pathname: string, query: ownProps.query };
	  };
	
	  var changeMobileShow = function changeMobileShow(value) {
	    var new_query = Object.assign(ownProps.query, { mobile_show: value });
	    _reactRouter.hashHistory.push({ pathname: ownProps.path, query: new_query });
	  };
	
	  var mobile_show = false;
	  // check for existing param first
	  if (ownProps.query.mobile_show) {
	    if (ownProps.query.mobile_show.toLowerCase() === 'info') {
	      mobile_show = 'info';
	    } else {
	      mobile_show = 'map';
	    }
	  }
	
	  // if mobile and no existing param then try and select the best display mode
	  if (browser_width < 451 && !mobile_show) {
	    if (active_hex || active_neighborhood) {
	      mobile_show = 'info';
	    } else {
	      mobile_show = 'map';
	    }
	  }
	
	  var changeActiveMode = function changeActiveMode(mode) {
	    var mode_param = void 0;
	    if (mode == 'Price') mode_param = 'price';
	    if (mode == 'Chance') mode_param = 'probability';
	    var new_active_var = void 0;
	    if (mode_param == 'probability') {
	      new_active_var = active_price + '-' + active_probability * 100;
	    } else {
	      new_active_var = active_probability * 100 + '-' + active_price;
	    }
	    var new_params = Object.assign(params, { mode: mode_param, active_var: new_active_var });
	    var new_params_string = paramsToString(new_params);
	    _reactRouter.hashHistory.push(new_params_string);
	  };
	
	  var changeActivePrice = function changeActivePrice(price) {
	    var new_active_var = void 0;
	    var new_price = price;
	    if (params.mode == 'probability') {
	      new_active_var = new_price + '-' + active_probability * 100;
	    } else {
	      new_active_var = active_probability * 100 + '-' + new_price;
	    }
	    var new_params = Object.assign(params, { active_var: new_active_var });
	    var new_params_string = paramsToString(new_params);
	    _reactRouter.hashHistory.push(new_params_string);
	  };
	
	  var changeActiveProbability = function changeActiveProbability(probability) {
	    var new_active_var = void 0;
	    var new_probability = probability * 100;
	    if (params.mode == 'probability') {
	      new_active_var = active_price + '-' + new_probability;
	    } else {
	      new_active_var = new_probability + '-' + active_price;
	    }
	    var new_params = Object.assign(params, { active_var: new_active_var });
	    var new_params_string = paramsToString(new_params);
	    _reactRouter.hashHistory.push(new_params_string);
	  };
	
	  var changeActiveYear = function changeActiveYear(year) {
	    var new_params = Object.assign(params, { year: year });
	    var new_params_string = paramsToString(new_params);
	    _reactRouter.hashHistory.push(new_params_string);
	  };
	
	  var setBoroughFilter = function setBoroughFilter(borough) {
	    var new_borough = 'all_boroughs';
	    if (borough) new_borough = borough;
	    var new_params = Object.assign(params, { borough_filter: new_borough });
	    var new_params_string = paramsToString(new_params);
	    _reactRouter.hashHistory.push(new_params_string);
	  };
	
	  var setExplainer = function setExplainer(value) {
	    if (value) {
	      var new_query = Object.assign(ownProps.query, { explainer: true });
	      _reactRouter.hashHistory.push({ pathname: ownProps.path, query: new_query });
	    } else {
	      var _new_query = Object.assign({}, ownProps.query);
	      delete _new_query['explainer'];
	      _reactRouter.hashHistory.push({ pathname: ownProps.path, query: _new_query });
	    }
	  };
	
	  var setShowRoads = function setShowRoads(value) {
	    if (!value) {
	      var new_query = Object.assign(ownProps.query, { show_roads: false });
	      _reactRouter.hashHistory.push({ pathname: ownProps.path, query: new_query });
	    } else {
	      var _new_query2 = Object.assign({}, ownProps.query);
	      delete _new_query2['show_roads'];
	      _reactRouter.hashHistory.push({ pathname: ownProps.path, query: _new_query2 });
	    }
	  };
	
	  var setActiveHex = function setActiveHex(hex) {
	    var new_params = Object.assign(params, { hex: hex });
	    var new_params_string = paramsToString(new_params);
	    // special for mobile, if you click a hex set mobile_show to info
	    var new_query = ownProps.query;
	    if (ownProps.query.mobile_show && hex) {
	      var _new_query3 = Object.assign(ownProps.query, { mobile_show: "info" });
	    }
	    _reactRouter.hashHistory.push({ pathname: new_params_string.pathname, query: new_query });
	  };
	
	  var closeHexFocus = function closeHexFocus(hex) {
	    var new_params = Object.assign(params, { hex: false });
	    var new_params_string = paramsToString(new_params);
	    _reactRouter.hashHistory.push(new_params_string);
	  };
	
	  return {
	    active_year: active_year,
	    active_price: active_price,
	    map: map,
	    neighborhoods: new_neighborhoods,
	    neighborhoods_samples: neighborhoods_samples,
	    active_mode: active_mode,
	    active_probability: active_probability,
	    borough_filter: borough_filter,
	    price_focus: price_focus,
	    probability_focus: probability_focus,
	    active_neighborhood: active_neighborhood,
	    active_neighborhood_with_samples: active_neighborhood_with_samples,
	    hexes: hexes,
	    active_hex: active_hex,
	    active_hex_with_samples: active_hex_with_samples,
	    show_roads: show_roads,
	    explainer: explainer,
	    browser_width: browser_width,
	    mobile_toggle: mobile_toggle,
	    changeActiveMode: changeActiveMode,
	    changeActivePrice: changeActivePrice,
	    changeActiveProbability: changeActiveProbability,
	    setBoroughFilter: setBoroughFilter,
	    changeActiveYear: changeActiveYear,
	    setExplainer: setExplainer,
	    setShowRoads: setShowRoads,
	    setActiveHex: setActiveHex,
	    closeHexFocus: closeHexFocus,
	    mobile_show: mobile_show,
	    changeMobileShow: changeMobileShow
	  };
	}, function mapDispatchToProps(dispatch, ownProps) {
	
	  var params = ownProps.params;
	
	  var paramsToString = function paramsToString(params) {
	    var string = '/' + params.mode + '/' + params.active_var + '/' + params.year + '/' + params.borough_filter + '/' + params.neighborhood;
	    if (params.hex) string = string + '/' + params.hex;
	    var param_object = { pathname: string, query: ownProps.query };
	    return param_object;
	  };
	
	  return {
	    setActiveNeighborhood: function setActiveNeighborhood(neighborhood) {
	      var new_neighborhood = 'all_neighborhoods';
	      if (neighborhood) new_neighborhood = neighborhood.toLowerCase().replace(/ /g, '_');
	      // Always clear hex on new neighborhood
	      var new_params = Object.assign(params, { neighborhood: new_neighborhood, hex: false });
	      var new_params_string = paramsToString(new_params);
	      _reactRouter.hashHistory.push(new_params_string);
	      // we use this action to clear hex_arrays, this is not pretty
	      dispatch({
	        type: 'SET_ACTIVE_NEIGHBORHOOD',
	        payload: {
	          neighborhood: neighborhood
	        }
	      });
	    },
	    closeNeighborhoodFocus: function closeNeighborhoodFocus() {
	      var new_neighborhood = 'all_neighborhoods';
	      // Always clear hex on new neighborhood
	      var hex_end = '';
	      if (params.hex) hex_end = '/' + params.hex;
	      _reactRouter.hashHistory.push('/' + params.mode + '/' + params.active_var + '/' + params.year + '/' + params.borough_filter + '/' + new_neighborhood + hex_end);
	      var new_params = Object.assign(params, { neighborhood: new_neighborhood, hex: false });
	      var new_params_string = paramsToString(new_params);
	      _reactRouter.hashHistory.push(new_params_string);
	      // we use this action to clear hex_arrays, this is not pretty
	      dispatch({
	        type: 'SET_ACTIVE_NEIGHBORHOOD',
	        payload: {
	          false: false
	        }
	      });
	    },
	    changePriceFocus: function changePriceFocus(price) {
	      return dispatch({
	        type: 'CHANGE_PRICE_FOCUS',
	        payload: {
	          price: price
	        }
	      });
	    },
	    changeProbabilityFocus: function changeProbabilityFocus(probability) {
	      return dispatch({
	        type: 'CHANGE_PROBABILITY_FOCUS',
	        payload: {
	          probability: probability
	        }
	      });
	    },
	    mapLoaded: function mapLoaded(map) {
	      return dispatch({
	        type: 'MAP_LOADED',
	        payload: {
	          map: map
	        }
	      });
	    },
	    getNeighborhoodsSamples: function getNeighborhoodsSamples(year) {
	      dispatch({
	        type: 'GET_NEIGHBORHOODS_SAMPLES',
	        payload: {
	          year: year
	        }
	      });
	    },
	    getNeighborhoodHexes: function getNeighborhoodHexes(neighborhood_name) {
	      dispatch({
	        type: 'GET_NEIGHBORHOOD_HEXES',
	        payload: {
	          neighborhood: neighborhood_name
	        }
	      });
	    },
	    setFeatureHover: function setFeatureHover(feature) {
	      return dispatch({
	        type: 'SET_FEATURE_HOVER',
	        payload: {
	          feature: feature
	        }
	      });
	    },
	    toggleMobile: function toggleMobile(value) {
	      return dispatch({
	        type: 'TOGGLE_MOBILE',
	        payload: {
	          value: value
	        }
	      });
	    },
	    prospectHeights2010: function prospectHeights2010() {
	      return dispatch({
	        type: 'PROSPECT_HEIGHTS_2010'
	      });
	    },
	    prospectHeights2016: function prospectHeights2016() {
	      return dispatch({
	        type: 'PROSPECT_HEIGHTS_2016'
	      });
	    }
	  };
	})(_Apper2.default);
	
	exports.default = ApperContainer;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(327);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _superagent = __webpack_require__(358);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _co = __webpack_require__(152);
	
	var _co2 = _interopRequireDefault(_co);
	
	var _store = __webpack_require__(356);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _msgpackLite = __webpack_require__(185);
	
	var _msgpackLite2 = _interopRequireDefault(_msgpackLite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Neighborhoods from './static/data/new_neighborhoods';
	
	
	var getNeighborhoodPromises = function getNeighborhoodPromises(neighborhoods, year) {
	  var neighborhood_sample_promises = [];
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = neighborhoods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var neighborhood = _step.value;
	
	      var neighborhood_name = neighborhood.properties.neighborhood;
	      var sample_string = 'borough=' + neighborhood.properties.borough + '&neighborhood=' + neighborhood_name + '&year=' + year + '&num_samples=500';
	      var request_promise = _superagent2.default.get('http://toymaker.local:5000/api/sample?' + sample_string);
	      neighborhood_sample_promises.push(request_promise);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return neighborhood_sample_promises;
	};
	
	var getNeighborhoodsSamples = function getNeighborhoodsSamples(store, year, next) {
	  var _store$getState = store.getState();
	
	  var neighborhoods = _store$getState.neighborhoods;
	  var neighborhoods_samples = _store$getState.neighborhoods_samples;
	
	  if (!neighborhoods_samples) neighborhoods_samples = {};
	  if (neighborhoods_samples[year] === undefined) {
	    // Check localStorage
	    var storage_sample_check = _store2.default.get('neighborhoods_samples');
	    if (storage_sample_check !== undefined && storage_sample_check[year] !== undefined) {
	      return next({
	        type: 'GOT_NEIGHBORHOODS_SAMPLES',
	        payload: {
	          neighborhoods_samples: storage_sample_check
	        }
	      });
	    } else {
	      (function () {
	        var neighborhood_promises = getNeighborhoodPromises(neighborhoods, year);
	        (0, _co2.default)(_regenerator2.default.mark(function _callee() {
	          var sample_response_array, returned_neighborhoods_samples;
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  _context.next = 2;
	                  return neighborhood_promises;
	
	                case 2:
	                  sample_response_array = _context.sent;
	                  returned_neighborhoods_samples = sample_response_array.map(function (response, i) {
	                    var samples = JSON.parse(response.text);
	                    var sample_prices = samples.map(function (sample) {
	                      return Math.round(sample.price);
	                    });
	                    return sample_prices;
	                  });
	
	                  neighborhoods_samples[year] = returned_neighborhoods_samples;
	                  _store2.default.set('neighborhoods_samples', neighborhoods_samples);
	                  return _context.abrupt('return', next({
	                    type: 'GOT_NEIGHBORHOODS_SAMPLES',
	                    payload: {
	                      neighborhoods_samples: neighborhoods_samples
	                    }
	                  }));
	
	                case 7:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, this);
	        })).catch(function (err) {
	          console.error(err.stack);
	        });
	      })();
	    }
	  } else {
	    return next({
	      type: 'GOT_NEIGHBORHOODS_SAMPLES',
	      payload: {
	        neighborhoods_samples: neighborhoods_samples
	      }
	    });
	  }
	};
	
	var getNeighborhoodHexes = function getNeighborhoodHexes(action, next) {
	  if (action.payload.neighborhood) {
	    (function () {
	      var neighb_name = action.payload.neighborhood.toLowerCase().replace(/ /g, '_');
	      fetch('https://s3.amazonaws.com/fflprototypespub/ff05/neighborhoods_geometry/' + neighb_name + '.geojson').then(function (response) {
	        return response.json();
	      }).then(function (json) {
	        var variation = Math.floor(Math.random() * 10);
	        if (variation.toString().length === 1) variation = '0' + variation;
	        var url = 'https://s3.amazonaws.com/fflprototypespub/ff05/neighborhoods/' + neighb_name + '_' + variation + '.msgpck';
	        fetch(url).then(function (response) {
	          return response.arrayBuffer();
	        }).then(function (buffer) {
	          var hex_geojson = json.features;
	          var hexes = _msgpackLite2.default.decode(new Buffer(buffer));
	          var geojson_ids = hex_geojson.map(function (geo) {
	            return geo.properties.hexid.toString();
	          });
	          var sorted_geojson = hexes.locations.map(function (hexid) {
	            var index = geojson_ids.indexOf(hexid);
	            return hex_geojson[index];
	          });
	          var years = [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018];
	          var sorted = years.map(function (year, i) {
	            var year_samples = hexes.samples[year];
	            year_samples.map(function (hex_samples, i) {
	              return hex_samples.sort(function (a, b) {
	                if (a < b) return -1;
	                if (a > b) return 1;
	                return 0;
	              });
	            });
	            return year_samples;
	          });
	          var hex_samples_sorted = {};
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = sorted.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var s = _step2.value;
	
	              var _s = _slicedToArray(s, 2);
	
	              var i = _s[0];
	              var sortee = _s[1];
	
	              var year = years[i];
	              hex_samples_sorted[year] = sortee;
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	
	          return next({
	            type: 'GOT_NEIGHBORHOOD_HEXES',
	            payload: {
	              hex_geojson: sorted_geojson,
	              hex_samples: hex_samples_sorted
	            }
	          });
	        });
	      });
	    })();
	  };
	};
	
	var dataService = function dataService(store) {
	  return function (next) {
	    return function (action) {
	      next(action);
	      switch (action.type) {
	        case 'GET_NEIGHBORHOOD_HEXES':
	          getNeighborhoodHexes(action, next);
	          break;
	        case 'GET_NEIGHBORHOODS_SAMPLES':
	          var variation = Math.floor(Math.random() * 10);
	          if (variation.toString().length === 1) variation = '0' + variation;
	          var url = 'https://s3.amazonaws.com/fflprototypespub/ff05/neighborhoods_' + variation + '.msgpck';
	          fetch(url).then(function (response) {
	            return response.arrayBuffer();
	          }).then(function (buffer) {
	            var json = _msgpackLite2.default.decode(new Buffer(buffer));
	            var years = [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018];
	            var sorted = years.map(function (year, i) {
	              var year_samples = json.samples[year];
	              year_samples.map(function (neighborhoods_samples, i) {
	                return neighborhoods_samples.sort(function (a, b) {
	                  if (a < b) return -1;
	                  if (a > b) return 1;
	                  return 0;
	                });
	              });
	              return year_samples;
	            });
	            var neighborhoods_samples_sorted = {};
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	              for (var _iterator3 = sorted.entries()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var s = _step3.value;
	
	                var _s2 = _slicedToArray(s, 2);
	
	                var i = _s2[0];
	                var sortee = _s2[1];
	
	                var year = years[i];
	                neighborhoods_samples_sorted[year] = sortee;
	              }
	            } catch (err) {
	              _didIteratorError3 = true;
	              _iteratorError3 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                  _iterator3.return();
	                }
	              } finally {
	                if (_didIteratorError3) {
	                  throw _iteratorError3;
	                }
	              }
	            }
	
	            return next({
	              type: 'GOT_NEIGHBORHOODS_SAMPLES',
	              payload: {
	                neighborhoods_samples: neighborhoods_samples_sorted
	              }
	            });
	          });
	          break;
	        default:
	          break;
	      }
	    };
	  };
	};
	
	exports.default = dataService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50).Buffer))

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(201);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(49);
	
	var _redux = __webpack_require__(88);
	
	var _reactRedux = __webpack_require__(131);
	
	var _reduxResponsive = __webpack_require__(147);
	
	var _reducer = __webpack_require__(322);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _App = __webpack_require__(318);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _dataService = __webpack_require__(320);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _redux.createStore)(_reducer2.default, (0, _redux.compose)(_reduxResponsive.responsiveStoreEnhancer, (0, _redux.applyMiddleware)(_dataService2.default), window.devToolsExtension ? window.devToolsExtension() : function (f) {
	  return f;
	}));
	
	_reactDom2.default.render(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(
	    _reactRouter.Router,
	    { history: _reactRouter.hashHistory },
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: '/', component: _App2.default },
	      _react2.default.createElement(_reactRouter.IndexRedirect, { to: '/probability/1000000-50/2016/all_boroughs/all_neighborhoods', query: { explainer: true } }),
	      _react2.default.createElement(_reactRouter.Route, { path: ':mode/:active_var/:year/:borough_filter/:neighborhood(/:hex)', component: _App2.default })
	    )
	  )
	), document.getElementById('root'));

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _new_neighborhoods = __webpack_require__(326);
	
	var _new_neighborhoods2 = _interopRequireDefault(_new_neighborhoods);
	
	var _redux = __webpack_require__(88);
	
	var _reduxResponsive = __webpack_require__(147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var App = function App() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? { active_year: 2016, active_price: 1000000, map: false, neighborhoods: _new_neighborhoods2.default.features, neighborhoods_samples: false, active_mode: 'Chance', active_probability: 0.5, price_focus: false, probability_focus: false, active_neighborhood: false, hex_arrays: false, borough_filter: false, active_hex: false, show_roads: true, explainer: true, mobile_toggle: true } : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'MAP_LOADED':
	      {
	        var active_year = state.active_year;
	        var active_price = state.active_price;
	        var neighborhoods = state.neighborhoods;
	        var neighborhoods_samples = state.neighborhoods_samples;
	        var active_mode = state.active_mode;
	        var active_probability = state.active_probability;
	        var price_focus = state.price_focus;
	        var probability_focus = state.probability_focus;
	        var active_neighborhood = state.active_neighborhood;
	        var borough_filter = state.borough_filter;
	        var hex_arrays = state.hex_arrays;
	        var active_hex = state.active_hex;
	        var show_roads = state.show_roads;
	        var explainer = state.explainer;
	        var mobile_toggle = state.mobile_toggle;
	
	        var map = action.payload.map;
	        return {
	          active_year: active_year,
	          active_price: active_price,
	          map: map,
	          neighborhoods: neighborhoods,
	          neighborhoods_samples: neighborhoods_samples,
	          active_mode: active_mode,
	          active_probability: active_probability,
	          price_focus: price_focus,
	          probability_focus: probability_focus,
	          active_neighborhood: active_neighborhood,
	          borough_filter: borough_filter,
	          hex_arrays: hex_arrays,
	          active_hex: active_hex,
	          show_roads: show_roads,
	          explainer: explainer,
	          mobile_toggle: mobile_toggle
	        };
	      }
	    case 'GOT_NEIGHBORHOODS_SAMPLES':
	      {
	        var _active_year = state.active_year;
	        var _active_price = state.active_price;
	        var _neighborhoods = state.neighborhoods;
	        var _map = state.map;
	        var _active_mode = state.active_mode;
	        var _active_probability = state.active_probability;
	        var _price_focus = state.price_focus;
	        var _probability_focus = state.probability_focus;
	        var _active_neighborhood = state.active_neighborhood;
	        var _borough_filter = state.borough_filter;
	        var _hex_arrays = state.hex_arrays;
	        var _active_hex = state.active_hex;
	        var _show_roads = state.show_roads;
	        var _explainer = state.explainer;
	        var _mobile_toggle = state.mobile_toggle;
	
	        var _neighborhoods_samples = action.payload.neighborhoods_samples;
	        return {
	          active_year: _active_year,
	          active_price: _active_price,
	          map: _map,
	          neighborhoods: _neighborhoods,
	          neighborhoods_samples: _neighborhoods_samples,
	          active_mode: _active_mode,
	          active_probability: _active_probability,
	          price_focus: _price_focus,
	          probability_focus: _probability_focus,
	          active_neighborhood: _active_neighborhood,
	          borough_filter: _borough_filter,
	          hex_arrays: _hex_arrays,
	          active_hex: _active_hex,
	          show_roads: _show_roads,
	          explainer: _explainer,
	          mobile_toggle: _mobile_toggle
	        };
	      }
	    case 'CHANGE_ACTIVE_YEAR':
	      {
	        var _active_price2 = state.active_price;
	        var _map2 = state.map;
	        var _neighborhoods2 = state.neighborhoods;
	        var _neighborhoods_samples2 = state.neighborhoods_samples;
	        var _active_mode2 = state.active_mode;
	        var _active_probability2 = state.active_probability;
	        var _price_focus2 = state.price_focus;
	        var _probability_focus2 = state.probability_focus;
	        var _active_neighborhood2 = state.active_neighborhood;
	        var _borough_filter2 = state.borough_filter;
	        var _hex_arrays2 = state.hex_arrays;
	        var _active_hex2 = state.active_hex;
	        var _show_roads2 = state.show_roads;
	        var _explainer2 = state.explainer;
	        var _mobile_toggle2 = state.mobile_toggle;
	
	        var _active_year2 = parseFloat(action.payload.year);
	        return {
	          active_year: _active_year2,
	          active_price: _active_price2,
	          map: _map2,
	          neighborhoods: _neighborhoods2,
	          neighborhoods_samples: _neighborhoods_samples2,
	          active_mode: _active_mode2,
	          active_probability: _active_probability2,
	          price_focus: _price_focus2,
	          probability_focus: _probability_focus2,
	          active_neighborhood: _active_neighborhood2,
	          borough_filter: _borough_filter2,
	          hex_arrays: _hex_arrays2,
	          active_hex: _active_hex2,
	          show_roads: _show_roads2,
	          explainer: _explainer2,
	          mobile_toggle: _mobile_toggle2
	        };
	      }
	    case 'CHANGE_ACTIVE_PRICE':
	      {
	        var _active_year3 = state.active_year;
	        var _map3 = state.map;
	        var _neighborhoods3 = state.neighborhoods;
	        var _neighborhoods_samples3 = state.neighborhoods_samples;
	        var _active_mode3 = state.active_mode;
	        var _active_probability3 = state.active_probability;
	        var _price_focus3 = state.price_focus;
	        var _probability_focus3 = state.probability_focus;
	        var _active_neighborhood3 = state.active_neighborhood;
	        var _borough_filter3 = state.borough_filter;
	        var _hex_arrays3 = state.hex_arrays;
	        var _active_hex3 = state.active_hex;
	        var _show_roads3 = state.show_roads;
	        var _explainer3 = state.explainer;
	        var _mobile_toggle3 = state.mobile_toggle;
	
	        var _active_price3 = parseFloat(action.payload.price);
	        return {
	          active_year: _active_year3,
	          active_price: _active_price3,
	          map: _map3,
	          neighborhoods: _neighborhoods3,
	          neighborhoods_samples: _neighborhoods_samples3,
	          active_mode: _active_mode3,
	          active_probability: _active_probability3,
	          price_focus: _price_focus3,
	          probability_focus: _probability_focus3,
	          active_neighborhood: _active_neighborhood3,
	          borough_filter: _borough_filter3,
	          hex_arrays: _hex_arrays3,
	          active_hex: _active_hex3,
	          show_roads: _show_roads3,
	          explainer: _explainer3,
	          mobile_toggle: _mobile_toggle3
	        };
	      }
	    case 'CHANGE_ACTIVE_MODE':
	      {
	        var _active_year4 = state.active_year;
	        var _map4 = state.map;
	        var _neighborhoods4 = state.neighborhoods;
	        var _neighborhoods_samples4 = state.neighborhoods_samples;
	        var _active_price4 = state.active_price;
	        var _active_probability4 = state.active_probability;
	        var _price_focus4 = state.price_focus;
	        var _probability_focus4 = state.probability_focus;
	        var _active_neighborhood4 = state.active_neighborhood;
	        var _borough_filter4 = state.borough_filter;
	        var _hex_arrays4 = state.hex_arrays;
	        var _active_hex4 = state.active_hex;
	        var _show_roads4 = state.show_roads;
	        var _explainer4 = state.explainer;
	        var _mobile_toggle4 = state.mobile_toggle;
	
	        var _active_mode4 = action.payload.mode;
	        return {
	          active_year: _active_year4,
	          active_price: _active_price4,
	          map: _map4,
	          neighborhoods: _neighborhoods4,
	          neighborhoods_samples: _neighborhoods_samples4,
	          active_mode: _active_mode4,
	          active_probability: _active_probability4,
	          price_focus: _price_focus4,
	          probability_focus: _probability_focus4,
	          active_neighborhood: _active_neighborhood4,
	          borough_filter: _borough_filter4,
	          hex_arrays: _hex_arrays4,
	          active_hex: _active_hex4,
	          show_roads: _show_roads4,
	          explainer: _explainer4,
	          mobile_toggle: _mobile_toggle4
	        };
	      }
	    case 'CHANGE_ACTIVE_PROBABILITY':
	      {
	        var _active_year5 = state.active_year;
	        var _map5 = state.map;
	        var _neighborhoods5 = state.neighborhoods;
	        var _neighborhoods_samples5 = state.neighborhoods_samples;
	        var _active_price5 = state.active_price;
	        var _active_mode5 = state.active_mode;
	        var _price_focus5 = state.price_focus;
	        var _probability_focus5 = state.probability_focus;
	        var _active_neighborhood5 = state.active_neighborhood;
	        var _borough_filter5 = state.borough_filter;
	        var _hex_arrays5 = state.hex_arrays;
	        var _active_hex5 = state.active_hex;
	        var _show_roads5 = state.show_roads;
	        var _explainer5 = state.explainer;
	        var _mobile_toggle5 = state.mobile_toggle;
	
	        var _active_probability5 = parseFloat(action.payload.probability);
	        return {
	          active_year: _active_year5,
	          active_price: _active_price5,
	          map: _map5,
	          neighborhoods: _neighborhoods5,
	          neighborhoods_samples: _neighborhoods_samples5,
	          active_mode: _active_mode5,
	          active_probability: _active_probability5,
	          price_focus: _price_focus5,
	          probability_focus: _probability_focus5,
	          active_neighborhood: _active_neighborhood5,
	          borough_filter: _borough_filter5,
	          hex_arrays: _hex_arrays5,
	          active_hex: _active_hex5,
	          show_roads: _show_roads5,
	          explainer: _explainer5,
	          mobile_toggle: _mobile_toggle5
	        };
	      }
	    case 'CHANGE_PRICE_FOCUS':
	      {
	        var _active_year6 = state.active_year;
	        var _map6 = state.map;
	        var _neighborhoods6 = state.neighborhoods;
	        var _neighborhoods_samples6 = state.neighborhoods_samples;
	        var _active_price6 = state.active_price;
	        var _active_mode6 = state.active_mode;
	        var _active_probability6 = state.active_probability;
	        var _probability_focus6 = state.probability_focus;
	        var _active_neighborhood6 = state.active_neighborhood;
	        var _borough_filter6 = state.borough_filter;
	        var _hex_arrays6 = state.hex_arrays;
	        var _active_hex6 = state.active_hex;
	        var _show_roads6 = state.show_roads;
	        var _explainer6 = state.explainer;
	        var _mobile_toggle6 = state.mobile_toggle;
	
	        var _price_focus6 = parseFloat(action.payload.price);
	        return {
	          active_year: _active_year6,
	          active_price: _active_price6,
	          map: _map6,
	          neighborhoods: _neighborhoods6,
	          neighborhoods_samples: _neighborhoods_samples6,
	          active_mode: _active_mode6,
	          active_probability: _active_probability6,
	          price_focus: _price_focus6,
	          probability_focus: _probability_focus6,
	          active_neighborhood: _active_neighborhood6,
	          borough_filter: _borough_filter6,
	          hex_arrays: _hex_arrays6,
	          active_hex: _active_hex6,
	          show_roads: _show_roads6,
	          explainer: _explainer6,
	          mobile_toggle: _mobile_toggle6
	        };
	      }
	    case 'CHANGE_PROBABILITY_FOCUS':
	      {
	        var _active_year7 = state.active_year;
	        var _map7 = state.map;
	        var _neighborhoods7 = state.neighborhoods;
	        var _neighborhoods_samples7 = state.neighborhoods_samples;
	        var _active_price7 = state.active_price;
	        var _active_mode7 = state.active_mode;
	        var _active_probability7 = state.active_probability;
	        var _price_focus7 = state.price_focus;
	        var _active_neighborhood7 = state.active_neighborhood;
	        var _borough_filter7 = state.borough_filter;
	        var _hex_arrays7 = state.hex_arrays;
	        var _active_hex7 = state.active_hex;
	        var _show_roads7 = state.show_roads;
	        var _explainer7 = state.explainer;
	        var _mobile_toggle7 = state.mobile_toggle;
	
	        var _probability_focus7 = false;
	        if (action.payload.probability !== false) {
	          _probability_focus7 = parseFloat(action.payload.probability);
	        }
	        return {
	          active_year: _active_year7,
	          active_price: _active_price7,
	          map: _map7,
	          neighborhoods: _neighborhoods7,
	          neighborhoods_samples: _neighborhoods_samples7,
	          active_mode: _active_mode7,
	          active_probability: _active_probability7,
	          price_focus: _price_focus7,
	          probability_focus: _probability_focus7,
	          active_neighborhood: _active_neighborhood7,
	          borough_filter: _borough_filter7,
	          hex_arrays: _hex_arrays7,
	          active_hex: _active_hex7,
	          show_roads: _show_roads7,
	          explainer: _explainer7,
	          mobile_toggle: _mobile_toggle7
	        };
	      }
	    case 'SET_ACTIVE_NEIGHBORHOOD':
	      {
	        var _active_year8 = state.active_year;
	        var _map8 = state.map;
	        var _neighborhoods8 = state.neighborhoods;
	        var _neighborhoods_samples8 = state.neighborhoods_samples;
	        var _active_price8 = state.active_price;
	        var _active_mode8 = state.active_mode;
	        var _active_probability8 = state.active_probability;
	        var _price_focus8 = state.price_focus;
	        var _probability_focus8 = state.probability_focus;
	        var _borough_filter8 = state.borough_filter;
	        var _active_hex8 = state.active_hex;
	        var _show_roads8 = state.show_roads;
	        var _explainer8 = state.explainer;
	        var _mobile_toggle8 = state.mobile_toggle;
	
	        var _active_neighborhood8 = action.payload.neighborhood;
	        var _hex_arrays8 = false;
	        return {
	          active_year: _active_year8,
	          active_price: _active_price8,
	          map: _map8,
	          neighborhoods: _neighborhoods8,
	          neighborhoods_samples: _neighborhoods_samples8,
	          active_mode: _active_mode8,
	          active_probability: _active_probability8,
	          price_focus: _price_focus8,
	          probability_focus: _probability_focus8,
	          active_neighborhood: _active_neighborhood8,
	          borough_filter: _borough_filter8,
	          hex_arrays: _hex_arrays8,
	          active_hex: _active_hex8,
	          show_roads: _show_roads8,
	          explainer: _explainer8,
	          mobile_toggle: _mobile_toggle8
	        };
	      }
	    case 'GOT_NEIGHBORHOOD_HEXES':
	      {
	        var _active_year9 = state.active_year;
	        var _map9 = state.map;
	        var _neighborhoods9 = state.neighborhoods;
	        var _neighborhoods_samples9 = state.neighborhoods_samples;
	        var _active_price9 = state.active_price;
	        var _active_mode9 = state.active_mode;
	        var _active_probability9 = state.active_probability;
	        var _price_focus9 = state.price_focus;
	        var _probability_focus9 = state.probability_focus;
	        var _active_neighborhood9 = state.active_neighborhood;
	        var _borough_filter9 = state.borough_filter;
	        var _active_hex9 = state.active_hex;
	        var _show_roads9 = state.show_roads;
	        var _explainer9 = state.explainer;
	        var _mobile_toggle9 = state.mobile_toggle;
	
	        var _hex_arrays9 = action.payload;
	        return {
	          active_year: _active_year9,
	          active_price: _active_price9,
	          map: _map9,
	          neighborhoods: _neighborhoods9,
	          neighborhoods_samples: _neighborhoods_samples9,
	          active_mode: _active_mode9,
	          active_probability: _active_probability9,
	          price_focus: _price_focus9,
	          probability_focus: _probability_focus9,
	          active_neighborhood: _active_neighborhood9,
	          borough_filter: _borough_filter9,
	          hex_arrays: _hex_arrays9,
	          active_hex: _active_hex9,
	          show_roads: _show_roads9,
	          explainer: _explainer9,
	          mobile_toggle: _mobile_toggle9
	        };
	      }
	    case 'SET_ACTIVE_HEX':
	      {
	        var _active_year10 = state.active_year;
	        var _map10 = state.map;
	        var _neighborhoods10 = state.neighborhoods;
	        var _neighborhoods_samples10 = state.neighborhoods_samples;
	        var _active_price10 = state.active_price;
	        var _active_mode10 = state.active_mode;
	        var _active_probability10 = state.active_probability;
	        var _price_focus10 = state.price_focus;
	        var _probability_focus10 = state.probability_focus;
	        var _borough_filter10 = state.borough_filter;
	        var _hex_arrays10 = state.hex_arrays;
	        var _active_neighborhood10 = state.active_neighborhood;
	        var _show_roads10 = state.show_roads;
	        var _explainer10 = state.explainer;
	        var _mobile_toggle10 = state.mobile_toggle;
	
	        var _active_hex10 = action.payload.hex;
	        return {
	          active_year: _active_year10,
	          active_price: _active_price10,
	          map: _map10,
	          neighborhoods: _neighborhoods10,
	          neighborhoods_samples: _neighborhoods_samples10,
	          active_mode: _active_mode10,
	          active_probability: _active_probability10,
	          price_focus: _price_focus10,
	          probability_focus: _probability_focus10,
	          active_neighborhood: _active_neighborhood10,
	          borough_filter: _borough_filter10,
	          hex_arrays: _hex_arrays10,
	          active_hex: _active_hex10,
	          show_roads: _show_roads10,
	          explainer: _explainer10,
	          mobile_toggle: _mobile_toggle10
	        };
	      }
	    case 'SET_BOROUGH_FILTER':
	      {
	        var _active_year11 = state.active_year;
	        var _map11 = state.map;
	        var _neighborhoods11 = state.neighborhoods;
	        var _neighborhoods_samples11 = state.neighborhoods_samples;
	        var _active_price11 = state.active_price;
	        var _active_mode11 = state.active_mode;
	        var _active_probability11 = state.active_probability;
	        var _price_focus11 = state.price_focus;
	        var _probability_focus11 = state.probability_focus;
	        var _active_neighborhood11 = state.active_neighborhood;
	        var _hex_arrays11 = state.hex_arrays;
	        var _active_hex11 = state.active_hex;
	        var _show_roads11 = state.show_roads;
	        var _explainer11 = state.explainer;
	        var _mobile_toggle11 = state.mobile_toggle;
	
	        var _borough_filter11 = action.payload.borough;
	        return {
	          active_year: _active_year11,
	          active_price: _active_price11,
	          map: _map11,
	          neighborhoods: _neighborhoods11,
	          neighborhoods_samples: _neighborhoods_samples11,
	          active_mode: _active_mode11,
	          active_probability: _active_probability11,
	          price_focus: _price_focus11,
	          probability_focus: _probability_focus11,
	          active_neighborhood: _active_neighborhood11,
	          borough_filter: _borough_filter11,
	          hex_arrays: _hex_arrays11,
	          active_hex: _active_hex11,
	          show_roads: _show_roads11,
	          explainer: _explainer11,
	          mobile_toggle: _mobile_toggle11
	        };
	      }
	    case 'SET_SHOW_ROADS':
	      {
	        var _active_year12 = state.active_year;
	        var _map12 = state.map;
	        var _neighborhoods12 = state.neighborhoods;
	        var _neighborhoods_samples12 = state.neighborhoods_samples;
	        var _active_price12 = state.active_price;
	        var _active_mode12 = state.active_mode;
	        var _active_probability12 = state.active_probability;
	        var _price_focus12 = state.price_focus;
	        var _probability_focus12 = state.probability_focus;
	        var _active_neighborhood12 = state.active_neighborhood;
	        var _hex_arrays12 = state.hex_arrays;
	        var _active_hex12 = state.active_hex;
	        var _borough_filter12 = state.borough_filter;
	        var _explainer12 = state.explainer;
	        var _mobile_toggle12 = state.mobile_toggle;
	
	        return {
	          active_year: _active_year12,
	          active_price: _active_price12,
	          map: _map12,
	          neighborhoods: _neighborhoods12,
	          neighborhoods_samples: _neighborhoods_samples12,
	          active_mode: _active_mode12,
	          active_probability: _active_probability12,
	          price_focus: _price_focus12,
	          probability_focus: _probability_focus12,
	          active_neighborhood: _active_neighborhood12,
	          borough_filter: _borough_filter12,
	          hex_arrays: _hex_arrays12,
	          active_hex: _active_hex12,
	          show_roads: action.payload.value,
	          explainer: _explainer12,
	          mobile_toggle: _mobile_toggle12
	        };
	      }
	    case 'SET_EXPLAINER':
	      {
	        var _active_year13 = state.active_year;
	        var _map13 = state.map;
	        var _neighborhoods13 = state.neighborhoods;
	        var _neighborhoods_samples13 = state.neighborhoods_samples;
	        var _active_price13 = state.active_price;
	        var _active_mode13 = state.active_mode;
	        var _active_probability13 = state.active_probability;
	        var _price_focus13 = state.price_focus;
	        var _probability_focus13 = state.probability_focus;
	        var _active_neighborhood13 = state.active_neighborhood;
	        var _hex_arrays13 = state.hex_arrays;
	        var _active_hex13 = state.active_hex;
	        var _borough_filter13 = state.borough_filter;
	        var _show_roads12 = state.show_roads;
	        var _mobile_toggle13 = state.mobile_toggle;
	
	        return {
	          active_year: _active_year13,
	          active_price: _active_price13,
	          map: _map13,
	          neighborhoods: _neighborhoods13,
	          neighborhoods_samples: _neighborhoods_samples13,
	          active_mode: _active_mode13,
	          active_probability: _active_probability13,
	          price_focus: _price_focus13,
	          probability_focus: _probability_focus13,
	          active_neighborhood: _active_neighborhood13,
	          borough_filter: _borough_filter13,
	          hex_arrays: _hex_arrays13,
	          active_hex: _active_hex13,
	          show_roads: _show_roads12,
	          explainer: action.payload.value,
	          mobile_toggle: _mobile_toggle13
	        };
	      }
	    case 'TOGGLE_MOBILE':
	      {
	        var _active_year14 = state.active_year;
	        var _map14 = state.map;
	        var _neighborhoods14 = state.neighborhoods;
	        var _neighborhoods_samples14 = state.neighborhoods_samples;
	        var _active_price14 = state.active_price;
	        var _active_mode14 = state.active_mode;
	        var _active_probability14 = state.active_probability;
	        var _price_focus14 = state.price_focus;
	        var _probability_focus14 = state.probability_focus;
	        var _active_neighborhood14 = state.active_neighborhood;
	        var _hex_arrays14 = state.hex_arrays;
	        var _active_hex14 = state.active_hex;
	        var _borough_filter14 = state.borough_filter;
	        var _show_roads13 = state.show_roads;
	        var _explainer13 = state.explainer;
	
	        return {
	          active_year: _active_year14,
	          active_price: _active_price14,
	          map: _map14,
	          neighborhoods: _neighborhoods14,
	          neighborhoods_samples: _neighborhoods_samples14,
	          active_mode: _active_mode14,
	          active_probability: _active_probability14,
	          price_focus: _price_focus14,
	          probability_focus: _probability_focus14,
	          active_neighborhood: _active_neighborhood14,
	          borough_filter: _borough_filter14,
	          hex_arrays: _hex_arrays14,
	          active_hex: _active_hex14,
	          show_roads: _show_roads13,
	          explainer: _explainer13,
	          mobile_toggle: action.payload.value
	        };
	      }
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  app: App,
	  browser: _reduxResponsive.responsiveStateReducer
	});

/***/ },
/* 323 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var borough_labels = {
	  "type": "FeatureCollection",
	  "features": [{
	    "type": "Feature",
	    "geometry": {
	      "type": "Point",
	      "coordinates": [-73.96650782568467, 40.783233713850535]
	    },
	    "properties": {
	      "name": "Manhattan"
	    }
	  }, {
	    "type": "Feature",
	    "geometry": {
	      "type": "Point",
	      "coordinates": [-73.8733309306482, 40.851231985684734]
	    },
	    "properties": {
	      "name": "Bronx"
	    }
	  }, {
	    "type": "Feature",
	    "geometry": {
	      "type": "Point",
	      "coordinates": [-73.81209808316632, 40.72849600779969]
	    },
	    "properties": {
	      "name": "Queens"
	    }
	  }, {
	    "type": "Feature",
	    "geometry": {
	      "type": "Point",
	      "coordinates": [-73.95577540845343, 40.65435912989912]
	    },
	    "properties": {
	      "name": "Brooklyn"
	    }
	  }, {
	    "type": "Feature",
	    "geometry": {
	      "type": "Point",
	      "coordinates": [-74.15199701416635, 40.58366082400295]
	    },
	    "properties": {
	      "name": "Staten Island"
	    }
	  }]
	};
	exports.default = borough_labels;

/***/ },
/* 324 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:true});var Boroughs={"type":"FeatureCollection","features":[{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-74.25402494919243,40.50405],[-74.255757,40.50405],[-74.25662302540378,40.50555],[-74.255757,40.50705],[-74.25662302540378,40.50855],[-74.255757,40.51005],[-74.25402494919243,40.51005],[-74.25315892378865,40.51155],[-74.25402494919243,40.51305],[-74.25315892378865,40.51455],[-74.25142687298107,40.51455],[-74.25056084757729,40.51605],[-74.24882879676971,40.51605],[-74.24796277136593,40.51755],[-74.24623072055836,40.51755],[-74.24536469515458,40.51905],[-74.243632644347,40.51905],[-74.24276661894322,40.52055],[-74.243632644347,40.52205],[-74.24276661894322,40.52355],[-74.243632644347,40.52505],[-74.24276661894322,40.52655],[-74.243632644347,40.52805],[-74.24276661894322,40.52955],[-74.243632644347,40.53105],[-74.24276661894322,40.53255],[-74.243632644347,40.53405],[-74.24276661894322,40.53555],[-74.243632644347,40.53705],[-74.24536469515458,40.53705],[-74.24623072055836,40.53855],[-74.24536469515458,40.54005],[-74.24623072055836,40.54155],[-74.24536469515458,40.54305],[-74.243632644347,40.54305],[-74.24276661894322,40.54455],[-74.24103456813565,40.54455],[-74.24016854273187,40.54305],[-74.23843649192429,40.54305],[-74.23757046652051,40.54455],[-74.23583841571293,40.54455],[-74.23497239030915,40.54605],[-74.23583841571293,40.54755],[-74.23497239030915,40.54905],[-74.23583841571293,40.55055],[-74.23757046652051,40.55055],[-74.23843649192429,40.55205],[-74.23757046652051,40.55355],[-74.23583841571293,40.55355],[-74.23497239030915,40.55505],[-74.23324033950158,40.55505],[-74.2323743140978,40.55355],[-74.23064226329022,40.55355],[-74.22977623788644,40.55205],[-74.22804418707886,40.55205],[-74.22717816167508,40.55355],[-74.22804418707886,40.55505],[-74.22717816167508,40.55655],[-74.22544611086751,40.55655],[-74.22458008546373,40.55505],[-74.22284803465615,40.55505],[-74.22198200925237,40.55655],[-74.2202499584448,40.55655],[-74.21938393304102,40.55505],[-74.21765188223344,40.55505],[-74.21678585682966,40.55655],[-74.21505380602208,40.55655],[-74.2141877806183,40.55805],[-74.21245572981073,40.55805],[-74.21158970440695,40.55955],[-74.20985765359937,40.55955],[-74.20899162819559,40.55805],[-74.20725957738802,40.55805],[-74.20639355198423,40.55655],[-74.20466150117666,40.55655],[-74.20379547577288,40.55805],[-74.2020634249653,40.55805],[-74.20119739956152,40.55955],[-74.2020634249653,40.56105],[-74.20119739956152,40.56255],[-74.19946534875395,40.56255],[-74.19859932335017,40.56405],[-74.19686727254259,40.56405],[-74.19600124713881,40.56255],[-74.19426919633123,40.56255],[-74.19340317092745,40.56405],[-74.19426919633123,40.56555],[-74.19340317092745,40.56705],[-74.19167112011988,40.56705],[-74.1908050947161,40.56555],[-74.18907304390852,40.56555],[-74.18820701850474,40.56705],[-74.18647496769717,40.56705],[-74.18560894229338,40.56855],[-74.18387689148581,40.56855],[-74.18301086608203,40.57005],[-74.18387689148581,40.57155],[-74.18301086608203,40.57305],[-74.18387689148581,40.57455],[-74.18560894229338,40.57455],[-74.18647496769717,40.57605],[-74.18820701850474,40.57605],[-74.18907304390852,40.57755],[-74.1908050947161,40.57755],[-74.19167112011988,40.57605],[-74.19340317092745,40.57605],[-74.19426919633123,40.57755],[-74.19600124713881,40.57755],[-74.19686727254259,40.57905],[-74.19859932335017,40.57905],[-74.19946534875395,40.57755],[-74.20119739956152,40.57755],[-74.2020634249653,40.57905],[-74.20119739956152,40.58055],[-74.2020634249653,40.58205],[-74.20119739956152,40.58355],[-74.2020634249653,40.58505],[-74.20379547577288,40.58505],[-74.20466150117666,40.58355],[-74.20639355198423,40.58355],[-74.20725957738802,40.58505],[-74.20639355198423,40.58655],[-74.20466150117666,40.58655],[-74.20379547577288,40.58805],[-74.20466150117666,40.58955],[-74.20379547577288,40.59105],[-74.2020634249653,40.59105],[-74.20119739956152,40.59255],[-74.19946534875395,40.59255],[-74.19859932335017,40.59105],[-74.19686727254259,40.59105],[-74.19600124713881,40.59255],[-74.19426919633123,40.59255],[-74.19340317092745,40.59405],[-74.19426919633123,40.59555],[-74.19600124713881,40.59555],[-74.19686727254259,40.59705],[-74.19859932335017,40.59705],[-74.19946534875395,40.59855],[-74.19859932335017,40.60005],[-74.19946534875395,40.60155],[-74.19859932335017,40.60305],[-74.19946534875395,40.60455],[-74.19859932335017,40.60605],[-74.19946534875395,40.60755],[-74.19859932335017,40.60905],[-74.19946534875395,40.61055],[-74.19859932335017,40.61205],[-74.19686727254259,40.61205],[-74.19600124713881,40.613550000000004],[-74.19686727254259,40.615050000000004],[-74.19859932335017,40.615050000000004],[-74.19946534875395,40.616550000000004],[-74.19859932335017,40.618050000000004],[-74.19686727254259,40.618050000000004],[-74.19600124713881,40.619550000000004],[-74.19686727254259,40.621050000000004],[-74.19600124713881,40.622550000000004],[-74.19686727254259,40.624050000000004],[-74.19600124713881,40.625550000000004],[-74.19686727254259,40.627050000000004],[-74.19600124713881,40.628550000000004],[-74.19686727254259,40.630050000000004],[-74.19600124713881,40.631550000000004],[-74.19686727254259,40.633050000000004],[-74.19600124713881,40.634550000000004],[-74.19426919633123,40.634550000000004],[-74.19340317092745,40.636050000000004],[-74.19167112011988,40.636050000000004],[-74.1908050947161,40.634550000000004],[-74.18907304390852,40.634550000000004],[-74.18820701850474,40.633050000000004],[-74.18647496769717,40.633050000000004],[-74.18560894229338,40.634550000000004],[-74.18647496769717,40.636050000000004],[-74.18560894229338,40.637550000000005],[-74.18647496769717,40.639050000000005],[-74.18560894229338,40.640550000000005],[-74.18387689148581,40.640550000000005],[-74.18301086608203,40.642050000000005],[-74.18127881527445,40.642050000000005],[-74.18041278987067,40.643550000000005],[-74.1786807390631,40.643550000000005],[-74.17781471365932,40.642050000000005],[-74.17608266285174,40.642050000000005],[-74.17521663744796,40.643550000000005],[-74.17348458664038,40.643550000000005],[-74.1726185612366,40.642050000000005],[-74.17088651042903,40.642050000000005],[-74.17002048502525,40.643550000000005],[-74.16828843421767,40.643550000000005],[-74.16742240881389,40.642050000000005],[-74.16569035800632,40.642050000000005],[-74.16482433260254,40.643550000000005],[-74.16309228179496,40.643550000000005],[-74.16222625639118,40.642050000000005],[-74.1604942055836,40.642050000000005],[-74.15962818017982,40.640550000000005],[-74.1604942055836,40.639050000000005],[-74.15962818017982,40.637550000000005],[-74.15789612937225,40.637550000000005],[-74.15703010396847,40.639050000000005],[-74.15529805316089,40.639050000000005],[-74.15443202775711,40.637550000000005],[-74.15269997694953,40.637550000000005],[-74.15183395154575,40.639050000000005],[-74.15010190073818,40.639050000000005],[-74.1492358753344,40.640550000000005],[-74.14750382452682,40.640550000000005],[-74.14663779912304,40.642050000000005],[-74.14490574831547,40.642050000000005],[-74.14403972291169,40.640550000000005],[-74.14230767210411,40.640550000000005],[-74.14144164670033,40.642050000000005],[-74.13970959589275,40.642050000000005],[-74.13884357048897,40.643550000000005],[-74.1371115196814,40.643550000000005],[-74.13624549427762,40.642050000000005],[-74.13451344347004,40.642050000000005],[-74.13364741806626,40.643550000000005],[-74.13191536725869,40.643550000000005],[-74.1310493418549,40.642050000000005],[-74.12931729104733,40.642050000000005],[-74.12845126564355,40.640550000000005],[-74.12671921483597,40.640550000000005],[-74.12585318943219,40.642050000000005],[-74.12412113862462,40.642050000000005],[-74.12325511322084,40.643550000000005],[-74.12152306241326,40.643550000000005],[-74.12065703700948,40.642050000000005],[-74.1189249862019,40.642050000000005],[-74.11805896079812,40.643550000000005],[-74.11632690999055,40.643550000000005],[-74.11546088458677,40.645050000000005],[-74.11372883377919,40.645050000000005],[-74.11286280837541,40.646550000000005],[-74.11113075756784,40.646550000000005],[-74.11026473216405,40.648050000000005],[-74.10853268135648,40.648050000000005],[-74.1076666559527,40.646550000000005],[-74.10593460514512,40.646550000000005],[-74.10506857974134,40.648050000000005],[-74.10333652893377,40.648050000000005],[-74.10247050352999,40.646550000000005],[-74.10073845272241,40.646550000000005],[-74.09987242731863,40.645050000000005],[-74.09814037651105,40.645050000000005],[-74.09727435110727,40.646550000000005],[-74.0955423002997,40.646550000000005],[-74.09467627489592,40.648050000000005],[-74.09294422408834,40.648050000000005],[-74.09207819868456,40.646550000000005],[-74.09034614787699,40.646550000000005],[-74.0894801224732,40.648050000000005],[-74.08774807166563,40.648050000000005],[-74.08688204626185,40.649550000000005],[-74.08514999545427,40.649550000000005],[-74.08428397005049,40.651050000000005],[-74.08255191924292,40.651050000000005],[-74.08168589383914,40.649550000000005],[-74.07995384303156,40.649550000000005],[-74.07908781762778,40.648050000000005],[-74.0773557668202,40.648050000000005],[-74.07648974141642,40.646550000000005],[-74.07475769060885,40.646550000000005],[-74.07389166520507,40.645050000000005],[-74.07215961439749,40.645050000000005],[-74.07129358899371,40.643550000000005],[-74.07215961439749,40.642050000000005],[-74.07129358899371,40.640550000000005],[-74.07215961439749,40.639050000000005],[-74.07129358899371,40.637550000000005],[-74.07215961439749,40.636050000000004],[-74.07129358899371,40.634550000000004],[-74.07215961439749,40.633050000000004],[-74.07129358899371,40.631550000000004],[-74.07215961439749,40.630050000000004],[-74.07129358899371,40.628550000000004],[-74.07215961439749,40.627050000000004],[-74.07129358899371,40.625550000000004],[-74.07215961439749,40.624050000000004],[-74.07129358899371,40.622550000000004],[-74.06956153818614,40.622550000000004],[-74.06869551278236,40.621050000000004],[-74.06696346197478,40.621050000000004],[-74.066097436571,40.619550000000004],[-74.06436538576342,40.619550000000004],[-74.06349936035964,40.618050000000004],[-74.06176730955207,40.618050000000004],[-74.06090128414829,40.616550000000004],[-74.06176730955207,40.615050000000004],[-74.06090128414829,40.613550000000004],[-74.05916923334071,40.613550000000004],[-74.05830320793693,40.61205],[-74.05657115712935,40.61205],[-74.05570513172557,40.61055],[-74.05657115712935,40.60905],[-74.05570513172557,40.60755],[-74.05657115712935,40.60605],[-74.05830320793693,40.60605],[-74.05916923334071,40.60455],[-74.06090128414829,40.60455],[-74.06176730955207,40.60305],[-74.06090128414829,40.60155],[-74.05916923334071,40.60155],[-74.05830320793693,40.60005],[-74.05916923334071,40.59855],[-74.06090128414829,40.59855],[-74.06176730955207,40.59705],[-74.06090128414829,40.59555],[-74.05916923334071,40.59555],[-74.05830320793693,40.59405],[-74.05916923334071,40.59255],[-74.06090128414829,40.59255],[-74.06176730955207,40.59105],[-74.06349936035964,40.59105],[-74.06436538576342,40.58955],[-74.066097436571,40.58955],[-74.06696346197478,40.58805],[-74.06869551278236,40.58805],[-74.06956153818614,40.58655],[-74.06869551278236,40.58505],[-74.06956153818614,40.58355],[-74.07129358899371,40.58355],[-74.07215961439749,40.58205],[-74.07389166520507,40.58205],[-74.07475769060885,40.58055],[-74.07648974141642,40.58055],[-74.0773557668202,40.57905],[-74.07648974141642,40.57755],[-74.0773557668202,40.57605],[-74.07908781762778,40.57605],[-74.07995384303156,40.57455],[-74.08168589383914,40.57455],[-74.08255191924292,40.57305],[-74.08428397005049,40.57305],[-74.08514999545427,40.57155],[-74.08428397005049,40.57005],[-74.08514999545427,40.56855],[-74.08688204626185,40.56855],[-74.08774807166563,40.56705],[-74.0894801224732,40.56705],[-74.09034614787699,40.56555],[-74.09207819868456,40.56555],[-74.09294422408834,40.56705],[-74.09467627489592,40.56705],[-74.0955423002997,40.56855],[-74.09727435110727,40.56855],[-74.09814037651105,40.57005],[-74.09987242731863,40.57005],[-74.10073845272241,40.57155],[-74.10247050352999,40.57155],[-74.10333652893377,40.57005],[-74.10247050352999,40.56855],[-74.10073845272241,40.56855],[-74.09987242731863,40.56705],[-74.09814037651105,40.56705],[-74.09727435110727,40.56555],[-74.0955423002997,40.56555],[-74.09467627489592,40.56405],[-74.0955423002997,40.56255],[-74.09727435110727,40.56255],[-74.09814037651105,40.56105],[-74.09987242731863,40.56105],[-74.10073845272241,40.55955],[-74.09987242731863,40.55805],[-74.10073845272241,40.55655],[-74.10247050352999,40.55655],[-74.10333652893377,40.55505],[-74.10506857974134,40.55505],[-74.10593460514512,40.55355],[-74.1076666559527,40.55355],[-74.10853268135648,40.55205],[-74.11026473216405,40.55205],[-74.11113075756784,40.55055],[-74.11026473216405,40.54905],[-74.11113075756784,40.54755],[-74.11286280837541,40.54755],[-74.11372883377919,40.54905],[-74.11546088458677,40.54905],[-74.11632690999055,40.55055],[-74.11805896079812,40.55055],[-74.1189249862019,40.55205],[-74.12065703700948,40.55205],[-74.12152306241326,40.55355],[-74.12325511322084,40.55355],[-74.12412113862462,40.55505],[-74.12585318943219,40.55505],[-74.12671921483597,40.55655],[-74.12845126564355,40.55655],[-74.12931729104733,40.55505],[-74.12845126564355,40.55355],[-74.12931729104733,40.55205],[-74.1310493418549,40.55205],[-74.13191536725869,40.55055],[-74.13364741806626,40.55055],[-74.13451344347004,40.54905],[-74.13624549427762,40.54905],[-74.1371115196814,40.54755],[-74.13624549427762,40.54605],[-74.1371115196814,40.54455],[-74.13884357048897,40.54455],[-74.13970959589275,40.54305],[-74.14144164670033,40.54305],[-74.14230767210411,40.54155],[-74.14144164670033,40.54005],[-74.14230767210411,40.53855],[-74.14144164670033,40.53705],[-74.14230767210411,40.53555],[-74.14403972291169,40.53555],[-74.14490574831547,40.53405],[-74.14663779912304,40.53405],[-74.14750382452682,40.53255],[-74.1492358753344,40.53255],[-74.15010190073818,40.53105],[-74.15183395154575,40.53105],[-74.15269997694953,40.52955],[-74.15443202775711,40.52955],[-74.15529805316089,40.52805],[-74.15703010396847,40.52805],[-74.15789612937225,40.52655],[-74.15962818017982,40.52655],[-74.1604942055836,40.52505],[-74.16222625639118,40.52505],[-74.16309228179496,40.52355],[-74.16482433260254,40.52355],[-74.16569035800632,40.52205],[-74.16742240881389,40.52205],[-74.16828843421767,40.52355],[-74.17002048502525,40.52355],[-74.17088651042903,40.52205],[-74.1726185612366,40.52205],[-74.17348458664038,40.52055],[-74.17521663744796,40.52055],[-74.17608266285174,40.51905],[-74.17781471365932,40.51905],[-74.1786807390631,40.52055],[-74.18041278987067,40.52055],[-74.18127881527445,40.51905],[-74.18301086608203,40.51905],[-74.18387689148581,40.51755],[-74.18560894229338,40.51755],[-74.18647496769717,40.51905],[-74.18820701850474,40.51905],[-74.18907304390852,40.52055],[-74.1908050947161,40.52055],[-74.19167112011988,40.51905],[-74.1908050947161,40.51755],[-74.19167112011988,40.51605],[-74.1908050947161,40.51455],[-74.19167112011988,40.51305],[-74.1908050947161,40.51155],[-74.19167112011988,40.51005],[-74.19340317092745,40.51005],[-74.19426919633123,40.51155],[-74.19600124713881,40.51155],[-74.19686727254259,40.51005],[-74.19859932335017,40.51005],[-74.19946534875395,40.51155],[-74.20119739956152,40.51155],[-74.2020634249653,40.51005],[-74.20379547577288,40.51005],[-74.20466150117666,40.51155],[-74.20639355198423,40.51155],[-74.20725957738802,40.51005],[-74.20899162819559,40.51005],[-74.20985765359937,40.51155],[-74.21158970440695,40.51155],[-74.21245572981073,40.51305],[-74.2141877806183,40.51305],[-74.21505380602208,40.51155],[-74.21678585682966,40.51155],[-74.21765188223344,40.51305],[-74.21938393304102,40.51305],[-74.2202499584448,40.51455],[-74.21938393304102,40.51605],[-74.2202499584448,40.51755],[-74.22198200925237,40.51755],[-74.22284803465615,40.51605],[-74.22458008546373,40.51605],[-74.22544611086751,40.51455],[-74.22458008546373,40.51305],[-74.22284803465615,40.51305],[-74.22198200925237,40.51155],[-74.22284803465615,40.51005],[-74.22198200925237,40.50855],[-74.22284803465615,40.50705],[-74.22198200925237,40.50555],[-74.2202499584448,40.50555],[-74.21938393304102,40.50405],[-74.2202499584448,40.50255],[-74.22198200925237,40.50255],[-74.22284803465615,40.50105],[-74.22458008546373,40.50105],[-74.22544611086751,40.50255],[-74.22717816167508,40.50255],[-74.22804418707886,40.50105],[-74.22977623788644,40.50105],[-74.23064226329022,40.49955],[-74.2323743140978,40.49955],[-74.23324033950158,40.49805],[-74.23497239030915,40.49805],[-74.23583841571293,40.49955],[-74.23757046652051,40.49955],[-74.23843649192429,40.49805],[-74.24016854273187,40.49805],[-74.24103456813565,40.49655],[-74.24276661894322,40.49655],[-74.243632644347,40.49805],[-74.24536469515458,40.49805],[-74.24623072055836,40.49655],[-74.24796277136593,40.49655],[-74.24882879676971,40.49805],[-74.25056084757729,40.49805],[-74.25142687298107,40.49955],[-74.25056084757729,40.50105],[-74.25142687298107,40.50255],[-74.25315892378865,40.50255],[-74.25402494919243,40.50405]]]},"properties":{"borough":"staten island"}},{"type":"Feature","geometry":{"type":"MultiPolygon","coordinates":[[[[-74.04098269986122,40.621050000000004],[-74.0427147506688,40.621050000000004],[-74.04358077607257,40.622550000000004],[-74.0427147506688,40.624050000000004],[-74.04358077607257,40.625550000000004],[-74.0427147506688,40.627050000000004],[-74.04098269986122,40.627050000000004],[-74.04011667445744,40.628550000000004],[-74.04098269986122,40.630050000000004],[-74.04011667445744,40.631550000000004],[-74.03838462364986,40.631550000000004],[-74.03751859824608,40.633050000000004],[-74.03838462364986,40.634550000000004],[-74.03751859824608,40.636050000000004],[-74.03838462364986,40.637550000000005],[-74.03751859824608,40.639050000000005],[-74.03838462364986,40.640550000000005],[-74.03751859824608,40.642050000000005],[-74.0357865474385,40.642050000000005],[-74.03492052203472,40.643550000000005],[-74.03318847122715,40.643550000000005],[-74.03232244582337,40.645050000000005],[-74.03059039501579,40.645050000000005],[-74.02972436961201,40.643550000000005],[-74.02799231880444,40.643550000000005],[-74.02712629340066,40.645050000000005],[-74.02799231880444,40.646550000000005],[-74.02712629340066,40.648050000000005],[-74.02539424259308,40.648050000000005],[-74.0245282171893,40.649550000000005],[-74.02539424259308,40.651050000000005],[-74.0245282171893,40.652550000000005],[-74.02279616638172,40.652550000000005],[-74.02193014097794,40.651050000000005],[-74.02019809017037,40.651050000000005],[-74.01933206476659,40.652550000000005],[-74.01760001395901,40.652550000000005],[-74.01673398855523,40.654050000000005],[-74.01760001395901,40.655550000000005],[-74.01673398855523,40.657050000000005],[-74.01500193774766,40.657050000000005],[-74.01413591234387,40.658550000000005],[-74.0124038615363,40.658550000000005],[-74.01153783613252,40.660050000000005],[-74.00980578532494,40.660050000000005],[-74.00893975992116,40.658550000000005],[-74.00720770911359,40.658550000000005],[-74.0063416837098,40.660050000000005],[-74.00720770911359,40.661550000000005],[-74.0063416837098,40.663050000000005],[-74.00460963290223,40.663050000000005],[-74.00374360749845,40.661550000000005],[-74.00201155669087,40.661550000000005],[-74.0011455312871,40.663050000000005],[-74.00201155669087,40.664550000000006],[-74.0011455312871,40.666050000000006],[-74.00201155669087,40.667550000000006],[-74.00374360749845,40.667550000000006],[-74.00460963290223,40.666050000000006],[-74.0063416837098,40.666050000000006],[-74.00720770911359,40.667550000000006],[-74.00893975992116,40.667550000000006],[-74.00980578532494,40.669050000000006],[-74.01153783613252,40.669050000000006],[-74.0124038615363,40.670550000000006],[-74.01413591234387,40.670550000000006],[-74.01500193774766,40.672050000000006],[-74.01673398855523,40.672050000000006],[-74.01760001395901,40.673550000000006],[-74.01933206476659,40.673550000000006],[-74.02019809017037,40.675050000000006],[-74.01933206476659,40.676550000000006],[-74.02019809017037,40.678050000000006],[-74.01933206476659,40.679550000000006],[-74.02019809017037,40.681050000000006],[-74.01933206476659,40.682550000000006],[-74.01760001395901,40.682550000000006],[-74.01673398855523,40.681050000000006],[-74.01500193774766,40.681050000000006],[-74.01413591234387,40.682550000000006],[-74.0124038615363,40.682550000000006],[-74.01153783613252,40.684050000000006],[-74.00980578532494,40.684050000000006],[-74.00893975992116,40.685550000000006],[-74.00980578532494,40.687050000000006],[-74.00893975992116,40.688550000000006],[-74.00720770911359,40.688550000000006],[-74.0063416837098,40.687050000000006],[-74.00460963290223,40.687050000000006],[-74.00374360749845,40.688550000000006],[-74.00201155669087,40.688550000000006],[-74.0011455312871,40.69005000000001],[-74.00201155669087,40.69155000000001],[-74.0011455312871,40.69305000000001],[-74.00201155669087,40.69455000000001],[-74.0011455312871,40.69605000000001],[-74.00201155669087,40.69755000000001],[-74.0011455312871,40.69905000000001],[-73.99941348047952,40.69905000000001],[-73.99854745507574,40.70055000000001],[-73.99681540426816,40.70055000000001],[-73.99594937886438,40.70205000000001],[-73.99681540426816,40.70355000000001],[-73.99594937886438,40.70505000000001],[-73.9942173280568,40.70505000000001],[-73.99335130265302,40.70655000000001],[-73.99161925184545,40.70655000000001],[-73.99075322644167,40.70505000000001],[-73.9890211756341,40.70505000000001],[-73.98815515023031,40.70655000000001],[-73.98642309942274,40.70655000000001],[-73.98555707401896,40.70505000000001],[-73.98382502321138,40.70505000000001],[-73.9829589978076,40.70655000000001],[-73.98122694700002,40.70655000000001],[-73.98036092159624,40.70805000000001],[-73.97862887078867,40.70805000000001],[-73.97776284538489,40.70655000000001],[-73.97862887078867,40.70505000000001],[-73.97776284538489,40.70355000000001],[-73.97862887078867,40.70205000000001],[-73.97776284538489,40.70055000000001],[-73.97603079457731,40.70055000000001],[-73.97516476917353,40.69905000000001],[-73.97343271836596,40.69905000000001],[-73.97256669296218,40.70055000000001],[-73.9708346421546,40.70055000000001],[-73.96996861675082,40.70205000000001],[-73.96823656594324,40.70205000000001],[-73.96737054053946,40.70355000000001],[-73.96823656594324,40.70505000000001],[-73.96996861675082,40.70505000000001],[-73.9708346421546,40.70655000000001],[-73.96996861675082,40.70805000000001],[-73.9708346421546,40.70955000000001],[-73.96996861675082,40.71105000000001],[-73.9708346421546,40.71255000000001],[-73.96996861675082,40.71405000000001],[-73.96823656594324,40.71405000000001],[-73.96737054053946,40.71555000000001],[-73.96823656594324,40.71705000000001],[-73.96737054053946,40.71855000000001],[-73.96823656594324,40.72005000000001],[-73.96737054053946,40.72155000000001],[-73.96563848973189,40.72155000000001],[-73.9647724643281,40.72305000000001],[-73.96304041352053,40.72305000000001],[-73.96217438811675,40.72455000000001],[-73.96304041352053,40.72605000000001],[-73.96217438811675,40.72755000000001],[-73.96304041352053,40.72905000000001],[-73.96217438811675,40.73055000000001],[-73.96304041352053,40.73205000000001],[-73.96217438811675,40.73355000000001],[-73.96304041352053,40.73505000000001],[-73.96217438811675,40.73655000000001],[-73.96044233730917,40.73655000000001],[-73.9595763119054,40.73805000000001],[-73.95784426109782,40.73805000000001],[-73.95697823569404,40.73955000000001],[-73.95524618488646,40.73955000000001],[-73.95438015948268,40.74105000000001],[-73.9526481086751,40.74105000000001],[-73.95178208327133,40.73955000000001],[-73.95005003246375,40.73955000000001],[-73.94918400705997,40.73805000000001],[-73.9474519562524,40.73805000000001],[-73.94658593084861,40.73655000000001],[-73.94485388004104,40.73655000000001],[-73.94398785463726,40.73505000000001],[-73.94225580382968,40.73505000000001],[-73.9413897784259,40.73355000000001],[-73.93965772761833,40.73355000000001],[-73.93879170221454,40.73205000000001],[-73.93965772761833,40.73055000000001],[-73.93879170221454,40.72905000000001],[-73.93705965140697,40.72905000000001],[-73.93619362600319,40.72755000000001],[-73.93446157519561,40.72755000000001],[-73.93359554979183,40.72905000000001],[-73.93186349898426,40.72905000000001],[-73.93099747358048,40.72755000000001],[-73.9292654227729,40.72755000000001],[-73.92839939736912,40.72605000000001],[-73.9292654227729,40.72455000000001],[-73.92839939736912,40.72305000000001],[-73.9292654227729,40.72155000000001],[-73.93099747358048,40.72155000000001],[-73.93186349898426,40.72305000000001],[-73.93359554979183,40.72305000000001],[-73.93446157519561,40.72155000000001],[-73.93359554979183,40.72005000000001],[-73.93186349898426,40.72005000000001],[-73.93099747358048,40.71855000000001],[-73.9292654227729,40.71855000000001],[-73.92839939736912,40.72005000000001],[-73.92666734656154,40.72005000000001],[-73.92580132115776,40.71855000000001],[-73.92406927035019,40.71855000000001],[-73.92320324494641,40.71705000000001],[-73.92406927035019,40.71555000000001],[-73.92320324494641,40.71405000000001],[-73.92406927035019,40.71255000000001],[-73.92320324494641,40.71105000000001],[-73.92147119413883,40.71105000000001],[-73.92060516873505,40.70955000000001],[-73.92147119413883,40.70805000000001],[-73.92060516873505,40.70655000000001],[-73.91887311792748,40.70655000000001],[-73.9180070925237,40.70805000000001],[-73.91627504171612,40.70805000000001],[-73.91540901631234,40.70655000000001],[-73.91367696550476,40.70655000000001],[-73.91281094010098,40.70505000000001],[-73.91367696550476,40.70355000000001],[-73.91281094010098,40.70205000000001],[-73.9110788892934,40.70205000000001],[-73.91021286388963,40.70055000000001],[-73.9110788892934,40.69905000000001],[-73.91021286388963,40.69755000000001],[-73.90848081308205,40.69755000000001],[-73.90761478767827,40.69605000000001],[-73.9058827368707,40.69605000000001],[-73.90501671146691,40.69455000000001],[-73.90328466065934,40.69455000000001],[-73.90241863525556,40.69305000000001],[-73.90068658444798,40.69305000000001],[-73.8998205590442,40.69155000000001],[-73.90068658444798,40.69005000000001],[-73.8998205590442,40.688550000000006],[-73.90068658444798,40.687050000000006],[-73.90241863525556,40.687050000000006],[-73.90328466065934,40.685550000000006],[-73.90241863525556,40.684050000000006],[-73.90068658444798,40.684050000000006],[-73.8998205590442,40.682550000000006],[-73.90068658444798,40.681050000000006],[-73.8998205590442,40.679550000000006],[-73.89808850823663,40.679550000000006],[-73.89722248283285,40.681050000000006],[-73.89808850823663,40.682550000000006],[-73.89722248283285,40.684050000000006],[-73.89549043202527,40.684050000000006],[-73.89462440662149,40.685550000000006],[-73.89289235581391,40.685550000000006],[-73.89202633041013,40.687050000000006],[-73.89029427960256,40.687050000000006],[-73.88942825419878,40.685550000000006],[-73.8876962033912,40.685550000000006],[-73.88683017798742,40.684050000000006],[-73.88509812717984,40.684050000000006],[-73.88423210177606,40.685550000000006],[-73.88509812717984,40.687050000000006],[-73.88423210177606,40.688550000000006],[-73.88250005096849,40.688550000000006],[-73.88163402556471,40.69005000000001],[-73.87990197475713,40.69005000000001],[-73.87903594935335,40.69155000000001],[-73.87730389854578,40.69155000000001],[-73.876437873142,40.69005000000001],[-73.87470582233442,40.69005000000001],[-73.87383979693064,40.69155000000001],[-73.87470582233442,40.69305000000001],[-73.87383979693064,40.69455000000001],[-73.87210774612306,40.69455000000001],[-73.87124172071928,40.69605000000001],[-73.86950966991171,40.69605000000001],[-73.86864364450793,40.69455000000001],[-73.86950966991171,40.69305000000001],[-73.86864364450793,40.69155000000001],[-73.86950966991171,40.69005000000001],[-73.86864364450793,40.688550000000006],[-73.86691159370035,40.688550000000006],[-73.86604556829657,40.687050000000006],[-73.86691159370035,40.685550000000006],[-73.86604556829657,40.684050000000006],[-73.86691159370035,40.682550000000006],[-73.86604556829657,40.681050000000006],[-73.864313517489,40.681050000000006],[-73.86344749208521,40.679550000000006],[-73.86171544127764,40.679550000000006],[-73.86084941587386,40.678050000000006],[-73.86171544127764,40.676550000000006],[-73.86084941587386,40.675050000000006],[-73.86171544127764,40.673550000000006],[-73.86084941587386,40.672050000000006],[-73.85911736506628,40.672050000000006],[-73.8582513396625,40.670550000000006],[-73.85651928885493,40.670550000000006],[-73.85565326345115,40.669050000000006],[-73.85651928885493,40.667550000000006],[-73.85565326345115,40.666050000000006],[-73.85651928885493,40.664550000000006],[-73.8582513396625,40.664550000000006],[-73.85911736506628,40.663050000000005],[-73.8582513396625,40.661550000000005],[-73.85911736506628,40.660050000000005],[-73.8582513396625,40.658550000000005],[-73.85911736506628,40.657050000000005],[-73.86084941587386,40.657050000000005],[-73.86171544127764,40.655550000000005],[-73.86084941587386,40.654050000000005],[-73.86171544127764,40.652550000000005],[-73.86344749208521,40.652550000000005],[-73.864313517489,40.651050000000005],[-73.86604556829657,40.651050000000005],[-73.86691159370035,40.649550000000005],[-73.86864364450793,40.649550000000005],[-73.86950966991171,40.648050000000005],[-73.87124172071928,40.648050000000005],[-73.87210774612306,40.646550000000005],[-73.87383979693064,40.646550000000005],[-73.87470582233442,40.645050000000005],[-73.87383979693064,40.643550000000005],[-73.87470582233442,40.642050000000005],[-73.876437873142,40.642050000000005],[-73.87730389854578,40.640550000000005],[-73.876437873142,40.639050000000005],[-73.87730389854578,40.637550000000005],[-73.87903594935335,40.637550000000005],[-73.87990197475713,40.639050000000005],[-73.88163402556471,40.639050000000005],[-73.88250005096849,40.637550000000005],[-73.88423210177606,40.637550000000005],[-73.88509812717984,40.636050000000004],[-73.88423210177606,40.634550000000004],[-73.88250005096849,40.634550000000004],[-73.88163402556471,40.633050000000004],[-73.88250005096849,40.631550000000004],[-73.88423210177606,40.631550000000004],[-73.88509812717984,40.630050000000004],[-73.88683017798742,40.630050000000004],[-73.8876962033912,40.628550000000004],[-73.88942825419878,40.628550000000004],[-73.89029427960256,40.627050000000004],[-73.89202633041013,40.627050000000004],[-73.89289235581391,40.628550000000004],[-73.89462440662149,40.628550000000004],[-73.89549043202527,40.627050000000004],[-73.89722248283285,40.627050000000004],[-73.89808850823663,40.625550000000004],[-73.8998205590442,40.625550000000004],[-73.90068658444798,40.624050000000004],[-73.90241863525556,40.624050000000004],[-73.90328466065934,40.622550000000004],[-73.90241863525556,40.621050000000004],[-73.90068658444798,40.621050000000004],[-73.8998205590442,40.619550000000004],[-73.89808850823663,40.619550000000004],[-73.89722248283285,40.618050000000004],[-73.89808850823663,40.616550000000004],[-73.89722248283285,40.615050000000004],[-73.89808850823663,40.613550000000004],[-73.8998205590442,40.613550000000004],[-73.90068658444798,40.61205],[-73.8998205590442,40.61055],[-73.90068658444798,40.60905],[-73.8998205590442,40.60755],[-73.90068658444798,40.60605],[-73.90241863525556,40.60605],[-73.90328466065934,40.60455],[-73.90501671146691,40.60455],[-73.9058827368707,40.60605],[-73.90761478767827,40.60605],[-73.90848081308205,40.60455],[-73.90761478767827,40.60305],[-73.90848081308205,40.60155],[-73.91021286388963,40.60155],[-73.9110788892934,40.60005],[-73.91281094010098,40.60005],[-73.91367696550476,40.60155],[-73.91540901631234,40.60155],[-73.91627504171612,40.60305],[-73.91540901631234,40.60455],[-73.91627504171612,40.60605],[-73.9180070925237,40.60605],[-73.91887311792748,40.60455],[-73.92060516873505,40.60455],[-73.92147119413883,40.60605],[-73.92320324494641,40.60605],[-73.92406927035019,40.60455],[-73.92580132115776,40.60455],[-73.92666734656154,40.60605],[-73.92839939736912,40.60605],[-73.9292654227729,40.60455],[-73.92839939736912,40.60305],[-73.9292654227729,40.60155],[-73.92839939736912,40.60005],[-73.92666734656154,40.60005],[-73.92580132115776,40.59855],[-73.92666734656154,40.59705],[-73.92580132115776,40.59555],[-73.92406927035019,40.59555],[-73.92320324494641,40.59405],[-73.92406927035019,40.59255],[-73.92320324494641,40.59105],[-73.92147119413883,40.59105],[-73.92060516873505,40.58955],[-73.91887311792748,40.58955],[-73.9180070925237,40.58805],[-73.91627504171612,40.58805],[-73.91540901631234,40.58655],[-73.91627504171612,40.58505],[-73.9180070925237,40.58505],[-73.91887311792748,40.58355],[-73.92060516873505,40.58355],[-73.92147119413883,40.58505],[-73.92320324494641,40.58505],[-73.92406927035019,40.58355],[-73.92580132115776,40.58355],[-73.92666734656154,40.58505],[-73.92839939736912,40.58505],[-73.9292654227729,40.58355],[-73.93099747358048,40.58355],[-73.93186349898426,40.58205],[-73.93099747358048,40.58055],[-73.93186349898426,40.57905],[-73.93359554979183,40.57905],[-73.93446157519561,40.57755],[-73.93619362600319,40.57755],[-73.93705965140697,40.57605],[-73.93879170221454,40.57605],[-73.93965772761833,40.57755],[-73.9413897784259,40.57755],[-73.94225580382968,40.57605],[-73.94398785463726,40.57605],[-73.94485388004104,40.57455],[-73.94658593084861,40.57455],[-73.9474519562524,40.57305],[-73.94918400705997,40.57305],[-73.95005003246375,40.57455],[-73.95178208327133,40.57455],[-73.9526481086751,40.57305],[-73.95438015948268,40.57305],[-73.95524618488646,40.57455],[-73.95697823569404,40.57455],[-73.95784426109782,40.57305],[-73.9595763119054,40.57305],[-73.96044233730917,40.57455],[-73.96217438811675,40.57455],[-73.96304041352053,40.57305],[-73.9647724643281,40.57305],[-73.96563848973189,40.57455],[-73.96737054053946,40.57455],[-73.96823656594324,40.57305],[-73.96996861675082,40.57305],[-73.9708346421546,40.57155],[-73.97256669296218,40.57155],[-73.97343271836596,40.57305],[-73.97516476917353,40.57305],[-73.97603079457731,40.57155],[-73.97776284538489,40.57155],[-73.97862887078867,40.57305],[-73.98036092159624,40.57305],[-73.98122694700002,40.57155],[-73.9829589978076,40.57155],[-73.98382502321138,40.57005],[-73.98555707401896,40.57005],[-73.98642309942274,40.57155],[-73.98815515023031,40.57155],[-73.9890211756341,40.57005],[-73.99075322644167,40.57005],[-73.99161925184545,40.57155],[-73.99335130265302,40.57155],[-73.9942173280568,40.57005],[-73.99594937886438,40.57005],[-73.99681540426816,40.57155],[-73.99854745507574,40.57155],[-73.99941348047952,40.57005],[-74.0011455312871,40.57005],[-74.00201155669087,40.57155],[-74.00374360749845,40.57155],[-74.00460963290223,40.57305],[-74.0063416837098,40.57305],[-74.00720770911359,40.57155],[-74.00893975992116,40.57155],[-74.00980578532494,40.57305],[-74.01153783613252,40.57305],[-74.0124038615363,40.57455],[-74.01413591234387,40.57455],[-74.01500193774766,40.57605],[-74.01413591234387,40.57755],[-74.01500193774766,40.57905],[-74.01413591234387,40.58055],[-74.0124038615363,40.58055],[-74.01153783613252,40.58205],[-74.00980578532494,40.58205],[-74.00893975992116,40.58355],[-74.00720770911359,40.58355],[-74.0063416837098,40.58205],[-74.00460963290223,40.58205],[-74.00374360749845,40.58355],[-74.00201155669087,40.58355],[-74.0011455312871,40.58205],[-73.99941348047952,40.58205],[-73.99854745507574,40.58055],[-73.99681540426816,40.58055],[-73.99594937886438,40.57905],[-73.9942173280568,40.57905],[-73.99335130265302,40.58055],[-73.99161925184545,40.58055],[-73.99075322644167,40.58205],[-73.99161925184545,40.58355],[-73.99075322644167,40.58505],[-73.99161925184545,40.58655],[-73.99335130265302,40.58655],[-73.9942173280568,40.58505],[-73.99335130265302,40.58355],[-73.9942173280568,40.58205],[-73.99594937886438,40.58205],[-73.99681540426816,40.58355],[-73.99854745507574,40.58355],[-73.99941348047952,40.58505],[-73.99854745507574,40.58655],[-73.99941348047952,40.58805],[-73.99854745507574,40.58955],[-73.99941348047952,40.59105],[-73.99854745507574,40.59255],[-73.99941348047952,40.59405],[-74.0011455312871,40.59405],[-74.00201155669087,40.59555],[-74.00374360749845,40.59555],[-74.00460963290223,40.59705],[-74.0063416837098,40.59705],[-74.00720770911359,40.59855],[-74.00893975992116,40.59855],[-74.00980578532494,40.60005],[-74.01153783613252,40.60005],[-74.0124038615363,40.60155],[-74.01413591234387,40.60155],[-74.01500193774766,40.60005],[-74.01673398855523,40.60005],[-74.01760001395901,40.60155],[-74.01933206476659,40.60155],[-74.02019809017037,40.60305],[-74.01933206476659,40.60455],[-74.02019809017037,40.60605],[-74.01933206476659,40.60755],[-74.01760001395901,40.60755],[-74.01673398855523,40.60905],[-74.01760001395901,40.61055],[-74.01673398855523,40.61205],[-74.01760001395901,40.613550000000004],[-74.01933206476659,40.613550000000004],[-74.02019809017037,40.615050000000004],[-74.02193014097794,40.615050000000004],[-74.02279616638172,40.613550000000004],[-74.02193014097794,40.61205],[-74.02279616638172,40.61055],[-74.02193014097794,40.60905],[-74.02279616638172,40.60755],[-74.0245282171893,40.60755],[-74.02539424259308,40.60905],[-74.02712629340066,40.60905],[-74.02799231880444,40.60755],[-74.02972436961201,40.60755],[-74.03059039501579,40.60905],[-74.03232244582337,40.60905],[-74.03318847122715,40.61055],[-74.03492052203472,40.61055],[-74.0357865474385,40.61205],[-74.03751859824608,40.61205],[-74.03838462364986,40.613550000000004],[-74.03751859824608,40.615050000000004],[-74.03838462364986,40.616550000000004],[-74.04011667445744,40.616550000000004],[-74.04098269986122,40.618050000000004],[-74.04011667445744,40.619550000000004],[-74.04098269986122,40.621050000000004]]]]},"properties":{"borough":"brooklyn"}},{"type":"Feature","geometry":{"type":"MultiPolygon","coordinates":[[[[-74.01760001395901,40.70355000000001],[-74.01933206476659,40.70355000000001],[-74.02019809017037,40.70505000000001],[-74.01933206476659,40.70655000000001],[-74.02019809017037,40.70805000000001],[-74.01933206476659,40.70955000000001],[-74.02019809017037,40.71105000000001],[-74.01933206476659,40.71255000000001],[-74.02019809017037,40.71405000000001],[-74.01933206476659,40.71555000000001],[-74.01760001395901,40.71555000000001],[-74.01673398855523,40.71705000000001],[-74.01760001395901,40.71855000000001],[-74.01673398855523,40.72005000000001],[-74.01500193774766,40.72005000000001],[-74.01413591234387,40.72155000000001],[-74.0124038615363,40.72155000000001],[-74.01153783613252,40.72305000000001],[-74.0124038615363,40.72455000000001],[-74.01153783613252,40.72605000000001],[-74.0124038615363,40.72755000000001],[-74.01153783613252,40.72905000000001],[-74.0124038615363,40.73055000000001],[-74.01153783613252,40.73205000000001],[-74.0124038615363,40.73355000000001],[-74.01153783613252,40.73505000000001],[-74.0124038615363,40.73655000000001],[-74.01153783613252,40.73805000000001],[-74.0124038615363,40.73955000000001],[-74.01153783613252,40.74105000000001],[-74.00980578532494,40.74105000000001],[-74.00893975992116,40.74255000000001],[-74.00980578532494,40.74405000000001],[-74.00893975992116,40.74555000000001],[-74.00980578532494,40.74705000000001],[-74.00893975992116,40.74855000000001],[-74.00980578532494,40.75005000000001],[-74.00893975992116,40.75155000000001],[-74.00980578532494,40.75305000000001],[-74.00893975992116,40.75455000000001],[-74.00720770911359,40.75455000000001],[-74.0063416837098,40.75605000000001],[-74.00720770911359,40.75755000000001],[-74.0063416837098,40.75905000000001],[-74.00460963290223,40.75905000000001],[-74.00374360749845,40.76055000000001],[-74.00460963290223,40.76205000000001],[-74.00374360749845,40.76355000000001],[-74.00201155669087,40.76355000000001],[-74.0011455312871,40.76505000000001],[-73.99941348047952,40.76505000000001],[-73.99854745507574,40.76655000000001],[-73.99681540426816,40.76655000000001],[-73.99594937886438,40.76805000000001],[-73.99681540426816,40.76955000000001],[-73.99594937886438,40.77105000000001],[-73.99681540426816,40.77255000000001],[-73.99594937886438,40.77405000000001],[-73.9942173280568,40.77405000000001],[-73.99335130265302,40.77555000000001],[-73.99161925184545,40.77555000000001],[-73.99075322644167,40.77705000000001],[-73.99161925184545,40.77855000000001],[-73.99075322644167,40.78005000000001],[-73.9890211756341,40.78005000000001],[-73.98815515023031,40.78155000000001],[-73.9890211756341,40.78305000000001],[-73.98815515023031,40.78455000000001],[-73.98642309942274,40.78455000000001],[-73.98555707401896,40.78605000000001],[-73.98382502321138,40.78605000000001],[-73.9829589978076,40.78755000000001],[-73.98382502321138,40.78905000000001],[-73.9829589978076,40.79055000000001],[-73.98122694700002,40.79055000000001],[-73.98036092159624,40.79205000000001],[-73.98122694700002,40.79355000000001],[-73.98036092159624,40.79505000000001],[-73.97862887078867,40.79505000000001],[-73.97776284538489,40.79655000000001],[-73.97603079457731,40.79655000000001],[-73.97516476917353,40.79805000000001],[-73.97343271836596,40.79805000000001],[-73.97256669296218,40.79955000000001],[-73.97343271836596,40.80105000000001],[-73.97256669296218,40.80255000000001],[-73.9708346421546,40.80255000000001],[-73.96996861675082,40.80405000000001],[-73.9708346421546,40.80555000000001],[-73.96996861675082,40.80705000000001],[-73.96823656594324,40.80705000000001],[-73.96737054053946,40.80855000000001],[-73.96823656594324,40.81005000000001],[-73.96737054053946,40.81155000000001],[-73.96563848973189,40.81155000000001],[-73.9647724643281,40.81305000000001],[-73.96563848973189,40.81455000000001],[-73.9647724643281,40.81605000000001],[-73.96304041352053,40.81605000000001],[-73.96217438811675,40.81755000000001],[-73.96304041352053,40.81905000000001],[-73.96217438811675,40.82055000000001],[-73.96044233730917,40.82055000000001],[-73.9595763119054,40.82205000000001],[-73.96044233730917,40.82355000000001],[-73.9595763119054,40.82505000000001],[-73.95784426109782,40.82505000000001],[-73.95697823569404,40.82355000000001],[-73.95524618488646,40.82355000000001],[-73.95438015948268,40.82505000000001],[-73.95524618488646,40.82655000000001],[-73.95438015948268,40.82805000000001],[-73.9526481086751,40.82805000000001],[-73.95178208327133,40.82955000000001],[-73.9526481086751,40.83105000000001],[-73.95178208327133,40.83255000000001],[-73.9526481086751,40.83405000000001],[-73.95178208327133,40.83555000000001],[-73.95005003246375,40.83555000000001],[-73.94918400705997,40.83705000000001],[-73.95005003246375,40.83855000000001],[-73.94918400705997,40.84005000000001],[-73.9474519562524,40.84005000000001],[-73.94658593084861,40.84155000000001],[-73.9474519562524,40.84305000000001],[-73.94658593084861,40.84455000000001],[-73.9474519562524,40.84605000000001],[-73.94658593084861,40.84755000000001],[-73.9474519562524,40.84905000000001],[-73.94918400705997,40.84905000000001],[-73.95005003246375,40.85055000000001],[-73.94918400705997,40.85205000000001],[-73.9474519562524,40.85205000000001],[-73.94658593084861,40.85355000000001],[-73.94485388004104,40.85355000000001],[-73.94398785463726,40.85205000000001],[-73.94225580382968,40.85205000000001],[-73.9413897784259,40.85355000000001],[-73.94225580382968,40.85505000000001],[-73.9413897784259,40.85655000000001],[-73.93965772761833,40.85655000000001],[-73.93879170221454,40.85805000000001],[-73.93705965140697,40.85805000000001],[-73.93619362600319,40.85955000000001],[-73.93705965140697,40.86105000000001],[-73.93619362600319,40.86255000000001],[-73.93705965140697,40.86405000000001],[-73.93619362600319,40.86555000000001],[-73.93446157519561,40.86555000000001],[-73.93359554979183,40.86705000000001],[-73.93446157519561,40.86855000000001],[-73.93359554979183,40.87005000000001],[-73.93186349898426,40.87005000000001],[-73.93099747358048,40.87155000000001],[-73.93186349898426,40.87305000000001],[-73.93099747358048,40.87455000000001],[-73.9292654227729,40.87455000000001],[-73.92839939736912,40.87305000000001],[-73.9292654227729,40.87155000000001],[-73.92839939736912,40.87005000000001],[-73.92666734656154,40.87005000000001],[-73.92580132115776,40.87155000000001],[-73.92406927035019,40.87155000000001],[-73.92320324494641,40.87305000000001],[-73.92147119413883,40.87305000000001],[-73.92060516873505,40.87455000000001],[-73.91887311792748,40.87455000000001],[-73.9180070925237,40.87305000000001],[-73.91627504171612,40.87305000000001],[-73.91540901631234,40.87455000000001],[-73.91627504171612,40.87605000000001],[-73.91540901631234,40.877550000000014],[-73.91367696550476,40.877550000000014],[-73.91281094010098,40.879050000000014],[-73.9110788892934,40.879050000000014],[-73.91021286388963,40.877550000000014],[-73.90848081308205,40.877550000000014],[-73.90761478767827,40.87605000000001],[-73.90848081308205,40.87455000000001],[-73.90761478767827,40.87305000000001],[-73.90848081308205,40.87155000000001],[-73.91021286388963,40.87155000000001],[-73.9110788892934,40.87005000000001],[-73.91021286388963,40.86855000000001],[-73.9110788892934,40.86705000000001],[-73.91281094010098,40.86705000000001],[-73.91367696550476,40.86855000000001],[-73.91540901631234,40.86855000000001],[-73.91627504171612,40.86705000000001],[-73.91540901631234,40.86555000000001],[-73.91367696550476,40.86555000000001],[-73.91281094010098,40.86405000000001],[-73.91367696550476,40.86255000000001],[-73.91540901631234,40.86255000000001],[-73.91627504171612,40.86105000000001],[-73.9180070925237,40.86105000000001],[-73.91887311792748,40.85955000000001],[-73.92060516873505,40.85955000000001],[-73.92147119413883,40.85805000000001],[-73.92320324494641,40.85805000000001],[-73.92406927035019,40.85655000000001],[-73.92320324494641,40.85505000000001],[-73.92406927035019,40.85355000000001],[-73.92580132115776,40.85355000000001],[-73.92666734656154,40.85205000000001],[-73.92580132115776,40.85055000000001],[-73.92666734656154,40.84905000000001],[-73.92839939736912,40.84905000000001],[-73.9292654227729,40.84755000000001],[-73.92839939736912,40.84605000000001],[-73.9292654227729,40.84455000000001],[-73.93099747358048,40.84455000000001],[-73.93186349898426,40.84305000000001],[-73.93099747358048,40.84155000000001],[-73.93186349898426,40.84005000000001],[-73.93099747358048,40.83855000000001],[-73.93186349898426,40.83705000000001],[-73.93359554979183,40.83705000000001],[-73.93446157519561,40.83555000000001],[-73.93359554979183,40.83405000000001],[-73.93446157519561,40.83255000000001],[-73.93359554979183,40.83105000000001],[-73.93446157519561,40.82955000000001],[-73.93359554979183,40.82805000000001],[-73.93446157519561,40.82655000000001],[-73.93359554979183,40.82505000000001],[-73.93446157519561,40.82355000000001],[-73.93359554979183,40.82205000000001],[-73.93446157519561,40.82055000000001],[-73.93359554979183,40.81905000000001],[-73.93446157519561,40.81755000000001],[-73.93359554979183,40.81605000000001],[-73.93446157519561,40.81455000000001],[-73.93359554979183,40.81305000000001],[-73.93446157519561,40.81155000000001],[-73.93359554979183,40.81005000000001],[-73.93446157519561,40.80855000000001],[-73.93359554979183,40.80705000000001],[-73.93186349898426,40.80705000000001],[-73.93099747358048,40.80555000000001],[-73.9292654227729,40.80555000000001],[-73.92839939736912,40.80405000000001],[-73.9292654227729,40.80255000000001],[-73.92839939736912,40.80105000000001],[-73.92666734656154,40.80105000000001],[-73.92580132115776,40.79955000000001],[-73.92666734656154,40.79805000000001],[-73.92839939736912,40.79805000000001],[-73.9292654227729,40.79655000000001],[-73.92839939736912,40.79505000000001],[-73.9292654227729,40.79355000000001],[-73.93099747358048,40.79355000000001],[-73.93186349898426,40.79205000000001],[-73.93359554979183,40.79205000000001],[-73.93446157519561,40.79055000000001],[-73.93619362600319,40.79055000000001],[-73.93705965140697,40.78905000000001],[-73.93619362600319,40.78755000000001],[-73.93705965140697,40.78605000000001],[-73.93879170221454,40.78605000000001],[-73.93965772761833,40.78455000000001],[-73.9413897784259,40.78455000000001],[-73.94225580382968,40.78305000000001],[-73.9413897784259,40.78155000000001],[-73.94225580382968,40.78005000000001],[-73.9413897784259,40.77855000000001],[-73.94225580382968,40.77705000000001],[-73.9413897784259,40.77555000000001],[-73.94225580382968,40.77405000000001],[-73.9413897784259,40.77255000000001],[-73.93965772761833,40.77255000000001],[-73.93879170221454,40.77105000000001],[-73.93965772761833,40.76955000000001],[-73.9413897784259,40.76955000000001],[-73.94225580382968,40.76805000000001],[-73.94398785463726,40.76805000000001],[-73.94485388004104,40.76955000000001],[-73.94658593084861,40.76955000000001],[-73.9474519562524,40.76805000000001],[-73.94918400705997,40.76805000000001],[-73.95005003246375,40.76655000000001],[-73.94918400705997,40.76505000000001],[-73.9474519562524,40.76505000000001],[-73.94658593084861,40.76355000000001],[-73.9474519562524,40.76205000000001],[-73.94658593084861,40.76055000000001],[-73.9474519562524,40.75905000000001],[-73.94918400705997,40.75905000000001],[-73.95005003246375,40.75755000000001],[-73.95178208327133,40.75755000000001],[-73.9526481086751,40.75605000000001],[-73.95438015948268,40.75605000000001],[-73.95524618488646,40.75455000000001],[-73.95438015948268,40.75305000000001],[-73.95524618488646,40.75155000000001],[-73.95697823569404,40.75155000000001],[-73.95784426109782,40.75305000000001],[-73.9595763119054,40.75305000000001],[-73.96044233730917,40.75455000000001],[-73.96217438811675,40.75455000000001],[-73.96304041352053,40.75305000000001],[-73.96217438811675,40.75155000000001],[-73.96304041352053,40.75005000000001],[-73.9647724643281,40.75005000000001],[-73.96563848973189,40.74855000000001],[-73.96737054053946,40.74855000000001],[-73.96823656594324,40.74705000000001],[-73.96737054053946,40.74555000000001],[-73.96823656594324,40.74405000000001],[-73.96996861675082,40.74405000000001],[-73.9708346421546,40.74255000000001],[-73.96996861675082,40.74105000000001],[-73.9708346421546,40.73955000000001],[-73.97256669296218,40.73955000000001],[-73.97343271836596,40.73805000000001],[-73.97256669296218,40.73655000000001],[-73.97343271836596,40.73505000000001],[-73.97256669296218,40.73355000000001],[-73.97343271836596,40.73205000000001],[-73.97256669296218,40.73055000000001],[-73.9708346421546,40.73055000000001],[-73.96996861675082,40.72905000000001],[-73.9708346421546,40.72755000000001],[-73.96996861675082,40.72605000000001],[-73.9708346421546,40.72455000000001],[-73.97256669296218,40.72455000000001],[-73.97343271836596,40.72305000000001],[-73.97256669296218,40.72155000000001],[-73.97343271836596,40.72005000000001],[-73.97256669296218,40.71855000000001],[-73.97343271836596,40.71705000000001],[-73.97516476917353,40.71705000000001],[-73.97603079457731,40.71555000000001],[-73.97516476917353,40.71405000000001],[-73.97603079457731,40.71255000000001],[-73.97776284538489,40.71255000000001],[-73.97862887078867,40.71105000000001],[-73.97776284538489,40.70955000000001],[-73.97862887078867,40.70805000000001],[-73.98036092159624,40.70805000000001],[-73.98122694700002,40.70955000000001],[-73.9829589978076,40.70955000000001],[-73.98382502321138,40.70805000000001],[-73.98555707401896,40.70805000000001],[-73.98642309942274,40.70955000000001],[-73.98815515023031,40.70955000000001],[-73.9890211756341,40.70805000000001],[-73.99075322644167,40.70805000000001],[-73.99161925184545,40.70955000000001],[-73.99335130265302,40.70955000000001],[-73.9942173280568,40.70805000000001],[-73.99594937886438,40.70805000000001],[-73.99681540426816,40.70655000000001],[-73.99854745507574,40.70655000000001],[-73.99941348047952,40.70505000000001],[-74.0011455312871,40.70505000000001],[-74.00201155669087,40.70355000000001],[-74.00374360749845,40.70355000000001],[-74.00460963290223,40.70205000000001],[-74.0063416837098,40.70205000000001],[-74.00720770911359,40.70055000000001],[-74.00893975992116,40.70055000000001],[-74.00980578532494,40.69905000000001],[-74.01153783613252,40.69905000000001],[-74.0124038615363,40.70055000000001],[-74.01413591234387,40.70055000000001],[-74.01500193774766,40.70205000000001],[-74.01673398855523,40.70205000000001],[-74.01760001395901,40.70355000000001]]]]},"properties":{"borough":"manhattan"}},{"type":"Feature","geometry":{"type":"MultiPolygon","coordinates":[[[[-73.96044233730917,40.73655000000001],[-73.96217438811675,40.73655000000001],[-73.96304041352053,40.73805000000001],[-73.96217438811675,40.73955000000001],[-73.96304041352053,40.74105000000001],[-73.96217438811675,40.74255000000001],[-73.96044233730917,40.74255000000001],[-73.9595763119054,40.74405000000001],[-73.96044233730917,40.74555000000001],[-73.9595763119054,40.74705000000001],[-73.96044233730917,40.74855000000001],[-73.9595763119054,40.75005000000001],[-73.95784426109782,40.75005000000001],[-73.95697823569404,40.75155000000001],[-73.95524618488646,40.75155000000001],[-73.95438015948268,40.75305000000001],[-73.9526481086751,40.75305000000001],[-73.95178208327133,40.75455000000001],[-73.9526481086751,40.75605000000001],[-73.95178208327133,40.75755000000001],[-73.95005003246375,40.75755000000001],[-73.94918400705997,40.75905000000001],[-73.9474519562524,40.75905000000001],[-73.94658593084861,40.76055000000001],[-73.9474519562524,40.76205000000001],[-73.94658593084861,40.76355000000001],[-73.94485388004104,40.76355000000001],[-73.94398785463726,40.76505000000001],[-73.94225580382968,40.76505000000001],[-73.9413897784259,40.76655000000001],[-73.93965772761833,40.76655000000001],[-73.93879170221454,40.76805000000001],[-73.93965772761833,40.76955000000001],[-73.93879170221454,40.77105000000001],[-73.93965772761833,40.77255000000001],[-73.93879170221454,40.77405000000001],[-73.93965772761833,40.77555000000001],[-73.93879170221454,40.77705000000001],[-73.93705965140697,40.77705000000001],[-73.93619362600319,40.77855000000001],[-73.93446157519561,40.77855000000001],[-73.93359554979183,40.78005000000001],[-73.93186349898426,40.78005000000001],[-73.93099747358048,40.77855000000001],[-73.9292654227729,40.77855000000001],[-73.92839939736912,40.77705000000001],[-73.92666734656154,40.77705000000001],[-73.92580132115776,40.77855000000001],[-73.92406927035019,40.77855000000001],[-73.92320324494641,40.78005000000001],[-73.92406927035019,40.78155000000001],[-73.92320324494641,40.78305000000001],[-73.92147119413883,40.78305000000001],[-73.92060516873505,40.78455000000001],[-73.91887311792748,40.78455000000001],[-73.9180070925237,40.78605000000001],[-73.91627504171612,40.78605000000001],[-73.91540901631234,40.78755000000001],[-73.91367696550476,40.78755000000001],[-73.91281094010098,40.78605000000001],[-73.9110788892934,40.78605000000001],[-73.91021286388963,40.78455000000001],[-73.90848081308205,40.78455000000001],[-73.90761478767827,40.78305000000001],[-73.9058827368707,40.78305000000001],[-73.90501671146691,40.78155000000001],[-73.90328466065934,40.78155000000001],[-73.90241863525556,40.78305000000001],[-73.90328466065934,40.78455000000001],[-73.90501671146691,40.78455000000001],[-73.9058827368707,40.78605000000001],[-73.90761478767827,40.78605000000001],[-73.90848081308205,40.78755000000001],[-73.90761478767827,40.78905000000001],[-73.9058827368707,40.78905000000001],[-73.90501671146691,40.79055000000001],[-73.90328466065934,40.79055000000001],[-73.90241863525556,40.78905000000001],[-73.90068658444798,40.78905000000001],[-73.8998205590442,40.79055000000001],[-73.89808850823663,40.79055000000001],[-73.89722248283285,40.78905000000001],[-73.89808850823663,40.78755000000001],[-73.89722248283285,40.78605000000001],[-73.89808850823663,40.78455000000001],[-73.8998205590442,40.78455000000001],[-73.90068658444798,40.78305000000001],[-73.8998205590442,40.78155000000001],[-73.89808850823663,40.78155000000001],[-73.89722248283285,40.78305000000001],[-73.89549043202527,40.78305000000001],[-73.89462440662149,40.78155000000001],[-73.89549043202527,40.78005000000001],[-73.89462440662149,40.77855000000001],[-73.89289235581391,40.77855000000001],[-73.89202633041013,40.78005000000001],[-73.89029427960256,40.78005000000001],[-73.88942825419878,40.77855000000001],[-73.8876962033912,40.77855000000001],[-73.88683017798742,40.77705000000001],[-73.8876962033912,40.77555000000001],[-73.88683017798742,40.77405000000001],[-73.8876962033912,40.77255000000001],[-73.88683017798742,40.77105000000001],[-73.8876962033912,40.76955000000001],[-73.88683017798742,40.76805000000001],[-73.88509812717984,40.76805000000001],[-73.88423210177606,40.76955000000001],[-73.88250005096849,40.76955000000001],[-73.88163402556471,40.77105000000001],[-73.87990197475713,40.77105000000001],[-73.87903594935335,40.77255000000001],[-73.87730389854578,40.77255000000001],[-73.876437873142,40.77105000000001],[-73.87470582233442,40.77105000000001],[-73.87383979693064,40.77255000000001],[-73.87210774612306,40.77255000000001],[-73.87124172071928,40.77105000000001],[-73.86950966991171,40.77105000000001],[-73.86864364450793,40.77255000000001],[-73.86691159370035,40.77255000000001],[-73.86604556829657,40.77105000000001],[-73.86691159370035,40.76955000000001],[-73.86604556829657,40.76805000000001],[-73.864313517489,40.76805000000001],[-73.86344749208521,40.76655000000001],[-73.86171544127764,40.76655000000001],[-73.86084941587386,40.76505000000001],[-73.85911736506628,40.76505000000001],[-73.8582513396625,40.76355000000001],[-73.85911736506628,40.76205000000001],[-73.8582513396625,40.76055000000001],[-73.85651928885493,40.76055000000001],[-73.85565326345115,40.75905000000001],[-73.85392121264357,40.75905000000001],[-73.85305518723979,40.75755000000001],[-73.85132313643221,40.75755000000001],[-73.85045711102843,40.75905000000001],[-73.84872506022086,40.75905000000001],[-73.84785903481708,40.76055000000001],[-73.8461269840095,40.76055000000001],[-73.84526095860572,40.76205000000001],[-73.84352890779815,40.76205000000001],[-73.84266288239436,40.76355000000001],[-73.84352890779815,40.76505000000001],[-73.84526095860572,40.76505000000001],[-73.8461269840095,40.76355000000001],[-73.84785903481708,40.76355000000001],[-73.84872506022086,40.76505000000001],[-73.84785903481708,40.76655000000001],[-73.84872506022086,40.76805000000001],[-73.84785903481708,40.76955000000001],[-73.84872506022086,40.77105000000001],[-73.85045711102843,40.77105000000001],[-73.85132313643221,40.77255000000001],[-73.85045711102843,40.77405000000001],[-73.85132313643221,40.77555000000001],[-73.85045711102843,40.77705000000001],[-73.85132313643221,40.77855000000001],[-73.85045711102843,40.78005000000001],[-73.85132313643221,40.78155000000001],[-73.85305518723979,40.78155000000001],[-73.85392121264357,40.78305000000001],[-73.85565326345115,40.78305000000001],[-73.85651928885493,40.78155000000001],[-73.8582513396625,40.78155000000001],[-73.85911736506628,40.78305000000001],[-73.8582513396625,40.78455000000001],[-73.85911736506628,40.78605000000001],[-73.8582513396625,40.78755000000001],[-73.85651928885493,40.78755000000001],[-73.85565326345115,40.78905000000001],[-73.85651928885493,40.79055000000001],[-73.85565326345115,40.79205000000001],[-73.85392121264357,40.79205000000001],[-73.85305518723979,40.79355000000001],[-73.85132313643221,40.79355000000001],[-73.85045711102843,40.79505000000001],[-73.85132313643221,40.79655000000001],[-73.85045711102843,40.79805000000001],[-73.84872506022086,40.79805000000001],[-73.84785903481708,40.79655000000001],[-73.8461269840095,40.79655000000001],[-73.84526095860572,40.79505000000001],[-73.84352890779815,40.79505000000001],[-73.84266288239436,40.79655000000001],[-73.84093083158679,40.79655000000001],[-73.84006480618301,40.79505000000001],[-73.83833275537543,40.79505000000001],[-73.83746672997165,40.79355000000001],[-73.83573467916408,40.79355000000001],[-73.8348686537603,40.79205000000001],[-73.83313660295272,40.79205000000001],[-73.83227057754894,40.79355000000001],[-73.83053852674136,40.79355000000001],[-73.82967250133758,40.79505000000001],[-73.83053852674136,40.79655000000001],[-73.82967250133758,40.79805000000001],[-73.82794045053001,40.79805000000001],[-73.82707442512623,40.79955000000001],[-73.82534237431865,40.79955000000001],[-73.82447634891487,40.80105000000001],[-73.8227442981073,40.80105000000001],[-73.82187827270351,40.80255000000001],[-73.82014622189594,40.80255000000001],[-73.81928019649216,40.80105000000001],[-73.81754814568458,40.80105000000001],[-73.8166821202808,40.79955000000001],[-73.81495006947323,40.79955000000001],[-73.81408404406945,40.80105000000001],[-73.81235199326187,40.80105000000001],[-73.81148596785809,40.79955000000001],[-73.80975391705051,40.79955000000001],[-73.80888789164673,40.79805000000001],[-73.80715584083916,40.79805000000001],[-73.80628981543538,40.79655000000001],[-73.8045577646278,40.79655000000001],[-73.80369173922402,40.79805000000001],[-73.80195968841645,40.79805000000001],[-73.80109366301267,40.79655000000001],[-73.79936161220509,40.79655000000001],[-73.79849558680131,40.79805000000001],[-73.79676353599373,40.79805000000001],[-73.79589751058995,40.79655000000001],[-73.79416545978238,40.79655000000001],[-73.7932994343786,40.79505000000001],[-73.79416545978238,40.79355000000001],[-73.7932994343786,40.79205000000001],[-73.79156738357102,40.79205000000001],[-73.79070135816724,40.79055000000001],[-73.78896930735966,40.79055000000001],[-73.78810328195588,40.78905000000001],[-73.78637123114831,40.78905000000001],[-73.78550520574453,40.79055000000001],[-73.78377315493695,40.79055000000001],[-73.78290712953317,40.78905000000001],[-73.7811750787256,40.78905000000001],[-73.78030905332182,40.79055000000001],[-73.77857700251424,40.79055000000001],[-73.77771097711046,40.78905000000001],[-73.77597892630288,40.78905000000001],[-73.7751129008991,40.78755000000001],[-73.77338085009153,40.78755000000001],[-73.77251482468775,40.78905000000001],[-73.77078277388017,40.78905000000001],[-73.76991674847639,40.78755000000001],[-73.77078277388017,40.78605000000001],[-73.77251482468775,40.78605000000001],[-73.77338085009153,40.78455000000001],[-73.77251482468775,40.78305000000001],[-73.77078277388017,40.78305000000001],[-73.76991674847639,40.78155000000001],[-73.76818469766881,40.78155000000001],[-73.76731867226503,40.78005000000001],[-73.76818469766881,40.77855000000001],[-73.76731867226503,40.77705000000001],[-73.76558662145746,40.77705000000001],[-73.76472059605368,40.77555000000001],[-73.76558662145746,40.77405000000001],[-73.76472059605368,40.77255000000001],[-73.7629885452461,40.77255000000001],[-73.76212251984232,40.77105000000001],[-73.76039046903475,40.77105000000001],[-73.75952444363097,40.76955000000001],[-73.75779239282339,40.76955000000001],[-73.75692636741961,40.77105000000001],[-73.75779239282339,40.77255000000001],[-73.75692636741961,40.77405000000001],[-73.75519431661203,40.77405000000001],[-73.75432829120825,40.77555000000001],[-73.75519431661203,40.77705000000001],[-73.75432829120825,40.77855000000001],[-73.75519431661203,40.78005000000001],[-73.75432829120825,40.78155000000001],[-73.75259624040068,40.78155000000001],[-73.7517302149969,40.78305000000001],[-73.74999816418932,40.78305000000001],[-73.74913213878554,40.78155000000001],[-73.74740008797797,40.78155000000001],[-73.74653406257418,40.78005000000001],[-73.74480201176661,40.78005000000001],[-73.74393598636283,40.77855000000001],[-73.74220393555525,40.77855000000001],[-73.74133791015147,40.77705000000001],[-73.7396058593439,40.77705000000001],[-73.73873983394012,40.77555000000001],[-73.73700778313254,40.77555000000001],[-73.73614175772876,40.77405000000001],[-73.73440970692118,40.77405000000001],[-73.7335436815174,40.77255000000001],[-73.73181163070983,40.77255000000001],[-73.73094560530605,40.77105000000001],[-73.72921355449847,40.77105000000001],[-73.72834752909469,40.76955000000001],[-73.72661547828712,40.76955000000001],[-73.72574945288333,40.76805000000001],[-73.72401740207576,40.76805000000001],[-73.72315137667198,40.76655000000001],[-73.7214193258644,40.76655000000001],[-73.72055330046062,40.76505000000001],[-73.71882124965305,40.76505000000001],[-73.71795522424927,40.76355000000001],[-73.71622317344169,40.76355000000001],[-73.71535714803791,40.76205000000001],[-73.71362509723033,40.76205000000001],[-73.71275907182655,40.76055000000001],[-73.71362509723033,40.75905000000001],[-73.71535714803791,40.75905000000001],[-73.71622317344169,40.75755000000001],[-73.71535714803791,40.75605000000001],[-73.71362509723033,40.75605000000001],[-73.71275907182655,40.75455000000001],[-73.71102702101898,40.75455000000001],[-73.7101609956152,40.75605000000001],[-73.70842894480762,40.75605000000001],[-73.70756291940384,40.75455000000001],[-73.70583086859627,40.75455000000001],[-73.70496484319249,40.75605000000001],[-73.70323279238491,40.75605000000001],[-73.70236676698113,40.75455000000001],[-73.70063471617355,40.75455000000001],[-73.69976869076977,40.75305000000001],[-73.70063471617355,40.75155000000001],[-73.69976869076977,40.75005000000001],[-73.70063471617355,40.74855000000001],[-73.69976869076977,40.74705000000001],[-73.70063471617355,40.74555000000001],[-73.69976869076977,40.74405000000001],[-73.70063471617355,40.74255000000001],[-73.69976869076977,40.74105000000001],[-73.6980366399622,40.74105000000001],[-73.69717061455842,40.73955000000001],[-73.6980366399622,40.73805000000001],[-73.69976869076977,40.73805000000001],[-73.70063471617355,40.73655000000001],[-73.69976869076977,40.73505000000001],[-73.70063471617355,40.73355000000001],[-73.70236676698113,40.73355000000001],[-73.70323279238491,40.73205000000001],[-73.70496484319249,40.73205000000001],[-73.70583086859627,40.73055000000001],[-73.70496484319249,40.72905000000001],[-73.70583086859627,40.72755000000001],[-73.70756291940384,40.72755000000001],[-73.70842894480762,40.72605000000001],[-73.7101609956152,40.72605000000001],[-73.71102702101898,40.72455000000001],[-73.71275907182655,40.72455000000001],[-73.71362509723033,40.72605000000001],[-73.71535714803791,40.72605000000001],[-73.71622317344169,40.72455000000001],[-73.71795522424927,40.72455000000001],[-73.71882124965305,40.72305000000001],[-73.72055330046062,40.72305000000001],[-73.7214193258644,40.72455000000001],[-73.72315137667198,40.72455000000001],[-73.72401740207576,40.72305000000001],[-73.72574945288333,40.72305000000001],[-73.72661547828712,40.72155000000001],[-73.72834752909469,40.72155000000001],[-73.72921355449847,40.72005000000001],[-73.72834752909469,40.71855000000001],[-73.72661547828712,40.71855000000001],[-73.72574945288333,40.71705000000001],[-73.72661547828712,40.71555000000001],[-73.72574945288333,40.71405000000001],[-73.72661547828712,40.71255000000001],[-73.72574945288333,40.71105000000001],[-73.72661547828712,40.70955000000001],[-73.72574945288333,40.70805000000001],[-73.72661547828712,40.70655000000001],[-73.72574945288333,40.70505000000001],[-73.72661547828712,40.70355000000001],[-73.72574945288333,40.70205000000001],[-73.72661547828712,40.70055000000001],[-73.72574945288333,40.69905000000001],[-73.72661547828712,40.69755000000001],[-73.72574945288333,40.69605000000001],[-73.72661547828712,40.69455000000001],[-73.72574945288333,40.69305000000001],[-73.72661547828712,40.69155000000001],[-73.72574945288333,40.69005000000001],[-73.72661547828712,40.688550000000006],[-73.72574945288333,40.687050000000006],[-73.72661547828712,40.685550000000006],[-73.72574945288333,40.684050000000006],[-73.72401740207576,40.684050000000006],[-73.72315137667198,40.682550000000006],[-73.72401740207576,40.681050000000006],[-73.72315137667198,40.679550000000006],[-73.72401740207576,40.678050000000006],[-73.72574945288333,40.678050000000006],[-73.72661547828712,40.676550000000006],[-73.72574945288333,40.675050000000006],[-73.72661547828712,40.673550000000006],[-73.72574945288333,40.672050000000006],[-73.72661547828712,40.670550000000006],[-73.72574945288333,40.669050000000006],[-73.72661547828712,40.667550000000006],[-73.72574945288333,40.666050000000006],[-73.72661547828712,40.664550000000006],[-73.72574945288333,40.663050000000005],[-73.72661547828712,40.661550000000005],[-73.72574945288333,40.660050000000005],[-73.72401740207576,40.660050000000005],[-73.72315137667198,40.658550000000005],[-73.72401740207576,40.657050000000005],[-73.72315137667198,40.655550000000005],[-73.72401740207576,40.654050000000005],[-73.72315137667198,40.652550000000005],[-73.72401740207576,40.651050000000005],[-73.72574945288333,40.651050000000005],[-73.72661547828712,40.649550000000005],[-73.72834752909469,40.649550000000005],[-73.72921355449847,40.648050000000005],[-73.73094560530605,40.648050000000005],[-73.73181163070983,40.649550000000005],[-73.7335436815174,40.649550000000005],[-73.73440970692118,40.648050000000005],[-73.73614175772876,40.648050000000005],[-73.73700778313254,40.646550000000005],[-73.73873983394012,40.646550000000005],[-73.7396058593439,40.645050000000005],[-73.73873983394012,40.643550000000005],[-73.7396058593439,40.642050000000005],[-73.74133791015147,40.642050000000005],[-73.74220393555525,40.640550000000005],[-73.74133791015147,40.639050000000005],[-73.7396058593439,40.639050000000005],[-73.73873983394012,40.637550000000005],[-73.7396058593439,40.636050000000004],[-73.73873983394012,40.634550000000004],[-73.7396058593439,40.633050000000004],[-73.74133791015147,40.633050000000004],[-73.74220393555525,40.634550000000004],[-73.74393598636283,40.634550000000004],[-73.74480201176661,40.636050000000004],[-73.74653406257418,40.636050000000004],[-73.74740008797797,40.637550000000005],[-73.74653406257418,40.639050000000005],[-73.74480201176661,40.639050000000005],[-73.74393598636283,40.640550000000005],[-73.74480201176661,40.642050000000005],[-73.74653406257418,40.642050000000005],[-73.74740008797797,40.643550000000005],[-73.74653406257418,40.645050000000005],[-73.74740008797797,40.646550000000005],[-73.74653406257418,40.648050000000005],[-73.74740008797797,40.649550000000005],[-73.74653406257418,40.651050000000005],[-73.74740008797797,40.652550000000005],[-73.74913213878554,40.652550000000005],[-73.74999816418932,40.654050000000005],[-73.7517302149969,40.654050000000005],[-73.75259624040068,40.652550000000005],[-73.7517302149969,40.651050000000005],[-73.75259624040068,40.649550000000005],[-73.7517302149969,40.648050000000005],[-73.75259624040068,40.646550000000005],[-73.7517302149969,40.645050000000005],[-73.75259624040068,40.643550000000005],[-73.7517302149969,40.642050000000005],[-73.75259624040068,40.640550000000005],[-73.75432829120825,40.640550000000005],[-73.75519431661203,40.639050000000005],[-73.75432829120825,40.637550000000005],[-73.75519431661203,40.636050000000004],[-73.75692636741961,40.636050000000004],[-73.75779239282339,40.634550000000004],[-73.75952444363097,40.634550000000004],[-73.76039046903475,40.633050000000004],[-73.76212251984232,40.633050000000004],[-73.7629885452461,40.634550000000004],[-73.76472059605368,40.634550000000004],[-73.76558662145746,40.636050000000004],[-73.76472059605368,40.637550000000005],[-73.7629885452461,40.637550000000005],[-73.76212251984232,40.639050000000005],[-73.7629885452461,40.640550000000005],[-73.76212251984232,40.642050000000005],[-73.76039046903475,40.642050000000005],[-73.75952444363097,40.643550000000005],[-73.76039046903475,40.645050000000005],[-73.75952444363097,40.646550000000005],[-73.75779239282339,40.646550000000005],[-73.75692636741961,40.648050000000005],[-73.75779239282339,40.649550000000005],[-73.75952444363097,40.649550000000005],[-73.76039046903475,40.651050000000005],[-73.75952444363097,40.652550000000005],[-73.76039046903475,40.654050000000005],[-73.76212251984232,40.654050000000005],[-73.7629885452461,40.652550000000005],[-73.76212251984232,40.651050000000005],[-73.7629885452461,40.649550000000005],[-73.76472059605368,40.649550000000005],[-73.76558662145746,40.651050000000005],[-73.76731867226503,40.651050000000005],[-73.76818469766881,40.652550000000005],[-73.76991674847639,40.652550000000005],[-73.77078277388017,40.654050000000005],[-73.76991674847639,40.655550000000005],[-73.77078277388017,40.657050000000005],[-73.77251482468775,40.657050000000005],[-73.77338085009153,40.658550000000005],[-73.7751129008991,40.658550000000005],[-73.77597892630288,40.660050000000005],[-73.77771097711046,40.660050000000005],[-73.77857700251424,40.661550000000005],[-73.78030905332182,40.661550000000005],[-73.7811750787256,40.663050000000005],[-73.78290712953317,40.663050000000005],[-73.78377315493695,40.661550000000005],[-73.78550520574453,40.661550000000005],[-73.78637123114831,40.663050000000005],[-73.78810328195588,40.663050000000005],[-73.78896930735966,40.664550000000006],[-73.79070135816724,40.664550000000006],[-73.79156738357102,40.663050000000005],[-73.7932994343786,40.663050000000005],[-73.79416545978238,40.664550000000006],[-73.79589751058995,40.664550000000006],[-73.79676353599373,40.663050000000005],[-73.79849558680131,40.663050000000005],[-73.79936161220509,40.664550000000006],[-73.80109366301267,40.664550000000006],[-73.80195968841645,40.666050000000006],[-73.80369173922402,40.666050000000006],[-73.8045577646278,40.664550000000006],[-73.80369173922402,40.663050000000005],[-73.8045577646278,40.661550000000005],[-73.80628981543538,40.661550000000005],[-73.80715584083916,40.660050000000005],[-73.80888789164673,40.660050000000005],[-73.80975391705051,40.658550000000005],[-73.81148596785809,40.658550000000005],[-73.81235199326187,40.660050000000005],[-73.81408404406945,40.660050000000005],[-73.81495006947323,40.661550000000005],[-73.8166821202808,40.661550000000005],[-73.81754814568458,40.663050000000005],[-73.81928019649216,40.663050000000005],[-73.82014622189594,40.661550000000005],[-73.82187827270351,40.661550000000005],[-73.8227442981073,40.663050000000005],[-73.82447634891487,40.663050000000005],[-73.82534237431865,40.664550000000006],[-73.82707442512623,40.664550000000006],[-73.82794045053001,40.663050000000005],[-73.82967250133758,40.663050000000005],[-73.83053852674136,40.661550000000005],[-73.82967250133758,40.660050000000005],[-73.82794045053001,40.660050000000005],[-73.82707442512623,40.658550000000005],[-73.82794045053001,40.657050000000005],[-73.82707442512623,40.655550000000005],[-73.82794045053001,40.654050000000005],[-73.82707442512623,40.652550000000005],[-73.82534237431865,40.652550000000005],[-73.82447634891487,40.651050000000005],[-73.82534237431865,40.649550000000005],[-73.82707442512623,40.649550000000005],[-73.82794045053001,40.648050000000005],[-73.82967250133758,40.648050000000005],[-73.83053852674136,40.649550000000005],[-73.83227057754894,40.649550000000005],[-73.83313660295272,40.648050000000005],[-73.8348686537603,40.648050000000005],[-73.83573467916408,40.646550000000005],[-73.83746672997165,40.646550000000005],[-73.83833275537543,40.648050000000005],[-73.84006480618301,40.648050000000005],[-73.84093083158679,40.646550000000005],[-73.84266288239436,40.646550000000005],[-73.84352890779815,40.648050000000005],[-73.84526095860572,40.648050000000005],[-73.8461269840095,40.646550000000005],[-73.84785903481708,40.646550000000005],[-73.84872506022086,40.648050000000005],[-73.84785903481708,40.649550000000005],[-73.84872506022086,40.651050000000005],[-73.84785903481708,40.652550000000005],[-73.84872506022086,40.654050000000005],[-73.85045711102843,40.654050000000005],[-73.85132313643221,40.652550000000005],[-73.85305518723979,40.652550000000005],[-73.85392121264357,40.654050000000005],[-73.85565326345115,40.654050000000005],[-73.85651928885493,40.655550000000005],[-73.8582513396625,40.655550000000005],[-73.85911736506628,40.654050000000005],[-73.86084941587386,40.654050000000005],[-73.86171544127764,40.655550000000005],[-73.86084941587386,40.657050000000005],[-73.85911736506628,40.657050000000005],[-73.8582513396625,40.658550000000005],[-73.85911736506628,40.660050000000005],[-73.8582513396625,40.661550000000005],[-73.85911736506628,40.663050000000005],[-73.8582513396625,40.664550000000006],[-73.85651928885493,40.664550000000006],[-73.85565326345115,40.666050000000006],[-73.85651928885493,40.667550000000006],[-73.85565326345115,40.669050000000006],[-73.85651928885493,40.670550000000006],[-73.8582513396625,40.670550000000006],[-73.85911736506628,40.672050000000006],[-73.86084941587386,40.672050000000006],[-73.86171544127764,40.673550000000006],[-73.86084941587386,40.675050000000006],[-73.86171544127764,40.676550000000006],[-73.86084941587386,40.678050000000006],[-73.86171544127764,40.679550000000006],[-73.86344749208521,40.679550000000006],[-73.864313517489,40.681050000000006],[-73.86604556829657,40.681050000000006],[-73.86691159370035,40.682550000000006],[-73.86604556829657,40.684050000000006],[-73.86691159370035,40.685550000000006],[-73.86604556829657,40.687050000000006],[-73.86691159370035,40.688550000000006],[-73.86864364450793,40.688550000000006],[-73.86950966991171,40.69005000000001],[-73.86864364450793,40.69155000000001],[-73.86950966991171,40.69305000000001],[-73.86864364450793,40.69455000000001],[-73.86950966991171,40.69605000000001],[-73.86864364450793,40.69755000000001],[-73.86691159370035,40.69755000000001],[-73.86604556829657,40.69605000000001],[-73.864313517489,40.69605000000001],[-73.86344749208521,40.69755000000001],[-73.86171544127764,40.69755000000001],[-73.86084941587386,40.69905000000001],[-73.85911736506628,40.69905000000001],[-73.8582513396625,40.69755000000001],[-73.85651928885493,40.69755000000001],[-73.85565326345115,40.69905000000001],[-73.85392121264357,40.69905000000001],[-73.85305518723979,40.70055000000001],[-73.85392121264357,40.70205000000001],[-73.85565326345115,40.70205000000001],[-73.85651928885493,40.70055000000001],[-73.8582513396625,40.70055000000001],[-73.85911736506628,40.70205000000001],[-73.86084941587386,40.70205000000001],[-73.86171544127764,40.70055000000001],[-73.86344749208521,40.70055000000001],[-73.864313517489,40.70205000000001],[-73.86604556829657,40.70205000000001],[-73.86691159370035,40.70055000000001],[-73.86864364450793,40.70055000000001],[-73.86950966991171,40.70205000000001],[-73.87124172071928,40.70205000000001],[-73.87210774612306,40.70055000000001],[-73.87383979693064,40.70055000000001],[-73.87470582233442,40.69905000000001],[-73.876437873142,40.69905000000001],[-73.87730389854578,40.70055000000001],[-73.87903594935335,40.70055000000001],[-73.87990197475713,40.69905000000001],[-73.87903594935335,40.69755000000001],[-73.87730389854578,40.69755000000001],[-73.876437873142,40.69605000000001],[-73.87730389854578,40.69455000000001],[-73.876437873142,40.69305000000001],[-73.87730389854578,40.69155000000001],[-73.87903594935335,40.69155000000001],[-73.87990197475713,40.69005000000001],[-73.88163402556471,40.69005000000001],[-73.88250005096849,40.688550000000006],[-73.88423210177606,40.688550000000006],[-73.88509812717984,40.687050000000006],[-73.88423210177606,40.685550000000006],[-73.88509812717984,40.684050000000006],[-73.88683017798742,40.684050000000006],[-73.8876962033912,40.685550000000006],[-73.88942825419878,40.685550000000006],[-73.89029427960256,40.687050000000006],[-73.89202633041013,40.687050000000006],[-73.89289235581391,40.685550000000006],[-73.89462440662149,40.685550000000006],[-73.89549043202527,40.684050000000006],[-73.89722248283285,40.684050000000006],[-73.89808850823663,40.685550000000006],[-73.89722248283285,40.687050000000006],[-73.89549043202527,40.687050000000006],[-73.89462440662149,40.688550000000006],[-73.89549043202527,40.69005000000001],[-73.89722248283285,40.69005000000001],[-73.89808850823663,40.688550000000006],[-73.8998205590442,40.688550000000006],[-73.90068658444798,40.69005000000001],[-73.8998205590442,40.69155000000001],[-73.90068658444798,40.69305000000001],[-73.90241863525556,40.69305000000001],[-73.90328466065934,40.69455000000001],[-73.90501671146691,40.69455000000001],[-73.9058827368707,40.69605000000001],[-73.90761478767827,40.69605000000001],[-73.90848081308205,40.69755000000001],[-73.91021286388963,40.69755000000001],[-73.9110788892934,40.69905000000001],[-73.91021286388963,40.70055000000001],[-73.9110788892934,40.70205000000001],[-73.91281094010098,40.70205000000001],[-73.91367696550476,40.70355000000001],[-73.91281094010098,40.70505000000001],[-73.91367696550476,40.70655000000001],[-73.91540901631234,40.70655000000001],[-73.91627504171612,40.70805000000001],[-73.9180070925237,40.70805000000001],[-73.91887311792748,40.70655000000001],[-73.92060516873505,40.70655000000001],[-73.92147119413883,40.70805000000001],[-73.92060516873505,40.70955000000001],[-73.92147119413883,40.71105000000001],[-73.92320324494641,40.71105000000001],[-73.92406927035019,40.71255000000001],[-73.92320324494641,40.71405000000001],[-73.92406927035019,40.71555000000001],[-73.92320324494641,40.71705000000001],[-73.92406927035019,40.71855000000001],[-73.92580132115776,40.71855000000001],[-73.92666734656154,40.72005000000001],[-73.92580132115776,40.72155000000001],[-73.92406927035019,40.72155000000001],[-73.92320324494641,40.72305000000001],[-73.92406927035019,40.72455000000001],[-73.92580132115776,40.72455000000001],[-73.92666734656154,40.72305000000001],[-73.92839939736912,40.72305000000001],[-73.9292654227729,40.72455000000001],[-73.92839939736912,40.72605000000001],[-73.9292654227729,40.72755000000001],[-73.93099747358048,40.72755000000001],[-73.93186349898426,40.72905000000001],[-73.93359554979183,40.72905000000001],[-73.93446157519561,40.72755000000001],[-73.93619362600319,40.72755000000001],[-73.93705965140697,40.72905000000001],[-73.93879170221454,40.72905000000001],[-73.93965772761833,40.73055000000001],[-73.93879170221454,40.73205000000001],[-73.93965772761833,40.73355000000001],[-73.9413897784259,40.73355000000001],[-73.94225580382968,40.73505000000001],[-73.94398785463726,40.73505000000001],[-73.94485388004104,40.73655000000001],[-73.94658593084861,40.73655000000001],[-73.9474519562524,40.73805000000001],[-73.94918400705997,40.73805000000001],[-73.95005003246375,40.73955000000001],[-73.95178208327133,40.73955000000001],[-73.9526481086751,40.74105000000001],[-73.95438015948268,40.74105000000001],[-73.95524618488646,40.73955000000001],[-73.95697823569404,40.73955000000001],[-73.95784426109782,40.73805000000001],[-73.9595763119054,40.73805000000001],[-73.96044233730917,40.73655000000001]]],[[[-73.9292654227729,40.55055],[-73.93099747358048,40.55055],[-73.93186349898426,40.55205],[-73.93099747358048,40.55355],[-73.93186349898426,40.55505],[-73.93099747358048,40.55655],[-73.93186349898426,40.55805],[-73.93099747358048,40.55955],[-73.9292654227729,40.55955],[-73.92839939736912,40.56105],[-73.92666734656154,40.56105],[-73.92580132115776,40.56255],[-73.92406927035019,40.56255],[-73.92320324494641,40.56105],[-73.92147119413883,40.56105],[-73.92060516873505,40.56255],[-73.91887311792748,40.56255],[-73.9180070925237,40.56405],[-73.91627504171612,40.56405],[-73.91540901631234,40.56255],[-73.91367696550476,40.56255],[-73.91281094010098,40.56105],[-73.9110788892934,40.56105],[-73.91021286388963,40.56255],[-73.90848081308205,40.56255],[-73.90761478767827,40.56105],[-73.9058827368707,40.56105],[-73.90501671146691,40.56255],[-73.90328466065934,40.56255],[-73.90241863525556,40.56405],[-73.90068658444798,40.56405],[-73.8998205590442,40.56255],[-73.90068658444798,40.56105],[-73.8998205590442,40.55955],[-73.90068658444798,40.55805],[-73.90241863525556,40.55805],[-73.90328466065934,40.55955],[-73.90501671146691,40.55955],[-73.9058827368707,40.55805],[-73.90761478767827,40.55805],[-73.90848081308205,40.55655],[-73.91021286388963,40.55655],[-73.9110788892934,40.55505],[-73.91281094010098,40.55505],[-73.91367696550476,40.55355],[-73.91540901631234,40.55355],[-73.91627504171612,40.55205],[-73.9180070925237,40.55205],[-73.91887311792748,40.55355],[-73.92060516873505,40.55355],[-73.92147119413883,40.55205],[-73.92320324494641,40.55205],[-73.92406927035019,40.55055],[-73.92580132115776,40.55055],[-73.92666734656154,40.54905],[-73.92839939736912,40.54905],[-73.9292654227729,40.55055]]],[[[-73.89549043202527,40.56405],[-73.89722248283285,40.56405],[-73.89808850823663,40.56555],[-73.89722248283285,40.56705],[-73.89549043202527,40.56705],[-73.89462440662149,40.56855],[-73.89289235581391,40.56855],[-73.89202633041013,40.57005],[-73.89029427960256,40.57005],[-73.88942825419878,40.56855],[-73.8876962033912,40.56855],[-73.88683017798742,40.57005],[-73.88509812717984,40.57005],[-73.88423210177606,40.56855],[-73.88250005096849,40.56855],[-73.88163402556471,40.57005],[-73.87990197475713,40.57005],[-73.87903594935335,40.57155],[-73.87730389854578,40.57155],[-73.876437873142,40.57305],[-73.87470582233442,40.57305],[-73.87383979693064,40.57155],[-73.87210774612306,40.57155],[-73.87124172071928,40.57305],[-73.86950966991171,40.57305],[-73.86864364450793,40.57455],[-73.86691159370035,40.57455],[-73.86604556829657,40.57605],[-73.864313517489,40.57605],[-73.86344749208521,40.57755],[-73.86171544127764,40.57755],[-73.86084941587386,40.57905],[-73.85911736506628,40.57905],[-73.8582513396625,40.58055],[-73.85651928885493,40.58055],[-73.85565326345115,40.58205],[-73.85392121264357,40.58205],[-73.85305518723979,40.58355],[-73.85132313643221,40.58355],[-73.85045711102843,40.58505],[-73.84872506022086,40.58505],[-73.84785903481708,40.58355],[-73.8461269840095,40.58355],[-73.84526095860572,40.58205],[-73.84352890779815,40.58205],[-73.84266288239436,40.58355],[-73.84093083158679,40.58355],[-73.84006480618301,40.58505],[-73.83833275537543,40.58505],[-73.83746672997165,40.58355],[-73.83573467916408,40.58355],[-73.8348686537603,40.58505],[-73.83313660295272,40.58505],[-73.83227057754894,40.58655],[-73.83053852674136,40.58655],[-73.82967250133758,40.58505],[-73.82794045053001,40.58505],[-73.82707442512623,40.58655],[-73.82534237431865,40.58655],[-73.82447634891487,40.58805],[-73.8227442981073,40.58805],[-73.82187827270351,40.58955],[-73.82014622189594,40.58955],[-73.81928019649216,40.59105],[-73.81754814568458,40.59105],[-73.8166821202808,40.59255],[-73.81495006947323,40.59255],[-73.81408404406945,40.59405],[-73.81235199326187,40.59405],[-73.81148596785809,40.59255],[-73.80975391705051,40.59255],[-73.80888789164673,40.59405],[-73.80715584083916,40.59405],[-73.80628981543538,40.59555],[-73.80715584083916,40.59705],[-73.80628981543538,40.59855],[-73.8045577646278,40.59855],[-73.80369173922402,40.60005],[-73.80195968841645,40.60005],[-73.80109366301267,40.60155],[-73.79936161220509,40.60155],[-73.79849558680131,40.60005],[-73.79676353599373,40.60005],[-73.79589751058995,40.60155],[-73.79416545978238,40.60155],[-73.7932994343786,40.60005],[-73.79156738357102,40.60005],[-73.79070135816724,40.59855],[-73.78896930735966,40.59855],[-73.78810328195588,40.60005],[-73.78637123114831,40.60005],[-73.78550520574453,40.59855],[-73.78377315493695,40.59855],[-73.78290712953317,40.60005],[-73.78377315493695,40.60155],[-73.78290712953317,40.60305],[-73.7811750787256,40.60305],[-73.78030905332182,40.60455],[-73.77857700251424,40.60455],[-73.77771097711046,40.60305],[-73.77597892630288,40.60305],[-73.7751129008991,40.60455],[-73.77338085009153,40.60455],[-73.77251482468775,40.60605],[-73.77078277388017,40.60605],[-73.76991674847639,40.60755],[-73.77078277388017,40.60905],[-73.77251482468775,40.60905],[-73.77338085009153,40.61055],[-73.7751129008991,40.61055],[-73.77597892630288,40.61205],[-73.7751129008991,40.613550000000004],[-73.77597892630288,40.615050000000004],[-73.7751129008991,40.616550000000004],[-73.77338085009153,40.616550000000004],[-73.77251482468775,40.615050000000004],[-73.77078277388017,40.615050000000004],[-73.76991674847639,40.616550000000004],[-73.76818469766881,40.616550000000004],[-73.76731867226503,40.615050000000004],[-73.76558662145746,40.615050000000004],[-73.76472059605368,40.613550000000004],[-73.7629885452461,40.613550000000004],[-73.76212251984232,40.61205],[-73.76039046903475,40.61205],[-73.75952444363097,40.61055],[-73.75779239282339,40.61055],[-73.75692636741961,40.61205],[-73.75519431661203,40.61205],[-73.75432829120825,40.61055],[-73.75259624040068,40.61055],[-73.7517302149969,40.61205],[-73.74999816418932,40.61205],[-73.74913213878554,40.613550000000004],[-73.74740008797797,40.613550000000004],[-73.74653406257418,40.61205],[-73.74480201176661,40.61205],[-73.74393598636283,40.61055],[-73.74220393555525,40.61055],[-73.74133791015147,40.60905],[-73.74220393555525,40.60755],[-73.74133791015147,40.60605],[-73.7396058593439,40.60605],[-73.73873983394012,40.60455],[-73.73700778313254,40.60455],[-73.73614175772876,40.60305],[-73.73700778313254,40.60155],[-73.73614175772876,40.60005],[-73.73700778313254,40.59855],[-73.73614175772876,40.59705],[-73.73700778313254,40.59555],[-73.73614175772876,40.59405],[-73.73700778313254,40.59255],[-73.73873983394012,40.59255],[-73.7396058593439,40.59405],[-73.74133791015147,40.59405],[-73.74220393555525,40.59255],[-73.74393598636283,40.59255],[-73.74480201176661,40.59405],[-73.74653406257418,40.59405],[-73.74740008797797,40.59255],[-73.74913213878554,40.59255],[-73.74999816418932,40.59105],[-73.7517302149969,40.59105],[-73.75259624040068,40.58955],[-73.75432829120825,40.58955],[-73.75519431661203,40.59105],[-73.75692636741961,40.59105],[-73.75779239282339,40.58955],[-73.75952444363097,40.58955],[-73.76039046903475,40.59105],[-73.76212251984232,40.59105],[-73.7629885452461,40.58955],[-73.76472059605368,40.58955],[-73.76558662145746,40.59105],[-73.76731867226503,40.59105],[-73.76818469766881,40.58955],[-73.76991674847639,40.58955],[-73.77078277388017,40.59105],[-73.77251482468775,40.59105],[-73.77338085009153,40.58955],[-73.7751129008991,40.58955],[-73.77597892630288,40.59105],[-73.77771097711046,40.59105],[-73.77857700251424,40.58955],[-73.78030905332182,40.58955],[-73.7811750787256,40.58805],[-73.78290712953317,40.58805],[-73.78377315493695,40.58955],[-73.78550520574453,40.58955],[-73.78637123114831,40.58805],[-73.78810328195588,40.58805],[-73.78896930735966,40.58655],[-73.79070135816724,40.58655],[-73.79156738357102,40.58505],[-73.7932994343786,40.58505],[-73.79416545978238,40.58655],[-73.79589751058995,40.58655],[-73.79676353599373,40.58505],[-73.79849558680131,40.58505],[-73.79936161220509,40.58355],[-73.80109366301267,40.58355],[-73.80195968841645,40.58505],[-73.80369173922402,40.58505],[-73.8045577646278,40.58355],[-73.80628981543538,40.58355],[-73.80715584083916,40.58505],[-73.80888789164673,40.58505],[-73.80975391705051,40.58355],[-73.81148596785809,40.58355],[-73.81235199326187,40.58205],[-73.81408404406945,40.58205],[-73.81495006947323,40.58355],[-73.8166821202808,40.58355],[-73.81754814568458,40.58205],[-73.81928019649216,40.58205],[-73.82014622189594,40.58055],[-73.82187827270351,40.58055],[-73.8227442981073,40.57905],[-73.82447634891487,40.57905],[-73.82534237431865,40.58055],[-73.82707442512623,40.58055],[-73.82794045053001,40.57905],[-73.82967250133758,40.57905],[-73.83053852674136,40.57755],[-73.83227057754894,40.57755],[-73.83313660295272,40.57605],[-73.8348686537603,40.57605],[-73.83573467916408,40.57455],[-73.83746672997165,40.57455],[-73.83833275537543,40.57605],[-73.84006480618301,40.57605],[-73.84093083158679,40.57455],[-73.84266288239436,40.57455],[-73.84352890779815,40.57305],[-73.84526095860572,40.57305],[-73.8461269840095,40.57155],[-73.84785903481708,40.57155],[-73.84872506022086,40.57005],[-73.85045711102843,40.57005],[-73.85132313643221,40.56855],[-73.85305518723979,40.56855],[-73.85392121264357,40.57005],[-73.85565326345115,40.57005],[-73.85651928885493,40.56855],[-73.8582513396625,40.56855],[-73.85911736506628,40.56705],[-73.86084941587386,40.56705],[-73.86171544127764,40.56555],[-73.86344749208521,40.56555],[-73.864313517489,40.56405],[-73.86604556829657,40.56405],[-73.86691159370035,40.56555],[-73.86864364450793,40.56555],[-73.86950966991171,40.56405],[-73.87124172071928,40.56405],[-73.87210774612306,40.56255],[-73.87383979693064,40.56255],[-73.87470582233442,40.56105],[-73.876437873142,40.56105],[-73.87730389854578,40.55955],[-73.87903594935335,40.55955],[-73.87990197475713,40.56105],[-73.88163402556471,40.56105],[-73.88250005096849,40.56255],[-73.88163402556471,40.56405],[-73.88250005096849,40.56555],[-73.88423210177606,40.56555],[-73.88509812717984,40.56405],[-73.88683017798742,40.56405],[-73.8876962033912,40.56555],[-73.88942825419878,40.56555],[-73.89029427960256,40.56405],[-73.89202633041013,40.56405],[-73.89289235581391,40.56255],[-73.89462440662149,40.56255],[-73.89549043202527,40.56405]]],[[[-73.82794045053001,40.621050000000004],[-73.82967250133758,40.621050000000004],[-73.83053852674136,40.622550000000004],[-73.82967250133758,40.624050000000004],[-73.83053852674136,40.625550000000004],[-73.82967250133758,40.627050000000004],[-73.83053852674136,40.628550000000004],[-73.82967250133758,40.630050000000004],[-73.83053852674136,40.631550000000004],[-73.82967250133758,40.633050000000004],[-73.82794045053001,40.633050000000004],[-73.82707442512623,40.631550000000004],[-73.82794045053001,40.630050000000004],[-73.82707442512623,40.628550000000004],[-73.82534237431865,40.628550000000004],[-73.82447634891487,40.627050000000004],[-73.82534237431865,40.625550000000004],[-73.82447634891487,40.624050000000004],[-73.82534237431865,40.622550000000004],[-73.82447634891487,40.621050000000004],[-73.8227442981073,40.621050000000004],[-73.82187827270351,40.622550000000004],[-73.82014622189594,40.622550000000004],[-73.81928019649216,40.624050000000004],[-73.81754814568458,40.624050000000004],[-73.8166821202808,40.622550000000004],[-73.81754814568458,40.621050000000004],[-73.8166821202808,40.619550000000004],[-73.81754814568458,40.618050000000004],[-73.81928019649216,40.618050000000004],[-73.82014622189594,40.619550000000004],[-73.82187827270351,40.619550000000004],[-73.8227442981073,40.618050000000004],[-73.82187827270351,40.616550000000004],[-73.82014622189594,40.616550000000004],[-73.81928019649216,40.615050000000004],[-73.81754814568458,40.615050000000004],[-73.8166821202808,40.613550000000004],[-73.81495006947323,40.613550000000004],[-73.81408404406945,40.61205],[-73.81495006947323,40.61055],[-73.81408404406945,40.60905],[-73.81495006947323,40.60755],[-73.81408404406945,40.60605],[-73.81495006947323,40.60455],[-73.8166821202808,40.60455],[-73.81754814568458,40.60305],[-73.8166821202808,40.60155],[-73.81754814568458,40.60005],[-73.8166821202808,40.59855],[-73.81754814568458,40.59705],[-73.81928019649216,40.59705],[-73.82014622189594,40.59555],[-73.82187827270351,40.59555],[-73.8227442981073,40.59705],[-73.82447634891487,40.59705],[-73.82534237431865,40.59855],[-73.82447634891487,40.60005],[-73.82534237431865,40.60155],[-73.82447634891487,40.60305],[-73.82534237431865,40.60455],[-73.82447634891487,40.60605],[-73.8227442981073,40.60605],[-73.82187827270351,40.60755],[-73.8227442981073,40.60905],[-73.82447634891487,40.60905],[-73.82534237431865,40.61055],[-73.82447634891487,40.61205],[-73.82534237431865,40.613550000000004],[-73.82447634891487,40.615050000000004],[-73.82534237431865,40.616550000000004],[-73.82707442512623,40.616550000000004],[-73.82794045053001,40.618050000000004],[-73.82707442512623,40.619550000000004],[-73.82794045053001,40.621050000000004]]],[[[-73.78637123114831,40.621050000000004],[-73.78810328195588,40.621050000000004],[-73.78896930735966,40.622550000000004],[-73.78810328195588,40.624050000000004],[-73.78637123114831,40.624050000000004],[-73.78550520574453,40.625550000000004],[-73.78377315493695,40.625550000000004],[-73.78290712953317,40.624050000000004],[-73.78377315493695,40.622550000000004],[-73.78290712953317,40.621050000000004],[-73.78377315493695,40.619550000000004],[-73.78550520574453,40.619550000000004],[-73.78637123114831,40.621050000000004]]]]},"properties":{"borough":"queens"}},{"type":"Feature","geometry":{"type":"MultiPolygon","coordinates":[[[[-73.93186349898426,40.80705000000001],[-73.93359554979183,40.80705000000001],[-73.93446157519561,40.80855000000001],[-73.93359554979183,40.81005000000001],[-73.93446157519561,40.81155000000001],[-73.93359554979183,40.81305000000001],[-73.93446157519561,40.81455000000001],[-73.93359554979183,40.81605000000001],[-73.93446157519561,40.81755000000001],[-73.93359554979183,40.81905000000001],[-73.93446157519561,40.82055000000001],[-73.93359554979183,40.82205000000001],[-73.93446157519561,40.82355000000001],[-73.93359554979183,40.82505000000001],[-73.93446157519561,40.82655000000001],[-73.93359554979183,40.82805000000001],[-73.93446157519561,40.82955000000001],[-73.93359554979183,40.83105000000001],[-73.93446157519561,40.83255000000001],[-73.93359554979183,40.83405000000001],[-73.93186349898426,40.83405000000001],[-73.93099747358048,40.83555000000001],[-73.93186349898426,40.83705000000001],[-73.93099747358048,40.83855000000001],[-73.93186349898426,40.84005000000001],[-73.93099747358048,40.84155000000001],[-73.93186349898426,40.84305000000001],[-73.93099747358048,40.84455000000001],[-73.9292654227729,40.84455000000001],[-73.92839939736912,40.84605000000001],[-73.9292654227729,40.84755000000001],[-73.92839939736912,40.84905000000001],[-73.92666734656154,40.84905000000001],[-73.92580132115776,40.85055000000001],[-73.92666734656154,40.85205000000001],[-73.92580132115776,40.85355000000001],[-73.92406927035019,40.85355000000001],[-73.92320324494641,40.85505000000001],[-73.92147119413883,40.85505000000001],[-73.92060516873505,40.85655000000001],[-73.91887311792748,40.85655000000001],[-73.9180070925237,40.85805000000001],[-73.91887311792748,40.85955000000001],[-73.9180070925237,40.86105000000001],[-73.91627504171612,40.86105000000001],[-73.91540901631234,40.86255000000001],[-73.91367696550476,40.86255000000001],[-73.91281094010098,40.86405000000001],[-73.91367696550476,40.86555000000001],[-73.91281094010098,40.86705000000001],[-73.9110788892934,40.86705000000001],[-73.91021286388963,40.86855000000001],[-73.9110788892934,40.87005000000001],[-73.91021286388963,40.87155000000001],[-73.90848081308205,40.87155000000001],[-73.90761478767827,40.87305000000001],[-73.90848081308205,40.87455000000001],[-73.90761478767827,40.87605000000001],[-73.90848081308205,40.877550000000014],[-73.91021286388963,40.877550000000014],[-73.9110788892934,40.879050000000014],[-73.91281094010098,40.879050000000014],[-73.91367696550476,40.877550000000014],[-73.91540901631234,40.877550000000014],[-73.91627504171612,40.87605000000001],[-73.9180070925237,40.87605000000001],[-73.91887311792748,40.87455000000001],[-73.92060516873505,40.87455000000001],[-73.92147119413883,40.87605000000001],[-73.92320324494641,40.87605000000001],[-73.92406927035019,40.877550000000014],[-73.92320324494641,40.879050000000014],[-73.92406927035019,40.880550000000014],[-73.92320324494641,40.882050000000014],[-73.92406927035019,40.883550000000014],[-73.92320324494641,40.885050000000014],[-73.92147119413883,40.885050000000014],[-73.92060516873505,40.886550000000014],[-73.92147119413883,40.888050000000014],[-73.92060516873505,40.889550000000014],[-73.91887311792748,40.889550000000014],[-73.9180070925237,40.891050000000014],[-73.91887311792748,40.892550000000014],[-73.9180070925237,40.894050000000014],[-73.91887311792748,40.895550000000014],[-73.9180070925237,40.897050000000014],[-73.91887311792748,40.898550000000014],[-73.9180070925237,40.900050000000014],[-73.91627504171612,40.900050000000014],[-73.91540901631234,40.901550000000015],[-73.91627504171612,40.903050000000015],[-73.91540901631234,40.904550000000015],[-73.91367696550476,40.904550000000015],[-73.91281094010098,40.906050000000015],[-73.91367696550476,40.907550000000015],[-73.91281094010098,40.909050000000015],[-73.91367696550476,40.910550000000015],[-73.91281094010098,40.912050000000015],[-73.91367696550476,40.913550000000015],[-73.91281094010098,40.915050000000015],[-73.9110788892934,40.915050000000015],[-73.91021286388963,40.916550000000015],[-73.90848081308205,40.916550000000015],[-73.90761478767827,40.915050000000015],[-73.9058827368707,40.915050000000015],[-73.90501671146691,40.913550000000015],[-73.90328466065934,40.913550000000015],[-73.90241863525556,40.915050000000015],[-73.90068658444798,40.915050000000015],[-73.8998205590442,40.913550000000015],[-73.89808850823663,40.913550000000015],[-73.89722248283285,40.912050000000015],[-73.89549043202527,40.912050000000015],[-73.89462440662149,40.913550000000015],[-73.89289235581391,40.913550000000015],[-73.89202633041013,40.912050000000015],[-73.89029427960256,40.912050000000015],[-73.88942825419878,40.910550000000015],[-73.8876962033912,40.910550000000015],[-73.88683017798742,40.909050000000015],[-73.88509812717984,40.909050000000015],[-73.88423210177606,40.907550000000015],[-73.88250005096849,40.907550000000015],[-73.88163402556471,40.906050000000015],[-73.88250005096849,40.904550000000015],[-73.88423210177606,40.904550000000015],[-73.88509812717984,40.903050000000015],[-73.88423210177606,40.901550000000015],[-73.88509812717984,40.900050000000014],[-73.88423210177606,40.898550000000014],[-73.88509812717984,40.897050000000014],[-73.88683017798742,40.897050000000014],[-73.8876962033912,40.895550000000014],[-73.88683017798742,40.894050000000014],[-73.8876962033912,40.892550000000014],[-73.88942825419878,40.892550000000014],[-73.89029427960256,40.891050000000014],[-73.88942825419878,40.889550000000014],[-73.89029427960256,40.888050000000014],[-73.89202633041013,40.888050000000014],[-73.89289235581391,40.886550000000014],[-73.89202633041013,40.885050000000014],[-73.89029427960256,40.885050000000014],[-73.88942825419878,40.886550000000014],[-73.8876962033912,40.886550000000014],[-73.88683017798742,40.885050000000014],[-73.88509812717984,40.885050000000014],[-73.88423210177606,40.883550000000014],[-73.88250005096849,40.883550000000014],[-73.88163402556471,40.885050000000014],[-73.87990197475713,40.885050000000014],[-73.87903594935335,40.886550000000014],[-73.87990197475713,40.888050000000014],[-73.87903594935335,40.889550000000014],[-73.87730389854578,40.889550000000014],[-73.876437873142,40.888050000000014],[-73.87730389854578,40.886550000000014],[-73.876437873142,40.885050000000014],[-73.87730389854578,40.883550000000014],[-73.876437873142,40.882050000000014],[-73.87470582233442,40.882050000000014],[-73.87383979693064,40.880550000000014],[-73.87210774612306,40.880550000000014],[-73.87124172071928,40.882050000000014],[-73.87210774612306,40.883550000000014],[-73.87124172071928,40.885050000000014],[-73.86950966991171,40.885050000000014],[-73.86864364450793,40.886550000000014],[-73.86950966991171,40.888050000000014],[-73.86864364450793,40.889550000000014],[-73.86691159370035,40.889550000000014],[-73.86604556829657,40.891050000000014],[-73.86691159370035,40.892550000000014],[-73.86604556829657,40.894050000000014],[-73.86691159370035,40.895550000000014],[-73.86864364450793,40.895550000000014],[-73.86950966991171,40.894050000000014],[-73.87124172071928,40.894050000000014],[-73.87210774612306,40.895550000000014],[-73.87383979693064,40.895550000000014],[-73.87470582233442,40.894050000000014],[-73.876437873142,40.894050000000014],[-73.87730389854578,40.892550000000014],[-73.87903594935335,40.892550000000014],[-73.87990197475713,40.894050000000014],[-73.88163402556471,40.894050000000014],[-73.88250005096849,40.895550000000014],[-73.88163402556471,40.897050000000014],[-73.87990197475713,40.897050000000014],[-73.87903594935335,40.898550000000014],[-73.87990197475713,40.900050000000014],[-73.87903594935335,40.901550000000015],[-73.87990197475713,40.903050000000015],[-73.87903594935335,40.904550000000015],[-73.87990197475713,40.906050000000015],[-73.87903594935335,40.907550000000015],[-73.87730389854578,40.907550000000015],[-73.876437873142,40.906050000000015],[-73.87470582233442,40.906050000000015],[-73.87383979693064,40.907550000000015],[-73.87210774612306,40.907550000000015],[-73.87124172071928,40.906050000000015],[-73.86950966991171,40.906050000000015],[-73.86864364450793,40.904550000000015],[-73.86691159370035,40.904550000000015],[-73.86604556829657,40.903050000000015],[-73.864313517489,40.903050000000015],[-73.86344749208521,40.904550000000015],[-73.86171544127764,40.904550000000015],[-73.86084941587386,40.903050000000015],[-73.85911736506628,40.903050000000015],[-73.8582513396625,40.904550000000015],[-73.85911736506628,40.906050000000015],[-73.8582513396625,40.907550000000015],[-73.85651928885493,40.907550000000015],[-73.85565326345115,40.909050000000015],[-73.85392121264357,40.909050000000015],[-73.85305518723979,40.910550000000015],[-73.85132313643221,40.910550000000015],[-73.85045711102843,40.909050000000015],[-73.84872506022086,40.909050000000015],[-73.84785903481708,40.907550000000015],[-73.8461269840095,40.907550000000015],[-73.84526095860572,40.906050000000015],[-73.84352890779815,40.906050000000015],[-73.84266288239436,40.904550000000015],[-73.84093083158679,40.904550000000015],[-73.84006480618301,40.903050000000015],[-73.83833275537543,40.903050000000015],[-73.83746672997165,40.901550000000015],[-73.83833275537543,40.900050000000014],[-73.83746672997165,40.898550000000014],[-73.83833275537543,40.897050000000014],[-73.83746672997165,40.895550000000014],[-73.83573467916408,40.895550000000014],[-73.8348686537603,40.894050000000014],[-73.83313660295272,40.894050000000014],[-73.83227057754894,40.892550000000014],[-73.83053852674136,40.892550000000014],[-73.82967250133758,40.894050000000014],[-73.82794045053001,40.894050000000014],[-73.82707442512623,40.892550000000014],[-73.82534237431865,40.892550000000014],[-73.82447634891487,40.891050000000014],[-73.8227442981073,40.891050000000014],[-73.82187827270351,40.892550000000014],[-73.82014622189594,40.892550000000014],[-73.81928019649216,40.891050000000014],[-73.81754814568458,40.891050000000014],[-73.8166821202808,40.889550000000014],[-73.81495006947323,40.889550000000014],[-73.81408404406945,40.891050000000014],[-73.81235199326187,40.891050000000014],[-73.81148596785809,40.889550000000014],[-73.80975391705051,40.889550000000014],[-73.80888789164673,40.888050000000014],[-73.80715584083916,40.888050000000014],[-73.80628981543538,40.889550000000014],[-73.8045577646278,40.889550000000014],[-73.80369173922402,40.888050000000014],[-73.80195968841645,40.888050000000014],[-73.80109366301267,40.886550000000014],[-73.79936161220509,40.886550000000014],[-73.79849558680131,40.885050000000014],[-73.79676353599373,40.885050000000014],[-73.79589751058995,40.886550000000014],[-73.79416545978238,40.886550000000014],[-73.7932994343786,40.885050000000014],[-73.79416545978238,40.883550000000014],[-73.7932994343786,40.882050000000014],[-73.79416545978238,40.880550000000014],[-73.79589751058995,40.880550000000014],[-73.79676353599373,40.882050000000014],[-73.79849558680131,40.882050000000014],[-73.79936161220509,40.883550000000014],[-73.80109366301267,40.883550000000014],[-73.80195968841645,40.885050000000014],[-73.80369173922402,40.885050000000014],[-73.8045577646278,40.883550000000014],[-73.80628981543538,40.883550000000014],[-73.80715584083916,40.885050000000014],[-73.80888789164673,40.885050000000014],[-73.80975391705051,40.886550000000014],[-73.81148596785809,40.886550000000014],[-73.81235199326187,40.885050000000014],[-73.81408404406945,40.885050000000014],[-73.81495006947323,40.883550000000014],[-73.8166821202808,40.883550000000014],[-73.81754814568458,40.882050000000014],[-73.81928019649216,40.882050000000014],[-73.82014622189594,40.880550000000014],[-73.81928019649216,40.879050000000014],[-73.82014622189594,40.877550000000014],[-73.82187827270351,40.877550000000014],[-73.8227442981073,40.87605000000001],[-73.82187827270351,40.87455000000001],[-73.8227442981073,40.87305000000001],[-73.82187827270351,40.87155000000001],[-73.82014622189594,40.87155000000001],[-73.81928019649216,40.87005000000001],[-73.82014622189594,40.86855000000001],[-73.81928019649216,40.86705000000001],[-73.81754814568458,40.86705000000001],[-73.8166821202808,40.86555000000001],[-73.81754814568458,40.86405000000001],[-73.8166821202808,40.86255000000001],[-73.81754814568458,40.86105000000001],[-73.81928019649216,40.86105000000001],[-73.82014622189594,40.85955000000001],[-73.82187827270351,40.85955000000001],[-73.8227442981073,40.85805000000001],[-73.82447634891487,40.85805000000001],[-73.82534237431865,40.85655000000001],[-73.82447634891487,40.85505000000001],[-73.82534237431865,40.85355000000001],[-73.82447634891487,40.85205000000001],[-73.82534237431865,40.85055000000001],[-73.82707442512623,40.85055000000001],[-73.82794045053001,40.84905000000001],[-73.82707442512623,40.84755000000001],[-73.82534237431865,40.84755000000001],[-73.82447634891487,40.84905000000001],[-73.8227442981073,40.84905000000001],[-73.82187827270351,40.85055000000001],[-73.82014622189594,40.85055000000001],[-73.81928019649216,40.84905000000001],[-73.81754814568458,40.84905000000001],[-73.8166821202808,40.85055000000001],[-73.81495006947323,40.85055000000001],[-73.81408404406945,40.84905000000001],[-73.81495006947323,40.84755000000001],[-73.81408404406945,40.84605000000001],[-73.81495006947323,40.84455000000001],[-73.81408404406945,40.84305000000001],[-73.81495006947323,40.84155000000001],[-73.81408404406945,40.84005000000001],[-73.81495006947323,40.83855000000001],[-73.81408404406945,40.83705000000001],[-73.81495006947323,40.83555000000001],[-73.81408404406945,40.83405000000001],[-73.81495006947323,40.83255000000001],[-73.81408404406945,40.83105000000001],[-73.81235199326187,40.83105000000001],[-73.81148596785809,40.82955000000001],[-73.81235199326187,40.82805000000001],[-73.81148596785809,40.82655000000001],[-73.80975391705051,40.82655000000001],[-73.80888789164673,40.82805000000001],[-73.80715584083916,40.82805000000001],[-73.80628981543538,40.82655000000001],[-73.80715584083916,40.82505000000001],[-73.80628981543538,40.82355000000001],[-73.8045577646278,40.82355000000001],[-73.80369173922402,40.82205000000001],[-73.8045577646278,40.82055000000001],[-73.80369173922402,40.81905000000001],[-73.80195968841645,40.81905000000001],[-73.80109366301267,40.81755000000001],[-73.79936161220509,40.81755000000001],[-73.79849558680131,40.81605000000001],[-73.79936161220509,40.81455000000001],[-73.79849558680131,40.81305000000001],[-73.79936161220509,40.81155000000001],[-73.79849558680131,40.81005000000001],[-73.79936161220509,40.80855000000001],[-73.80109366301267,40.80855000000001],[-73.80195968841645,40.80705000000001],[-73.80369173922402,40.80705000000001],[-73.8045577646278,40.80855000000001],[-73.80628981543538,40.80855000000001],[-73.80715584083916,40.81005000000001],[-73.80888789164673,40.81005000000001],[-73.80975391705051,40.81155000000001],[-73.81148596785809,40.81155000000001],[-73.81235199326187,40.81305000000001],[-73.81408404406945,40.81305000000001],[-73.81495006947323,40.81155000000001],[-73.8166821202808,40.81155000000001],[-73.81754814568458,40.81305000000001],[-73.81928019649216,40.81305000000001],[-73.82014622189594,40.81155000000001],[-73.82187827270351,40.81155000000001],[-73.8227442981073,40.81005000000001],[-73.82447634891487,40.81005000000001],[-73.82534237431865,40.80855000000001],[-73.82707442512623,40.80855000000001],[-73.82794045053001,40.81005000000001],[-73.82707442512623,40.81155000000001],[-73.82794045053001,40.81305000000001],[-73.82967250133758,40.81305000000001],[-73.83053852674136,40.81455000000001],[-73.82967250133758,40.81605000000001],[-73.83053852674136,40.81755000000001],[-73.83227057754894,40.81755000000001],[-73.83313660295272,40.81605000000001],[-73.8348686537603,40.81605000000001],[-73.83573467916408,40.81455000000001],[-73.83746672997165,40.81455000000001],[-73.83833275537543,40.81605000000001],[-73.84006480618301,40.81605000000001],[-73.84093083158679,40.81455000000001],[-73.84266288239436,40.81455000000001],[-73.84352890779815,40.81305000000001],[-73.84266288239436,40.81155000000001],[-73.84352890779815,40.81005000000001],[-73.84526095860572,40.81005000000001],[-73.8461269840095,40.81155000000001],[-73.84785903481708,40.81155000000001],[-73.84872506022086,40.81005000000001],[-73.84785903481708,40.80855000000001],[-73.84872506022086,40.80705000000001],[-73.84785903481708,40.80555000000001],[-73.84872506022086,40.80405000000001],[-73.85045711102843,40.80405000000001],[-73.85132313643221,40.80255000000001],[-73.85305518723979,40.80255000000001],[-73.85392121264357,40.80405000000001],[-73.85565326345115,40.80405000000001],[-73.85651928885493,40.80255000000001],[-73.8582513396625,40.80255000000001],[-73.85911736506628,40.80405000000001],[-73.8582513396625,40.80555000000001],[-73.85911736506628,40.80705000000001],[-73.86084941587386,40.80705000000001],[-73.86171544127764,40.80855000000001],[-73.86084941587386,40.81005000000001],[-73.86171544127764,40.81155000000001],[-73.86344749208521,40.81155000000001],[-73.864313517489,40.81305000000001],[-73.86604556829657,40.81305000000001],[-73.86691159370035,40.81455000000001],[-73.86864364450793,40.81455000000001],[-73.86950966991171,40.81605000000001],[-73.87124172071928,40.81605000000001],[-73.87210774612306,40.81755000000001],[-73.87383979693064,40.81755000000001],[-73.87470582233442,40.81905000000001],[-73.876437873142,40.81905000000001],[-73.87730389854578,40.81755000000001],[-73.87903594935335,40.81755000000001],[-73.87990197475713,40.81605000000001],[-73.87903594935335,40.81455000000001],[-73.87990197475713,40.81305000000001],[-73.87903594935335,40.81155000000001],[-73.87730389854578,40.81155000000001],[-73.876437873142,40.81005000000001],[-73.87470582233442,40.81005000000001],[-73.87383979693064,40.80855000000001],[-73.87470582233442,40.80705000000001],[-73.876437873142,40.80705000000001],[-73.87730389854578,40.80555000000001],[-73.87903594935335,40.80555000000001],[-73.87990197475713,40.80405000000001],[-73.88163402556471,40.80405000000001],[-73.88250005096849,40.80255000000001],[-73.88423210177606,40.80255000000001],[-73.88509812717984,40.80405000000001],[-73.88683017798742,40.80405000000001],[-73.8876962033912,40.80255000000001],[-73.88942825419878,40.80255000000001],[-73.89029427960256,40.80405000000001],[-73.89202633041013,40.80405000000001],[-73.89289235581391,40.80555000000001],[-73.89462440662149,40.80555000000001],[-73.89549043202527,40.80405000000001],[-73.89722248283285,40.80405000000001],[-73.89808850823663,40.80555000000001],[-73.8998205590442,40.80555000000001],[-73.90068658444798,40.80405000000001],[-73.90241863525556,40.80405000000001],[-73.90328466065934,40.80255000000001],[-73.90501671146691,40.80255000000001],[-73.9058827368707,40.80105000000001],[-73.90501671146691,40.79955000000001],[-73.9058827368707,40.79805000000001],[-73.90761478767827,40.79805000000001],[-73.90848081308205,40.79655000000001],[-73.91021286388963,40.79655000000001],[-73.9110788892934,40.79505000000001],[-73.91281094010098,40.79505000000001],[-73.91367696550476,40.79655000000001],[-73.91540901631234,40.79655000000001],[-73.91627504171612,40.79805000000001],[-73.9180070925237,40.79805000000001],[-73.91887311792748,40.79655000000001],[-73.92060516873505,40.79655000000001],[-73.92147119413883,40.79805000000001],[-73.92060516873505,40.79955000000001],[-73.92147119413883,40.80105000000001],[-73.92320324494641,40.80105000000001],[-73.92406927035019,40.80255000000001],[-73.92580132115776,40.80255000000001],[-73.92666734656154,40.80405000000001],[-73.92839939736912,40.80405000000001],[-73.9292654227729,40.80555000000001],[-73.93099747358048,40.80555000000001],[-73.93186349898426,40.80705000000001]]],[[[-73.8998205590442,40.79955000000001],[-73.90068658444798,40.80105000000001],[-73.8998205590442,40.80255000000001],[-73.89808850823663,40.80255000000001],[-73.89722248283285,40.80105000000001],[-73.89808850823663,40.79955000000001],[-73.8998205590442,40.79955000000001]]],[[[-73.87470582233442,40.80105000000001],[-73.876437873142,40.80105000000001],[-73.87730389854578,40.80255000000001],[-73.876437873142,40.80405000000001],[-73.87470582233442,40.80405000000001],[-73.87383979693064,40.80555000000001],[-73.87210774612306,40.80555000000001],[-73.87124172071928,40.80705000000001],[-73.86950966991171,40.80705000000001],[-73.86864364450793,40.80855000000001],[-73.86691159370035,40.80855000000001],[-73.86604556829657,40.80705000000001],[-73.86691159370035,40.80555000000001],[-73.86864364450793,40.80555000000001],[-73.86950966991171,40.80405000000001],[-73.86864364450793,40.80255000000001],[-73.86950966991171,40.80105000000001],[-73.87124172071928,40.80105000000001],[-73.87210774612306,40.79955000000001],[-73.87383979693064,40.79955000000001],[-73.87470582233442,40.80105000000001]]],[[[-73.79156738357102,40.84605000000001],[-73.7932994343786,40.84605000000001],[-73.79416545978238,40.84755000000001],[-73.7932994343786,40.84905000000001],[-73.79156738357102,40.84905000000001],[-73.79070135816724,40.85055000000001],[-73.79156738357102,40.85205000000001],[-73.7932994343786,40.85205000000001],[-73.79416545978238,40.85355000000001],[-73.7932994343786,40.85505000000001],[-73.79416545978238,40.85655000000001],[-73.7932994343786,40.85805000000001],[-73.79156738357102,40.85805000000001],[-73.79070135816724,40.85955000000001],[-73.78896930735966,40.85955000000001],[-73.78810328195588,40.85805000000001],[-73.78637123114831,40.85805000000001],[-73.78550520574453,40.85655000000001],[-73.78637123114831,40.85505000000001],[-73.78550520574453,40.85355000000001],[-73.78377315493695,40.85355000000001],[-73.78290712953317,40.85205000000001],[-73.7811750787256,40.85205000000001],[-73.78030905332182,40.85055000000001],[-73.7811750787256,40.84905000000001],[-73.78030905332182,40.84755000000001],[-73.7811750787256,40.84605000000001],[-73.78030905332182,40.84455000000001],[-73.7811750787256,40.84305000000001],[-73.78030905332182,40.84155000000001],[-73.7811750787256,40.84005000000001],[-73.78030905332182,40.83855000000001],[-73.7811750787256,40.83705000000001],[-73.78290712953317,40.83705000000001],[-73.78377315493695,40.83555000000001],[-73.78550520574453,40.83555000000001],[-73.78637123114831,40.83705000000001],[-73.78810328195588,40.83705000000001],[-73.78896930735966,40.83855000000001],[-73.78810328195588,40.84005000000001],[-73.78896930735966,40.84155000000001],[-73.79070135816724,40.84155000000001],[-73.79156738357102,40.84305000000001],[-73.79070135816724,40.84455000000001],[-73.79156738357102,40.84605000000001]]]]},"properties":{"borough":"bronx"}}]};exports.default=Boroughs;

/***/ },
/* 325 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Neighborhood_Labels = { "type": "FeatureCollection", "features": [{ "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.03025994616785, 40.62714868869293] }, "properties": { "name": "Bay Ridge", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.01321215646915, 40.62148333582434] }, "properties": { "name": "Dyker Heights", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.0106277999371, 40.651609335438515] }, "properties": { "name": "Sunset Park West", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.00896958495393, 40.60439480677671] }, "properties": { "name": "Bath Beach", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.00428670820371, 40.678558474551096] }, "properties": { "name": "Carroll Gardens-Columbia Street-Red Hook", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.00435220242963, 40.6420905606269] }, "properties": { "name": "Sunset Park East", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.99395590941042, 40.57695567296482] }, "properties": { "name": "Seagate-Coney Island", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.9954186257, 40.61224356846038] }, "properties": { "name": "Bensonhurst West", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.98805324857148, 40.63075587338438] }, "properties": { "name": "Borough Park", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.99538900375212, 40.69596176156684] }, "properties": { "name": "Brooklyn Heights-Cobble Hill", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.98079391403267, 40.58856314682058] }, "properties": { "name": "Gravesend", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.9833920144373, 40.60148182028974] }, "properties": { "name": "Bensonhurst East", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "park-cemetery-etc-Brooklyn", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.98395493962778, 40.67077500690882] }, "properties": { "name": "Park Slope-Gowanus", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.98555699992077, 40.69389611309336] }, "properties": { "name": "DUMBO-Vinegar Hill-Downtown Brooklyn-Boerum Hill", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.97700975382443, 40.64172389876175] }, "properties": { "name": "Kensington-Ocean Parkway", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.97808764147696, 40.65398752010171] }, "properties": { "name": "Windsor Terrace", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.97351921349974, 40.578299941137445] }, "properties": { "name": "West Brighton", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.97463759730125, 40.69213694220877] }, "properties": { "name": "Fort Greene", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.97004731754721, 40.61709543869803] }, "properties": { "name": "Ocean Parkway South", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.96118060136793, 40.6386811546835] }, "properties": { "name": "Flatbush", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.96743243605054, 40.67687144867576] }, "properties": { "name": "Prospect Heights", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.96459017973125, 40.60020791479679] }, "properties": { "name": "Homecrest", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.96098363968072, 40.57998752005635] }, "properties": { "name": "Brighton Beach", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.9568372412088, 40.62077092272361] }, "properties": { "name": "Midwood", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.96310703967595, 40.68808846641186] }, "properties": { "name": "Clinton Hill", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.95935977021227, 40.714649980520015] }, "properties": { "name": "North Side-South Side", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.95856594550173, 40.70346666480991] }, "properties": { "name": "Williamsburg", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.94968195427334, 40.65881249047587] }, "properties": { "name": "Prospect Lefferts Gardens-Wingate", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "Crown Heights South", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.93976430765144, 40.67461153420264] }, "properties": { "name": "Crown Heights North", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.94959337203012, 40.72970452954896] }, "properties": { "name": "Greenpoint", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.9400262167296, 40.58856062055793] }, "properties": { "name": "Sheepshead Bay-Gerritsen Beach-Manhattan Beach", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.9496472162751, 40.69127092272149] }, "properties": { "name": "Bedford", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.9475455782126, 40.60499594466054] }, "properties": { "name": "Madison", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.95152732186398, 40.645755855936265] }, "properties": { "name": "Erasmus", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.93597727610943, 40.7149875861249] }, "properties": { "name": "East Williamsburg", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.92939963226581, 40.62650072429443] }, "properties": { "name": "Flatlands", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.93827544053899, 40.64490578171518] }, "properties": { "name": "East Flatbush-Farragut", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.9180369589573, 40.614067243274164] }, "properties": { "name": "Georgetown-Marine Park-Bergen Beach-Mill Basin", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.93149543877601, 40.68813750033056] }, "properties": { "name": "Stuyvesant Heights", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.92335612354832, 40.69572649843549] }, "properties": { "name": "Bushwick South", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.91652558069501, 40.70074728440515] }, "properties": { "name": "Bushwick North", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.92216778509565, 40.65258261158572] }, "properties": { "name": "Rugby-Remsen Village", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.91058090734775, 40.66376249043577] }, "properties": { "name": "Brownsville", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.91358077690778, 40.67671668674147] }, "properties": { "name": "Ocean Hill", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.90022532142079, 40.63828368998007] }, "properties": { "name": "Canarsie", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.87788338154233, 40.663766917304294] }, "properties": { "name": "East New York", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.89565698425518, 40.66680000488039] }, "properties": { "name": "East New York (Pennsylvania Ave)", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.87835118811353, 40.68310814118273] }, "properties": { "name": "Cypress Hills-City Line", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.88105675173878, 40.64721670869424] }, "properties": { "name": "Starrett City", "borough": "brooklyn" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "Mott Haven-Port Morris", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.92512080634678, 40.82847853483313] }, "properties": { "name": "West Concourse", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.92670668255728, 40.83779998407726] }, "properties": { "name": "Highbridge", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.91632918242989, 40.85317500774125] }, "properties": { "name": "University Heights-Morris Heights", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.91537432562255, 40.831169972538255] }, "properties": { "name": "East Concourse-Concourse Village", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.91218127062236, 40.81864100143556] }, "properties": { "name": "Melrose South-Mott Haven North", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.91118079000877, 40.88249118496983] }, "properties": { "name": "Spuyten Duyvil-Kingsbridge", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.9063404680918, 40.900585700428806] }, "properties": { "name": "North Riverdale-Fieldston-Riverdale", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.90313399030317, 40.82759344660854] }, "properties": { "name": "Morrisania-Melrose", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.90660446131312, 40.86613335355555] }, "properties": { "name": "Kingsbridge Heights", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.90598457422452, 40.84816762056094] }, "properties": { "name": "Mount Hope", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.89927935971167, 40.84398753672193] }, "properties": { "name": "Claremont-Bathgate", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.89895457016793, 40.81819287731383] }, "properties": { "name": "Longwood", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.89982059560215, 40.857550020178486] }, "properties": { "name": "Fordham South", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.8956883967105, 40.876907151660546] }, "properties": { "name": "Van Cortlandt Village", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "Hunts Point", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.888995307994, 40.86817503672186] }, "properties": { "name": "Bedford Park-Fordham North", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.8870034195887, 40.83495002023496] }, "properties": { "name": "Crotona Park East", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "park-cemetery-etc-Bronx", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "East Tremont", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.88498986561136, 40.85673749537913] }, "properties": { "name": "Belmont", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.87773709740318, 40.8781751029918] }, "properties": { "name": "Norwood", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.85591971409065, 40.81739614349463] }, "properties": { "name": "Soundview-Castle Hill-Clason Point-Harding Park", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.86992386127268, 40.827723915944716] }, "properties": { "name": "Soundview-Bruckner", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.87210771420243, 40.83397855379651] }, "properties": { "name": "West Farms-Bronx River", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.85339127187875, 40.89850523222837] }, "properties": { "name": "Woodlawn-Wakefield", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.85288198667891, 40.84651666917674] }, "properties": { "name": "Van Nest-Morris Park-Westchester Square", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.85608628701006, 40.8543000059962] }, "properties": { "name": "Pelham Parkway", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.86556925489415, 40.864125000317266] }, "properties": { "name": "Bronxdale", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.8593951155331, 40.881965077024965] }, "properties": { "name": "Williamsbridge-Olinville", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.85825137617184, 40.83788335350836] }, "properties": { "name": "Parkchester", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.8463152712953, 40.86378914200633] }, "properties": { "name": "Allerton-Pelham Gardens", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.84764258485102, 40.832008364548265] }, "properties": { "name": "Westchester-Unionport", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "Eastchester-Edenwald-Baychester", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.82805066925698, 40.87362272580725] }, "properties": { "name": "Co-op City", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.82115793005194, 40.82462943716527] }, "properties": { "name": "Schuylerville-Throgs Neck-Edgewater Park", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "Pelham Bay-Country Club-City Island", "borough": "bronx" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.93250840725251, 40.73944361466126] }, "properties": { "name": "Hunters Point-Sunnyside-West Maspeth", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.93846048448923, 40.75768230312747] }, "properties": { "name": "Queensbridge-Ravenswood-Long Island City", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.92950800395184, 40.7721300518617] }, "properties": { "name": "Old Astoria", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.91947399668871, 40.76140712257603] }, "properties": { "name": "Astoria", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "Breezy Point-Belle Harbor-Rockaway Park-Broad Channel", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.90294784308756, 40.72391109454987] }, "properties": { "name": "Maspeth", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.90569548580909, 40.776685133868135] }, "properties": { "name": "Steinway", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.9048592997208, 40.70600457154866] }, "properties": { "name": "Ridgewood", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "park-cemetery-etc-Queens", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.90428055454791, 40.74877498053527] }, "properties": { "name": "Woodside", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.89283043073108, 40.73847853497731] }, "properties": { "name": "Elmhurst-Maspeth", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.87620916178706, 40.70272927286886] }, "properties": { "name": "Glendale", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.87973638421082, 40.718572044009754] }, "properties": { "name": "Middle Village", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.8852630638845, 40.75814522674104] }, "properties": { "name": "Jackson Heights", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "Airport", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.87711842652878, 40.7400143435875] }, "properties": { "name": "Elmhurst", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.8676736751077, 40.7637899884337] }, "properties": { "name": "East Elmhurst", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.86359817297297, 40.75285438518395] }, "properties": { "name": "North Corona", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.8637806152873, 40.72524232777338] }, "properties": { "name": "Rego Park", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.85631821961769, 40.68895177048437] }, "properties": { "name": "Woodhaven", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.85730137970685, 40.742937027420396] }, "properties": { "name": "Corona", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.84449237062697, 40.659318755246936] }, "properties": { "name": "Lindenwood-Howard Beach", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.84706719462017, 40.674749974874665] }, "properties": { "name": "Ozone Park", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.84708696962105, 40.72151388507168] }, "properties": { "name": "Forest Hills", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.84391244932173, 40.78058572310276] }, "properties": { "name": "College Point", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.83124943670843, 40.69475148901103] }, "properties": { "name": "Richmond Hill", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.81920598169906, 40.67583572308704] }, "properties": { "name": "South Ozone Park", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.82860660519727, 40.70781922041645] }, "properties": { "name": "Kew Gardens", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.82917759294044, 40.76131528580384] }, "properties": { "name": "Flushing", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.81610186950651, 40.78927499239485] }, "properties": { "name": "Whitestone", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.82169257840198, 40.74279993522746] }, "properties": { "name": "Queensboro Hill", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.81918811785195, 40.726145773256384] }, "properties": { "name": "Kew Gardens Hills", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.81000864577746, 40.768711773184094] }, "properties": { "name": "Murray Hill", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.80916238151072, 40.71181823556073] }, "properties": { "name": "Briarwood-Jamaica Hills", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.79116456748548, 40.59321278319437] }, "properties": { "name": "Hammels-Arverne-Edgemere", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.80743141458257, 40.75318637475129] }, "properties": { "name": "East Flushing", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.7946139993059, 40.7047018199982] }, "properties": { "name": "Jamaica", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.8027176167346, 40.72836258609989] }, "properties": { "name": "Pomonok-Flushing Heights-Hillcrest", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.79096280914423, 40.69488962781149] }, "properties": { "name": "South Jamaica", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.79104475661742, 40.67838619289524] }, "properties": { "name": "Baisley Park", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.78713533731775, 40.78231468715073] }, "properties": { "name": "Ft. Totten-Bay Terrace-Clearview", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "Springfield Gardens South-Brookville", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.78810319878379, 40.7505499540948] }, "properties": { "name": "Auburndale", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.78313508633424, 40.73449739896679] }, "properties": { "name": "Fresh Meadows-Utopia", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.77593334473664, 40.72112894663526] }, "properties": { "name": "Jamaica Estates-Holliswood", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.77299596643266, 40.76274445358419] }, "properties": { "name": "Bayside-Bayside Hills", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.77333403562776, 40.67184729600478] }, "properties": { "name": "Springfield Gardens North", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.7633753085522, 40.691579123267154] }, "properties": { "name": "St. Albans", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.75522523132508, 40.60285356328321] }, "properties": { "name": "Far Rockaway-Bayswater", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.76125653085975, 40.71077224232111] }, "properties": { "name": "Hollis", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.75398891994121, 40.742732441833745] }, "properties": { "name": "Oakland Gardens", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "Rosedale", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.74412681762414, 40.67611780330524] }, "properties": { "name": "Laurelton", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.74121415773709, 40.71548404690587] }, "properties": { "name": "Queens Village", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.73721203025922, 40.76336603543686] }, "properties": { "name": "Douglas Manor-Douglaston-Little Neck", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.73608399537319, 40.69414998493026] }, "properties": { "name": "Cambria Heights", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.72637819837132, 40.73453629439434] }, "properties": { "name": "Bellerose", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.70982336814389, 40.74458388484241] }, "properties": { "name": "Glen Oaks-Floral Park-New Hyde Park", "borough": "queens" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.01092315792279, 40.708243504646816] }, "properties": { "name": "Battery Park City-Lower Manhattan", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.00421602156258, 40.72082274741409] }, "properties": { "name": "SoHo-TriBeCa-Civic Center-Little Italy", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.00153917220756, 40.733277268839956] }, "properties": { "name": "West Village", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.99933976683113, 40.74800744163067] }, "properties": { "name": "Hudson Yards-Chelsea-Flatiron-Union Square", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.99453631293628, 40.71491837865075] }, "properties": { "name": "Chinatown", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.99237709062108, 40.76423753665864] }, "properties": { "name": "Clinton", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.98302084188211, 40.75629999181202] }, "properties": { "name": "Midtown-Midtown South", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.98410051520355, 40.77493632970576] }, "properties": { "name": "Lincoln Square", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.98058447173148, 40.7179210006641] }, "properties": { "name": "Lower East Side", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.9854332899374, 40.72776424929546] }, "properties": { "name": "East Village", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.98339210705696, 40.73680005313587] }, "properties": { "name": "Gramercy", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.97321624856686, 40.789737520184445] }, "properties": { "name": "Upper West Side", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.97717026250041, 40.74373418891972] }, "properties": { "name": "Murray Hill-Kips Bay", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.97429878026004, 40.73130002011022] }, "properties": { "name": "Stuyvesant Town-Cooper Village", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "park-cemetery-etc-Manhattan", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.96785555129401, 40.753950020129935] }, "properties": { "name": "Turtle Bay-East Midtown", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.96165478547117, 40.77525000696104] }, "properties": { "name": "Upper East Side-Carnegie Hill", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "Morningside Heights", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "Lenox Hill-Roosevelt Island", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.95571248747636, 40.8183576819864] }, "properties": { "name": "Manhattanville", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.9517427876789, 40.80452731092308] }, "properties": { "name": "Central Harlem South", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.94582377872497, 40.790789972546634] }, "properties": { "name": "East Harlem South", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.94774054808903, 40.77771662071153] }, "properties": { "name": "Yorkville", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.94745192431809, 40.82704998234508] }, "properties": { "name": "Hamilton Heights", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.94052377011684, 40.81767163103175] }, "properties": { "name": "Central Harlem North-Polo Grounds", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.94095674231036, 40.84254998709389] }, "properties": { "name": "Washington Heights South", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "East Harlem North", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "Washington Heights North", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-73.91722770621934, 40.869000020180124] }, "properties": { "name": "Marble Hill-Inwood", "borough": "manhattan" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.23322190785497, 40.523980848025914] }, "properties": { "name": "Charleston-Richmond Valley-Tottenville", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.20797092334433, 40.54060355390528] }, "properties": { "name": "Rossville-Woodrow", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.183768652449, 40.529850007718565] }, "properties": { "name": "Annadale-Huguenot-Prince's Bay-Eltingville", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "New Springville-Bloomfield-Travis", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.18842072160805, 40.5531993553367] }, "properties": { "name": "Arden Heights", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.16529312205705, 40.63106836145675] }, "properties": { "name": "Mariner's Harbor-Arlington-Port Ivory-Graniteville", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.15140094544003, 40.55147500359322] }, "properties": { "name": "Great Kills", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.13321055012236, 40.586891523832065] }, "properties": { "name": "Todt Hill-Emerson Hill-Heartland Village-Lighthouse Hill", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.14035452965017, 40.628996820165064] }, "properties": { "name": "Port Richmond", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.12576318390528, 40.616530503634735] }, "properties": { "name": "Westerleigh", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.12340129639279, 40.561985049114064] }, "properties": { "name": "Oakwood-Oakwood Beach", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.10279656477594, 40.63906766249705] }, "properties": { "name": "West New Brighton-New Brighton-St. George", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.10561617586546, 40.572233802983725] }, "properties": { "name": "New Dorp-Midland Beach", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.1037011066869, 40.629997333048514] }, "properties": { "name": "New Brighton-Silver Lake", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.08598507656265, 40.58674642043545] }, "properties": { "name": "Old Town-Dongan Hills-South Beach", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.08744248051157, 40.61805003550534] }, "properties": { "name": "Grymes Hill-Clifton-Fox Hills", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [-74.07537628251934, 40.599835715544764] }, "properties": { "name": "Grasmere-Arrochar-Ft. Wadsworth", "borough": "staten island" } }, { "type": "Feature", "geometry": { "type": "Point", "coordinates": [null, null] }, "properties": { "name": "Stapleton-Rosebank", "borough": "staten island" } }] };
	exports.default = Neighborhood_Labels;

/***/ },
/* 326 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:true});var Neighborhoods={"type":"FeatureCollection","features":[{"id":"31","properties":{"borough":"staten island","borocode":5,"neighborhood":"Charleston-Richmond Valley-Tottenville"},"type":"Feature","geometry":{"coordinates":[[[-74.22284803465615,40.50105],[-74.22458008546373,40.50105],[-74.22544611086751,40.50255],[-74.22717816167508,40.50255],[-74.22804418707886,40.50105],[-74.22977623788644,40.50105],[-74.23064226329022,40.49955],[-74.2323743140978,40.49955],[-74.23324033950158,40.49805],[-74.23497239030915,40.49805],[-74.23583841571293,40.49955],[-74.23757046652051,40.49955],[-74.23843649192429,40.49805],[-74.24016854273187,40.49805],[-74.24103456813565,40.49655],[-74.24276661894322,40.49655],[-74.243632644347,40.49805],[-74.24536469515458,40.49805],[-74.24623072055836,40.49655],[-74.24796277136593,40.49655],[-74.24882879676971,40.49805],[-74.25056084757729,40.49805],[-74.25142687298107,40.49955],[-74.25056084757729,40.50105],[-74.25142687298107,40.50255],[-74.25315892378865,40.50255],[-74.25402494919243,40.50405],[-74.255757,40.50405],[-74.25662302540378,40.50555],[-74.255757,40.50705],[-74.25662302540378,40.50855],[-74.255757,40.51005],[-74.25402494919243,40.51005],[-74.25315892378865,40.51155],[-74.25402494919243,40.51305],[-74.25315892378865,40.51455],[-74.25142687298107,40.51455],[-74.25056084757729,40.51605],[-74.24882879676971,40.51605],[-74.24796277136593,40.51755],[-74.24623072055836,40.51755],[-74.24536469515458,40.51905],[-74.243632644347,40.51905],[-74.24276661894322,40.52055],[-74.243632644347,40.52205],[-74.24276661894322,40.52355],[-74.243632644347,40.52505],[-74.24276661894322,40.52655],[-74.243632644347,40.52805],[-74.24276661894322,40.52955],[-74.243632644347,40.53105],[-74.24276661894322,40.53255],[-74.243632644347,40.53405],[-74.24276661894322,40.53555],[-74.243632644347,40.53705],[-74.24536469515458,40.53705],[-74.24623072055836,40.53855],[-74.24536469515458,40.54005],[-74.24623072055836,40.54155],[-74.24536469515458,40.54305],[-74.243632644347,40.54305],[-74.24276661894322,40.54455],[-74.24103456813565,40.54455],[-74.24016854273187,40.54305],[-74.23843649192429,40.54305],[-74.23757046652051,40.54455],[-74.23583841571293,40.54455],[-74.23497239030915,40.54605],[-74.23583841571293,40.54755],[-74.23497239030915,40.54905],[-74.23583841571293,40.55055],[-74.23757046652051,40.55055],[-74.23843649192429,40.55205],[-74.23757046652051,40.55355],[-74.23583841571293,40.55355],[-74.23497239030915,40.55505],[-74.23324033950158,40.55505],[-74.2323743140978,40.55355],[-74.23064226329022,40.55355],[-74.22977623788644,40.55205],[-74.22804418707886,40.55205],[-74.22717816167508,40.55355],[-74.22804418707886,40.55505],[-74.22717816167508,40.55655],[-74.22544611086751,40.55655],[-74.22458008546373,40.55505],[-74.22284803465615,40.55505],[-74.22198200925237,40.55655],[-74.2202499584448,40.55655],[-74.21938393304102,40.55505],[-74.2202499584448,40.55355],[-74.22198200925237,40.55355],[-74.22284803465615,40.55205],[-74.22198200925237,40.55055],[-74.2202499584448,40.55055],[-74.21938393304102,40.54905],[-74.2202499584448,40.54755],[-74.21938393304102,40.54605],[-74.2202499584448,40.54455],[-74.21938393304102,40.54305],[-74.21765188223344,40.54305],[-74.21678585682966,40.54155],[-74.21765188223344,40.54005],[-74.21678585682966,40.53855],[-74.21765188223344,40.53705],[-74.21678585682966,40.53555],[-74.21765188223344,40.53405],[-74.21678585682966,40.53255],[-74.21765188223344,40.53105],[-74.21678585682966,40.52955],[-74.21765188223344,40.52805],[-74.21678585682966,40.52655],[-74.21505380602208,40.52655],[-74.2141877806183,40.52505],[-74.21245572981073,40.52505],[-74.21158970440695,40.52355],[-74.21245572981073,40.52205],[-74.2141877806183,40.52205],[-74.21505380602208,40.52055],[-74.21678585682966,40.52055],[-74.21765188223344,40.51905],[-74.21938393304102,40.51905],[-74.2202499584448,40.51755],[-74.22198200925237,40.51755],[-74.22284803465615,40.51605],[-74.22458008546373,40.51605],[-74.22544611086751,40.51455],[-74.22458008546373,40.51305],[-74.22284803465615,40.51305],[-74.22198200925237,40.51155],[-74.22284803465615,40.51005],[-74.22198200925237,40.50855],[-74.22284803465615,40.50705],[-74.22198200925237,40.50555],[-74.2202499584448,40.50555],[-74.21938393304102,40.50405],[-74.2202499584448,40.50255],[-74.22198200925237,40.50255],[-74.22284803465615,40.50105]],[[-74.22458008546373,40.53105],[-74.22544611086751,40.52955],[-74.22458008546373,40.52805],[-74.22544611086751,40.52655],[-74.22458008546373,40.52505],[-74.22284803465615,40.52505],[-74.22198200925237,40.52655],[-74.22284803465615,40.52805],[-74.22198200925237,40.52955],[-74.22284803465615,40.53105],[-74.22458008546373,40.53105]]],"type":"Polygon"}},{"id":"76","properties":{"borough":"staten island","borocode":5,"neighborhood":"Great Kills"},"type":"Feature","geometry":{"coordinates":[[[-74.15789612937225,40.52655],[-74.15962818017982,40.52655],[-74.1604942055836,40.52805],[-74.15962818017982,40.52955],[-74.15789612937225,40.52955],[-74.15703010396847,40.53105],[-74.15529805316089,40.53105],[-74.15443202775711,40.53255],[-74.15529805316089,40.53405],[-74.15703010396847,40.53405],[-74.15789612937225,40.53555],[-74.15703010396847,40.53705],[-74.15789612937225,40.53855],[-74.15962818017982,40.53855],[-74.1604942055836,40.54005],[-74.16222625639118,40.54005],[-74.16309228179496,40.54155],[-74.16222625639118,40.54305],[-74.16309228179496,40.54455],[-74.16482433260254,40.54455],[-74.16569035800632,40.54605],[-74.16742240881389,40.54605],[-74.16828843421767,40.54755],[-74.16742240881389,40.54905],[-74.16828843421767,40.55055],[-74.16742240881389,40.55205],[-74.16828843421767,40.55355],[-74.16742240881389,40.55505],[-74.16828843421767,40.55655],[-74.17002048502525,40.55655],[-74.17088651042903,40.55805],[-74.17002048502525,40.55955],[-74.17088651042903,40.56105],[-74.17002048502525,40.56255],[-74.16828843421767,40.56255],[-74.16742240881389,40.56105],[-74.16569035800632,40.56105],[-74.16482433260254,40.56255],[-74.16309228179496,40.56255],[-74.16222625639118,40.56405],[-74.1604942055836,40.56405],[-74.15962818017982,40.56255],[-74.15789612937225,40.56255],[-74.15703010396847,40.56405],[-74.15789612937225,40.56555],[-74.15703010396847,40.56705],[-74.15529805316089,40.56705],[-74.15443202775711,40.56855],[-74.15269997694953,40.56855],[-74.15183395154575,40.56705],[-74.15010190073818,40.56705],[-74.1492358753344,40.56855],[-74.15010190073818,40.57005],[-74.1492358753344,40.57155],[-74.14750382452682,40.57155],[-74.14663779912304,40.57005],[-74.14490574831547,40.57005],[-74.14403972291169,40.56855],[-74.14230767210411,40.56855],[-74.14144164670033,40.56705],[-74.13970959589275,40.56705],[-74.13884357048897,40.56555],[-74.1371115196814,40.56555],[-74.13624549427762,40.56405],[-74.13451344347004,40.56405],[-74.13364741806626,40.56255],[-74.13451344347004,40.56105],[-74.13624549427762,40.56105],[-74.1371115196814,40.55955],[-74.13884357048897,40.55955],[-74.13970959589275,40.55805],[-74.13884357048897,40.55655],[-74.1371115196814,40.55655],[-74.13624549427762,40.55505],[-74.13451344347004,40.55505],[-74.13364741806626,40.55355],[-74.13451344347004,40.55205],[-74.13364741806626,40.55055],[-74.13451344347004,40.54905],[-74.13624549427762,40.54905],[-74.1371115196814,40.54755],[-74.13624549427762,40.54605],[-74.1371115196814,40.54455],[-74.13884357048897,40.54455],[-74.13970959589275,40.54305],[-74.14144164670033,40.54305],[-74.14230767210411,40.54155],[-74.14144164670033,40.54005],[-74.14230767210411,40.53855],[-74.14144164670033,40.53705],[-74.14230767210411,40.53555],[-74.14403972291169,40.53555],[-74.14490574831547,40.53405],[-74.14663779912304,40.53405],[-74.14750382452682,40.53255],[-74.1492358753344,40.53255],[-74.15010190073818,40.53105],[-74.15183395154575,40.53105],[-74.15269997694953,40.52955],[-74.15443202775711,40.52955],[-74.15529805316089,40.52805],[-74.15703010396847,40.52805],[-74.15789612937225,40.52655]]],"type":"Polygon"}},{"id":"165","properties":{"borough":"staten island","borocode":5,"neighborhood":"Todt Hill-Emerson Hill-Heartland Village-Lighthouse Hill"},"type":"Feature","geometry":{"coordinates":[[[-74.1371115196814,40.57155],[-74.13884357048897,40.57155],[-74.13970959589275,40.57305],[-74.14144164670033,40.57305],[-74.14230767210411,40.57155],[-74.14403972291169,40.57155],[-74.14490574831547,40.57005],[-74.14663779912304,40.57005],[-74.14750382452682,40.57155],[-74.1492358753344,40.57155],[-74.15010190073818,40.57005],[-74.1492358753344,40.56855],[-74.15010190073818,40.56705],[-74.15183395154575,40.56705],[-74.15269997694953,40.56855],[-74.15443202775711,40.56855],[-74.15529805316089,40.56705],[-74.15703010396847,40.56705],[-74.15789612937225,40.56555],[-74.15703010396847,40.56405],[-74.15789612937225,40.56255],[-74.15962818017982,40.56255],[-74.1604942055836,40.56405],[-74.16222625639118,40.56405],[-74.16309228179496,40.56255],[-74.16482433260254,40.56255],[-74.16569035800632,40.56105],[-74.16742240881389,40.56105],[-74.16828843421767,40.56255],[-74.17002048502525,40.56255],[-74.17088651042903,40.56405],[-74.17002048502525,40.56555],[-74.17088651042903,40.56705],[-74.17002048502525,40.56855],[-74.17088651042903,40.57005],[-74.17002048502525,40.57155],[-74.17088651042903,40.57305],[-74.17002048502525,40.57455],[-74.17088651042903,40.57605],[-74.17002048502525,40.57755],[-74.17088651042903,40.57905],[-74.17002048502525,40.58055],[-74.17088651042903,40.58205],[-74.17002048502525,40.58355],[-74.17088651042903,40.58505],[-74.17002048502525,40.58655],[-74.17088651042903,40.58805],[-74.17002048502525,40.58955],[-74.16828843421767,40.58955],[-74.16742240881389,40.59105],[-74.16569035800632,40.59105],[-74.16482433260254,40.59255],[-74.16309228179496,40.59255],[-74.16222625639118,40.59405],[-74.1604942055836,40.59405],[-74.15962818017982,40.59555],[-74.15789612937225,40.59555],[-74.15703010396847,40.59405],[-74.15529805316089,40.59405],[-74.15443202775711,40.59255],[-74.15269997694953,40.59255],[-74.15183395154575,40.59105],[-74.15010190073818,40.59105],[-74.1492358753344,40.58955],[-74.14750382452682,40.58955],[-74.14663779912304,40.58805],[-74.14490574831547,40.58805],[-74.14403972291169,40.58655],[-74.14230767210411,40.58655],[-74.14144164670033,40.58805],[-74.14230767210411,40.58955],[-74.14144164670033,40.59105],[-74.13970959589275,40.59105],[-74.13884357048897,40.59255],[-74.1371115196814,40.59255],[-74.13624549427762,40.59405],[-74.13451344347004,40.59405],[-74.13364741806626,40.59555],[-74.13191536725869,40.59555],[-74.1310493418549,40.59705],[-74.12931729104733,40.59705],[-74.12845126564355,40.59555],[-74.12671921483597,40.59555],[-74.12585318943219,40.59705],[-74.12412113862462,40.59705],[-74.12325511322084,40.59855],[-74.12152306241326,40.59855],[-74.12065703700948,40.60005],[-74.1189249862019,40.60005],[-74.11805896079812,40.60155],[-74.11632690999055,40.60155],[-74.11546088458677,40.60305],[-74.11632690999055,40.60455],[-74.11546088458677,40.60605],[-74.11632690999055,40.60755],[-74.11805896079812,40.60755],[-74.1189249862019,40.60905],[-74.11805896079812,40.61055],[-74.11632690999055,40.61055],[-74.11546088458677,40.61205],[-74.11372883377919,40.61205],[-74.11286280837541,40.61055],[-74.11113075756784,40.61055],[-74.11026473216405,40.60905],[-74.10853268135648,40.60905],[-74.1076666559527,40.61055],[-74.10593460514512,40.61055],[-74.10506857974134,40.60905],[-74.10333652893377,40.60905],[-74.10247050352999,40.61055],[-74.10073845272241,40.61055],[-74.09987242731863,40.61205],[-74.09814037651105,40.61205],[-74.09727435110727,40.61055],[-74.0955423002997,40.61055],[-74.09467627489592,40.60905],[-74.09294422408834,40.60905],[-74.09207819868456,40.60755],[-74.09294422408834,40.60605],[-74.09207819868456,40.60455],[-74.09294422408834,40.60305],[-74.09207819868456,40.60155],[-74.09294422408834,40.60005],[-74.09207819868456,40.59855],[-74.09294422408834,40.59705],[-74.09467627489592,40.59705],[-74.0955423002997,40.59555],[-74.09727435110727,40.59555],[-74.09814037651105,40.59405],[-74.09987242731863,40.59405],[-74.10073845272241,40.59255],[-74.09987242731863,40.59105],[-74.10073845272241,40.58955],[-74.10247050352999,40.58955],[-74.10333652893377,40.58805],[-74.10506857974134,40.58805],[-74.10593460514512,40.58655],[-74.1076666559527,40.58655],[-74.10853268135648,40.58505],[-74.1076666559527,40.58355],[-74.10853268135648,40.58205],[-74.11026473216405,40.58205],[-74.11113075756784,40.58355],[-74.11286280837541,40.58355],[-74.11372883377919,40.58205],[-74.11546088458677,40.58205],[-74.11632690999055,40.58055],[-74.11546088458677,40.57905],[-74.11632690999055,40.57755],[-74.11805896079812,40.57755],[-74.1189249862019,40.57605],[-74.12065703700948,40.57605],[-74.12152306241326,40.57455],[-74.12325511322084,40.57455],[-74.12412113862462,40.57605],[-74.12585318943219,40.57605],[-74.12671921483597,40.57755],[-74.12845126564355,40.57755],[-74.12931729104733,40.57605],[-74.12845126564355,40.57455],[-74.12931729104733,40.57305],[-74.1310493418549,40.57305],[-74.13191536725869,40.57455],[-74.13364741806626,40.57455],[-74.13451344347004,40.57305],[-74.13624549427762,40.57305],[-74.1371115196814,40.57155]]],"type":"Polygon"}},{"id":"117","properties":{"borough":"staten island","borocode":5,"neighborhood":"New Springville-Bloomfield-Travis"},"type":"Feature","geometry":{"coordinates":[[[[-74.14230767210411,40.58655],[-74.14403972291169,40.58655],[-74.14490574831547,40.58805],[-74.14663779912304,40.58805],[-74.14750382452682,40.58955],[-74.1492358753344,40.58955],[-74.15010190073818,40.59105],[-74.15183395154575,40.59105],[-74.15269997694953,40.59255],[-74.15443202775711,40.59255],[-74.15529805316089,40.59405],[-74.15703010396847,40.59405],[-74.15789612937225,40.59555],[-74.15962818017982,40.59555],[-74.1604942055836,40.59405],[-74.16222625639118,40.59405],[-74.16309228179496,40.59255],[-74.16482433260254,40.59255],[-74.16569035800632,40.59105],[-74.16742240881389,40.59105],[-74.16828843421767,40.58955],[-74.17002048502525,40.58955],[-74.17088651042903,40.58805],[-74.17002048502525,40.58655],[-74.17088651042903,40.58505],[-74.17002048502525,40.58355],[-74.17088651042903,40.58205],[-74.17002048502525,40.58055],[-74.17088651042903,40.57905],[-74.17002048502525,40.57755],[-74.17088651042903,40.57605],[-74.17002048502525,40.57455],[-74.17088651042903,40.57305],[-74.17002048502525,40.57155],[-74.17088651042903,40.57005],[-74.17002048502525,40.56855],[-74.17088651042903,40.56705],[-74.17002048502525,40.56555],[-74.17088651042903,40.56405],[-74.1726185612366,40.56405],[-74.17348458664038,40.56555],[-74.17521663744796,40.56555],[-74.17608266285174,40.56405],[-74.17781471365932,40.56405],[-74.1786807390631,40.56555],[-74.18041278987067,40.56555],[-74.18127881527445,40.56705],[-74.18301086608203,40.56705],[-74.18387689148581,40.56555],[-74.18560894229338,40.56555],[-74.18647496769717,40.56705],[-74.18560894229338,40.56855],[-74.18387689148581,40.56855],[-74.18301086608203,40.57005],[-74.18387689148581,40.57155],[-74.18301086608203,40.57305],[-74.18387689148581,40.57455],[-74.18560894229338,40.57455],[-74.18647496769717,40.57605],[-74.18820701850474,40.57605],[-74.18907304390852,40.57755],[-74.1908050947161,40.57755],[-74.19167112011988,40.57605],[-74.19340317092745,40.57605],[-74.19426919633123,40.57755],[-74.19600124713881,40.57755],[-74.19686727254259,40.57905],[-74.19859932335017,40.57905],[-74.19946534875395,40.57755],[-74.20119739956152,40.57755],[-74.2020634249653,40.57905],[-74.20119739956152,40.58055],[-74.2020634249653,40.58205],[-74.20119739956152,40.58355],[-74.2020634249653,40.58505],[-74.20379547577288,40.58505],[-74.20466150117666,40.58355],[-74.20639355198423,40.58355],[-74.20725957738802,40.58505],[-74.20639355198423,40.58655],[-74.20466150117666,40.58655],[-74.20379547577288,40.58805],[-74.20466150117666,40.58955],[-74.20379547577288,40.59105],[-74.2020634249653,40.59105],[-74.20119739956152,40.59255],[-74.19946534875395,40.59255],[-74.19859932335017,40.59105],[-74.19686727254259,40.59105],[-74.19600124713881,40.59255],[-74.19426919633123,40.59255],[-74.19340317092745,40.59405],[-74.19426919633123,40.59555],[-74.19600124713881,40.59555],[-74.19686727254259,40.59705],[-74.19859932335017,40.59705],[-74.19946534875395,40.59855],[-74.19859932335017,40.60005],[-74.19946534875395,40.60155],[-74.19859932335017,40.60305],[-74.19946534875395,40.60455],[-74.19859932335017,40.60605],[-74.19946534875395,40.60755],[-74.19859932335017,40.60905],[-74.19946534875395,40.61055],[-74.19859932335017,40.61205],[-74.19686727254259,40.61205],[-74.19600124713881,40.613550000000004],[-74.19686727254259,40.615050000000004],[-74.19859932335017,40.615050000000004],[-74.19946534875395,40.616550000000004],[-74.19859932335017,40.618050000000004],[-74.19686727254259,40.618050000000004],[-74.19600124713881,40.619550000000004],[-74.19686727254259,40.621050000000004],[-74.19600124713881,40.622550000000004],[-74.19686727254259,40.624050000000004],[-74.19600124713881,40.625550000000004],[-74.19686727254259,40.627050000000004],[-74.19600124713881,40.628550000000004],[-74.19686727254259,40.630050000000004],[-74.19600124713881,40.631550000000004],[-74.19686727254259,40.633050000000004],[-74.19600124713881,40.634550000000004],[-74.19426919633123,40.634550000000004],[-74.19340317092745,40.633050000000004],[-74.19426919633123,40.631550000000004],[-74.19340317092745,40.630050000000004],[-74.19167112011988,40.630050000000004],[-74.1908050947161,40.631550000000004],[-74.18907304390852,40.631550000000004],[-74.18820701850474,40.630050000000004],[-74.18647496769717,40.630050000000004],[-74.18560894229338,40.628550000000004],[-74.18387689148581,40.628550000000004],[-74.18301086608203,40.627050000000004],[-74.18127881527445,40.627050000000004],[-74.18041278987067,40.625550000000004],[-74.1786807390631,40.625550000000004],[-74.17781471365932,40.624050000000004],[-74.17608266285174,40.624050000000004],[-74.17521663744796,40.622550000000004],[-74.17348458664038,40.622550000000004],[-74.1726185612366,40.621050000000004],[-74.17088651042903,40.621050000000004],[-74.17002048502525,40.619550000000004],[-74.16828843421767,40.619550000000004],[-74.16742240881389,40.621050000000004],[-74.16569035800632,40.621050000000004],[-74.16482433260254,40.619550000000004],[-74.16309228179496,40.619550000000004],[-74.16222625639118,40.618050000000004],[-74.1604942055836,40.618050000000004],[-74.15962818017982,40.616550000000004],[-74.15789612937225,40.616550000000004],[-74.15703010396847,40.615050000000004],[-74.15529805316089,40.615050000000004],[-74.15443202775711,40.613550000000004],[-74.15529805316089,40.61205],[-74.15443202775711,40.61055],[-74.15269997694953,40.61055],[-74.15183395154575,40.60905],[-74.15010190073818,40.60905],[-74.1492358753344,40.61055],[-74.14750382452682,40.61055],[-74.14663779912304,40.60905],[-74.14490574831547,40.60905],[-74.14403972291169,40.60755],[-74.14230767210411,40.60755],[-74.14144164670033,40.60905],[-74.13970959589275,40.60905],[-74.13884357048897,40.60755],[-74.1371115196814,40.60755],[-74.13624549427762,40.60905],[-74.13451344347004,40.60905],[-74.13364741806626,40.60755],[-74.13191536725869,40.60755],[-74.1310493418549,40.60905],[-74.12931729104733,40.60905],[-74.12845126564355,40.60755],[-74.12671921483597,40.60755],[-74.12585318943219,40.60905],[-74.12412113862462,40.60905],[-74.12325511322084,40.61055],[-74.12152306241326,40.61055],[-74.12065703700948,40.60905],[-74.1189249862019,40.60905],[-74.11805896079812,40.60755],[-74.11632690999055,40.60755],[-74.11546088458677,40.60605],[-74.11632690999055,40.60455],[-74.11546088458677,40.60305],[-74.11632690999055,40.60155],[-74.11805896079812,40.60155],[-74.1189249862019,40.60005],[-74.12065703700948,40.60005],[-74.12152306241326,40.59855],[-74.12325511322084,40.59855],[-74.12412113862462,40.59705],[-74.12585318943219,40.59705],[-74.12671921483597,40.59555],[-74.12845126564355,40.59555],[-74.12931729104733,40.59705],[-74.1310493418549,40.59705],[-74.13191536725869,40.59555],[-74.13364741806626,40.59555],[-74.13451344347004,40.59405],[-74.13624549427762,40.59405],[-74.1371115196814,40.59255],[-74.13884357048897,40.59255],[-74.13970959589275,40.59105],[-74.14144164670033,40.59105],[-74.14230767210411,40.58955],[-74.14144164670033,40.58805],[-74.14230767210411,40.58655]]],[[[-74.18907304390852,40.56255],[-74.1908050947161,40.56255],[-74.19167112011988,40.56405],[-74.19340317092745,40.56405],[-74.19426919633123,40.56555],[-74.19340317092745,40.56705],[-74.19167112011988,40.56705],[-74.1908050947161,40.56555],[-74.18907304390852,40.56555],[-74.18820701850474,40.56405],[-74.18907304390852,40.56255]]],[[[-74.19946534875395,40.55955],[-74.20119739956152,40.55955],[-74.2020634249653,40.56105],[-74.20119739956152,40.56255],[-74.19946534875395,40.56255],[-74.19859932335017,40.56405],[-74.19686727254259,40.56405],[-74.19600124713881,40.56255],[-74.19686727254259,40.56105],[-74.19859932335017,40.56105],[-74.19946534875395,40.55955]]]],"type":"MultiPolygon"}},{"id":"134","properties":{"borough":"staten island","borocode":5,"neighborhood":"Port Richmond"},"type":"Feature","geometry":{"coordinates":[[[-74.13191536725869,40.628550000000004],[-74.13364741806626,40.628550000000004],[-74.13451344347004,40.630050000000004],[-74.13624549427762,40.630050000000004],[-74.1371115196814,40.628550000000004],[-74.13624549427762,40.627050000000004],[-74.1371115196814,40.625550000000004],[-74.13884357048897,40.625550000000004],[-74.13970959589275,40.624050000000004],[-74.13884357048897,40.622550000000004],[-74.13970959589275,40.621050000000004],[-74.13884357048897,40.619550000000004],[-74.13970959589275,40.618050000000004],[-74.13884357048897,40.616550000000004],[-74.13970959589275,40.615050000000004],[-74.14144164670033,40.615050000000004],[-74.14230767210411,40.616550000000004],[-74.14403972291169,40.616550000000004],[-74.14490574831547,40.618050000000004],[-74.14663779912304,40.618050000000004],[-74.14750382452682,40.616550000000004],[-74.14663779912304,40.615050000000004],[-74.14750382452682,40.613550000000004],[-74.14663779912304,40.61205],[-74.14750382452682,40.61055],[-74.1492358753344,40.61055],[-74.15010190073818,40.60905],[-74.15183395154575,40.60905],[-74.15269997694953,40.61055],[-74.15183395154575,40.61205],[-74.15269997694953,40.613550000000004],[-74.15183395154575,40.615050000000004],[-74.15269997694953,40.616550000000004],[-74.15183395154575,40.618050000000004],[-74.15269997694953,40.619550000000004],[-74.15183395154575,40.621050000000004],[-74.15010190073818,40.621050000000004],[-74.1492358753344,40.622550000000004],[-74.14750382452682,40.622550000000004],[-74.14663779912304,40.624050000000004],[-74.14750382452682,40.625550000000004],[-74.14663779912304,40.627050000000004],[-74.14490574831547,40.627050000000004],[-74.14403972291169,40.628550000000004],[-74.14490574831547,40.630050000000004],[-74.14403972291169,40.631550000000004],[-74.14490574831547,40.633050000000004],[-74.14403972291169,40.634550000000004],[-74.14490574831547,40.636050000000004],[-74.14403972291169,40.637550000000005],[-74.14490574831547,40.639050000000005],[-74.14403972291169,40.640550000000005],[-74.14230767210411,40.640550000000005],[-74.14144164670033,40.642050000000005],[-74.13970959589275,40.642050000000005],[-74.13884357048897,40.643550000000005],[-74.1371115196814,40.643550000000005],[-74.13624549427762,40.642050000000005],[-74.13451344347004,40.642050000000005],[-74.13364741806626,40.643550000000005],[-74.13191536725869,40.643550000000005],[-74.1310493418549,40.642050000000005],[-74.12931729104733,40.642050000000005],[-74.12845126564355,40.640550000000005],[-74.12671921483597,40.640550000000005],[-74.12585318943219,40.639050000000005],[-74.12671921483597,40.637550000000005],[-74.12845126564355,40.637550000000005],[-74.12931729104733,40.636050000000004],[-74.12845126564355,40.634550000000004],[-74.12931729104733,40.633050000000004],[-74.1310493418549,40.633050000000004],[-74.13191536725869,40.631550000000004],[-74.1310493418549,40.630050000000004],[-74.13191536725869,40.628550000000004]]],"type":"Polygon"}},{"id":"103","properties":{"borough":"staten island","borocode":5,"neighborhood":"Mariner's Harbor-Arlington-Port Ivory-Graniteville"},"type":"Feature","geometry":{"coordinates":[[[-74.19167112011988,40.630050000000004],[-74.19340317092745,40.630050000000004],[-74.19426919633123,40.631550000000004],[-74.19340317092745,40.633050000000004],[-74.19426919633123,40.634550000000004],[-74.19340317092745,40.636050000000004],[-74.19167112011988,40.636050000000004],[-74.1908050947161,40.634550000000004],[-74.18907304390852,40.634550000000004],[-74.18820701850474,40.633050000000004],[-74.18647496769717,40.633050000000004],[-74.18560894229338,40.634550000000004],[-74.18647496769717,40.636050000000004],[-74.18560894229338,40.637550000000005],[-74.18647496769717,40.639050000000005],[-74.18560894229338,40.640550000000005],[-74.18387689148581,40.640550000000005],[-74.18301086608203,40.642050000000005],[-74.18127881527445,40.642050000000005],[-74.18041278987067,40.643550000000005],[-74.1786807390631,40.643550000000005],[-74.17781471365932,40.642050000000005],[-74.17608266285174,40.642050000000005],[-74.17521663744796,40.643550000000005],[-74.17348458664038,40.643550000000005],[-74.1726185612366,40.642050000000005],[-74.17088651042903,40.642050000000005],[-74.17002048502525,40.643550000000005],[-74.16828843421767,40.643550000000005],[-74.16742240881389,40.642050000000005],[-74.16569035800632,40.642050000000005],[-74.16482433260254,40.643550000000005],[-74.16309228179496,40.643550000000005],[-74.16222625639118,40.642050000000005],[-74.1604942055836,40.642050000000005],[-74.15962818017982,40.640550000000005],[-74.1604942055836,40.639050000000005],[-74.15962818017982,40.637550000000005],[-74.15789612937225,40.637550000000005],[-74.15703010396847,40.639050000000005],[-74.15529805316089,40.639050000000005],[-74.15443202775711,40.637550000000005],[-74.15269997694953,40.637550000000005],[-74.15183395154575,40.639050000000005],[-74.15010190073818,40.639050000000005],[-74.1492358753344,40.640550000000005],[-74.14750382452682,40.640550000000005],[-74.14663779912304,40.642050000000005],[-74.14490574831547,40.642050000000005],[-74.14403972291169,40.640550000000005],[-74.14490574831547,40.639050000000005],[-74.14403972291169,40.637550000000005],[-74.14490574831547,40.636050000000004],[-74.14403972291169,40.634550000000004],[-74.14490574831547,40.633050000000004],[-74.14403972291169,40.631550000000004],[-74.14490574831547,40.630050000000004],[-74.14403972291169,40.628550000000004],[-74.14490574831547,40.627050000000004],[-74.14663779912304,40.627050000000004],[-74.14750382452682,40.625550000000004],[-74.14663779912304,40.624050000000004],[-74.14750382452682,40.622550000000004],[-74.1492358753344,40.622550000000004],[-74.15010190073818,40.621050000000004],[-74.15183395154575,40.621050000000004],[-74.15269997694953,40.619550000000004],[-74.15183395154575,40.618050000000004],[-74.15269997694953,40.616550000000004],[-74.15183395154575,40.615050000000004],[-74.15269997694953,40.613550000000004],[-74.15443202775711,40.613550000000004],[-74.15529805316089,40.615050000000004],[-74.15703010396847,40.615050000000004],[-74.15789612937225,40.616550000000004],[-74.15962818017982,40.616550000000004],[-74.1604942055836,40.618050000000004],[-74.16222625639118,40.618050000000004],[-74.16309228179496,40.619550000000004],[-74.16482433260254,40.619550000000004],[-74.16569035800632,40.621050000000004],[-74.16742240881389,40.621050000000004],[-74.16828843421767,40.619550000000004],[-74.17002048502525,40.619550000000004],[-74.17088651042903,40.621050000000004],[-74.1726185612366,40.621050000000004],[-74.17348458664038,40.622550000000004],[-74.17521663744796,40.622550000000004],[-74.17608266285174,40.624050000000004],[-74.17781471365932,40.624050000000004],[-74.1786807390631,40.625550000000004],[-74.18041278987067,40.625550000000004],[-74.18127881527445,40.627050000000004],[-74.18301086608203,40.627050000000004],[-74.18387689148581,40.628550000000004],[-74.18560894229338,40.628550000000004],[-74.18647496769717,40.630050000000004],[-74.18820701850474,40.630050000000004],[-74.18907304390852,40.631550000000004],[-74.1908050947161,40.631550000000004],[-74.19167112011988,40.630050000000004]]],"type":"Polygon"}},{"id":"180","properties":{"borough":"staten island","borocode":5,"neighborhood":"Westerleigh"},"type":"Feature","geometry":{"coordinates":[[[-74.10333652893377,40.60905],[-74.10506857974134,40.60905],[-74.10593460514512,40.61055],[-74.1076666559527,40.61055],[-74.10853268135648,40.60905],[-74.11026473216405,40.60905],[-74.11113075756784,40.61055],[-74.11286280837541,40.61055],[-74.11372883377919,40.61205],[-74.11546088458677,40.61205],[-74.11632690999055,40.61055],[-74.11805896079812,40.61055],[-74.1189249862019,40.60905],[-74.12065703700948,40.60905],[-74.12152306241326,40.61055],[-74.12325511322084,40.61055],[-74.12412113862462,40.60905],[-74.12585318943219,40.60905],[-74.12671921483597,40.60755],[-74.12845126564355,40.60755],[-74.12931729104733,40.60905],[-74.1310493418549,40.60905],[-74.13191536725869,40.60755],[-74.13364741806626,40.60755],[-74.13451344347004,40.60905],[-74.13624549427762,40.60905],[-74.1371115196814,40.60755],[-74.13884357048897,40.60755],[-74.13970959589275,40.60905],[-74.14144164670033,40.60905],[-74.14230767210411,40.60755],[-74.14403972291169,40.60755],[-74.14490574831547,40.60905],[-74.14663779912304,40.60905],[-74.14750382452682,40.61055],[-74.14663779912304,40.61205],[-74.14750382452682,40.613550000000004],[-74.14663779912304,40.615050000000004],[-74.14750382452682,40.616550000000004],[-74.14663779912304,40.618050000000004],[-74.14490574831547,40.618050000000004],[-74.14403972291169,40.616550000000004],[-74.14230767210411,40.616550000000004],[-74.14144164670033,40.615050000000004],[-74.13970959589275,40.615050000000004],[-74.13884357048897,40.616550000000004],[-74.13970959589275,40.618050000000004],[-74.13884357048897,40.619550000000004],[-74.13970959589275,40.621050000000004],[-74.13884357048897,40.622550000000004],[-74.13970959589275,40.624050000000004],[-74.13884357048897,40.625550000000004],[-74.1371115196814,40.625550000000004],[-74.13624549427762,40.627050000000004],[-74.1371115196814,40.628550000000004],[-74.13624549427762,40.630050000000004],[-74.13451344347004,40.630050000000004],[-74.13364741806626,40.628550000000004],[-74.13191536725869,40.628550000000004],[-74.1310493418549,40.627050000000004],[-74.12931729104733,40.627050000000004],[-74.12845126564355,40.625550000000004],[-74.12671921483597,40.625550000000004],[-74.12585318943219,40.627050000000004],[-74.12412113862462,40.627050000000004],[-74.12325511322084,40.625550000000004],[-74.12152306241326,40.625550000000004],[-74.12065703700948,40.624050000000004],[-74.1189249862019,40.624050000000004],[-74.11805896079812,40.625550000000004],[-74.11632690999055,40.625550000000004],[-74.11546088458677,40.624050000000004],[-74.11632690999055,40.622550000000004],[-74.11546088458677,40.621050000000004],[-74.11372883377919,40.621050000000004],[-74.11286280837541,40.622550000000004],[-74.11113075756784,40.622550000000004],[-74.11026473216405,40.621050000000004],[-74.11113075756784,40.619550000000004],[-74.11026473216405,40.618050000000004],[-74.10853268135648,40.618050000000004],[-74.1076666559527,40.619550000000004],[-74.10593460514512,40.619550000000004],[-74.10506857974134,40.618050000000004],[-74.10333652893377,40.618050000000004],[-74.10247050352999,40.616550000000004],[-74.10333652893377,40.615050000000004],[-74.10247050352999,40.613550000000004],[-74.10073845272241,40.613550000000004],[-74.09987242731863,40.61205],[-74.10073845272241,40.61055],[-74.10247050352999,40.61055],[-74.10333652893377,40.60905]]],"type":"Polygon"}},{"id":"123","properties":{"borough":"staten island","borocode":5,"neighborhood":"Oakwood-Oakwood Beach"},"type":"Feature","geometry":{"coordinates":[[[-74.13191536725869,40.55055],[-74.13364741806626,40.55055],[-74.13451344347004,40.55205],[-74.13364741806626,40.55355],[-74.13451344347004,40.55505],[-74.13624549427762,40.55505],[-74.1371115196814,40.55655],[-74.13884357048897,40.55655],[-74.13970959589275,40.55805],[-74.13884357048897,40.55955],[-74.1371115196814,40.55955],[-74.13624549427762,40.56105],[-74.13451344347004,40.56105],[-74.13364741806626,40.56255],[-74.13451344347004,40.56405],[-74.13624549427762,40.56405],[-74.1371115196814,40.56555],[-74.13884357048897,40.56555],[-74.13970959589275,40.56705],[-74.14144164670033,40.56705],[-74.14230767210411,40.56855],[-74.14403972291169,40.56855],[-74.14490574831547,40.57005],[-74.14403972291169,40.57155],[-74.14230767210411,40.57155],[-74.14144164670033,40.57305],[-74.13970959589275,40.57305],[-74.13884357048897,40.57155],[-74.1371115196814,40.57155],[-74.13624549427762,40.57305],[-74.13451344347004,40.57305],[-74.13364741806626,40.57455],[-74.13191536725869,40.57455],[-74.1310493418549,40.57305],[-74.12931729104733,40.57305],[-74.12845126564355,40.57455],[-74.12931729104733,40.57605],[-74.12845126564355,40.57755],[-74.12671921483597,40.57755],[-74.12585318943219,40.57605],[-74.12412113862462,40.57605],[-74.12325511322084,40.57455],[-74.12152306241326,40.57455],[-74.12065703700948,40.57305],[-74.12152306241326,40.57155],[-74.12325511322084,40.57155],[-74.12412113862462,40.57005],[-74.12325511322084,40.56855],[-74.12152306241326,40.56855],[-74.12065703700948,40.56705],[-74.1189249862019,40.56705],[-74.11805896079812,40.56555],[-74.1189249862019,40.56405],[-74.11805896079812,40.56255],[-74.11632690999055,40.56255],[-74.11546088458677,40.56405],[-74.11372883377919,40.56405],[-74.11286280837541,40.56555],[-74.11113075756784,40.56555],[-74.11026473216405,40.56405],[-74.10853268135648,40.56405],[-74.1076666559527,40.56255],[-74.10593460514512,40.56255],[-74.10506857974134,40.56105],[-74.10333652893377,40.56105],[-74.10247050352999,40.55955],[-74.10073845272241,40.55955],[-74.09987242731863,40.55805],[-74.10073845272241,40.55655],[-74.10247050352999,40.55655],[-74.10333652893377,40.55505],[-74.10506857974134,40.55505],[-74.10593460514512,40.55355],[-74.1076666559527,40.55355],[-74.10853268135648,40.55205],[-74.11026473216405,40.55205],[-74.11113075756784,40.55055],[-74.11026473216405,40.54905],[-74.11113075756784,40.54755],[-74.11286280837541,40.54755],[-74.11372883377919,40.54905],[-74.11546088458677,40.54905],[-74.11632690999055,40.55055],[-74.11805896079812,40.55055],[-74.1189249862019,40.55205],[-74.12065703700948,40.55205],[-74.12152306241326,40.55355],[-74.12325511322084,40.55355],[-74.12412113862462,40.55505],[-74.12585318943219,40.55505],[-74.12671921483597,40.55655],[-74.12845126564355,40.55655],[-74.12931729104733,40.55505],[-74.12845126564355,40.55355],[-74.12931729104733,40.55205],[-74.1310493418549,40.55205],[-74.13191536725869,40.55055]]],"type":"Polygon"}},{"id":"177","properties":{"borough":"staten island","borocode":5,"neighborhood":"West New Brighton-New Brighton-St. George"},"type":"Feature","geometry":{"coordinates":[[[[-74.07215961439749,40.636050000000004],[-74.07389166520507,40.636050000000004],[-74.07475769060885,40.637550000000005],[-74.07648974141642,40.637550000000005],[-74.0773557668202,40.639050000000005],[-74.07908781762778,40.639050000000005],[-74.07995384303156,40.637550000000005],[-74.08168589383914,40.637550000000005],[-74.08255191924292,40.636050000000004],[-74.08428397005049,40.636050000000004],[-74.08514999545427,40.634550000000004],[-74.08688204626185,40.634550000000004],[-74.08774807166563,40.636050000000004],[-74.0894801224732,40.636050000000004],[-74.09034614787699,40.637550000000005],[-74.09207819868456,40.637550000000005],[-74.09294422408834,40.636050000000004],[-74.09467627489592,40.636050000000004],[-74.0955423002997,40.637550000000005],[-74.09727435110727,40.637550000000005],[-74.09814037651105,40.639050000000005],[-74.09987242731863,40.639050000000005],[-74.10073845272241,40.640550000000005],[-74.10247050352999,40.640550000000005],[-74.10333652893377,40.642050000000005],[-74.10506857974134,40.642050000000005],[-74.10593460514512,40.640550000000005],[-74.10506857974134,40.639050000000005],[-74.10593460514512,40.637550000000005],[-74.1076666559527,40.637550000000005],[-74.10853268135648,40.639050000000005],[-74.11026473216405,40.639050000000005],[-74.11113075756784,40.637550000000005],[-74.11286280837541,40.637550000000005],[-74.11372883377919,40.639050000000005],[-74.11546088458677,40.639050000000005],[-74.11632690999055,40.637550000000005],[-74.11805896079812,40.637550000000005],[-74.1189249862019,40.636050000000004],[-74.11805896079812,40.634550000000004],[-74.11632690999055,40.634550000000004],[-74.11546088458677,40.633050000000004],[-74.11632690999055,40.631550000000004],[-74.11546088458677,40.630050000000004],[-74.11632690999055,40.628550000000004],[-74.11546088458677,40.627050000000004],[-74.11632690999055,40.625550000000004],[-74.11805896079812,40.625550000000004],[-74.1189249862019,40.624050000000004],[-74.12065703700948,40.624050000000004],[-74.12152306241326,40.625550000000004],[-74.12325511322084,40.625550000000004],[-74.12412113862462,40.627050000000004],[-74.12585318943219,40.627050000000004],[-74.12671921483597,40.625550000000004],[-74.12845126564355,40.625550000000004],[-74.12931729104733,40.627050000000004],[-74.1310493418549,40.627050000000004],[-74.13191536725869,40.628550000000004],[-74.1310493418549,40.630050000000004],[-74.13191536725869,40.631550000000004],[-74.1310493418549,40.633050000000004],[-74.12931729104733,40.633050000000004],[-74.12845126564355,40.634550000000004],[-74.12931729104733,40.636050000000004],[-74.12845126564355,40.637550000000005],[-74.12671921483597,40.637550000000005],[-74.12585318943219,40.639050000000005],[-74.12671921483597,40.640550000000005],[-74.12585318943219,40.642050000000005],[-74.12412113862462,40.642050000000005],[-74.12325511322084,40.643550000000005],[-74.12152306241326,40.643550000000005],[-74.12065703700948,40.642050000000005],[-74.1189249862019,40.642050000000005],[-74.11805896079812,40.643550000000005],[-74.11632690999055,40.643550000000005],[-74.11546088458677,40.645050000000005],[-74.11372883377919,40.645050000000005],[-74.11286280837541,40.646550000000005],[-74.11113075756784,40.646550000000005],[-74.11026473216405,40.648050000000005],[-74.10853268135648,40.648050000000005],[-74.1076666559527,40.646550000000005],[-74.10593460514512,40.646550000000005],[-74.10506857974134,40.648050000000005],[-74.10333652893377,40.648050000000005],[-74.10247050352999,40.646550000000005],[-74.10073845272241,40.646550000000005],[-74.09987242731863,40.645050000000005],[-74.09814037651105,40.645050000000005],[-74.09727435110727,40.646550000000005],[-74.0955423002997,40.646550000000005],[-74.09467627489592,40.648050000000005],[-74.09294422408834,40.648050000000005],[-74.09207819868456,40.646550000000005],[-74.09034614787699,40.646550000000005],[-74.0894801224732,40.648050000000005],[-74.08774807166563,40.648050000000005],[-74.08688204626185,40.649550000000005],[-74.08514999545427,40.649550000000005],[-74.08428397005049,40.651050000000005],[-74.08255191924292,40.651050000000005],[-74.08168589383914,40.649550000000005],[-74.07995384303156,40.649550000000005],[-74.07908781762778,40.648050000000005],[-74.0773557668202,40.648050000000005],[-74.07648974141642,40.646550000000005],[-74.07475769060885,40.646550000000005],[-74.07389166520507,40.645050000000005],[-74.07215961439749,40.645050000000005],[-74.07129358899371,40.643550000000005],[-74.07215961439749,40.642050000000005],[-74.07129358899371,40.640550000000005],[-74.07215961439749,40.639050000000005],[-74.07129358899371,40.637550000000005],[-74.07215961439749,40.636050000000004]]],[[[-74.11372883377919,40.621050000000004],[-74.11546088458677,40.621050000000004],[-74.11632690999055,40.622550000000004],[-74.11546088458677,40.624050000000004],[-74.11372883377919,40.624050000000004],[-74.11286280837541,40.622550000000004],[-74.11372883377919,40.621050000000004]]]],"type":"MultiPolygon"}},{"id":"116","properties":{"borough":"staten island","borocode":5,"neighborhood":"New Dorp-Midland Beach"},"type":"Feature","geometry":{"coordinates":[[[-74.11632690999055,40.56255],[-74.11805896079812,40.56255],[-74.1189249862019,40.56405],[-74.11805896079812,40.56555],[-74.1189249862019,40.56705],[-74.12065703700948,40.56705],[-74.12152306241326,40.56855],[-74.12325511322084,40.56855],[-74.12412113862462,40.57005],[-74.12325511322084,40.57155],[-74.12152306241326,40.57155],[-74.12065703700948,40.57305],[-74.12152306241326,40.57455],[-74.12065703700948,40.57605],[-74.1189249862019,40.57605],[-74.11805896079812,40.57755],[-74.11632690999055,40.57755],[-74.11546088458677,40.57905],[-74.11632690999055,40.58055],[-74.11546088458677,40.58205],[-74.11372883377919,40.58205],[-74.11286280837541,40.58355],[-74.11113075756784,40.58355],[-74.11026473216405,40.58205],[-74.10853268135648,40.58205],[-74.1076666559527,40.58355],[-74.10853268135648,40.58505],[-74.1076666559527,40.58655],[-74.10593460514512,40.58655],[-74.10506857974134,40.58505],[-74.10333652893377,40.58505],[-74.10247050352999,40.58355],[-74.10073845272241,40.58355],[-74.09987242731863,40.58205],[-74.10073845272241,40.58055],[-74.09987242731863,40.57905],[-74.09814037651105,40.57905],[-74.09727435110727,40.57755],[-74.0955423002997,40.57755],[-74.09467627489592,40.57605],[-74.09294422408834,40.57605],[-74.09207819868456,40.57455],[-74.09034614787699,40.57455],[-74.0894801224732,40.57305],[-74.08774807166563,40.57305],[-74.08688204626185,40.57155],[-74.08514999545427,40.57155],[-74.08428397005049,40.57005],[-74.08514999545427,40.56855],[-74.08688204626185,40.56855],[-74.08774807166563,40.56705],[-74.0894801224732,40.56705],[-74.09034614787699,40.56555],[-74.09207819868456,40.56555],[-74.09294422408834,40.56705],[-74.09467627489592,40.56705],[-74.0955423002997,40.56855],[-74.09727435110727,40.56855],[-74.09814037651105,40.57005],[-74.09987242731863,40.57005],[-74.10073845272241,40.57155],[-74.10247050352999,40.57155],[-74.10333652893377,40.57005],[-74.10247050352999,40.56855],[-74.10073845272241,40.56855],[-74.09987242731863,40.56705],[-74.09814037651105,40.56705],[-74.09727435110727,40.56555],[-74.0955423002997,40.56555],[-74.09467627489592,40.56405],[-74.0955423002997,40.56255],[-74.09727435110727,40.56255],[-74.09814037651105,40.56105],[-74.09987242731863,40.56105],[-74.10073845272241,40.55955],[-74.10247050352999,40.55955],[-74.10333652893377,40.56105],[-74.10506857974134,40.56105],[-74.10593460514512,40.56255],[-74.1076666559527,40.56255],[-74.10853268135648,40.56405],[-74.11026473216405,40.56405],[-74.11113075756784,40.56555],[-74.11286280837541,40.56555],[-74.11372883377919,40.56405],[-74.11546088458677,40.56405],[-74.11632690999055,40.56255]]],"type":"Polygon"}},{"id":"115","properties":{"borough":"staten island","borocode":5,"neighborhood":"New Brighton-Silver Lake"},"type":"Feature","geometry":{"coordinates":[[[-74.10073845272241,40.616550000000004],[-74.10247050352999,40.616550000000004],[-74.10333652893377,40.618050000000004],[-74.10506857974134,40.618050000000004],[-74.10593460514512,40.619550000000004],[-74.1076666559527,40.619550000000004],[-74.10853268135648,40.618050000000004],[-74.11026473216405,40.618050000000004],[-74.11113075756784,40.619550000000004],[-74.11026473216405,40.621050000000004],[-74.11113075756784,40.622550000000004],[-74.11286280837541,40.622550000000004],[-74.11372883377919,40.624050000000004],[-74.11546088458677,40.624050000000004],[-74.11632690999055,40.625550000000004],[-74.11546088458677,40.627050000000004],[-74.11632690999055,40.628550000000004],[-74.11546088458677,40.630050000000004],[-74.11632690999055,40.631550000000004],[-74.11546088458677,40.633050000000004],[-74.11632690999055,40.634550000000004],[-74.11805896079812,40.634550000000004],[-74.1189249862019,40.636050000000004],[-74.11805896079812,40.637550000000005],[-74.11632690999055,40.637550000000005],[-74.11546088458677,40.639050000000005],[-74.11372883377919,40.639050000000005],[-74.11286280837541,40.637550000000005],[-74.11113075756784,40.637550000000005],[-74.11026473216405,40.639050000000005],[-74.10853268135648,40.639050000000005],[-74.1076666559527,40.637550000000005],[-74.10593460514512,40.637550000000005],[-74.10506857974134,40.639050000000005],[-74.10593460514512,40.640550000000005],[-74.10506857974134,40.642050000000005],[-74.10333652893377,40.642050000000005],[-74.10247050352999,40.640550000000005],[-74.10073845272241,40.640550000000005],[-74.09987242731863,40.639050000000005],[-74.09814037651105,40.639050000000005],[-74.09727435110727,40.637550000000005],[-74.0955423002997,40.637550000000005],[-74.09467627489592,40.636050000000004],[-74.09294422408834,40.636050000000004],[-74.09207819868456,40.637550000000005],[-74.09034614787699,40.637550000000005],[-74.0894801224732,40.636050000000004],[-74.08774807166563,40.636050000000004],[-74.08688204626185,40.634550000000004],[-74.08774807166563,40.633050000000004],[-74.08688204626185,40.631550000000004],[-74.08774807166563,40.630050000000004],[-74.0894801224732,40.630050000000004],[-74.09034614787699,40.628550000000004],[-74.09207819868456,40.628550000000004],[-74.09294422408834,40.627050000000004],[-74.09467627489592,40.627050000000004],[-74.0955423002997,40.625550000000004],[-74.09727435110727,40.625550000000004],[-74.09814037651105,40.624050000000004],[-74.09727435110727,40.622550000000004],[-74.09814037651105,40.621050000000004],[-74.09987242731863,40.621050000000004],[-74.10073845272241,40.619550000000004],[-74.09987242731863,40.618050000000004],[-74.10073845272241,40.616550000000004]]],"type":"Polygon"}},{"id":"127","properties":{"borough":"staten island","borocode":5,"neighborhood":"Old Town-Dongan Hills-South Beach"},"type":"Feature","geometry":{"coordinates":[[[-74.08514999545427,40.57155],[-74.08688204626185,40.57155],[-74.08774807166563,40.57305],[-74.0894801224732,40.57305],[-74.09034614787699,40.57455],[-74.09207819868456,40.57455],[-74.09294422408834,40.57605],[-74.09467627489592,40.57605],[-74.0955423002997,40.57755],[-74.09727435110727,40.57755],[-74.09814037651105,40.57905],[-74.09987242731863,40.57905],[-74.10073845272241,40.58055],[-74.09987242731863,40.58205],[-74.10073845272241,40.58355],[-74.10247050352999,40.58355],[-74.10333652893377,40.58505],[-74.10506857974134,40.58505],[-74.10593460514512,40.58655],[-74.10506857974134,40.58805],[-74.10333652893377,40.58805],[-74.10247050352999,40.58955],[-74.10073845272241,40.58955],[-74.09987242731863,40.59105],[-74.10073845272241,40.59255],[-74.09987242731863,40.59405],[-74.09814037651105,40.59405],[-74.09727435110727,40.59555],[-74.0955423002997,40.59555],[-74.09467627489592,40.59705],[-74.09294422408834,40.59705],[-74.09207819868456,40.59855],[-74.09034614787699,40.59855],[-74.0894801224732,40.60005],[-74.08774807166563,40.60005],[-74.08688204626185,40.60155],[-74.08514999545427,40.60155],[-74.08428397005049,40.60305],[-74.08255191924292,40.60305],[-74.08168589383914,40.60155],[-74.08255191924292,40.60005],[-74.08168589383914,40.59855],[-74.08255191924292,40.59705],[-74.08428397005049,40.59705],[-74.08514999545427,40.59555],[-74.08428397005049,40.59405],[-74.08255191924292,40.59405],[-74.08168589383914,40.59255],[-74.07995384303156,40.59255],[-74.07908781762778,40.59405],[-74.0773557668202,40.59405],[-74.07648974141642,40.59555],[-74.07475769060885,40.59555],[-74.07389166520507,40.59705],[-74.07215961439749,40.59705],[-74.07129358899371,40.59555],[-74.06956153818614,40.59555],[-74.06869551278236,40.59405],[-74.06956153818614,40.59255],[-74.06869551278236,40.59105],[-74.06696346197478,40.59105],[-74.066097436571,40.58955],[-74.06696346197478,40.58805],[-74.06869551278236,40.58805],[-74.06956153818614,40.58655],[-74.06869551278236,40.58505],[-74.06956153818614,40.58355],[-74.07129358899371,40.58355],[-74.07215961439749,40.58205],[-74.07389166520507,40.58205],[-74.07475769060885,40.58055],[-74.07648974141642,40.58055],[-74.0773557668202,40.57905],[-74.07648974141642,40.57755],[-74.0773557668202,40.57605],[-74.07908781762778,40.57605],[-74.07995384303156,40.57455],[-74.08168589383914,40.57455],[-74.08255191924292,40.57305],[-74.08428397005049,40.57305],[-74.08514999545427,40.57155]]],"type":"Polygon"}},{"id":"78","properties":{"borough":"staten island","borocode":5,"neighborhood":"Grymes Hill-Clifton-Fox Hills"},"type":"Feature","geometry":{"coordinates":[[[-74.09294422408834,40.60905],[-74.09467627489592,40.60905],[-74.0955423002997,40.61055],[-74.09727435110727,40.61055],[-74.09814037651105,40.61205],[-74.09987242731863,40.61205],[-74.10073845272241,40.613550000000004],[-74.10247050352999,40.613550000000004],[-74.10333652893377,40.615050000000004],[-74.10247050352999,40.616550000000004],[-74.10073845272241,40.616550000000004],[-74.09987242731863,40.618050000000004],[-74.10073845272241,40.619550000000004],[-74.09987242731863,40.621050000000004],[-74.09814037651105,40.621050000000004],[-74.09727435110727,40.622550000000004],[-74.09814037651105,40.624050000000004],[-74.09727435110727,40.625550000000004],[-74.0955423002997,40.625550000000004],[-74.09467627489592,40.627050000000004],[-74.09294422408834,40.627050000000004],[-74.09207819868456,40.628550000000004],[-74.09034614787699,40.628550000000004],[-74.0894801224732,40.630050000000004],[-74.08774807166563,40.630050000000004],[-74.08688204626185,40.631550000000004],[-74.08774807166563,40.633050000000004],[-74.08688204626185,40.634550000000004],[-74.08514999545427,40.634550000000004],[-74.08428397005049,40.633050000000004],[-74.08255191924292,40.633050000000004],[-74.08168589383914,40.631550000000004],[-74.08255191924292,40.630050000000004],[-74.08168589383914,40.628550000000004],[-74.08255191924292,40.627050000000004],[-74.08428397005049,40.627050000000004],[-74.08514999545427,40.625550000000004],[-74.08688204626185,40.625550000000004],[-74.08774807166563,40.624050000000004],[-74.08688204626185,40.622550000000004],[-74.08774807166563,40.621050000000004],[-74.08688204626185,40.619550000000004],[-74.08774807166563,40.618050000000004],[-74.08688204626185,40.616550000000004],[-74.08774807166563,40.615050000000004],[-74.08688204626185,40.613550000000004],[-74.08514999545427,40.613550000000004],[-74.08428397005049,40.615050000000004],[-74.08255191924292,40.615050000000004],[-74.08168589383914,40.616550000000004],[-74.07995384303156,40.616550000000004],[-74.07908781762778,40.618050000000004],[-74.0773557668202,40.618050000000004],[-74.07648974141642,40.619550000000004],[-74.0773557668202,40.621050000000004],[-74.07648974141642,40.622550000000004],[-74.07475769060885,40.622550000000004],[-74.07389166520507,40.624050000000004],[-74.07215961439749,40.624050000000004],[-74.07129358899371,40.622550000000004],[-74.06956153818614,40.622550000000004],[-74.06869551278236,40.621050000000004],[-74.06956153818614,40.619550000000004],[-74.07129358899371,40.619550000000004],[-74.07215961439749,40.618050000000004],[-74.07389166520507,40.618050000000004],[-74.07475769060885,40.616550000000004],[-74.07389166520507,40.615050000000004],[-74.07475769060885,40.613550000000004],[-74.07648974141642,40.613550000000004],[-74.0773557668202,40.61205],[-74.07648974141642,40.61055],[-74.0773557668202,40.60905],[-74.07908781762778,40.60905],[-74.07995384303156,40.60755],[-74.07908781762778,40.60605],[-74.07995384303156,40.60455],[-74.08168589383914,40.60455],[-74.08255191924292,40.60605],[-74.08428397005049,40.60605],[-74.08514999545427,40.60755],[-74.08688204626185,40.60755],[-74.08774807166563,40.60905],[-74.0894801224732,40.60905],[-74.09034614787699,40.61055],[-74.09207819868456,40.61055],[-74.09294422408834,40.60905]]],"type":"Polygon"}},{"id":"74","properties":{"borough":"staten island","borocode":5,"neighborhood":"Grasmere-Arrochar-Ft. Wadsworth"},"type":"Feature","geometry":{"coordinates":[[[-74.07995384303156,40.59255],[-74.08168589383914,40.59255],[-74.08255191924292,40.59405],[-74.08428397005049,40.59405],[-74.08514999545427,40.59555],[-74.08428397005049,40.59705],[-74.08255191924292,40.59705],[-74.08168589383914,40.59855],[-74.08255191924292,40.60005],[-74.08168589383914,40.60155],[-74.08255191924292,40.60305],[-74.08428397005049,40.60305],[-74.08514999545427,40.60155],[-74.08688204626185,40.60155],[-74.08774807166563,40.60005],[-74.0894801224732,40.60005],[-74.09034614787699,40.59855],[-74.09207819868456,40.59855],[-74.09294422408834,40.60005],[-74.09207819868456,40.60155],[-74.09294422408834,40.60305],[-74.09207819868456,40.60455],[-74.09294422408834,40.60605],[-74.09207819868456,40.60755],[-74.09294422408834,40.60905],[-74.09207819868456,40.61055],[-74.09034614787699,40.61055],[-74.0894801224732,40.60905],[-74.08774807166563,40.60905],[-74.08688204626185,40.60755],[-74.08514999545427,40.60755],[-74.08428397005049,40.60605],[-74.08255191924292,40.60605],[-74.08168589383914,40.60455],[-74.07995384303156,40.60455],[-74.07908781762778,40.60605],[-74.0773557668202,40.60605],[-74.07648974141642,40.60455],[-74.07475769060885,40.60455],[-74.07389166520507,40.60605],[-74.07215961439749,40.60605],[-74.07129358899371,40.60455],[-74.06956153818614,40.60455],[-74.06869551278236,40.60305],[-74.06696346197478,40.60305],[-74.066097436571,40.60155],[-74.06436538576342,40.60155],[-74.06349936035964,40.60305],[-74.06176730955207,40.60305],[-74.06090128414829,40.60155],[-74.05916923334071,40.60155],[-74.05830320793693,40.60005],[-74.05916923334071,40.59855],[-74.06090128414829,40.59855],[-74.06176730955207,40.59705],[-74.06090128414829,40.59555],[-74.05916923334071,40.59555],[-74.05830320793693,40.59405],[-74.05916923334071,40.59255],[-74.06090128414829,40.59255],[-74.06176730955207,40.59105],[-74.06349936035964,40.59105],[-74.06436538576342,40.58955],[-74.066097436571,40.58955],[-74.06696346197478,40.59105],[-74.06869551278236,40.59105],[-74.06956153818614,40.59255],[-74.06869551278236,40.59405],[-74.06956153818614,40.59555],[-74.07129358899371,40.59555],[-74.07215961439749,40.59705],[-74.07389166520507,40.59705],[-74.07475769060885,40.59555],[-74.07648974141642,40.59555],[-74.0773557668202,40.59405],[-74.07908781762778,40.59405],[-74.07995384303156,40.59255]]],"type":"Polygon"}},{"id":"158","properties":{"borough":"staten island","borocode":5,"neighborhood":"Stapleton-Rosebank"},"type":"Feature","geometry":{"coordinates":[[[[-74.07475769060885,40.60455],[-74.07648974141642,40.60455],[-74.0773557668202,40.60605],[-74.07908781762778,40.60605],[-74.07995384303156,40.60755],[-74.07908781762778,40.60905],[-74.0773557668202,40.60905],[-74.07648974141642,40.61055],[-74.0773557668202,40.61205],[-74.07648974141642,40.613550000000004],[-74.07475769060885,40.613550000000004],[-74.07389166520507,40.615050000000004],[-74.07475769060885,40.616550000000004],[-74.07389166520507,40.618050000000004],[-74.07215961439749,40.618050000000004],[-74.07129358899371,40.619550000000004],[-74.06956153818614,40.619550000000004],[-74.06869551278236,40.621050000000004],[-74.06696346197478,40.621050000000004],[-74.066097436571,40.619550000000004],[-74.06436538576342,40.619550000000004],[-74.06349936035964,40.618050000000004],[-74.06176730955207,40.618050000000004],[-74.06090128414829,40.616550000000004],[-74.06176730955207,40.615050000000004],[-74.06090128414829,40.613550000000004],[-74.05916923334071,40.613550000000004],[-74.05830320793693,40.61205],[-74.05657115712935,40.61205],[-74.05570513172557,40.61055],[-74.05657115712935,40.60905],[-74.05570513172557,40.60755],[-74.05657115712935,40.60605],[-74.05830320793693,40.60605],[-74.05916923334071,40.60455],[-74.06090128414829,40.60455],[-74.06176730955207,40.60305],[-74.06349936035964,40.60305],[-74.06436538576342,40.60155],[-74.066097436571,40.60155],[-74.06696346197478,40.60305],[-74.06869551278236,40.60305],[-74.06956153818614,40.60455],[-74.07129358899371,40.60455],[-74.07215961439749,40.60605],[-74.07389166520507,40.60605],[-74.07475769060885,40.60455]]],[[[-74.08514999545427,40.613550000000004],[-74.08688204626185,40.613550000000004],[-74.08774807166563,40.615050000000004],[-74.08688204626185,40.616550000000004],[-74.08774807166563,40.618050000000004],[-74.08688204626185,40.619550000000004],[-74.08774807166563,40.621050000000004],[-74.08688204626185,40.622550000000004],[-74.08774807166563,40.624050000000004],[-74.08688204626185,40.625550000000004],[-74.08514999545427,40.625550000000004],[-74.08428397005049,40.627050000000004],[-74.08255191924292,40.627050000000004],[-74.08168589383914,40.628550000000004],[-74.08255191924292,40.630050000000004],[-74.08168589383914,40.631550000000004],[-74.08255191924292,40.633050000000004],[-74.08428397005049,40.633050000000004],[-74.08514999545427,40.634550000000004],[-74.08428397005049,40.636050000000004],[-74.08255191924292,40.636050000000004],[-74.08168589383914,40.637550000000005],[-74.07995384303156,40.637550000000005],[-74.07908781762778,40.639050000000005],[-74.0773557668202,40.639050000000005],[-74.07648974141642,40.637550000000005],[-74.07475769060885,40.637550000000005],[-74.07389166520507,40.636050000000004],[-74.07215961439749,40.636050000000004],[-74.07129358899371,40.634550000000004],[-74.07215961439749,40.633050000000004],[-74.07129358899371,40.631550000000004],[-74.07215961439749,40.630050000000004],[-74.07129358899371,40.628550000000004],[-74.07215961439749,40.627050000000004],[-74.07129358899371,40.625550000000004],[-74.07215961439749,40.624050000000004],[-74.07389166520507,40.624050000000004],[-74.07475769060885,40.622550000000004],[-74.07648974141642,40.622550000000004],[-74.0773557668202,40.621050000000004],[-74.07648974141642,40.619550000000004],[-74.0773557668202,40.618050000000004],[-74.07908781762778,40.618050000000004],[-74.07995384303156,40.616550000000004],[-74.08168589383914,40.616550000000004],[-74.08255191924292,40.615050000000004],[-74.08428397005049,40.615050000000004],[-74.08514999545427,40.613550000000004]]]],"type":"MultiPolygon"}},{"id":"144","properties":{"borough":"staten island","borocode":5,"neighborhood":"Rossville-Woodrow"},"type":"Feature","geometry":{"coordinates":[[[-74.2020634249653,40.52505],[-74.20379547577288,40.52505],[-74.20466150117666,40.52655],[-74.20639355198423,40.52655],[-74.20725957738802,40.52505],[-74.20899162819559,40.52505],[-74.20985765359937,40.52355],[-74.21158970440695,40.52355],[-74.21245572981073,40.52505],[-74.2141877806183,40.52505],[-74.21505380602208,40.52655],[-74.21678585682966,40.52655],[-74.21765188223344,40.52805],[-74.21678585682966,40.52955],[-74.21765188223344,40.53105],[-74.21678585682966,40.53255],[-74.21765188223344,40.53405],[-74.21678585682966,40.53555],[-74.21765188223344,40.53705],[-74.21678585682966,40.53855],[-74.21765188223344,40.54005],[-74.21678585682966,40.54155],[-74.21765188223344,40.54305],[-74.21938393304102,40.54305],[-74.2202499584448,40.54455],[-74.21938393304102,40.54605],[-74.2202499584448,40.54755],[-74.21938393304102,40.54905],[-74.2202499584448,40.55055],[-74.22198200925237,40.55055],[-74.22284803465615,40.55205],[-74.22198200925237,40.55355],[-74.2202499584448,40.55355],[-74.21938393304102,40.55505],[-74.21765188223344,40.55505],[-74.21678585682966,40.55655],[-74.21505380602208,40.55655],[-74.2141877806183,40.55805],[-74.21245572981073,40.55805],[-74.21158970440695,40.55955],[-74.20985765359937,40.55955],[-74.20899162819559,40.55805],[-74.20725957738802,40.55805],[-74.20639355198423,40.55655],[-74.20466150117666,40.55655],[-74.20379547577288,40.55505],[-74.20466150117666,40.55355],[-74.20379547577288,40.55205],[-74.2020634249653,40.55205],[-74.20119739956152,40.55055],[-74.2020634249653,40.54905],[-74.20119739956152,40.54755],[-74.19946534875395,40.54755],[-74.19859932335017,40.54605],[-74.19946534875395,40.54455],[-74.19859932335017,40.54305],[-74.19686727254259,40.54305],[-74.19600124713881,40.54155],[-74.19686727254259,40.54005],[-74.19600124713881,40.53855],[-74.19426919633123,40.53855],[-74.19340317092745,40.53705],[-74.19426919633123,40.53555],[-74.19340317092745,40.53405],[-74.19167112011988,40.53405],[-74.1908050947161,40.53255],[-74.19167112011988,40.53105],[-74.19340317092745,40.53105],[-74.19426919633123,40.52955],[-74.19600124713881,40.52955],[-74.19686727254259,40.52805],[-74.19859932335017,40.52805],[-74.19946534875395,40.52655],[-74.20119739956152,40.52655],[-74.2020634249653,40.52505]]],"type":"Polygon"}},{"id":"2","properties":{"borough":"staten island","borocode":5,"neighborhood":"Annadale-Huguenot-Prince's Bay-Eltingville"},"type":"Feature","geometry":{"coordinates":[[[-74.16569035800632,40.52205],[-74.16742240881389,40.52205],[-74.16828843421767,40.52355],[-74.17002048502525,40.52355],[-74.17088651042903,40.52205],[-74.1726185612366,40.52205],[-74.17348458664038,40.52055],[-74.17521663744796,40.52055],[-74.17608266285174,40.51905],[-74.17781471365932,40.51905],[-74.1786807390631,40.52055],[-74.18041278987067,40.52055],[-74.18127881527445,40.51905],[-74.18301086608203,40.51905],[-74.18387689148581,40.51755],[-74.18560894229338,40.51755],[-74.18647496769717,40.51905],[-74.18820701850474,40.51905],[-74.18907304390852,40.52055],[-74.1908050947161,40.52055],[-74.19167112011988,40.51905],[-74.1908050947161,40.51755],[-74.19167112011988,40.51605],[-74.1908050947161,40.51455],[-74.19167112011988,40.51305],[-74.1908050947161,40.51155],[-74.19167112011988,40.51005],[-74.19340317092745,40.51005],[-74.19426919633123,40.51155],[-74.19600124713881,40.51155],[-74.19686727254259,40.51005],[-74.19859932335017,40.51005],[-74.19946534875395,40.51155],[-74.20119739956152,40.51155],[-74.2020634249653,40.51005],[-74.20379547577288,40.51005],[-74.20466150117666,40.51155],[-74.20639355198423,40.51155],[-74.20725957738802,40.51005],[-74.20899162819559,40.51005],[-74.20985765359937,40.51155],[-74.21158970440695,40.51155],[-74.21245572981073,40.51305],[-74.2141877806183,40.51305],[-74.21505380602208,40.51155],[-74.21678585682966,40.51155],[-74.21765188223344,40.51305],[-74.21938393304102,40.51305],[-74.2202499584448,40.51455],[-74.21938393304102,40.51605],[-74.2202499584448,40.51755],[-74.21938393304102,40.51905],[-74.21765188223344,40.51905],[-74.21678585682966,40.52055],[-74.21505380602208,40.52055],[-74.2141877806183,40.52205],[-74.21245572981073,40.52205],[-74.21158970440695,40.52355],[-74.20985765359937,40.52355],[-74.20899162819559,40.52505],[-74.20725957738802,40.52505],[-74.20639355198423,40.52655],[-74.20466150117666,40.52655],[-74.20379547577288,40.52505],[-74.2020634249653,40.52505],[-74.20119739956152,40.52655],[-74.19946534875395,40.52655],[-74.19859932335017,40.52805],[-74.19686727254259,40.52805],[-74.19600124713881,40.52955],[-74.19426919633123,40.52955],[-74.19340317092745,40.53105],[-74.19167112011988,40.53105],[-74.1908050947161,40.53255],[-74.19167112011988,40.53405],[-74.1908050947161,40.53555],[-74.18907304390852,40.53555],[-74.18820701850474,40.53705],[-74.18907304390852,40.53855],[-74.18820701850474,40.54005],[-74.18647496769717,40.54005],[-74.18560894229338,40.54155],[-74.18387689148581,40.54155],[-74.18301086608203,40.54305],[-74.18387689148581,40.54455],[-74.18301086608203,40.54605],[-74.18127881527445,40.54605],[-74.18041278987067,40.54755],[-74.1786807390631,40.54755],[-74.17781471365932,40.54905],[-74.1786807390631,40.55055],[-74.17781471365932,40.55205],[-74.17608266285174,40.55205],[-74.17521663744796,40.55355],[-74.17608266285174,40.55505],[-74.17521663744796,40.55655],[-74.17348458664038,40.55655],[-74.1726185612366,40.55805],[-74.17348458664038,40.55955],[-74.1726185612366,40.56105],[-74.17088651042903,40.56105],[-74.17002048502525,40.55955],[-74.17088651042903,40.55805],[-74.17002048502525,40.55655],[-74.16828843421767,40.55655],[-74.16742240881389,40.55505],[-74.16828843421767,40.55355],[-74.16742240881389,40.55205],[-74.16828843421767,40.55055],[-74.16742240881389,40.54905],[-74.16828843421767,40.54755],[-74.16742240881389,40.54605],[-74.16569035800632,40.54605],[-74.16482433260254,40.54455],[-74.16309228179496,40.54455],[-74.16222625639118,40.54305],[-74.16309228179496,40.54155],[-74.16222625639118,40.54005],[-74.1604942055836,40.54005],[-74.15962818017982,40.53855],[-74.15789612937225,40.53855],[-74.15703010396847,40.53705],[-74.15789612937225,40.53555],[-74.15703010396847,40.53405],[-74.15529805316089,40.53405],[-74.15443202775711,40.53255],[-74.15529805316089,40.53105],[-74.15703010396847,40.53105],[-74.15789612937225,40.52955],[-74.15962818017982,40.52955],[-74.1604942055836,40.52805],[-74.15962818017982,40.52655],[-74.1604942055836,40.52505],[-74.16222625639118,40.52505],[-74.16309228179496,40.52355],[-74.16482433260254,40.52355],[-74.16569035800632,40.52205]]],"type":"Polygon"}},{"id":"9","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Bay Ridge"},"type":"Feature","geometry":{"coordinates":[[[-74.02972436961201,40.60755],[-74.03059039501579,40.60905],[-74.03232244582337,40.60905],[-74.03318847122715,40.61055],[-74.03492052203472,40.61055],[-74.0357865474385,40.61205],[-74.03751859824608,40.61205],[-74.03838462364986,40.613550000000004],[-74.03751859824608,40.615050000000004],[-74.03838462364986,40.616550000000004],[-74.04011667445744,40.616550000000004],[-74.04098269986122,40.618050000000004],[-74.04011667445744,40.619550000000004],[-74.04098269986122,40.621050000000004],[-74.0427147506688,40.621050000000004],[-74.04358077607257,40.622550000000004],[-74.0427147506688,40.624050000000004],[-74.04358077607257,40.625550000000004],[-74.0427147506688,40.627050000000004],[-74.04098269986122,40.627050000000004],[-74.04011667445744,40.628550000000004],[-74.04098269986122,40.630050000000004],[-74.04011667445744,40.631550000000004],[-74.03838462364986,40.631550000000004],[-74.03751859824608,40.633050000000004],[-74.03838462364986,40.634550000000004],[-74.03751859824608,40.636050000000004],[-74.03838462364986,40.637550000000005],[-74.03751859824608,40.639050000000005],[-74.03838462364986,40.640550000000005],[-74.03751859824608,40.642050000000005],[-74.0357865474385,40.642050000000005],[-74.03492052203472,40.643550000000005],[-74.03318847122715,40.643550000000005],[-74.03232244582337,40.645050000000005],[-74.03059039501579,40.645050000000005],[-74.02972436961201,40.643550000000005],[-74.02799231880444,40.643550000000005],[-74.02712629340066,40.642050000000005],[-74.02799231880444,40.640550000000005],[-74.02712629340066,40.639050000000005],[-74.02539424259308,40.639050000000005],[-74.0245282171893,40.640550000000005],[-74.02279616638172,40.640550000000005],[-74.02193014097794,40.639050000000005],[-74.02279616638172,40.637550000000005],[-74.02193014097794,40.636050000000004],[-74.02019809017037,40.636050000000004],[-74.01933206476659,40.637550000000005],[-74.01760001395901,40.637550000000005],[-74.01673398855523,40.636050000000004],[-74.01760001395901,40.634550000000004],[-74.01673398855523,40.633050000000004],[-74.01760001395901,40.631550000000004],[-74.01673398855523,40.630050000000004],[-74.01760001395901,40.628550000000004],[-74.01673398855523,40.627050000000004],[-74.01760001395901,40.625550000000004],[-74.01933206476659,40.625550000000004],[-74.02019809017037,40.624050000000004],[-74.01933206476659,40.622550000000004],[-74.02019809017037,40.621050000000004],[-74.02193014097794,40.621050000000004],[-74.02279616638172,40.619550000000004],[-74.0245282171893,40.619550000000004],[-74.02539424259308,40.618050000000004],[-74.0245282171893,40.616550000000004],[-74.02539424259308,40.615050000000004],[-74.02712629340066,40.615050000000004],[-74.02799231880444,40.613550000000004],[-74.02712629340066,40.61205],[-74.02799231880444,40.61055],[-74.02712629340066,40.60905],[-74.02799231880444,40.60755],[-74.02972436961201,40.60755]]],"type":"Polygon"}},{"id":"45","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Dyker Heights"},"type":"Feature","geometry":{"coordinates":[[[-74.0245282171893,40.60755],[-74.02539424259308,40.60905],[-74.02712629340066,40.60905],[-74.02799231880444,40.61055],[-74.02712629340066,40.61205],[-74.02799231880444,40.613550000000004],[-74.02712629340066,40.615050000000004],[-74.02539424259308,40.615050000000004],[-74.0245282171893,40.616550000000004],[-74.02539424259308,40.618050000000004],[-74.0245282171893,40.619550000000004],[-74.02279616638172,40.619550000000004],[-74.02193014097794,40.621050000000004],[-74.02019809017037,40.621050000000004],[-74.01933206476659,40.622550000000004],[-74.02019809017037,40.624050000000004],[-74.01933206476659,40.625550000000004],[-74.01760001395901,40.625550000000004],[-74.01673398855523,40.627050000000004],[-74.01760001395901,40.628550000000004],[-74.01673398855523,40.630050000000004],[-74.01760001395901,40.631550000000004],[-74.01673398855523,40.633050000000004],[-74.01500193774766,40.633050000000004],[-74.01413591234387,40.631550000000004],[-74.0124038615363,40.631550000000004],[-74.01153783613252,40.630050000000004],[-74.00980578532494,40.630050000000004],[-74.00893975992116,40.631550000000004],[-74.00720770911359,40.631550000000004],[-74.0063416837098,40.633050000000004],[-74.00460963290223,40.633050000000004],[-74.00374360749845,40.631550000000004],[-74.00201155669087,40.631550000000004],[-74.0011455312871,40.630050000000004],[-74.00201155669087,40.628550000000004],[-74.0011455312871,40.627050000000004],[-73.99941348047952,40.627050000000004],[-73.99854745507574,40.625550000000004],[-73.99941348047952,40.624050000000004],[-74.0011455312871,40.624050000000004],[-74.00201155669087,40.622550000000004],[-74.00374360749845,40.622550000000004],[-74.00460963290223,40.621050000000004],[-74.00374360749845,40.619550000000004],[-74.00460963290223,40.618050000000004],[-74.0063416837098,40.618050000000004],[-74.00720770911359,40.616550000000004],[-74.00893975992116,40.616550000000004],[-74.00980578532494,40.615050000000004],[-74.00893975992116,40.613550000000004],[-74.00980578532494,40.61205],[-74.01153783613252,40.61205],[-74.0124038615363,40.613550000000004],[-74.01413591234387,40.613550000000004],[-74.01500193774766,40.61205],[-74.01673398855523,40.61205],[-74.01760001395901,40.613550000000004],[-74.01933206476659,40.613550000000004],[-74.02019809017037,40.615050000000004],[-74.02193014097794,40.615050000000004],[-74.02279616638172,40.613550000000004],[-74.02193014097794,40.61205],[-74.02279616638172,40.61055],[-74.02193014097794,40.60905],[-74.02279616638172,40.60755],[-74.0245282171893,40.60755]]],"type":"Polygon"}},{"id":"164","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Sunset Park West"},"type":"Feature","geometry":{"coordinates":[[[-74.02539424259308,40.639050000000005],[-74.02712629340066,40.639050000000005],[-74.02799231880444,40.640550000000005],[-74.02712629340066,40.642050000000005],[-74.02799231880444,40.643550000000005],[-74.02712629340066,40.645050000000005],[-74.02799231880444,40.646550000000005],[-74.02712629340066,40.648050000000005],[-74.02539424259308,40.648050000000005],[-74.0245282171893,40.649550000000005],[-74.02539424259308,40.651050000000005],[-74.0245282171893,40.652550000000005],[-74.02279616638172,40.652550000000005],[-74.02193014097794,40.651050000000005],[-74.02019809017037,40.651050000000005],[-74.01933206476659,40.652550000000005],[-74.01760001395901,40.652550000000005],[-74.01673398855523,40.654050000000005],[-74.01760001395901,40.655550000000005],[-74.01673398855523,40.657050000000005],[-74.01500193774766,40.657050000000005],[-74.01413591234387,40.658550000000005],[-74.0124038615363,40.658550000000005],[-74.01153783613252,40.660050000000005],[-74.00980578532494,40.660050000000005],[-74.00893975992116,40.658550000000005],[-74.00720770911359,40.658550000000005],[-74.0063416837098,40.660050000000005],[-74.00720770911359,40.661550000000005],[-74.0063416837098,40.663050000000005],[-74.00460963290223,40.663050000000005],[-74.00374360749845,40.661550000000005],[-74.00201155669087,40.661550000000005],[-74.0011455312871,40.663050000000005],[-74.00201155669087,40.664550000000006],[-74.0011455312871,40.666050000000006],[-73.99941348047952,40.666050000000006],[-73.99854745507574,40.667550000000006],[-73.99681540426816,40.667550000000006],[-73.99594937886438,40.666050000000006],[-73.99681540426816,40.664550000000006],[-73.99594937886438,40.663050000000005],[-73.9942173280568,40.663050000000005],[-73.99335130265302,40.661550000000005],[-73.99161925184545,40.661550000000005],[-73.99075322644167,40.660050000000005],[-73.9890211756341,40.660050000000005],[-73.98815515023031,40.658550000000005],[-73.9890211756341,40.657050000000005],[-73.99075322644167,40.657050000000005],[-73.99161925184545,40.655550000000005],[-73.99335130265302,40.655550000000005],[-73.9942173280568,40.657050000000005],[-73.99594937886438,40.657050000000005],[-73.99681540426816,40.655550000000005],[-73.99854745507574,40.655550000000005],[-73.99941348047952,40.654050000000005],[-74.0011455312871,40.654050000000005],[-74.00201155669087,40.652550000000005],[-74.00374360749845,40.652550000000005],[-74.00460963290223,40.651050000000005],[-74.00374360749845,40.649550000000005],[-74.00460963290223,40.648050000000005],[-74.0063416837098,40.648050000000005],[-74.00720770911359,40.646550000000005],[-74.00893975992116,40.646550000000005],[-74.00980578532494,40.645050000000005],[-74.01153783613252,40.645050000000005],[-74.0124038615363,40.643550000000005],[-74.01413591234387,40.643550000000005],[-74.01500193774766,40.642050000000005],[-74.01413591234387,40.640550000000005],[-74.01500193774766,40.639050000000005],[-74.01413591234387,40.637550000000005],[-74.01500193774766,40.636050000000004],[-74.01673398855523,40.636050000000004],[-74.01760001395901,40.637550000000005],[-74.01933206476659,40.637550000000005],[-74.02019809017037,40.636050000000004],[-74.02193014097794,40.636050000000004],[-74.02279616638172,40.637550000000005],[-74.02193014097794,40.639050000000005],[-74.02279616638172,40.640550000000005],[-74.0245282171893,40.640550000000005],[-74.02539424259308,40.639050000000005]]],"type":"Polygon"}},{"id":"7","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Bath Beach"},"type":"Feature","geometry":{"coordinates":[[[-74.00201155669087,40.59555],[-74.00374360749845,40.59555],[-74.00460963290223,40.59705],[-74.0063416837098,40.59705],[-74.00720770911359,40.59855],[-74.00893975992116,40.59855],[-74.00980578532494,40.60005],[-74.01153783613252,40.60005],[-74.0124038615363,40.60155],[-74.01413591234387,40.60155],[-74.01500193774766,40.60005],[-74.01673398855523,40.60005],[-74.01760001395901,40.60155],[-74.01933206476659,40.60155],[-74.02019809017037,40.60305],[-74.01933206476659,40.60455],[-74.02019809017037,40.60605],[-74.01933206476659,40.60755],[-74.01760001395901,40.60755],[-74.01673398855523,40.60905],[-74.01760001395901,40.61055],[-74.01673398855523,40.61205],[-74.01500193774766,40.61205],[-74.01413591234387,40.613550000000004],[-74.0124038615363,40.613550000000004],[-74.01153783613252,40.61205],[-74.00980578532494,40.61205],[-74.00893975992116,40.61055],[-74.00720770911359,40.61055],[-74.0063416837098,40.60905],[-74.00460963290223,40.60905],[-74.00374360749845,40.61055],[-74.00201155669087,40.61055],[-74.0011455312871,40.60905],[-74.00201155669087,40.60755],[-74.00374360749845,40.60755],[-74.00460963290223,40.60605],[-74.00374360749845,40.60455],[-74.00201155669087,40.60455],[-74.0011455312871,40.60305],[-73.99941348047952,40.60305],[-73.99854745507574,40.60155],[-73.99681540426816,40.60155],[-73.99594937886438,40.60005],[-73.99681540426816,40.59855],[-73.99854745507574,40.59855],[-73.99941348047952,40.59705],[-74.0011455312871,40.59705],[-74.00201155669087,40.59555]]],"type":"Polygon"}},{"id":"8","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Battery Park City-Lower Manhattan"},"type":"Feature","geometry":{"coordinates":[[[-74.00980578532494,40.69905000000001],[-74.01153783613252,40.69905000000001],[-74.0124038615363,40.70055000000001],[-74.01413591234387,40.70055000000001],[-74.01500193774766,40.70205000000001],[-74.01673398855523,40.70205000000001],[-74.01760001395901,40.70355000000001],[-74.01933206476659,40.70355000000001],[-74.02019809017037,40.70505000000001],[-74.01933206476659,40.70655000000001],[-74.02019809017037,40.70805000000001],[-74.01933206476659,40.70955000000001],[-74.02019809017037,40.71105000000001],[-74.01933206476659,40.71255000000001],[-74.02019809017037,40.71405000000001],[-74.01933206476659,40.71555000000001],[-74.01760001395901,40.71555000000001],[-74.01673398855523,40.71705000000001],[-74.01760001395901,40.71855000000001],[-74.01673398855523,40.72005000000001],[-74.01500193774766,40.72005000000001],[-74.01413591234387,40.71855000000001],[-74.0124038615363,40.71855000000001],[-74.01153783613252,40.71705000000001],[-74.0124038615363,40.71555000000001],[-74.01413591234387,40.71555000000001],[-74.01500193774766,40.71405000000001],[-74.01413591234387,40.71255000000001],[-74.0124038615363,40.71255000000001],[-74.01153783613252,40.71105000000001],[-74.00980578532494,40.71105000000001],[-74.00893975992116,40.71255000000001],[-74.00720770911359,40.71255000000001],[-74.0063416837098,40.71405000000001],[-74.00460963290223,40.71405000000001],[-74.00374360749845,40.71255000000001],[-74.00201155669087,40.71255000000001],[-74.0011455312871,40.71105000000001],[-73.99941348047952,40.71105000000001],[-73.99854745507574,40.70955000000001],[-73.99941348047952,40.70805000000001],[-73.99854745507574,40.70655000000001],[-73.99941348047952,40.70505000000001],[-74.0011455312871,40.70505000000001],[-74.00201155669087,40.70355000000001],[-74.00374360749845,40.70355000000001],[-74.00460963290223,40.70205000000001],[-74.0063416837098,40.70205000000001],[-74.00720770911359,40.70055000000001],[-74.00893975992116,40.70055000000001],[-74.00980578532494,40.69905000000001]]],"type":"Polygon"}},{"id":"163","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Sunset Park East"},"type":"Feature","geometry":{"coordinates":[[[-73.9942173280568,40.639050000000005],[-73.99594937886438,40.639050000000005],[-73.99681540426816,40.640550000000005],[-73.99854745507574,40.640550000000005],[-73.99941348047952,40.642050000000005],[-74.0011455312871,40.642050000000005],[-74.00201155669087,40.640550000000005],[-74.0011455312871,40.639050000000005],[-74.00201155669087,40.637550000000005],[-74.00374360749845,40.637550000000005],[-74.00460963290223,40.636050000000004],[-74.0063416837098,40.636050000000004],[-74.00720770911359,40.634550000000004],[-74.0063416837098,40.633050000000004],[-74.00720770911359,40.631550000000004],[-74.00893975992116,40.631550000000004],[-74.00980578532494,40.630050000000004],[-74.01153783613252,40.630050000000004],[-74.0124038615363,40.631550000000004],[-74.01413591234387,40.631550000000004],[-74.01500193774766,40.633050000000004],[-74.01673398855523,40.633050000000004],[-74.01760001395901,40.634550000000004],[-74.01673398855523,40.636050000000004],[-74.01500193774766,40.636050000000004],[-74.01413591234387,40.637550000000005],[-74.01500193774766,40.639050000000005],[-74.01413591234387,40.640550000000005],[-74.01500193774766,40.642050000000005],[-74.01413591234387,40.643550000000005],[-74.0124038615363,40.643550000000005],[-74.01153783613252,40.645050000000005],[-74.00980578532494,40.645050000000005],[-74.00893975992116,40.646550000000005],[-74.00720770911359,40.646550000000005],[-74.0063416837098,40.648050000000005],[-74.00460963290223,40.648050000000005],[-74.00374360749845,40.649550000000005],[-74.00460963290223,40.651050000000005],[-74.00374360749845,40.652550000000005],[-74.00201155669087,40.652550000000005],[-74.0011455312871,40.654050000000005],[-73.99941348047952,40.654050000000005],[-73.99854745507574,40.652550000000005],[-73.99681540426816,40.652550000000005],[-73.99594937886438,40.651050000000005],[-73.9942173280568,40.651050000000005],[-73.99335130265302,40.649550000000005],[-73.99161925184545,40.649550000000005],[-73.99075322644167,40.648050000000005],[-73.99161925184545,40.646550000000005],[-73.99075322644167,40.645050000000005],[-73.99161925184545,40.643550000000005],[-73.99075322644167,40.642050000000005],[-73.99161925184545,40.640550000000005],[-73.99335130265302,40.640550000000005],[-73.9942173280568,40.639050000000005]]],"type":"Polygon"}},{"id":"28","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Carroll Gardens-Columbia Street-Red Hook"},"type":"Feature","geometry":{"coordinates":[[[-74.00460963290223,40.666050000000006],[-74.0063416837098,40.666050000000006],[-74.00720770911359,40.667550000000006],[-74.00893975992116,40.667550000000006],[-74.00980578532494,40.669050000000006],[-74.01153783613252,40.669050000000006],[-74.0124038615363,40.670550000000006],[-74.01413591234387,40.670550000000006],[-74.01500193774766,40.672050000000006],[-74.01673398855523,40.672050000000006],[-74.01760001395901,40.673550000000006],[-74.01933206476659,40.673550000000006],[-74.02019809017037,40.675050000000006],[-74.01933206476659,40.676550000000006],[-74.02019809017037,40.678050000000006],[-74.01933206476659,40.679550000000006],[-74.02019809017037,40.681050000000006],[-74.01933206476659,40.682550000000006],[-74.01760001395901,40.682550000000006],[-74.01673398855523,40.681050000000006],[-74.01500193774766,40.681050000000006],[-74.01413591234387,40.682550000000006],[-74.0124038615363,40.682550000000006],[-74.01153783613252,40.684050000000006],[-74.00980578532494,40.684050000000006],[-74.00893975992116,40.685550000000006],[-74.00980578532494,40.687050000000006],[-74.00893975992116,40.688550000000006],[-74.00720770911359,40.688550000000006],[-74.0063416837098,40.687050000000006],[-74.00460963290223,40.687050000000006],[-74.00374360749845,40.688550000000006],[-74.00201155669087,40.688550000000006],[-74.0011455312871,40.69005000000001],[-73.99941348047952,40.69005000000001],[-73.99854745507574,40.69155000000001],[-73.99681540426816,40.69155000000001],[-73.99594937886438,40.69005000000001],[-73.9942173280568,40.69005000000001],[-73.99335130265302,40.688550000000006],[-73.9942173280568,40.687050000000006],[-73.99335130265302,40.685550000000006],[-73.9942173280568,40.684050000000006],[-73.99335130265302,40.682550000000006],[-73.99161925184545,40.682550000000006],[-73.99075322644167,40.684050000000006],[-73.9890211756341,40.684050000000006],[-73.98815515023031,40.682550000000006],[-73.9890211756341,40.681050000000006],[-73.98815515023031,40.679550000000006],[-73.9890211756341,40.678050000000006],[-73.99075322644167,40.678050000000006],[-73.99161925184545,40.676550000000006],[-73.99335130265302,40.676550000000006],[-73.9942173280568,40.675050000000006],[-73.99594937886438,40.675050000000006],[-73.99681540426816,40.673550000000006],[-73.99854745507574,40.673550000000006],[-73.99941348047952,40.672050000000006],[-73.99854745507574,40.670550000000006],[-73.99941348047952,40.669050000000006],[-73.99854745507574,40.667550000000006],[-73.99941348047952,40.666050000000006],[-74.0011455312871,40.666050000000006],[-74.00201155669087,40.667550000000006],[-74.00374360749845,40.667550000000006],[-74.00460963290223,40.666050000000006]]],"type":"Polygon"}},{"id":"147","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Seagate-Coney Island"},"type":"Feature","geometry":{"coordinates":[[[-74.00720770911359,40.57155],[-74.00893975992116,40.57155],[-74.00980578532494,40.57305],[-74.01153783613252,40.57305],[-74.0124038615363,40.57455],[-74.01413591234387,40.57455],[-74.01500193774766,40.57605],[-74.01413591234387,40.57755],[-74.01500193774766,40.57905],[-74.01413591234387,40.58055],[-74.0124038615363,40.58055],[-74.01153783613252,40.58205],[-74.00980578532494,40.58205],[-74.00893975992116,40.58355],[-74.00720770911359,40.58355],[-74.0063416837098,40.58205],[-74.00460963290223,40.58205],[-74.00374360749845,40.58355],[-74.00201155669087,40.58355],[-74.0011455312871,40.58205],[-73.99941348047952,40.58205],[-73.99854745507574,40.58055],[-73.99681540426816,40.58055],[-73.99594937886438,40.57905],[-73.9942173280568,40.57905],[-73.99335130265302,40.58055],[-73.99161925184545,40.58055],[-73.99075322644167,40.58205],[-73.99161925184545,40.58355],[-73.99075322644167,40.58505],[-73.9890211756341,40.58505],[-73.98815515023031,40.58355],[-73.98642309942274,40.58355],[-73.98555707401896,40.58205],[-73.98382502321138,40.58205],[-73.9829589978076,40.58355],[-73.98122694700002,40.58355],[-73.98036092159624,40.58505],[-73.97862887078867,40.58505],[-73.97776284538489,40.58355],[-73.97603079457731,40.58355],[-73.97516476917353,40.58205],[-73.97603079457731,40.58055],[-73.97776284538489,40.58055],[-73.97862887078867,40.57905],[-73.98036092159624,40.57905],[-73.98122694700002,40.57755],[-73.98036092159624,40.57605],[-73.97862887078867,40.57605],[-73.97776284538489,40.57455],[-73.97603079457731,40.57455],[-73.97516476917353,40.57605],[-73.97343271836596,40.57605],[-73.97256669296218,40.57455],[-73.9708346421546,40.57455],[-73.96996861675082,40.57305],[-73.9708346421546,40.57155],[-73.97256669296218,40.57155],[-73.97343271836596,40.57305],[-73.97516476917353,40.57305],[-73.97603079457731,40.57155],[-73.97776284538489,40.57155],[-73.97862887078867,40.57305],[-73.98036092159624,40.57305],[-73.98122694700002,40.57155],[-73.9829589978076,40.57155],[-73.98382502321138,40.57005],[-73.98555707401896,40.57005],[-73.98642309942274,40.57155],[-73.98815515023031,40.57155],[-73.9890211756341,40.57005],[-73.99075322644167,40.57005],[-73.99161925184545,40.57155],[-73.99335130265302,40.57155],[-73.9942173280568,40.57005],[-73.99594937886438,40.57005],[-73.99681540426816,40.57155],[-73.99854745507574,40.57155],[-73.99941348047952,40.57005],[-74.0011455312871,40.57005],[-74.00201155669087,40.57155],[-74.00374360749845,40.57155],[-74.00460963290223,40.57305],[-74.0063416837098,40.57305],[-74.00720770911359,40.57155]]],"type":"Polygon"}},{"id":"149","properties":{"borough":"manhattan","borocode":1,"neighborhood":"SoHo-TriBeCa-Civic Center-Little Italy"},"type":"Feature","geometry":{"coordinates":[[[-73.99681540426816,40.71555000000001],[-73.99854745507574,40.71555000000001],[-73.99941348047952,40.71705000000001],[-74.0011455312871,40.71705000000001],[-74.00201155669087,40.71555000000001],[-74.00374360749845,40.71555000000001],[-74.00460963290223,40.71405000000001],[-74.0063416837098,40.71405000000001],[-74.00720770911359,40.71255000000001],[-74.00893975992116,40.71255000000001],[-74.00980578532494,40.71105000000001],[-74.01153783613252,40.71105000000001],[-74.0124038615363,40.71255000000001],[-74.01413591234387,40.71255000000001],[-74.01500193774766,40.71405000000001],[-74.01413591234387,40.71555000000001],[-74.0124038615363,40.71555000000001],[-74.01153783613252,40.71705000000001],[-74.0124038615363,40.71855000000001],[-74.01413591234387,40.71855000000001],[-74.01500193774766,40.72005000000001],[-74.01413591234387,40.72155000000001],[-74.0124038615363,40.72155000000001],[-74.01153783613252,40.72305000000001],[-74.0124038615363,40.72455000000001],[-74.01153783613252,40.72605000000001],[-74.0124038615363,40.72755000000001],[-74.01153783613252,40.72905000000001],[-74.00980578532494,40.72905000000001],[-74.00893975992116,40.72755000000001],[-74.00720770911359,40.72755000000001],[-74.0063416837098,40.72905000000001],[-74.00460963290223,40.72905000000001],[-74.00374360749845,40.72755000000001],[-74.00201155669087,40.72755000000001],[-74.0011455312871,40.72605000000001],[-73.99941348047952,40.72605000000001],[-73.99854745507574,40.72755000000001],[-73.99681540426816,40.72755000000001],[-73.99594937886438,40.72605000000001],[-73.9942173280568,40.72605000000001],[-73.99335130265302,40.72455000000001],[-73.99161925184545,40.72455000000001],[-73.99075322644167,40.72305000000001],[-73.99161925184545,40.72155000000001],[-73.99335130265302,40.72155000000001],[-73.9942173280568,40.72005000000001],[-73.99335130265302,40.71855000000001],[-73.9942173280568,40.71705000000001],[-73.99594937886438,40.71705000000001],[-73.99681540426816,40.71555000000001]]],"type":"Polygon"}},{"id":"178","properties":{"borough":"manhattan","borocode":1,"neighborhood":"West Village"},"type":"Feature","geometry":{"coordinates":[[[-73.99161925184545,40.72455000000001],[-73.99335130265302,40.72455000000001],[-73.9942173280568,40.72605000000001],[-73.99594937886438,40.72605000000001],[-73.99681540426816,40.72755000000001],[-73.99854745507574,40.72755000000001],[-73.99941348047952,40.72605000000001],[-74.0011455312871,40.72605000000001],[-74.00201155669087,40.72755000000001],[-74.00374360749845,40.72755000000001],[-74.00460963290223,40.72905000000001],[-74.0063416837098,40.72905000000001],[-74.00720770911359,40.72755000000001],[-74.00893975992116,40.72755000000001],[-74.00980578532494,40.72905000000001],[-74.01153783613252,40.72905000000001],[-74.0124038615363,40.73055000000001],[-74.01153783613252,40.73205000000001],[-74.0124038615363,40.73355000000001],[-74.01153783613252,40.73505000000001],[-74.0124038615363,40.73655000000001],[-74.01153783613252,40.73805000000001],[-74.0124038615363,40.73955000000001],[-74.01153783613252,40.74105000000001],[-74.00980578532494,40.74105000000001],[-74.00893975992116,40.74255000000001],[-74.00720770911359,40.74255000000001],[-74.0063416837098,40.74105000000001],[-74.00460963290223,40.74105000000001],[-74.00374360749845,40.73955000000001],[-74.00201155669087,40.73955000000001],[-74.0011455312871,40.73805000000001],[-73.99941348047952,40.73805000000001],[-73.99854745507574,40.73655000000001],[-73.99681540426816,40.73655000000001],[-73.99594937886438,40.73805000000001],[-73.9942173280568,40.73805000000001],[-73.99335130265302,40.73655000000001],[-73.99161925184545,40.73655000000001],[-73.99075322644167,40.73505000000001],[-73.9890211756341,40.73505000000001],[-73.98815515023031,40.73355000000001],[-73.9890211756341,40.73205000000001],[-73.99075322644167,40.73205000000001],[-73.99161925184545,40.73055000000001],[-73.99075322644167,40.72905000000001],[-73.99161925184545,40.72755000000001],[-73.99075322644167,40.72605000000001],[-73.99161925184545,40.72455000000001]]],"type":"Polygon"}},{"id":"16","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Bensonhurst West"},"type":"Feature","geometry":{"coordinates":[[[-73.99681540426816,40.59255],[-73.99854745507574,40.59255],[-73.99941348047952,40.59405],[-74.0011455312871,40.59405],[-74.00201155669087,40.59555],[-74.0011455312871,40.59705],[-73.99941348047952,40.59705],[-73.99854745507574,40.59855],[-73.99681540426816,40.59855],[-73.99594937886438,40.60005],[-73.99681540426816,40.60155],[-73.99854745507574,40.60155],[-73.99941348047952,40.60305],[-74.0011455312871,40.60305],[-74.00201155669087,40.60455],[-74.00374360749845,40.60455],[-74.00460963290223,40.60605],[-74.00374360749845,40.60755],[-74.00201155669087,40.60755],[-74.0011455312871,40.60905],[-74.00201155669087,40.61055],[-74.00374360749845,40.61055],[-74.00460963290223,40.60905],[-74.0063416837098,40.60905],[-74.00720770911359,40.61055],[-74.00893975992116,40.61055],[-74.00980578532494,40.61205],[-74.00893975992116,40.613550000000004],[-74.00980578532494,40.615050000000004],[-74.00893975992116,40.616550000000004],[-74.00720770911359,40.616550000000004],[-74.0063416837098,40.618050000000004],[-74.00460963290223,40.618050000000004],[-74.00374360749845,40.619550000000004],[-74.00460963290223,40.621050000000004],[-74.00374360749845,40.622550000000004],[-74.00201155669087,40.622550000000004],[-74.0011455312871,40.624050000000004],[-73.99941348047952,40.624050000000004],[-73.99854745507574,40.625550000000004],[-73.99681540426816,40.625550000000004],[-73.99594937886438,40.624050000000004],[-73.9942173280568,40.624050000000004],[-73.99335130265302,40.625550000000004],[-73.99161925184545,40.625550000000004],[-73.99075322644167,40.624050000000004],[-73.9890211756341,40.624050000000004],[-73.98815515023031,40.622550000000004],[-73.98642309942274,40.622550000000004],[-73.98555707401896,40.621050000000004],[-73.98642309942274,40.619550000000004],[-73.98555707401896,40.618050000000004],[-73.98382502321138,40.618050000000004],[-73.9829589978076,40.616550000000004],[-73.98122694700002,40.616550000000004],[-73.98036092159624,40.615050000000004],[-73.98122694700002,40.613550000000004],[-73.9829589978076,40.613550000000004],[-73.98382502321138,40.61205],[-73.9829589978076,40.61055],[-73.98382502321138,40.60905],[-73.98555707401896,40.60905],[-73.98642309942274,40.60755],[-73.98815515023031,40.60755],[-73.9890211756341,40.60605],[-73.98815515023031,40.60455],[-73.9890211756341,40.60305],[-73.99075322644167,40.60305],[-73.99161925184545,40.60155],[-73.99075322644167,40.60005],[-73.99161925184545,40.59855],[-73.99335130265302,40.59855],[-73.9942173280568,40.59705],[-73.99594937886438,40.59705],[-73.99681540426816,40.59555],[-73.99594937886438,40.59405],[-73.99681540426816,40.59255]]],"type":"Polygon"}},{"id":"84","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Hudson Yards-Chelsea-Flatiron-Union Square"},"type":"Feature","geometry":{"coordinates":[[[-73.9890211756341,40.73505000000001],[-73.99075322644167,40.73505000000001],[-73.99161925184545,40.73655000000001],[-73.99335130265302,40.73655000000001],[-73.9942173280568,40.73805000000001],[-73.99594937886438,40.73805000000001],[-73.99681540426816,40.73655000000001],[-73.99854745507574,40.73655000000001],[-73.99941348047952,40.73805000000001],[-74.0011455312871,40.73805000000001],[-74.00201155669087,40.73955000000001],[-74.00374360749845,40.73955000000001],[-74.00460963290223,40.74105000000001],[-74.0063416837098,40.74105000000001],[-74.00720770911359,40.74255000000001],[-74.00893975992116,40.74255000000001],[-74.00980578532494,40.74405000000001],[-74.00893975992116,40.74555000000001],[-74.00980578532494,40.74705000000001],[-74.00893975992116,40.74855000000001],[-74.00980578532494,40.75005000000001],[-74.00893975992116,40.75155000000001],[-74.00980578532494,40.75305000000001],[-74.00893975992116,40.75455000000001],[-74.00720770911359,40.75455000000001],[-74.0063416837098,40.75605000000001],[-74.00720770911359,40.75755000000001],[-74.0063416837098,40.75905000000001],[-74.00460963290223,40.75905000000001],[-74.00374360749845,40.76055000000001],[-74.00460963290223,40.76205000000001],[-74.00374360749845,40.76355000000001],[-74.00201155669087,40.76355000000001],[-74.0011455312871,40.76205000000001],[-73.99941348047952,40.76205000000001],[-73.99854745507574,40.76055000000001],[-73.99681540426816,40.76055000000001],[-73.99594937886438,40.75905000000001],[-73.99681540426816,40.75755000000001],[-73.99594937886438,40.75605000000001],[-73.9942173280568,40.75605000000001],[-73.99335130265302,40.75455000000001],[-73.9942173280568,40.75305000000001],[-73.99335130265302,40.75155000000001],[-73.9942173280568,40.75005000000001],[-73.99594937886438,40.75005000000001],[-73.99681540426816,40.74855000000001],[-73.99594937886438,40.74705000000001],[-73.9942173280568,40.74705000000001],[-73.99335130265302,40.74555000000001],[-73.99161925184545,40.74555000000001],[-73.99075322644167,40.74405000000001],[-73.9890211756341,40.74405000000001],[-73.98815515023031,40.74555000000001],[-73.98642309942274,40.74555000000001],[-73.98555707401896,40.74405000000001],[-73.98642309942274,40.74255000000001],[-73.98555707401896,40.74105000000001],[-73.98642309942274,40.73955000000001],[-73.98815515023031,40.73955000000001],[-73.9890211756341,40.73805000000001],[-73.98815515023031,40.73655000000001],[-73.9890211756341,40.73505000000001]]],"type":"Polygon"}},{"id":"17","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Borough Park"},"type":"Feature","geometry":{"coordinates":[[[-73.97603079457731,40.613550000000004],[-73.97776284538489,40.613550000000004],[-73.97862887078867,40.615050000000004],[-73.98036092159624,40.615050000000004],[-73.98122694700002,40.616550000000004],[-73.9829589978076,40.616550000000004],[-73.98382502321138,40.618050000000004],[-73.98555707401896,40.618050000000004],[-73.98642309942274,40.619550000000004],[-73.98555707401896,40.621050000000004],[-73.98642309942274,40.622550000000004],[-73.98815515023031,40.622550000000004],[-73.9890211756341,40.624050000000004],[-73.99075322644167,40.624050000000004],[-73.99161925184545,40.625550000000004],[-73.99335130265302,40.625550000000004],[-73.9942173280568,40.624050000000004],[-73.99594937886438,40.624050000000004],[-73.99681540426816,40.625550000000004],[-73.99854745507574,40.625550000000004],[-73.99941348047952,40.627050000000004],[-74.0011455312871,40.627050000000004],[-74.00201155669087,40.628550000000004],[-74.0011455312871,40.630050000000004],[-74.00201155669087,40.631550000000004],[-74.00374360749845,40.631550000000004],[-74.00460963290223,40.633050000000004],[-74.0063416837098,40.633050000000004],[-74.00720770911359,40.634550000000004],[-74.0063416837098,40.636050000000004],[-74.00460963290223,40.636050000000004],[-74.00374360749845,40.637550000000005],[-74.00201155669087,40.637550000000005],[-74.0011455312871,40.639050000000005],[-74.00201155669087,40.640550000000005],[-74.0011455312871,40.642050000000005],[-73.99941348047952,40.642050000000005],[-73.99854745507574,40.640550000000005],[-73.99681540426816,40.640550000000005],[-73.99594937886438,40.639050000000005],[-73.9942173280568,40.639050000000005],[-73.99335130265302,40.640550000000005],[-73.99161925184545,40.640550000000005],[-73.99075322644167,40.642050000000005],[-73.99161925184545,40.643550000000005],[-73.99075322644167,40.645050000000005],[-73.9890211756341,40.645050000000005],[-73.98815515023031,40.643550000000005],[-73.98642309942274,40.643550000000005],[-73.98555707401896,40.642050000000005],[-73.98382502321138,40.642050000000005],[-73.9829589978076,40.640550000000005],[-73.98122694700002,40.640550000000005],[-73.98036092159624,40.639050000000005],[-73.97862887078867,40.639050000000005],[-73.97776284538489,40.637550000000005],[-73.97862887078867,40.636050000000004],[-73.97776284538489,40.634550000000004],[-73.97603079457731,40.634550000000004],[-73.97516476917353,40.633050000000004],[-73.97603079457731,40.631550000000004],[-73.97516476917353,40.630050000000004],[-73.97603079457731,40.628550000000004],[-73.97516476917353,40.627050000000004],[-73.97603079457731,40.625550000000004],[-73.97516476917353,40.624050000000004],[-73.97603079457731,40.622550000000004],[-73.97516476917353,40.621050000000004],[-73.97603079457731,40.619550000000004],[-73.97516476917353,40.618050000000004],[-73.97603079457731,40.616550000000004],[-73.97516476917353,40.615050000000004],[-73.97603079457731,40.613550000000004]]],"type":"Polygon"}},{"id":"22","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Brooklyn Heights-Cobble Hill"},"type":"Feature","geometry":{"coordinates":[[[-73.99941348047952,40.69005000000001],[-74.0011455312871,40.69005000000001],[-74.00201155669087,40.69155000000001],[-74.0011455312871,40.69305000000001],[-74.00201155669087,40.69455000000001],[-74.0011455312871,40.69605000000001],[-74.00201155669087,40.69755000000001],[-74.0011455312871,40.69905000000001],[-73.99941348047952,40.69905000000001],[-73.99854745507574,40.70055000000001],[-73.99681540426816,40.70055000000001],[-73.99594937886438,40.70205000000001],[-73.99681540426816,40.70355000000001],[-73.99594937886438,40.70505000000001],[-73.9942173280568,40.70505000000001],[-73.99335130265302,40.70355000000001],[-73.99161925184545,40.70355000000001],[-73.99075322644167,40.70205000000001],[-73.99161925184545,40.70055000000001],[-73.99075322644167,40.69905000000001],[-73.99161925184545,40.69755000000001],[-73.99075322644167,40.69605000000001],[-73.9890211756341,40.69605000000001],[-73.98815515023031,40.69455000000001],[-73.9890211756341,40.69305000000001],[-73.98815515023031,40.69155000000001],[-73.9890211756341,40.69005000000001],[-73.99075322644167,40.69005000000001],[-73.99161925184545,40.688550000000006],[-73.99335130265302,40.688550000000006],[-73.9942173280568,40.69005000000001],[-73.99594937886438,40.69005000000001],[-73.99681540426816,40.69155000000001],[-73.99854745507574,40.69155000000001],[-73.99941348047952,40.69005000000001]]],"type":"Polygon"}},{"id":"34","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Clinton"},"type":"Feature","geometry":{"coordinates":[[[-73.99161925184545,40.75455000000001],[-73.99335130265302,40.75455000000001],[-73.9942173280568,40.75605000000001],[-73.99594937886438,40.75605000000001],[-73.99681540426816,40.75755000000001],[-73.99594937886438,40.75905000000001],[-73.99681540426816,40.76055000000001],[-73.99854745507574,40.76055000000001],[-73.99941348047952,40.76205000000001],[-74.0011455312871,40.76205000000001],[-74.00201155669087,40.76355000000001],[-74.0011455312871,40.76505000000001],[-73.99941348047952,40.76505000000001],[-73.99854745507574,40.76655000000001],[-73.99681540426816,40.76655000000001],[-73.99594937886438,40.76805000000001],[-73.99681540426816,40.76955000000001],[-73.99594937886438,40.77105000000001],[-73.99681540426816,40.77255000000001],[-73.99594937886438,40.77405000000001],[-73.9942173280568,40.77405000000001],[-73.99335130265302,40.77255000000001],[-73.99161925184545,40.77255000000001],[-73.99075322644167,40.77105000000001],[-73.9890211756341,40.77105000000001],[-73.98815515023031,40.76955000000001],[-73.98642309942274,40.76955000000001],[-73.98555707401896,40.76805000000001],[-73.98382502321138,40.76805000000001],[-73.9829589978076,40.76655000000001],[-73.98382502321138,40.76505000000001],[-73.98555707401896,40.76505000000001],[-73.98642309942274,40.76355000000001],[-73.98555707401896,40.76205000000001],[-73.98642309942274,40.76055000000001],[-73.98815515023031,40.76055000000001],[-73.9890211756341,40.75905000000001],[-73.98815515023031,40.75755000000001],[-73.9890211756341,40.75605000000001],[-73.99075322644167,40.75605000000001],[-73.99161925184545,40.75455000000001]]],"type":"Polygon"}},{"id":"32","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Chinatown"},"type":"Feature","geometry":{"coordinates":[[[-73.99681540426816,40.70655000000001],[-73.99854745507574,40.70655000000001],[-73.99941348047952,40.70805000000001],[-73.99854745507574,40.70955000000001],[-73.99941348047952,40.71105000000001],[-74.0011455312871,40.71105000000001],[-74.00201155669087,40.71255000000001],[-74.00374360749845,40.71255000000001],[-74.00460963290223,40.71405000000001],[-74.00374360749845,40.71555000000001],[-74.00201155669087,40.71555000000001],[-74.0011455312871,40.71705000000001],[-73.99941348047952,40.71705000000001],[-73.99854745507574,40.71555000000001],[-73.99681540426816,40.71555000000001],[-73.99594937886438,40.71705000000001],[-73.9942173280568,40.71705000000001],[-73.99335130265302,40.71855000000001],[-73.9942173280568,40.72005000000001],[-73.99335130265302,40.72155000000001],[-73.99161925184545,40.72155000000001],[-73.99075322644167,40.72305000000001],[-73.9890211756341,40.72305000000001],[-73.98815515023031,40.72155000000001],[-73.98642309942274,40.72155000000001],[-73.98555707401896,40.72305000000001],[-73.98382502321138,40.72305000000001],[-73.9829589978076,40.72155000000001],[-73.98382502321138,40.72005000000001],[-73.98555707401896,40.72005000000001],[-73.98642309942274,40.71855000000001],[-73.98815515023031,40.71855000000001],[-73.9890211756341,40.71705000000001],[-73.98815515023031,40.71555000000001],[-73.9890211756341,40.71405000000001],[-73.99075322644167,40.71405000000001],[-73.99161925184545,40.71255000000001],[-73.99075322644167,40.71105000000001],[-73.99161925184545,40.70955000000001],[-73.99335130265302,40.70955000000001],[-73.9942173280568,40.70805000000001],[-73.99594937886438,40.70805000000001],[-73.99681540426816,40.70655000000001]]],"type":"Polygon"}},{"id":"15","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Bensonhurst East"},"type":"Feature","geometry":{"coordinates":[[[-73.97603079457731,40.59555],[-73.97776284538489,40.59555],[-73.97862887078867,40.59705],[-73.98036092159624,40.59705],[-73.98122694700002,40.59555],[-73.98036092159624,40.59405],[-73.98122694700002,40.59255],[-73.9829589978076,40.59255],[-73.98382502321138,40.59405],[-73.98555707401896,40.59405],[-73.98642309942274,40.59255],[-73.98815515023031,40.59255],[-73.9890211756341,40.59105],[-73.99075322644167,40.59105],[-73.99161925184545,40.58955],[-73.99335130265302,40.58955],[-73.9942173280568,40.59105],[-73.99594937886438,40.59105],[-73.99681540426816,40.58955],[-73.99854745507574,40.58955],[-73.99941348047952,40.59105],[-73.99854745507574,40.59255],[-73.99681540426816,40.59255],[-73.99594937886438,40.59405],[-73.99681540426816,40.59555],[-73.99594937886438,40.59705],[-73.9942173280568,40.59705],[-73.99335130265302,40.59855],[-73.99161925184545,40.59855],[-73.99075322644167,40.60005],[-73.99161925184545,40.60155],[-73.99075322644167,40.60305],[-73.9890211756341,40.60305],[-73.98815515023031,40.60455],[-73.9890211756341,40.60605],[-73.98815515023031,40.60755],[-73.98642309942274,40.60755],[-73.98555707401896,40.60905],[-73.98382502321138,40.60905],[-73.9829589978076,40.61055],[-73.98382502321138,40.61205],[-73.9829589978076,40.613550000000004],[-73.98122694700002,40.613550000000004],[-73.98036092159624,40.615050000000004],[-73.97862887078867,40.615050000000004],[-73.97776284538489,40.613550000000004],[-73.97603079457731,40.613550000000004],[-73.97516476917353,40.61205],[-73.97343271836596,40.61205],[-73.97256669296218,40.61055],[-73.97343271836596,40.60905],[-73.97256669296218,40.60755],[-73.97343271836596,40.60605],[-73.97256669296218,40.60455],[-73.97343271836596,40.60305],[-73.97256669296218,40.60155],[-73.97343271836596,40.60005],[-73.97256669296218,40.59855],[-73.97343271836596,40.59705],[-73.97516476917353,40.59705],[-73.97603079457731,40.59555]]],"type":"Polygon"}},{"id":"129","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Park Slope-Gowanus"},"type":"Feature","geometry":{"coordinates":[[[-73.97862887078867,40.660050000000005],[-73.98036092159624,40.660050000000005],[-73.98122694700002,40.661550000000005],[-73.9829589978076,40.661550000000005],[-73.98382502321138,40.660050000000005],[-73.98555707401896,40.660050000000005],[-73.98642309942274,40.658550000000005],[-73.98815515023031,40.658550000000005],[-73.9890211756341,40.660050000000005],[-73.99075322644167,40.660050000000005],[-73.99161925184545,40.661550000000005],[-73.99335130265302,40.661550000000005],[-73.9942173280568,40.663050000000005],[-73.99594937886438,40.663050000000005],[-73.99681540426816,40.664550000000006],[-73.99594937886438,40.666050000000006],[-73.99681540426816,40.667550000000006],[-73.99854745507574,40.667550000000006],[-73.99941348047952,40.669050000000006],[-73.99854745507574,40.670550000000006],[-73.99941348047952,40.672050000000006],[-73.99854745507574,40.673550000000006],[-73.99681540426816,40.673550000000006],[-73.99594937886438,40.675050000000006],[-73.9942173280568,40.675050000000006],[-73.99335130265302,40.676550000000006],[-73.99161925184545,40.676550000000006],[-73.99075322644167,40.678050000000006],[-73.9890211756341,40.678050000000006],[-73.98815515023031,40.679550000000006],[-73.98642309942274,40.679550000000006],[-73.98555707401896,40.681050000000006],[-73.98382502321138,40.681050000000006],[-73.9829589978076,40.679550000000006],[-73.98122694700002,40.679550000000006],[-73.98036092159624,40.681050000000006],[-73.98122694700002,40.682550000000006],[-73.98036092159624,40.684050000000006],[-73.97862887078867,40.684050000000006],[-73.97776284538489,40.685550000000006],[-73.97603079457731,40.685550000000006],[-73.97516476917353,40.684050000000006],[-73.97603079457731,40.682550000000006],[-73.97516476917353,40.681050000000006],[-73.97603079457731,40.679550000000006],[-73.97516476917353,40.678050000000006],[-73.97343271836596,40.678050000000006],[-73.97256669296218,40.676550000000006],[-73.9708346421546,40.676550000000006],[-73.96996861675082,40.675050000000006],[-73.9708346421546,40.673550000000006],[-73.96996861675082,40.672050000000006],[-73.9708346421546,40.670550000000006],[-73.96996861675082,40.669050000000006],[-73.9708346421546,40.667550000000006],[-73.97256669296218,40.667550000000006],[-73.97343271836596,40.666050000000006],[-73.97516476917353,40.666050000000006],[-73.97603079457731,40.664550000000006],[-73.97516476917353,40.663050000000005],[-73.97603079457731,40.661550000000005],[-73.97776284538489,40.661550000000005],[-73.97862887078867,40.660050000000005]]],"type":"Polygon"}},{"id":"107","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Midtown-Midtown South"},"type":"Feature","geometry":{"coordinates":[[[-73.98382502321138,40.74405000000001],[-73.98555707401896,40.74405000000001],[-73.98642309942274,40.74555000000001],[-73.98815515023031,40.74555000000001],[-73.9890211756341,40.74405000000001],[-73.99075322644167,40.74405000000001],[-73.99161925184545,40.74555000000001],[-73.99335130265302,40.74555000000001],[-73.9942173280568,40.74705000000001],[-73.99594937886438,40.74705000000001],[-73.99681540426816,40.74855000000001],[-73.99594937886438,40.75005000000001],[-73.9942173280568,40.75005000000001],[-73.99335130265302,40.75155000000001],[-73.9942173280568,40.75305000000001],[-73.99335130265302,40.75455000000001],[-73.99161925184545,40.75455000000001],[-73.99075322644167,40.75605000000001],[-73.9890211756341,40.75605000000001],[-73.98815515023031,40.75755000000001],[-73.9890211756341,40.75905000000001],[-73.98815515023031,40.76055000000001],[-73.98642309942274,40.76055000000001],[-73.98555707401896,40.76205000000001],[-73.98642309942274,40.76355000000001],[-73.98555707401896,40.76505000000001],[-73.98382502321138,40.76505000000001],[-73.9829589978076,40.76655000000001],[-73.98122694700002,40.76655000000001],[-73.98036092159624,40.76805000000001],[-73.97862887078867,40.76805000000001],[-73.97776284538489,40.76655000000001],[-73.97603079457731,40.76655000000001],[-73.97516476917353,40.76805000000001],[-73.97343271836596,40.76805000000001],[-73.97256669296218,40.76655000000001],[-73.97343271836596,40.76505000000001],[-73.97256669296218,40.76355000000001],[-73.9708346421546,40.76355000000001],[-73.96996861675082,40.76205000000001],[-73.9708346421546,40.76055000000001],[-73.97256669296218,40.76055000000001],[-73.97343271836596,40.75905000000001],[-73.97256669296218,40.75755000000001],[-73.97343271836596,40.75605000000001],[-73.97516476917353,40.75605000000001],[-73.97603079457731,40.75455000000001],[-73.97776284538489,40.75455000000001],[-73.97862887078867,40.75305000000001],[-73.98036092159624,40.75305000000001],[-73.98122694700002,40.75155000000001],[-73.9829589978076,40.75155000000001],[-73.98382502321138,40.75005000000001],[-73.9829589978076,40.74855000000001],[-73.98122694700002,40.74855000000001],[-73.98036092159624,40.74705000000001],[-73.98122694700002,40.74555000000001],[-73.9829589978076,40.74555000000001],[-73.98382502321138,40.74405000000001]]],"type":"Polygon"}},{"id":"43","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"DUMBO-Vinegar Hill-Downtown Brooklyn-Boerum Hill"},"type":"Feature","geometry":{"coordinates":[[[-73.98122694700002,40.679550000000006],[-73.9829589978076,40.679550000000006],[-73.98382502321138,40.681050000000006],[-73.98555707401896,40.681050000000006],[-73.98642309942274,40.679550000000006],[-73.98815515023031,40.679550000000006],[-73.9890211756341,40.681050000000006],[-73.98815515023031,40.682550000000006],[-73.9890211756341,40.684050000000006],[-73.99075322644167,40.684050000000006],[-73.99161925184545,40.682550000000006],[-73.99335130265302,40.682550000000006],[-73.9942173280568,40.684050000000006],[-73.99335130265302,40.685550000000006],[-73.9942173280568,40.687050000000006],[-73.99335130265302,40.688550000000006],[-73.99161925184545,40.688550000000006],[-73.99075322644167,40.69005000000001],[-73.9890211756341,40.69005000000001],[-73.98815515023031,40.69155000000001],[-73.9890211756341,40.69305000000001],[-73.98815515023031,40.69455000000001],[-73.9890211756341,40.69605000000001],[-73.99075322644167,40.69605000000001],[-73.99161925184545,40.69755000000001],[-73.99075322644167,40.69905000000001],[-73.99161925184545,40.70055000000001],[-73.99075322644167,40.70205000000001],[-73.99161925184545,40.70355000000001],[-73.99335130265302,40.70355000000001],[-73.9942173280568,40.70505000000001],[-73.99335130265302,40.70655000000001],[-73.99161925184545,40.70655000000001],[-73.99075322644167,40.70505000000001],[-73.9890211756341,40.70505000000001],[-73.98815515023031,40.70655000000001],[-73.98642309942274,40.70655000000001],[-73.98555707401896,40.70505000000001],[-73.98382502321138,40.70505000000001],[-73.9829589978076,40.70655000000001],[-73.98122694700002,40.70655000000001],[-73.98036092159624,40.70805000000001],[-73.97862887078867,40.70805000000001],[-73.97776284538489,40.70655000000001],[-73.97862887078867,40.70505000000001],[-73.97776284538489,40.70355000000001],[-73.97862887078867,40.70205000000001],[-73.97776284538489,40.70055000000001],[-73.97862887078867,40.69905000000001],[-73.98036092159624,40.69905000000001],[-73.98122694700002,40.69755000000001],[-73.98036092159624,40.69605000000001],[-73.98122694700002,40.69455000000001],[-73.98036092159624,40.69305000000001],[-73.98122694700002,40.69155000000001],[-73.98036092159624,40.69005000000001],[-73.98122694700002,40.688550000000006],[-73.98036092159624,40.687050000000006],[-73.97862887078867,40.687050000000006],[-73.97776284538489,40.685550000000006],[-73.97862887078867,40.684050000000006],[-73.98036092159624,40.684050000000006],[-73.98122694700002,40.682550000000006],[-73.98036092159624,40.681050000000006],[-73.98122694700002,40.679550000000006]]],"type":"Polygon"}},{"id":"96","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Lincoln Square"},"type":"Feature","geometry":{"coordinates":[[[-73.98122694700002,40.76655000000001],[-73.9829589978076,40.76655000000001],[-73.98382502321138,40.76805000000001],[-73.98555707401896,40.76805000000001],[-73.98642309942274,40.76955000000001],[-73.98815515023031,40.76955000000001],[-73.9890211756341,40.77105000000001],[-73.99075322644167,40.77105000000001],[-73.99161925184545,40.77255000000001],[-73.99335130265302,40.77255000000001],[-73.9942173280568,40.77405000000001],[-73.99335130265302,40.77555000000001],[-73.99161925184545,40.77555000000001],[-73.99075322644167,40.77705000000001],[-73.99161925184545,40.77855000000001],[-73.99075322644167,40.78005000000001],[-73.9890211756341,40.78005000000001],[-73.98815515023031,40.78155000000001],[-73.98642309942274,40.78155000000001],[-73.98555707401896,40.78005000000001],[-73.98382502321138,40.78005000000001],[-73.9829589978076,40.78155000000001],[-73.98122694700002,40.78155000000001],[-73.98036092159624,40.78005000000001],[-73.97862887078867,40.78005000000001],[-73.97776284538489,40.77855000000001],[-73.97603079457731,40.77855000000001],[-73.97516476917353,40.77705000000001],[-73.97603079457731,40.77555000000001],[-73.97516476917353,40.77405000000001],[-73.97603079457731,40.77255000000001],[-73.97776284538489,40.77255000000001],[-73.97862887078867,40.77105000000001],[-73.97776284538489,40.76955000000001],[-73.97862887078867,40.76805000000001],[-73.98036092159624,40.76805000000001],[-73.98122694700002,40.76655000000001]]],"type":"Polygon"}},{"id":"75","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Gravesend"},"type":"Feature","geometry":{"coordinates":[[[-73.99594937886438,40.58205],[-73.99681540426816,40.58355],[-73.99854745507574,40.58355],[-73.99941348047952,40.58505],[-73.99854745507574,40.58655],[-73.99941348047952,40.58805],[-73.99854745507574,40.58955],[-73.99681540426816,40.58955],[-73.99594937886438,40.59105],[-73.9942173280568,40.59105],[-73.99335130265302,40.58955],[-73.99161925184545,40.58955],[-73.99075322644167,40.59105],[-73.9890211756341,40.59105],[-73.98815515023031,40.59255],[-73.98642309942274,40.59255],[-73.98555707401896,40.59405],[-73.98382502321138,40.59405],[-73.9829589978076,40.59255],[-73.98122694700002,40.59255],[-73.98036092159624,40.59405],[-73.98122694700002,40.59555],[-73.98036092159624,40.59705],[-73.97862887078867,40.59705],[-73.97776284538489,40.59555],[-73.97603079457731,40.59555],[-73.97516476917353,40.59705],[-73.97343271836596,40.59705],[-73.97256669296218,40.59555],[-73.9708346421546,40.59555],[-73.96996861675082,40.59405],[-73.9708346421546,40.59255],[-73.96996861675082,40.59105],[-73.96823656594324,40.59105],[-73.96737054053946,40.58955],[-73.96563848973189,40.58955],[-73.9647724643281,40.58805],[-73.96563848973189,40.58655],[-73.9647724643281,40.58505],[-73.96563848973189,40.58355],[-73.96737054053946,40.58355],[-73.96823656594324,40.58205],[-73.96996861675082,40.58205],[-73.9708346421546,40.58355],[-73.97256669296218,40.58355],[-73.97343271836596,40.58205],[-73.97516476917353,40.58205],[-73.97603079457731,40.58355],[-73.97516476917353,40.58505],[-73.97603079457731,40.58655],[-73.97516476917353,40.58805],[-73.97603079457731,40.58955],[-73.97776284538489,40.58955],[-73.97862887078867,40.58805],[-73.97776284538489,40.58655],[-73.97862887078867,40.58505],[-73.98036092159624,40.58505],[-73.98122694700002,40.58355],[-73.9829589978076,40.58355],[-73.98382502321138,40.58205],[-73.98555707401896,40.58205],[-73.98642309942274,40.58355],[-73.98815515023031,40.58355],[-73.9890211756341,40.58505],[-73.99075322644167,40.58505],[-73.99161925184545,40.58655],[-73.99335130265302,40.58655],[-73.9942173280568,40.58505],[-73.99335130265302,40.58355],[-73.9942173280568,40.58205],[-73.99594937886438,40.58205]]],"type":"Polygon"}},{"id":"99","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Lower East Side"},"type":"Feature","geometry":{"coordinates":[[[-73.98036092159624,40.70805000000001],[-73.98122694700002,40.70955000000001],[-73.9829589978076,40.70955000000001],[-73.98382502321138,40.70805000000001],[-73.98555707401896,40.70805000000001],[-73.98642309942274,40.70955000000001],[-73.98815515023031,40.70955000000001],[-73.9890211756341,40.70805000000001],[-73.99075322644167,40.70805000000001],[-73.99161925184545,40.70955000000001],[-73.99075322644167,40.71105000000001],[-73.99161925184545,40.71255000000001],[-73.99075322644167,40.71405000000001],[-73.9890211756341,40.71405000000001],[-73.98815515023031,40.71555000000001],[-73.9890211756341,40.71705000000001],[-73.98815515023031,40.71855000000001],[-73.98642309942274,40.71855000000001],[-73.98555707401896,40.72005000000001],[-73.98382502321138,40.72005000000001],[-73.9829589978076,40.72155000000001],[-73.98382502321138,40.72305000000001],[-73.9829589978076,40.72455000000001],[-73.98122694700002,40.72455000000001],[-73.98036092159624,40.72605000000001],[-73.97862887078867,40.72605000000001],[-73.97776284538489,40.72755000000001],[-73.97862887078867,40.72905000000001],[-73.97776284538489,40.73055000000001],[-73.97603079457731,40.73055000000001],[-73.97516476917353,40.72905000000001],[-73.97343271836596,40.72905000000001],[-73.97256669296218,40.72755000000001],[-73.9708346421546,40.72755000000001],[-73.96996861675082,40.72605000000001],[-73.9708346421546,40.72455000000001],[-73.97256669296218,40.72455000000001],[-73.97343271836596,40.72305000000001],[-73.97256669296218,40.72155000000001],[-73.97343271836596,40.72005000000001],[-73.97256669296218,40.71855000000001],[-73.97343271836596,40.71705000000001],[-73.97516476917353,40.71705000000001],[-73.97603079457731,40.71555000000001],[-73.97516476917353,40.71405000000001],[-73.97603079457731,40.71255000000001],[-73.97776284538489,40.71255000000001],[-73.97862887078867,40.71105000000001],[-73.97776284538489,40.70955000000001],[-73.97862887078867,40.70805000000001],[-73.98036092159624,40.70805000000001]]],"type":"Polygon"}},{"id":"55","properties":{"borough":"manhattan","borocode":1,"neighborhood":"East Village"},"type":"Feature","geometry":{"coordinates":[[[-73.98642309942274,40.72155000000001],[-73.98815515023031,40.72155000000001],[-73.9890211756341,40.72305000000001],[-73.99075322644167,40.72305000000001],[-73.99161925184545,40.72455000000001],[-73.99075322644167,40.72605000000001],[-73.99161925184545,40.72755000000001],[-73.99075322644167,40.72905000000001],[-73.99161925184545,40.73055000000001],[-73.99075322644167,40.73205000000001],[-73.9890211756341,40.73205000000001],[-73.98815515023031,40.73355000000001],[-73.98642309942274,40.73355000000001],[-73.98555707401896,40.73205000000001],[-73.98382502321138,40.73205000000001],[-73.9829589978076,40.73055000000001],[-73.98122694700002,40.73055000000001],[-73.98036092159624,40.73205000000001],[-73.97862887078867,40.73205000000001],[-73.97776284538489,40.73055000000001],[-73.97862887078867,40.72905000000001],[-73.97776284538489,40.72755000000001],[-73.97862887078867,40.72605000000001],[-73.98036092159624,40.72605000000001],[-73.98122694700002,40.72455000000001],[-73.9829589978076,40.72455000000001],[-73.98382502321138,40.72305000000001],[-73.98555707401896,40.72305000000001],[-73.98642309942274,40.72155000000001]]],"type":"Polygon"}},{"id":"90","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Kensington-Ocean Parkway"},"type":"Feature","geometry":{"coordinates":[[[-73.97343271836596,40.633050000000004],[-73.97516476917353,40.633050000000004],[-73.97603079457731,40.634550000000004],[-73.97776284538489,40.634550000000004],[-73.97862887078867,40.636050000000004],[-73.97776284538489,40.637550000000005],[-73.97862887078867,40.639050000000005],[-73.98036092159624,40.639050000000005],[-73.98122694700002,40.640550000000005],[-73.9829589978076,40.640550000000005],[-73.98382502321138,40.642050000000005],[-73.98555707401896,40.642050000000005],[-73.98642309942274,40.643550000000005],[-73.98815515023031,40.643550000000005],[-73.9890211756341,40.645050000000005],[-73.98815515023031,40.646550000000005],[-73.98642309942274,40.646550000000005],[-73.98555707401896,40.648050000000005],[-73.98382502321138,40.648050000000005],[-73.9829589978076,40.649550000000005],[-73.98122694700002,40.649550000000005],[-73.98036092159624,40.648050000000005],[-73.97862887078867,40.648050000000005],[-73.97776284538489,40.646550000000005],[-73.97603079457731,40.646550000000005],[-73.97516476917353,40.645050000000005],[-73.97343271836596,40.645050000000005],[-73.97256669296218,40.646550000000005],[-73.9708346421546,40.646550000000005],[-73.96996861675082,40.645050000000005],[-73.9708346421546,40.643550000000005],[-73.96996861675082,40.642050000000005],[-73.96823656594324,40.642050000000005],[-73.96737054053946,40.640550000000005],[-73.96823656594324,40.639050000000005],[-73.96737054053946,40.637550000000005],[-73.96823656594324,40.636050000000004],[-73.96996861675082,40.636050000000004],[-73.9708346421546,40.634550000000004],[-73.97256669296218,40.634550000000004],[-73.97343271836596,40.633050000000004]]],"type":"Polygon"}},{"id":"184","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Windsor Terrace"},"type":"Feature","geometry":{"coordinates":[[[-73.97343271836596,40.645050000000005],[-73.97516476917353,40.645050000000005],[-73.97603079457731,40.646550000000005],[-73.97776284538489,40.646550000000005],[-73.97862887078867,40.648050000000005],[-73.98036092159624,40.648050000000005],[-73.98122694700002,40.649550000000005],[-73.9829589978076,40.649550000000005],[-73.98382502321138,40.651050000000005],[-73.9829589978076,40.652550000000005],[-73.98382502321138,40.654050000000005],[-73.98555707401896,40.654050000000005],[-73.98642309942274,40.655550000000005],[-73.98815515023031,40.655550000000005],[-73.9890211756341,40.657050000000005],[-73.98815515023031,40.658550000000005],[-73.98642309942274,40.658550000000005],[-73.98555707401896,40.660050000000005],[-73.98382502321138,40.660050000000005],[-73.9829589978076,40.661550000000005],[-73.98122694700002,40.661550000000005],[-73.98036092159624,40.660050000000005],[-73.97862887078867,40.660050000000005],[-73.97776284538489,40.661550000000005],[-73.97603079457731,40.661550000000005],[-73.97516476917353,40.660050000000005],[-73.97343271836596,40.660050000000005],[-73.97256669296218,40.658550000000005],[-73.97343271836596,40.657050000000005],[-73.97256669296218,40.655550000000005],[-73.9708346421546,40.655550000000005],[-73.96996861675082,40.654050000000005],[-73.9708346421546,40.652550000000005],[-73.96996861675082,40.651050000000005],[-73.9708346421546,40.649550000000005],[-73.96996861675082,40.648050000000005],[-73.9708346421546,40.646550000000005],[-73.97256669296218,40.646550000000005],[-73.97343271836596,40.645050000000005]]],"type":"Polygon"}},{"id":"73","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Gramercy"},"type":"Feature","geometry":{"coordinates":[[[-73.98122694700002,40.73055000000001],[-73.9829589978076,40.73055000000001],[-73.98382502321138,40.73205000000001],[-73.98555707401896,40.73205000000001],[-73.98642309942274,40.73355000000001],[-73.98815515023031,40.73355000000001],[-73.9890211756341,40.73505000000001],[-73.98815515023031,40.73655000000001],[-73.9890211756341,40.73805000000001],[-73.98815515023031,40.73955000000001],[-73.98642309942274,40.73955000000001],[-73.98555707401896,40.74105000000001],[-73.98642309942274,40.74255000000001],[-73.98555707401896,40.74405000000001],[-73.98382502321138,40.74405000000001],[-73.9829589978076,40.74255000000001],[-73.98122694700002,40.74255000000001],[-73.98036092159624,40.74105000000001],[-73.98122694700002,40.73955000000001],[-73.98036092159624,40.73805000000001],[-73.97862887078867,40.73805000000001],[-73.97776284538489,40.73655000000001],[-73.97862887078867,40.73505000000001],[-73.97776284538489,40.73355000000001],[-73.97862887078867,40.73205000000001],[-73.98036092159624,40.73205000000001],[-73.98122694700002,40.73055000000001]]],"type":"Polygon"}},{"id":"169","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Upper West Side"},"type":"Feature","geometry":{"coordinates":[[[-73.98382502321138,40.78005000000001],[-73.98555707401896,40.78005000000001],[-73.98642309942274,40.78155000000001],[-73.98815515023031,40.78155000000001],[-73.9890211756341,40.78305000000001],[-73.98815515023031,40.78455000000001],[-73.98642309942274,40.78455000000001],[-73.98555707401896,40.78605000000001],[-73.98382502321138,40.78605000000001],[-73.9829589978076,40.78755000000001],[-73.98382502321138,40.78905000000001],[-73.9829589978076,40.79055000000001],[-73.98122694700002,40.79055000000001],[-73.98036092159624,40.79205000000001],[-73.98122694700002,40.79355000000001],[-73.98036092159624,40.79505000000001],[-73.97862887078867,40.79505000000001],[-73.97776284538489,40.79655000000001],[-73.97603079457731,40.79655000000001],[-73.97516476917353,40.79805000000001],[-73.97343271836596,40.79805000000001],[-73.97256669296218,40.79955000000001],[-73.97343271836596,40.80105000000001],[-73.97256669296218,40.80255000000001],[-73.9708346421546,40.80255000000001],[-73.96996861675082,40.80105000000001],[-73.96823656594324,40.80105000000001],[-73.96737054053946,40.79955000000001],[-73.96563848973189,40.79955000000001],[-73.9647724643281,40.80105000000001],[-73.96304041352053,40.80105000000001],[-73.96217438811675,40.79955000000001],[-73.96044233730917,40.79955000000001],[-73.9595763119054,40.79805000000001],[-73.96044233730917,40.79655000000001],[-73.9595763119054,40.79505000000001],[-73.96044233730917,40.79355000000001],[-73.96217438811675,40.79355000000001],[-73.96304041352053,40.79205000000001],[-73.96217438811675,40.79055000000001],[-73.96304041352053,40.78905000000001],[-73.9647724643281,40.78905000000001],[-73.96563848973189,40.78755000000001],[-73.96737054053946,40.78755000000001],[-73.96823656594324,40.78605000000001],[-73.96737054053946,40.78455000000001],[-73.96823656594324,40.78305000000001],[-73.96996861675082,40.78305000000001],[-73.9708346421546,40.78155000000001],[-73.96996861675082,40.78005000000001],[-73.9708346421546,40.77855000000001],[-73.97256669296218,40.77855000000001],[-73.97343271836596,40.77705000000001],[-73.97516476917353,40.77705000000001],[-73.97603079457731,40.77855000000001],[-73.97776284538489,40.77855000000001],[-73.97862887078867,40.78005000000001],[-73.98036092159624,40.78005000000001],[-73.98122694700002,40.78155000000001],[-73.9829589978076,40.78155000000001],[-73.98382502321138,40.78005000000001]]],"type":"Polygon"}},{"id":"3","properties":{"borough":"staten island","borocode":5,"neighborhood":"Arden Heights"},"type":"Feature","geometry":{"coordinates":[[[-74.19167112011988,40.53405],[-74.19340317092745,40.53405],[-74.19426919633123,40.53555],[-74.19340317092745,40.53705],[-74.19426919633123,40.53855],[-74.19600124713881,40.53855],[-74.19686727254259,40.54005],[-74.19600124713881,40.54155],[-74.19686727254259,40.54305],[-74.19859932335017,40.54305],[-74.19946534875395,40.54455],[-74.19859932335017,40.54605],[-74.19946534875395,40.54755],[-74.20119739956152,40.54755],[-74.2020634249653,40.54905],[-74.20119739956152,40.55055],[-74.2020634249653,40.55205],[-74.20379547577288,40.55205],[-74.20466150117666,40.55355],[-74.20379547577288,40.55505],[-74.20466150117666,40.55655],[-74.20379547577288,40.55805],[-74.2020634249653,40.55805],[-74.20119739956152,40.55955],[-74.19946534875395,40.55955],[-74.19859932335017,40.56105],[-74.19686727254259,40.56105],[-74.19600124713881,40.56255],[-74.19426919633123,40.56255],[-74.19340317092745,40.56405],[-74.19167112011988,40.56405],[-74.1908050947161,40.56255],[-74.18907304390852,40.56255],[-74.18820701850474,40.56405],[-74.18907304390852,40.56555],[-74.18820701850474,40.56705],[-74.18647496769717,40.56705],[-74.18560894229338,40.56555],[-74.18387689148581,40.56555],[-74.18301086608203,40.56705],[-74.18127881527445,40.56705],[-74.18041278987067,40.56555],[-74.1786807390631,40.56555],[-74.17781471365932,40.56405],[-74.17608266285174,40.56405],[-74.17521663744796,40.56555],[-74.17348458664038,40.56555],[-74.1726185612366,40.56405],[-74.17088651042903,40.56405],[-74.17002048502525,40.56255],[-74.17088651042903,40.56105],[-74.1726185612366,40.56105],[-74.17348458664038,40.55955],[-74.1726185612366,40.55805],[-74.17348458664038,40.55655],[-74.17521663744796,40.55655],[-74.17608266285174,40.55505],[-74.17521663744796,40.55355],[-74.17608266285174,40.55205],[-74.17781471365932,40.55205],[-74.1786807390631,40.55055],[-74.17781471365932,40.54905],[-74.1786807390631,40.54755],[-74.18041278987067,40.54755],[-74.18127881527445,40.54605],[-74.18301086608203,40.54605],[-74.18387689148581,40.54455],[-74.18301086608203,40.54305],[-74.18387689148581,40.54155],[-74.18560894229338,40.54155],[-74.18647496769717,40.54005],[-74.18820701850474,40.54005],[-74.18907304390852,40.53855],[-74.18820701850474,40.53705],[-74.18907304390852,40.53555],[-74.1908050947161,40.53555],[-74.19167112011988,40.53405]]],"type":"Polygon"}},{"id":"114","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Murray Hill-Kips Bay"},"type":"Feature","geometry":{"coordinates":[[[-73.97603079457731,40.73355000000001],[-73.97776284538489,40.73355000000001],[-73.97862887078867,40.73505000000001],[-73.97776284538489,40.73655000000001],[-73.97862887078867,40.73805000000001],[-73.98036092159624,40.73805000000001],[-73.98122694700002,40.73955000000001],[-73.98036092159624,40.74105000000001],[-73.98122694700002,40.74255000000001],[-73.9829589978076,40.74255000000001],[-73.98382502321138,40.74405000000001],[-73.9829589978076,40.74555000000001],[-73.98122694700002,40.74555000000001],[-73.98036092159624,40.74705000000001],[-73.98122694700002,40.74855000000001],[-73.9829589978076,40.74855000000001],[-73.98382502321138,40.75005000000001],[-73.9829589978076,40.75155000000001],[-73.98122694700002,40.75155000000001],[-73.98036092159624,40.75305000000001],[-73.97862887078867,40.75305000000001],[-73.97776284538489,40.75155000000001],[-73.97603079457731,40.75155000000001],[-73.97516476917353,40.75005000000001],[-73.97343271836596,40.75005000000001],[-73.97256669296218,40.74855000000001],[-73.97343271836596,40.74705000000001],[-73.97256669296218,40.74555000000001],[-73.97343271836596,40.74405000000001],[-73.97256669296218,40.74255000000001],[-73.9708346421546,40.74255000000001],[-73.96996861675082,40.74105000000001],[-73.9708346421546,40.73955000000001],[-73.97256669296218,40.73955000000001],[-73.97343271836596,40.73805000000001],[-73.97256669296218,40.73655000000001],[-73.97343271836596,40.73505000000001],[-73.97516476917353,40.73505000000001],[-73.97603079457731,40.73355000000001]]],"type":"Polygon"}},{"id":"67","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Fort Greene"},"type":"Feature","geometry":{"coordinates":[[[-73.97343271836596,40.681050000000006],[-73.97516476917353,40.681050000000006],[-73.97603079457731,40.682550000000006],[-73.97516476917353,40.684050000000006],[-73.97603079457731,40.685550000000006],[-73.97776284538489,40.685550000000006],[-73.97862887078867,40.687050000000006],[-73.98036092159624,40.687050000000006],[-73.98122694700002,40.688550000000006],[-73.98036092159624,40.69005000000001],[-73.98122694700002,40.69155000000001],[-73.98036092159624,40.69305000000001],[-73.98122694700002,40.69455000000001],[-73.98036092159624,40.69605000000001],[-73.98122694700002,40.69755000000001],[-73.98036092159624,40.69905000000001],[-73.97862887078867,40.69905000000001],[-73.97776284538489,40.70055000000001],[-73.97603079457731,40.70055000000001],[-73.97516476917353,40.69905000000001],[-73.97343271836596,40.69905000000001],[-73.97256669296218,40.70055000000001],[-73.9708346421546,40.70055000000001],[-73.96996861675082,40.69905000000001],[-73.96823656594324,40.69905000000001],[-73.96737054053946,40.69755000000001],[-73.96823656594324,40.69605000000001],[-73.96737054053946,40.69455000000001],[-73.96823656594324,40.69305000000001],[-73.96996861675082,40.69305000000001],[-73.9708346421546,40.69155000000001],[-73.96996861675082,40.69005000000001],[-73.9708346421546,40.688550000000006],[-73.96996861675082,40.687050000000006],[-73.9708346421546,40.685550000000006],[-73.96996861675082,40.684050000000006],[-73.9708346421546,40.682550000000006],[-73.97256669296218,40.682550000000006],[-73.97343271836596,40.681050000000006]]],"type":"Polygon"}},{"id":"174","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"West Brighton"},"type":"Feature","geometry":{"coordinates":[[[-73.96823656594324,40.57305],[-73.96996861675082,40.57305],[-73.9708346421546,40.57455],[-73.97256669296218,40.57455],[-73.97343271836596,40.57605],[-73.97516476917353,40.57605],[-73.97603079457731,40.57455],[-73.97776284538489,40.57455],[-73.97862887078867,40.57605],[-73.98036092159624,40.57605],[-73.98122694700002,40.57755],[-73.98036092159624,40.57905],[-73.97862887078867,40.57905],[-73.97776284538489,40.58055],[-73.97603079457731,40.58055],[-73.97516476917353,40.58205],[-73.97343271836596,40.58205],[-73.97256669296218,40.58355],[-73.9708346421546,40.58355],[-73.96996861675082,40.58205],[-73.96823656594324,40.58205],[-73.96737054053946,40.58055],[-73.96823656594324,40.57905],[-73.96996861675082,40.57905],[-73.9708346421546,40.57755],[-73.96996861675082,40.57605],[-73.96823656594324,40.57605],[-73.96737054053946,40.57455],[-73.96823656594324,40.57305]]],"type":"Polygon"}},{"id":"125","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Ocean Parkway South"},"type":"Feature","geometry":{"coordinates":[[[-73.9708346421546,40.60755],[-73.97256669296218,40.60755],[-73.97343271836596,40.60905],[-73.97256669296218,40.61055],[-73.97343271836596,40.61205],[-73.97516476917353,40.61205],[-73.97603079457731,40.613550000000004],[-73.97516476917353,40.615050000000004],[-73.97603079457731,40.616550000000004],[-73.97516476917353,40.618050000000004],[-73.97603079457731,40.619550000000004],[-73.97516476917353,40.621050000000004],[-73.97603079457731,40.622550000000004],[-73.97516476917353,40.624050000000004],[-73.97603079457731,40.625550000000004],[-73.97516476917353,40.627050000000004],[-73.97343271836596,40.627050000000004],[-73.97256669296218,40.625550000000004],[-73.9708346421546,40.625550000000004],[-73.96996861675082,40.624050000000004],[-73.96823656594324,40.624050000000004],[-73.96737054053946,40.622550000000004],[-73.96563848973189,40.622550000000004],[-73.9647724643281,40.621050000000004],[-73.96563848973189,40.619550000000004],[-73.9647724643281,40.618050000000004],[-73.96304041352053,40.618050000000004],[-73.96217438811675,40.616550000000004],[-73.96304041352053,40.615050000000004],[-73.96217438811675,40.613550000000004],[-73.96304041352053,40.61205],[-73.9647724643281,40.61205],[-73.96563848973189,40.61055],[-73.96737054053946,40.61055],[-73.96823656594324,40.60905],[-73.96996861675082,40.60905],[-73.9708346421546,40.60755]]],"type":"Polygon"}},{"id":"62","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Flatbush"},"type":"Feature","geometry":{"coordinates":[[[-73.9526481086751,40.627050000000004],[-73.95438015948268,40.627050000000004],[-73.95524618488646,40.628550000000004],[-73.95697823569404,40.628550000000004],[-73.95784426109782,40.627050000000004],[-73.9595763119054,40.627050000000004],[-73.96044233730917,40.628550000000004],[-73.96217438811675,40.628550000000004],[-73.96304041352053,40.630050000000004],[-73.9647724643281,40.630050000000004],[-73.96563848973189,40.628550000000004],[-73.96737054053946,40.628550000000004],[-73.96823656594324,40.630050000000004],[-73.96996861675082,40.630050000000004],[-73.9708346421546,40.628550000000004],[-73.96996861675082,40.627050000000004],[-73.9708346421546,40.625550000000004],[-73.97256669296218,40.625550000000004],[-73.97343271836596,40.627050000000004],[-73.97516476917353,40.627050000000004],[-73.97603079457731,40.628550000000004],[-73.97516476917353,40.630050000000004],[-73.97603079457731,40.631550000000004],[-73.97516476917353,40.633050000000004],[-73.97343271836596,40.633050000000004],[-73.97256669296218,40.634550000000004],[-73.9708346421546,40.634550000000004],[-73.96996861675082,40.636050000000004],[-73.96823656594324,40.636050000000004],[-73.96737054053946,40.637550000000005],[-73.96823656594324,40.639050000000005],[-73.96737054053946,40.640550000000005],[-73.96823656594324,40.642050000000005],[-73.96996861675082,40.642050000000005],[-73.9708346421546,40.643550000000005],[-73.96996861675082,40.645050000000005],[-73.9708346421546,40.646550000000005],[-73.96996861675082,40.648050000000005],[-73.9708346421546,40.649550000000005],[-73.96996861675082,40.651050000000005],[-73.96823656594324,40.651050000000005],[-73.96737054053946,40.652550000000005],[-73.96823656594324,40.654050000000005],[-73.96737054053946,40.655550000000005],[-73.96563848973189,40.655550000000005],[-73.9647724643281,40.657050000000005],[-73.96304041352053,40.657050000000005],[-73.96217438811675,40.655550000000005],[-73.96044233730917,40.655550000000005],[-73.9595763119054,40.654050000000005],[-73.96044233730917,40.652550000000005],[-73.9595763119054,40.651050000000005],[-73.95784426109782,40.651050000000005],[-73.95697823569404,40.649550000000005],[-73.95784426109782,40.648050000000005],[-73.95697823569404,40.646550000000005],[-73.95784426109782,40.645050000000005],[-73.95697823569404,40.643550000000005],[-73.95784426109782,40.642050000000005],[-73.95697823569404,40.640550000000005],[-73.95524618488646,40.640550000000005],[-73.95438015948268,40.639050000000005],[-73.9526481086751,40.639050000000005],[-73.95178208327133,40.637550000000005],[-73.95005003246375,40.637550000000005],[-73.94918400705997,40.639050000000005],[-73.9474519562524,40.639050000000005],[-73.94658593084861,40.637550000000005],[-73.94485388004104,40.637550000000005],[-73.94398785463726,40.636050000000004],[-73.94485388004104,40.634550000000004],[-73.94398785463726,40.633050000000004],[-73.94485388004104,40.631550000000004],[-73.94658593084861,40.631550000000004],[-73.9474519562524,40.630050000000004],[-73.94918400705997,40.630050000000004],[-73.95005003246375,40.628550000000004],[-73.95178208327133,40.628550000000004],[-73.9526481086751,40.627050000000004]]],"type":"Polygon"}},{"id":"135","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Prospect Heights"},"type":"Feature","geometry":{"coordinates":[[[-73.96563848973189,40.670550000000006],[-73.96737054053946,40.670550000000006],[-73.96823656594324,40.672050000000006],[-73.96996861675082,40.672050000000006],[-73.9708346421546,40.673550000000006],[-73.96996861675082,40.675050000000006],[-73.9708346421546,40.676550000000006],[-73.97256669296218,40.676550000000006],[-73.97343271836596,40.678050000000006],[-73.97516476917353,40.678050000000006],[-73.97603079457731,40.679550000000006],[-73.97516476917353,40.681050000000006],[-73.97343271836596,40.681050000000006],[-73.97256669296218,40.682550000000006],[-73.9708346421546,40.682550000000006],[-73.96996861675082,40.681050000000006],[-73.96823656594324,40.681050000000006],[-73.96737054053946,40.682550000000006],[-73.96563848973189,40.682550000000006],[-73.9647724643281,40.681050000000006],[-73.96304041352053,40.681050000000006],[-73.96217438811675,40.679550000000006],[-73.96304041352053,40.678050000000006],[-73.96217438811675,40.676550000000006],[-73.96304041352053,40.675050000000006],[-73.96217438811675,40.673550000000006],[-73.96044233730917,40.673550000000006],[-73.9595763119054,40.672050000000006],[-73.96044233730917,40.670550000000006],[-73.96217438811675,40.670550000000006],[-73.96304041352053,40.672050000000006],[-73.9647724643281,40.672050000000006],[-73.96563848973189,40.670550000000006]]],"type":"Polygon"}},{"id":"166","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Turtle Bay-East Midtown"},"type":"Feature","geometry":{"coordinates":[[[-73.9708346421546,40.74255000000001],[-73.97256669296218,40.74255000000001],[-73.97343271836596,40.74405000000001],[-73.97256669296218,40.74555000000001],[-73.97343271836596,40.74705000000001],[-73.97256669296218,40.74855000000001],[-73.97343271836596,40.75005000000001],[-73.97516476917353,40.75005000000001],[-73.97603079457731,40.75155000000001],[-73.97776284538489,40.75155000000001],[-73.97862887078867,40.75305000000001],[-73.97776284538489,40.75455000000001],[-73.97603079457731,40.75455000000001],[-73.97516476917353,40.75605000000001],[-73.97343271836596,40.75605000000001],[-73.97256669296218,40.75755000000001],[-73.97343271836596,40.75905000000001],[-73.97256669296218,40.76055000000001],[-73.9708346421546,40.76055000000001],[-73.96996861675082,40.76205000000001],[-73.96823656594324,40.76205000000001],[-73.96737054053946,40.76055000000001],[-73.96563848973189,40.76055000000001],[-73.9647724643281,40.76205000000001],[-73.96304041352053,40.76205000000001],[-73.96217438811675,40.76055000000001],[-73.96044233730917,40.76055000000001],[-73.9595763119054,40.75905000000001],[-73.95784426109782,40.75905000000001],[-73.95697823569404,40.75755000000001],[-73.95784426109782,40.75605000000001],[-73.9595763119054,40.75605000000001],[-73.96044233730917,40.75455000000001],[-73.96217438811675,40.75455000000001],[-73.96304041352053,40.75305000000001],[-73.96217438811675,40.75155000000001],[-73.96304041352053,40.75005000000001],[-73.9647724643281,40.75005000000001],[-73.96563848973189,40.74855000000001],[-73.96737054053946,40.74855000000001],[-73.96823656594324,40.74705000000001],[-73.96737054053946,40.74555000000001],[-73.96823656594324,40.74405000000001],[-73.96996861675082,40.74405000000001],[-73.9708346421546,40.74255000000001]]],"type":"Polygon"}},{"id":"83","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Homecrest"},"type":"Feature","geometry":{"coordinates":[[[-73.95784426109782,40.58805],[-73.9595763119054,40.58805],[-73.96044233730917,40.58955],[-73.96217438811675,40.58955],[-73.96304041352053,40.59105],[-73.9647724643281,40.59105],[-73.96563848973189,40.58955],[-73.96737054053946,40.58955],[-73.96823656594324,40.59105],[-73.96996861675082,40.59105],[-73.9708346421546,40.59255],[-73.96996861675082,40.59405],[-73.9708346421546,40.59555],[-73.97256669296218,40.59555],[-73.97343271836596,40.59705],[-73.97256669296218,40.59855],[-73.97343271836596,40.60005],[-73.97256669296218,40.60155],[-73.97343271836596,40.60305],[-73.97256669296218,40.60455],[-73.97343271836596,40.60605],[-73.97256669296218,40.60755],[-73.9708346421546,40.60755],[-73.96996861675082,40.60905],[-73.96823656594324,40.60905],[-73.96737054053946,40.61055],[-73.96563848973189,40.61055],[-73.9647724643281,40.61205],[-73.96304041352053,40.61205],[-73.96217438811675,40.61055],[-73.96044233730917,40.61055],[-73.9595763119054,40.60905],[-73.95784426109782,40.60905],[-73.95697823569404,40.60755],[-73.95784426109782,40.60605],[-73.95697823569404,40.60455],[-73.95784426109782,40.60305],[-73.95697823569404,40.60155],[-73.95784426109782,40.60005],[-73.95697823569404,40.59855],[-73.95784426109782,40.59705],[-73.95697823569404,40.59555],[-73.95784426109782,40.59405],[-73.95697823569404,40.59255],[-73.95784426109782,40.59105],[-73.95697823569404,40.58955],[-73.95784426109782,40.58805]]],"type":"Polygon"}},{"id":"168","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Upper East Side-Carnegie Hill"},"type":"Feature","geometry":{"coordinates":[[[-73.96823656594324,40.76205000000001],[-73.96996861675082,40.76205000000001],[-73.9708346421546,40.76355000000001],[-73.97256669296218,40.76355000000001],[-73.97343271836596,40.76505000000001],[-73.97256669296218,40.76655000000001],[-73.97343271836596,40.76805000000001],[-73.97256669296218,40.76955000000001],[-73.9708346421546,40.76955000000001],[-73.96996861675082,40.77105000000001],[-73.96823656594324,40.77105000000001],[-73.96737054053946,40.77255000000001],[-73.96823656594324,40.77405000000001],[-73.96737054053946,40.77555000000001],[-73.96563848973189,40.77555000000001],[-73.9647724643281,40.77705000000001],[-73.96563848973189,40.77855000000001],[-73.9647724643281,40.78005000000001],[-73.96304041352053,40.78005000000001],[-73.96217438811675,40.78155000000001],[-73.96044233730917,40.78155000000001],[-73.9595763119054,40.78305000000001],[-73.96044233730917,40.78455000000001],[-73.9595763119054,40.78605000000001],[-73.95784426109782,40.78605000000001],[-73.95697823569404,40.78755000000001],[-73.95524618488646,40.78755000000001],[-73.95438015948268,40.78605000000001],[-73.9526481086751,40.78605000000001],[-73.95178208327133,40.78755000000001],[-73.95005003246375,40.78755000000001],[-73.94918400705997,40.78605000000001],[-73.95005003246375,40.78455000000001],[-73.94918400705997,40.78305000000001],[-73.95005003246375,40.78155000000001],[-73.95178208327133,40.78155000000001],[-73.9526481086751,40.78005000000001],[-73.95438015948268,40.78005000000001],[-73.95524618488646,40.77855000000001],[-73.95438015948268,40.77705000000001],[-73.95524618488646,40.77555000000001],[-73.95697823569404,40.77555000000001],[-73.95784426109782,40.77405000000001],[-73.9595763119054,40.77405000000001],[-73.96044233730917,40.77255000000001],[-73.9595763119054,40.77105000000001],[-73.96044233730917,40.76955000000001],[-73.96217438811675,40.76955000000001],[-73.96304041352053,40.76805000000001],[-73.96217438811675,40.76655000000001],[-73.96304041352053,40.76505000000001],[-73.9647724643281,40.76505000000001],[-73.96563848973189,40.76355000000001],[-73.96737054053946,40.76355000000001],[-73.96823656594324,40.76205000000001]]],"type":"Polygon"}},{"id":"20","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Brighton Beach"},"type":"Feature","geometry":{"coordinates":[[[-73.9526481086751,40.57305],[-73.95438015948268,40.57305],[-73.95524618488646,40.57455],[-73.95697823569404,40.57455],[-73.95784426109782,40.57305],[-73.9595763119054,40.57305],[-73.96044233730917,40.57455],[-73.96217438811675,40.57455],[-73.96304041352053,40.57305],[-73.9647724643281,40.57305],[-73.96563848973189,40.57455],[-73.96737054053946,40.57455],[-73.96823656594324,40.57605],[-73.96996861675082,40.57605],[-73.9708346421546,40.57755],[-73.96996861675082,40.57905],[-73.96823656594324,40.57905],[-73.96737054053946,40.58055],[-73.96823656594324,40.58205],[-73.96737054053946,40.58355],[-73.96563848973189,40.58355],[-73.9647724643281,40.58505],[-73.96563848973189,40.58655],[-73.9647724643281,40.58805],[-73.96563848973189,40.58955],[-73.9647724643281,40.59105],[-73.96304041352053,40.59105],[-73.96217438811675,40.58955],[-73.96044233730917,40.58955],[-73.9595763119054,40.58805],[-73.96044233730917,40.58655],[-73.9595763119054,40.58505],[-73.96044233730917,40.58355],[-73.9595763119054,40.58205],[-73.95784426109782,40.58205],[-73.95697823569404,40.58355],[-73.95524618488646,40.58355],[-73.95438015948268,40.58205],[-73.9526481086751,40.58205],[-73.95178208327133,40.58055],[-73.9526481086751,40.57905],[-73.95178208327133,40.57755],[-73.9526481086751,40.57605],[-73.95178208327133,40.57455],[-73.9526481086751,40.57305]]],"type":"Polygon"}},{"id":"108","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Midwood"},"type":"Feature","geometry":{"coordinates":[[[-73.95005003246375,40.61055],[-73.95178208327133,40.61055],[-73.9526481086751,40.61205],[-73.95438015948268,40.61205],[-73.95524618488646,40.61055],[-73.95697823569404,40.61055],[-73.95784426109782,40.60905],[-73.9595763119054,40.60905],[-73.96044233730917,40.61055],[-73.96217438811675,40.61055],[-73.96304041352053,40.61205],[-73.96217438811675,40.613550000000004],[-73.96304041352053,40.615050000000004],[-73.96217438811675,40.616550000000004],[-73.96304041352053,40.618050000000004],[-73.9647724643281,40.618050000000004],[-73.96563848973189,40.619550000000004],[-73.9647724643281,40.621050000000004],[-73.96563848973189,40.622550000000004],[-73.96737054053946,40.622550000000004],[-73.96823656594324,40.624050000000004],[-73.96996861675082,40.624050000000004],[-73.9708346421546,40.625550000000004],[-73.96996861675082,40.627050000000004],[-73.9708346421546,40.628550000000004],[-73.96996861675082,40.630050000000004],[-73.96823656594324,40.630050000000004],[-73.96737054053946,40.628550000000004],[-73.96563848973189,40.628550000000004],[-73.9647724643281,40.630050000000004],[-73.96304041352053,40.630050000000004],[-73.96217438811675,40.628550000000004],[-73.96044233730917,40.628550000000004],[-73.9595763119054,40.627050000000004],[-73.95784426109782,40.627050000000004],[-73.95697823569404,40.628550000000004],[-73.95524618488646,40.628550000000004],[-73.95438015948268,40.627050000000004],[-73.9526481086751,40.627050000000004],[-73.95178208327133,40.628550000000004],[-73.95005003246375,40.628550000000004],[-73.94918400705997,40.630050000000004],[-73.9474519562524,40.630050000000004],[-73.94658593084861,40.628550000000004],[-73.9474519562524,40.627050000000004],[-73.94658593084861,40.625550000000004],[-73.9474519562524,40.624050000000004],[-73.94658593084861,40.622550000000004],[-73.94485388004104,40.622550000000004],[-73.94398785463726,40.621050000000004],[-73.94485388004104,40.619550000000004],[-73.94658593084861,40.619550000000004],[-73.9474519562524,40.618050000000004],[-73.94658593084861,40.616550000000004],[-73.9474519562524,40.615050000000004],[-73.94918400705997,40.615050000000004],[-73.95005003246375,40.613550000000004],[-73.94918400705997,40.61205],[-73.95005003246375,40.61055]]],"type":"Polygon"}},{"id":"35","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Clinton Hill"},"type":"Feature","geometry":{"coordinates":[[[-73.96823656594324,40.681050000000006],[-73.96996861675082,40.681050000000006],[-73.9708346421546,40.682550000000006],[-73.96996861675082,40.684050000000006],[-73.9708346421546,40.685550000000006],[-73.96996861675082,40.687050000000006],[-73.9708346421546,40.688550000000006],[-73.96996861675082,40.69005000000001],[-73.9708346421546,40.69155000000001],[-73.96996861675082,40.69305000000001],[-73.96823656594324,40.69305000000001],[-73.96737054053946,40.69455000000001],[-73.96823656594324,40.69605000000001],[-73.96737054053946,40.69755000000001],[-73.96563848973189,40.69755000000001],[-73.9647724643281,40.69605000000001],[-73.96304041352053,40.69605000000001],[-73.96217438811675,40.69755000000001],[-73.96044233730917,40.69755000000001],[-73.9595763119054,40.69605000000001],[-73.96044233730917,40.69455000000001],[-73.9595763119054,40.69305000000001],[-73.95784426109782,40.69305000000001],[-73.95697823569404,40.69455000000001],[-73.95524618488646,40.69455000000001],[-73.95438015948268,40.69305000000001],[-73.95524618488646,40.69155000000001],[-73.95697823569404,40.69155000000001],[-73.95784426109782,40.69005000000001],[-73.9595763119054,40.69005000000001],[-73.96044233730917,40.688550000000006],[-73.9595763119054,40.687050000000006],[-73.95784426109782,40.687050000000006],[-73.95697823569404,40.685550000000006],[-73.95524618488646,40.685550000000006],[-73.95438015948268,40.684050000000006],[-73.95524618488646,40.682550000000006],[-73.95438015948268,40.681050000000006],[-73.95524618488646,40.679550000000006],[-73.95697823569404,40.679550000000006],[-73.95784426109782,40.681050000000006],[-73.9595763119054,40.681050000000006],[-73.96044233730917,40.679550000000006],[-73.96217438811675,40.679550000000006],[-73.96304041352053,40.681050000000006],[-73.9647724643281,40.681050000000006],[-73.96563848973189,40.682550000000006],[-73.96737054053946,40.682550000000006],[-73.96823656594324,40.681050000000006]]],"type":"Polygon"}},{"id":"120","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"North Side-South Side"},"type":"Feature","geometry":{"coordinates":[[[-73.96823656594324,40.70505000000001],[-73.96996861675082,40.70505000000001],[-73.9708346421546,40.70655000000001],[-73.96996861675082,40.70805000000001],[-73.9708346421546,40.70955000000001],[-73.96996861675082,40.71105000000001],[-73.9708346421546,40.71255000000001],[-73.96996861675082,40.71405000000001],[-73.96823656594324,40.71405000000001],[-73.96737054053946,40.71555000000001],[-73.96823656594324,40.71705000000001],[-73.96737054053946,40.71855000000001],[-73.96823656594324,40.72005000000001],[-73.96737054053946,40.72155000000001],[-73.96563848973189,40.72155000000001],[-73.9647724643281,40.72305000000001],[-73.96304041352053,40.72305000000001],[-73.96217438811675,40.72455000000001],[-73.96044233730917,40.72455000000001],[-73.9595763119054,40.72305000000001],[-73.95784426109782,40.72305000000001],[-73.95697823569404,40.72455000000001],[-73.95524618488646,40.72455000000001],[-73.95438015948268,40.72305000000001],[-73.95524618488646,40.72155000000001],[-73.95438015948268,40.72005000000001],[-73.9526481086751,40.72005000000001],[-73.95178208327133,40.72155000000001],[-73.95005003246375,40.72155000000001],[-73.94918400705997,40.72005000000001],[-73.9474519562524,40.72005000000001],[-73.94658593084861,40.71855000000001],[-73.9474519562524,40.71705000000001],[-73.94918400705997,40.71705000000001],[-73.95005003246375,40.71555000000001],[-73.94918400705997,40.71405000000001],[-73.95005003246375,40.71255000000001],[-73.94918400705997,40.71105000000001],[-73.95005003246375,40.70955000000001],[-73.94918400705997,40.70805000000001],[-73.95005003246375,40.70655000000001],[-73.95178208327133,40.70655000000001],[-73.9526481086751,40.70805000000001],[-73.95438015948268,40.70805000000001],[-73.95524618488646,40.70655000000001],[-73.95697823569404,40.70655000000001],[-73.95784426109782,40.70805000000001],[-73.9595763119054,40.70805000000001],[-73.96044233730917,40.70655000000001],[-73.96217438811675,40.70655000000001],[-73.96304041352053,40.70805000000001],[-73.9647724643281,40.70805000000001],[-73.96563848973189,40.70655000000001],[-73.96737054053946,40.70655000000001],[-73.96823656594324,40.70505000000001]]],"type":"Polygon"}},{"id":"109","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Morningside Heights"},"type":"Feature","geometry":{"coordinates":[[[[-73.9526481086751,40.81005000000001],[-73.95438015948268,40.81005000000001],[-73.95524618488646,40.81155000000001],[-73.95438015948268,40.81305000000001],[-73.9526481086751,40.81305000000001],[-73.95178208327133,40.81155000000001],[-73.9526481086751,40.81005000000001]]],[[[-73.95784426109782,40.79805000000001],[-73.9595763119054,40.79805000000001],[-73.96044233730917,40.79955000000001],[-73.96217438811675,40.79955000000001],[-73.96304041352053,40.80105000000001],[-73.9647724643281,40.80105000000001],[-73.96563848973189,40.79955000000001],[-73.96737054053946,40.79955000000001],[-73.96823656594324,40.80105000000001],[-73.96996861675082,40.80105000000001],[-73.9708346421546,40.80255000000001],[-73.96996861675082,40.80405000000001],[-73.9708346421546,40.80555000000001],[-73.96996861675082,40.80705000000001],[-73.96823656594324,40.80705000000001],[-73.96737054053946,40.80855000000001],[-73.96823656594324,40.81005000000001],[-73.96737054053946,40.81155000000001],[-73.96563848973189,40.81155000000001],[-73.9647724643281,40.81305000000001],[-73.96563848973189,40.81455000000001],[-73.9647724643281,40.81605000000001],[-73.96304041352053,40.81605000000001],[-73.96217438811675,40.81755000000001],[-73.96044233730917,40.81755000000001],[-73.9595763119054,40.81605000000001],[-73.95784426109782,40.81605000000001],[-73.95697823569404,40.81455000000001],[-73.95784426109782,40.81305000000001],[-73.95697823569404,40.81155000000001],[-73.95784426109782,40.81005000000001],[-73.95697823569404,40.80855000000001],[-73.95784426109782,40.80705000000001],[-73.9595763119054,40.80705000000001],[-73.96044233730917,40.80555000000001],[-73.9595763119054,40.80405000000001],[-73.96044233730917,40.80255000000001],[-73.9595763119054,40.80105000000001],[-73.95784426109782,40.80105000000001],[-73.95697823569404,40.79955000000001],[-73.95784426109782,40.79805000000001]]]],"type":"MultiPolygon"}},{"id":"183","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Williamsburg"},"type":"Feature","geometry":{"coordinates":[[[-73.95005003246375,40.70055000000001],[-73.95178208327133,40.70055000000001],[-73.9526481086751,40.70205000000001],[-73.95438015948268,40.70205000000001],[-73.95524618488646,40.70055000000001],[-73.95697823569404,40.70055000000001],[-73.95784426109782,40.69905000000001],[-73.9595763119054,40.69905000000001],[-73.96044233730917,40.69755000000001],[-73.96217438811675,40.69755000000001],[-73.96304041352053,40.69905000000001],[-73.9647724643281,40.69905000000001],[-73.96563848973189,40.70055000000001],[-73.96737054053946,40.70055000000001],[-73.96823656594324,40.70205000000001],[-73.96737054053946,40.70355000000001],[-73.96823656594324,40.70505000000001],[-73.96737054053946,40.70655000000001],[-73.96563848973189,40.70655000000001],[-73.9647724643281,40.70805000000001],[-73.96304041352053,40.70805000000001],[-73.96217438811675,40.70655000000001],[-73.96044233730917,40.70655000000001],[-73.9595763119054,40.70805000000001],[-73.95784426109782,40.70805000000001],[-73.95697823569404,40.70655000000001],[-73.95524618488646,40.70655000000001],[-73.95438015948268,40.70805000000001],[-73.9526481086751,40.70805000000001],[-73.95178208327133,40.70655000000001],[-73.95005003246375,40.70655000000001],[-73.94918400705997,40.70505000000001],[-73.9474519562524,40.70505000000001],[-73.94658593084861,40.70355000000001],[-73.9474519562524,40.70205000000001],[-73.94918400705997,40.70205000000001],[-73.95005003246375,40.70055000000001]]],"type":"Polygon"}},{"id":"95","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Lenox Hill-Roosevelt Island"},"type":"Feature","geometry":{"coordinates":[[[[-73.94398785463726,40.76805000000001],[-73.94485388004104,40.76955000000001],[-73.94398785463726,40.77105000000001],[-73.94485388004104,40.77255000000001],[-73.94398785463726,40.77405000000001],[-73.94225580382968,40.77405000000001],[-73.9413897784259,40.77255000000001],[-73.93965772761833,40.77255000000001],[-73.93879170221454,40.77105000000001],[-73.93965772761833,40.76955000000001],[-73.9413897784259,40.76955000000001],[-73.94225580382968,40.76805000000001],[-73.94398785463726,40.76805000000001]]],[[[-73.95697823569404,40.75155000000001],[-73.95784426109782,40.75305000000001],[-73.9595763119054,40.75305000000001],[-73.96044233730917,40.75455000000001],[-73.9595763119054,40.75605000000001],[-73.95784426109782,40.75605000000001],[-73.95697823569404,40.75755000000001],[-73.95524618488646,40.75755000000001],[-73.95438015948268,40.75905000000001],[-73.95524618488646,40.76055000000001],[-73.95697823569404,40.76055000000001],[-73.95784426109782,40.75905000000001],[-73.9595763119054,40.75905000000001],[-73.96044233730917,40.76055000000001],[-73.96217438811675,40.76055000000001],[-73.96304041352053,40.76205000000001],[-73.9647724643281,40.76205000000001],[-73.96563848973189,40.76055000000001],[-73.96737054053946,40.76055000000001],[-73.96823656594324,40.76205000000001],[-73.96737054053946,40.76355000000001],[-73.96563848973189,40.76355000000001],[-73.9647724643281,40.76505000000001],[-73.96304041352053,40.76505000000001],[-73.96217438811675,40.76655000000001],[-73.96304041352053,40.76805000000001],[-73.96217438811675,40.76955000000001],[-73.96044233730917,40.76955000000001],[-73.9595763119054,40.77105000000001],[-73.96044233730917,40.77255000000001],[-73.9595763119054,40.77405000000001],[-73.95784426109782,40.77405000000001],[-73.95697823569404,40.77555000000001],[-73.95524618488646,40.77555000000001],[-73.95438015948268,40.77405000000001],[-73.9526481086751,40.77405000000001],[-73.95178208327133,40.77255000000001],[-73.95005003246375,40.77255000000001],[-73.94918400705997,40.77105000000001],[-73.9474519562524,40.77105000000001],[-73.94658593084861,40.76955000000001],[-73.9474519562524,40.76805000000001],[-73.94918400705997,40.76805000000001],[-73.95005003246375,40.76655000000001],[-73.94918400705997,40.76505000000001],[-73.9474519562524,40.76505000000001],[-73.94658593084861,40.76355000000001],[-73.9474519562524,40.76205000000001],[-73.94658593084861,40.76055000000001],[-73.9474519562524,40.75905000000001],[-73.94918400705997,40.75905000000001],[-73.95005003246375,40.75755000000001],[-73.95178208327133,40.75755000000001],[-73.9526481086751,40.75605000000001],[-73.95438015948268,40.75605000000001],[-73.95524618488646,40.75455000000001],[-73.95438015948268,40.75305000000001],[-73.95524618488646,40.75155000000001],[-73.95697823569404,40.75155000000001]]]],"type":"MultiPolygon"}},{"id":"136","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Prospect Lefferts Gardens-Wingate"},"type":"Feature","geometry":{"coordinates":[[[-73.9292654227729,40.655550000000005],[-73.93099747358048,40.655550000000005],[-73.93186349898426,40.657050000000005],[-73.93359554979183,40.657050000000005],[-73.93446157519561,40.658550000000005],[-73.93619362600319,40.658550000000005],[-73.93705965140697,40.657050000000005],[-73.93879170221454,40.657050000000005],[-73.93965772761833,40.658550000000005],[-73.9413897784259,40.658550000000005],[-73.94225580382968,40.657050000000005],[-73.94398785463726,40.657050000000005],[-73.94485388004104,40.655550000000005],[-73.94658593084861,40.655550000000005],[-73.9474519562524,40.657050000000005],[-73.94918400705997,40.657050000000005],[-73.95005003246375,40.655550000000005],[-73.94918400705997,40.654050000000005],[-73.95005003246375,40.652550000000005],[-73.94918400705997,40.651050000000005],[-73.95005003246375,40.649550000000005],[-73.95178208327133,40.649550000000005],[-73.9526481086751,40.651050000000005],[-73.95438015948268,40.651050000000005],[-73.95524618488646,40.649550000000005],[-73.95697823569404,40.649550000000005],[-73.95784426109782,40.651050000000005],[-73.9595763119054,40.651050000000005],[-73.96044233730917,40.652550000000005],[-73.9595763119054,40.654050000000005],[-73.96044233730917,40.655550000000005],[-73.96217438811675,40.655550000000005],[-73.96304041352053,40.657050000000005],[-73.9647724643281,40.657050000000005],[-73.96563848973189,40.658550000000005],[-73.9647724643281,40.660050000000005],[-73.96563848973189,40.661550000000005],[-73.9647724643281,40.663050000000005],[-73.96304041352053,40.663050000000005],[-73.96217438811675,40.664550000000006],[-73.96044233730917,40.664550000000006],[-73.9595763119054,40.666050000000006],[-73.95784426109782,40.666050000000006],[-73.95697823569404,40.664550000000006],[-73.95524618488646,40.664550000000006],[-73.95438015948268,40.663050000000005],[-73.9526481086751,40.663050000000005],[-73.95178208327133,40.664550000000006],[-73.95005003246375,40.664550000000006],[-73.94918400705997,40.663050000000005],[-73.9474519562524,40.663050000000005],[-73.94658593084861,40.664550000000006],[-73.94485388004104,40.664550000000006],[-73.94398785463726,40.663050000000005],[-73.94225580382968,40.663050000000005],[-73.9413897784259,40.661550000000005],[-73.93965772761833,40.661550000000005],[-73.93879170221454,40.663050000000005],[-73.93705965140697,40.663050000000005],[-73.93619362600319,40.664550000000006],[-73.93446157519561,40.664550000000006],[-73.93359554979183,40.663050000000005],[-73.93186349898426,40.663050000000005],[-73.93099747358048,40.661550000000005],[-73.9292654227729,40.661550000000005],[-73.92839939736912,40.660050000000005],[-73.9292654227729,40.658550000000005],[-73.92839939736912,40.657050000000005],[-73.9292654227729,40.655550000000005]]],"type":"Polygon"}},{"id":"41","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Crown Heights South"},"type":"Feature","geometry":{"coordinates":[[[[-73.93186349898426,40.663050000000005],[-73.93359554979183,40.663050000000005],[-73.93446157519561,40.664550000000006],[-73.93359554979183,40.666050000000006],[-73.93186349898426,40.666050000000006],[-73.93099747358048,40.664550000000006],[-73.93186349898426,40.663050000000005]]],[[[-73.96044233730917,40.664550000000006],[-73.96217438811675,40.664550000000006],[-73.96304041352053,40.666050000000006],[-73.96217438811675,40.667550000000006],[-73.96304041352053,40.669050000000006],[-73.96217438811675,40.670550000000006],[-73.96044233730917,40.670550000000006],[-73.9595763119054,40.672050000000006],[-73.95784426109782,40.672050000000006],[-73.95697823569404,40.670550000000006],[-73.95524618488646,40.670550000000006],[-73.95438015948268,40.669050000000006],[-73.9526481086751,40.669050000000006],[-73.95178208327133,40.670550000000006],[-73.95005003246375,40.670550000000006],[-73.94918400705997,40.669050000000006],[-73.9474519562524,40.669050000000006],[-73.94658593084861,40.667550000000006],[-73.94485388004104,40.667550000000006],[-73.94398785463726,40.669050000000006],[-73.94225580382968,40.669050000000006],[-73.9413897784259,40.667550000000006],[-73.93965772761833,40.667550000000006],[-73.93879170221454,40.669050000000006],[-73.93705965140697,40.669050000000006],[-73.93619362600319,40.667550000000006],[-73.93705965140697,40.666050000000006],[-73.93619362600319,40.664550000000006],[-73.93705965140697,40.663050000000005],[-73.93879170221454,40.663050000000005],[-73.93965772761833,40.661550000000005],[-73.9413897784259,40.661550000000005],[-73.94225580382968,40.663050000000005],[-73.94398785463726,40.663050000000005],[-73.94485388004104,40.664550000000006],[-73.94658593084861,40.664550000000006],[-73.9474519562524,40.663050000000005],[-73.94918400705997,40.663050000000005],[-73.95005003246375,40.664550000000006],[-73.95178208327133,40.664550000000006],[-73.9526481086751,40.663050000000005],[-73.95438015948268,40.663050000000005],[-73.95524618488646,40.664550000000006],[-73.95697823569404,40.664550000000006],[-73.95784426109782,40.666050000000006],[-73.9595763119054,40.666050000000006],[-73.96044233730917,40.664550000000006]]]],"type":"MultiPolygon"}},{"id":"40","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Crown Heights North"},"type":"Feature","geometry":{"coordinates":[[[-73.9526481086751,40.669050000000006],[-73.95438015948268,40.669050000000006],[-73.95524618488646,40.670550000000006],[-73.95697823569404,40.670550000000006],[-73.95784426109782,40.672050000000006],[-73.9595763119054,40.672050000000006],[-73.96044233730917,40.673550000000006],[-73.96217438811675,40.673550000000006],[-73.96304041352053,40.675050000000006],[-73.96217438811675,40.676550000000006],[-73.96304041352053,40.678050000000006],[-73.96217438811675,40.679550000000006],[-73.96044233730917,40.679550000000006],[-73.9595763119054,40.681050000000006],[-73.95784426109782,40.681050000000006],[-73.95697823569404,40.679550000000006],[-73.95524618488646,40.679550000000006],[-73.95438015948268,40.681050000000006],[-73.9526481086751,40.681050000000006],[-73.95178208327133,40.679550000000006],[-73.95005003246375,40.679550000000006],[-73.94918400705997,40.681050000000006],[-73.9474519562524,40.681050000000006],[-73.94658593084861,40.679550000000006],[-73.94485388004104,40.679550000000006],[-73.94398785463726,40.681050000000006],[-73.94225580382968,40.681050000000006],[-73.9413897784259,40.679550000000006],[-73.93965772761833,40.679550000000006],[-73.93879170221454,40.681050000000006],[-73.93705965140697,40.681050000000006],[-73.93619362600319,40.679550000000006],[-73.93446157519561,40.679550000000006],[-73.93359554979183,40.681050000000006],[-73.93446157519561,40.682550000000006],[-73.93359554979183,40.684050000000006],[-73.93186349898426,40.684050000000006],[-73.93099747358048,40.682550000000006],[-73.9292654227729,40.682550000000006],[-73.92839939736912,40.684050000000006],[-73.92666734656154,40.684050000000006],[-73.92580132115776,40.682550000000006],[-73.92406927035019,40.682550000000006],[-73.92320324494641,40.681050000000006],[-73.92406927035019,40.679550000000006],[-73.92320324494641,40.678050000000006],[-73.92147119413883,40.678050000000006],[-73.92060516873505,40.676550000000006],[-73.92147119413883,40.675050000000006],[-73.92060516873505,40.673550000000006],[-73.92147119413883,40.672050000000006],[-73.92320324494641,40.672050000000006],[-73.92406927035019,40.670550000000006],[-73.92320324494641,40.669050000000006],[-73.92406927035019,40.667550000000006],[-73.92580132115776,40.667550000000006],[-73.92666734656154,40.666050000000006],[-73.92839939736912,40.666050000000006],[-73.9292654227729,40.664550000000006],[-73.93099747358048,40.664550000000006],[-73.93186349898426,40.666050000000006],[-73.93359554979183,40.666050000000006],[-73.93446157519561,40.664550000000006],[-73.93619362600319,40.664550000000006],[-73.93705965140697,40.666050000000006],[-73.93619362600319,40.667550000000006],[-73.93705965140697,40.669050000000006],[-73.93879170221454,40.669050000000006],[-73.93965772761833,40.667550000000006],[-73.9413897784259,40.667550000000006],[-73.94225580382968,40.669050000000006],[-73.94398785463726,40.669050000000006],[-73.94485388004104,40.667550000000006],[-73.94658593084861,40.667550000000006],[-73.9474519562524,40.669050000000006],[-73.94918400705997,40.669050000000006],[-73.95005003246375,40.670550000000006],[-73.95178208327133,40.670550000000006],[-73.9526481086751,40.669050000000006]]],"type":"Polygon"}},{"id":"77","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Greenpoint"},"type":"Feature","geometry":{"coordinates":[[[-73.95784426109782,40.72305000000001],[-73.9595763119054,40.72305000000001],[-73.96044233730917,40.72455000000001],[-73.96217438811675,40.72455000000001],[-73.96304041352053,40.72605000000001],[-73.96217438811675,40.72755000000001],[-73.96304041352053,40.72905000000001],[-73.96217438811675,40.73055000000001],[-73.96304041352053,40.73205000000001],[-73.96217438811675,40.73355000000001],[-73.96304041352053,40.73505000000001],[-73.96217438811675,40.73655000000001],[-73.96044233730917,40.73655000000001],[-73.9595763119054,40.73805000000001],[-73.95784426109782,40.73805000000001],[-73.95697823569404,40.73955000000001],[-73.95524618488646,40.73955000000001],[-73.95438015948268,40.74105000000001],[-73.9526481086751,40.74105000000001],[-73.95178208327133,40.73955000000001],[-73.95005003246375,40.73955000000001],[-73.94918400705997,40.73805000000001],[-73.9474519562524,40.73805000000001],[-73.94658593084861,40.73655000000001],[-73.94485388004104,40.73655000000001],[-73.94398785463726,40.73505000000001],[-73.94225580382968,40.73505000000001],[-73.9413897784259,40.73355000000001],[-73.93965772761833,40.73355000000001],[-73.93879170221454,40.73205000000001],[-73.93965772761833,40.73055000000001],[-73.93879170221454,40.72905000000001],[-73.93705965140697,40.72905000000001],[-73.93619362600319,40.72755000000001],[-73.93446157519561,40.72755000000001],[-73.93359554979183,40.72605000000001],[-73.93446157519561,40.72455000000001],[-73.93619362600319,40.72455000000001],[-73.93705965140697,40.72305000000001],[-73.93879170221454,40.72305000000001],[-73.93965772761833,40.72155000000001],[-73.9413897784259,40.72155000000001],[-73.94225580382968,40.72005000000001],[-73.94398785463726,40.72005000000001],[-73.94485388004104,40.71855000000001],[-73.94658593084861,40.71855000000001],[-73.9474519562524,40.72005000000001],[-73.94918400705997,40.72005000000001],[-73.95005003246375,40.72155000000001],[-73.95178208327133,40.72155000000001],[-73.9526481086751,40.72005000000001],[-73.95438015948268,40.72005000000001],[-73.95524618488646,40.72155000000001],[-73.95438015948268,40.72305000000001],[-73.95524618488646,40.72455000000001],[-73.95697823569404,40.72455000000001],[-73.95784426109782,40.72305000000001]]],"type":"Polygon"}},{"id":"148","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Sheepshead Bay-Gerritsen Beach-Manhattan Beach"},"type":"Feature","geometry":{"coordinates":[[[-73.91887311792748,40.58355],[-73.92060516873505,40.58355],[-73.92147119413883,40.58505],[-73.92320324494641,40.58505],[-73.92406927035019,40.58355],[-73.92580132115776,40.58355],[-73.92666734656154,40.58505],[-73.92839939736912,40.58505],[-73.9292654227729,40.58355],[-73.93099747358048,40.58355],[-73.93186349898426,40.58205],[-73.93099747358048,40.58055],[-73.93186349898426,40.57905],[-73.93359554979183,40.57905],[-73.93446157519561,40.57755],[-73.93619362600319,40.57755],[-73.93705965140697,40.57605],[-73.93879170221454,40.57605],[-73.93965772761833,40.57755],[-73.9413897784259,40.57755],[-73.94225580382968,40.57605],[-73.94398785463726,40.57605],[-73.94485388004104,40.57455],[-73.94658593084861,40.57455],[-73.9474519562524,40.57305],[-73.94918400705997,40.57305],[-73.95005003246375,40.57455],[-73.95178208327133,40.57455],[-73.9526481086751,40.57605],[-73.95178208327133,40.57755],[-73.9526481086751,40.57905],[-73.95178208327133,40.58055],[-73.9526481086751,40.58205],[-73.95438015948268,40.58205],[-73.95524618488646,40.58355],[-73.95697823569404,40.58355],[-73.95784426109782,40.58205],[-73.9595763119054,40.58205],[-73.96044233730917,40.58355],[-73.9595763119054,40.58505],[-73.96044233730917,40.58655],[-73.9595763119054,40.58805],[-73.95784426109782,40.58805],[-73.95697823569404,40.58955],[-73.95784426109782,40.59105],[-73.95697823569404,40.59255],[-73.95784426109782,40.59405],[-73.95697823569404,40.59555],[-73.95524618488646,40.59555],[-73.95438015948268,40.59705],[-73.9526481086751,40.59705],[-73.95178208327133,40.59855],[-73.95005003246375,40.59855],[-73.94918400705997,40.59705],[-73.9474519562524,40.59705],[-73.94658593084861,40.59855],[-73.94485388004104,40.59855],[-73.94398785463726,40.59705],[-73.94225580382968,40.59705],[-73.9413897784259,40.59855],[-73.94225580382968,40.60005],[-73.9413897784259,40.60155],[-73.93965772761833,40.60155],[-73.93879170221454,40.60005],[-73.93705965140697,40.60005],[-73.93619362600319,40.60155],[-73.93446157519561,40.60155],[-73.93359554979183,40.60305],[-73.93186349898426,40.60305],[-73.93099747358048,40.60155],[-73.9292654227729,40.60155],[-73.92839939736912,40.60005],[-73.92666734656154,40.60005],[-73.92580132115776,40.59855],[-73.92666734656154,40.59705],[-73.92580132115776,40.59555],[-73.92406927035019,40.59555],[-73.92320324494641,40.59405],[-73.92406927035019,40.59255],[-73.92320324494641,40.59105],[-73.92147119413883,40.59105],[-73.92060516873505,40.58955],[-73.91887311792748,40.58955],[-73.9180070925237,40.58805],[-73.91627504171612,40.58805],[-73.91540901631234,40.58655],[-73.91627504171612,40.58505],[-73.9180070925237,40.58505],[-73.91887311792748,40.58355]]],"type":"Polygon"}},{"id":"11","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Bedford"},"type":"Feature","geometry":{"coordinates":[[[-73.93965772761833,40.679550000000006],[-73.9413897784259,40.679550000000006],[-73.94225580382968,40.681050000000006],[-73.94398785463726,40.681050000000006],[-73.94485388004104,40.679550000000006],[-73.94658593084861,40.679550000000006],[-73.9474519562524,40.681050000000006],[-73.94918400705997,40.681050000000006],[-73.95005003246375,40.679550000000006],[-73.95178208327133,40.679550000000006],[-73.9526481086751,40.681050000000006],[-73.95438015948268,40.681050000000006],[-73.95524618488646,40.682550000000006],[-73.95438015948268,40.684050000000006],[-73.95524618488646,40.685550000000006],[-73.95697823569404,40.685550000000006],[-73.95784426109782,40.687050000000006],[-73.9595763119054,40.687050000000006],[-73.96044233730917,40.688550000000006],[-73.9595763119054,40.69005000000001],[-73.95784426109782,40.69005000000001],[-73.95697823569404,40.69155000000001],[-73.95524618488646,40.69155000000001],[-73.95438015948268,40.69305000000001],[-73.95524618488646,40.69455000000001],[-73.95697823569404,40.69455000000001],[-73.95784426109782,40.69305000000001],[-73.9595763119054,40.69305000000001],[-73.96044233730917,40.69455000000001],[-73.9595763119054,40.69605000000001],[-73.96044233730917,40.69755000000001],[-73.9595763119054,40.69905000000001],[-73.95784426109782,40.69905000000001],[-73.95697823569404,40.70055000000001],[-73.95524618488646,40.70055000000001],[-73.95438015948268,40.70205000000001],[-73.9526481086751,40.70205000000001],[-73.95178208327133,40.70055000000001],[-73.95005003246375,40.70055000000001],[-73.94918400705997,40.70205000000001],[-73.9474519562524,40.70205000000001],[-73.94658593084861,40.70355000000001],[-73.94485388004104,40.70355000000001],[-73.94398785463726,40.70205000000001],[-73.94225580382968,40.70205000000001],[-73.9413897784259,40.70055000000001],[-73.94225580382968,40.69905000000001],[-73.9413897784259,40.69755000000001],[-73.94225580382968,40.69605000000001],[-73.94398785463726,40.69605000000001],[-73.94485388004104,40.69455000000001],[-73.94398785463726,40.69305000000001],[-73.94225580382968,40.69305000000001],[-73.9413897784259,40.69155000000001],[-73.94225580382968,40.69005000000001],[-73.9413897784259,40.688550000000006],[-73.94225580382968,40.687050000000006],[-73.9413897784259,40.685550000000006],[-73.94225580382968,40.684050000000006],[-73.9413897784259,40.682550000000006],[-73.93965772761833,40.682550000000006],[-73.93879170221454,40.681050000000006],[-73.93965772761833,40.679550000000006]]],"type":"Polygon"}},{"id":"85","properties":{"borough":"queens","borocode":4,"neighborhood":"Hunters Point-Sunnyside-West Maspeth"},"type":"Feature","geometry":{"coordinates":[[[-73.96044233730917,40.73655000000001],[-73.96217438811675,40.73655000000001],[-73.96304041352053,40.73805000000001],[-73.96217438811675,40.73955000000001],[-73.96304041352053,40.74105000000001],[-73.96217438811675,40.74255000000001],[-73.96044233730917,40.74255000000001],[-73.9595763119054,40.74405000000001],[-73.96044233730917,40.74555000000001],[-73.9595763119054,40.74705000000001],[-73.96044233730917,40.74855000000001],[-73.9595763119054,40.75005000000001],[-73.95784426109782,40.75005000000001],[-73.95697823569404,40.75155000000001],[-73.95524618488646,40.75155000000001],[-73.95438015948268,40.75305000000001],[-73.9526481086751,40.75305000000001],[-73.95178208327133,40.75455000000001],[-73.9526481086751,40.75605000000001],[-73.95178208327133,40.75755000000001],[-73.95005003246375,40.75755000000001],[-73.94918400705997,40.75605000000001],[-73.9474519562524,40.75605000000001],[-73.94658593084861,40.75455000000001],[-73.94485388004104,40.75455000000001],[-73.94398785463726,40.75305000000001],[-73.94225580382968,40.75305000000001],[-73.9413897784259,40.75155000000001],[-73.93965772761833,40.75155000000001],[-73.93879170221454,40.75005000000001],[-73.93705965140697,40.75005000000001],[-73.93619362600319,40.74855000000001],[-73.93446157519561,40.74855000000001],[-73.93359554979183,40.75005000000001],[-73.93186349898426,40.75005000000001],[-73.93099747358048,40.75155000000001],[-73.9292654227729,40.75155000000001],[-73.92839939736912,40.75005000000001],[-73.92666734656154,40.75005000000001],[-73.92580132115776,40.75155000000001],[-73.92406927035019,40.75155000000001],[-73.92320324494641,40.75305000000001],[-73.92147119413883,40.75305000000001],[-73.92060516873505,40.75155000000001],[-73.91887311792748,40.75155000000001],[-73.9180070925237,40.75305000000001],[-73.91627504171612,40.75305000000001],[-73.91540901631234,40.75155000000001],[-73.91367696550476,40.75155000000001],[-73.91281094010098,40.75305000000001],[-73.9110788892934,40.75305000000001],[-73.91021286388963,40.75155000000001],[-73.9110788892934,40.75005000000001],[-73.91021286388963,40.74855000000001],[-73.9110788892934,40.74705000000001],[-73.91021286388963,40.74555000000001],[-73.9110788892934,40.74405000000001],[-73.91281094010098,40.74405000000001],[-73.91367696550476,40.74255000000001],[-73.91281094010098,40.74105000000001],[-73.91367696550476,40.73955000000001],[-73.91540901631234,40.73955000000001],[-73.91627504171612,40.73805000000001],[-73.91540901631234,40.73655000000001],[-73.91627504171612,40.73505000000001],[-73.91540901631234,40.73355000000001],[-73.91627504171612,40.73205000000001],[-73.91540901631234,40.73055000000001],[-73.91367696550476,40.73055000000001],[-73.91281094010098,40.73205000000001],[-73.9110788892934,40.73205000000001],[-73.91021286388963,40.73055000000001],[-73.9110788892934,40.72905000000001],[-73.91021286388963,40.72755000000001],[-73.9110788892934,40.72605000000001],[-73.91281094010098,40.72605000000001],[-73.91367696550476,40.72455000000001],[-73.91281094010098,40.72305000000001],[-73.91367696550476,40.72155000000001],[-73.91281094010098,40.72005000000001],[-73.91367696550476,40.71855000000001],[-73.91540901631234,40.71855000000001],[-73.91627504171612,40.72005000000001],[-73.9180070925237,40.72005000000001],[-73.91887311792748,40.71855000000001],[-73.92060516873505,40.71855000000001],[-73.92147119413883,40.71705000000001],[-73.92320324494641,40.71705000000001],[-73.92406927035019,40.71855000000001],[-73.92580132115776,40.71855000000001],[-73.92666734656154,40.72005000000001],[-73.92580132115776,40.72155000000001],[-73.92406927035019,40.72155000000001],[-73.92320324494641,40.72305000000001],[-73.92406927035019,40.72455000000001],[-73.92580132115776,40.72455000000001],[-73.92666734656154,40.72305000000001],[-73.92839939736912,40.72305000000001],[-73.9292654227729,40.72455000000001],[-73.92839939736912,40.72605000000001],[-73.9292654227729,40.72755000000001],[-73.93099747358048,40.72755000000001],[-73.93186349898426,40.72905000000001],[-73.93359554979183,40.72905000000001],[-73.93446157519561,40.72755000000001],[-73.93619362600319,40.72755000000001],[-73.93705965140697,40.72905000000001],[-73.93879170221454,40.72905000000001],[-73.93965772761833,40.73055000000001],[-73.93879170221454,40.73205000000001],[-73.93965772761833,40.73355000000001],[-73.9413897784259,40.73355000000001],[-73.94225580382968,40.73505000000001],[-73.94398785463726,40.73505000000001],[-73.94485388004104,40.73655000000001],[-73.94658593084861,40.73655000000001],[-73.9474519562524,40.73805000000001],[-73.94918400705997,40.73805000000001],[-73.95005003246375,40.73955000000001],[-73.95178208327133,40.73955000000001],[-73.9526481086751,40.74105000000001],[-73.95438015948268,40.74105000000001],[-73.95524618488646,40.73955000000001],[-73.95697823569404,40.73955000000001],[-73.95784426109782,40.73805000000001],[-73.9595763119054,40.73805000000001],[-73.96044233730917,40.73655000000001]]],"type":"Polygon"}},{"id":"30","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Central Harlem South"},"type":"Feature","geometry":{"coordinates":[[[-73.95005003246375,40.79655000000001],[-73.95178208327133,40.79655000000001],[-73.9526481086751,40.79805000000001],[-73.95438015948268,40.79805000000001],[-73.95524618488646,40.79955000000001],[-73.95697823569404,40.79955000000001],[-73.95784426109782,40.80105000000001],[-73.9595763119054,40.80105000000001],[-73.96044233730917,40.80255000000001],[-73.9595763119054,40.80405000000001],[-73.96044233730917,40.80555000000001],[-73.9595763119054,40.80705000000001],[-73.95784426109782,40.80705000000001],[-73.95697823569404,40.80855000000001],[-73.95784426109782,40.81005000000001],[-73.95697823569404,40.81155000000001],[-73.95524618488646,40.81155000000001],[-73.95438015948268,40.81005000000001],[-73.9526481086751,40.81005000000001],[-73.95178208327133,40.81155000000001],[-73.95005003246375,40.81155000000001],[-73.94918400705997,40.81005000000001],[-73.9474519562524,40.81005000000001],[-73.94658593084861,40.80855000000001],[-73.94485388004104,40.80855000000001],[-73.94398785463726,40.80705000000001],[-73.94225580382968,40.80705000000001],[-73.9413897784259,40.80555000000001],[-73.94225580382968,40.80405000000001],[-73.94398785463726,40.80405000000001],[-73.94485388004104,40.80255000000001],[-73.94658593084861,40.80255000000001],[-73.9474519562524,40.80105000000001],[-73.94658593084861,40.79955000000001],[-73.9474519562524,40.79805000000001],[-73.94918400705997,40.79805000000001],[-73.95005003246375,40.79655000000001]]],"type":"Polygon"}},{"id":"100","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Madison"},"type":"Feature","geometry":{"coordinates":[[[-73.93705965140697,40.60005],[-73.93879170221454,40.60005],[-73.93965772761833,40.60155],[-73.9413897784259,40.60155],[-73.94225580382968,40.60005],[-73.9413897784259,40.59855],[-73.94225580382968,40.59705],[-73.94398785463726,40.59705],[-73.94485388004104,40.59855],[-73.94658593084861,40.59855],[-73.9474519562524,40.59705],[-73.94918400705997,40.59705],[-73.95005003246375,40.59855],[-73.95178208327133,40.59855],[-73.9526481086751,40.59705],[-73.95438015948268,40.59705],[-73.95524618488646,40.59555],[-73.95697823569404,40.59555],[-73.95784426109782,40.59705],[-73.95697823569404,40.59855],[-73.95784426109782,40.60005],[-73.95697823569404,40.60155],[-73.95784426109782,40.60305],[-73.95697823569404,40.60455],[-73.95784426109782,40.60605],[-73.95697823569404,40.60755],[-73.95784426109782,40.60905],[-73.95697823569404,40.61055],[-73.95524618488646,40.61055],[-73.95438015948268,40.61205],[-73.9526481086751,40.61205],[-73.95178208327133,40.61055],[-73.95005003246375,40.61055],[-73.94918400705997,40.61205],[-73.95005003246375,40.613550000000004],[-73.94918400705997,40.615050000000004],[-73.9474519562524,40.615050000000004],[-73.94658593084861,40.616550000000004],[-73.94485388004104,40.616550000000004],[-73.94398785463726,40.615050000000004],[-73.94485388004104,40.613550000000004],[-73.94398785463726,40.61205],[-73.94485388004104,40.61055],[-73.94398785463726,40.60905],[-73.94225580382968,40.60905],[-73.9413897784259,40.61055],[-73.93965772761833,40.61055],[-73.93879170221454,40.60905],[-73.93705965140697,40.60905],[-73.93619362600319,40.60755],[-73.93705965140697,40.60605],[-73.93619362600319,40.60455],[-73.93446157519561,40.60455],[-73.93359554979183,40.60305],[-73.93446157519561,40.60155],[-73.93619362600319,40.60155],[-73.93705965140697,40.60005]]],"type":"Polygon"}},{"id":"60","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Erasmus"},"type":"Feature","geometry":{"coordinates":[[[-73.95005003246375,40.637550000000005],[-73.95178208327133,40.637550000000005],[-73.9526481086751,40.639050000000005],[-73.95438015948268,40.639050000000005],[-73.95524618488646,40.640550000000005],[-73.95697823569404,40.640550000000005],[-73.95784426109782,40.642050000000005],[-73.95697823569404,40.643550000000005],[-73.95784426109782,40.645050000000005],[-73.95697823569404,40.646550000000005],[-73.95784426109782,40.648050000000005],[-73.95697823569404,40.649550000000005],[-73.95524618488646,40.649550000000005],[-73.95438015948268,40.651050000000005],[-73.9526481086751,40.651050000000005],[-73.95178208327133,40.649550000000005],[-73.95005003246375,40.649550000000005],[-73.94918400705997,40.651050000000005],[-73.95005003246375,40.652550000000005],[-73.94918400705997,40.654050000000005],[-73.95005003246375,40.655550000000005],[-73.94918400705997,40.657050000000005],[-73.9474519562524,40.657050000000005],[-73.94658593084861,40.655550000000005],[-73.9474519562524,40.654050000000005],[-73.94658593084861,40.652550000000005],[-73.9474519562524,40.651050000000005],[-73.94658593084861,40.649550000000005],[-73.9474519562524,40.648050000000005],[-73.94658593084861,40.646550000000005],[-73.9474519562524,40.645050000000005],[-73.94658593084861,40.643550000000005],[-73.9474519562524,40.642050000000005],[-73.94658593084861,40.640550000000005],[-73.9474519562524,40.639050000000005],[-73.94918400705997,40.639050000000005],[-73.95005003246375,40.637550000000005]]],"type":"Polygon"}},{"id":"51","properties":{"borough":"manhattan","borocode":1,"neighborhood":"East Harlem South"},"type":"Feature","geometry":{"coordinates":[[[-73.9526481086751,40.78605000000001],[-73.95438015948268,40.78605000000001],[-73.95524618488646,40.78755000000001],[-73.95697823569404,40.78755000000001],[-73.95784426109782,40.78905000000001],[-73.95697823569404,40.79055000000001],[-73.95524618488646,40.79055000000001],[-73.95438015948268,40.79205000000001],[-73.9526481086751,40.79205000000001],[-73.95178208327133,40.79355000000001],[-73.9526481086751,40.79505000000001],[-73.95178208327133,40.79655000000001],[-73.95005003246375,40.79655000000001],[-73.94918400705997,40.79805000000001],[-73.9474519562524,40.79805000000001],[-73.94658593084861,40.79955000000001],[-73.94485388004104,40.79955000000001],[-73.94398785463726,40.79805000000001],[-73.94225580382968,40.79805000000001],[-73.9413897784259,40.79655000000001],[-73.94225580382968,40.79505000000001],[-73.9413897784259,40.79355000000001],[-73.94225580382968,40.79205000000001],[-73.9413897784259,40.79055000000001],[-73.93965772761833,40.79055000000001],[-73.93879170221454,40.79205000000001],[-73.93705965140697,40.79205000000001],[-73.93619362600319,40.79355000000001],[-73.93446157519561,40.79355000000001],[-73.93359554979183,40.79205000000001],[-73.93446157519561,40.79055000000001],[-73.93619362600319,40.79055000000001],[-73.93705965140697,40.78905000000001],[-73.93619362600319,40.78755000000001],[-73.93705965140697,40.78605000000001],[-73.93879170221454,40.78605000000001],[-73.93965772761833,40.78455000000001],[-73.9413897784259,40.78455000000001],[-73.94225580382968,40.78305000000001],[-73.94398785463726,40.78305000000001],[-73.94485388004104,40.78455000000001],[-73.94658593084861,40.78455000000001],[-73.9474519562524,40.78605000000001],[-73.94918400705997,40.78605000000001],[-73.95005003246375,40.78755000000001],[-73.95178208327133,40.78755000000001],[-73.9526481086751,40.78605000000001]]],"type":"Polygon"}},{"id":"101","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Manhattanville"},"type":"Feature","geometry":{"coordinates":[[[-73.95524618488646,40.81155000000001],[-73.95697823569404,40.81155000000001],[-73.95784426109782,40.81305000000001],[-73.95697823569404,40.81455000000001],[-73.95784426109782,40.81605000000001],[-73.9595763119054,40.81605000000001],[-73.96044233730917,40.81755000000001],[-73.96217438811675,40.81755000000001],[-73.96304041352053,40.81905000000001],[-73.96217438811675,40.82055000000001],[-73.96044233730917,40.82055000000001],[-73.9595763119054,40.82205000000001],[-73.96044233730917,40.82355000000001],[-73.9595763119054,40.82505000000001],[-73.95784426109782,40.82505000000001],[-73.95697823569404,40.82355000000001],[-73.95524618488646,40.82355000000001],[-73.95438015948268,40.82205000000001],[-73.9526481086751,40.82205000000001],[-73.95178208327133,40.82055000000001],[-73.95005003246375,40.82055000000001],[-73.94918400705997,40.81905000000001],[-73.95005003246375,40.81755000000001],[-73.94918400705997,40.81605000000001],[-73.95005003246375,40.81455000000001],[-73.95178208327133,40.81455000000001],[-73.9526481086751,40.81305000000001],[-73.95438015948268,40.81305000000001],[-73.95524618488646,40.81155000000001]]],"type":"Polygon"}},{"id":"188","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Yorkville"},"type":"Feature","geometry":{"coordinates":[[[-73.94485388004104,40.76955000000001],[-73.94658593084861,40.76955000000001],[-73.9474519562524,40.77105000000001],[-73.94918400705997,40.77105000000001],[-73.95005003246375,40.77255000000001],[-73.95178208327133,40.77255000000001],[-73.9526481086751,40.77405000000001],[-73.95438015948268,40.77405000000001],[-73.95524618488646,40.77555000000001],[-73.95438015948268,40.77705000000001],[-73.95524618488646,40.77855000000001],[-73.95438015948268,40.78005000000001],[-73.9526481086751,40.78005000000001],[-73.95178208327133,40.78155000000001],[-73.95005003246375,40.78155000000001],[-73.94918400705997,40.78305000000001],[-73.95005003246375,40.78455000000001],[-73.94918400705997,40.78605000000001],[-73.9474519562524,40.78605000000001],[-73.94658593084861,40.78455000000001],[-73.94485388004104,40.78455000000001],[-73.94398785463726,40.78305000000001],[-73.94225580382968,40.78305000000001],[-73.9413897784259,40.78155000000001],[-73.94225580382968,40.78005000000001],[-73.9413897784259,40.77855000000001],[-73.94225580382968,40.77705000000001],[-73.9413897784259,40.77555000000001],[-73.94225580382968,40.77405000000001],[-73.94398785463726,40.77405000000001],[-73.94485388004104,40.77255000000001],[-73.94398785463726,40.77105000000001],[-73.94485388004104,40.76955000000001]]],"type":"Polygon"}},{"id":"79","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Hamilton Heights"},"type":"Feature","geometry":{"coordinates":[[[-73.9474519562524,40.81905000000001],[-73.94918400705997,40.81905000000001],[-73.95005003246375,40.82055000000001],[-73.95178208327133,40.82055000000001],[-73.9526481086751,40.82205000000001],[-73.95438015948268,40.82205000000001],[-73.95524618488646,40.82355000000001],[-73.95438015948268,40.82505000000001],[-73.95524618488646,40.82655000000001],[-73.95438015948268,40.82805000000001],[-73.9526481086751,40.82805000000001],[-73.95178208327133,40.82955000000001],[-73.9526481086751,40.83105000000001],[-73.95178208327133,40.83255000000001],[-73.9526481086751,40.83405000000001],[-73.95178208327133,40.83555000000001],[-73.95005003246375,40.83555000000001],[-73.94918400705997,40.83405000000001],[-73.9474519562524,40.83405000000001],[-73.94658593084861,40.83255000000001],[-73.94485388004104,40.83255000000001],[-73.94398785463726,40.83105000000001],[-73.94225580382968,40.83105000000001],[-73.9413897784259,40.83255000000001],[-73.93965772761833,40.83255000000001],[-73.93879170221454,40.83105000000001],[-73.93965772761833,40.82955000000001],[-73.93879170221454,40.82805000000001],[-73.93965772761833,40.82655000000001],[-73.9413897784259,40.82655000000001],[-73.94225580382968,40.82505000000001],[-73.9413897784259,40.82355000000001],[-73.94225580382968,40.82205000000001],[-73.94398785463726,40.82205000000001],[-73.94485388004104,40.82055000000001],[-73.94658593084861,40.82055000000001],[-73.9474519562524,40.81905000000001]]],"type":"Polygon"}},{"id":"29","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Central Harlem North-Polo Grounds"},"type":"Feature","geometry":{"coordinates":[[[-73.93965772761833,40.80555000000001],[-73.9413897784259,40.80555000000001],[-73.94225580382968,40.80705000000001],[-73.94398785463726,40.80705000000001],[-73.94485388004104,40.80855000000001],[-73.94658593084861,40.80855000000001],[-73.9474519562524,40.81005000000001],[-73.94918400705997,40.81005000000001],[-73.95005003246375,40.81155000000001],[-73.95178208327133,40.81155000000001],[-73.9526481086751,40.81305000000001],[-73.95178208327133,40.81455000000001],[-73.95005003246375,40.81455000000001],[-73.94918400705997,40.81605000000001],[-73.95005003246375,40.81755000000001],[-73.94918400705997,40.81905000000001],[-73.9474519562524,40.81905000000001],[-73.94658593084861,40.82055000000001],[-73.94485388004104,40.82055000000001],[-73.94398785463726,40.82205000000001],[-73.94225580382968,40.82205000000001],[-73.9413897784259,40.82355000000001],[-73.94225580382968,40.82505000000001],[-73.9413897784259,40.82655000000001],[-73.93965772761833,40.82655000000001],[-73.93879170221454,40.82805000000001],[-73.93965772761833,40.82955000000001],[-73.93879170221454,40.83105000000001],[-73.93965772761833,40.83255000000001],[-73.93879170221454,40.83405000000001],[-73.93705965140697,40.83405000000001],[-73.93619362600319,40.83255000000001],[-73.93446157519561,40.83255000000001],[-73.93359554979183,40.83105000000001],[-73.93446157519561,40.82955000000001],[-73.93359554979183,40.82805000000001],[-73.93446157519561,40.82655000000001],[-73.93359554979183,40.82505000000001],[-73.93446157519561,40.82355000000001],[-73.93359554979183,40.82205000000001],[-73.93446157519561,40.82055000000001],[-73.93359554979183,40.81905000000001],[-73.93446157519561,40.81755000000001],[-73.93359554979183,40.81605000000001],[-73.93446157519561,40.81455000000001],[-73.93619362600319,40.81455000000001],[-73.93705965140697,40.81305000000001],[-73.93619362600319,40.81155000000001],[-73.93446157519561,40.81155000000001],[-73.93359554979183,40.81005000000001],[-73.93446157519561,40.80855000000001],[-73.93619362600319,40.80855000000001],[-73.93705965140697,40.80705000000001],[-73.93879170221454,40.80705000000001],[-73.93965772761833,40.80555000000001]]],"type":"Polygon"}},{"id":"56","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"East Williamsburg"},"type":"Feature","geometry":{"coordinates":[[[-73.92666734656154,40.70805000000001],[-73.92839939736912,40.70805000000001],[-73.9292654227729,40.70955000000001],[-73.93099747358048,40.70955000000001],[-73.93186349898426,40.71105000000001],[-73.93359554979183,40.71105000000001],[-73.93446157519561,40.71255000000001],[-73.93619362600319,40.71255000000001],[-73.93705965140697,40.71105000000001],[-73.93879170221454,40.71105000000001],[-73.93965772761833,40.70955000000001],[-73.9413897784259,40.70955000000001],[-73.94225580382968,40.71105000000001],[-73.94398785463726,40.71105000000001],[-73.94485388004104,40.70955000000001],[-73.94398785463726,40.70805000000001],[-73.94225580382968,40.70805000000001],[-73.9413897784259,40.70655000000001],[-73.94225580382968,40.70505000000001],[-73.9413897784259,40.70355000000001],[-73.93965772761833,40.70355000000001],[-73.93879170221454,40.70205000000001],[-73.93965772761833,40.70055000000001],[-73.9413897784259,40.70055000000001],[-73.94225580382968,40.70205000000001],[-73.94398785463726,40.70205000000001],[-73.94485388004104,40.70355000000001],[-73.94658593084861,40.70355000000001],[-73.9474519562524,40.70505000000001],[-73.94918400705997,40.70505000000001],[-73.95005003246375,40.70655000000001],[-73.94918400705997,40.70805000000001],[-73.95005003246375,40.70955000000001],[-73.94918400705997,40.71105000000001],[-73.95005003246375,40.71255000000001],[-73.94918400705997,40.71405000000001],[-73.95005003246375,40.71555000000001],[-73.94918400705997,40.71705000000001],[-73.9474519562524,40.71705000000001],[-73.94658593084861,40.71855000000001],[-73.94485388004104,40.71855000000001],[-73.94398785463726,40.72005000000001],[-73.94225580382968,40.72005000000001],[-73.9413897784259,40.72155000000001],[-73.93965772761833,40.72155000000001],[-73.93879170221454,40.72305000000001],[-73.93705965140697,40.72305000000001],[-73.93619362600319,40.72455000000001],[-73.93446157519561,40.72455000000001],[-73.93359554979183,40.72605000000001],[-73.93446157519561,40.72755000000001],[-73.93359554979183,40.72905000000001],[-73.93186349898426,40.72905000000001],[-73.93099747358048,40.72755000000001],[-73.9292654227729,40.72755000000001],[-73.92839939736912,40.72605000000001],[-73.9292654227729,40.72455000000001],[-73.92839939736912,40.72305000000001],[-73.9292654227729,40.72155000000001],[-73.93099747358048,40.72155000000001],[-73.93186349898426,40.72305000000001],[-73.93359554979183,40.72305000000001],[-73.93446157519561,40.72155000000001],[-73.93359554979183,40.72005000000001],[-73.93186349898426,40.72005000000001],[-73.93099747358048,40.71855000000001],[-73.9292654227729,40.71855000000001],[-73.92839939736912,40.72005000000001],[-73.92666734656154,40.72005000000001],[-73.92580132115776,40.71855000000001],[-73.92406927035019,40.71855000000001],[-73.92320324494641,40.71705000000001],[-73.92406927035019,40.71555000000001],[-73.92320324494641,40.71405000000001],[-73.92147119413883,40.71405000000001],[-73.92060516873505,40.71255000000001],[-73.92147119413883,40.71105000000001],[-73.92320324494641,40.71105000000001],[-73.92406927035019,40.70955000000001],[-73.92580132115776,40.70955000000001],[-73.92666734656154,40.70805000000001]]],"type":"Polygon"}},{"id":"173","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Washington Heights South"},"type":"Feature","geometry":{"coordinates":[[[-73.94225580382968,40.83105000000001],[-73.94398785463726,40.83105000000001],[-73.94485388004104,40.83255000000001],[-73.94658593084861,40.83255000000001],[-73.9474519562524,40.83405000000001],[-73.94918400705997,40.83405000000001],[-73.95005003246375,40.83555000000001],[-73.94918400705997,40.83705000000001],[-73.95005003246375,40.83855000000001],[-73.94918400705997,40.84005000000001],[-73.9474519562524,40.84005000000001],[-73.94658593084861,40.84155000000001],[-73.9474519562524,40.84305000000001],[-73.94658593084861,40.84455000000001],[-73.9474519562524,40.84605000000001],[-73.94658593084861,40.84755000000001],[-73.9474519562524,40.84905000000001],[-73.94918400705997,40.84905000000001],[-73.95005003246375,40.85055000000001],[-73.94918400705997,40.85205000000001],[-73.9474519562524,40.85205000000001],[-73.94658593084861,40.85055000000001],[-73.94485388004104,40.85055000000001],[-73.94398785463726,40.85205000000001],[-73.94225580382968,40.85205000000001],[-73.9413897784259,40.85355000000001],[-73.93965772761833,40.85355000000001],[-73.93879170221454,40.85205000000001],[-73.93705965140697,40.85205000000001],[-73.93619362600319,40.85055000000001],[-73.93446157519561,40.85055000000001],[-73.93359554979183,40.84905000000001],[-73.93186349898426,40.84905000000001],[-73.93099747358048,40.84755000000001],[-73.93186349898426,40.84605000000001],[-73.93099747358048,40.84455000000001],[-73.93186349898426,40.84305000000001],[-73.93359554979183,40.84305000000001],[-73.93446157519561,40.84155000000001],[-73.93359554979183,40.84005000000001],[-73.93446157519561,40.83855000000001],[-73.93359554979183,40.83705000000001],[-73.93446157519561,40.83555000000001],[-73.93619362600319,40.83555000000001],[-73.93705965140697,40.83405000000001],[-73.93879170221454,40.83405000000001],[-73.93965772761833,40.83255000000001],[-73.9413897784259,40.83255000000001],[-73.94225580382968,40.83105000000001]]],"type":"Polygon"}},{"id":"63","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Flatlands"},"type":"Feature","geometry":{"coordinates":[[[-73.94485388004104,40.616550000000004],[-73.94658593084861,40.616550000000004],[-73.9474519562524,40.618050000000004],[-73.94658593084861,40.619550000000004],[-73.94485388004104,40.619550000000004],[-73.94398785463726,40.621050000000004],[-73.94485388004104,40.622550000000004],[-73.94658593084861,40.622550000000004],[-73.9474519562524,40.624050000000004],[-73.94658593084861,40.625550000000004],[-73.9474519562524,40.627050000000004],[-73.94658593084861,40.628550000000004],[-73.9474519562524,40.630050000000004],[-73.94658593084861,40.631550000000004],[-73.94485388004104,40.631550000000004],[-73.94398785463726,40.630050000000004],[-73.94225580382968,40.630050000000004],[-73.9413897784259,40.631550000000004],[-73.93965772761833,40.631550000000004],[-73.93879170221454,40.633050000000004],[-73.93705965140697,40.633050000000004],[-73.93619362600319,40.634550000000004],[-73.93446157519561,40.634550000000004],[-73.93359554979183,40.636050000000004],[-73.93186349898426,40.636050000000004],[-73.93099747358048,40.634550000000004],[-73.9292654227729,40.634550000000004],[-73.92839939736912,40.636050000000004],[-73.92666734656154,40.636050000000004],[-73.92580132115776,40.637550000000005],[-73.92666734656154,40.639050000000005],[-73.92580132115776,40.640550000000005],[-73.92406927035019,40.640550000000005],[-73.92320324494641,40.642050000000005],[-73.92147119413883,40.642050000000005],[-73.92060516873505,40.640550000000005],[-73.91887311792748,40.640550000000005],[-73.9180070925237,40.639050000000005],[-73.91887311792748,40.637550000000005],[-73.9180070925237,40.636050000000004],[-73.91887311792748,40.634550000000004],[-73.9180070925237,40.633050000000004],[-73.91627504171612,40.633050000000004],[-73.91540901631234,40.631550000000004],[-73.91627504171612,40.630050000000004],[-73.91540901631234,40.628550000000004],[-73.91627504171612,40.627050000000004],[-73.9180070925237,40.627050000000004],[-73.91887311792748,40.625550000000004],[-73.9180070925237,40.624050000000004],[-73.91627504171612,40.624050000000004],[-73.91540901631234,40.622550000000004],[-73.91627504171612,40.621050000000004],[-73.91540901631234,40.619550000000004],[-73.91627504171612,40.618050000000004],[-73.91540901631234,40.616550000000004],[-73.91627504171612,40.615050000000004],[-73.9180070925237,40.615050000000004],[-73.91887311792748,40.613550000000004],[-73.92060516873505,40.613550000000004],[-73.92147119413883,40.615050000000004],[-73.92320324494641,40.615050000000004],[-73.92406927035019,40.613550000000004],[-73.92580132115776,40.613550000000004],[-73.92666734656154,40.615050000000004],[-73.92839939736912,40.615050000000004],[-73.9292654227729,40.616550000000004],[-73.93099747358048,40.616550000000004],[-73.93186349898426,40.618050000000004],[-73.93359554979183,40.618050000000004],[-73.93446157519561,40.619550000000004],[-73.93619362600319,40.619550000000004],[-73.93705965140697,40.621050000000004],[-73.93879170221454,40.621050000000004],[-73.93965772761833,40.619550000000004],[-73.9413897784259,40.619550000000004],[-73.94225580382968,40.618050000000004],[-73.94398785463726,40.618050000000004],[-73.94485388004104,40.616550000000004]]],"type":"Polygon"}},{"id":"48","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"East Flatbush-Farragut"},"type":"Feature","geometry":{"coordinates":[[[-73.9292654227729,40.634550000000004],[-73.93099747358048,40.634550000000004],[-73.93186349898426,40.636050000000004],[-73.93359554979183,40.636050000000004],[-73.93446157519561,40.634550000000004],[-73.93619362600319,40.634550000000004],[-73.93705965140697,40.633050000000004],[-73.93879170221454,40.633050000000004],[-73.93965772761833,40.631550000000004],[-73.9413897784259,40.631550000000004],[-73.94225580382968,40.630050000000004],[-73.94398785463726,40.630050000000004],[-73.94485388004104,40.631550000000004],[-73.94398785463726,40.633050000000004],[-73.94485388004104,40.634550000000004],[-73.94398785463726,40.636050000000004],[-73.94485388004104,40.637550000000005],[-73.94658593084861,40.637550000000005],[-73.9474519562524,40.639050000000005],[-73.94658593084861,40.640550000000005],[-73.9474519562524,40.642050000000005],[-73.94658593084861,40.643550000000005],[-73.9474519562524,40.645050000000005],[-73.94658593084861,40.646550000000005],[-73.9474519562524,40.648050000000005],[-73.94658593084861,40.649550000000005],[-73.9474519562524,40.651050000000005],[-73.94658593084861,40.652550000000005],[-73.9474519562524,40.654050000000005],[-73.94658593084861,40.655550000000005],[-73.94485388004104,40.655550000000005],[-73.94398785463726,40.657050000000005],[-73.94225580382968,40.657050000000005],[-73.9413897784259,40.658550000000005],[-73.93965772761833,40.658550000000005],[-73.93879170221454,40.657050000000005],[-73.93705965140697,40.657050000000005],[-73.93619362600319,40.658550000000005],[-73.93446157519561,40.658550000000005],[-73.93359554979183,40.657050000000005],[-73.93186349898426,40.657050000000005],[-73.93099747358048,40.655550000000005],[-73.93186349898426,40.654050000000005],[-73.93099747358048,40.652550000000005],[-73.93186349898426,40.651050000000005],[-73.93099747358048,40.649550000000005],[-73.93186349898426,40.648050000000005],[-73.93099747358048,40.646550000000005],[-73.9292654227729,40.646550000000005],[-73.92839939736912,40.645050000000005],[-73.9292654227729,40.643550000000005],[-73.92839939736912,40.642050000000005],[-73.9292654227729,40.640550000000005],[-73.92839939736912,40.639050000000005],[-73.92666734656154,40.639050000000005],[-73.92580132115776,40.637550000000005],[-73.92666734656154,40.636050000000004],[-73.92839939736912,40.636050000000004],[-73.9292654227729,40.634550000000004]],[[-73.93879170221454,40.645050000000005],[-73.93705965140697,40.645050000000005],[-73.93619362600319,40.646550000000005],[-73.93705965140697,40.648050000000005],[-73.93879170221454,40.648050000000005],[-73.93965772761833,40.646550000000005],[-73.93879170221454,40.645050000000005]]],"type":"Polygon"}},{"id":"139","properties":{"borough":"queens","borocode":4,"neighborhood":"Queensbridge-Ravenswood-Long Island City"},"type":"Feature","geometry":{"coordinates":[[[-73.92666734656154,40.75005000000001],[-73.92839939736912,40.75005000000001],[-73.9292654227729,40.75155000000001],[-73.93099747358048,40.75155000000001],[-73.93186349898426,40.75005000000001],[-73.93359554979183,40.75005000000001],[-73.93446157519561,40.74855000000001],[-73.93619362600319,40.74855000000001],[-73.93705965140697,40.75005000000001],[-73.93879170221454,40.75005000000001],[-73.93965772761833,40.75155000000001],[-73.9413897784259,40.75155000000001],[-73.94225580382968,40.75305000000001],[-73.94398785463726,40.75305000000001],[-73.94485388004104,40.75455000000001],[-73.94658593084861,40.75455000000001],[-73.9474519562524,40.75605000000001],[-73.94918400705997,40.75605000000001],[-73.95005003246375,40.75755000000001],[-73.94918400705997,40.75905000000001],[-73.9474519562524,40.75905000000001],[-73.94658593084861,40.76055000000001],[-73.9474519562524,40.76205000000001],[-73.94658593084861,40.76355000000001],[-73.94485388004104,40.76355000000001],[-73.94398785463726,40.76505000000001],[-73.94225580382968,40.76505000000001],[-73.9413897784259,40.76655000000001],[-73.93965772761833,40.76655000000001],[-73.93879170221454,40.76805000000001],[-73.93965772761833,40.76955000000001],[-73.93879170221454,40.77105000000001],[-73.93705965140697,40.77105000000001],[-73.93619362600319,40.76955000000001],[-73.93705965140697,40.76805000000001],[-73.93619362600319,40.76655000000001],[-73.93705965140697,40.76505000000001],[-73.93619362600319,40.76355000000001],[-73.93446157519561,40.76355000000001],[-73.93359554979183,40.76205000000001],[-73.93446157519561,40.76055000000001],[-73.93359554979183,40.75905000000001],[-73.93446157519561,40.75755000000001],[-73.93359554979183,40.75605000000001],[-73.93186349898426,40.75605000000001],[-73.93099747358048,40.75755000000001],[-73.9292654227729,40.75755000000001],[-73.92839939736912,40.75605000000001],[-73.92666734656154,40.75605000000001],[-73.92580132115776,40.75455000000001],[-73.92406927035019,40.75455000000001],[-73.92320324494641,40.75305000000001],[-73.92406927035019,40.75155000000001],[-73.92580132115776,40.75155000000001],[-73.92666734656154,40.75005000000001]]],"type":"Polygon"}},{"id":"50","properties":{"borough":"manhattan","borocode":1,"neighborhood":"East Harlem North"},"type":"Feature","geometry":{"coordinates":[[[[-73.93965772761833,40.79055000000001],[-73.9413897784259,40.79055000000001],[-73.94225580382968,40.79205000000001],[-73.9413897784259,40.79355000000001],[-73.94225580382968,40.79505000000001],[-73.9413897784259,40.79655000000001],[-73.94225580382968,40.79805000000001],[-73.94398785463726,40.79805000000001],[-73.94485388004104,40.79955000000001],[-73.94658593084861,40.79955000000001],[-73.9474519562524,40.80105000000001],[-73.94658593084861,40.80255000000001],[-73.94485388004104,40.80255000000001],[-73.94398785463726,40.80405000000001],[-73.94225580382968,40.80405000000001],[-73.9413897784259,40.80555000000001],[-73.93965772761833,40.80555000000001],[-73.93879170221454,40.80705000000001],[-73.93705965140697,40.80705000000001],[-73.93619362600319,40.80855000000001],[-73.93446157519561,40.80855000000001],[-73.93359554979183,40.80705000000001],[-73.93186349898426,40.80705000000001],[-73.93099747358048,40.80555000000001],[-73.9292654227729,40.80555000000001],[-73.92839939736912,40.80405000000001],[-73.9292654227729,40.80255000000001],[-73.92839939736912,40.80105000000001],[-73.92666734656154,40.80105000000001],[-73.92580132115776,40.79955000000001],[-73.92666734656154,40.79805000000001],[-73.92839939736912,40.79805000000001],[-73.9292654227729,40.79655000000001],[-73.92839939736912,40.79505000000001],[-73.9292654227729,40.79355000000001],[-73.93099747358048,40.79355000000001],[-73.93186349898426,40.79205000000001],[-73.93359554979183,40.79205000000001],[-73.93446157519561,40.79355000000001],[-73.93619362600319,40.79355000000001],[-73.93705965140697,40.79205000000001],[-73.93879170221454,40.79205000000001],[-73.93965772761833,40.79055000000001]]],[[[-73.93446157519561,40.81155000000001],[-73.93619362600319,40.81155000000001],[-73.93705965140697,40.81305000000001],[-73.93619362600319,40.81455000000001],[-73.93446157519561,40.81455000000001],[-73.93359554979183,40.81305000000001],[-73.93446157519561,40.81155000000001]]]],"type":"MultiPolygon"}},{"id":"70","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Georgetown-Marine Park-Bergen Beach-Mill Basin"},"type":"Feature","geometry":{"coordinates":[[[-73.90328466065934,40.60455],[-73.90501671146691,40.60455],[-73.9058827368707,40.60605],[-73.90761478767827,40.60605],[-73.90848081308205,40.60455],[-73.90761478767827,40.60305],[-73.90848081308205,40.60155],[-73.91021286388963,40.60155],[-73.9110788892934,40.60305],[-73.91281094010098,40.60305],[-73.91367696550476,40.60155],[-73.91540901631234,40.60155],[-73.91627504171612,40.60305],[-73.91540901631234,40.60455],[-73.91627504171612,40.60605],[-73.9180070925237,40.60605],[-73.91887311792748,40.60455],[-73.92060516873505,40.60455],[-73.92147119413883,40.60605],[-73.92320324494641,40.60605],[-73.92406927035019,40.60455],[-73.92580132115776,40.60455],[-73.92666734656154,40.60605],[-73.92839939736912,40.60605],[-73.9292654227729,40.60455],[-73.93099747358048,40.60455],[-73.93186349898426,40.60605],[-73.93359554979183,40.60605],[-73.93446157519561,40.60755],[-73.93619362600319,40.60755],[-73.93705965140697,40.60905],[-73.93879170221454,40.60905],[-73.93965772761833,40.61055],[-73.9413897784259,40.61055],[-73.94225580382968,40.60905],[-73.94398785463726,40.60905],[-73.94485388004104,40.61055],[-73.94398785463726,40.61205],[-73.94485388004104,40.613550000000004],[-73.94398785463726,40.615050000000004],[-73.94485388004104,40.616550000000004],[-73.94398785463726,40.618050000000004],[-73.94225580382968,40.618050000000004],[-73.9413897784259,40.619550000000004],[-73.93965772761833,40.619550000000004],[-73.93879170221454,40.621050000000004],[-73.93705965140697,40.621050000000004],[-73.93619362600319,40.619550000000004],[-73.93446157519561,40.619550000000004],[-73.93359554979183,40.618050000000004],[-73.93186349898426,40.618050000000004],[-73.93099747358048,40.616550000000004],[-73.9292654227729,40.616550000000004],[-73.92839939736912,40.615050000000004],[-73.92666734656154,40.615050000000004],[-73.92580132115776,40.613550000000004],[-73.92406927035019,40.613550000000004],[-73.92320324494641,40.615050000000004],[-73.92147119413883,40.615050000000004],[-73.92060516873505,40.613550000000004],[-73.91887311792748,40.613550000000004],[-73.9180070925237,40.615050000000004],[-73.91627504171612,40.615050000000004],[-73.91540901631234,40.616550000000004],[-73.91627504171612,40.618050000000004],[-73.91540901631234,40.619550000000004],[-73.91627504171612,40.621050000000004],[-73.91540901631234,40.622550000000004],[-73.91627504171612,40.624050000000004],[-73.9180070925237,40.624050000000004],[-73.91887311792748,40.625550000000004],[-73.9180070925237,40.627050000000004],[-73.91627504171612,40.627050000000004],[-73.91540901631234,40.628550000000004],[-73.91367696550476,40.628550000000004],[-73.91281094010098,40.630050000000004],[-73.9110788892934,40.630050000000004],[-73.91021286388963,40.628550000000004],[-73.90848081308205,40.628550000000004],[-73.90761478767827,40.627050000000004],[-73.9058827368707,40.627050000000004],[-73.90501671146691,40.625550000000004],[-73.90328466065934,40.625550000000004],[-73.90241863525556,40.624050000000004],[-73.90328466065934,40.622550000000004],[-73.90241863525556,40.621050000000004],[-73.90068658444798,40.621050000000004],[-73.8998205590442,40.619550000000004],[-73.89808850823663,40.619550000000004],[-73.89722248283285,40.618050000000004],[-73.89808850823663,40.616550000000004],[-73.89722248283285,40.615050000000004],[-73.89808850823663,40.613550000000004],[-73.8998205590442,40.613550000000004],[-73.90068658444798,40.61205],[-73.8998205590442,40.61055],[-73.90068658444798,40.60905],[-73.8998205590442,40.60755],[-73.90068658444798,40.60605],[-73.90241863525556,40.60605],[-73.90328466065934,40.60455]]],"type":"Polygon"}},{"id":"161","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Stuyvesant Heights"},"type":"Feature","geometry":{"coordinates":[[[-73.93446157519561,40.679550000000006],[-73.93619362600319,40.679550000000006],[-73.93705965140697,40.681050000000006],[-73.93879170221454,40.681050000000006],[-73.93965772761833,40.682550000000006],[-73.9413897784259,40.682550000000006],[-73.94225580382968,40.684050000000006],[-73.9413897784259,40.685550000000006],[-73.94225580382968,40.687050000000006],[-73.9413897784259,40.688550000000006],[-73.94225580382968,40.69005000000001],[-73.9413897784259,40.69155000000001],[-73.94225580382968,40.69305000000001],[-73.94398785463726,40.69305000000001],[-73.94485388004104,40.69455000000001],[-73.94398785463726,40.69605000000001],[-73.94225580382968,40.69605000000001],[-73.9413897784259,40.69755000000001],[-73.93965772761833,40.69755000000001],[-73.93879170221454,40.69905000000001],[-73.93705965140697,40.69905000000001],[-73.93619362600319,40.69755000000001],[-73.93446157519561,40.69755000000001],[-73.93359554979183,40.69605000000001],[-73.93186349898426,40.69605000000001],[-73.93099747358048,40.69455000000001],[-73.9292654227729,40.69455000000001],[-73.92839939736912,40.69305000000001],[-73.92666734656154,40.69305000000001],[-73.92580132115776,40.69155000000001],[-73.92406927035019,40.69155000000001],[-73.92320324494641,40.69005000000001],[-73.92147119413883,40.69005000000001],[-73.92060516873505,40.688550000000006],[-73.91887311792748,40.688550000000006],[-73.9180070925237,40.687050000000006],[-73.91887311792748,40.685550000000006],[-73.9180070925237,40.684050000000006],[-73.91887311792748,40.682550000000006],[-73.9180070925237,40.681050000000006],[-73.91627504171612,40.681050000000006],[-73.91540901631234,40.679550000000006],[-73.91627504171612,40.678050000000006],[-73.9180070925237,40.678050000000006],[-73.91887311792748,40.679550000000006],[-73.92060516873505,40.679550000000006],[-73.92147119413883,40.678050000000006],[-73.92320324494641,40.678050000000006],[-73.92406927035019,40.679550000000006],[-73.92320324494641,40.681050000000006],[-73.92406927035019,40.682550000000006],[-73.92580132115776,40.682550000000006],[-73.92666734656154,40.684050000000006],[-73.92839939736912,40.684050000000006],[-73.9292654227729,40.682550000000006],[-73.93099747358048,40.682550000000006],[-73.93186349898426,40.684050000000006],[-73.93359554979183,40.684050000000006],[-73.93446157519561,40.682550000000006],[-73.93359554979183,40.681050000000006],[-73.93446157519561,40.679550000000006]]],"type":"Polygon"}},{"id":"25","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Bushwick South"},"type":"Feature","geometry":{"coordinates":[[[-73.90328466065934,40.679550000000006],[-73.90501671146691,40.679550000000006],[-73.9058827368707,40.681050000000006],[-73.90761478767827,40.681050000000006],[-73.90848081308205,40.682550000000006],[-73.91021286388963,40.682550000000006],[-73.9110788892934,40.684050000000006],[-73.91281094010098,40.684050000000006],[-73.91367696550476,40.685550000000006],[-73.91540901631234,40.685550000000006],[-73.91627504171612,40.687050000000006],[-73.9180070925237,40.687050000000006],[-73.91887311792748,40.688550000000006],[-73.92060516873505,40.688550000000006],[-73.92147119413883,40.69005000000001],[-73.92320324494641,40.69005000000001],[-73.92406927035019,40.69155000000001],[-73.92580132115776,40.69155000000001],[-73.92666734656154,40.69305000000001],[-73.92839939736912,40.69305000000001],[-73.9292654227729,40.69455000000001],[-73.93099747358048,40.69455000000001],[-73.93186349898426,40.69605000000001],[-73.93359554979183,40.69605000000001],[-73.93446157519561,40.69755000000001],[-73.93619362600319,40.69755000000001],[-73.93705965140697,40.69905000000001],[-73.93879170221454,40.69905000000001],[-73.93965772761833,40.69755000000001],[-73.9413897784259,40.69755000000001],[-73.94225580382968,40.69905000000001],[-73.9413897784259,40.70055000000001],[-73.93965772761833,40.70055000000001],[-73.93879170221454,40.70205000000001],[-73.93965772761833,40.70355000000001],[-73.9413897784259,40.70355000000001],[-73.94225580382968,40.70505000000001],[-73.9413897784259,40.70655000000001],[-73.94225580382968,40.70805000000001],[-73.94398785463726,40.70805000000001],[-73.94485388004104,40.70955000000001],[-73.94398785463726,40.71105000000001],[-73.94225580382968,40.71105000000001],[-73.9413897784259,40.70955000000001],[-73.93965772761833,40.70955000000001],[-73.93879170221454,40.71105000000001],[-73.93705965140697,40.71105000000001],[-73.93619362600319,40.71255000000001],[-73.93446157519561,40.71255000000001],[-73.93359554979183,40.71105000000001],[-73.93186349898426,40.71105000000001],[-73.93099747358048,40.70955000000001],[-73.93186349898426,40.70805000000001],[-73.93359554979183,40.70805000000001],[-73.93446157519561,40.70655000000001],[-73.93359554979183,40.70505000000001],[-73.93186349898426,40.70505000000001],[-73.93099747358048,40.70355000000001],[-73.9292654227729,40.70355000000001],[-73.92839939736912,40.70205000000001],[-73.92666734656154,40.70205000000001],[-73.92580132115776,40.70055000000001],[-73.92406927035019,40.70055000000001],[-73.92320324494641,40.69905000000001],[-73.92147119413883,40.69905000000001],[-73.92060516873505,40.69755000000001],[-73.91887311792748,40.69755000000001],[-73.9180070925237,40.69605000000001],[-73.91627504171612,40.69605000000001],[-73.91540901631234,40.69455000000001],[-73.91367696550476,40.69455000000001],[-73.91281094010098,40.69305000000001],[-73.9110788892934,40.69305000000001],[-73.91021286388963,40.69155000000001],[-73.90848081308205,40.69155000000001],[-73.90761478767827,40.69005000000001],[-73.9058827368707,40.69005000000001],[-73.90501671146691,40.688550000000006],[-73.90328466065934,40.688550000000006],[-73.90241863525556,40.687050000000006],[-73.90328466065934,40.685550000000006],[-73.90241863525556,40.684050000000006],[-73.90068658444798,40.684050000000006],[-73.8998205590442,40.682550000000006],[-73.90068658444798,40.681050000000006],[-73.90241863525556,40.681050000000006],[-73.90328466065934,40.679550000000006]]],"type":"Polygon"}},{"id":"172","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Washington Heights North"},"type":"Feature","geometry":{"coordinates":[[[[-73.9292654227729,40.84755000000001],[-73.93099747358048,40.84755000000001],[-73.93186349898426,40.84905000000001],[-73.93359554979183,40.84905000000001],[-73.93446157519561,40.85055000000001],[-73.93619362600319,40.85055000000001],[-73.93705965140697,40.85205000000001],[-73.93879170221454,40.85205000000001],[-73.93965772761833,40.85355000000001],[-73.9413897784259,40.85355000000001],[-73.94225580382968,40.85505000000001],[-73.9413897784259,40.85655000000001],[-73.93965772761833,40.85655000000001],[-73.93879170221454,40.85805000000001],[-73.93705965140697,40.85805000000001],[-73.93619362600319,40.85955000000001],[-73.93705965140697,40.86105000000001],[-73.93619362600319,40.86255000000001],[-73.93705965140697,40.86405000000001],[-73.93619362600319,40.86555000000001],[-73.93446157519561,40.86555000000001],[-73.93359554979183,40.86705000000001],[-73.93186349898426,40.86705000000001],[-73.93099747358048,40.86855000000001],[-73.9292654227729,40.86855000000001],[-73.92839939736912,40.86705000000001],[-73.92666734656154,40.86705000000001],[-73.92580132115776,40.86555000000001],[-73.92666734656154,40.86405000000001],[-73.92580132115776,40.86255000000001],[-73.92406927035019,40.86255000000001],[-73.92320324494641,40.86105000000001],[-73.92406927035019,40.85955000000001],[-73.92320324494641,40.85805000000001],[-73.92406927035019,40.85655000000001],[-73.92320324494641,40.85505000000001],[-73.92406927035019,40.85355000000001],[-73.92580132115776,40.85355000000001],[-73.92666734656154,40.85205000000001],[-73.92580132115776,40.85055000000001],[-73.92666734656154,40.84905000000001],[-73.92839939736912,40.84905000000001],[-73.9292654227729,40.84755000000001]]],[[[-73.94658593084861,40.85055000000001],[-73.9474519562524,40.85205000000001],[-73.94658593084861,40.85355000000001],[-73.94485388004104,40.85355000000001],[-73.94398785463726,40.85205000000001],[-73.94485388004104,40.85055000000001],[-73.94658593084861,40.85055000000001]]]],"type":"MultiPolygon"}},{"id":"4","properties":{"borough":"queens","borocode":4,"neighborhood":"Astoria"},"type":"Feature","geometry":{"coordinates":[[[-73.93186349898426,40.75605000000001],[-73.93359554979183,40.75605000000001],[-73.93446157519561,40.75755000000001],[-73.93359554979183,40.75905000000001],[-73.93446157519561,40.76055000000001],[-73.93359554979183,40.76205000000001],[-73.93446157519561,40.76355000000001],[-73.93619362600319,40.76355000000001],[-73.93705965140697,40.76505000000001],[-73.93619362600319,40.76655000000001],[-73.93446157519561,40.76655000000001],[-73.93359554979183,40.76805000000001],[-73.93186349898426,40.76805000000001],[-73.93099747358048,40.76655000000001],[-73.9292654227729,40.76655000000001],[-73.92839939736912,40.76505000000001],[-73.92666734656154,40.76505000000001],[-73.92580132115776,40.76655000000001],[-73.92406927035019,40.76655000000001],[-73.92320324494641,40.76805000000001],[-73.92147119413883,40.76805000000001],[-73.92060516873505,40.76655000000001],[-73.91887311792748,40.76655000000001],[-73.9180070925237,40.76805000000001],[-73.91887311792748,40.76955000000001],[-73.9180070925237,40.77105000000001],[-73.91627504171612,40.77105000000001],[-73.91540901631234,40.76955000000001],[-73.91367696550476,40.76955000000001],[-73.91281094010098,40.76805000000001],[-73.9110788892934,40.76805000000001],[-73.91021286388963,40.76955000000001],[-73.90848081308205,40.76955000000001],[-73.90761478767827,40.76805000000001],[-73.9058827368707,40.76805000000001],[-73.90501671146691,40.76655000000001],[-73.90328466065934,40.76655000000001],[-73.90241863525556,40.76505000000001],[-73.90328466065934,40.76355000000001],[-73.90501671146691,40.76355000000001],[-73.9058827368707,40.76205000000001],[-73.90761478767827,40.76205000000001],[-73.90848081308205,40.76055000000001],[-73.90761478767827,40.75905000000001],[-73.90848081308205,40.75755000000001],[-73.91021286388963,40.75755000000001],[-73.9110788892934,40.75605000000001],[-73.91021286388963,40.75455000000001],[-73.9110788892934,40.75305000000001],[-73.91281094010098,40.75305000000001],[-73.91367696550476,40.75155000000001],[-73.91540901631234,40.75155000000001],[-73.91627504171612,40.75305000000001],[-73.9180070925237,40.75305000000001],[-73.91887311792748,40.75155000000001],[-73.92060516873505,40.75155000000001],[-73.92147119413883,40.75305000000001],[-73.92320324494641,40.75305000000001],[-73.92406927035019,40.75455000000001],[-73.92580132115776,40.75455000000001],[-73.92666734656154,40.75605000000001],[-73.92839939736912,40.75605000000001],[-73.9292654227729,40.75755000000001],[-73.93099747358048,40.75755000000001],[-73.93186349898426,40.75605000000001]]],"type":"Polygon"}},{"id":"126","properties":{"borough":"queens","borocode":4,"neighborhood":"Old Astoria"},"type":"Feature","geometry":{"coordinates":[[[-73.93446157519561,40.76655000000001],[-73.93619362600319,40.76655000000001],[-73.93705965140697,40.76805000000001],[-73.93619362600319,40.76955000000001],[-73.93705965140697,40.77105000000001],[-73.93879170221454,40.77105000000001],[-73.93965772761833,40.77255000000001],[-73.93879170221454,40.77405000000001],[-73.93965772761833,40.77555000000001],[-73.93879170221454,40.77705000000001],[-73.93705965140697,40.77705000000001],[-73.93619362600319,40.77855000000001],[-73.93446157519561,40.77855000000001],[-73.93359554979183,40.78005000000001],[-73.93186349898426,40.78005000000001],[-73.93099747358048,40.77855000000001],[-73.9292654227729,40.77855000000001],[-73.92839939736912,40.77705000000001],[-73.92666734656154,40.77705000000001],[-73.92580132115776,40.77555000000001],[-73.92406927035019,40.77555000000001],[-73.92320324494641,40.77405000000001],[-73.92147119413883,40.77405000000001],[-73.92060516873505,40.77255000000001],[-73.91887311792748,40.77255000000001],[-73.9180070925237,40.77105000000001],[-73.91887311792748,40.76955000000001],[-73.9180070925237,40.76805000000001],[-73.91887311792748,40.76655000000001],[-73.92060516873505,40.76655000000001],[-73.92147119413883,40.76805000000001],[-73.92320324494641,40.76805000000001],[-73.92406927035019,40.76655000000001],[-73.92580132115776,40.76655000000001],[-73.92666734656154,40.76505000000001],[-73.92839939736912,40.76505000000001],[-73.9292654227729,40.76655000000001],[-73.93099747358048,40.76655000000001],[-73.93186349898426,40.76805000000001],[-73.93359554979183,40.76805000000001],[-73.93446157519561,40.76655000000001]]],"type":"Polygon"}},{"id":"24","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Bushwick North"},"type":"Feature","geometry":{"coordinates":[[[-73.90328466065934,40.688550000000006],[-73.90501671146691,40.688550000000006],[-73.9058827368707,40.69005000000001],[-73.90761478767827,40.69005000000001],[-73.90848081308205,40.69155000000001],[-73.91021286388963,40.69155000000001],[-73.9110788892934,40.69305000000001],[-73.91281094010098,40.69305000000001],[-73.91367696550476,40.69455000000001],[-73.91540901631234,40.69455000000001],[-73.91627504171612,40.69605000000001],[-73.9180070925237,40.69605000000001],[-73.91887311792748,40.69755000000001],[-73.92060516873505,40.69755000000001],[-73.92147119413883,40.69905000000001],[-73.92320324494641,40.69905000000001],[-73.92406927035019,40.70055000000001],[-73.92580132115776,40.70055000000001],[-73.92666734656154,40.70205000000001],[-73.92839939736912,40.70205000000001],[-73.9292654227729,40.70355000000001],[-73.93099747358048,40.70355000000001],[-73.93186349898426,40.70505000000001],[-73.93359554979183,40.70505000000001],[-73.93446157519561,40.70655000000001],[-73.93359554979183,40.70805000000001],[-73.93186349898426,40.70805000000001],[-73.93099747358048,40.70955000000001],[-73.9292654227729,40.70955000000001],[-73.92839939736912,40.70805000000001],[-73.92666734656154,40.70805000000001],[-73.92580132115776,40.70955000000001],[-73.92406927035019,40.70955000000001],[-73.92320324494641,40.71105000000001],[-73.92147119413883,40.71105000000001],[-73.92060516873505,40.70955000000001],[-73.92147119413883,40.70805000000001],[-73.92060516873505,40.70655000000001],[-73.91887311792748,40.70655000000001],[-73.9180070925237,40.70805000000001],[-73.91627504171612,40.70805000000001],[-73.91540901631234,40.70655000000001],[-73.91367696550476,40.70655000000001],[-73.91281094010098,40.70505000000001],[-73.91367696550476,40.70355000000001],[-73.91281094010098,40.70205000000001],[-73.9110788892934,40.70205000000001],[-73.91021286388963,40.70055000000001],[-73.9110788892934,40.69905000000001],[-73.91021286388963,40.69755000000001],[-73.90848081308205,40.69755000000001],[-73.90761478767827,40.69605000000001],[-73.9058827368707,40.69605000000001],[-73.90501671146691,40.69455000000001],[-73.90328466065934,40.69455000000001],[-73.90241863525556,40.69305000000001],[-73.90068658444798,40.69305000000001],[-73.8998205590442,40.69155000000001],[-73.90068658444798,40.69005000000001],[-73.90241863525556,40.69005000000001],[-73.90328466065934,40.688550000000006]]],"type":"Polygon"}},{"id":"81","properties":{"borough":"bronx","borocode":2,"neighborhood":"Highbridge"},"type":"Feature","geometry":{"coordinates":[[[-73.93186349898426,40.82805000000001],[-73.93359554979183,40.82805000000001],[-73.93446157519561,40.82955000000001],[-73.93359554979183,40.83105000000001],[-73.93446157519561,40.83255000000001],[-73.93359554979183,40.83405000000001],[-73.93186349898426,40.83405000000001],[-73.93099747358048,40.83555000000001],[-73.93186349898426,40.83705000000001],[-73.93099747358048,40.83855000000001],[-73.93186349898426,40.84005000000001],[-73.93099747358048,40.84155000000001],[-73.93186349898426,40.84305000000001],[-73.93099747358048,40.84455000000001],[-73.9292654227729,40.84455000000001],[-73.92839939736912,40.84605000000001],[-73.92666734656154,40.84605000000001],[-73.92580132115776,40.84455000000001],[-73.92406927035019,40.84455000000001],[-73.92320324494641,40.84605000000001],[-73.92147119413883,40.84605000000001],[-73.92060516873505,40.84455000000001],[-73.91887311792748,40.84455000000001],[-73.9180070925237,40.84305000000001],[-73.91887311792748,40.84155000000001],[-73.9180070925237,40.84005000000001],[-73.91887311792748,40.83855000000001],[-73.92060516873505,40.83855000000001],[-73.92147119413883,40.83705000000001],[-73.92320324494641,40.83705000000001],[-73.92406927035019,40.83555000000001],[-73.92320324494641,40.83405000000001],[-73.92406927035019,40.83255000000001],[-73.92580132115776,40.83255000000001],[-73.92666734656154,40.83105000000001],[-73.92580132115776,40.82955000000001],[-73.92666734656154,40.82805000000001],[-73.92839939736912,40.82805000000001],[-73.9292654227729,40.82955000000001],[-73.93099747358048,40.82955000000001],[-73.93186349898426,40.82805000000001]]],"type":"Polygon"}},{"id":"145","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Rugby-Remsen Village"},"type":"Feature","geometry":{"coordinates":[[[-73.92666734656154,40.639050000000005],[-73.92839939736912,40.639050000000005],[-73.9292654227729,40.640550000000005],[-73.92839939736912,40.642050000000005],[-73.9292654227729,40.643550000000005],[-73.92839939736912,40.645050000000005],[-73.9292654227729,40.646550000000005],[-73.93099747358048,40.646550000000005],[-73.93186349898426,40.648050000000005],[-73.93099747358048,40.649550000000005],[-73.93186349898426,40.651050000000005],[-73.93099747358048,40.652550000000005],[-73.93186349898426,40.654050000000005],[-73.93099747358048,40.655550000000005],[-73.9292654227729,40.655550000000005],[-73.92839939736912,40.657050000000005],[-73.9292654227729,40.658550000000005],[-73.92839939736912,40.660050000000005],[-73.9292654227729,40.661550000000005],[-73.93099747358048,40.661550000000005],[-73.93186349898426,40.663050000000005],[-73.93099747358048,40.664550000000006],[-73.9292654227729,40.664550000000006],[-73.92839939736912,40.666050000000006],[-73.92666734656154,40.666050000000006],[-73.92580132115776,40.664550000000006],[-73.92406927035019,40.664550000000006],[-73.92320324494641,40.663050000000005],[-73.92147119413883,40.663050000000005],[-73.92060516873505,40.661550000000005],[-73.91887311792748,40.661550000000005],[-73.9180070925237,40.660050000000005],[-73.91627504171612,40.660050000000005],[-73.91540901631234,40.658550000000005],[-73.91367696550476,40.658550000000005],[-73.91281094010098,40.657050000000005],[-73.91367696550476,40.655550000000005],[-73.91281094010098,40.654050000000005],[-73.9110788892934,40.654050000000005],[-73.91021286388963,40.652550000000005],[-73.90848081308205,40.652550000000005],[-73.90761478767827,40.651050000000005],[-73.90848081308205,40.649550000000005],[-73.91021286388963,40.649550000000005],[-73.9110788892934,40.648050000000005],[-73.91281094010098,40.648050000000005],[-73.91367696550476,40.646550000000005],[-73.91540901631234,40.646550000000005],[-73.91627504171612,40.645050000000005],[-73.9180070925237,40.645050000000005],[-73.91887311792748,40.643550000000005],[-73.92060516873505,40.643550000000005],[-73.92147119413883,40.642050000000005],[-73.92320324494641,40.642050000000005],[-73.92406927035019,40.640550000000005],[-73.92580132115776,40.640550000000005],[-73.92666734656154,40.639050000000005]]],"type":"Polygon"}},{"id":"175","properties":{"borough":"bronx","borocode":2,"neighborhood":"West Concourse"},"type":"Feature","geometry":{"coordinates":[[[-73.93186349898426,40.81305000000001],[-73.93359554979183,40.81305000000001],[-73.93446157519561,40.81455000000001],[-73.93359554979183,40.81605000000001],[-73.93446157519561,40.81755000000001],[-73.93359554979183,40.81905000000001],[-73.93446157519561,40.82055000000001],[-73.93359554979183,40.82205000000001],[-73.93446157519561,40.82355000000001],[-73.93359554979183,40.82505000000001],[-73.93446157519561,40.82655000000001],[-73.93359554979183,40.82805000000001],[-73.93186349898426,40.82805000000001],[-73.93099747358048,40.82955000000001],[-73.9292654227729,40.82955000000001],[-73.92839939736912,40.82805000000001],[-73.92666734656154,40.82805000000001],[-73.92580132115776,40.82955000000001],[-73.92666734656154,40.83105000000001],[-73.92580132115776,40.83255000000001],[-73.92406927035019,40.83255000000001],[-73.92320324494641,40.83405000000001],[-73.92406927035019,40.83555000000001],[-73.92320324494641,40.83705000000001],[-73.92147119413883,40.83705000000001],[-73.92060516873505,40.83855000000001],[-73.91887311792748,40.83855000000001],[-73.9180070925237,40.84005000000001],[-73.91887311792748,40.84155000000001],[-73.9180070925237,40.84305000000001],[-73.91887311792748,40.84455000000001],[-73.9180070925237,40.84605000000001],[-73.91627504171612,40.84605000000001],[-73.91540901631234,40.84455000000001],[-73.91367696550476,40.84455000000001],[-73.91281094010098,40.84305000000001],[-73.91367696550476,40.84155000000001],[-73.91281094010098,40.84005000000001],[-73.91367696550476,40.83855000000001],[-73.91540901631234,40.83855000000001],[-73.91627504171612,40.83705000000001],[-73.91540901631234,40.83555000000001],[-73.91627504171612,40.83405000000001],[-73.9180070925237,40.83405000000001],[-73.91887311792748,40.83255000000001],[-73.92060516873505,40.83255000000001],[-73.92147119413883,40.83105000000001],[-73.92060516873505,40.82955000000001],[-73.92147119413883,40.82805000000001],[-73.92320324494641,40.82805000000001],[-73.92406927035019,40.82655000000001],[-73.92320324494641,40.82505000000001],[-73.92406927035019,40.82355000000001],[-73.92580132115776,40.82355000000001],[-73.92666734656154,40.82205000000001],[-73.92580132115776,40.82055000000001],[-73.92666734656154,40.81905000000001],[-73.92580132115776,40.81755000000001],[-73.92666734656154,40.81605000000001],[-73.92839939736912,40.81605000000001],[-73.9292654227729,40.81455000000001],[-73.93099747358048,40.81455000000001],[-73.93186349898426,40.81305000000001]]],"type":"Polygon"}},{"id":"111","properties":{"borough":"bronx","borocode":2,"neighborhood":"Mott Haven-Port Morris"},"type":"Feature","geometry":{"coordinates":[[[[-73.8998205590442,40.79955000000001],[-73.90068658444798,40.80105000000001],[-73.8998205590442,40.80255000000001],[-73.89808850823663,40.80255000000001],[-73.89722248283285,40.80105000000001],[-73.89808850823663,40.79955000000001],[-73.8998205590442,40.79955000000001]]],[[[-73.92060516873505,40.79655000000001],[-73.92147119413883,40.79805000000001],[-73.92060516873505,40.79955000000001],[-73.92147119413883,40.80105000000001],[-73.92320324494641,40.80105000000001],[-73.92406927035019,40.80255000000001],[-73.92580132115776,40.80255000000001],[-73.92666734656154,40.80405000000001],[-73.92839939736912,40.80405000000001],[-73.9292654227729,40.80555000000001],[-73.93099747358048,40.80555000000001],[-73.93186349898426,40.80705000000001],[-73.93359554979183,40.80705000000001],[-73.93446157519561,40.80855000000001],[-73.93359554979183,40.81005000000001],[-73.93446157519561,40.81155000000001],[-73.93359554979183,40.81305000000001],[-73.93186349898426,40.81305000000001],[-73.93099747358048,40.81455000000001],[-73.9292654227729,40.81455000000001],[-73.92839939736912,40.81605000000001],[-73.92666734656154,40.81605000000001],[-73.92580132115776,40.81755000000001],[-73.92406927035019,40.81755000000001],[-73.92320324494641,40.81605000000001],[-73.92147119413883,40.81605000000001],[-73.92060516873505,40.81455000000001],[-73.91887311792748,40.81455000000001],[-73.9180070925237,40.81605000000001],[-73.91627504171612,40.81605000000001],[-73.91540901631234,40.81455000000001],[-73.91367696550476,40.81455000000001],[-73.91281094010098,40.81305000000001],[-73.9110788892934,40.81305000000001],[-73.91021286388963,40.81455000000001],[-73.90848081308205,40.81455000000001],[-73.90761478767827,40.81305000000001],[-73.9058827368707,40.81305000000001],[-73.90501671146691,40.81155000000001],[-73.90328466065934,40.81155000000001],[-73.90241863525556,40.81005000000001],[-73.90328466065934,40.80855000000001],[-73.90241863525556,40.80705000000001],[-73.90068658444798,40.80705000000001],[-73.8998205590442,40.80555000000001],[-73.90068658444798,40.80405000000001],[-73.90241863525556,40.80405000000001],[-73.90328466065934,40.80255000000001],[-73.90501671146691,40.80255000000001],[-73.9058827368707,40.80105000000001],[-73.90501671146691,40.79955000000001],[-73.9058827368707,40.79805000000001],[-73.90761478767827,40.79805000000001],[-73.90848081308205,40.79655000000001],[-73.91021286388963,40.79655000000001],[-73.9110788892934,40.79505000000001],[-73.91281094010098,40.79505000000001],[-73.91367696550476,40.79655000000001],[-73.91540901631234,40.79655000000001],[-73.91627504171612,40.79805000000001],[-73.9180070925237,40.79805000000001],[-73.91887311792748,40.79655000000001],[-73.92060516873505,40.79655000000001]]]],"type":"MultiPolygon"}},{"id":"102","properties":{"borough":"manhattan","borocode":1,"neighborhood":"Marble Hill-Inwood"},"type":"Feature","geometry":{"coordinates":[[[-73.92320324494641,40.85805000000001],[-73.92406927035019,40.85955000000001],[-73.92320324494641,40.86105000000001],[-73.92406927035019,40.86255000000001],[-73.92580132115776,40.86255000000001],[-73.92666734656154,40.86405000000001],[-73.92580132115776,40.86555000000001],[-73.92666734656154,40.86705000000001],[-73.92839939736912,40.86705000000001],[-73.9292654227729,40.86855000000001],[-73.92839939736912,40.87005000000001],[-73.92666734656154,40.87005000000001],[-73.92580132115776,40.87155000000001],[-73.92406927035019,40.87155000000001],[-73.92320324494641,40.87005000000001],[-73.92147119413883,40.87005000000001],[-73.92060516873505,40.87155000000001],[-73.92147119413883,40.87305000000001],[-73.92060516873505,40.87455000000001],[-73.91887311792748,40.87455000000001],[-73.9180070925237,40.87305000000001],[-73.91627504171612,40.87305000000001],[-73.91540901631234,40.87455000000001],[-73.91627504171612,40.87605000000001],[-73.91540901631234,40.877550000000014],[-73.91367696550476,40.877550000000014],[-73.91281094010098,40.879050000000014],[-73.9110788892934,40.879050000000014],[-73.91021286388963,40.877550000000014],[-73.90848081308205,40.877550000000014],[-73.90761478767827,40.87605000000001],[-73.90848081308205,40.87455000000001],[-73.90761478767827,40.87305000000001],[-73.90848081308205,40.87155000000001],[-73.91021286388963,40.87155000000001],[-73.9110788892934,40.87005000000001],[-73.91021286388963,40.86855000000001],[-73.9110788892934,40.86705000000001],[-73.91281094010098,40.86705000000001],[-73.91367696550476,40.86855000000001],[-73.91540901631234,40.86855000000001],[-73.91627504171612,40.86705000000001],[-73.91540901631234,40.86555000000001],[-73.91367696550476,40.86555000000001],[-73.91281094010098,40.86405000000001],[-73.91367696550476,40.86255000000001],[-73.91540901631234,40.86255000000001],[-73.91627504171612,40.86105000000001],[-73.9180070925237,40.86105000000001],[-73.91887311792748,40.85955000000001],[-73.92060516873505,40.85955000000001],[-73.92147119413883,40.85805000000001],[-73.92320324494641,40.85805000000001]]],"type":"Polygon"}},{"id":"23","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Brownsville"},"type":"Feature","geometry":{"coordinates":[[[-73.90328466065934,40.652550000000005],[-73.90501671146691,40.652550000000005],[-73.9058827368707,40.654050000000005],[-73.90761478767827,40.654050000000005],[-73.90848081308205,40.652550000000005],[-73.91021286388963,40.652550000000005],[-73.9110788892934,40.654050000000005],[-73.91281094010098,40.654050000000005],[-73.91367696550476,40.655550000000005],[-73.91281094010098,40.657050000000005],[-73.91367696550476,40.658550000000005],[-73.91540901631234,40.658550000000005],[-73.91627504171612,40.660050000000005],[-73.9180070925237,40.660050000000005],[-73.91887311792748,40.661550000000005],[-73.92060516873505,40.661550000000005],[-73.92147119413883,40.663050000000005],[-73.92320324494641,40.663050000000005],[-73.92406927035019,40.664550000000006],[-73.92580132115776,40.664550000000006],[-73.92666734656154,40.666050000000006],[-73.92580132115776,40.667550000000006],[-73.92406927035019,40.667550000000006],[-73.92320324494641,40.669050000000006],[-73.92147119413883,40.669050000000006],[-73.92060516873505,40.667550000000006],[-73.91887311792748,40.667550000000006],[-73.9180070925237,40.669050000000006],[-73.91627504171612,40.669050000000006],[-73.91540901631234,40.670550000000006],[-73.91367696550476,40.670550000000006],[-73.91281094010098,40.672050000000006],[-73.9110788892934,40.672050000000006],[-73.91021286388963,40.670550000000006],[-73.90848081308205,40.670550000000006],[-73.90761478767827,40.672050000000006],[-73.90848081308205,40.673550000000006],[-73.90761478767827,40.675050000000006],[-73.9058827368707,40.675050000000006],[-73.90501671146691,40.673550000000006],[-73.90328466065934,40.673550000000006],[-73.90241863525556,40.672050000000006],[-73.90328466065934,40.670550000000006],[-73.90241863525556,40.669050000000006],[-73.90328466065934,40.667550000000006],[-73.90241863525556,40.666050000000006],[-73.90068658444798,40.666050000000006],[-73.8998205590442,40.664550000000006],[-73.90068658444798,40.663050000000005],[-73.8998205590442,40.661550000000005],[-73.90068658444798,40.660050000000005],[-73.8998205590442,40.658550000000005],[-73.90068658444798,40.657050000000005],[-73.90241863525556,40.657050000000005],[-73.90328466065934,40.655550000000005],[-73.90241863525556,40.654050000000005],[-73.90328466065934,40.652550000000005]]],"type":"Polygon"}},{"id":"160","properties":{"borough":"queens","borocode":4,"neighborhood":"Steinway"},"type":"Feature","geometry":{"coordinates":[[[-73.90068658444798,40.76505000000001],[-73.90241863525556,40.76505000000001],[-73.90328466065934,40.76655000000001],[-73.90501671146691,40.76655000000001],[-73.9058827368707,40.76805000000001],[-73.90761478767827,40.76805000000001],[-73.90848081308205,40.76955000000001],[-73.91021286388963,40.76955000000001],[-73.9110788892934,40.76805000000001],[-73.91281094010098,40.76805000000001],[-73.91367696550476,40.76955000000001],[-73.91540901631234,40.76955000000001],[-73.91627504171612,40.77105000000001],[-73.9180070925237,40.77105000000001],[-73.91887311792748,40.77255000000001],[-73.92060516873505,40.77255000000001],[-73.92147119413883,40.77405000000001],[-73.92320324494641,40.77405000000001],[-73.92406927035019,40.77555000000001],[-73.92580132115776,40.77555000000001],[-73.92666734656154,40.77705000000001],[-73.92580132115776,40.77855000000001],[-73.92406927035019,40.77855000000001],[-73.92320324494641,40.78005000000001],[-73.92147119413883,40.78005000000001],[-73.92060516873505,40.78155000000001],[-73.92147119413883,40.78305000000001],[-73.92060516873505,40.78455000000001],[-73.91887311792748,40.78455000000001],[-73.9180070925237,40.78605000000001],[-73.91627504171612,40.78605000000001],[-73.91540901631234,40.78755000000001],[-73.91627504171612,40.78905000000001],[-73.91540901631234,40.79055000000001],[-73.91367696550476,40.79055000000001],[-73.91281094010098,40.78905000000001],[-73.91367696550476,40.78755000000001],[-73.91281094010098,40.78605000000001],[-73.9110788892934,40.78605000000001],[-73.91021286388963,40.78455000000001],[-73.90848081308205,40.78455000000001],[-73.90761478767827,40.78305000000001],[-73.9058827368707,40.78305000000001],[-73.90501671146691,40.78155000000001],[-73.90328466065934,40.78155000000001],[-73.90241863525556,40.78305000000001],[-73.90328466065934,40.78455000000001],[-73.90501671146691,40.78455000000001],[-73.9058827368707,40.78605000000001],[-73.90761478767827,40.78605000000001],[-73.90848081308205,40.78755000000001],[-73.90761478767827,40.78905000000001],[-73.9058827368707,40.78905000000001],[-73.90501671146691,40.79055000000001],[-73.90328466065934,40.79055000000001],[-73.90241863525556,40.78905000000001],[-73.90068658444798,40.78905000000001],[-73.8998205590442,40.79055000000001],[-73.89808850823663,40.79055000000001],[-73.89722248283285,40.78905000000001],[-73.89808850823663,40.78755000000001],[-73.89722248283285,40.78605000000001],[-73.89808850823663,40.78455000000001],[-73.8998205590442,40.78455000000001],[-73.90068658444798,40.78305000000001],[-73.8998205590442,40.78155000000001],[-73.89808850823663,40.78155000000001],[-73.89722248283285,40.78305000000001],[-73.89549043202527,40.78305000000001],[-73.89462440662149,40.78155000000001],[-73.89549043202527,40.78005000000001],[-73.89462440662149,40.77855000000001],[-73.89289235581391,40.77855000000001],[-73.89202633041013,40.77705000000001],[-73.89029427960256,40.77705000000001],[-73.88942825419878,40.77555000000001],[-73.8876962033912,40.77555000000001],[-73.88683017798742,40.77405000000001],[-73.8876962033912,40.77255000000001],[-73.88683017798742,40.77105000000001],[-73.8876962033912,40.76955000000001],[-73.88683017798742,40.76805000000001],[-73.8876962033912,40.76655000000001],[-73.88942825419878,40.76655000000001],[-73.89029427960256,40.76505000000001],[-73.89202633041013,40.76505000000001],[-73.89289235581391,40.76655000000001],[-73.89462440662149,40.76655000000001],[-73.89549043202527,40.76505000000001],[-73.89722248283285,40.76505000000001],[-73.89808850823663,40.76655000000001],[-73.8998205590442,40.76655000000001],[-73.90068658444798,40.76505000000001]]],"type":"Polygon"}},{"id":"167","properties":{"borough":"bronx","borocode":2,"neighborhood":"University Heights-Morris Heights"},"type":"Feature","geometry":{"coordinates":[[[-73.91367696550476,40.84455000000001],[-73.91540901631234,40.84455000000001],[-73.91627504171612,40.84605000000001],[-73.9180070925237,40.84605000000001],[-73.91887311792748,40.84455000000001],[-73.92060516873505,40.84455000000001],[-73.92147119413883,40.84605000000001],[-73.92320324494641,40.84605000000001],[-73.92406927035019,40.84455000000001],[-73.92580132115776,40.84455000000001],[-73.92666734656154,40.84605000000001],[-73.92839939736912,40.84605000000001],[-73.9292654227729,40.84755000000001],[-73.92839939736912,40.84905000000001],[-73.92666734656154,40.84905000000001],[-73.92580132115776,40.85055000000001],[-73.92666734656154,40.85205000000001],[-73.92580132115776,40.85355000000001],[-73.92406927035019,40.85355000000001],[-73.92320324494641,40.85505000000001],[-73.92147119413883,40.85505000000001],[-73.92060516873505,40.85655000000001],[-73.91887311792748,40.85655000000001],[-73.9180070925237,40.85805000000001],[-73.91887311792748,40.85955000000001],[-73.9180070925237,40.86105000000001],[-73.91627504171612,40.86105000000001],[-73.91540901631234,40.86255000000001],[-73.91367696550476,40.86255000000001],[-73.91281094010098,40.86405000000001],[-73.9110788892934,40.86405000000001],[-73.91021286388963,40.86255000000001],[-73.9110788892934,40.86105000000001],[-73.91021286388963,40.85955000000001],[-73.90848081308205,40.85955000000001],[-73.90761478767827,40.86105000000001],[-73.9058827368707,40.86105000000001],[-73.90501671146691,40.85955000000001],[-73.9058827368707,40.85805000000001],[-73.90501671146691,40.85655000000001],[-73.9058827368707,40.85505000000001],[-73.90761478767827,40.85505000000001],[-73.90848081308205,40.85355000000001],[-73.90761478767827,40.85205000000001],[-73.90848081308205,40.85055000000001],[-73.91021286388963,40.85055000000001],[-73.9110788892934,40.84905000000001],[-73.91281094010098,40.84905000000001],[-73.91367696550476,40.84755000000001],[-73.91281094010098,40.84605000000001],[-73.91367696550476,40.84455000000001]]],"type":"Polygon"}},{"id":"124","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Ocean Hill"},"type":"Feature","geometry":{"coordinates":[[[-73.91887311792748,40.667550000000006],[-73.92060516873505,40.667550000000006],[-73.92147119413883,40.669050000000006],[-73.92320324494641,40.669050000000006],[-73.92406927035019,40.670550000000006],[-73.92320324494641,40.672050000000006],[-73.92147119413883,40.672050000000006],[-73.92060516873505,40.673550000000006],[-73.92147119413883,40.675050000000006],[-73.92060516873505,40.676550000000006],[-73.92147119413883,40.678050000000006],[-73.92060516873505,40.679550000000006],[-73.91887311792748,40.679550000000006],[-73.9180070925237,40.678050000000006],[-73.91627504171612,40.678050000000006],[-73.91540901631234,40.679550000000006],[-73.91627504171612,40.681050000000006],[-73.9180070925237,40.681050000000006],[-73.91887311792748,40.682550000000006],[-73.9180070925237,40.684050000000006],[-73.91887311792748,40.685550000000006],[-73.9180070925237,40.687050000000006],[-73.91627504171612,40.687050000000006],[-73.91540901631234,40.685550000000006],[-73.91367696550476,40.685550000000006],[-73.91281094010098,40.684050000000006],[-73.9110788892934,40.684050000000006],[-73.91021286388963,40.682550000000006],[-73.90848081308205,40.682550000000006],[-73.90761478767827,40.681050000000006],[-73.9058827368707,40.681050000000006],[-73.90501671146691,40.679550000000006],[-73.90328466065934,40.679550000000006],[-73.90241863525556,40.678050000000006],[-73.90328466065934,40.676550000000006],[-73.90241863525556,40.675050000000006],[-73.90328466065934,40.673550000000006],[-73.90501671146691,40.673550000000006],[-73.9058827368707,40.675050000000006],[-73.90761478767827,40.675050000000006],[-73.90848081308205,40.673550000000006],[-73.90761478767827,40.672050000000006],[-73.90848081308205,40.670550000000006],[-73.91021286388963,40.670550000000006],[-73.9110788892934,40.672050000000006],[-73.91281094010098,40.672050000000006],[-73.91367696550476,40.670550000000006],[-73.91540901631234,40.670550000000006],[-73.91627504171612,40.669050000000006],[-73.9180070925237,40.669050000000006],[-73.91887311792748,40.667550000000006]]],"type":"Polygon"}},{"id":"105","properties":{"borough":"bronx","borocode":2,"neighborhood":"Melrose South-Mott Haven North"},"type":"Feature","geometry":{"coordinates":[[[-73.91887311792748,40.81455000000001],[-73.92060516873505,40.81455000000001],[-73.92147119413883,40.81605000000001],[-73.92320324494641,40.81605000000001],[-73.92406927035019,40.81755000000001],[-73.92320324494641,40.81905000000001],[-73.92406927035019,40.82055000000001],[-73.92320324494641,40.82205000000001],[-73.92147119413883,40.82205000000001],[-73.92060516873505,40.82055000000001],[-73.91887311792748,40.82055000000001],[-73.9180070925237,40.82205000000001],[-73.91887311792748,40.82355000000001],[-73.9180070925237,40.82505000000001],[-73.91627504171612,40.82505000000001],[-73.91540901631234,40.82355000000001],[-73.91367696550476,40.82355000000001],[-73.91281094010098,40.82205000000001],[-73.9110788892934,40.82205000000001],[-73.91021286388963,40.82055000000001],[-73.90848081308205,40.82055000000001],[-73.90761478767827,40.82205000000001],[-73.9058827368707,40.82205000000001],[-73.90501671146691,40.82355000000001],[-73.90328466065934,40.82355000000001],[-73.90241863525556,40.82205000000001],[-73.90068658444798,40.82205000000001],[-73.8998205590442,40.82055000000001],[-73.90068658444798,40.81905000000001],[-73.90241863525556,40.81905000000001],[-73.90328466065934,40.81755000000001],[-73.90241863525556,40.81605000000001],[-73.90328466065934,40.81455000000001],[-73.90501671146691,40.81455000000001],[-73.9058827368707,40.81305000000001],[-73.90761478767827,40.81305000000001],[-73.90848081308205,40.81455000000001],[-73.91021286388963,40.81455000000001],[-73.9110788892934,40.81305000000001],[-73.91281094010098,40.81305000000001],[-73.91367696550476,40.81455000000001],[-73.91540901631234,40.81455000000001],[-73.91627504171612,40.81605000000001],[-73.9180070925237,40.81605000000001],[-73.91887311792748,40.81455000000001]]],"type":"Polygon"}},{"id":"46","properties":{"borough":"bronx","borocode":2,"neighborhood":"East Concourse-Concourse Village"},"type":"Feature","geometry":{"coordinates":[[[-73.92406927035019,40.81755000000001],[-73.92580132115776,40.81755000000001],[-73.92666734656154,40.81905000000001],[-73.92580132115776,40.82055000000001],[-73.92666734656154,40.82205000000001],[-73.92580132115776,40.82355000000001],[-73.92406927035019,40.82355000000001],[-73.92320324494641,40.82505000000001],[-73.92406927035019,40.82655000000001],[-73.92320324494641,40.82805000000001],[-73.92147119413883,40.82805000000001],[-73.92060516873505,40.82955000000001],[-73.92147119413883,40.83105000000001],[-73.92060516873505,40.83255000000001],[-73.91887311792748,40.83255000000001],[-73.9180070925237,40.83405000000001],[-73.91627504171612,40.83405000000001],[-73.91540901631234,40.83555000000001],[-73.91627504171612,40.83705000000001],[-73.91540901631234,40.83855000000001],[-73.91367696550476,40.83855000000001],[-73.91281094010098,40.84005000000001],[-73.91367696550476,40.84155000000001],[-73.91281094010098,40.84305000000001],[-73.9110788892934,40.84305000000001],[-73.91021286388963,40.84155000000001],[-73.90848081308205,40.84155000000001],[-73.90761478767827,40.84005000000001],[-73.9058827368707,40.84005000000001],[-73.90501671146691,40.83855000000001],[-73.9058827368707,40.83705000000001],[-73.90501671146691,40.83555000000001],[-73.9058827368707,40.83405000000001],[-73.90761478767827,40.83405000000001],[-73.90848081308205,40.83255000000001],[-73.91021286388963,40.83255000000001],[-73.9110788892934,40.83105000000001],[-73.91021286388963,40.82955000000001],[-73.9110788892934,40.82805000000001],[-73.91281094010098,40.82805000000001],[-73.91367696550476,40.82655000000001],[-73.91540901631234,40.82655000000001],[-73.91627504171612,40.82505000000001],[-73.9180070925237,40.82505000000001],[-73.91887311792748,40.82355000000001],[-73.9180070925237,40.82205000000001],[-73.91887311792748,40.82055000000001],[-73.92060516873505,40.82055000000001],[-73.92147119413883,40.82205000000001],[-73.92320324494641,40.82205000000001],[-73.92406927035019,40.82055000000001],[-73.92320324494641,40.81905000000001],[-73.92406927035019,40.81755000000001]]],"type":"Polygon"}},{"id":"156","properties":{"borough":"bronx","borocode":2,"neighborhood":"Spuyten Duyvil-Kingsbridge"},"type":"Feature","geometry":{"coordinates":[[[-73.9058827368707,40.87305000000001],[-73.90761478767827,40.87305000000001],[-73.90848081308205,40.87455000000001],[-73.90761478767827,40.87605000000001],[-73.90848081308205,40.877550000000014],[-73.91021286388963,40.877550000000014],[-73.9110788892934,40.879050000000014],[-73.91281094010098,40.879050000000014],[-73.91367696550476,40.877550000000014],[-73.91540901631234,40.877550000000014],[-73.91627504171612,40.87605000000001],[-73.9180070925237,40.87605000000001],[-73.91887311792748,40.87455000000001],[-73.92060516873505,40.87455000000001],[-73.92147119413883,40.87605000000001],[-73.92320324494641,40.87605000000001],[-73.92406927035019,40.877550000000014],[-73.92320324494641,40.879050000000014],[-73.92406927035019,40.880550000000014],[-73.92320324494641,40.882050000000014],[-73.92406927035019,40.883550000000014],[-73.92320324494641,40.885050000000014],[-73.92147119413883,40.885050000000014],[-73.92060516873505,40.886550000000014],[-73.91887311792748,40.886550000000014],[-73.9180070925237,40.888050000000014],[-73.91627504171612,40.888050000000014],[-73.91540901631234,40.886550000000014],[-73.91367696550476,40.886550000000014],[-73.91281094010098,40.888050000000014],[-73.9110788892934,40.888050000000014],[-73.91021286388963,40.889550000000014],[-73.90848081308205,40.889550000000014],[-73.90761478767827,40.888050000000014],[-73.9058827368707,40.888050000000014],[-73.90501671146691,40.886550000000014],[-73.90328466065934,40.886550000000014],[-73.90241863525556,40.888050000000014],[-73.90328466065934,40.889550000000014],[-73.90241863525556,40.891050000000014],[-73.90068658444798,40.891050000000014],[-73.8998205590442,40.889550000000014],[-73.89808850823663,40.889550000000014],[-73.89722248283285,40.888050000000014],[-73.89808850823663,40.886550000000014],[-73.89722248283285,40.885050000000014],[-73.89808850823663,40.883550000000014],[-73.8998205590442,40.883550000000014],[-73.90068658444798,40.882050000000014],[-73.90241863525556,40.882050000000014],[-73.90328466065934,40.880550000000014],[-73.90241863525556,40.879050000000014],[-73.90328466065934,40.877550000000014],[-73.90501671146691,40.877550000000014],[-73.9058827368707,40.87605000000001],[-73.90501671146691,40.87455000000001],[-73.9058827368707,40.87305000000001]]],"type":"Polygon"}},{"id":"142","properties":{"borough":"queens","borocode":4,"neighborhood":"Ridgewood"},"type":"Feature","geometry":{"coordinates":[[[-73.90068658444798,40.69305000000001],[-73.90241863525556,40.69305000000001],[-73.90328466065934,40.69455000000001],[-73.90501671146691,40.69455000000001],[-73.9058827368707,40.69605000000001],[-73.90761478767827,40.69605000000001],[-73.90848081308205,40.69755000000001],[-73.91021286388963,40.69755000000001],[-73.9110788892934,40.69905000000001],[-73.91021286388963,40.70055000000001],[-73.9110788892934,40.70205000000001],[-73.91281094010098,40.70205000000001],[-73.91367696550476,40.70355000000001],[-73.91281094010098,40.70505000000001],[-73.91367696550476,40.70655000000001],[-73.91540901631234,40.70655000000001],[-73.91627504171612,40.70805000000001],[-73.9180070925237,40.70805000000001],[-73.91887311792748,40.70655000000001],[-73.92060516873505,40.70655000000001],[-73.92147119413883,40.70805000000001],[-73.92060516873505,40.70955000000001],[-73.92147119413883,40.71105000000001],[-73.92060516873505,40.71255000000001],[-73.92147119413883,40.71405000000001],[-73.92060516873505,40.71555000000001],[-73.91887311792748,40.71555000000001],[-73.9180070925237,40.71405000000001],[-73.91627504171612,40.71405000000001],[-73.91540901631234,40.71255000000001],[-73.91367696550476,40.71255000000001],[-73.91281094010098,40.71405000000001],[-73.9110788892934,40.71405000000001],[-73.91021286388963,40.71555000000001],[-73.9110788892934,40.71705000000001],[-73.91021286388963,40.71855000000001],[-73.90848081308205,40.71855000000001],[-73.90761478767827,40.71705000000001],[-73.9058827368707,40.71705000000001],[-73.90501671146691,40.71555000000001],[-73.9058827368707,40.71405000000001],[-73.90501671146691,40.71255000000001],[-73.90328466065934,40.71255000000001],[-73.90241863525556,40.71405000000001],[-73.90068658444798,40.71405000000001],[-73.8998205590442,40.71255000000001],[-73.89808850823663,40.71255000000001],[-73.89722248283285,40.71405000000001],[-73.89549043202527,40.71405000000001],[-73.89462440662149,40.71255000000001],[-73.89289235581391,40.71255000000001],[-73.89202633041013,40.71105000000001],[-73.89029427960256,40.71105000000001],[-73.88942825419878,40.71255000000001],[-73.8876962033912,40.71255000000001],[-73.88683017798742,40.71105000000001],[-73.8876962033912,40.70955000000001],[-73.88683017798742,40.70805000000001],[-73.8876962033912,40.70655000000001],[-73.88942825419878,40.70655000000001],[-73.89029427960256,40.70505000000001],[-73.89202633041013,40.70505000000001],[-73.89289235581391,40.70355000000001],[-73.89202633041013,40.70205000000001],[-73.89289235581391,40.70055000000001],[-73.89462440662149,40.70055000000001],[-73.89549043202527,40.69905000000001],[-73.89722248283285,40.69905000000001],[-73.89808850823663,40.69755000000001],[-73.89722248283285,40.69605000000001],[-73.89808850823663,40.69455000000001],[-73.8998205590442,40.69455000000001],[-73.90068658444798,40.69305000000001]]],"type":"Polygon"}},{"id":"119","properties":{"borough":"bronx","borocode":2,"neighborhood":"North Riverdale-Fieldston-Riverdale"},"type":"Feature","geometry":{"coordinates":[[[-73.89808850823663,40.889550000000014],[-73.8998205590442,40.889550000000014],[-73.90068658444798,40.891050000000014],[-73.90241863525556,40.891050000000014],[-73.90328466065934,40.889550000000014],[-73.90241863525556,40.888050000000014],[-73.90328466065934,40.886550000000014],[-73.90501671146691,40.886550000000014],[-73.9058827368707,40.888050000000014],[-73.90761478767827,40.888050000000014],[-73.90848081308205,40.889550000000014],[-73.91021286388963,40.889550000000014],[-73.9110788892934,40.888050000000014],[-73.91281094010098,40.888050000000014],[-73.91367696550476,40.886550000000014],[-73.91540901631234,40.886550000000014],[-73.91627504171612,40.888050000000014],[-73.9180070925237,40.888050000000014],[-73.91887311792748,40.886550000000014],[-73.92060516873505,40.886550000000014],[-73.92147119413883,40.888050000000014],[-73.92060516873505,40.889550000000014],[-73.91887311792748,40.889550000000014],[-73.9180070925237,40.891050000000014],[-73.91887311792748,40.892550000000014],[-73.9180070925237,40.894050000000014],[-73.91887311792748,40.895550000000014],[-73.9180070925237,40.897050000000014],[-73.91887311792748,40.898550000000014],[-73.9180070925237,40.900050000000014],[-73.91627504171612,40.900050000000014],[-73.91540901631234,40.901550000000015],[-73.91627504171612,40.903050000000015],[-73.91540901631234,40.904550000000015],[-73.91367696550476,40.904550000000015],[-73.91281094010098,40.906050000000015],[-73.91367696550476,40.907550000000015],[-73.91281094010098,40.909050000000015],[-73.91367696550476,40.910550000000015],[-73.91281094010098,40.912050000000015],[-73.91367696550476,40.913550000000015],[-73.91281094010098,40.915050000000015],[-73.9110788892934,40.915050000000015],[-73.91021286388963,40.916550000000015],[-73.90848081308205,40.916550000000015],[-73.90761478767827,40.915050000000015],[-73.9058827368707,40.915050000000015],[-73.90501671146691,40.913550000000015],[-73.90328466065934,40.913550000000015],[-73.90241863525556,40.915050000000015],[-73.90068658444798,40.915050000000015],[-73.8998205590442,40.913550000000015],[-73.89808850823663,40.913550000000015],[-73.89722248283285,40.912050000000015],[-73.89549043202527,40.912050000000015],[-73.89462440662149,40.910550000000015],[-73.89549043202527,40.909050000000015],[-73.89462440662149,40.907550000000015],[-73.89549043202527,40.906050000000015],[-73.89462440662149,40.904550000000015],[-73.89549043202527,40.903050000000015],[-73.89462440662149,40.901550000000015],[-73.89549043202527,40.900050000000014],[-73.89462440662149,40.898550000000014],[-73.89549043202527,40.897050000000014],[-73.89462440662149,40.895550000000014],[-73.89549043202527,40.894050000000014],[-73.89462440662149,40.892550000000014],[-73.89549043202527,40.891050000000014],[-73.89722248283285,40.891050000000014],[-73.89808850823663,40.889550000000014]]],"type":"Polygon"}},{"id":"27","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Canarsie"},"type":"Feature","geometry":{"coordinates":[[[-73.90068658444798,40.624050000000004],[-73.90241863525556,40.624050000000004],[-73.90328466065934,40.625550000000004],[-73.90501671146691,40.625550000000004],[-73.9058827368707,40.627050000000004],[-73.90761478767827,40.627050000000004],[-73.90848081308205,40.628550000000004],[-73.91021286388963,40.628550000000004],[-73.9110788892934,40.630050000000004],[-73.91281094010098,40.630050000000004],[-73.91367696550476,40.631550000000004],[-73.91540901631234,40.631550000000004],[-73.91627504171612,40.633050000000004],[-73.9180070925237,40.633050000000004],[-73.91887311792748,40.634550000000004],[-73.9180070925237,40.636050000000004],[-73.91887311792748,40.637550000000005],[-73.9180070925237,40.639050000000005],[-73.91887311792748,40.640550000000005],[-73.92060516873505,40.640550000000005],[-73.92147119413883,40.642050000000005],[-73.92060516873505,40.643550000000005],[-73.91887311792748,40.643550000000005],[-73.9180070925237,40.645050000000005],[-73.91627504171612,40.645050000000005],[-73.91540901631234,40.646550000000005],[-73.91367696550476,40.646550000000005],[-73.91281094010098,40.648050000000005],[-73.9110788892934,40.648050000000005],[-73.91021286388963,40.649550000000005],[-73.90848081308205,40.649550000000005],[-73.90761478767827,40.648050000000005],[-73.9058827368707,40.648050000000005],[-73.90501671146691,40.646550000000005],[-73.90328466065934,40.646550000000005],[-73.90241863525556,40.648050000000005],[-73.90068658444798,40.648050000000005],[-73.8998205590442,40.649550000000005],[-73.89808850823663,40.649550000000005],[-73.89722248283285,40.651050000000005],[-73.89549043202527,40.651050000000005],[-73.89462440662149,40.652550000000005],[-73.89289235581391,40.652550000000005],[-73.89202633041013,40.651050000000005],[-73.89029427960256,40.651050000000005],[-73.88942825419878,40.649550000000005],[-73.89029427960256,40.648050000000005],[-73.88942825419878,40.646550000000005],[-73.8876962033912,40.646550000000005],[-73.88683017798742,40.645050000000005],[-73.88509812717984,40.645050000000005],[-73.88423210177606,40.643550000000005],[-73.88250005096849,40.643550000000005],[-73.88163402556471,40.642050000000005],[-73.87990197475713,40.642050000000005],[-73.87903594935335,40.640550000000005],[-73.87990197475713,40.639050000000005],[-73.88163402556471,40.639050000000005],[-73.88250005096849,40.637550000000005],[-73.88423210177606,40.637550000000005],[-73.88509812717984,40.636050000000004],[-73.88423210177606,40.634550000000004],[-73.88250005096849,40.634550000000004],[-73.88163402556471,40.633050000000004],[-73.88250005096849,40.631550000000004],[-73.88423210177606,40.631550000000004],[-73.88509812717984,40.630050000000004],[-73.88683017798742,40.630050000000004],[-73.8876962033912,40.628550000000004],[-73.88942825419878,40.628550000000004],[-73.89029427960256,40.627050000000004],[-73.89202633041013,40.627050000000004],[-73.89289235581391,40.628550000000004],[-73.89462440662149,40.628550000000004],[-73.89549043202527,40.627050000000004],[-73.89722248283285,40.627050000000004],[-73.89808850823663,40.625550000000004],[-73.8998205590442,40.625550000000004],[-73.90068658444798,40.624050000000004]]],"type":"Polygon"}},{"id":"104","properties":{"borough":"queens","borocode":4,"neighborhood":"Maspeth"},"type":"Feature","geometry":{"coordinates":[[[-73.90328466065934,40.71255000000001],[-73.90501671146691,40.71255000000001],[-73.9058827368707,40.71405000000001],[-73.90501671146691,40.71555000000001],[-73.9058827368707,40.71705000000001],[-73.90761478767827,40.71705000000001],[-73.90848081308205,40.71855000000001],[-73.91021286388963,40.71855000000001],[-73.9110788892934,40.71705000000001],[-73.91021286388963,40.71555000000001],[-73.9110788892934,40.71405000000001],[-73.91281094010098,40.71405000000001],[-73.91367696550476,40.71255000000001],[-73.91540901631234,40.71255000000001],[-73.91627504171612,40.71405000000001],[-73.9180070925237,40.71405000000001],[-73.91887311792748,40.71555000000001],[-73.92060516873505,40.71555000000001],[-73.92147119413883,40.71405000000001],[-73.92320324494641,40.71405000000001],[-73.92406927035019,40.71555000000001],[-73.92320324494641,40.71705000000001],[-73.92147119413883,40.71705000000001],[-73.92060516873505,40.71855000000001],[-73.91887311792748,40.71855000000001],[-73.9180070925237,40.72005000000001],[-73.91627504171612,40.72005000000001],[-73.91540901631234,40.71855000000001],[-73.91367696550476,40.71855000000001],[-73.91281094010098,40.72005000000001],[-73.91367696550476,40.72155000000001],[-73.91281094010098,40.72305000000001],[-73.91367696550476,40.72455000000001],[-73.91281094010098,40.72605000000001],[-73.9110788892934,40.72605000000001],[-73.91021286388963,40.72755000000001],[-73.90848081308205,40.72755000000001],[-73.90761478767827,40.72905000000001],[-73.9058827368707,40.72905000000001],[-73.90501671146691,40.73055000000001],[-73.9058827368707,40.73205000000001],[-73.90501671146691,40.73355000000001],[-73.90328466065934,40.73355000000001],[-73.90241863525556,40.73505000000001],[-73.90068658444798,40.73505000000001],[-73.8998205590442,40.73355000000001],[-73.89808850823663,40.73355000000001],[-73.89722248283285,40.73505000000001],[-73.89549043202527,40.73505000000001],[-73.89462440662149,40.73655000000001],[-73.89289235581391,40.73655000000001],[-73.89202633041013,40.73505000000001],[-73.89029427960256,40.73505000000001],[-73.88942825419878,40.73355000000001],[-73.8876962033912,40.73355000000001],[-73.88683017798742,40.73205000000001],[-73.8876962033912,40.73055000000001],[-73.88683017798742,40.72905000000001],[-73.8876962033912,40.72755000000001],[-73.88683017798742,40.72605000000001],[-73.8876962033912,40.72455000000001],[-73.88942825419878,40.72455000000001],[-73.89029427960256,40.72605000000001],[-73.89202633041013,40.72605000000001],[-73.89289235581391,40.72455000000001],[-73.89462440662149,40.72455000000001],[-73.89549043202527,40.72305000000001],[-73.89462440662149,40.72155000000001],[-73.89549043202527,40.72005000000001],[-73.89462440662149,40.71855000000001],[-73.89549043202527,40.71705000000001],[-73.89722248283285,40.71705000000001],[-73.89808850823663,40.71555000000001],[-73.8998205590442,40.71555000000001],[-73.90068658444798,40.71405000000001],[-73.90241863525556,40.71405000000001],[-73.90328466065934,40.71255000000001]]],"type":"Polygon"}},{"id":"110","properties":{"borough":"bronx","borocode":2,"neighborhood":"Morrisania-Melrose"},"type":"Feature","geometry":{"coordinates":[[[-73.8876962033912,40.82655000000001],[-73.88942825419878,40.82655000000001],[-73.89029427960256,40.82805000000001],[-73.89202633041013,40.82805000000001],[-73.89289235581391,40.82655000000001],[-73.89462440662149,40.82655000000001],[-73.89549043202527,40.82805000000001],[-73.89722248283285,40.82805000000001],[-73.89808850823663,40.82655000000001],[-73.8998205590442,40.82655000000001],[-73.90068658444798,40.82505000000001],[-73.8998205590442,40.82355000000001],[-73.90068658444798,40.82205000000001],[-73.90241863525556,40.82205000000001],[-73.90328466065934,40.82355000000001],[-73.90501671146691,40.82355000000001],[-73.9058827368707,40.82205000000001],[-73.90761478767827,40.82205000000001],[-73.90848081308205,40.82055000000001],[-73.91021286388963,40.82055000000001],[-73.9110788892934,40.82205000000001],[-73.91281094010098,40.82205000000001],[-73.91367696550476,40.82355000000001],[-73.91540901631234,40.82355000000001],[-73.91627504171612,40.82505000000001],[-73.91540901631234,40.82655000000001],[-73.91367696550476,40.82655000000001],[-73.91281094010098,40.82805000000001],[-73.9110788892934,40.82805000000001],[-73.91021286388963,40.82955000000001],[-73.90848081308205,40.82955000000001],[-73.90761478767827,40.83105000000001],[-73.9058827368707,40.83105000000001],[-73.90501671146691,40.83255000000001],[-73.90328466065934,40.83255000000001],[-73.90241863525556,40.83405000000001],[-73.90068658444798,40.83405000000001],[-73.8998205590442,40.83555000000001],[-73.89808850823663,40.83555000000001],[-73.89722248283285,40.83405000000001],[-73.89808850823663,40.83255000000001],[-73.89722248283285,40.83105000000001],[-73.89549043202527,40.83105000000001],[-73.89462440662149,40.82955000000001],[-73.89289235581391,40.82955000000001],[-73.89202633041013,40.83105000000001],[-73.89029427960256,40.83105000000001],[-73.88942825419878,40.82955000000001],[-73.8876962033912,40.82955000000001],[-73.88683017798742,40.82805000000001],[-73.8876962033912,40.82655000000001]]],"type":"Polygon"}},{"id":"187","properties":{"borough":"queens","borocode":4,"neighborhood":"Woodside"},"type":"Feature","geometry":{"coordinates":[[[-73.90068658444798,40.73805000000001],[-73.90241863525556,40.73805000000001],[-73.90328466065934,40.73955000000001],[-73.90501671146691,40.73955000000001],[-73.9058827368707,40.73805000000001],[-73.90501671146691,40.73655000000001],[-73.9058827368707,40.73505000000001],[-73.90761478767827,40.73505000000001],[-73.90848081308205,40.73655000000001],[-73.91021286388963,40.73655000000001],[-73.9110788892934,40.73805000000001],[-73.91021286388963,40.73955000000001],[-73.9110788892934,40.74105000000001],[-73.91281094010098,40.74105000000001],[-73.91367696550476,40.74255000000001],[-73.91281094010098,40.74405000000001],[-73.9110788892934,40.74405000000001],[-73.91021286388963,40.74555000000001],[-73.9110788892934,40.74705000000001],[-73.91021286388963,40.74855000000001],[-73.9110788892934,40.75005000000001],[-73.91021286388963,40.75155000000001],[-73.9110788892934,40.75305000000001],[-73.91021286388963,40.75455000000001],[-73.9110788892934,40.75605000000001],[-73.91021286388963,40.75755000000001],[-73.90848081308205,40.75755000000001],[-73.90761478767827,40.75905000000001],[-73.90848081308205,40.76055000000001],[-73.90761478767827,40.76205000000001],[-73.9058827368707,40.76205000000001],[-73.90501671146691,40.76355000000001],[-73.90328466065934,40.76355000000001],[-73.90241863525556,40.76205000000001],[-73.90068658444798,40.76205000000001],[-73.8998205590442,40.76055000000001],[-73.90068658444798,40.75905000000001],[-73.8998205590442,40.75755000000001],[-73.90068658444798,40.75605000000001],[-73.8998205590442,40.75455000000001],[-73.89808850823663,40.75455000000001],[-73.89722248283285,40.75305000000001],[-73.89808850823663,40.75155000000001],[-73.89722248283285,40.75005000000001],[-73.89549043202527,40.75005000000001],[-73.89462440662149,40.74855000000001],[-73.89549043202527,40.74705000000001],[-73.89462440662149,40.74555000000001],[-73.89549043202527,40.74405000000001],[-73.89722248283285,40.74405000000001],[-73.89808850823663,40.74255000000001],[-73.89722248283285,40.74105000000001],[-73.89808850823663,40.73955000000001],[-73.8998205590442,40.73955000000001],[-73.90068658444798,40.73805000000001]]],"type":"Polygon"}},{"id":"112","properties":{"borough":"bronx","borocode":2,"neighborhood":"Mount Hope"},"type":"Feature","geometry":{"coordinates":[[[-73.9058827368707,40.84005000000001],[-73.90761478767827,40.84005000000001],[-73.90848081308205,40.84155000000001],[-73.91021286388963,40.84155000000001],[-73.9110788892934,40.84305000000001],[-73.91281094010098,40.84305000000001],[-73.91367696550476,40.84455000000001],[-73.91281094010098,40.84605000000001],[-73.91367696550476,40.84755000000001],[-73.91281094010098,40.84905000000001],[-73.9110788892934,40.84905000000001],[-73.91021286388963,40.85055000000001],[-73.90848081308205,40.85055000000001],[-73.90761478767827,40.85205000000001],[-73.90848081308205,40.85355000000001],[-73.90761478767827,40.85505000000001],[-73.9058827368707,40.85505000000001],[-73.90501671146691,40.85355000000001],[-73.90328466065934,40.85355000000001],[-73.90241863525556,40.85505000000001],[-73.90068658444798,40.85505000000001],[-73.8998205590442,40.85355000000001],[-73.89808850823663,40.85355000000001],[-73.89722248283285,40.85205000000001],[-73.89808850823663,40.85055000000001],[-73.8998205590442,40.85055000000001],[-73.90068658444798,40.84905000000001],[-73.8998205590442,40.84755000000001],[-73.90068658444798,40.84605000000001],[-73.90241863525556,40.84605000000001],[-73.90328466065934,40.84455000000001],[-73.90501671146691,40.84455000000001],[-73.9058827368707,40.84305000000001],[-73.90501671146691,40.84155000000001],[-73.9058827368707,40.84005000000001]]],"type":"Polygon"}},{"id":"59","properties":{"borough":"queens","borocode":4,"neighborhood":"Elmhurst-Maspeth"},"type":"Feature","geometry":{"coordinates":[[[-73.87990197475713,40.73205000000001],[-73.88163402556471,40.73205000000001],[-73.88250005096849,40.73355000000001],[-73.88423210177606,40.73355000000001],[-73.88509812717984,40.73505000000001],[-73.88683017798742,40.73505000000001],[-73.8876962033912,40.73355000000001],[-73.88942825419878,40.73355000000001],[-73.89029427960256,40.73505000000001],[-73.89202633041013,40.73505000000001],[-73.89289235581391,40.73655000000001],[-73.89462440662149,40.73655000000001],[-73.89549043202527,40.73505000000001],[-73.89722248283285,40.73505000000001],[-73.89808850823663,40.73355000000001],[-73.8998205590442,40.73355000000001],[-73.90068658444798,40.73505000000001],[-73.90241863525556,40.73505000000001],[-73.90328466065934,40.73355000000001],[-73.90501671146691,40.73355000000001],[-73.9058827368707,40.73205000000001],[-73.90761478767827,40.73205000000001],[-73.90848081308205,40.73355000000001],[-73.91021286388963,40.73355000000001],[-73.9110788892934,40.73505000000001],[-73.91021286388963,40.73655000000001],[-73.90848081308205,40.73655000000001],[-73.90761478767827,40.73505000000001],[-73.9058827368707,40.73505000000001],[-73.90501671146691,40.73655000000001],[-73.9058827368707,40.73805000000001],[-73.90501671146691,40.73955000000001],[-73.90328466065934,40.73955000000001],[-73.90241863525556,40.73805000000001],[-73.90068658444798,40.73805000000001],[-73.8998205590442,40.73955000000001],[-73.89808850823663,40.73955000000001],[-73.89722248283285,40.74105000000001],[-73.89808850823663,40.74255000000001],[-73.89722248283285,40.74405000000001],[-73.89549043202527,40.74405000000001],[-73.89462440662149,40.74555000000001],[-73.89549043202527,40.74705000000001],[-73.89462440662149,40.74855000000001],[-73.89289235581391,40.74855000000001],[-73.89202633041013,40.74705000000001],[-73.89029427960256,40.74705000000001],[-73.88942825419878,40.74555000000001],[-73.89029427960256,40.74405000000001],[-73.88942825419878,40.74255000000001],[-73.8876962033912,40.74255000000001],[-73.88683017798742,40.74105000000001],[-73.88509812717984,40.74105000000001],[-73.88423210177606,40.73955000000001],[-73.88250005096849,40.73955000000001],[-73.88163402556471,40.74105000000001],[-73.87990197475713,40.74105000000001],[-73.87903594935335,40.73955000000001],[-73.87990197475713,40.73805000000001],[-73.87903594935335,40.73655000000001],[-73.87990197475713,40.73505000000001],[-73.87903594935335,40.73355000000001],[-73.87990197475713,40.73205000000001]]],"type":"Polygon"}},{"id":"33","properties":{"borough":"bronx","borocode":2,"neighborhood":"Claremont-Bathgate"},"type":"Feature","geometry":{"coordinates":[[[-73.90848081308205,40.82955000000001],[-73.91021286388963,40.82955000000001],[-73.9110788892934,40.83105000000001],[-73.91021286388963,40.83255000000001],[-73.90848081308205,40.83255000000001],[-73.90761478767827,40.83405000000001],[-73.9058827368707,40.83405000000001],[-73.90501671146691,40.83555000000001],[-73.9058827368707,40.83705000000001],[-73.90501671146691,40.83855000000001],[-73.9058827368707,40.84005000000001],[-73.90501671146691,40.84155000000001],[-73.9058827368707,40.84305000000001],[-73.90501671146691,40.84455000000001],[-73.90328466065934,40.84455000000001],[-73.90241863525556,40.84605000000001],[-73.90068658444798,40.84605000000001],[-73.8998205590442,40.84755000000001],[-73.90068658444798,40.84905000000001],[-73.8998205590442,40.85055000000001],[-73.89808850823663,40.85055000000001],[-73.89722248283285,40.85205000000001],[-73.89808850823663,40.85355000000001],[-73.89722248283285,40.85505000000001],[-73.89549043202527,40.85505000000001],[-73.89462440662149,40.85655000000001],[-73.89289235581391,40.85655000000001],[-73.89202633041013,40.85805000000001],[-73.89289235581391,40.85955000000001],[-73.89202633041013,40.86105000000001],[-73.89029427960256,40.86105000000001],[-73.88942825419878,40.85955000000001],[-73.89029427960256,40.85805000000001],[-73.88942825419878,40.85655000000001],[-73.89029427960256,40.85505000000001],[-73.88942825419878,40.85355000000001],[-73.89029427960256,40.85205000000001],[-73.89202633041013,40.85205000000001],[-73.89289235581391,40.85355000000001],[-73.89462440662149,40.85355000000001],[-73.89549043202527,40.85205000000001],[-73.89462440662149,40.85055000000001],[-73.89549043202527,40.84905000000001],[-73.89462440662149,40.84755000000001],[-73.89549043202527,40.84605000000001],[-73.89462440662149,40.84455000000001],[-73.89549043202527,40.84305000000001],[-73.89462440662149,40.84155000000001],[-73.89549043202527,40.84005000000001],[-73.89722248283285,40.84005000000001],[-73.89808850823663,40.83855000000001],[-73.89722248283285,40.83705000000001],[-73.89808850823663,40.83555000000001],[-73.8998205590442,40.83555000000001],[-73.90068658444798,40.83405000000001],[-73.90241863525556,40.83405000000001],[-73.90328466065934,40.83255000000001],[-73.90501671146691,40.83255000000001],[-73.9058827368707,40.83105000000001],[-73.90761478767827,40.83105000000001],[-73.90848081308205,40.82955000000001]]],"type":"Polygon"}},{"id":"93","properties":{"borough":"bronx","borocode":2,"neighborhood":"Kingsbridge Heights"},"type":"Feature","geometry":{"coordinates":[[[-73.90848081308205,40.85955000000001],[-73.91021286388963,40.85955000000001],[-73.9110788892934,40.86105000000001],[-73.91021286388963,40.86255000000001],[-73.9110788892934,40.86405000000001],[-73.91281094010098,40.86405000000001],[-73.91367696550476,40.86555000000001],[-73.91281094010098,40.86705000000001],[-73.9110788892934,40.86705000000001],[-73.91021286388963,40.86855000000001],[-73.9110788892934,40.87005000000001],[-73.91021286388963,40.87155000000001],[-73.90848081308205,40.87155000000001],[-73.90761478767827,40.87305000000001],[-73.9058827368707,40.87305000000001],[-73.90501671146691,40.87155000000001],[-73.90328466065934,40.87155000000001],[-73.90241863525556,40.87005000000001],[-73.90328466065934,40.86855000000001],[-73.90241863525556,40.86705000000001],[-73.90068658444798,40.86705000000001],[-73.8998205590442,40.86855000000001],[-73.89808850823663,40.86855000000001],[-73.89722248283285,40.86705000000001],[-73.89808850823663,40.86555000000001],[-73.8998205590442,40.86555000000001],[-73.90068658444798,40.86405000000001],[-73.8998205590442,40.86255000000001],[-73.90068658444798,40.86105000000001],[-73.90241863525556,40.86105000000001],[-73.90328466065934,40.85955000000001],[-73.90501671146691,40.85955000000001],[-73.9058827368707,40.86105000000001],[-73.90761478767827,40.86105000000001],[-73.90848081308205,40.85955000000001]]],"type":"Polygon"}},{"id":"52","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"East New York"},"type":"Feature","geometry":{"coordinates":[[[-73.90328466065934,40.646550000000005],[-73.90501671146691,40.646550000000005],[-73.9058827368707,40.648050000000005],[-73.90761478767827,40.648050000000005],[-73.90848081308205,40.649550000000005],[-73.90761478767827,40.651050000000005],[-73.90848081308205,40.652550000000005],[-73.90761478767827,40.654050000000005],[-73.9058827368707,40.654050000000005],[-73.90501671146691,40.652550000000005],[-73.90328466065934,40.652550000000005],[-73.90241863525556,40.654050000000005],[-73.90328466065934,40.655550000000005],[-73.90241863525556,40.657050000000005],[-73.90068658444798,40.657050000000005],[-73.8998205590442,40.658550000000005],[-73.89808850823663,40.658550000000005],[-73.89722248283285,40.657050000000005],[-73.89549043202527,40.657050000000005],[-73.89462440662149,40.658550000000005],[-73.89289235581391,40.658550000000005],[-73.89202633041013,40.660050000000005],[-73.89029427960256,40.660050000000005],[-73.88942825419878,40.661550000000005],[-73.8876962033912,40.661550000000005],[-73.88683017798742,40.663050000000005],[-73.88509812717984,40.663050000000005],[-73.88423210177606,40.664550000000006],[-73.88509812717984,40.666050000000006],[-73.88683017798742,40.666050000000006],[-73.8876962033912,40.664550000000006],[-73.88942825419878,40.664550000000006],[-73.89029427960256,40.666050000000006],[-73.88942825419878,40.667550000000006],[-73.89029427960256,40.669050000000006],[-73.88942825419878,40.670550000000006],[-73.89029427960256,40.672050000000006],[-73.89202633041013,40.672050000000006],[-73.89289235581391,40.673550000000006],[-73.89462440662149,40.673550000000006],[-73.89549043202527,40.675050000000006],[-73.89722248283285,40.675050000000006],[-73.89808850823663,40.673550000000006],[-73.8998205590442,40.673550000000006],[-73.90068658444798,40.675050000000006],[-73.8998205590442,40.676550000000006],[-73.89808850823663,40.676550000000006],[-73.89722248283285,40.678050000000006],[-73.89549043202527,40.678050000000006],[-73.89462440662149,40.676550000000006],[-73.89289235581391,40.676550000000006],[-73.89202633041013,40.678050000000006],[-73.89029427960256,40.678050000000006],[-73.88942825419878,40.679550000000006],[-73.8876962033912,40.679550000000006],[-73.88683017798742,40.681050000000006],[-73.88509812717984,40.681050000000006],[-73.88423210177606,40.679550000000006],[-73.88250005096849,40.679550000000006],[-73.88163402556471,40.681050000000006],[-73.87990197475713,40.681050000000006],[-73.87903594935335,40.679550000000006],[-73.87730389854578,40.679550000000006],[-73.876437873142,40.681050000000006],[-73.87470582233442,40.681050000000006],[-73.87383979693064,40.679550000000006],[-73.87210774612306,40.679550000000006],[-73.87124172071928,40.678050000000006],[-73.86950966991171,40.678050000000006],[-73.86864364450793,40.676550000000006],[-73.86691159370035,40.676550000000006],[-73.86604556829657,40.675050000000006],[-73.864313517489,40.675050000000006],[-73.86344749208521,40.676550000000006],[-73.86171544127764,40.676550000000006],[-73.86084941587386,40.675050000000006],[-73.86171544127764,40.673550000000006],[-73.86084941587386,40.672050000000006],[-73.85911736506628,40.672050000000006],[-73.8582513396625,40.670550000000006],[-73.85651928885493,40.670550000000006],[-73.85565326345115,40.669050000000006],[-73.85651928885493,40.667550000000006],[-73.85565326345115,40.666050000000006],[-73.85651928885493,40.664550000000006],[-73.8582513396625,40.664550000000006],[-73.85911736506628,40.663050000000005],[-73.8582513396625,40.661550000000005],[-73.85911736506628,40.660050000000005],[-73.8582513396625,40.658550000000005],[-73.85911736506628,40.657050000000005],[-73.86084941587386,40.657050000000005],[-73.86171544127764,40.655550000000005],[-73.86084941587386,40.654050000000005],[-73.86171544127764,40.652550000000005],[-73.86344749208521,40.652550000000005],[-73.864313517489,40.651050000000005],[-73.86604556829657,40.651050000000005],[-73.86691159370035,40.649550000000005],[-73.86864364450793,40.649550000000005],[-73.86950966991171,40.648050000000005],[-73.87124172071928,40.648050000000005],[-73.87210774612306,40.646550000000005],[-73.87383979693064,40.646550000000005],[-73.87470582233442,40.648050000000005],[-73.876437873142,40.648050000000005],[-73.87730389854578,40.649550000000005],[-73.876437873142,40.651050000000005],[-73.87730389854578,40.652550000000005],[-73.87903594935335,40.652550000000005],[-73.87990197475713,40.654050000000005],[-73.88163402556471,40.654050000000005],[-73.88250005096849,40.655550000000005],[-73.88423210177606,40.655550000000005],[-73.88509812717984,40.654050000000005],[-73.88423210177606,40.652550000000005],[-73.88509812717984,40.651050000000005],[-73.88683017798742,40.651050000000005],[-73.8876962033912,40.649550000000005],[-73.88942825419878,40.649550000000005],[-73.89029427960256,40.651050000000005],[-73.89202633041013,40.651050000000005],[-73.89289235581391,40.652550000000005],[-73.89462440662149,40.652550000000005],[-73.89549043202527,40.651050000000005],[-73.89722248283285,40.651050000000005],[-73.89808850823663,40.649550000000005],[-73.8998205590442,40.649550000000005],[-73.90068658444798,40.648050000000005],[-73.90241863525556,40.648050000000005],[-73.90328466065934,40.646550000000005]]],"type":"Polygon"}},{"id":"98","properties":{"borough":"bronx","borocode":2,"neighborhood":"Longwood"},"type":"Feature","geometry":{"coordinates":[[[-73.90068658444798,40.81005000000001],[-73.90241863525556,40.81005000000001],[-73.90328466065934,40.81155000000001],[-73.90501671146691,40.81155000000001],[-73.9058827368707,40.81305000000001],[-73.90501671146691,40.81455000000001],[-73.90328466065934,40.81455000000001],[-73.90241863525556,40.81605000000001],[-73.90328466065934,40.81755000000001],[-73.90241863525556,40.81905000000001],[-73.90068658444798,40.81905000000001],[-73.8998205590442,40.82055000000001],[-73.90068658444798,40.82205000000001],[-73.8998205590442,40.82355000000001],[-73.90068658444798,40.82505000000001],[-73.8998205590442,40.82655000000001],[-73.89808850823663,40.82655000000001],[-73.89722248283285,40.82805000000001],[-73.89549043202527,40.82805000000001],[-73.89462440662149,40.82655000000001],[-73.89549043202527,40.82505000000001],[-73.89462440662149,40.82355000000001],[-73.89549043202527,40.82205000000001],[-73.89462440662149,40.82055000000001],[-73.89549043202527,40.81905000000001],[-73.89462440662149,40.81755000000001],[-73.89549043202527,40.81605000000001],[-73.89462440662149,40.81455000000001],[-73.89549043202527,40.81305000000001],[-73.89722248283285,40.81305000000001],[-73.89808850823663,40.81155000000001],[-73.8998205590442,40.81155000000001],[-73.90068658444798,40.81005000000001]]],"type":"Polygon"}},{"id":"65","properties":{"borough":"bronx","borocode":2,"neighborhood":"Fordham South"},"type":"Feature","geometry":{"coordinates":[[[-73.90328466065934,40.85355000000001],[-73.90501671146691,40.85355000000001],[-73.9058827368707,40.85505000000001],[-73.90501671146691,40.85655000000001],[-73.9058827368707,40.85805000000001],[-73.90501671146691,40.85955000000001],[-73.90328466065934,40.85955000000001],[-73.90241863525556,40.86105000000001],[-73.90068658444798,40.86105000000001],[-73.8998205590442,40.86255000000001],[-73.89808850823663,40.86255000000001],[-73.89722248283285,40.86105000000001],[-73.89808850823663,40.85955000000001],[-73.89722248283285,40.85805000000001],[-73.89549043202527,40.85805000000001],[-73.89462440662149,40.85955000000001],[-73.89289235581391,40.85955000000001],[-73.89202633041013,40.85805000000001],[-73.89289235581391,40.85655000000001],[-73.89462440662149,40.85655000000001],[-73.89549043202527,40.85505000000001],[-73.89722248283285,40.85505000000001],[-73.89808850823663,40.85355000000001],[-73.8998205590442,40.85355000000001],[-73.90068658444798,40.85505000000001],[-73.90241863525556,40.85505000000001],[-73.90328466065934,40.85355000000001]]],"type":"Polygon"}},{"id":"170","properties":{"borough":"bronx","borocode":2,"neighborhood":"Van Cortlandt Village"},"type":"Feature","geometry":{"coordinates":[[[-73.90068658444798,40.86705000000001],[-73.90241863525556,40.86705000000001],[-73.90328466065934,40.86855000000001],[-73.90241863525556,40.87005000000001],[-73.90328466065934,40.87155000000001],[-73.90501671146691,40.87155000000001],[-73.9058827368707,40.87305000000001],[-73.90501671146691,40.87455000000001],[-73.9058827368707,40.87605000000001],[-73.90501671146691,40.877550000000014],[-73.90328466065934,40.877550000000014],[-73.90241863525556,40.879050000000014],[-73.90328466065934,40.880550000000014],[-73.90241863525556,40.882050000000014],[-73.90068658444798,40.882050000000014],[-73.8998205590442,40.883550000000014],[-73.89808850823663,40.883550000000014],[-73.89722248283285,40.885050000000014],[-73.89808850823663,40.886550000000014],[-73.89722248283285,40.888050000000014],[-73.89549043202527,40.888050000000014],[-73.89462440662149,40.886550000000014],[-73.89289235581391,40.886550000000014],[-73.89202633041013,40.885050000000014],[-73.89029427960256,40.885050000000014],[-73.88942825419878,40.886550000000014],[-73.8876962033912,40.886550000000014],[-73.88683017798742,40.885050000000014],[-73.8876962033912,40.883550000000014],[-73.88683017798742,40.882050000000014],[-73.88509812717984,40.882050000000014],[-73.88423210177606,40.880550000000014],[-73.88509812717984,40.879050000000014],[-73.88683017798742,40.879050000000014],[-73.8876962033912,40.877550000000014],[-73.88942825419878,40.877550000000014],[-73.89029427960256,40.87605000000001],[-73.88942825419878,40.87455000000001],[-73.89029427960256,40.87305000000001],[-73.88942825419878,40.87155000000001],[-73.89029427960256,40.87005000000001],[-73.89202633041013,40.87005000000001],[-73.89289235581391,40.86855000000001],[-73.89202633041013,40.86705000000001],[-73.89289235581391,40.86555000000001],[-73.89462440662149,40.86555000000001],[-73.89549043202527,40.86705000000001],[-73.89722248283285,40.86705000000001],[-73.89808850823663,40.86855000000001],[-73.8998205590442,40.86855000000001],[-73.90068658444798,40.86705000000001]]],"type":"Polygon"}},{"id":"53","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"East New York (Pennsylvania Ave)"},"type":"Feature","geometry":{"coordinates":[[[-73.89549043202527,40.657050000000005],[-73.89722248283285,40.657050000000005],[-73.89808850823663,40.658550000000005],[-73.8998205590442,40.658550000000005],[-73.90068658444798,40.660050000000005],[-73.8998205590442,40.661550000000005],[-73.90068658444798,40.663050000000005],[-73.8998205590442,40.664550000000006],[-73.90068658444798,40.666050000000006],[-73.90241863525556,40.666050000000006],[-73.90328466065934,40.667550000000006],[-73.90241863525556,40.669050000000006],[-73.90328466065934,40.670550000000006],[-73.90241863525556,40.672050000000006],[-73.90328466065934,40.673550000000006],[-73.90241863525556,40.675050000000006],[-73.90328466065934,40.676550000000006],[-73.90241863525556,40.678050000000006],[-73.90068658444798,40.678050000000006],[-73.8998205590442,40.676550000000006],[-73.90068658444798,40.675050000000006],[-73.8998205590442,40.673550000000006],[-73.89808850823663,40.673550000000006],[-73.89722248283285,40.675050000000006],[-73.89549043202527,40.675050000000006],[-73.89462440662149,40.673550000000006],[-73.89289235581391,40.673550000000006],[-73.89202633041013,40.672050000000006],[-73.89029427960256,40.672050000000006],[-73.88942825419878,40.670550000000006],[-73.89029427960256,40.669050000000006],[-73.88942825419878,40.667550000000006],[-73.89029427960256,40.666050000000006],[-73.88942825419878,40.664550000000006],[-73.8876962033912,40.664550000000006],[-73.88683017798742,40.666050000000006],[-73.88509812717984,40.666050000000006],[-73.88423210177606,40.664550000000006],[-73.88509812717984,40.663050000000005],[-73.88683017798742,40.663050000000005],[-73.8876962033912,40.661550000000005],[-73.88942825419878,40.661550000000005],[-73.89029427960256,40.660050000000005],[-73.89202633041013,40.660050000000005],[-73.89289235581391,40.658550000000005],[-73.89462440662149,40.658550000000005],[-73.89549043202527,40.657050000000005]]],"type":"Polygon"}},{"id":"42","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Cypress Hills-City Line"},"type":"Feature","geometry":{"coordinates":[[[-73.89808850823663,40.676550000000006],[-73.8998205590442,40.676550000000006],[-73.90068658444798,40.678050000000006],[-73.90241863525556,40.678050000000006],[-73.90328466065934,40.679550000000006],[-73.90241863525556,40.681050000000006],[-73.90068658444798,40.681050000000006],[-73.8998205590442,40.679550000000006],[-73.89808850823663,40.679550000000006],[-73.89722248283285,40.681050000000006],[-73.89808850823663,40.682550000000006],[-73.89722248283285,40.684050000000006],[-73.89549043202527,40.684050000000006],[-73.89462440662149,40.685550000000006],[-73.89289235581391,40.685550000000006],[-73.89202633041013,40.687050000000006],[-73.89029427960256,40.687050000000006],[-73.88942825419878,40.685550000000006],[-73.8876962033912,40.685550000000006],[-73.88683017798742,40.684050000000006],[-73.88509812717984,40.684050000000006],[-73.88423210177606,40.685550000000006],[-73.88250005096849,40.685550000000006],[-73.88163402556471,40.687050000000006],[-73.87990197475713,40.687050000000006],[-73.87903594935335,40.688550000000006],[-73.87730389854578,40.688550000000006],[-73.876437873142,40.69005000000001],[-73.87470582233442,40.69005000000001],[-73.87383979693064,40.69155000000001],[-73.87210774612306,40.69155000000001],[-73.87124172071928,40.69305000000001],[-73.86950966991171,40.69305000000001],[-73.86864364450793,40.69155000000001],[-73.86950966991171,40.69005000000001],[-73.86864364450793,40.688550000000006],[-73.86691159370035,40.688550000000006],[-73.86604556829657,40.687050000000006],[-73.86691159370035,40.685550000000006],[-73.86604556829657,40.684050000000006],[-73.86691159370035,40.682550000000006],[-73.86604556829657,40.681050000000006],[-73.864313517489,40.681050000000006],[-73.86344749208521,40.679550000000006],[-73.86171544127764,40.679550000000006],[-73.86084941587386,40.678050000000006],[-73.86171544127764,40.676550000000006],[-73.86344749208521,40.676550000000006],[-73.864313517489,40.675050000000006],[-73.86604556829657,40.675050000000006],[-73.86691159370035,40.676550000000006],[-73.86864364450793,40.676550000000006],[-73.86950966991171,40.678050000000006],[-73.87124172071928,40.678050000000006],[-73.87210774612306,40.679550000000006],[-73.87383979693064,40.679550000000006],[-73.87470582233442,40.681050000000006],[-73.876437873142,40.681050000000006],[-73.87730389854578,40.679550000000006],[-73.87903594935335,40.679550000000006],[-73.87990197475713,40.681050000000006],[-73.88163402556471,40.681050000000006],[-73.88250005096849,40.679550000000006],[-73.88423210177606,40.679550000000006],[-73.88509812717984,40.681050000000006],[-73.88683017798742,40.681050000000006],[-73.8876962033912,40.679550000000006],[-73.88942825419878,40.679550000000006],[-73.89029427960256,40.678050000000006],[-73.89202633041013,40.678050000000006],[-73.89289235581391,40.676550000000006],[-73.89462440662149,40.676550000000006],[-73.89549043202527,40.678050000000006],[-73.89722248283285,40.678050000000006],[-73.89808850823663,40.676550000000006]]],"type":"Polygon"}},{"id":"72","properties":{"borough":"queens","borocode":4,"neighborhood":"Glendale"},"type":"Feature","geometry":{"coordinates":[[[-73.85132313643221,40.70055000000001],[-73.85305518723979,40.70055000000001],[-73.85392121264357,40.70205000000001],[-73.85565326345115,40.70205000000001],[-73.85651928885493,40.70055000000001],[-73.8582513396625,40.70055000000001],[-73.85911736506628,40.70205000000001],[-73.86084941587386,40.70205000000001],[-73.86171544127764,40.70055000000001],[-73.86344749208521,40.70055000000001],[-73.864313517489,40.70205000000001],[-73.86604556829657,40.70205000000001],[-73.86691159370035,40.70055000000001],[-73.86864364450793,40.70055000000001],[-73.86950966991171,40.70205000000001],[-73.87124172071928,40.70205000000001],[-73.87210774612306,40.70055000000001],[-73.87383979693064,40.70055000000001],[-73.87470582233442,40.69905000000001],[-73.876437873142,40.69905000000001],[-73.87730389854578,40.70055000000001],[-73.87903594935335,40.70055000000001],[-73.87990197475713,40.69905000000001],[-73.88163402556471,40.69905000000001],[-73.88250005096849,40.69755000000001],[-73.88423210177606,40.69755000000001],[-73.88509812717984,40.69905000000001],[-73.88683017798742,40.69905000000001],[-73.8876962033912,40.69755000000001],[-73.88683017798742,40.69605000000001],[-73.8876962033912,40.69455000000001],[-73.88942825419878,40.69455000000001],[-73.89029427960256,40.69305000000001],[-73.89202633041013,40.69305000000001],[-73.89289235581391,40.69155000000001],[-73.89462440662149,40.69155000000001],[-73.89549043202527,40.69005000000001],[-73.89722248283285,40.69005000000001],[-73.89808850823663,40.69155000000001],[-73.8998205590442,40.69155000000001],[-73.90068658444798,40.69305000000001],[-73.8998205590442,40.69455000000001],[-73.89808850823663,40.69455000000001],[-73.89722248283285,40.69605000000001],[-73.89808850823663,40.69755000000001],[-73.89722248283285,40.69905000000001],[-73.89549043202527,40.69905000000001],[-73.89462440662149,40.70055000000001],[-73.89289235581391,40.70055000000001],[-73.89202633041013,40.70205000000001],[-73.89289235581391,40.70355000000001],[-73.89202633041013,40.70505000000001],[-73.89029427960256,40.70505000000001],[-73.88942825419878,40.70655000000001],[-73.8876962033912,40.70655000000001],[-73.88683017798742,40.70805000000001],[-73.88509812717984,40.70805000000001],[-73.88423210177606,40.70655000000001],[-73.88250005096849,40.70655000000001],[-73.88163402556471,40.70805000000001],[-73.87990197475713,40.70805000000001],[-73.87903594935335,40.70655000000001],[-73.87730389854578,40.70655000000001],[-73.876437873142,40.70805000000001],[-73.87470582233442,40.70805000000001],[-73.87383979693064,40.70655000000001],[-73.87210774612306,40.70655000000001],[-73.87124172071928,40.70805000000001],[-73.86950966991171,40.70805000000001],[-73.86864364450793,40.70955000000001],[-73.86950966991171,40.71105000000001],[-73.86864364450793,40.71255000000001],[-73.86691159370035,40.71255000000001],[-73.86604556829657,40.71105000000001],[-73.864313517489,40.71105000000001],[-73.86344749208521,40.71255000000001],[-73.86171544127764,40.71255000000001],[-73.86084941587386,40.71105000000001],[-73.85911736506628,40.71105000000001],[-73.8582513396625,40.70955000000001],[-73.85651928885493,40.70955000000001],[-73.85565326345115,40.70805000000001],[-73.85392121264357,40.70805000000001],[-73.85305518723979,40.70655000000001],[-73.85392121264357,40.70505000000001],[-73.85305518723979,40.70355000000001],[-73.85132313643221,40.70355000000001],[-73.85045711102843,40.70205000000001],[-73.85132313643221,40.70055000000001]]],"type":"Polygon"}},{"id":"106","properties":{"borough":"queens","borocode":4,"neighborhood":"Middle Village"},"type":"Feature","geometry":{"coordinates":[[[-73.89029427960256,40.71105000000001],[-73.89202633041013,40.71105000000001],[-73.89289235581391,40.71255000000001],[-73.89462440662149,40.71255000000001],[-73.89549043202527,40.71405000000001],[-73.89722248283285,40.71405000000001],[-73.89808850823663,40.71255000000001],[-73.8998205590442,40.71255000000001],[-73.90068658444798,40.71405000000001],[-73.8998205590442,40.71555000000001],[-73.89808850823663,40.71555000000001],[-73.89722248283285,40.71705000000001],[-73.89549043202527,40.71705000000001],[-73.89462440662149,40.71855000000001],[-73.89549043202527,40.72005000000001],[-73.89462440662149,40.72155000000001],[-73.89549043202527,40.72305000000001],[-73.89462440662149,40.72455000000001],[-73.89289235581391,40.72455000000001],[-73.89202633041013,40.72605000000001],[-73.89029427960256,40.72605000000001],[-73.88942825419878,40.72455000000001],[-73.8876962033912,40.72455000000001],[-73.88683017798742,40.72605000000001],[-73.8876962033912,40.72755000000001],[-73.88683017798742,40.72905000000001],[-73.88509812717984,40.72905000000001],[-73.88423210177606,40.72755000000001],[-73.88250005096849,40.72755000000001],[-73.88163402556471,40.72905000000001],[-73.87990197475713,40.72905000000001],[-73.87903594935335,40.73055000000001],[-73.87730389854578,40.73055000000001],[-73.876437873142,40.73205000000001],[-73.87470582233442,40.73205000000001],[-73.87383979693064,40.73055000000001],[-73.87210774612306,40.73055000000001],[-73.87124172071928,40.72905000000001],[-73.87210774612306,40.72755000000001],[-73.87124172071928,40.72605000000001],[-73.86950966991171,40.72605000000001],[-73.86864364450793,40.72455000000001],[-73.86950966991171,40.72305000000001],[-73.86864364450793,40.72155000000001],[-73.86691159370035,40.72155000000001],[-73.86604556829657,40.72005000000001],[-73.86691159370035,40.71855000000001],[-73.86604556829657,40.71705000000001],[-73.864313517489,40.71705000000001],[-73.86344749208521,40.71555000000001],[-73.86171544127764,40.71555000000001],[-73.86084941587386,40.71405000000001],[-73.86171544127764,40.71255000000001],[-73.86344749208521,40.71255000000001],[-73.864313517489,40.71105000000001],[-73.86604556829657,40.71105000000001],[-73.86691159370035,40.71255000000001],[-73.86864364450793,40.71255000000001],[-73.86950966991171,40.71105000000001],[-73.86864364450793,40.70955000000001],[-73.86950966991171,40.70805000000001],[-73.87124172071928,40.70805000000001],[-73.87210774612306,40.70655000000001],[-73.87383979693064,40.70655000000001],[-73.87470582233442,40.70805000000001],[-73.876437873142,40.70805000000001],[-73.87730389854578,40.70655000000001],[-73.87903594935335,40.70655000000001],[-73.87990197475713,40.70805000000001],[-73.87903594935335,40.70955000000001],[-73.87990197475713,40.71105000000001],[-73.88163402556471,40.71105000000001],[-73.88250005096849,40.70955000000001],[-73.88423210177606,40.70955000000001],[-73.88509812717984,40.71105000000001],[-73.88683017798742,40.71105000000001],[-73.8876962033912,40.71255000000001],[-73.88942825419878,40.71255000000001],[-73.89029427960256,40.71105000000001]]],"type":"Polygon"}},{"id":"87","properties":{"borough":"queens","borocode":4,"neighborhood":"Jackson Heights"},"type":"Feature","geometry":{"coordinates":[[[-73.88509812717984,40.74705000000001],[-73.88683017798742,40.74705000000001],[-73.8876962033912,40.74855000000001],[-73.88942825419878,40.74855000000001],[-73.89029427960256,40.74705000000001],[-73.89202633041013,40.74705000000001],[-73.89289235581391,40.74855000000001],[-73.89462440662149,40.74855000000001],[-73.89549043202527,40.75005000000001],[-73.89722248283285,40.75005000000001],[-73.89808850823663,40.75155000000001],[-73.89722248283285,40.75305000000001],[-73.89808850823663,40.75455000000001],[-73.8998205590442,40.75455000000001],[-73.90068658444798,40.75605000000001],[-73.8998205590442,40.75755000000001],[-73.90068658444798,40.75905000000001],[-73.8998205590442,40.76055000000001],[-73.89808850823663,40.76055000000001],[-73.89722248283285,40.76205000000001],[-73.89549043202527,40.76205000000001],[-73.89462440662149,40.76355000000001],[-73.89289235581391,40.76355000000001],[-73.89202633041013,40.76505000000001],[-73.89029427960256,40.76505000000001],[-73.88942825419878,40.76655000000001],[-73.8876962033912,40.76655000000001],[-73.88683017798742,40.76805000000001],[-73.88509812717984,40.76805000000001],[-73.88423210177606,40.76955000000001],[-73.88250005096849,40.76955000000001],[-73.88163402556471,40.77105000000001],[-73.87990197475713,40.77105000000001],[-73.87903594935335,40.77255000000001],[-73.87730389854578,40.77255000000001],[-73.876437873142,40.77105000000001],[-73.87470582233442,40.77105000000001],[-73.87383979693064,40.76955000000001],[-73.87470582233442,40.76805000000001],[-73.876437873142,40.76805000000001],[-73.87730389854578,40.76655000000001],[-73.876437873142,40.76505000000001],[-73.87470582233442,40.76505000000001],[-73.87383979693064,40.76355000000001],[-73.87470582233442,40.76205000000001],[-73.876437873142,40.76205000000001],[-73.87730389854578,40.76055000000001],[-73.876437873142,40.75905000000001],[-73.87470582233442,40.75905000000001],[-73.87383979693064,40.75755000000001],[-73.87470582233442,40.75605000000001],[-73.87383979693064,40.75455000000001],[-73.87210774612306,40.75455000000001],[-73.87124172071928,40.75305000000001],[-73.87210774612306,40.75155000000001],[-73.87124172071928,40.75005000000001],[-73.87210774612306,40.74855000000001],[-73.87383979693064,40.74855000000001],[-73.87470582233442,40.74705000000001],[-73.876437873142,40.74705000000001],[-73.87730389854578,40.74855000000001],[-73.87903594935335,40.74855000000001],[-73.87990197475713,40.75005000000001],[-73.88163402556471,40.75005000000001],[-73.88250005096849,40.74855000000001],[-73.88423210177606,40.74855000000001],[-73.88509812717984,40.74705000000001]]],"type":"Polygon"}},{"id":"12","properties":{"borough":"bronx","borocode":2,"neighborhood":"Bedford Park-Fordham North"},"type":"Feature","geometry":{"coordinates":[[[-73.89549043202527,40.85805000000001],[-73.89722248283285,40.85805000000001],[-73.89808850823663,40.85955000000001],[-73.89722248283285,40.86105000000001],[-73.89808850823663,40.86255000000001],[-73.8998205590442,40.86255000000001],[-73.90068658444798,40.86405000000001],[-73.8998205590442,40.86555000000001],[-73.89808850823663,40.86555000000001],[-73.89722248283285,40.86705000000001],[-73.89549043202527,40.86705000000001],[-73.89462440662149,40.86555000000001],[-73.89289235581391,40.86555000000001],[-73.89202633041013,40.86705000000001],[-73.89289235581391,40.86855000000001],[-73.89202633041013,40.87005000000001],[-73.89029427960256,40.87005000000001],[-73.88942825419878,40.87155000000001],[-73.89029427960256,40.87305000000001],[-73.88942825419878,40.87455000000001],[-73.89029427960256,40.87605000000001],[-73.88942825419878,40.877550000000014],[-73.8876962033912,40.877550000000014],[-73.88683017798742,40.879050000000014],[-73.88509812717984,40.879050000000014],[-73.88423210177606,40.877550000000014],[-73.88250005096849,40.877550000000014],[-73.88163402556471,40.87605000000001],[-73.88250005096849,40.87455000000001],[-73.88163402556471,40.87305000000001],[-73.88250005096849,40.87155000000001],[-73.88163402556471,40.87005000000001],[-73.87990197475713,40.87005000000001],[-73.87903594935335,40.86855000000001],[-73.87990197475713,40.86705000000001],[-73.88163402556471,40.86705000000001],[-73.88250005096849,40.86555000000001],[-73.88423210177606,40.86555000000001],[-73.88509812717984,40.86405000000001],[-73.88683017798742,40.86405000000001],[-73.8876962033912,40.86255000000001],[-73.88942825419878,40.86255000000001],[-73.89029427960256,40.86105000000001],[-73.89202633041013,40.86105000000001],[-73.89289235581391,40.85955000000001],[-73.89462440662149,40.85955000000001],[-73.89549043202527,40.85805000000001]]],"type":"Polygon"}},{"id":"39","properties":{"borough":"bronx","borocode":2,"neighborhood":"Crotona Park East"},"type":"Feature","geometry":{"coordinates":[[[-73.88509812717984,40.82805000000001],[-73.88683017798742,40.82805000000001],[-73.8876962033912,40.82955000000001],[-73.88942825419878,40.82955000000001],[-73.89029427960256,40.83105000000001],[-73.89202633041013,40.83105000000001],[-73.89289235581391,40.82955000000001],[-73.89462440662149,40.82955000000001],[-73.89549043202527,40.83105000000001],[-73.89722248283285,40.83105000000001],[-73.89808850823663,40.83255000000001],[-73.89722248283285,40.83405000000001],[-73.89808850823663,40.83555000000001],[-73.89722248283285,40.83705000000001],[-73.89549043202527,40.83705000000001],[-73.89462440662149,40.83855000000001],[-73.89289235581391,40.83855000000001],[-73.89202633041013,40.83705000000001],[-73.89029427960256,40.83705000000001],[-73.88942825419878,40.83855000000001],[-73.8876962033912,40.83855000000001],[-73.88683017798742,40.84005000000001],[-73.88509812717984,40.84005000000001],[-73.88423210177606,40.83855000000001],[-73.88250005096849,40.83855000000001],[-73.88163402556471,40.83705000000001],[-73.87990197475713,40.83705000000001],[-73.87903594935335,40.83855000000001],[-73.87730389854578,40.83855000000001],[-73.876437873142,40.84005000000001],[-73.87470582233442,40.84005000000001],[-73.87383979693064,40.84155000000001],[-73.87210774612306,40.84155000000001],[-73.87124172071928,40.84005000000001],[-73.87210774612306,40.83855000000001],[-73.87383979693064,40.83855000000001],[-73.87470582233442,40.83705000000001],[-73.876437873142,40.83705000000001],[-73.87730389854578,40.83555000000001],[-73.87903594935335,40.83555000000001],[-73.87990197475713,40.83405000000001],[-73.88163402556471,40.83405000000001],[-73.88250005096849,40.83255000000001],[-73.88423210177606,40.83255000000001],[-73.88509812717984,40.83105000000001],[-73.88423210177606,40.82955000000001],[-73.88509812717984,40.82805000000001]]],"type":"Polygon"}},{"id":"86","properties":{"borough":"bronx","borocode":2,"neighborhood":"Hunts Point"},"type":"Feature","geometry":{"coordinates":[[[[-73.87383979693064,40.79955000000001],[-73.87470582233442,40.80105000000001],[-73.876437873142,40.80105000000001],[-73.87730389854578,40.80255000000001],[-73.876437873142,40.80405000000001],[-73.87470582233442,40.80405000000001],[-73.87383979693064,40.80555000000001],[-73.87210774612306,40.80555000000001],[-73.87124172071928,40.80705000000001],[-73.86950966991171,40.80705000000001],[-73.86864364450793,40.80855000000001],[-73.86691159370035,40.80855000000001],[-73.86604556829657,40.80705000000001],[-73.86691159370035,40.80555000000001],[-73.86864364450793,40.80555000000001],[-73.86950966991171,40.80405000000001],[-73.86864364450793,40.80255000000001],[-73.86950966991171,40.80105000000001],[-73.87124172071928,40.80105000000001],[-73.87210774612306,40.79955000000001],[-73.87383979693064,40.79955000000001]]],[[[-73.87124172071928,40.81005000000001],[-73.87210774612306,40.81155000000001],[-73.87124172071928,40.81305000000001],[-73.86950966991171,40.81305000000001],[-73.86864364450793,40.81155000000001],[-73.86950966991171,40.81005000000001],[-73.87124172071928,40.81005000000001]]],[[[-73.89722248283285,40.80405000000001],[-73.89808850823663,40.80555000000001],[-73.8998205590442,40.80555000000001],[-73.90068658444798,40.80705000000001],[-73.90241863525556,40.80705000000001],[-73.90328466065934,40.80855000000001],[-73.90241863525556,40.81005000000001],[-73.90068658444798,40.81005000000001],[-73.8998205590442,40.81155000000001],[-73.89808850823663,40.81155000000001],[-73.89722248283285,40.81305000000001],[-73.89549043202527,40.81305000000001],[-73.89462440662149,40.81455000000001],[-73.89549043202527,40.81605000000001],[-73.89462440662149,40.81755000000001],[-73.89549043202527,40.81905000000001],[-73.89462440662149,40.82055000000001],[-73.89549043202527,40.82205000000001],[-73.89462440662149,40.82355000000001],[-73.89549043202527,40.82505000000001],[-73.89462440662149,40.82655000000001],[-73.89289235581391,40.82655000000001],[-73.89202633041013,40.82805000000001],[-73.89029427960256,40.82805000000001],[-73.88942825419878,40.82655000000001],[-73.8876962033912,40.82655000000001],[-73.88683017798742,40.82805000000001],[-73.88509812717984,40.82805000000001],[-73.88423210177606,40.82655000000001],[-73.88509812717984,40.82505000000001],[-73.88423210177606,40.82355000000001],[-73.88509812717984,40.82205000000001],[-73.88423210177606,40.82055000000001],[-73.88250005096849,40.82055000000001],[-73.88163402556471,40.81905000000001],[-73.88250005096849,40.81755000000001],[-73.88163402556471,40.81605000000001],[-73.87990197475713,40.81605000000001],[-73.87903594935335,40.81455000000001],[-73.87990197475713,40.81305000000001],[-73.87903594935335,40.81155000000001],[-73.87730389854578,40.81155000000001],[-73.876437873142,40.81005000000001],[-73.87470582233442,40.81005000000001],[-73.87383979693064,40.80855000000001],[-73.87470582233442,40.80705000000001],[-73.876437873142,40.80705000000001],[-73.87730389854578,40.80555000000001],[-73.87903594935335,40.80555000000001],[-73.87990197475713,40.80405000000001],[-73.88163402556471,40.80405000000001],[-73.88250005096849,40.80255000000001],[-73.88423210177606,40.80255000000001],[-73.88509812717984,40.80405000000001],[-73.88683017798742,40.80405000000001],[-73.8876962033912,40.80255000000001],[-73.88942825419878,40.80255000000001],[-73.89029427960256,40.80405000000001],[-73.89202633041013,40.80405000000001],[-73.89289235581391,40.80555000000001],[-73.89462440662149,40.80555000000001],[-73.89549043202527,40.80405000000001],[-73.89722248283285,40.80405000000001]]]],"type":"MultiPolygon"}},{"id":"54","properties":{"borough":"bronx","borocode":2,"neighborhood":"East Tremont"},"type":"Feature","geometry":{"coordinates":[[[[-73.86950966991171,40.84605000000001],[-73.87124172071928,40.84605000000001],[-73.87210774612306,40.84755000000001],[-73.87124172071928,40.84905000000001],[-73.86950966991171,40.84905000000001],[-73.86864364450793,40.84755000000001],[-73.86950966991171,40.84605000000001]]],[[[-73.89202633041013,40.83705000000001],[-73.89289235581391,40.83855000000001],[-73.89202633041013,40.84005000000001],[-73.89289235581391,40.84155000000001],[-73.89462440662149,40.84155000000001],[-73.89549043202527,40.84305000000001],[-73.89462440662149,40.84455000000001],[-73.89549043202527,40.84605000000001],[-73.89462440662149,40.84755000000001],[-73.89549043202527,40.84905000000001],[-73.89462440662149,40.85055000000001],[-73.89549043202527,40.85205000000001],[-73.89462440662149,40.85355000000001],[-73.89289235581391,40.85355000000001],[-73.89202633041013,40.85205000000001],[-73.89029427960256,40.85205000000001],[-73.88942825419878,40.85055000000001],[-73.8876962033912,40.85055000000001],[-73.88683017798742,40.84905000000001],[-73.88509812717984,40.84905000000001],[-73.88423210177606,40.85055000000001],[-73.88250005096849,40.85055000000001],[-73.88163402556471,40.84905000000001],[-73.87990197475713,40.84905000000001],[-73.87903594935335,40.84755000000001],[-73.87730389854578,40.84755000000001],[-73.876437873142,40.84605000000001],[-73.87730389854578,40.84455000000001],[-73.876437873142,40.84305000000001],[-73.87470582233442,40.84305000000001],[-73.87383979693064,40.84455000000001],[-73.87210774612306,40.84455000000001],[-73.87124172071928,40.84305000000001],[-73.87210774612306,40.84155000000001],[-73.87383979693064,40.84155000000001],[-73.87470582233442,40.84005000000001],[-73.876437873142,40.84005000000001],[-73.87730389854578,40.83855000000001],[-73.87903594935335,40.83855000000001],[-73.87990197475713,40.83705000000001],[-73.88163402556471,40.83705000000001],[-73.88250005096849,40.83855000000001],[-73.88423210177606,40.83855000000001],[-73.88509812717984,40.84005000000001],[-73.88683017798742,40.84005000000001],[-73.8876962033912,40.83855000000001],[-73.88942825419878,40.83855000000001],[-73.89029427960256,40.83705000000001],[-73.89202633041013,40.83705000000001]]]],"type":"MultiPolygon"}},{"id":"159","properties":{"borough":"brooklyn","borocode":3,"neighborhood":"Starrett City"},"type":"Feature","geometry":{"coordinates":[[[-73.87903594935335,40.637550000000005],[-73.87990197475713,40.639050000000005],[-73.87903594935335,40.640550000000005],[-73.87990197475713,40.642050000000005],[-73.88163402556471,40.642050000000005],[-73.88250005096849,40.643550000000005],[-73.88423210177606,40.643550000000005],[-73.88509812717984,40.645050000000005],[-73.88683017798742,40.645050000000005],[-73.8876962033912,40.646550000000005],[-73.88942825419878,40.646550000000005],[-73.89029427960256,40.648050000000005],[-73.88942825419878,40.649550000000005],[-73.8876962033912,40.649550000000005],[-73.88683017798742,40.651050000000005],[-73.88509812717984,40.651050000000005],[-73.88423210177606,40.652550000000005],[-73.88509812717984,40.654050000000005],[-73.88423210177606,40.655550000000005],[-73.88250005096849,40.655550000000005],[-73.88163402556471,40.654050000000005],[-73.87990197475713,40.654050000000005],[-73.87903594935335,40.652550000000005],[-73.87730389854578,40.652550000000005],[-73.876437873142,40.651050000000005],[-73.87730389854578,40.649550000000005],[-73.876437873142,40.648050000000005],[-73.87470582233442,40.648050000000005],[-73.87383979693064,40.646550000000005],[-73.87470582233442,40.645050000000005],[-73.87383979693064,40.643550000000005],[-73.87470582233442,40.642050000000005],[-73.876437873142,40.642050000000005],[-73.87730389854578,40.640550000000005],[-73.876437873142,40.639050000000005],[-73.87730389854578,40.637550000000005],[-73.87903594935335,40.637550000000005]]],"type":"Polygon"}},{"id":"58","properties":{"borough":"queens","borocode":4,"neighborhood":"Elmhurst"},"type":"Feature","geometry":{"coordinates":[[[-73.87210774612306,40.73055000000001],[-73.87383979693064,40.73055000000001],[-73.87470582233442,40.73205000000001],[-73.876437873142,40.73205000000001],[-73.87730389854578,40.73055000000001],[-73.87903594935335,40.73055000000001],[-73.87990197475713,40.72905000000001],[-73.88163402556471,40.72905000000001],[-73.88250005096849,40.72755000000001],[-73.88423210177606,40.72755000000001],[-73.88509812717984,40.72905000000001],[-73.88683017798742,40.72905000000001],[-73.8876962033912,40.73055000000001],[-73.88683017798742,40.73205000000001],[-73.8876962033912,40.73355000000001],[-73.88683017798742,40.73505000000001],[-73.88509812717984,40.73505000000001],[-73.88423210177606,40.73355000000001],[-73.88250005096849,40.73355000000001],[-73.88163402556471,40.73205000000001],[-73.87990197475713,40.73205000000001],[-73.87903594935335,40.73355000000001],[-73.87990197475713,40.73505000000001],[-73.87903594935335,40.73655000000001],[-73.87990197475713,40.73805000000001],[-73.87903594935335,40.73955000000001],[-73.87990197475713,40.74105000000001],[-73.88163402556471,40.74105000000001],[-73.88250005096849,40.73955000000001],[-73.88423210177606,40.73955000000001],[-73.88509812717984,40.74105000000001],[-73.88683017798742,40.74105000000001],[-73.8876962033912,40.74255000000001],[-73.88942825419878,40.74255000000001],[-73.89029427960256,40.74405000000001],[-73.88942825419878,40.74555000000001],[-73.89029427960256,40.74705000000001],[-73.88942825419878,40.74855000000001],[-73.8876962033912,40.74855000000001],[-73.88683017798742,40.74705000000001],[-73.88509812717984,40.74705000000001],[-73.88423210177606,40.74855000000001],[-73.88250005096849,40.74855000000001],[-73.88163402556471,40.75005000000001],[-73.87990197475713,40.75005000000001],[-73.87903594935335,40.74855000000001],[-73.87730389854578,40.74855000000001],[-73.876437873142,40.74705000000001],[-73.87470582233442,40.74705000000001],[-73.87383979693064,40.74855000000001],[-73.87210774612306,40.74855000000001],[-73.87124172071928,40.75005000000001],[-73.86950966991171,40.75005000000001],[-73.86864364450793,40.74855000000001],[-73.86950966991171,40.74705000000001],[-73.86864364450793,40.74555000000001],[-73.86691159370035,40.74555000000001],[-73.86604556829657,40.74405000000001],[-73.86691159370035,40.74255000000001],[-73.86604556829657,40.74105000000001],[-73.86691159370035,40.73955000000001],[-73.86604556829657,40.73805000000001],[-73.86691159370035,40.73655000000001],[-73.86604556829657,40.73505000000001],[-73.86691159370035,40.73355000000001],[-73.86864364450793,40.73355000000001],[-73.86950966991171,40.73205000000001],[-73.87124172071928,40.73205000000001],[-73.87210774612306,40.73055000000001]]],"type":"Polygon"}},{"id":"14","properties":{"borough":"bronx","borocode":2,"neighborhood":"Belmont"},"type":"Feature","geometry":{"coordinates":[[[-73.88509812717984,40.84905000000001],[-73.88683017798742,40.84905000000001],[-73.8876962033912,40.85055000000001],[-73.88942825419878,40.85055000000001],[-73.89029427960256,40.85205000000001],[-73.88942825419878,40.85355000000001],[-73.89029427960256,40.85505000000001],[-73.88942825419878,40.85655000000001],[-73.89029427960256,40.85805000000001],[-73.88942825419878,40.85955000000001],[-73.89029427960256,40.86105000000001],[-73.88942825419878,40.86255000000001],[-73.8876962033912,40.86255000000001],[-73.88683017798742,40.86405000000001],[-73.88509812717984,40.86405000000001],[-73.88423210177606,40.86555000000001],[-73.88250005096849,40.86555000000001],[-73.88163402556471,40.86405000000001],[-73.88250005096849,40.86255000000001],[-73.88423210177606,40.86255000000001],[-73.88509812717984,40.86105000000001],[-73.88423210177606,40.85955000000001],[-73.88250005096849,40.85955000000001],[-73.88163402556471,40.86105000000001],[-73.87990197475713,40.86105000000001],[-73.87903594935335,40.85955000000001],[-73.87990197475713,40.85805000000001],[-73.87903594935335,40.85655000000001],[-73.87990197475713,40.85505000000001],[-73.87903594935335,40.85355000000001],[-73.87990197475713,40.85205000000001],[-73.88163402556471,40.85205000000001],[-73.88250005096849,40.85055000000001],[-73.88423210177606,40.85055000000001],[-73.88509812717984,40.84905000000001]]],"type":"Polygon"}},{"id":"151","properties":{"borough":"bronx","borocode":2,"neighborhood":"Soundview-Castle Hill-Clason Point-Harding Park"},"type":"Feature","geometry":{"coordinates":[[[-73.87990197475713,40.81605000000001],[-73.88163402556471,40.81605000000001],[-73.88250005096849,40.81755000000001],[-73.88163402556471,40.81905000000001],[-73.88250005096849,40.82055000000001],[-73.88423210177606,40.82055000000001],[-73.88509812717984,40.82205000000001],[-73.88423210177606,40.82355000000001],[-73.88250005096849,40.82355000000001],[-73.88163402556471,40.82205000000001],[-73.87990197475713,40.82205000000001],[-73.87903594935335,40.82355000000001],[-73.87730389854578,40.82355000000001],[-73.876437873142,40.82205000000001],[-73.87470582233442,40.82205000000001],[-73.87383979693064,40.82355000000001],[-73.87210774612306,40.82355000000001],[-73.87124172071928,40.82505000000001],[-73.86950966991171,40.82505000000001],[-73.86864364450793,40.82655000000001],[-73.86691159370035,40.82655000000001],[-73.86604556829657,40.82505000000001],[-73.864313517489,40.82505000000001],[-73.86344749208521,40.82655000000001],[-73.86171544127764,40.82655000000001],[-73.86084941587386,40.82505000000001],[-73.85911736506628,40.82505000000001],[-73.8582513396625,40.82655000000001],[-73.85651928885493,40.82655000000001],[-73.85565326345115,40.82505000000001],[-73.85651928885493,40.82355000000001],[-73.85565326345115,40.82205000000001],[-73.85392121264357,40.82205000000001],[-73.85305518723979,40.82355000000001],[-73.85132313643221,40.82355000000001],[-73.85045711102843,40.82205000000001],[-73.84872506022086,40.82205000000001],[-73.84785903481708,40.82355000000001],[-73.8461269840095,40.82355000000001],[-73.84526095860572,40.82205000000001],[-73.84352890779815,40.82205000000001],[-73.84266288239436,40.82355000000001],[-73.84093083158679,40.82355000000001],[-73.84006480618301,40.82505000000001],[-73.84093083158679,40.82655000000001],[-73.84266288239436,40.82655000000001],[-73.84352890779815,40.82805000000001],[-73.84266288239436,40.82955000000001],[-73.84093083158679,40.82955000000001],[-73.84006480618301,40.82805000000001],[-73.83833275537543,40.82805000000001],[-73.83746672997165,40.82955000000001],[-73.83573467916408,40.82955000000001],[-73.8348686537603,40.82805000000001],[-73.83573467916408,40.82655000000001],[-73.8348686537603,40.82505000000001],[-73.83573467916408,40.82355000000001],[-73.8348686537603,40.82205000000001],[-73.83573467916408,40.82055000000001],[-73.8348686537603,40.81905000000001],[-73.83573467916408,40.81755000000001],[-73.8348686537603,40.81605000000001],[-73.83573467916408,40.81455000000001],[-73.83746672997165,40.81455000000001],[-73.83833275537543,40.81605000000001],[-73.84006480618301,40.81605000000001],[-73.84093083158679,40.81455000000001],[-73.84266288239436,40.81455000000001],[-73.84352890779815,40.81305000000001],[-73.84266288239436,40.81155000000001],[-73.84352890779815,40.81005000000001],[-73.84526095860572,40.81005000000001],[-73.8461269840095,40.81155000000001],[-73.84785903481708,40.81155000000001],[-73.84872506022086,40.81005000000001],[-73.84785903481708,40.80855000000001],[-73.84872506022086,40.80705000000001],[-73.84785903481708,40.80555000000001],[-73.84872506022086,40.80405000000001],[-73.85045711102843,40.80405000000001],[-73.85132313643221,40.80255000000001],[-73.85305518723979,40.80255000000001],[-73.85392121264357,40.80405000000001],[-73.85565326345115,40.80405000000001],[-73.85651928885493,40.80255000000001],[-73.8582513396625,40.80255000000001],[-73.85911736506628,40.80405000000001],[-73.8582513396625,40.80555000000001],[-73.85911736506628,40.80705000000001],[-73.86084941587386,40.80705000000001],[-73.86171544127764,40.80855000000001],[-73.86084941587386,40.81005000000001],[-73.86171544127764,40.81155000000001],[-73.86344749208521,40.81155000000001],[-73.864313517489,40.81305000000001],[-73.86604556829657,40.81305000000001],[-73.86691159370035,40.81455000000001],[-73.86864364450793,40.81455000000001],[-73.86950966991171,40.81605000000001],[-73.87124172071928,40.81605000000001],[-73.87210774612306,40.81755000000001],[-73.87383979693064,40.81755000000001],[-73.87470582233442,40.81905000000001],[-73.876437873142,40.81905000000001],[-73.87730389854578,40.81755000000001],[-73.87903594935335,40.81755000000001],[-73.87990197475713,40.81605000000001]]],"type":"Polygon"}},{"id":"47","properties":{"borough":"queens","borocode":4,"neighborhood":"East Elmhurst"},"type":"Feature","geometry":{"coordinates":[[[-73.85651928885493,40.75755000000001],[-73.8582513396625,40.75755000000001],[-73.85911736506628,40.75905000000001],[-73.86084941587386,40.75905000000001],[-73.86171544127764,40.75755000000001],[-73.86344749208521,40.75755000000001],[-73.864313517489,40.75905000000001],[-73.86604556829657,40.75905000000001],[-73.86691159370035,40.75755000000001],[-73.86864364450793,40.75755000000001],[-73.86950966991171,40.75605000000001],[-73.87124172071928,40.75605000000001],[-73.87210774612306,40.75755000000001],[-73.87383979693064,40.75755000000001],[-73.87470582233442,40.75905000000001],[-73.876437873142,40.75905000000001],[-73.87730389854578,40.76055000000001],[-73.876437873142,40.76205000000001],[-73.87470582233442,40.76205000000001],[-73.87383979693064,40.76355000000001],[-73.87470582233442,40.76505000000001],[-73.876437873142,40.76505000000001],[-73.87730389854578,40.76655000000001],[-73.876437873142,40.76805000000001],[-73.87470582233442,40.76805000000001],[-73.87383979693064,40.76955000000001],[-73.87470582233442,40.77105000000001],[-73.87383979693064,40.77255000000001],[-73.87210774612306,40.77255000000001],[-73.87124172071928,40.77105000000001],[-73.86950966991171,40.77105000000001],[-73.86864364450793,40.77255000000001],[-73.86691159370035,40.77255000000001],[-73.86604556829657,40.77105000000001],[-73.86691159370035,40.76955000000001],[-73.86604556829657,40.76805000000001],[-73.864313517489,40.76805000000001],[-73.86344749208521,40.76655000000001],[-73.86171544127764,40.76655000000001],[-73.86084941587386,40.76505000000001],[-73.85911736506628,40.76505000000001],[-73.8582513396625,40.76355000000001],[-73.85911736506628,40.76205000000001],[-73.8582513396625,40.76055000000001],[-73.85651928885493,40.76055000000001],[-73.85565326345115,40.75905000000001],[-73.85651928885493,40.75755000000001]]],"type":"Polygon"}},{"id":"186","properties":{"borough":"bronx","borocode":2,"neighborhood":"Woodlawn-Wakefield"},"type":"Feature","geometry":{"coordinates":[[[-73.86171544127764,40.892550000000014],[-73.86344749208521,40.892550000000014],[-73.864313517489,40.894050000000014],[-73.86604556829657,40.894050000000014],[-73.86691159370035,40.895550000000014],[-73.86864364450793,40.895550000000014],[-73.86950966991171,40.894050000000014],[-73.87124172071928,40.894050000000014],[-73.87210774612306,40.895550000000014],[-73.87383979693064,40.895550000000014],[-73.87470582233442,40.894050000000014],[-73.876437873142,40.894050000000014],[-73.87730389854578,40.895550000000014],[-73.876437873142,40.897050000000014],[-73.87730389854578,40.898550000000014],[-73.876437873142,40.900050000000014],[-73.87470582233442,40.900050000000014],[-73.87383979693064,40.901550000000015],[-73.87210774612306,40.901550000000015],[-73.87124172071928,40.903050000000015],[-73.86950966991171,40.903050000000015],[-73.86864364450793,40.904550000000015],[-73.86691159370035,40.904550000000015],[-73.86604556829657,40.903050000000015],[-73.864313517489,40.903050000000015],[-73.86344749208521,40.904550000000015],[-73.86171544127764,40.904550000000015],[-73.86084941587386,40.903050000000015],[-73.85911736506628,40.903050000000015],[-73.8582513396625,40.904550000000015],[-73.85911736506628,40.906050000000015],[-73.8582513396625,40.907550000000015],[-73.85651928885493,40.907550000000015],[-73.85565326345115,40.909050000000015],[-73.85392121264357,40.909050000000015],[-73.85305518723979,40.910550000000015],[-73.85132313643221,40.910550000000015],[-73.85045711102843,40.909050000000015],[-73.84872506022086,40.909050000000015],[-73.84785903481708,40.907550000000015],[-73.8461269840095,40.907550000000015],[-73.84526095860572,40.906050000000015],[-73.84352890779815,40.906050000000015],[-73.84266288239436,40.904550000000015],[-73.84093083158679,40.904550000000015],[-73.84006480618301,40.903050000000015],[-73.83833275537543,40.903050000000015],[-73.83746672997165,40.901550000000015],[-73.83833275537543,40.900050000000014],[-73.83746672997165,40.898550000000014],[-73.83833275537543,40.897050000000014],[-73.83746672997165,40.895550000000014],[-73.83573467916408,40.895550000000014],[-73.8348686537603,40.894050000000014],[-73.83573467916408,40.892550000000014],[-73.8348686537603,40.891050000000014],[-73.83573467916408,40.889550000000014],[-73.83746672997165,40.889550000000014],[-73.83833275537543,40.888050000000014],[-73.84006480618301,40.888050000000014],[-73.84093083158679,40.886550000000014],[-73.84266288239436,40.886550000000014],[-73.84352890779815,40.888050000000014],[-73.84526095860572,40.888050000000014],[-73.8461269840095,40.889550000000014],[-73.84785903481708,40.889550000000014],[-73.84872506022086,40.891050000000014],[-73.85045711102843,40.891050000000014],[-73.85132313643221,40.892550000000014],[-73.85305518723979,40.892550000000014],[-73.85392121264357,40.894050000000014],[-73.85565326345115,40.894050000000014],[-73.85651928885493,40.892550000000014],[-73.8582513396625,40.892550000000014],[-73.85911736506628,40.894050000000014],[-73.86084941587386,40.894050000000014],[-73.86171544127764,40.892550000000014]]],"type":"Polygon"}},{"id":"118","properties":{"borough":"queens","borocode":4,"neighborhood":"North Corona"},"type":"Feature","geometry":{"coordinates":[[[-73.86691159370035,40.74555000000001],[-73.86864364450793,40.74555000000001],[-73.86950966991171,40.74705000000001],[-73.86864364450793,40.74855000000001],[-73.86950966991171,40.75005000000001],[-73.87124172071928,40.75005000000001],[-73.87210774612306,40.75155000000001],[-73.87124172071928,40.75305000000001],[-73.87210774612306,40.75455000000001],[-73.87383979693064,40.75455000000001],[-73.87470582233442,40.75605000000001],[-73.87383979693064,40.75755000000001],[-73.87210774612306,40.75755000000001],[-73.87124172071928,40.75605000000001],[-73.86950966991171,40.75605000000001],[-73.86864364450793,40.75755000000001],[-73.86691159370035,40.75755000000001],[-73.86604556829657,40.75905000000001],[-73.864313517489,40.75905000000001],[-73.86344749208521,40.75755000000001],[-73.86171544127764,40.75755000000001],[-73.86084941587386,40.75905000000001],[-73.85911736506628,40.75905000000001],[-73.8582513396625,40.75755000000001],[-73.85651928885493,40.75755000000001],[-73.85565326345115,40.75905000000001],[-73.85392121264357,40.75905000000001],[-73.85305518723979,40.75755000000001],[-73.85392121264357,40.75605000000001],[-73.85565326345115,40.75605000000001],[-73.85651928885493,40.75455000000001],[-73.85565326345115,40.75305000000001],[-73.85651928885493,40.75155000000001],[-73.85565326345115,40.75005000000001],[-73.85651928885493,40.74855000000001],[-73.8582513396625,40.74855000000001],[-73.85911736506628,40.74705000000001],[-73.86084941587386,40.74705000000001],[-73.86171544127764,40.74555000000001],[-73.86344749208521,40.74555000000001],[-73.864313517489,40.74705000000001],[-73.86604556829657,40.74705000000001],[-73.86691159370035,40.74555000000001]]],"type":"Polygon"}},{"id":"140","properties":{"borough":"queens","borocode":4,"neighborhood":"Rego Park"},"type":"Feature","geometry":{"coordinates":[[[-73.85911736506628,40.71105000000001],[-73.86084941587386,40.71105000000001],[-73.86171544127764,40.71255000000001],[-73.86084941587386,40.71405000000001],[-73.86171544127764,40.71555000000001],[-73.86344749208521,40.71555000000001],[-73.864313517489,40.71705000000001],[-73.86604556829657,40.71705000000001],[-73.86691159370035,40.71855000000001],[-73.86604556829657,40.72005000000001],[-73.86691159370035,40.72155000000001],[-73.86864364450793,40.72155000000001],[-73.86950966991171,40.72305000000001],[-73.86864364450793,40.72455000000001],[-73.86950966991171,40.72605000000001],[-73.87124172071928,40.72605000000001],[-73.87210774612306,40.72755000000001],[-73.87124172071928,40.72905000000001],[-73.87210774612306,40.73055000000001],[-73.87124172071928,40.73205000000001],[-73.86950966991171,40.73205000000001],[-73.86864364450793,40.73355000000001],[-73.86691159370035,40.73355000000001],[-73.86604556829657,40.73505000000001],[-73.864313517489,40.73505000000001],[-73.86344749208521,40.73355000000001],[-73.86171544127764,40.73355000000001],[-73.86084941587386,40.73505000000001],[-73.85911736506628,40.73505000000001],[-73.8582513396625,40.73355000000001],[-73.85911736506628,40.73205000000001],[-73.8582513396625,40.73055000000001],[-73.85911736506628,40.72905000000001],[-73.8582513396625,40.72755000000001],[-73.85911736506628,40.72605000000001],[-73.8582513396625,40.72455000000001],[-73.85911736506628,40.72305000000001],[-73.8582513396625,40.72155000000001],[-73.85911736506628,40.72005000000001],[-73.8582513396625,40.71855000000001],[-73.85911736506628,40.71705000000001],[-73.8582513396625,40.71555000000001],[-73.85911736506628,40.71405000000001],[-73.8582513396625,40.71255000000001],[-73.85911736506628,40.71105000000001]]],"type":"Polygon"}},{"id":"171","properties":{"borough":"bronx","borocode":2,"neighborhood":"Van Nest-Morris Park-Westchester Square"},"type":"Feature","geometry":{"coordinates":[[[-73.86691159370035,40.83855000000001],[-73.86864364450793,40.83855000000001],[-73.86950966991171,40.84005000000001],[-73.87124172071928,40.84005000000001],[-73.87210774612306,40.84155000000001],[-73.87124172071928,40.84305000000001],[-73.87210774612306,40.84455000000001],[-73.87124172071928,40.84605000000001],[-73.86950966991171,40.84605000000001],[-73.86864364450793,40.84755000000001],[-73.86950966991171,40.84905000000001],[-73.86864364450793,40.85055000000001],[-73.86691159370035,40.85055000000001],[-73.86604556829657,40.85205000000001],[-73.864313517489,40.85205000000001],[-73.86344749208521,40.85055000000001],[-73.86171544127764,40.85055000000001],[-73.86084941587386,40.84905000000001],[-73.85911736506628,40.84905000000001],[-73.8582513396625,40.85055000000001],[-73.85651928885493,40.85055000000001],[-73.85565326345115,40.85205000000001],[-73.85392121264357,40.85205000000001],[-73.85305518723979,40.85055000000001],[-73.85132313643221,40.85055000000001],[-73.85045711102843,40.85205000000001],[-73.84872506022086,40.85205000000001],[-73.84785903481708,40.85055000000001],[-73.8461269840095,40.85055000000001],[-73.84526095860572,40.84905000000001],[-73.84352890779815,40.84905000000001],[-73.84266288239436,40.85055000000001],[-73.84093083158679,40.85055000000001],[-73.84006480618301,40.85205000000001],[-73.84093083158679,40.85355000000001],[-73.84006480618301,40.85505000000001],[-73.83833275537543,40.85505000000001],[-73.83746672997165,40.85655000000001],[-73.83573467916408,40.85655000000001],[-73.8348686537603,40.85805000000001],[-73.83313660295272,40.85805000000001],[-73.83227057754894,40.85655000000001],[-73.83313660295272,40.85505000000001],[-73.8348686537603,40.85505000000001],[-73.83573467916408,40.85355000000001],[-73.8348686537603,40.85205000000001],[-73.83573467916408,40.85055000000001],[-73.83746672997165,40.85055000000001],[-73.83833275537543,40.84905000000001],[-73.83746672997165,40.84755000000001],[-73.83833275537543,40.84605000000001],[-73.83746672997165,40.84455000000001],[-73.83833275537543,40.84305000000001],[-73.83746672997165,40.84155000000001],[-73.83833275537543,40.84005000000001],[-73.84006480618301,40.84005000000001],[-73.84093083158679,40.84155000000001],[-73.84266288239436,40.84155000000001],[-73.84352890779815,40.84005000000001],[-73.84526095860572,40.84005000000001],[-73.8461269840095,40.84155000000001],[-73.84785903481708,40.84155000000001],[-73.84872506022086,40.84305000000001],[-73.85045711102843,40.84305000000001],[-73.85132313643221,40.84155000000001],[-73.85305518723979,40.84155000000001],[-73.85392121264357,40.84005000000001],[-73.85565326345115,40.84005000000001],[-73.85651928885493,40.84155000000001],[-73.8582513396625,40.84155000000001],[-73.85911736506628,40.84305000000001],[-73.86084941587386,40.84305000000001],[-73.86171544127764,40.84155000000001],[-73.86344749208521,40.84155000000001],[-73.864313517489,40.84005000000001],[-73.86604556829657,40.84005000000001],[-73.86691159370035,40.83855000000001]]],"type":"Polygon"}},{"id":"132","properties":{"borough":"bronx","borocode":2,"neighborhood":"Pelham Parkway"},"type":"Feature","geometry":{"coordinates":[[[-73.86691159370035,40.85055000000001],[-73.86864364450793,40.85055000000001],[-73.86950966991171,40.85205000000001],[-73.87124172071928,40.85205000000001],[-73.87210774612306,40.85355000000001],[-73.87124172071928,40.85505000000001],[-73.87210774612306,40.85655000000001],[-73.87124172071928,40.85805000000001],[-73.86950966991171,40.85805000000001],[-73.86864364450793,40.85655000000001],[-73.86691159370035,40.85655000000001],[-73.86604556829657,40.85805000000001],[-73.864313517489,40.85805000000001],[-73.86344749208521,40.85955000000001],[-73.86171544127764,40.85955000000001],[-73.86084941587386,40.85805000000001],[-73.85911736506628,40.85805000000001],[-73.8582513396625,40.85955000000001],[-73.85651928885493,40.85955000000001],[-73.85565326345115,40.85805000000001],[-73.85392121264357,40.85805000000001],[-73.85305518723979,40.85655000000001],[-73.85132313643221,40.85655000000001],[-73.85045711102843,40.85805000000001],[-73.84872506022086,40.85805000000001],[-73.84785903481708,40.85655000000001],[-73.8461269840095,40.85655000000001],[-73.84526095860572,40.85805000000001],[-73.84352890779815,40.85805000000001],[-73.84266288239436,40.85655000000001],[-73.84093083158679,40.85655000000001],[-73.84006480618301,40.85505000000001],[-73.84093083158679,40.85355000000001],[-73.84006480618301,40.85205000000001],[-73.84093083158679,40.85055000000001],[-73.84266288239436,40.85055000000001],[-73.84352890779815,40.84905000000001],[-73.84526095860572,40.84905000000001],[-73.8461269840095,40.85055000000001],[-73.84785903481708,40.85055000000001],[-73.84872506022086,40.85205000000001],[-73.85045711102843,40.85205000000001],[-73.85132313643221,40.85055000000001],[-73.85305518723979,40.85055000000001],[-73.85392121264357,40.85205000000001],[-73.85565326345115,40.85205000000001],[-73.85651928885493,40.85055000000001],[-73.8582513396625,40.85055000000001],[-73.85911736506628,40.84905000000001],[-73.86084941587386,40.84905000000001],[-73.86171544127764,40.85055000000001],[-73.86344749208521,40.85055000000001],[-73.864313517489,40.85205000000001],[-73.86604556829657,40.85205000000001],[-73.86691159370035,40.85055000000001]]],"type":"Polygon"}},{"id":"21","properties":{"borough":"bronx","borocode":2,"neighborhood":"Bronxdale"},"type":"Feature","geometry":{"coordinates":[[[-73.85911736506628,40.85805000000001],[-73.86084941587386,40.85805000000001],[-73.86171544127764,40.85955000000001],[-73.86344749208521,40.85955000000001],[-73.864313517489,40.85805000000001],[-73.86604556829657,40.85805000000001],[-73.86691159370035,40.85655000000001],[-73.86864364450793,40.85655000000001],[-73.86950966991171,40.85805000000001],[-73.87124172071928,40.85805000000001],[-73.87210774612306,40.85955000000001],[-73.87124172071928,40.86105000000001],[-73.87210774612306,40.86255000000001],[-73.87124172071928,40.86405000000001],[-73.87210774612306,40.86555000000001],[-73.87124172071928,40.86705000000001],[-73.87210774612306,40.86855000000001],[-73.87124172071928,40.87005000000001],[-73.86950966991171,40.87005000000001],[-73.86864364450793,40.87155000000001],[-73.86691159370035,40.87155000000001],[-73.86604556829657,40.87005000000001],[-73.864313517489,40.87005000000001],[-73.86344749208521,40.87155000000001],[-73.86171544127764,40.87155000000001],[-73.86084941587386,40.87005000000001],[-73.86171544127764,40.86855000000001],[-73.86084941587386,40.86705000000001],[-73.85911736506628,40.86705000000001],[-73.8582513396625,40.86555000000001],[-73.85911736506628,40.86405000000001],[-73.8582513396625,40.86255000000001],[-73.85911736506628,40.86105000000001],[-73.8582513396625,40.85955000000001],[-73.85911736506628,40.85805000000001]]],"type":"Polygon"}},{"id":"182","properties":{"borough":"bronx","borocode":2,"neighborhood":"Williamsbridge-Olinville"},"type":"Feature","geometry":{"coordinates":[[[-73.85911736506628,40.87005000000001],[-73.86084941587386,40.87005000000001],[-73.86171544127764,40.87155000000001],[-73.86344749208521,40.87155000000001],[-73.864313517489,40.87005000000001],[-73.86604556829657,40.87005000000001],[-73.86691159370035,40.87155000000001],[-73.86864364450793,40.87155000000001],[-73.86950966991171,40.87005000000001],[-73.87124172071928,40.87005000000001],[-73.87210774612306,40.87155000000001],[-73.87124172071928,40.87305000000001],[-73.87210774612306,40.87455000000001],[-73.87124172071928,40.87605000000001],[-73.86950966991171,40.87605000000001],[-73.86864364450793,40.877550000000014],[-73.86950966991171,40.879050000000014],[-73.86864364450793,40.880550000000014],[-73.86950966991171,40.882050000000014],[-73.86864364450793,40.883550000000014],[-73.86950966991171,40.885050000000014],[-73.86864364450793,40.886550000000014],[-73.86691159370035,40.886550000000014],[-73.86604556829657,40.888050000000014],[-73.86691159370035,40.889550000000014],[-73.86604556829657,40.891050000000014],[-73.864313517489,40.891050000000014],[-73.86344749208521,40.892550000000014],[-73.86171544127764,40.892550000000014],[-73.86084941587386,40.894050000000014],[-73.85911736506628,40.894050000000014],[-73.8582513396625,40.892550000000014],[-73.85651928885493,40.892550000000014],[-73.85565326345115,40.894050000000014],[-73.85392121264357,40.894050000000014],[-73.85305518723979,40.892550000000014],[-73.85132313643221,40.892550000000014],[-73.85045711102843,40.891050000000014],[-73.84872506022086,40.891050000000014],[-73.84785903481708,40.889550000000014],[-73.8461269840095,40.889550000000014],[-73.84526095860572,40.888050000000014],[-73.8461269840095,40.886550000000014],[-73.84785903481708,40.886550000000014],[-73.84872506022086,40.885050000000014],[-73.84785903481708,40.883550000000014],[-73.84872506022086,40.882050000000014],[-73.85045711102843,40.882050000000014],[-73.85132313643221,40.880550000000014],[-73.85045711102843,40.879050000000014],[-73.85132313643221,40.877550000000014],[-73.85045711102843,40.87605000000001],[-73.85132313643221,40.87455000000001],[-73.85305518723979,40.87455000000001],[-73.85392121264357,40.87305000000001],[-73.85565326345115,40.87305000000001],[-73.85651928885493,40.87155000000001],[-73.8582513396625,40.87155000000001],[-73.85911736506628,40.87005000000001]]],"type":"Polygon"}},{"id":"185","properties":{"borough":"queens","borocode":4,"neighborhood":"Woodhaven"},"type":"Feature","geometry":{"coordinates":[[[-73.84352890779815,40.681050000000006],[-73.84526095860572,40.681050000000006],[-73.8461269840095,40.682550000000006],[-73.84785903481708,40.682550000000006],[-73.84872506022086,40.681050000000006],[-73.85045711102843,40.681050000000006],[-73.85132313643221,40.679550000000006],[-73.85305518723979,40.679550000000006],[-73.85392121264357,40.678050000000006],[-73.85565326345115,40.678050000000006],[-73.85651928885493,40.679550000000006],[-73.8582513396625,40.679550000000006],[-73.85911736506628,40.681050000000006],[-73.86084941587386,40.681050000000006],[-73.86171544127764,40.679550000000006],[-73.86344749208521,40.679550000000006],[-73.864313517489,40.681050000000006],[-73.86604556829657,40.681050000000006],[-73.86691159370035,40.682550000000006],[-73.86604556829657,40.684050000000006],[-73.86691159370035,40.685550000000006],[-73.86604556829657,40.687050000000006],[-73.86691159370035,40.688550000000006],[-73.86864364450793,40.688550000000006],[-73.86950966991171,40.69005000000001],[-73.86864364450793,40.69155000000001],[-73.86950966991171,40.69305000000001],[-73.86864364450793,40.69455000000001],[-73.86950966991171,40.69605000000001],[-73.86864364450793,40.69755000000001],[-73.86691159370035,40.69755000000001],[-73.86604556829657,40.69605000000001],[-73.864313517489,40.69605000000001],[-73.86344749208521,40.69755000000001],[-73.86171544127764,40.69755000000001],[-73.86084941587386,40.69905000000001],[-73.85911736506628,40.69905000000001],[-73.8582513396625,40.69755000000001],[-73.85651928885493,40.69755000000001],[-73.85565326345115,40.69905000000001],[-73.85392121264357,40.69905000000001],[-73.85305518723979,40.70055000000001],[-73.85132313643221,40.70055000000001],[-73.85045711102843,40.69905000000001],[-73.84872506022086,40.69905000000001],[-73.84785903481708,40.69755000000001],[-73.84872506022086,40.69605000000001],[-73.84785903481708,40.69455000000001],[-73.8461269840095,40.69455000000001],[-73.84526095860572,40.69305000000001],[-73.8461269840095,40.69155000000001],[-73.84526095860572,40.69005000000001],[-73.84352890779815,40.69005000000001],[-73.84266288239436,40.688550000000006],[-73.84352890779815,40.687050000000006],[-73.84266288239436,40.685550000000006],[-73.84093083158679,40.685550000000006],[-73.84006480618301,40.684050000000006],[-73.84093083158679,40.682550000000006],[-73.84266288239436,40.682550000000006],[-73.84352890779815,40.681050000000006]]],"type":"Polygon"}},{"id":"18","properties":{"borough":"queens","borocode":4,"neighborhood":"Breezy Point-Belle Harbor-Rockaway Park-Broad Channel"},"type":"Feature","geometry":{"coordinates":[[[[-73.82014622189594,40.59555],[-73.82187827270351,40.59555],[-73.8227442981073,40.59705],[-73.82447634891487,40.59705],[-73.82534237431865,40.59855],[-73.82447634891487,40.60005],[-73.82534237431865,40.60155],[-73.82447634891487,40.60305],[-73.82534237431865,40.60455],[-73.82447634891487,40.60605],[-73.8227442981073,40.60605],[-73.82187827270351,40.60755],[-73.8227442981073,40.60905],[-73.82447634891487,40.60905],[-73.82534237431865,40.61055],[-73.82447634891487,40.61205],[-73.82534237431865,40.613550000000004],[-73.82447634891487,40.615050000000004],[-73.8227442981073,40.615050000000004],[-73.82187827270351,40.616550000000004],[-73.82014622189594,40.616550000000004],[-73.81928019649216,40.615050000000004],[-73.81754814568458,40.615050000000004],[-73.8166821202808,40.613550000000004],[-73.81495006947323,40.613550000000004],[-73.81408404406945,40.61205],[-73.81495006947323,40.61055],[-73.81408404406945,40.60905],[-73.81495006947323,40.60755],[-73.81408404406945,40.60605],[-73.81495006947323,40.60455],[-73.8166821202808,40.60455],[-73.81754814568458,40.60305],[-73.8166821202808,40.60155],[-73.81754814568458,40.60005],[-73.8166821202808,40.59855],[-73.81754814568458,40.59705],[-73.81928019649216,40.59705],[-73.82014622189594,40.59555]]],[[[-73.86171544127764,40.56555],[-73.86344749208521,40.56555],[-73.864313517489,40.56705],[-73.86344749208521,40.56855],[-73.864313517489,40.57005],[-73.86604556829657,40.57005],[-73.86691159370035,40.57155],[-73.86604556829657,40.57305],[-73.86691159370035,40.57455],[-73.86604556829657,40.57605],[-73.864313517489,40.57605],[-73.86344749208521,40.57755],[-73.86171544127764,40.57755],[-73.86084941587386,40.57905],[-73.85911736506628,40.57905],[-73.8582513396625,40.58055],[-73.85651928885493,40.58055],[-73.85565326345115,40.58205],[-73.85392121264357,40.58205],[-73.85305518723979,40.58355],[-73.85132313643221,40.58355],[-73.85045711102843,40.58505],[-73.84872506022086,40.58505],[-73.84785903481708,40.58355],[-73.8461269840095,40.58355],[-73.84526095860572,40.58205],[-73.84352890779815,40.58205],[-73.84266288239436,40.58355],[-73.84093083158679,40.58355],[-73.84006480618301,40.58505],[-73.83833275537543,40.58505],[-73.83746672997165,40.58355],[-73.83573467916408,40.58355],[-73.8348686537603,40.58505],[-73.83313660295272,40.58505],[-73.83227057754894,40.58655],[-73.83053852674136,40.58655],[-73.82967250133758,40.58505],[-73.82794045053001,40.58505],[-73.82707442512623,40.58655],[-73.82534237431865,40.58655],[-73.82447634891487,40.58805],[-73.8227442981073,40.58805],[-73.82187827270351,40.58955],[-73.82014622189594,40.58955],[-73.81928019649216,40.58805],[-73.81754814568458,40.58805],[-73.8166821202808,40.58655],[-73.81754814568458,40.58505],[-73.8166821202808,40.58355],[-73.81754814568458,40.58205],[-73.81928019649216,40.58205],[-73.82014622189594,40.58055],[-73.82187827270351,40.58055],[-73.8227442981073,40.57905],[-73.82447634891487,40.57905],[-73.82534237431865,40.58055],[-73.82707442512623,40.58055],[-73.82794045053001,40.57905],[-73.82967250133758,40.57905],[-73.83053852674136,40.57755],[-73.83227057754894,40.57755],[-73.83313660295272,40.57605],[-73.8348686537603,40.57605],[-73.83573467916408,40.57455],[-73.83746672997165,40.57455],[-73.83833275537543,40.57605],[-73.84006480618301,40.57605],[-73.84093083158679,40.57455],[-73.84266288239436,40.57455],[-73.84352890779815,40.57305],[-73.84526095860572,40.57305],[-73.8461269840095,40.57155],[-73.84785903481708,40.57155],[-73.84872506022086,40.57005],[-73.85045711102843,40.57005],[-73.85132313643221,40.56855],[-73.85305518723979,40.56855],[-73.85392121264357,40.57005],[-73.85565326345115,40.57005],[-73.85651928885493,40.56855],[-73.8582513396625,40.56855],[-73.85911736506628,40.56705],[-73.86084941587386,40.56705],[-73.86171544127764,40.56555]]],[[[-73.89462440662149,40.56255],[-73.89549043202527,40.56405],[-73.89722248283285,40.56405],[-73.89808850823663,40.56555],[-73.89722248283285,40.56705],[-73.89549043202527,40.56705],[-73.89462440662149,40.56855],[-73.89289235581391,40.56855],[-73.89202633041013,40.57005],[-73.89029427960256,40.57005],[-73.88942825419878,40.56855],[-73.8876962033912,40.56855],[-73.88683017798742,40.57005],[-73.88509812717984,40.57005],[-73.88423210177606,40.56855],[-73.88509812717984,40.56705],[-73.88423210177606,40.56555],[-73.88509812717984,40.56405],[-73.88683017798742,40.56405],[-73.8876962033912,40.56555],[-73.88942825419878,40.56555],[-73.89029427960256,40.56405],[-73.89202633041013,40.56405],[-73.89289235581391,40.56255],[-73.89462440662149,40.56255]]],[[[-73.9180070925237,40.55205],[-73.91887311792748,40.55355],[-73.92060516873505,40.55355],[-73.92147119413883,40.55205],[-73.92320324494641,40.55205],[-73.92406927035019,40.55055],[-73.92580132115776,40.55055],[-73.92666734656154,40.54905],[-73.92839939736912,40.54905],[-73.9292654227729,40.55055],[-73.93099747358048,40.55055],[-73.93186349898426,40.55205],[-73.93099747358048,40.55355],[-73.93186349898426,40.55505],[-73.93099747358048,40.55655],[-73.93186349898426,40.55805],[-73.93099747358048,40.55955],[-73.9292654227729,40.55955],[-73.92839939736912,40.56105],[-73.92666734656154,40.56105],[-73.92580132115776,40.56255],[-73.92406927035019,40.56255],[-73.92320324494641,40.56105],[-73.92147119413883,40.56105],[-73.92060516873505,40.56255],[-73.91887311792748,40.56255],[-73.9180070925237,40.56405],[-73.91627504171612,40.56405],[-73.91540901631234,40.56255],[-73.91367696550476,40.56255],[-73.91281094010098,40.56105],[-73.9110788892934,40.56105],[-73.91021286388963,40.56255],[-73.90848081308205,40.56255],[-73.90761478767827,40.56105],[-73.9058827368707,40.56105],[-73.90501671146691,40.56255],[-73.90328466065934,40.56255],[-73.90241863525556,40.56405],[-73.90068658444798,40.56405],[-73.8998205590442,40.56255],[-73.90068658444798,40.56105],[-73.8998205590442,40.55955],[-73.90068658444798,40.55805],[-73.90241863525556,40.55805],[-73.90328466065934,40.55955],[-73.90501671146691,40.55955],[-73.9058827368707,40.55805],[-73.90761478767827,40.55805],[-73.90848081308205,40.55655],[-73.91021286388963,40.55655],[-73.9110788892934,40.55505],[-73.91281094010098,40.55505],[-73.91367696550476,40.55355],[-73.91540901631234,40.55355],[-73.91627504171612,40.55205],[-73.9180070925237,40.55205]]]],"type":"MultiPolygon"}},{"id":"38","properties":{"borough":"queens","borocode":4,"neighborhood":"Corona"},"type":"Feature","geometry":{"coordinates":[[[-73.85392121264357,40.73505000000001],[-73.85565326345115,40.73505000000001],[-73.85651928885493,40.73655000000001],[-73.8582513396625,40.73655000000001],[-73.85911736506628,40.73505000000001],[-73.86084941587386,40.73505000000001],[-73.86171544127764,40.73355000000001],[-73.86344749208521,40.73355000000001],[-73.864313517489,40.73505000000001],[-73.86604556829657,40.73505000000001],[-73.86691159370035,40.73655000000001],[-73.86604556829657,40.73805000000001],[-73.86691159370035,40.73955000000001],[-73.86604556829657,40.74105000000001],[-73.86691159370035,40.74255000000001],[-73.86604556829657,40.74405000000001],[-73.86691159370035,40.74555000000001],[-73.86604556829657,40.74705000000001],[-73.864313517489,40.74705000000001],[-73.86344749208521,40.74555000000001],[-73.86171544127764,40.74555000000001],[-73.86084941587386,40.74705000000001],[-73.85911736506628,40.74705000000001],[-73.8582513396625,40.74855000000001],[-73.85651928885493,40.74855000000001],[-73.85565326345115,40.75005000000001],[-73.85651928885493,40.75155000000001],[-73.85565326345115,40.75305000000001],[-73.85651928885493,40.75455000000001],[-73.85565326345115,40.75605000000001],[-73.85392121264357,40.75605000000001],[-73.85305518723979,40.75455000000001],[-73.85132313643221,40.75455000000001],[-73.85045711102843,40.75305000000001],[-73.85132313643221,40.75155000000001],[-73.85045711102843,40.75005000000001],[-73.85132313643221,40.74855000000001],[-73.85045711102843,40.74705000000001],[-73.85132313643221,40.74555000000001],[-73.85045711102843,40.74405000000001],[-73.84872506022086,40.74405000000001],[-73.84785903481708,40.74255000000001],[-73.84872506022086,40.74105000000001],[-73.84785903481708,40.73955000000001],[-73.84872506022086,40.73805000000001],[-73.85045711102843,40.73805000000001],[-73.85132313643221,40.73655000000001],[-73.85305518723979,40.73655000000001],[-73.85392121264357,40.73505000000001]]],"type":"Polygon"}},{"id":"130","properties":{"borough":"bronx","borocode":2,"neighborhood":"Parkchester"},"type":"Feature","geometry":{"coordinates":[[[-73.85651928885493,40.83255000000001],[-73.8582513396625,40.83255000000001],[-73.85911736506628,40.83405000000001],[-73.86084941587386,40.83405000000001],[-73.86171544127764,40.83555000000001],[-73.86084941587386,40.83705000000001],[-73.86171544127764,40.83855000000001],[-73.86344749208521,40.83855000000001],[-73.864313517489,40.84005000000001],[-73.86344749208521,40.84155000000001],[-73.86171544127764,40.84155000000001],[-73.86084941587386,40.84305000000001],[-73.85911736506628,40.84305000000001],[-73.8582513396625,40.84155000000001],[-73.85651928885493,40.84155000000001],[-73.85565326345115,40.84005000000001],[-73.85392121264357,40.84005000000001],[-73.85305518723979,40.83855000000001],[-73.85392121264357,40.83705000000001],[-73.85305518723979,40.83555000000001],[-73.85392121264357,40.83405000000001],[-73.85565326345115,40.83405000000001],[-73.85651928885493,40.83255000000001]]],"type":"Polygon"}},{"id":"97","properties":{"borough":"queens","borocode":4,"neighborhood":"Lindenwood-Howard Beach"},"type":"Feature","geometry":{"coordinates":[[[-73.82794045053001,40.648050000000005],[-73.82967250133758,40.648050000000005],[-73.83053852674136,40.649550000000005],[-73.83227057754894,40.649550000000005],[-73.83313660295272,40.648050000000005],[-73.8348686537603,40.648050000000005],[-73.83573467916408,40.646550000000005],[-73.83746672997165,40.646550000000005],[-73.83833275537543,40.648050000000005],[-73.84006480618301,40.648050000000005],[-73.84093083158679,40.646550000000005],[-73.84266288239436,40.646550000000005],[-73.84352890779815,40.648050000000005],[-73.84526095860572,40.648050000000005],[-73.8461269840095,40.646550000000005],[-73.84785903481708,40.646550000000005],[-73.84872506022086,40.648050000000005],[-73.84785903481708,40.649550000000005],[-73.84872506022086,40.651050000000005],[-73.84785903481708,40.652550000000005],[-73.84872506022086,40.654050000000005],[-73.85045711102843,40.654050000000005],[-73.85132313643221,40.652550000000005],[-73.85305518723979,40.652550000000005],[-73.85392121264357,40.654050000000005],[-73.85565326345115,40.654050000000005],[-73.85651928885493,40.655550000000005],[-73.8582513396625,40.655550000000005],[-73.85911736506628,40.654050000000005],[-73.86084941587386,40.654050000000005],[-73.86171544127764,40.655550000000005],[-73.86084941587386,40.657050000000005],[-73.85911736506628,40.657050000000005],[-73.8582513396625,40.658550000000005],[-73.85911736506628,40.660050000000005],[-73.8582513396625,40.661550000000005],[-73.85911736506628,40.663050000000005],[-73.8582513396625,40.664550000000006],[-73.85651928885493,40.664550000000006],[-73.85565326345115,40.666050000000006],[-73.85651928885493,40.667550000000006],[-73.85565326345115,40.669050000000006],[-73.85651928885493,40.670550000000006],[-73.8582513396625,40.670550000000006],[-73.85911736506628,40.672050000000006],[-73.86084941587386,40.672050000000006],[-73.86171544127764,40.673550000000006],[-73.86084941587386,40.675050000000006],[-73.85911736506628,40.675050000000006],[-73.8582513396625,40.673550000000006],[-73.85651928885493,40.673550000000006],[-73.85565326345115,40.672050000000006],[-73.85392121264357,40.672050000000006],[-73.85305518723979,40.670550000000006],[-73.85132313643221,40.670550000000006],[-73.85045711102843,40.672050000000006],[-73.84872506022086,40.672050000000006],[-73.84785903481708,40.670550000000006],[-73.8461269840095,40.670550000000006],[-73.84526095860572,40.669050000000006],[-73.84352890779815,40.669050000000006],[-73.84266288239436,40.667550000000006],[-73.84093083158679,40.667550000000006],[-73.84006480618301,40.666050000000006],[-73.83833275537543,40.666050000000006],[-73.83746672997165,40.667550000000006],[-73.83573467916408,40.667550000000006],[-73.8348686537603,40.666050000000006],[-73.83313660295272,40.666050000000006],[-73.83227057754894,40.664550000000006],[-73.83053852674136,40.664550000000006],[-73.82967250133758,40.663050000000005],[-73.83053852674136,40.661550000000005],[-73.82967250133758,40.660050000000005],[-73.82794045053001,40.660050000000005],[-73.82707442512623,40.658550000000005],[-73.82794045053001,40.657050000000005],[-73.82707442512623,40.655550000000005],[-73.82794045053001,40.654050000000005],[-73.82707442512623,40.652550000000005],[-73.82534237431865,40.652550000000005],[-73.82447634891487,40.651050000000005],[-73.82534237431865,40.649550000000005],[-73.82707442512623,40.649550000000005],[-73.82794045053001,40.648050000000005]]],"type":"Polygon"}},{"id":"128","properties":{"borough":"queens","borocode":4,"neighborhood":"Ozone Park"},"type":"Feature","geometry":{"coordinates":[[[-73.83313660295272,40.666050000000006],[-73.8348686537603,40.666050000000006],[-73.83573467916408,40.667550000000006],[-73.83746672997165,40.667550000000006],[-73.83833275537543,40.666050000000006],[-73.84006480618301,40.666050000000006],[-73.84093083158679,40.667550000000006],[-73.84266288239436,40.667550000000006],[-73.84352890779815,40.669050000000006],[-73.84526095860572,40.669050000000006],[-73.8461269840095,40.670550000000006],[-73.84785903481708,40.670550000000006],[-73.84872506022086,40.672050000000006],[-73.85045711102843,40.672050000000006],[-73.85132313643221,40.670550000000006],[-73.85305518723979,40.670550000000006],[-73.85392121264357,40.672050000000006],[-73.85565326345115,40.672050000000006],[-73.85651928885493,40.673550000000006],[-73.8582513396625,40.673550000000006],[-73.85911736506628,40.675050000000006],[-73.86084941587386,40.675050000000006],[-73.86171544127764,40.676550000000006],[-73.86084941587386,40.678050000000006],[-73.86171544127764,40.679550000000006],[-73.86084941587386,40.681050000000006],[-73.85911736506628,40.681050000000006],[-73.8582513396625,40.679550000000006],[-73.85651928885493,40.679550000000006],[-73.85565326345115,40.678050000000006],[-73.85392121264357,40.678050000000006],[-73.85305518723979,40.679550000000006],[-73.85132313643221,40.679550000000006],[-73.85045711102843,40.681050000000006],[-73.84872506022086,40.681050000000006],[-73.84785903481708,40.682550000000006],[-73.8461269840095,40.682550000000006],[-73.84526095860572,40.681050000000006],[-73.84352890779815,40.681050000000006],[-73.84266288239436,40.682550000000006],[-73.84093083158679,40.682550000000006],[-73.84006480618301,40.681050000000006],[-73.84093083158679,40.679550000000006],[-73.84006480618301,40.678050000000006],[-73.83833275537543,40.678050000000006],[-73.83746672997165,40.676550000000006],[-73.83833275537543,40.675050000000006],[-73.83746672997165,40.673550000000006],[-73.83573467916408,40.673550000000006],[-73.8348686537603,40.672050000000006],[-73.83313660295272,40.672050000000006],[-73.83227057754894,40.670550000000006],[-73.83313660295272,40.669050000000006],[-73.83227057754894,40.667550000000006],[-73.83313660295272,40.666050000000006]]],"type":"Polygon"}},{"id":"1","properties":{"borough":"bronx","borocode":2,"neighborhood":"Allerton-Pelham Gardens"},"type":"Feature","geometry":{"coordinates":[[[-73.83053852674136,40.85655000000001],[-73.83227057754894,40.85655000000001],[-73.83313660295272,40.85805000000001],[-73.8348686537603,40.85805000000001],[-73.83573467916408,40.85655000000001],[-73.83746672997165,40.85655000000001],[-73.83833275537543,40.85505000000001],[-73.84006480618301,40.85505000000001],[-73.84093083158679,40.85655000000001],[-73.84266288239436,40.85655000000001],[-73.84352890779815,40.85805000000001],[-73.84526095860572,40.85805000000001],[-73.8461269840095,40.85655000000001],[-73.84785903481708,40.85655000000001],[-73.84872506022086,40.85805000000001],[-73.85045711102843,40.85805000000001],[-73.85132313643221,40.85655000000001],[-73.85305518723979,40.85655000000001],[-73.85392121264357,40.85805000000001],[-73.85565326345115,40.85805000000001],[-73.85651928885493,40.85955000000001],[-73.8582513396625,40.85955000000001],[-73.85911736506628,40.86105000000001],[-73.8582513396625,40.86255000000001],[-73.85911736506628,40.86405000000001],[-73.8582513396625,40.86555000000001],[-73.85911736506628,40.86705000000001],[-73.86084941587386,40.86705000000001],[-73.86171544127764,40.86855000000001],[-73.86084941587386,40.87005000000001],[-73.85911736506628,40.87005000000001],[-73.8582513396625,40.87155000000001],[-73.85651928885493,40.87155000000001],[-73.85565326345115,40.87305000000001],[-73.85392121264357,40.87305000000001],[-73.85305518723979,40.87455000000001],[-73.85132313643221,40.87455000000001],[-73.85045711102843,40.87305000000001],[-73.84872506022086,40.87305000000001],[-73.84785903481708,40.87155000000001],[-73.8461269840095,40.87155000000001],[-73.84526095860572,40.87005000000001],[-73.84352890779815,40.87005000000001],[-73.84266288239436,40.86855000000001],[-73.84093083158679,40.86855000000001],[-73.84006480618301,40.86705000000001],[-73.83833275537543,40.86705000000001],[-73.83746672997165,40.86555000000001],[-73.83573467916408,40.86555000000001],[-73.8348686537603,40.86405000000001],[-73.83313660295272,40.86405000000001],[-73.83227057754894,40.86555000000001],[-73.83053852674136,40.86555000000001],[-73.82967250133758,40.86405000000001],[-73.83053852674136,40.86255000000001],[-73.82967250133758,40.86105000000001],[-73.82794045053001,40.86105000000001],[-73.82707442512623,40.85955000000001],[-73.82794045053001,40.85805000000001],[-73.82967250133758,40.85805000000001],[-73.83053852674136,40.85655000000001]]],"type":"Polygon"}},{"id":"66","properties":{"borough":"queens","borocode":4,"neighborhood":"Forest Hills"},"type":"Feature","geometry":{"coordinates":[[[-73.83833275537543,40.70805000000001],[-73.84006480618301,40.70805000000001],[-73.84093083158679,40.70955000000001],[-73.84266288239436,40.70955000000001],[-73.84352890779815,40.70805000000001],[-73.84526095860572,40.70805000000001],[-73.8461269840095,40.70655000000001],[-73.84785903481708,40.70655000000001],[-73.84872506022086,40.70805000000001],[-73.85045711102843,40.70805000000001],[-73.85132313643221,40.70655000000001],[-73.85305518723979,40.70655000000001],[-73.85392121264357,40.70805000000001],[-73.85565326345115,40.70805000000001],[-73.85651928885493,40.70955000000001],[-73.8582513396625,40.70955000000001],[-73.85911736506628,40.71105000000001],[-73.8582513396625,40.71255000000001],[-73.85911736506628,40.71405000000001],[-73.8582513396625,40.71555000000001],[-73.85911736506628,40.71705000000001],[-73.8582513396625,40.71855000000001],[-73.85911736506628,40.72005000000001],[-73.8582513396625,40.72155000000001],[-73.85911736506628,40.72305000000001],[-73.8582513396625,40.72455000000001],[-73.85911736506628,40.72605000000001],[-73.8582513396625,40.72755000000001],[-73.85911736506628,40.72905000000001],[-73.8582513396625,40.73055000000001],[-73.85911736506628,40.73205000000001],[-73.8582513396625,40.73355000000001],[-73.85911736506628,40.73505000000001],[-73.8582513396625,40.73655000000001],[-73.85651928885493,40.73655000000001],[-73.85565326345115,40.73505000000001],[-73.85392121264357,40.73505000000001],[-73.85305518723979,40.73655000000001],[-73.85132313643221,40.73655000000001],[-73.85045711102843,40.73805000000001],[-73.84872506022086,40.73805000000001],[-73.84785903481708,40.73955000000001],[-73.8461269840095,40.73955000000001],[-73.84526095860572,40.73805000000001],[-73.8461269840095,40.73655000000001],[-73.84526095860572,40.73505000000001],[-73.84352890779815,40.73505000000001],[-73.84266288239436,40.73355000000001],[-73.84352890779815,40.73205000000001],[-73.84266288239436,40.73055000000001],[-73.84093083158679,40.73055000000001],[-73.84006480618301,40.72905000000001],[-73.83833275537543,40.72905000000001],[-73.83746672997165,40.72755000000001],[-73.83833275537543,40.72605000000001],[-73.83746672997165,40.72455000000001],[-73.83573467916408,40.72455000000001],[-73.8348686537603,40.72305000000001],[-73.83573467916408,40.72155000000001],[-73.8348686537603,40.72005000000001],[-73.83313660295272,40.72005000000001],[-73.83227057754894,40.71855000000001],[-73.83053852674136,40.71855000000001],[-73.82967250133758,40.71705000000001],[-73.83053852674136,40.71555000000001],[-73.83227057754894,40.71555000000001],[-73.83313660295272,40.71405000000001],[-73.8348686537603,40.71405000000001],[-73.83573467916408,40.71255000000001],[-73.8348686537603,40.71105000000001],[-73.83573467916408,40.70955000000001],[-73.83746672997165,40.70955000000001],[-73.83833275537543,40.70805000000001]]],"type":"Polygon"}},{"id":"37","properties":{"borough":"queens","borocode":4,"neighborhood":"College Point"},"type":"Feature","geometry":{"coordinates":[[[-73.84785903481708,40.76355000000001],[-73.84872506022086,40.76505000000001],[-73.84785903481708,40.76655000000001],[-73.84872506022086,40.76805000000001],[-73.84785903481708,40.76955000000001],[-73.84872506022086,40.77105000000001],[-73.85045711102843,40.77105000000001],[-73.85132313643221,40.77255000000001],[-73.85045711102843,40.77405000000001],[-73.85132313643221,40.77555000000001],[-73.85045711102843,40.77705000000001],[-73.85132313643221,40.77855000000001],[-73.85045711102843,40.78005000000001],[-73.85132313643221,40.78155000000001],[-73.85305518723979,40.78155000000001],[-73.85392121264357,40.78305000000001],[-73.85565326345115,40.78305000000001],[-73.85651928885493,40.78155000000001],[-73.8582513396625,40.78155000000001],[-73.85911736506628,40.78305000000001],[-73.8582513396625,40.78455000000001],[-73.85911736506628,40.78605000000001],[-73.8582513396625,40.78755000000001],[-73.85651928885493,40.78755000000001],[-73.85565326345115,40.78905000000001],[-73.85651928885493,40.79055000000001],[-73.85565326345115,40.79205000000001],[-73.85392121264357,40.79205000000001],[-73.85305518723979,40.79355000000001],[-73.85132313643221,40.79355000000001],[-73.85045711102843,40.79505000000001],[-73.85132313643221,40.79655000000001],[-73.85045711102843,40.79805000000001],[-73.84872506022086,40.79805000000001],[-73.84785903481708,40.79655000000001],[-73.8461269840095,40.79655000000001],[-73.84526095860572,40.79505000000001],[-73.84352890779815,40.79505000000001],[-73.84266288239436,40.79655000000001],[-73.84093083158679,40.79655000000001],[-73.84006480618301,40.79505000000001],[-73.84093083158679,40.79355000000001],[-73.84006480618301,40.79205000000001],[-73.84093083158679,40.79055000000001],[-73.84006480618301,40.78905000000001],[-73.83833275537543,40.78905000000001],[-73.83746672997165,40.78755000000001],[-73.83833275537543,40.78605000000001],[-73.83746672997165,40.78455000000001],[-73.83833275537543,40.78305000000001],[-73.83746672997165,40.78155000000001],[-73.83573467916408,40.78155000000001],[-73.8348686537603,40.78305000000001],[-73.83313660295272,40.78305000000001],[-73.83227057754894,40.78155000000001],[-73.83053852674136,40.78155000000001],[-73.82967250133758,40.78005000000001],[-73.82794045053001,40.78005000000001],[-73.82707442512623,40.77855000000001],[-73.82794045053001,40.77705000000001],[-73.82967250133758,40.77705000000001],[-73.83053852674136,40.77555000000001],[-73.82967250133758,40.77405000000001],[-73.83053852674136,40.77255000000001],[-73.83227057754894,40.77255000000001],[-73.83313660295272,40.77105000000001],[-73.8348686537603,40.77105000000001],[-73.83573467916408,40.76955000000001],[-73.83746672997165,40.76955000000001],[-73.83833275537543,40.76805000000001],[-73.83746672997165,40.76655000000001],[-73.83833275537543,40.76505000000001],[-73.84006480618301,40.76505000000001],[-73.84093083158679,40.76355000000001],[-73.84266288239436,40.76355000000001],[-73.84352890779815,40.76505000000001],[-73.84526095860572,40.76505000000001],[-73.8461269840095,40.76355000000001],[-73.84785903481708,40.76355000000001]]],"type":"Polygon"}},{"id":"179","properties":{"borough":"bronx","borocode":2,"neighborhood":"Westchester-Unionport"},"type":"Feature","geometry":{"coordinates":[[[-73.85392121264357,40.82205000000001],[-73.85565326345115,40.82205000000001],[-73.85651928885493,40.82355000000001],[-73.85565326345115,40.82505000000001],[-73.85651928885493,40.82655000000001],[-73.85565326345115,40.82805000000001],[-73.85651928885493,40.82955000000001],[-73.85565326345115,40.83105000000001],[-73.85651928885493,40.83255000000001],[-73.85565326345115,40.83405000000001],[-73.85392121264357,40.83405000000001],[-73.85305518723979,40.83555000000001],[-73.85392121264357,40.83705000000001],[-73.85305518723979,40.83855000000001],[-73.85392121264357,40.84005000000001],[-73.85305518723979,40.84155000000001],[-73.85132313643221,40.84155000000001],[-73.85045711102843,40.84305000000001],[-73.84872506022086,40.84305000000001],[-73.84785903481708,40.84155000000001],[-73.8461269840095,40.84155000000001],[-73.84526095860572,40.84005000000001],[-73.84352890779815,40.84005000000001],[-73.84266288239436,40.84155000000001],[-73.84093083158679,40.84155000000001],[-73.84006480618301,40.84005000000001],[-73.84093083158679,40.83855000000001],[-73.84006480618301,40.83705000000001],[-73.83833275537543,40.83705000000001],[-73.83746672997165,40.83555000000001],[-73.83833275537543,40.83405000000001],[-73.83746672997165,40.83255000000001],[-73.83833275537543,40.83105000000001],[-73.84006480618301,40.83105000000001],[-73.84093083158679,40.82955000000001],[-73.84266288239436,40.82955000000001],[-73.84352890779815,40.82805000000001],[-73.84266288239436,40.82655000000001],[-73.84093083158679,40.82655000000001],[-73.84006480618301,40.82505000000001],[-73.84093083158679,40.82355000000001],[-73.84266288239436,40.82355000000001],[-73.84352890779815,40.82205000000001],[-73.84526095860572,40.82205000000001],[-73.8461269840095,40.82355000000001],[-73.84785903481708,40.82355000000001],[-73.84872506022086,40.82205000000001],[-73.85045711102843,40.82205000000001],[-73.85132313643221,40.82355000000001],[-73.85305518723979,40.82355000000001],[-73.85392121264357,40.82205000000001]]],"type":"Polygon"}},{"id":"57","properties":{"borough":"bronx","borocode":2,"neighborhood":"Eastchester-Edenwald-Baychester"},"type":"Feature","geometry":{"coordinates":[[[-73.79416545978238,40.880550000000014],[-73.79589751058995,40.880550000000014],[-73.79676353599373,40.882050000000014],[-73.79849558680131,40.882050000000014],[-73.79936161220509,40.883550000000014],[-73.80109366301267,40.883550000000014],[-73.80195968841645,40.885050000000014],[-73.80369173922402,40.885050000000014],[-73.8045577646278,40.883550000000014],[-73.80628981543538,40.883550000000014],[-73.80715584083916,40.885050000000014],[-73.80888789164673,40.885050000000014],[-73.80975391705051,40.886550000000014],[-73.81148596785809,40.886550000000014],[-73.81235199326187,40.885050000000014],[-73.81408404406945,40.885050000000014],[-73.81495006947323,40.886550000000014],[-73.8166821202808,40.886550000000014],[-73.81754814568458,40.885050000000014],[-73.81928019649216,40.885050000000014],[-73.82014622189594,40.886550000000014],[-73.82187827270351,40.886550000000014],[-73.8227442981073,40.888050000000014],[-73.82447634891487,40.888050000000014],[-73.82534237431865,40.886550000000014],[-73.82707442512623,40.886550000000014],[-73.82794045053001,40.885050000000014],[-73.82967250133758,40.885050000000014],[-73.83053852674136,40.886550000000014],[-73.83227057754894,40.886550000000014],[-73.83313660295272,40.885050000000014],[-73.83227057754894,40.883550000000014],[-73.83313660295272,40.882050000000014],[-73.8348686537603,40.882050000000014],[-73.83573467916408,40.880550000000014],[-73.83746672997165,40.880550000000014],[-73.83833275537543,40.882050000000014],[-73.84006480618301,40.882050000000014],[-73.84093083158679,40.880550000000014],[-73.84266288239436,40.880550000000014],[-73.84352890779815,40.879050000000014],[-73.84266288239436,40.877550000000014],[-73.84093083158679,40.877550000000014],[-73.84006480618301,40.87605000000001],[-73.83833275537543,40.87605000000001],[-73.83746672997165,40.87455000000001],[-73.83833275537543,40.87305000000001],[-73.83746672997165,40.87155000000001],[-73.83833275537543,40.87005000000001],[-73.83746672997165,40.86855000000001],[-73.83573467916408,40.86855000000001],[-73.8348686537603,40.86705000000001],[-73.83313660295272,40.86705000000001],[-73.83227057754894,40.86555000000001],[-73.83313660295272,40.86405000000001],[-73.8348686537603,40.86405000000001],[-73.83573467916408,40.86555000000001],[-73.83746672997165,40.86555000000001],[-73.83833275537543,40.86705000000001],[-73.84006480618301,40.86705000000001],[-73.84093083158679,40.86855000000001],[-73.84266288239436,40.86855000000001],[-73.84352890779815,40.87005000000001],[-73.84526095860572,40.87005000000001],[-73.8461269840095,40.87155000000001],[-73.84785903481708,40.87155000000001],[-73.84872506022086,40.87305000000001],[-73.85045711102843,40.87305000000001],[-73.85132313643221,40.87455000000001],[-73.85045711102843,40.87605000000001],[-73.85132313643221,40.877550000000014],[-73.85045711102843,40.879050000000014],[-73.85132313643221,40.880550000000014],[-73.85045711102843,40.882050000000014],[-73.84872506022086,40.882050000000014],[-73.84785903481708,40.883550000000014],[-73.84872506022086,40.885050000000014],[-73.84785903481708,40.886550000000014],[-73.8461269840095,40.886550000000014],[-73.84526095860572,40.888050000000014],[-73.84352890779815,40.888050000000014],[-73.84266288239436,40.886550000000014],[-73.84093083158679,40.886550000000014],[-73.84006480618301,40.888050000000014],[-73.83833275537543,40.888050000000014],[-73.83746672997165,40.889550000000014],[-73.83573467916408,40.889550000000014],[-73.8348686537603,40.891050000000014],[-73.83573467916408,40.892550000000014],[-73.8348686537603,40.894050000000014],[-73.83313660295272,40.894050000000014],[-73.83227057754894,40.892550000000014],[-73.83053852674136,40.892550000000014],[-73.82967250133758,40.894050000000014],[-73.82794045053001,40.894050000000014],[-73.82707442512623,40.892550000000014],[-73.82534237431865,40.892550000000014],[-73.82447634891487,40.891050000000014],[-73.8227442981073,40.891050000000014],[-73.82187827270351,40.892550000000014],[-73.82014622189594,40.892550000000014],[-73.81928019649216,40.891050000000014],[-73.81754814568458,40.891050000000014],[-73.8166821202808,40.889550000000014],[-73.81495006947323,40.889550000000014],[-73.81408404406945,40.891050000000014],[-73.81235199326187,40.891050000000014],[-73.81148596785809,40.889550000000014],[-73.80975391705051,40.889550000000014],[-73.80888789164673,40.888050000000014],[-73.80715584083916,40.888050000000014],[-73.80628981543538,40.889550000000014],[-73.8045577646278,40.889550000000014],[-73.80369173922402,40.888050000000014],[-73.80195968841645,40.888050000000014],[-73.80109366301267,40.886550000000014],[-73.79936161220509,40.886550000000014],[-73.79849558680131,40.885050000000014],[-73.79676353599373,40.885050000000014],[-73.79589751058995,40.886550000000014],[-73.79416545978238,40.886550000000014],[-73.7932994343786,40.885050000000014],[-73.79416545978238,40.883550000000014],[-73.7932994343786,40.882050000000014],[-73.79416545978238,40.880550000000014]]],"type":"Polygon"}},{"id":"141","properties":{"borough":"queens","borocode":4,"neighborhood":"Richmond Hill"},"type":"Feature","geometry":{"coordinates":[[[-73.8227442981073,40.687050000000006],[-73.82447634891487,40.687050000000006],[-73.82534237431865,40.688550000000006],[-73.82707442512623,40.688550000000006],[-73.82794045053001,40.687050000000006],[-73.82967250133758,40.687050000000006],[-73.83053852674136,40.685550000000006],[-73.83227057754894,40.685550000000006],[-73.83313660295272,40.684050000000006],[-73.8348686537603,40.684050000000006],[-73.83573467916408,40.685550000000006],[-73.83746672997165,40.685550000000006],[-73.83833275537543,40.684050000000006],[-73.83746672997165,40.682550000000006],[-73.83833275537543,40.681050000000006],[-73.84006480618301,40.681050000000006],[-73.84093083158679,40.682550000000006],[-73.84006480618301,40.684050000000006],[-73.84093083158679,40.685550000000006],[-73.84266288239436,40.685550000000006],[-73.84352890779815,40.687050000000006],[-73.84266288239436,40.688550000000006],[-73.84352890779815,40.69005000000001],[-73.84526095860572,40.69005000000001],[-73.8461269840095,40.69155000000001],[-73.84526095860572,40.69305000000001],[-73.8461269840095,40.69455000000001],[-73.84785903481708,40.69455000000001],[-73.84872506022086,40.69605000000001],[-73.84785903481708,40.69755000000001],[-73.84872506022086,40.69905000000001],[-73.84785903481708,40.70055000000001],[-73.8461269840095,40.70055000000001],[-73.84526095860572,40.70205000000001],[-73.84352890779815,40.70205000000001],[-73.84266288239436,40.70355000000001],[-73.84093083158679,40.70355000000001],[-73.84006480618301,40.70505000000001],[-73.83833275537543,40.70505000000001],[-73.83746672997165,40.70355000000001],[-73.83573467916408,40.70355000000001],[-73.8348686537603,40.70205000000001],[-73.83313660295272,40.70205000000001],[-73.83227057754894,40.70355000000001],[-73.83053852674136,40.70355000000001],[-73.82967250133758,40.70205000000001],[-73.82794045053001,40.70205000000001],[-73.82707442512623,40.70355000000001],[-73.82534237431865,40.70355000000001],[-73.82447634891487,40.70205000000001],[-73.8227442981073,40.70205000000001],[-73.82187827270351,40.70355000000001],[-73.82014622189594,40.70355000000001],[-73.81928019649216,40.70205000000001],[-73.81754814568458,40.70205000000001],[-73.8166821202808,40.70055000000001],[-73.81495006947323,40.70055000000001],[-73.81408404406945,40.69905000000001],[-73.81495006947323,40.69755000000001],[-73.81408404406945,40.69605000000001],[-73.81235199326187,40.69605000000001],[-73.81148596785809,40.69455000000001],[-73.81235199326187,40.69305000000001],[-73.81148596785809,40.69155000000001],[-73.81235199326187,40.69005000000001],[-73.81408404406945,40.69005000000001],[-73.81495006947323,40.69155000000001],[-73.8166821202808,40.69155000000001],[-73.81754814568458,40.69005000000001],[-73.81928019649216,40.69005000000001],[-73.82014622189594,40.688550000000006],[-73.82187827270351,40.688550000000006],[-73.8227442981073,40.687050000000006]]],"type":"Polygon"}},{"id":"36","properties":{"borough":"bronx","borocode":2,"neighborhood":"Co-op City"},"type":"Feature","geometry":{"coordinates":[[[-73.8227442981073,40.85805000000001],[-73.82447634891487,40.85805000000001],[-73.82534237431865,40.85955000000001],[-73.82707442512623,40.85955000000001],[-73.82794045053001,40.86105000000001],[-73.82967250133758,40.86105000000001],[-73.83053852674136,40.86255000000001],[-73.82967250133758,40.86405000000001],[-73.83053852674136,40.86555000000001],[-73.83227057754894,40.86555000000001],[-73.83313660295272,40.86705000000001],[-73.8348686537603,40.86705000000001],[-73.83573467916408,40.86855000000001],[-73.83746672997165,40.86855000000001],[-73.83833275537543,40.87005000000001],[-73.83746672997165,40.87155000000001],[-73.83833275537543,40.87305000000001],[-73.83746672997165,40.87455000000001],[-73.83833275537543,40.87605000000001],[-73.84006480618301,40.87605000000001],[-73.84093083158679,40.877550000000014],[-73.84266288239436,40.877550000000014],[-73.84352890779815,40.879050000000014],[-73.84266288239436,40.880550000000014],[-73.84093083158679,40.880550000000014],[-73.84006480618301,40.882050000000014],[-73.83833275537543,40.882050000000014],[-73.83746672997165,40.880550000000014],[-73.83573467916408,40.880550000000014],[-73.8348686537603,40.882050000000014],[-73.83313660295272,40.882050000000014],[-73.83227057754894,40.883550000000014],[-73.83313660295272,40.885050000000014],[-73.83227057754894,40.886550000000014],[-73.83053852674136,40.886550000000014],[-73.82967250133758,40.885050000000014],[-73.82794045053001,40.885050000000014],[-73.82707442512623,40.886550000000014],[-73.82534237431865,40.886550000000014],[-73.82447634891487,40.888050000000014],[-73.8227442981073,40.888050000000014],[-73.82187827270351,40.886550000000014],[-73.82014622189594,40.886550000000014],[-73.81928019649216,40.885050000000014],[-73.82014622189594,40.883550000000014],[-73.81928019649216,40.882050000000014],[-73.82014622189594,40.880550000000014],[-73.81928019649216,40.879050000000014],[-73.82014622189594,40.877550000000014],[-73.82187827270351,40.877550000000014],[-73.8227442981073,40.87605000000001],[-73.82187827270351,40.87455000000001],[-73.8227442981073,40.87305000000001],[-73.82187827270351,40.87155000000001],[-73.82014622189594,40.87155000000001],[-73.81928019649216,40.87005000000001],[-73.82014622189594,40.86855000000001],[-73.81928019649216,40.86705000000001],[-73.81754814568458,40.86705000000001],[-73.8166821202808,40.86555000000001],[-73.81754814568458,40.86405000000001],[-73.8166821202808,40.86255000000001],[-73.81754814568458,40.86105000000001],[-73.81928019649216,40.86105000000001],[-73.82014622189594,40.85955000000001],[-73.82187827270351,40.85955000000001],[-73.8227442981073,40.85805000000001]]],"type":"Polygon"}},{"id":"153","properties":{"borough":"queens","borocode":4,"neighborhood":"South Ozone Park"},"type":"Feature","geometry":{"coordinates":[[[-73.82794045053001,40.663050000000005],[-73.82967250133758,40.663050000000005],[-73.83053852674136,40.664550000000006],[-73.83227057754894,40.664550000000006],[-73.83313660295272,40.666050000000006],[-73.83227057754894,40.667550000000006],[-73.83313660295272,40.669050000000006],[-73.83227057754894,40.670550000000006],[-73.83313660295272,40.672050000000006],[-73.8348686537603,40.672050000000006],[-73.83573467916408,40.673550000000006],[-73.83746672997165,40.673550000000006],[-73.83833275537543,40.675050000000006],[-73.83746672997165,40.676550000000006],[-73.83833275537543,40.678050000000006],[-73.84006480618301,40.678050000000006],[-73.84093083158679,40.679550000000006],[-73.84006480618301,40.681050000000006],[-73.83833275537543,40.681050000000006],[-73.83746672997165,40.682550000000006],[-73.83833275537543,40.684050000000006],[-73.83746672997165,40.685550000000006],[-73.83573467916408,40.685550000000006],[-73.8348686537603,40.684050000000006],[-73.83313660295272,40.684050000000006],[-73.83227057754894,40.685550000000006],[-73.83053852674136,40.685550000000006],[-73.82967250133758,40.687050000000006],[-73.82794045053001,40.687050000000006],[-73.82707442512623,40.688550000000006],[-73.82534237431865,40.688550000000006],[-73.82447634891487,40.687050000000006],[-73.8227442981073,40.687050000000006],[-73.82187827270351,40.688550000000006],[-73.82014622189594,40.688550000000006],[-73.81928019649216,40.69005000000001],[-73.81754814568458,40.69005000000001],[-73.8166821202808,40.69155000000001],[-73.81495006947323,40.69155000000001],[-73.81408404406945,40.69005000000001],[-73.81235199326187,40.69005000000001],[-73.81148596785809,40.69155000000001],[-73.80975391705051,40.69155000000001],[-73.80888789164673,40.69005000000001],[-73.80975391705051,40.688550000000006],[-73.80888789164673,40.687050000000006],[-73.80715584083916,40.687050000000006],[-73.80628981543538,40.685550000000006],[-73.80715584083916,40.684050000000006],[-73.80628981543538,40.682550000000006],[-73.8045577646278,40.682550000000006],[-73.80369173922402,40.681050000000006],[-73.8045577646278,40.679550000000006],[-73.80369173922402,40.678050000000006],[-73.80195968841645,40.678050000000006],[-73.80109366301267,40.676550000000006],[-73.80195968841645,40.675050000000006],[-73.80109366301267,40.673550000000006],[-73.80195968841645,40.672050000000006],[-73.80109366301267,40.670550000000006],[-73.80195968841645,40.669050000000006],[-73.80109366301267,40.667550000000006],[-73.80195968841645,40.666050000000006],[-73.80369173922402,40.666050000000006],[-73.8045577646278,40.664550000000006],[-73.80628981543538,40.664550000000006],[-73.80715584083916,40.663050000000005],[-73.80888789164673,40.663050000000005],[-73.80975391705051,40.661550000000005],[-73.81148596785809,40.661550000000005],[-73.81235199326187,40.663050000000005],[-73.81408404406945,40.663050000000005],[-73.81495006947323,40.661550000000005],[-73.8166821202808,40.661550000000005],[-73.81754814568458,40.663050000000005],[-73.81928019649216,40.663050000000005],[-73.82014622189594,40.661550000000005],[-73.82187827270351,40.661550000000005],[-73.8227442981073,40.663050000000005],[-73.82447634891487,40.663050000000005],[-73.82534237431865,40.664550000000006],[-73.82707442512623,40.664550000000006],[-73.82794045053001,40.663050000000005]]],"type":"Polygon"}},{"id":"91","properties":{"borough":"queens","borocode":4,"neighborhood":"Kew Gardens"},"type":"Feature","geometry":{"coordinates":[[[-73.83313660295272,40.70205000000001],[-73.8348686537603,40.70205000000001],[-73.83573467916408,40.70355000000001],[-73.83746672997165,40.70355000000001],[-73.83833275537543,40.70505000000001],[-73.84006480618301,40.70505000000001],[-73.84093083158679,40.70655000000001],[-73.84006480618301,40.70805000000001],[-73.83833275537543,40.70805000000001],[-73.83746672997165,40.70955000000001],[-73.83573467916408,40.70955000000001],[-73.8348686537603,40.71105000000001],[-73.83573467916408,40.71255000000001],[-73.8348686537603,40.71405000000001],[-73.83313660295272,40.71405000000001],[-73.83227057754894,40.71555000000001],[-73.83053852674136,40.71555000000001],[-73.82967250133758,40.71405000000001],[-73.82794045053001,40.71405000000001],[-73.82707442512623,40.71555000000001],[-73.82534237431865,40.71555000000001],[-73.82447634891487,40.71405000000001],[-73.82534237431865,40.71255000000001],[-73.82447634891487,40.71105000000001],[-73.8227442981073,40.71105000000001],[-73.82187827270351,40.70955000000001],[-73.82014622189594,40.70955000000001],[-73.81928019649216,40.70805000000001],[-73.81754814568458,40.70805000000001],[-73.8166821202808,40.70655000000001],[-73.81754814568458,40.70505000000001],[-73.8166821202808,40.70355000000001],[-73.81754814568458,40.70205000000001],[-73.81928019649216,40.70205000000001],[-73.82014622189594,40.70355000000001],[-73.82187827270351,40.70355000000001],[-73.8227442981073,40.70205000000001],[-73.82447634891487,40.70205000000001],[-73.82534237431865,40.70355000000001],[-73.82707442512623,40.70355000000001],[-73.82794045053001,40.70205000000001],[-73.82967250133758,40.70205000000001],[-73.83053852674136,40.70355000000001],[-73.83227057754894,40.70355000000001],[-73.83313660295272,40.70205000000001]]],"type":"Polygon"}},{"id":"181","properties":{"borough":"queens","borocode":4,"neighborhood":"Whitestone"},"type":"Feature","geometry":{"coordinates":[[[-73.83573467916408,40.78155000000001],[-73.83746672997165,40.78155000000001],[-73.83833275537543,40.78305000000001],[-73.83746672997165,40.78455000000001],[-73.83833275537543,40.78605000000001],[-73.83746672997165,40.78755000000001],[-73.83833275537543,40.78905000000001],[-73.84006480618301,40.78905000000001],[-73.84093083158679,40.79055000000001],[-73.84006480618301,40.79205000000001],[-73.84093083158679,40.79355000000001],[-73.84006480618301,40.79505000000001],[-73.83833275537543,40.79505000000001],[-73.83746672997165,40.79355000000001],[-73.83573467916408,40.79355000000001],[-73.8348686537603,40.79205000000001],[-73.83313660295272,40.79205000000001],[-73.83227057754894,40.79355000000001],[-73.83053852674136,40.79355000000001],[-73.82967250133758,40.79505000000001],[-73.83053852674136,40.79655000000001],[-73.82967250133758,40.79805000000001],[-73.82794045053001,40.79805000000001],[-73.82707442512623,40.79955000000001],[-73.82534237431865,40.79955000000001],[-73.82447634891487,40.80105000000001],[-73.8227442981073,40.80105000000001],[-73.82187827270351,40.80255000000001],[-73.82014622189594,40.80255000000001],[-73.81928019649216,40.80105000000001],[-73.81754814568458,40.80105000000001],[-73.8166821202808,40.79955000000001],[-73.81495006947323,40.79955000000001],[-73.81408404406945,40.80105000000001],[-73.81235199326187,40.80105000000001],[-73.81148596785809,40.79955000000001],[-73.80975391705051,40.79955000000001],[-73.80888789164673,40.79805000000001],[-73.80715584083916,40.79805000000001],[-73.80628981543538,40.79655000000001],[-73.8045577646278,40.79655000000001],[-73.80369173922402,40.79805000000001],[-73.80195968841645,40.79805000000001],[-73.80109366301267,40.79655000000001],[-73.79936161220509,40.79655000000001],[-73.79849558680131,40.79805000000001],[-73.79676353599373,40.79805000000001],[-73.79589751058995,40.79655000000001],[-73.79416545978238,40.79655000000001],[-73.7932994343786,40.79505000000001],[-73.79416545978238,40.79355000000001],[-73.7932994343786,40.79205000000001],[-73.79416545978238,40.79055000000001],[-73.7932994343786,40.78905000000001],[-73.79416545978238,40.78755000000001],[-73.79589751058995,40.78755000000001],[-73.79676353599373,40.78605000000001],[-73.79849558680131,40.78605000000001],[-73.79936161220509,40.78455000000001],[-73.80109366301267,40.78455000000001],[-73.80195968841645,40.78305000000001],[-73.80109366301267,40.78155000000001],[-73.80195968841645,40.78005000000001],[-73.80369173922402,40.78005000000001],[-73.8045577646278,40.77855000000001],[-73.80369173922402,40.77705000000001],[-73.8045577646278,40.77555000000001],[-73.80628981543538,40.77555000000001],[-73.80715584083916,40.77705000000001],[-73.80888789164673,40.77705000000001],[-73.80975391705051,40.77555000000001],[-73.81148596785809,40.77555000000001],[-73.81235199326187,40.77705000000001],[-73.81408404406945,40.77705000000001],[-73.81495006947323,40.77855000000001],[-73.8166821202808,40.77855000000001],[-73.81754814568458,40.78005000000001],[-73.81928019649216,40.78005000000001],[-73.82014622189594,40.77855000000001],[-73.82187827270351,40.77855000000001],[-73.8227442981073,40.78005000000001],[-73.82187827270351,40.78155000000001],[-73.8227442981073,40.78305000000001],[-73.82447634891487,40.78305000000001],[-73.82534237431865,40.78155000000001],[-73.82707442512623,40.78155000000001],[-73.82794045053001,40.78005000000001],[-73.82967250133758,40.78005000000001],[-73.83053852674136,40.78155000000001],[-73.83227057754894,40.78155000000001],[-73.83313660295272,40.78305000000001],[-73.8348686537603,40.78305000000001],[-73.83573467916408,40.78155000000001]]],"type":"Polygon"}},{"id":"146","properties":{"borough":"bronx","borocode":2,"neighborhood":"Schuylerville-Throgs Neck-Edgewater Park"},"type":"Feature","geometry":{"coordinates":[[[-73.8348686537603,40.81605000000001],[-73.83573467916408,40.81755000000001],[-73.8348686537603,40.81905000000001],[-73.83573467916408,40.82055000000001],[-73.8348686537603,40.82205000000001],[-73.83573467916408,40.82355000000001],[-73.8348686537603,40.82505000000001],[-73.83573467916408,40.82655000000001],[-73.8348686537603,40.82805000000001],[-73.83573467916408,40.82955000000001],[-73.83746672997165,40.82955000000001],[-73.83833275537543,40.83105000000001],[-73.83746672997165,40.83255000000001],[-73.83833275537543,40.83405000000001],[-73.83746672997165,40.83555000000001],[-73.83833275537543,40.83705000000001],[-73.84006480618301,40.83705000000001],[-73.84093083158679,40.83855000000001],[-73.84006480618301,40.84005000000001],[-73.83833275537543,40.84005000000001],[-73.83746672997165,40.84155000000001],[-73.83833275537543,40.84305000000001],[-73.83746672997165,40.84455000000001],[-73.83573467916408,40.84455000000001],[-73.8348686537603,40.84305000000001],[-73.83313660295272,40.84305000000001],[-73.83227057754894,40.84455000000001],[-73.83053852674136,40.84455000000001],[-73.82967250133758,40.84305000000001],[-73.82794045053001,40.84305000000001],[-73.82707442512623,40.84455000000001],[-73.82534237431865,40.84455000000001],[-73.82447634891487,40.84305000000001],[-73.82534237431865,40.84155000000001],[-73.82447634891487,40.84005000000001],[-73.82534237431865,40.83855000000001],[-73.82447634891487,40.83705000000001],[-73.82534237431865,40.83555000000001],[-73.82447634891487,40.83405000000001],[-73.8227442981073,40.83405000000001],[-73.82187827270351,40.83555000000001],[-73.82014622189594,40.83555000000001],[-73.81928019649216,40.83705000000001],[-73.81754814568458,40.83705000000001],[-73.8166821202808,40.83555000000001],[-73.81495006947323,40.83555000000001],[-73.81408404406945,40.83405000000001],[-73.81495006947323,40.83255000000001],[-73.81408404406945,40.83105000000001],[-73.81235199326187,40.83105000000001],[-73.81148596785809,40.82955000000001],[-73.81235199326187,40.82805000000001],[-73.81148596785809,40.82655000000001],[-73.80975391705051,40.82655000000001],[-73.80888789164673,40.82805000000001],[-73.80715584083916,40.82805000000001],[-73.80628981543538,40.82655000000001],[-73.80715584083916,40.82505000000001],[-73.80628981543538,40.82355000000001],[-73.8045577646278,40.82355000000001],[-73.80369173922402,40.82205000000001],[-73.8045577646278,40.82055000000001],[-73.80369173922402,40.81905000000001],[-73.80195968841645,40.81905000000001],[-73.80109366301267,40.81755000000001],[-73.79936161220509,40.81755000000001],[-73.79849558680131,40.81605000000001],[-73.79936161220509,40.81455000000001],[-73.79849558680131,40.81305000000001],[-73.79936161220509,40.81155000000001],[-73.79849558680131,40.81005000000001],[-73.79936161220509,40.80855000000001],[-73.80109366301267,40.80855000000001],[-73.80195968841645,40.80705000000001],[-73.80369173922402,40.80705000000001],[-73.8045577646278,40.80855000000001],[-73.80628981543538,40.80855000000001],[-73.80715584083916,40.81005000000001],[-73.80888789164673,40.81005000000001],[-73.80975391705051,40.81155000000001],[-73.81148596785809,40.81155000000001],[-73.81235199326187,40.81305000000001],[-73.81408404406945,40.81305000000001],[-73.81495006947323,40.81155000000001],[-73.8166821202808,40.81155000000001],[-73.81754814568458,40.81305000000001],[-73.81928019649216,40.81305000000001],[-73.82014622189594,40.81155000000001],[-73.82187827270351,40.81155000000001],[-73.8227442981073,40.81005000000001],[-73.82447634891487,40.81005000000001],[-73.82534237431865,40.80855000000001],[-73.82707442512623,40.80855000000001],[-73.82794045053001,40.81005000000001],[-73.82707442512623,40.81155000000001],[-73.82794045053001,40.81305000000001],[-73.82967250133758,40.81305000000001],[-73.83053852674136,40.81455000000001],[-73.82967250133758,40.81605000000001],[-73.83053852674136,40.81755000000001],[-73.83227057754894,40.81755000000001],[-73.83313660295272,40.81605000000001],[-73.8348686537603,40.81605000000001]]],"type":"Polygon"}},{"id":"138","properties":{"borough":"queens","borocode":4,"neighborhood":"Queensboro Hill"},"type":"Feature","geometry":{"coordinates":[[[[-73.79676353599373,40.73805000000001],[-73.79849558680131,40.73805000000001],[-73.79936161220509,40.73955000000001],[-73.79849558680131,40.74105000000001],[-73.79676353599373,40.74105000000001],[-73.79589751058995,40.73955000000001],[-73.79676353599373,40.73805000000001]]],[[[-73.81495006947323,40.73655000000001],[-73.8166821202808,40.73655000000001],[-73.81754814568458,40.73805000000001],[-73.81928019649216,40.73805000000001],[-73.82014622189594,40.73655000000001],[-73.82187827270351,40.73655000000001],[-73.8227442981073,40.73805000000001],[-73.82447634891487,40.73805000000001],[-73.82534237431865,40.73655000000001],[-73.82707442512623,40.73655000000001],[-73.82794045053001,40.73505000000001],[-73.82967250133758,40.73505000000001],[-73.83053852674136,40.73655000000001],[-73.83227057754894,40.73655000000001],[-73.83313660295272,40.73805000000001],[-73.83227057754894,40.73955000000001],[-73.83313660295272,40.74105000000001],[-73.8348686537603,40.74105000000001],[-73.83573467916408,40.74255000000001],[-73.83746672997165,40.74255000000001],[-73.83833275537543,40.74405000000001],[-73.83746672997165,40.74555000000001],[-73.83573467916408,40.74555000000001],[-73.8348686537603,40.74705000000001],[-73.83573467916408,40.74855000000001],[-73.8348686537603,40.75005000000001],[-73.83313660295272,40.75005000000001],[-73.83227057754894,40.75155000000001],[-73.83053852674136,40.75155000000001],[-73.82967250133758,40.75005000000001],[-73.82794045053001,40.75005000000001],[-73.82707442512623,40.75155000000001],[-73.82534237431865,40.75155000000001],[-73.82447634891487,40.75005000000001],[-73.8227442981073,40.75005000000001],[-73.82187827270351,40.74855000000001],[-73.82014622189594,40.74855000000001],[-73.81928019649216,40.74705000000001],[-73.81754814568458,40.74705000000001],[-73.8166821202808,40.74555000000001],[-73.81495006947323,40.74555000000001],[-73.81408404406945,40.74705000000001],[-73.81235199326187,40.74705000000001],[-73.81148596785809,40.74555000000001],[-73.81235199326187,40.74405000000001],[-73.81148596785809,40.74255000000001],[-73.80975391705051,40.74255000000001],[-73.80888789164673,40.74405000000001],[-73.80715584083916,40.74405000000001],[-73.80628981543538,40.74255000000001],[-73.8045577646278,40.74255000000001],[-73.80369173922402,40.74105000000001],[-73.80195968841645,40.74105000000001],[-73.80109366301267,40.73955000000001],[-73.80195968841645,40.73805000000001],[-73.80369173922402,40.73805000000001],[-73.8045577646278,40.73955000000001],[-73.80628981543538,40.73955000000001],[-73.80715584083916,40.73805000000001],[-73.80888789164673,40.73805000000001],[-73.80975391705051,40.73955000000001],[-73.81148596785809,40.73955000000001],[-73.81235199326187,40.73805000000001],[-73.81408404406945,40.73805000000001],[-73.81495006947323,40.73655000000001]]]],"type":"MultiPolygon"}},{"id":"64","properties":{"borough":"queens","borocode":4,"neighborhood":"Flushing"},"type":"Feature","geometry":{"coordinates":[[[-73.83313660295272,40.75005000000001],[-73.8348686537603,40.75005000000001],[-73.83573467916408,40.75155000000001],[-73.83746672997165,40.75155000000001],[-73.83833275537543,40.75305000000001],[-73.84006480618301,40.75305000000001],[-73.84093083158679,40.75455000000001],[-73.84006480618301,40.75605000000001],[-73.83833275537543,40.75605000000001],[-73.83746672997165,40.75755000000001],[-73.83833275537543,40.75905000000001],[-73.83746672997165,40.76055000000001],[-73.83833275537543,40.76205000000001],[-73.83746672997165,40.76355000000001],[-73.83833275537543,40.76505000000001],[-73.83746672997165,40.76655000000001],[-73.83833275537543,40.76805000000001],[-73.83746672997165,40.76955000000001],[-73.83573467916408,40.76955000000001],[-73.8348686537603,40.77105000000001],[-73.83313660295272,40.77105000000001],[-73.83227057754894,40.77255000000001],[-73.83053852674136,40.77255000000001],[-73.82967250133758,40.77405000000001],[-73.83053852674136,40.77555000000001],[-73.82967250133758,40.77705000000001],[-73.82794045053001,40.77705000000001],[-73.82707442512623,40.77855000000001],[-73.82794045053001,40.78005000000001],[-73.82707442512623,40.78155000000001],[-73.82534237431865,40.78155000000001],[-73.82447634891487,40.78305000000001],[-73.8227442981073,40.78305000000001],[-73.82187827270351,40.78155000000001],[-73.8227442981073,40.78005000000001],[-73.82447634891487,40.78005000000001],[-73.82534237431865,40.77855000000001],[-73.82447634891487,40.77705000000001],[-73.82534237431865,40.77555000000001],[-73.82707442512623,40.77555000000001],[-73.82794045053001,40.77405000000001],[-73.82707442512623,40.77255000000001],[-73.82794045053001,40.77105000000001],[-73.82707442512623,40.76955000000001],[-73.82534237431865,40.76955000000001],[-73.82447634891487,40.76805000000001],[-73.82534237431865,40.76655000000001],[-73.82447634891487,40.76505000000001],[-73.8227442981073,40.76505000000001],[-73.82187827270351,40.76355000000001],[-73.8227442981073,40.76205000000001],[-73.82187827270351,40.76055000000001],[-73.82014622189594,40.76055000000001],[-73.81928019649216,40.75905000000001],[-73.82014622189594,40.75755000000001],[-73.81928019649216,40.75605000000001],[-73.82014622189594,40.75455000000001],[-73.81928019649216,40.75305000000001],[-73.82014622189594,40.75155000000001],[-73.81928019649216,40.75005000000001],[-73.81754814568458,40.75005000000001],[-73.8166821202808,40.74855000000001],[-73.81754814568458,40.74705000000001],[-73.81928019649216,40.74705000000001],[-73.82014622189594,40.74855000000001],[-73.82187827270351,40.74855000000001],[-73.8227442981073,40.75005000000001],[-73.82447634891487,40.75005000000001],[-73.82534237431865,40.75155000000001],[-73.82707442512623,40.75155000000001],[-73.82794045053001,40.75005000000001],[-73.82967250133758,40.75005000000001],[-73.83053852674136,40.75155000000001],[-73.83227057754894,40.75155000000001],[-73.83313660295272,40.75005000000001]]],"type":"Polygon"}},{"id":"131","properties":{"borough":"bronx","borocode":2,"neighborhood":"Pelham Bay-Country Club-City Island"},"type":"Feature","geometry":{"coordinates":[[[[-73.76991674847639,40.84455000000001],[-73.77078277388017,40.84605000000001],[-73.76991674847639,40.84755000000001],[-73.76818469766881,40.84755000000001],[-73.76731867226503,40.84605000000001],[-73.76818469766881,40.84455000000001],[-73.76991674847639,40.84455000000001]]],[[[-73.78377315493695,40.83555000000001],[-73.78550520574453,40.83555000000001],[-73.78637123114831,40.83705000000001],[-73.78810328195588,40.83705000000001],[-73.78896930735966,40.83855000000001],[-73.78810328195588,40.84005000000001],[-73.78896930735966,40.84155000000001],[-73.79070135816724,40.84155000000001],[-73.79156738357102,40.84305000000001],[-73.79070135816724,40.84455000000001],[-73.79156738357102,40.84605000000001],[-73.7932994343786,40.84605000000001],[-73.79416545978238,40.84755000000001],[-73.7932994343786,40.84905000000001],[-73.79156738357102,40.84905000000001],[-73.79070135816724,40.85055000000001],[-73.79156738357102,40.85205000000001],[-73.7932994343786,40.85205000000001],[-73.79416545978238,40.85355000000001],[-73.7932994343786,40.85505000000001],[-73.79416545978238,40.85655000000001],[-73.7932994343786,40.85805000000001],[-73.79156738357102,40.85805000000001],[-73.79070135816724,40.85955000000001],[-73.78896930735966,40.85955000000001],[-73.78810328195588,40.85805000000001],[-73.78637123114831,40.85805000000001],[-73.78550520574453,40.85655000000001],[-73.78637123114831,40.85505000000001],[-73.78550520574453,40.85355000000001],[-73.78377315493695,40.85355000000001],[-73.78290712953317,40.85205000000001],[-73.7811750787256,40.85205000000001],[-73.78030905332182,40.85055000000001],[-73.7811750787256,40.84905000000001],[-73.78030905332182,40.84755000000001],[-73.7811750787256,40.84605000000001],[-73.78030905332182,40.84455000000001],[-73.7811750787256,40.84305000000001],[-73.78030905332182,40.84155000000001],[-73.7811750787256,40.84005000000001],[-73.78030905332182,40.83855000000001],[-73.7811750787256,40.83705000000001],[-73.78290712953317,40.83705000000001],[-73.78377315493695,40.83555000000001]]],[[[-73.82794045053001,40.84305000000001],[-73.82967250133758,40.84305000000001],[-73.83053852674136,40.84455000000001],[-73.83227057754894,40.84455000000001],[-73.83313660295272,40.84305000000001],[-73.8348686537603,40.84305000000001],[-73.83573467916408,40.84455000000001],[-73.83746672997165,40.84455000000001],[-73.83833275537543,40.84605000000001],[-73.83746672997165,40.84755000000001],[-73.83833275537543,40.84905000000001],[-73.83746672997165,40.85055000000001],[-73.83573467916408,40.85055000000001],[-73.8348686537603,40.85205000000001],[-73.83573467916408,40.85355000000001],[-73.8348686537603,40.85505000000001],[-73.83313660295272,40.85505000000001],[-73.83227057754894,40.85655000000001],[-73.83053852674136,40.85655000000001],[-73.82967250133758,40.85805000000001],[-73.82794045053001,40.85805000000001],[-73.82707442512623,40.85655000000001],[-73.82794045053001,40.85505000000001],[-73.82707442512623,40.85355000000001],[-73.82534237431865,40.85355000000001],[-73.82447634891487,40.85205000000001],[-73.82534237431865,40.85055000000001],[-73.82707442512623,40.85055000000001],[-73.82794045053001,40.84905000000001],[-73.82707442512623,40.84755000000001],[-73.82534237431865,40.84755000000001],[-73.82447634891487,40.84905000000001],[-73.8227442981073,40.84905000000001],[-73.82187827270351,40.85055000000001],[-73.82014622189594,40.85055000000001],[-73.81928019649216,40.84905000000001],[-73.81754814568458,40.84905000000001],[-73.8166821202808,40.85055000000001],[-73.81495006947323,40.85055000000001],[-73.81408404406945,40.84905000000001],[-73.81495006947323,40.84755000000001],[-73.81408404406945,40.84605000000001],[-73.81495006947323,40.84455000000001],[-73.81408404406945,40.84305000000001],[-73.81495006947323,40.84155000000001],[-73.81408404406945,40.84005000000001],[-73.81495006947323,40.83855000000001],[-73.81408404406945,40.83705000000001],[-73.81495006947323,40.83555000000001],[-73.8166821202808,40.83555000000001],[-73.81754814568458,40.83705000000001],[-73.81928019649216,40.83705000000001],[-73.82014622189594,40.83555000000001],[-73.82187827270351,40.83555000000001],[-73.8227442981073,40.83405000000001],[-73.82447634891487,40.83405000000001],[-73.82534237431865,40.83555000000001],[-73.82447634891487,40.83705000000001],[-73.82534237431865,40.83855000000001],[-73.82447634891487,40.84005000000001],[-73.82534237431865,40.84155000000001],[-73.82447634891487,40.84305000000001],[-73.82534237431865,40.84455000000001],[-73.82707442512623,40.84455000000001],[-73.82794045053001,40.84305000000001]]]],"type":"MultiPolygon"}},{"id":"92","properties":{"borough":"queens","borocode":4,"neighborhood":"Kew Gardens Hills"},"type":"Feature","geometry":{"coordinates":[[[-73.82534237431865,40.71555000000001],[-73.82707442512623,40.71555000000001],[-73.82794045053001,40.71705000000001],[-73.82707442512623,40.71855000000001],[-73.82794045053001,40.72005000000001],[-73.82707442512623,40.72155000000001],[-73.82794045053001,40.72305000000001],[-73.82967250133758,40.72305000000001],[-73.83053852674136,40.72455000000001],[-73.82967250133758,40.72605000000001],[-73.83053852674136,40.72755000000001],[-73.82967250133758,40.72905000000001],[-73.83053852674136,40.73055000000001],[-73.82967250133758,40.73205000000001],[-73.82794045053001,40.73205000000001],[-73.82707442512623,40.73355000000001],[-73.82794045053001,40.73505000000001],[-73.82707442512623,40.73655000000001],[-73.82534237431865,40.73655000000001],[-73.82447634891487,40.73805000000001],[-73.8227442981073,40.73805000000001],[-73.82187827270351,40.73655000000001],[-73.82014622189594,40.73655000000001],[-73.81928019649216,40.73805000000001],[-73.81754814568458,40.73805000000001],[-73.8166821202808,40.73655000000001],[-73.81495006947323,40.73655000000001],[-73.81408404406945,40.73505000000001],[-73.81495006947323,40.73355000000001],[-73.81408404406945,40.73205000000001],[-73.81495006947323,40.73055000000001],[-73.81408404406945,40.72905000000001],[-73.81495006947323,40.72755000000001],[-73.81408404406945,40.72605000000001],[-73.81235199326187,40.72605000000001],[-73.81148596785809,40.72755000000001],[-73.80975391705051,40.72755000000001],[-73.80888789164673,40.72905000000001],[-73.80715584083916,40.72905000000001],[-73.80628981543538,40.72755000000001],[-73.80715584083916,40.72605000000001],[-73.80628981543538,40.72455000000001],[-73.8045577646278,40.72455000000001],[-73.80369173922402,40.72305000000001],[-73.8045577646278,40.72155000000001],[-73.80628981543538,40.72155000000001],[-73.80715584083916,40.72005000000001],[-73.80888789164673,40.72005000000001],[-73.80975391705051,40.71855000000001],[-73.81148596785809,40.71855000000001],[-73.81235199326187,40.71705000000001],[-73.81408404406945,40.71705000000001],[-73.81495006947323,40.71555000000001],[-73.8166821202808,40.71555000000001],[-73.81754814568458,40.71705000000001],[-73.81928019649216,40.71705000000001],[-73.82014622189594,40.71855000000001],[-73.82187827270351,40.71855000000001],[-73.8227442981073,40.71705000000001],[-73.82447634891487,40.71705000000001],[-73.82534237431865,40.71555000000001]]],"type":"Polygon"}},{"id":"113","properties":{"borough":"queens","borocode":4,"neighborhood":"Murray Hill"},"type":"Feature","geometry":{"coordinates":[[[-73.81754814568458,40.75905000000001],[-73.81928019649216,40.75905000000001],[-73.82014622189594,40.76055000000001],[-73.82187827270351,40.76055000000001],[-73.8227442981073,40.76205000000001],[-73.82187827270351,40.76355000000001],[-73.8227442981073,40.76505000000001],[-73.82447634891487,40.76505000000001],[-73.82534237431865,40.76655000000001],[-73.82447634891487,40.76805000000001],[-73.82534237431865,40.76955000000001],[-73.82707442512623,40.76955000000001],[-73.82794045053001,40.77105000000001],[-73.82707442512623,40.77255000000001],[-73.82794045053001,40.77405000000001],[-73.82707442512623,40.77555000000001],[-73.82534237431865,40.77555000000001],[-73.82447634891487,40.77705000000001],[-73.82534237431865,40.77855000000001],[-73.82447634891487,40.78005000000001],[-73.8227442981073,40.78005000000001],[-73.82187827270351,40.77855000000001],[-73.82014622189594,40.77855000000001],[-73.81928019649216,40.78005000000001],[-73.81754814568458,40.78005000000001],[-73.8166821202808,40.77855000000001],[-73.81495006947323,40.77855000000001],[-73.81408404406945,40.77705000000001],[-73.81235199326187,40.77705000000001],[-73.81148596785809,40.77555000000001],[-73.80975391705051,40.77555000000001],[-73.80888789164673,40.77705000000001],[-73.80715584083916,40.77705000000001],[-73.80628981543538,40.77555000000001],[-73.8045577646278,40.77555000000001],[-73.80369173922402,40.77705000000001],[-73.80195968841645,40.77705000000001],[-73.80109366301267,40.77555000000001],[-73.79936161220509,40.77555000000001],[-73.79849558680131,40.77405000000001],[-73.79676353599373,40.77405000000001],[-73.79589751058995,40.77255000000001],[-73.79416545978238,40.77255000000001],[-73.7932994343786,40.77105000000001],[-73.79416545978238,40.76955000000001],[-73.7932994343786,40.76805000000001],[-73.79416545978238,40.76655000000001],[-73.7932994343786,40.76505000000001],[-73.79416545978238,40.76355000000001],[-73.7932994343786,40.76205000000001],[-73.79156738357102,40.76205000000001],[-73.79070135816724,40.76055000000001],[-73.79156738357102,40.75905000000001],[-73.7932994343786,40.75905000000001],[-73.79416545978238,40.75755000000001],[-73.79589751058995,40.75755000000001],[-73.79676353599373,40.75905000000001],[-73.79849558680131,40.75905000000001],[-73.79936161220509,40.76055000000001],[-73.80109366301267,40.76055000000001],[-73.80195968841645,40.75905000000001],[-73.80369173922402,40.75905000000001],[-73.8045577646278,40.76055000000001],[-73.80628981543538,40.76055000000001],[-73.80715584083916,40.76205000000001],[-73.80888789164673,40.76205000000001],[-73.80975391705051,40.76055000000001],[-73.81148596785809,40.76055000000001],[-73.81235199326187,40.76205000000001],[-73.81408404406945,40.76205000000001],[-73.81495006947323,40.76055000000001],[-73.8166821202808,40.76055000000001],[-73.81754814568458,40.75905000000001]]],"type":"Polygon"}},{"id":"19","properties":{"borough":"queens","borocode":4,"neighborhood":"Briarwood-Jamaica Hills"},"type":"Feature","geometry":{"coordinates":[[[-73.79676353599373,40.70805000000001],[-73.79849558680131,40.70805000000001],[-73.79936161220509,40.70955000000001],[-73.80109366301267,40.70955000000001],[-73.80195968841645,40.70805000000001],[-73.80109366301267,40.70655000000001],[-73.80195968841645,40.70505000000001],[-73.80369173922402,40.70505000000001],[-73.8045577646278,40.70655000000001],[-73.80628981543538,40.70655000000001],[-73.80715584083916,40.70805000000001],[-73.80888789164673,40.70805000000001],[-73.80975391705051,40.70655000000001],[-73.81148596785809,40.70655000000001],[-73.81235199326187,40.70505000000001],[-73.81148596785809,40.70355000000001],[-73.81235199326187,40.70205000000001],[-73.81408404406945,40.70205000000001],[-73.81495006947323,40.70055000000001],[-73.8166821202808,40.70055000000001],[-73.81754814568458,40.70205000000001],[-73.8166821202808,40.70355000000001],[-73.81754814568458,40.70505000000001],[-73.8166821202808,40.70655000000001],[-73.81754814568458,40.70805000000001],[-73.81928019649216,40.70805000000001],[-73.82014622189594,40.70955000000001],[-73.82187827270351,40.70955000000001],[-73.8227442981073,40.71105000000001],[-73.82447634891487,40.71105000000001],[-73.82534237431865,40.71255000000001],[-73.82447634891487,40.71405000000001],[-73.82534237431865,40.71555000000001],[-73.82447634891487,40.71705000000001],[-73.8227442981073,40.71705000000001],[-73.82187827270351,40.71855000000001],[-73.82014622189594,40.71855000000001],[-73.81928019649216,40.71705000000001],[-73.81754814568458,40.71705000000001],[-73.8166821202808,40.71555000000001],[-73.81495006947323,40.71555000000001],[-73.81408404406945,40.71705000000001],[-73.81235199326187,40.71705000000001],[-73.81148596785809,40.71855000000001],[-73.80975391705051,40.71855000000001],[-73.80888789164673,40.71705000000001],[-73.80715584083916,40.71705000000001],[-73.80628981543538,40.71555000000001],[-73.8045577646278,40.71555000000001],[-73.80369173922402,40.71705000000001],[-73.80195968841645,40.71705000000001],[-73.80109366301267,40.71555000000001],[-73.79936161220509,40.71555000000001],[-73.79849558680131,40.71705000000001],[-73.79676353599373,40.71705000000001],[-73.79589751058995,40.71855000000001],[-73.79416545978238,40.71855000000001],[-73.7932994343786,40.72005000000001],[-73.79156738357102,40.72005000000001],[-73.79070135816724,40.71855000000001],[-73.79156738357102,40.71705000000001],[-73.7932994343786,40.71705000000001],[-73.79416545978238,40.71555000000001],[-73.7932994343786,40.71405000000001],[-73.79416545978238,40.71255000000001],[-73.7932994343786,40.71105000000001],[-73.79416545978238,40.70955000000001],[-73.79589751058995,40.70955000000001],[-73.79676353599373,40.70805000000001]]],"type":"Polygon"}},{"id":"49","properties":{"borough":"queens","borocode":4,"neighborhood":"East Flushing"},"type":"Feature","geometry":{"coordinates":[[[-73.81495006947323,40.74555000000001],[-73.8166821202808,40.74555000000001],[-73.81754814568458,40.74705000000001],[-73.8166821202808,40.74855000000001],[-73.81754814568458,40.75005000000001],[-73.81928019649216,40.75005000000001],[-73.82014622189594,40.75155000000001],[-73.81928019649216,40.75305000000001],[-73.82014622189594,40.75455000000001],[-73.81928019649216,40.75605000000001],[-73.82014622189594,40.75755000000001],[-73.81928019649216,40.75905000000001],[-73.81754814568458,40.75905000000001],[-73.8166821202808,40.76055000000001],[-73.81495006947323,40.76055000000001],[-73.81408404406945,40.76205000000001],[-73.81235199326187,40.76205000000001],[-73.81148596785809,40.76055000000001],[-73.80975391705051,40.76055000000001],[-73.80888789164673,40.76205000000001],[-73.80715584083916,40.76205000000001],[-73.80628981543538,40.76055000000001],[-73.8045577646278,40.76055000000001],[-73.80369173922402,40.75905000000001],[-73.80195968841645,40.75905000000001],[-73.80109366301267,40.76055000000001],[-73.79936161220509,40.76055000000001],[-73.79849558680131,40.75905000000001],[-73.79676353599373,40.75905000000001],[-73.79589751058995,40.75755000000001],[-73.79416545978238,40.75755000000001],[-73.7932994343786,40.75605000000001],[-73.79416545978238,40.75455000000001],[-73.79589751058995,40.75455000000001],[-73.79676353599373,40.75305000000001],[-73.79589751058995,40.75155000000001],[-73.79676353599373,40.75005000000001],[-73.79589751058995,40.74855000000001],[-73.79676353599373,40.74705000000001],[-73.79589751058995,40.74555000000001],[-73.79676353599373,40.74405000000001],[-73.79849558680131,40.74405000000001],[-73.79936161220509,40.74555000000001],[-73.80109366301267,40.74555000000001],[-73.80195968841645,40.74405000000001],[-73.80369173922402,40.74405000000001],[-73.8045577646278,40.74555000000001],[-73.80369173922402,40.74705000000001],[-73.8045577646278,40.74855000000001],[-73.80628981543538,40.74855000000001],[-73.80715584083916,40.74705000000001],[-73.80888789164673,40.74705000000001],[-73.80975391705051,40.74555000000001],[-73.81148596785809,40.74555000000001],[-73.81235199326187,40.74705000000001],[-73.81408404406945,40.74705000000001],[-73.81495006947323,40.74555000000001]]],"type":"Polygon"}},{"id":"80","properties":{"borough":"queens","borocode":4,"neighborhood":"Hammels-Arverne-Edgemere"},"type":"Feature","geometry":{"coordinates":[[[-73.7629885452461,40.58955],[-73.76472059605368,40.58955],[-73.76558662145746,40.59105],[-73.76731867226503,40.59105],[-73.76818469766881,40.58955],[-73.76991674847639,40.58955],[-73.77078277388017,40.59105],[-73.77251482468775,40.59105],[-73.77338085009153,40.58955],[-73.7751129008991,40.58955],[-73.77597892630288,40.59105],[-73.77771097711046,40.59105],[-73.77857700251424,40.58955],[-73.78030905332182,40.58955],[-73.7811750787256,40.58805],[-73.78290712953317,40.58805],[-73.78377315493695,40.58955],[-73.78550520574453,40.58955],[-73.78637123114831,40.58805],[-73.78810328195588,40.58805],[-73.78896930735966,40.58655],[-73.79070135816724,40.58655],[-73.79156738357102,40.58505],[-73.7932994343786,40.58505],[-73.79416545978238,40.58655],[-73.79589751058995,40.58655],[-73.79676353599373,40.58505],[-73.79849558680131,40.58505],[-73.79936161220509,40.58355],[-73.80109366301267,40.58355],[-73.80195968841645,40.58505],[-73.80369173922402,40.58505],[-73.8045577646278,40.58355],[-73.80628981543538,40.58355],[-73.80715584083916,40.58505],[-73.80888789164673,40.58505],[-73.80975391705051,40.58355],[-73.81148596785809,40.58355],[-73.81235199326187,40.58205],[-73.81408404406945,40.58205],[-73.81495006947323,40.58355],[-73.8166821202808,40.58355],[-73.81754814568458,40.58505],[-73.8166821202808,40.58655],[-73.81754814568458,40.58805],[-73.81928019649216,40.58805],[-73.82014622189594,40.58955],[-73.81928019649216,40.59105],[-73.81754814568458,40.59105],[-73.8166821202808,40.59255],[-73.81495006947323,40.59255],[-73.81408404406945,40.59405],[-73.81235199326187,40.59405],[-73.81148596785809,40.59255],[-73.80975391705051,40.59255],[-73.80888789164673,40.59405],[-73.80715584083916,40.59405],[-73.80628981543538,40.59555],[-73.80715584083916,40.59705],[-73.80628981543538,40.59855],[-73.8045577646278,40.59855],[-73.80369173922402,40.60005],[-73.80195968841645,40.60005],[-73.80109366301267,40.60155],[-73.79936161220509,40.60155],[-73.79849558680131,40.60005],[-73.79676353599373,40.60005],[-73.79589751058995,40.60155],[-73.79416545978238,40.60155],[-73.7932994343786,40.60005],[-73.79156738357102,40.60005],[-73.79070135816724,40.59855],[-73.78896930735966,40.59855],[-73.78810328195588,40.60005],[-73.78637123114831,40.60005],[-73.78550520574453,40.59855],[-73.78377315493695,40.59855],[-73.78290712953317,40.60005],[-73.78377315493695,40.60155],[-73.78290712953317,40.60305],[-73.7811750787256,40.60305],[-73.78030905332182,40.60455],[-73.77857700251424,40.60455],[-73.77771097711046,40.60305],[-73.77597892630288,40.60305],[-73.7751129008991,40.60455],[-73.77338085009153,40.60455],[-73.77251482468775,40.60305],[-73.77338085009153,40.60155],[-73.77251482468775,40.60005],[-73.77078277388017,40.60005],[-73.76991674847639,40.59855],[-73.76818469766881,40.59855],[-73.76731867226503,40.60005],[-73.76558662145746,40.60005],[-73.76472059605368,40.59855],[-73.7629885452461,40.59855],[-73.76212251984232,40.59705],[-73.7629885452461,40.59555],[-73.76472059605368,40.59555],[-73.76558662145746,40.59405],[-73.76472059605368,40.59255],[-73.7629885452461,40.59255],[-73.76212251984232,40.59105],[-73.7629885452461,40.58955]]],"type":"Polygon"}},{"id":"88","properties":{"borough":"queens","borocode":4,"neighborhood":"Jamaica"},"type":"Feature","geometry":{"coordinates":[[[-73.78377315493695,40.70355000000001],[-73.78550520574453,40.70355000000001],[-73.78637123114831,40.70505000000001],[-73.78810328195588,40.70505000000001],[-73.78896930735966,40.70355000000001],[-73.79070135816724,40.70355000000001],[-73.79156738357102,40.70205000000001],[-73.7932994343786,40.70205000000001],[-73.79416545978238,40.70055000000001],[-73.79589751058995,40.70055000000001],[-73.79676353599373,40.69905000000001],[-73.79849558680131,40.69905000000001],[-73.79936161220509,40.69755000000001],[-73.80109366301267,40.69755000000001],[-73.80195968841645,40.69605000000001],[-73.80109366301267,40.69455000000001],[-73.80195968841645,40.69305000000001],[-73.80369173922402,40.69305000000001],[-73.8045577646278,40.69155000000001],[-73.80628981543538,40.69155000000001],[-73.80715584083916,40.69305000000001],[-73.80888789164673,40.69305000000001],[-73.80975391705051,40.69155000000001],[-73.81148596785809,40.69155000000001],[-73.81235199326187,40.69305000000001],[-73.81148596785809,40.69455000000001],[-73.81235199326187,40.69605000000001],[-73.81408404406945,40.69605000000001],[-73.81495006947323,40.69755000000001],[-73.81408404406945,40.69905000000001],[-73.81495006947323,40.70055000000001],[-73.81408404406945,40.70205000000001],[-73.81235199326187,40.70205000000001],[-73.81148596785809,40.70355000000001],[-73.81235199326187,40.70505000000001],[-73.81148596785809,40.70655000000001],[-73.80975391705051,40.70655000000001],[-73.80888789164673,40.70805000000001],[-73.80715584083916,40.70805000000001],[-73.80628981543538,40.70655000000001],[-73.8045577646278,40.70655000000001],[-73.80369173922402,40.70505000000001],[-73.80195968841645,40.70505000000001],[-73.80109366301267,40.70655000000001],[-73.80195968841645,40.70805000000001],[-73.80109366301267,40.70955000000001],[-73.79936161220509,40.70955000000001],[-73.79849558680131,40.70805000000001],[-73.79676353599373,40.70805000000001],[-73.79589751058995,40.70955000000001],[-73.79416545978238,40.70955000000001],[-73.7932994343786,40.71105000000001],[-73.79156738357102,40.71105000000001],[-73.79070135816724,40.71255000000001],[-73.78896930735966,40.71255000000001],[-73.78810328195588,40.71405000000001],[-73.78637123114831,40.71405000000001],[-73.78550520574453,40.71255000000001],[-73.78377315493695,40.71255000000001],[-73.78290712953317,40.71405000000001],[-73.7811750787256,40.71405000000001],[-73.78030905332182,40.71255000000001],[-73.77857700251424,40.71255000000001],[-73.77771097711046,40.71405000000001],[-73.77597892630288,40.71405000000001],[-73.7751129008991,40.71555000000001],[-73.77338085009153,40.71555000000001],[-73.77251482468775,40.71705000000001],[-73.77078277388017,40.71705000000001],[-73.76991674847639,40.71555000000001],[-73.77078277388017,40.71405000000001],[-73.76991674847639,40.71255000000001],[-73.77078277388017,40.71105000000001],[-73.76991674847639,40.70955000000001],[-73.77078277388017,40.70805000000001],[-73.77251482468775,40.70805000000001],[-73.77338085009153,40.70955000000001],[-73.7751129008991,40.70955000000001],[-73.77597892630288,40.70805000000001],[-73.7751129008991,40.70655000000001],[-73.77597892630288,40.70505000000001],[-73.77771097711046,40.70505000000001],[-73.77857700251424,40.70655000000001],[-73.78030905332182,40.70655000000001],[-73.7811750787256,40.70505000000001],[-73.78290712953317,40.70505000000001],[-73.78377315493695,40.70355000000001]]],"type":"Polygon"}},{"id":"133","properties":{"borough":"queens","borocode":4,"neighborhood":"Pomonok-Flushing Heights-Hillcrest"},"type":"Feature","geometry":{"coordinates":[[[-73.81235199326187,40.72605000000001],[-73.81408404406945,40.72605000000001],[-73.81495006947323,40.72755000000001],[-73.81408404406945,40.72905000000001],[-73.81495006947323,40.73055000000001],[-73.81408404406945,40.73205000000001],[-73.81495006947323,40.73355000000001],[-73.81408404406945,40.73505000000001],[-73.81495006947323,40.73655000000001],[-73.81408404406945,40.73805000000001],[-73.81235199326187,40.73805000000001],[-73.81148596785809,40.73955000000001],[-73.80975391705051,40.73955000000001],[-73.80888789164673,40.73805000000001],[-73.80715584083916,40.73805000000001],[-73.80628981543538,40.73955000000001],[-73.8045577646278,40.73955000000001],[-73.80369173922402,40.73805000000001],[-73.80195968841645,40.73805000000001],[-73.80109366301267,40.73955000000001],[-73.79936161220509,40.73955000000001],[-73.79849558680131,40.73805000000001],[-73.79676353599373,40.73805000000001],[-73.79589751058995,40.73655000000001],[-73.79676353599373,40.73505000000001],[-73.79589751058995,40.73355000000001],[-73.79416545978238,40.73355000000001],[-73.7932994343786,40.73205000000001],[-73.79416545978238,40.73055000000001],[-73.7932994343786,40.72905000000001],[-73.79416545978238,40.72755000000001],[-73.7932994343786,40.72605000000001],[-73.79156738357102,40.72605000000001],[-73.79070135816724,40.72455000000001],[-73.79156738357102,40.72305000000001],[-73.79070135816724,40.72155000000001],[-73.79156738357102,40.72005000000001],[-73.7932994343786,40.72005000000001],[-73.79416545978238,40.71855000000001],[-73.79589751058995,40.71855000000001],[-73.79676353599373,40.71705000000001],[-73.79849558680131,40.71705000000001],[-73.79936161220509,40.71555000000001],[-73.80109366301267,40.71555000000001],[-73.80195968841645,40.71705000000001],[-73.80369173922402,40.71705000000001],[-73.8045577646278,40.71555000000001],[-73.80628981543538,40.71555000000001],[-73.80715584083916,40.71705000000001],[-73.80888789164673,40.71705000000001],[-73.80975391705051,40.71855000000001],[-73.80888789164673,40.72005000000001],[-73.80715584083916,40.72005000000001],[-73.80628981543538,40.72155000000001],[-73.8045577646278,40.72155000000001],[-73.80369173922402,40.72305000000001],[-73.8045577646278,40.72455000000001],[-73.80628981543538,40.72455000000001],[-73.80715584083916,40.72605000000001],[-73.80628981543538,40.72755000000001],[-73.80715584083916,40.72905000000001],[-73.80888789164673,40.72905000000001],[-73.80975391705051,40.72755000000001],[-73.81148596785809,40.72755000000001],[-73.81235199326187,40.72605000000001]]],"type":"Polygon"}},{"id":"152","properties":{"borough":"queens","borocode":4,"neighborhood":"South Jamaica"},"type":"Feature","geometry":{"coordinates":[[[-73.78377315493695,40.688550000000006],[-73.78550520574453,40.688550000000006],[-73.78637123114831,40.69005000000001],[-73.78810328195588,40.69005000000001],[-73.78896930735966,40.688550000000006],[-73.79070135816724,40.688550000000006],[-73.79156738357102,40.687050000000006],[-73.7932994343786,40.687050000000006],[-73.79416545978238,40.688550000000006],[-73.79589751058995,40.688550000000006],[-73.79676353599373,40.687050000000006],[-73.79849558680131,40.687050000000006],[-73.79936161220509,40.685550000000006],[-73.80109366301267,40.685550000000006],[-73.80195968841645,40.684050000000006],[-73.80369173922402,40.684050000000006],[-73.8045577646278,40.682550000000006],[-73.80628981543538,40.682550000000006],[-73.80715584083916,40.684050000000006],[-73.80628981543538,40.685550000000006],[-73.80715584083916,40.687050000000006],[-73.80888789164673,40.687050000000006],[-73.80975391705051,40.688550000000006],[-73.80888789164673,40.69005000000001],[-73.80975391705051,40.69155000000001],[-73.80888789164673,40.69305000000001],[-73.80715584083916,40.69305000000001],[-73.80628981543538,40.69155000000001],[-73.8045577646278,40.69155000000001],[-73.80369173922402,40.69305000000001],[-73.80195968841645,40.69305000000001],[-73.80109366301267,40.69455000000001],[-73.80195968841645,40.69605000000001],[-73.80109366301267,40.69755000000001],[-73.79936161220509,40.69755000000001],[-73.79849558680131,40.69905000000001],[-73.79676353599373,40.69905000000001],[-73.79589751058995,40.70055000000001],[-73.79416545978238,40.70055000000001],[-73.7932994343786,40.70205000000001],[-73.79156738357102,40.70205000000001],[-73.79070135816724,40.70355000000001],[-73.78896930735966,40.70355000000001],[-73.78810328195588,40.70505000000001],[-73.78637123114831,40.70505000000001],[-73.78550520574453,40.70355000000001],[-73.78377315493695,40.70355000000001],[-73.78290712953317,40.70505000000001],[-73.7811750787256,40.70505000000001],[-73.78030905332182,40.70655000000001],[-73.77857700251424,40.70655000000001],[-73.77771097711046,40.70505000000001],[-73.77597892630288,40.70505000000001],[-73.7751129008991,40.70355000000001],[-73.77597892630288,40.70205000000001],[-73.7751129008991,40.70055000000001],[-73.77597892630288,40.69905000000001],[-73.7751129008991,40.69755000000001],[-73.77597892630288,40.69605000000001],[-73.77771097711046,40.69605000000001],[-73.77857700251424,40.69455000000001],[-73.77771097711046,40.69305000000001],[-73.77857700251424,40.69155000000001],[-73.78030905332182,40.69155000000001],[-73.7811750787256,40.69005000000001],[-73.78290712953317,40.69005000000001],[-73.78377315493695,40.688550000000006]]],"type":"Polygon"}},{"id":"6","properties":{"borough":"queens","borocode":4,"neighborhood":"Baisley Park"},"type":"Feature","geometry":{"coordinates":[[[-73.78896930735966,40.664550000000006],[-73.79070135816724,40.664550000000006],[-73.79156738357102,40.666050000000006],[-73.7932994343786,40.666050000000006],[-73.79416545978238,40.667550000000006],[-73.79589751058995,40.667550000000006],[-73.79676353599373,40.666050000000006],[-73.79849558680131,40.666050000000006],[-73.79936161220509,40.664550000000006],[-73.80109366301267,40.664550000000006],[-73.80195968841645,40.666050000000006],[-73.80109366301267,40.667550000000006],[-73.80195968841645,40.669050000000006],[-73.80109366301267,40.670550000000006],[-73.80195968841645,40.672050000000006],[-73.80109366301267,40.673550000000006],[-73.80195968841645,40.675050000000006],[-73.80109366301267,40.676550000000006],[-73.80195968841645,40.678050000000006],[-73.80369173922402,40.678050000000006],[-73.8045577646278,40.679550000000006],[-73.80369173922402,40.681050000000006],[-73.8045577646278,40.682550000000006],[-73.80369173922402,40.684050000000006],[-73.80195968841645,40.684050000000006],[-73.80109366301267,40.685550000000006],[-73.79936161220509,40.685550000000006],[-73.79849558680131,40.687050000000006],[-73.79676353599373,40.687050000000006],[-73.79589751058995,40.688550000000006],[-73.79416545978238,40.688550000000006],[-73.7932994343786,40.687050000000006],[-73.79156738357102,40.687050000000006],[-73.79070135816724,40.688550000000006],[-73.78896930735966,40.688550000000006],[-73.78810328195588,40.69005000000001],[-73.78637123114831,40.69005000000001],[-73.78550520574453,40.688550000000006],[-73.78377315493695,40.688550000000006],[-73.78290712953317,40.687050000000006],[-73.7811750787256,40.687050000000006],[-73.78030905332182,40.685550000000006],[-73.77857700251424,40.685550000000006],[-73.77771097711046,40.687050000000006],[-73.77597892630288,40.687050000000006],[-73.7751129008991,40.685550000000006],[-73.77597892630288,40.684050000000006],[-73.7751129008991,40.682550000000006],[-73.77338085009153,40.682550000000006],[-73.77251482468775,40.681050000000006],[-73.77338085009153,40.679550000000006],[-73.7751129008991,40.679550000000006],[-73.77597892630288,40.678050000000006],[-73.77771097711046,40.678050000000006],[-73.77857700251424,40.679550000000006],[-73.78030905332182,40.679550000000006],[-73.7811750787256,40.678050000000006],[-73.78290712953317,40.678050000000006],[-73.78377315493695,40.676550000000006],[-73.78550520574453,40.676550000000006],[-73.78637123114831,40.675050000000006],[-73.78550520574453,40.673550000000006],[-73.78637123114831,40.672050000000006],[-73.78550520574453,40.670550000000006],[-73.78637123114831,40.669050000000006],[-73.78810328195588,40.669050000000006],[-73.78896930735966,40.667550000000006],[-73.78810328195588,40.666050000000006],[-73.78896930735966,40.664550000000006]]],"type":"Polygon"}},{"id":"69","properties":{"borough":"queens","borocode":4,"neighborhood":"Ft. Totten-Bay Terrace-Clearview"},"type":"Feature","geometry":{"coordinates":[[[-73.78637123114831,40.77405000000001],[-73.78810328195588,40.77405000000001],[-73.78896930735966,40.77555000000001],[-73.79070135816724,40.77555000000001],[-73.79156738357102,40.77405000000001],[-73.7932994343786,40.77405000000001],[-73.79416545978238,40.77255000000001],[-73.79589751058995,40.77255000000001],[-73.79676353599373,40.77405000000001],[-73.79849558680131,40.77405000000001],[-73.79936161220509,40.77555000000001],[-73.80109366301267,40.77555000000001],[-73.80195968841645,40.77705000000001],[-73.80369173922402,40.77705000000001],[-73.8045577646278,40.77855000000001],[-73.80369173922402,40.78005000000001],[-73.80195968841645,40.78005000000001],[-73.80109366301267,40.78155000000001],[-73.80195968841645,40.78305000000001],[-73.80109366301267,40.78455000000001],[-73.79936161220509,40.78455000000001],[-73.79849558680131,40.78605000000001],[-73.79676353599373,40.78605000000001],[-73.79589751058995,40.78755000000001],[-73.79416545978238,40.78755000000001],[-73.7932994343786,40.78905000000001],[-73.79416545978238,40.79055000000001],[-73.7932994343786,40.79205000000001],[-73.79156738357102,40.79205000000001],[-73.79070135816724,40.79055000000001],[-73.78896930735966,40.79055000000001],[-73.78810328195588,40.78905000000001],[-73.78637123114831,40.78905000000001],[-73.78550520574453,40.79055000000001],[-73.78377315493695,40.79055000000001],[-73.78290712953317,40.78905000000001],[-73.7811750787256,40.78905000000001],[-73.78030905332182,40.79055000000001],[-73.77857700251424,40.79055000000001],[-73.77771097711046,40.78905000000001],[-73.77597892630288,40.78905000000001],[-73.7751129008991,40.78755000000001],[-73.77338085009153,40.78755000000001],[-73.77251482468775,40.78905000000001],[-73.77078277388017,40.78905000000001],[-73.76991674847639,40.78755000000001],[-73.77078277388017,40.78605000000001],[-73.77251482468775,40.78605000000001],[-73.77338085009153,40.78455000000001],[-73.77251482468775,40.78305000000001],[-73.77078277388017,40.78305000000001],[-73.76991674847639,40.78155000000001],[-73.76818469766881,40.78155000000001],[-73.76731867226503,40.78005000000001],[-73.76818469766881,40.77855000000001],[-73.76991674847639,40.77855000000001],[-73.77078277388017,40.78005000000001],[-73.77251482468775,40.78005000000001],[-73.77338085009153,40.77855000000001],[-73.7751129008991,40.77855000000001],[-73.77597892630288,40.78005000000001],[-73.77771097711046,40.78005000000001],[-73.77857700251424,40.77855000000001],[-73.78030905332182,40.77855000000001],[-73.7811750787256,40.77705000000001],[-73.78290712953317,40.77705000000001],[-73.78377315493695,40.77555000000001],[-73.78550520574453,40.77555000000001],[-73.78637123114831,40.77405000000001]]],"type":"Polygon"}},{"id":"5","properties":{"borough":"queens","borocode":4,"neighborhood":"Auburndale"},"type":"Feature","geometry":{"coordinates":[[[-73.77597892630288,40.74105000000001],[-73.77771097711046,40.74105000000001],[-73.77857700251424,40.74255000000001],[-73.78030905332182,40.74255000000001],[-73.7811750787256,40.74105000000001],[-73.78290712953317,40.74105000000001],[-73.78377315493695,40.73955000000001],[-73.78550520574453,40.73955000000001],[-73.78637123114831,40.74105000000001],[-73.78810328195588,40.74105000000001],[-73.78896930735966,40.73955000000001],[-73.79070135816724,40.73955000000001],[-73.79156738357102,40.73805000000001],[-73.7932994343786,40.73805000000001],[-73.79416545978238,40.73955000000001],[-73.79589751058995,40.73955000000001],[-73.79676353599373,40.74105000000001],[-73.79849558680131,40.74105000000001],[-73.79936161220509,40.74255000000001],[-73.79849558680131,40.74405000000001],[-73.79676353599373,40.74405000000001],[-73.79589751058995,40.74555000000001],[-73.79676353599373,40.74705000000001],[-73.79589751058995,40.74855000000001],[-73.79676353599373,40.75005000000001],[-73.79589751058995,40.75155000000001],[-73.79676353599373,40.75305000000001],[-73.79589751058995,40.75455000000001],[-73.79416545978238,40.75455000000001],[-73.7932994343786,40.75605000000001],[-73.79416545978238,40.75755000000001],[-73.7932994343786,40.75905000000001],[-73.79156738357102,40.75905000000001],[-73.79070135816724,40.76055000000001],[-73.79156738357102,40.76205000000001],[-73.7932994343786,40.76205000000001],[-73.79416545978238,40.76355000000001],[-73.7932994343786,40.76505000000001],[-73.79416545978238,40.76655000000001],[-73.7932994343786,40.76805000000001],[-73.79156738357102,40.76805000000001],[-73.79070135816724,40.76655000000001],[-73.78896930735966,40.76655000000001],[-73.78810328195588,40.76505000000001],[-73.78637123114831,40.76505000000001],[-73.78550520574453,40.76355000000001],[-73.78637123114831,40.76205000000001],[-73.78550520574453,40.76055000000001],[-73.78377315493695,40.76055000000001],[-73.78290712953317,40.75905000000001],[-73.78377315493695,40.75755000000001],[-73.78290712953317,40.75605000000001],[-73.7811750787256,40.75605000000001],[-73.78030905332182,40.75455000000001],[-73.7811750787256,40.75305000000001],[-73.78030905332182,40.75155000000001],[-73.77857700251424,40.75155000000001],[-73.77771097711046,40.75005000000001],[-73.77857700251424,40.74855000000001],[-73.77771097711046,40.74705000000001],[-73.77857700251424,40.74555000000001],[-73.77771097711046,40.74405000000001],[-73.77597892630288,40.74405000000001],[-73.7751129008991,40.74255000000001],[-73.77597892630288,40.74105000000001]]],"type":"Polygon"}},{"id":"68","properties":{"borough":"queens","borocode":4,"neighborhood":"Fresh Meadows-Utopia"},"type":"Feature","geometry":{"coordinates":[[[-73.77078277388017,40.72905000000001],[-73.77251482468775,40.72905000000001],[-73.77338085009153,40.73055000000001],[-73.7751129008991,40.73055000000001],[-73.77597892630288,40.72905000000001],[-73.77771097711046,40.72905000000001],[-73.77857700251424,40.73055000000001],[-73.78030905332182,40.73055000000001],[-73.7811750787256,40.72905000000001],[-73.78290712953317,40.72905000000001],[-73.78377315493695,40.72755000000001],[-73.78550520574453,40.72755000000001],[-73.78637123114831,40.72605000000001],[-73.78810328195588,40.72605000000001],[-73.78896930735966,40.72755000000001],[-73.79070135816724,40.72755000000001],[-73.79156738357102,40.72605000000001],[-73.7932994343786,40.72605000000001],[-73.79416545978238,40.72755000000001],[-73.7932994343786,40.72905000000001],[-73.79416545978238,40.73055000000001],[-73.7932994343786,40.73205000000001],[-73.79416545978238,40.73355000000001],[-73.79589751058995,40.73355000000001],[-73.79676353599373,40.73505000000001],[-73.79589751058995,40.73655000000001],[-73.79676353599373,40.73805000000001],[-73.79589751058995,40.73955000000001],[-73.79416545978238,40.73955000000001],[-73.7932994343786,40.73805000000001],[-73.79156738357102,40.73805000000001],[-73.79070135816724,40.73955000000001],[-73.78896930735966,40.73955000000001],[-73.78810328195588,40.74105000000001],[-73.78637123114831,40.74105000000001],[-73.78550520574453,40.73955000000001],[-73.78377315493695,40.73955000000001],[-73.78290712953317,40.74105000000001],[-73.7811750787256,40.74105000000001],[-73.78030905332182,40.74255000000001],[-73.77857700251424,40.74255000000001],[-73.77771097711046,40.74105000000001],[-73.77597892630288,40.74105000000001],[-73.7751129008991,40.74255000000001],[-73.77338085009153,40.74255000000001],[-73.77251482468775,40.74105000000001],[-73.77338085009153,40.73955000000001],[-73.77251482468775,40.73805000000001],[-73.77078277388017,40.73805000000001],[-73.76991674847639,40.73655000000001],[-73.77078277388017,40.73505000000001],[-73.76991674847639,40.73355000000001],[-73.77078277388017,40.73205000000001],[-73.76991674847639,40.73055000000001],[-73.77078277388017,40.72905000000001]]],"type":"Polygon"}},{"id":"89","properties":{"borough":"queens","borocode":4,"neighborhood":"Jamaica Estates-Holliswood"},"type":"Feature","geometry":{"coordinates":[[[-73.79156738357102,40.71105000000001],[-73.7932994343786,40.71105000000001],[-73.79416545978238,40.71255000000001],[-73.7932994343786,40.71405000000001],[-73.79416545978238,40.71555000000001],[-73.7932994343786,40.71705000000001],[-73.79156738357102,40.71705000000001],[-73.79070135816724,40.71855000000001],[-73.79156738357102,40.72005000000001],[-73.79070135816724,40.72155000000001],[-73.79156738357102,40.72305000000001],[-73.79070135816724,40.72455000000001],[-73.79156738357102,40.72605000000001],[-73.79070135816724,40.72755000000001],[-73.78896930735966,40.72755000000001],[-73.78810328195588,40.72605000000001],[-73.78637123114831,40.72605000000001],[-73.78550520574453,40.72755000000001],[-73.78377315493695,40.72755000000001],[-73.78290712953317,40.72905000000001],[-73.7811750787256,40.72905000000001],[-73.78030905332182,40.73055000000001],[-73.77857700251424,40.73055000000001],[-73.77771097711046,40.72905000000001],[-73.77597892630288,40.72905000000001],[-73.7751129008991,40.72755000000001],[-73.77338085009153,40.72755000000001],[-73.77251482468775,40.72605000000001],[-73.77078277388017,40.72605000000001],[-73.76991674847639,40.72755000000001],[-73.76818469766881,40.72755000000001],[-73.76731867226503,40.72605000000001],[-73.76558662145746,40.72605000000001],[-73.76472059605368,40.72755000000001],[-73.7629885452461,40.72755000000001],[-73.76212251984232,40.72605000000001],[-73.76039046903475,40.72605000000001],[-73.75952444363097,40.72755000000001],[-73.75779239282339,40.72755000000001],[-73.75692636741961,40.72605000000001],[-73.75519431661203,40.72605000000001],[-73.75432829120825,40.72455000000001],[-73.75519431661203,40.72305000000001],[-73.75432829120825,40.72155000000001],[-73.75519431661203,40.72005000000001],[-73.75692636741961,40.72005000000001],[-73.75779239282339,40.71855000000001],[-73.75952444363097,40.71855000000001],[-73.76039046903475,40.71705000000001],[-73.76212251984232,40.71705000000001],[-73.7629885452461,40.71855000000001],[-73.76472059605368,40.71855000000001],[-73.76558662145746,40.71705000000001],[-73.76731867226503,40.71705000000001],[-73.76818469766881,40.71555000000001],[-73.76991674847639,40.71555000000001],[-73.77078277388017,40.71705000000001],[-73.77251482468775,40.71705000000001],[-73.77338085009153,40.71555000000001],[-73.7751129008991,40.71555000000001],[-73.77597892630288,40.71405000000001],[-73.77771097711046,40.71405000000001],[-73.77857700251424,40.71255000000001],[-73.78030905332182,40.71255000000001],[-73.7811750787256,40.71405000000001],[-73.78290712953317,40.71405000000001],[-73.78377315493695,40.71255000000001],[-73.78550520574453,40.71255000000001],[-73.78637123114831,40.71405000000001],[-73.78810328195588,40.71405000000001],[-73.78896930735966,40.71255000000001],[-73.79070135816724,40.71255000000001],[-73.79156738357102,40.71105000000001]]],"type":"Polygon"}},{"id":"10","properties":{"borough":"queens","borocode":4,"neighborhood":"Bayside-Bayside Hills"},"type":"Feature","geometry":{"coordinates":[[[-73.7629885452461,40.74555000000001],[-73.76472059605368,40.74555000000001],[-73.76558662145746,40.74705000000001],[-73.76731867226503,40.74705000000001],[-73.76818469766881,40.74555000000001],[-73.76991674847639,40.74555000000001],[-73.77078277388017,40.74405000000001],[-73.77251482468775,40.74405000000001],[-73.77338085009153,40.74255000000001],[-73.7751129008991,40.74255000000001],[-73.77597892630288,40.74405000000001],[-73.77771097711046,40.74405000000001],[-73.77857700251424,40.74555000000001],[-73.77771097711046,40.74705000000001],[-73.77857700251424,40.74855000000001],[-73.77771097711046,40.75005000000001],[-73.77857700251424,40.75155000000001],[-73.78030905332182,40.75155000000001],[-73.7811750787256,40.75305000000001],[-73.78030905332182,40.75455000000001],[-73.7811750787256,40.75605000000001],[-73.78290712953317,40.75605000000001],[-73.78377315493695,40.75755000000001],[-73.78290712953317,40.75905000000001],[-73.78377315493695,40.76055000000001],[-73.78550520574453,40.76055000000001],[-73.78637123114831,40.76205000000001],[-73.78550520574453,40.76355000000001],[-73.78637123114831,40.76505000000001],[-73.78810328195588,40.76505000000001],[-73.78896930735966,40.76655000000001],[-73.79070135816724,40.76655000000001],[-73.79156738357102,40.76805000000001],[-73.7932994343786,40.76805000000001],[-73.79416545978238,40.76955000000001],[-73.7932994343786,40.77105000000001],[-73.79416545978238,40.77255000000001],[-73.7932994343786,40.77405000000001],[-73.79156738357102,40.77405000000001],[-73.79070135816724,40.77555000000001],[-73.78896930735966,40.77555000000001],[-73.78810328195588,40.77405000000001],[-73.78637123114831,40.77405000000001],[-73.78550520574453,40.77555000000001],[-73.78377315493695,40.77555000000001],[-73.78290712953317,40.77705000000001],[-73.7811750787256,40.77705000000001],[-73.78030905332182,40.77855000000001],[-73.77857700251424,40.77855000000001],[-73.77771097711046,40.78005000000001],[-73.77597892630288,40.78005000000001],[-73.7751129008991,40.77855000000001],[-73.77338085009153,40.77855000000001],[-73.77251482468775,40.78005000000001],[-73.77078277388017,40.78005000000001],[-73.76991674847639,40.77855000000001],[-73.76818469766881,40.77855000000001],[-73.76731867226503,40.77705000000001],[-73.76558662145746,40.77705000000001],[-73.76472059605368,40.77555000000001],[-73.76558662145746,40.77405000000001],[-73.76472059605368,40.77255000000001],[-73.7629885452461,40.77255000000001],[-73.76212251984232,40.77105000000001],[-73.76039046903475,40.77105000000001],[-73.75952444363097,40.76955000000001],[-73.75779239282339,40.76955000000001],[-73.75692636741961,40.76805000000001],[-73.75779239282339,40.76655000000001],[-73.75692636741961,40.76505000000001],[-73.75779239282339,40.76355000000001],[-73.75692636741961,40.76205000000001],[-73.75779239282339,40.76055000000001],[-73.75952444363097,40.76055000000001],[-73.76039046903475,40.75905000000001],[-73.75952444363097,40.75755000000001],[-73.76039046903475,40.75605000000001],[-73.75952444363097,40.75455000000001],[-73.75779239282339,40.75455000000001],[-73.75692636741961,40.75305000000001],[-73.75779239282339,40.75155000000001],[-73.75692636741961,40.75005000000001],[-73.75779239282339,40.74855000000001],[-73.75952444363097,40.74855000000001],[-73.76039046903475,40.74705000000001],[-73.76212251984232,40.74705000000001],[-73.7629885452461,40.74555000000001]]],"type":"Polygon"}},{"id":"154","properties":{"borough":"queens","borocode":4,"neighborhood":"Springfield Gardens North"},"type":"Feature","geometry":{"coordinates":[[[-73.78637123114831,40.666050000000006],[-73.78810328195588,40.666050000000006],[-73.78896930735966,40.667550000000006],[-73.78810328195588,40.669050000000006],[-73.78637123114831,40.669050000000006],[-73.78550520574453,40.670550000000006],[-73.78637123114831,40.672050000000006],[-73.78550520574453,40.673550000000006],[-73.78637123114831,40.675050000000006],[-73.78550520574453,40.676550000000006],[-73.78377315493695,40.676550000000006],[-73.78290712953317,40.678050000000006],[-73.7811750787256,40.678050000000006],[-73.78030905332182,40.679550000000006],[-73.77857700251424,40.679550000000006],[-73.77771097711046,40.678050000000006],[-73.77597892630288,40.678050000000006],[-73.7751129008991,40.679550000000006],[-73.77338085009153,40.679550000000006],[-73.77251482468775,40.678050000000006],[-73.77078277388017,40.678050000000006],[-73.76991674847639,40.676550000000006],[-73.76818469766881,40.676550000000006],[-73.76731867226503,40.675050000000006],[-73.76558662145746,40.675050000000006],[-73.76472059605368,40.673550000000006],[-73.7629885452461,40.673550000000006],[-73.76212251984232,40.675050000000006],[-73.76039046903475,40.675050000000006],[-73.75952444363097,40.673550000000006],[-73.75779239282339,40.673550000000006],[-73.75692636741961,40.672050000000006],[-73.75779239282339,40.670550000000006],[-73.75692636741961,40.669050000000006],[-73.75779239282339,40.667550000000006],[-73.75952444363097,40.667550000000006],[-73.76039046903475,40.666050000000006],[-73.76212251984232,40.666050000000006],[-73.7629885452461,40.667550000000006],[-73.76472059605368,40.667550000000006],[-73.76558662145746,40.666050000000006],[-73.76731867226503,40.666050000000006],[-73.76818469766881,40.667550000000006],[-73.76991674847639,40.667550000000006],[-73.77078277388017,40.666050000000006],[-73.77251482468775,40.666050000000006],[-73.77338085009153,40.667550000000006],[-73.7751129008991,40.667550000000006],[-73.77597892630288,40.666050000000006],[-73.77771097711046,40.666050000000006],[-73.77857700251424,40.667550000000006],[-73.78030905332182,40.667550000000006],[-73.7811750787256,40.666050000000006],[-73.78290712953317,40.666050000000006],[-73.78377315493695,40.667550000000006],[-73.78550520574453,40.667550000000006],[-73.78637123114831,40.666050000000006]]],"type":"Polygon"}},{"id":"155","properties":{"borough":"queens","borocode":4,"neighborhood":"Springfield Gardens South-Brookville"},"type":"Feature","geometry":{"coordinates":[[[[-73.7629885452461,40.652550000000005],[-73.76472059605368,40.652550000000005],[-73.76558662145746,40.654050000000005],[-73.76731867226503,40.654050000000005],[-73.76818469766881,40.655550000000005],[-73.76991674847639,40.655550000000005],[-73.77078277388017,40.657050000000005],[-73.77251482468775,40.657050000000005],[-73.77338085009153,40.658550000000005],[-73.7751129008991,40.658550000000005],[-73.77597892630288,40.660050000000005],[-73.77771097711046,40.660050000000005],[-73.77857700251424,40.661550000000005],[-73.78030905332182,40.661550000000005],[-73.7811750787256,40.663050000000005],[-73.78290712953317,40.663050000000005],[-73.78377315493695,40.661550000000005],[-73.78550520574453,40.661550000000005],[-73.78637123114831,40.663050000000005],[-73.78810328195588,40.663050000000005],[-73.78896930735966,40.664550000000006],[-73.78810328195588,40.666050000000006],[-73.78637123114831,40.666050000000006],[-73.78550520574453,40.667550000000006],[-73.78377315493695,40.667550000000006],[-73.78290712953317,40.666050000000006],[-73.7811750787256,40.666050000000006],[-73.78030905332182,40.667550000000006],[-73.77857700251424,40.667550000000006],[-73.77771097711046,40.666050000000006],[-73.77597892630288,40.666050000000006],[-73.7751129008991,40.667550000000006],[-73.77338085009153,40.667550000000006],[-73.77251482468775,40.666050000000006],[-73.77078277388017,40.666050000000006],[-73.76991674847639,40.667550000000006],[-73.76818469766881,40.667550000000006],[-73.76731867226503,40.666050000000006],[-73.76558662145746,40.666050000000006],[-73.76472059605368,40.667550000000006],[-73.7629885452461,40.667550000000006],[-73.76212251984232,40.666050000000006],[-73.76039046903475,40.666050000000006],[-73.75952444363097,40.667550000000006],[-73.75779239282339,40.667550000000006],[-73.75692636741961,40.666050000000006],[-73.75519431661203,40.666050000000006],[-73.75432829120825,40.664550000000006],[-73.75259624040068,40.664550000000006],[-73.7517302149969,40.666050000000006],[-73.74999816418932,40.666050000000006],[-73.74913213878554,40.667550000000006],[-73.74740008797797,40.667550000000006],[-73.74653406257418,40.666050000000006],[-73.74480201176661,40.666050000000006],[-73.74393598636283,40.664550000000006],[-73.74220393555525,40.664550000000006],[-73.74133791015147,40.663050000000005],[-73.74220393555525,40.661550000000005],[-73.74393598636283,40.661550000000005],[-73.74480201176661,40.660050000000005],[-73.74653406257418,40.660050000000005],[-73.74740008797797,40.658550000000005],[-73.74653406257418,40.657050000000005],[-73.74480201176661,40.657050000000005],[-73.74393598636283,40.655550000000005],[-73.74480201176661,40.654050000000005],[-73.74393598636283,40.652550000000005],[-73.74480201176661,40.651050000000005],[-73.74653406257418,40.651050000000005],[-73.74740008797797,40.652550000000005],[-73.74913213878554,40.652550000000005],[-73.74999816418932,40.654050000000005],[-73.7517302149969,40.654050000000005],[-73.75259624040068,40.652550000000005],[-73.75432829120825,40.652550000000005],[-73.75519431661203,40.654050000000005],[-73.75692636741961,40.654050000000005],[-73.75779239282339,40.655550000000005],[-73.75952444363097,40.655550000000005],[-73.76039046903475,40.654050000000005],[-73.76212251984232,40.654050000000005],[-73.7629885452461,40.652550000000005]]],[[[-73.79156738357102,40.663050000000005],[-73.7932994343786,40.663050000000005],[-73.79416545978238,40.664550000000006],[-73.79589751058995,40.664550000000006],[-73.79676353599373,40.663050000000005],[-73.79849558680131,40.663050000000005],[-73.79936161220509,40.664550000000006],[-73.79849558680131,40.666050000000006],[-73.79676353599373,40.666050000000006],[-73.79589751058995,40.667550000000006],[-73.79416545978238,40.667550000000006],[-73.7932994343786,40.666050000000006],[-73.79156738357102,40.666050000000006],[-73.79070135816724,40.664550000000006],[-73.79156738357102,40.663050000000005]]]],"type":"MultiPolygon"}},{"id":"157","properties":{"borough":"queens","borocode":4,"neighborhood":"St. Albans"},"type":"Feature","geometry":{"coordinates":[[[-73.77857700251424,40.685550000000006],[-73.78030905332182,40.685550000000006],[-73.7811750787256,40.687050000000006],[-73.78290712953317,40.687050000000006],[-73.78377315493695,40.688550000000006],[-73.78290712953317,40.69005000000001],[-73.7811750787256,40.69005000000001],[-73.78030905332182,40.69155000000001],[-73.77857700251424,40.69155000000001],[-73.77771097711046,40.69305000000001],[-73.77857700251424,40.69455000000001],[-73.77771097711046,40.69605000000001],[-73.77597892630288,40.69605000000001],[-73.7751129008991,40.69755000000001],[-73.77597892630288,40.69905000000001],[-73.7751129008991,40.70055000000001],[-73.77597892630288,40.70205000000001],[-73.7751129008991,40.70355000000001],[-73.77597892630288,40.70505000000001],[-73.7751129008991,40.70655000000001],[-73.77597892630288,40.70805000000001],[-73.7751129008991,40.70955000000001],[-73.77338085009153,40.70955000000001],[-73.77251482468775,40.70805000000001],[-73.77078277388017,40.70805000000001],[-73.76991674847639,40.70955000000001],[-73.76818469766881,40.70955000000001],[-73.76731867226503,40.70805000000001],[-73.76818469766881,40.70655000000001],[-73.76731867226503,40.70505000000001],[-73.76558662145746,40.70505000000001],[-73.76472059605368,40.70355000000001],[-73.7629885452461,40.70355000000001],[-73.76212251984232,40.70205000000001],[-73.76039046903475,40.70205000000001],[-73.75952444363097,40.70355000000001],[-73.75779239282339,40.70355000000001],[-73.75692636741961,40.70505000000001],[-73.75519431661203,40.70505000000001],[-73.75432829120825,40.70655000000001],[-73.75259624040068,40.70655000000001],[-73.7517302149969,40.70505000000001],[-73.75259624040068,40.70355000000001],[-73.7517302149969,40.70205000000001],[-73.74999816418932,40.70205000000001],[-73.74913213878554,40.70055000000001],[-73.74999816418932,40.69905000000001],[-73.74913213878554,40.69755000000001],[-73.74740008797797,40.69755000000001],[-73.74653406257418,40.69605000000001],[-73.74480201176661,40.69605000000001],[-73.74393598636283,40.69455000000001],[-73.74480201176661,40.69305000000001],[-73.74653406257418,40.69305000000001],[-73.74740008797797,40.69155000000001],[-73.74653406257418,40.69005000000001],[-73.74740008797797,40.688550000000006],[-73.74653406257418,40.687050000000006],[-73.74740008797797,40.685550000000006],[-73.74913213878554,40.685550000000006],[-73.74999816418932,40.684050000000006],[-73.7517302149969,40.684050000000006],[-73.75259624040068,40.682550000000006],[-73.7517302149969,40.681050000000006],[-73.75259624040068,40.679550000000006],[-73.75432829120825,40.679550000000006],[-73.75519431661203,40.678050000000006],[-73.75692636741961,40.678050000000006],[-73.75779239282339,40.676550000000006],[-73.75952444363097,40.676550000000006],[-73.76039046903475,40.675050000000006],[-73.76212251984232,40.675050000000006],[-73.7629885452461,40.673550000000006],[-73.76472059605368,40.673550000000006],[-73.76558662145746,40.675050000000006],[-73.76731867226503,40.675050000000006],[-73.76818469766881,40.676550000000006],[-73.76991674847639,40.676550000000006],[-73.77078277388017,40.678050000000006],[-73.77251482468775,40.678050000000006],[-73.77338085009153,40.679550000000006],[-73.77251482468775,40.681050000000006],[-73.77338085009153,40.682550000000006],[-73.7751129008991,40.682550000000006],[-73.77597892630288,40.684050000000006],[-73.7751129008991,40.685550000000006],[-73.77597892630288,40.687050000000006],[-73.77771097711046,40.687050000000006],[-73.77857700251424,40.685550000000006]]],"type":"Polygon"}},{"id":"61","properties":{"borough":"queens","borocode":4,"neighborhood":"Far Rockaway-Bayswater"},"type":"Feature","geometry":{"coordinates":[[[-73.73700778313254,40.59255],[-73.73873983394012,40.59255],[-73.7396058593439,40.59405],[-73.74133791015147,40.59405],[-73.74220393555525,40.59255],[-73.74393598636283,40.59255],[-73.74480201176661,40.59405],[-73.74653406257418,40.59405],[-73.74740008797797,40.59255],[-73.74913213878554,40.59255],[-73.74999816418932,40.59105],[-73.7517302149969,40.59105],[-73.75259624040068,40.58955],[-73.75432829120825,40.58955],[-73.75519431661203,40.59105],[-73.75692636741961,40.59105],[-73.75779239282339,40.58955],[-73.75952444363097,40.58955],[-73.76039046903475,40.59105],[-73.76212251984232,40.59105],[-73.7629885452461,40.59255],[-73.76472059605368,40.59255],[-73.76558662145746,40.59405],[-73.76472059605368,40.59555],[-73.7629885452461,40.59555],[-73.76212251984232,40.59705],[-73.7629885452461,40.59855],[-73.76472059605368,40.59855],[-73.76558662145746,40.60005],[-73.76731867226503,40.60005],[-73.76818469766881,40.59855],[-73.76991674847639,40.59855],[-73.77078277388017,40.60005],[-73.76991674847639,40.60155],[-73.77078277388017,40.60305],[-73.77251482468775,40.60305],[-73.77338085009153,40.60455],[-73.77251482468775,40.60605],[-73.77078277388017,40.60605],[-73.76991674847639,40.60755],[-73.77078277388017,40.60905],[-73.77251482468775,40.60905],[-73.77338085009153,40.61055],[-73.7751129008991,40.61055],[-73.77597892630288,40.61205],[-73.7751129008991,40.613550000000004],[-73.77597892630288,40.615050000000004],[-73.7751129008991,40.616550000000004],[-73.77338085009153,40.616550000000004],[-73.77251482468775,40.615050000000004],[-73.77078277388017,40.615050000000004],[-73.76991674847639,40.616550000000004],[-73.76818469766881,40.616550000000004],[-73.76731867226503,40.615050000000004],[-73.76558662145746,40.615050000000004],[-73.76472059605368,40.613550000000004],[-73.7629885452461,40.613550000000004],[-73.76212251984232,40.61205],[-73.76039046903475,40.61205],[-73.75952444363097,40.61055],[-73.75779239282339,40.61055],[-73.75692636741961,40.61205],[-73.75519431661203,40.61205],[-73.75432829120825,40.61055],[-73.75259624040068,40.61055],[-73.7517302149969,40.61205],[-73.74999816418932,40.61205],[-73.74913213878554,40.613550000000004],[-73.74740008797797,40.613550000000004],[-73.74653406257418,40.61205],[-73.74480201176661,40.61205],[-73.74393598636283,40.61055],[-73.74220393555525,40.61055],[-73.74133791015147,40.60905],[-73.74220393555525,40.60755],[-73.74133791015147,40.60605],[-73.7396058593439,40.60605],[-73.73873983394012,40.60455],[-73.73700778313254,40.60455],[-73.73614175772876,40.60305],[-73.73700778313254,40.60155],[-73.73614175772876,40.60005],[-73.73700778313254,40.59855],[-73.73614175772876,40.59705],[-73.73700778313254,40.59555],[-73.73614175772876,40.59405],[-73.73700778313254,40.59255]]],"type":"Polygon"}},{"id":"82","properties":{"borough":"queens","borocode":4,"neighborhood":"Hollis"},"type":"Feature","geometry":{"coordinates":[[[-73.76039046903475,40.70205000000001],[-73.76212251984232,40.70205000000001],[-73.7629885452461,40.70355000000001],[-73.76472059605368,40.70355000000001],[-73.76558662145746,40.70505000000001],[-73.76731867226503,40.70505000000001],[-73.76818469766881,40.70655000000001],[-73.76731867226503,40.70805000000001],[-73.76818469766881,40.70955000000001],[-73.76991674847639,40.70955000000001],[-73.77078277388017,40.71105000000001],[-73.76991674847639,40.71255000000001],[-73.77078277388017,40.71405000000001],[-73.76991674847639,40.71555000000001],[-73.76818469766881,40.71555000000001],[-73.76731867226503,40.71705000000001],[-73.76558662145746,40.71705000000001],[-73.76472059605368,40.71855000000001],[-73.7629885452461,40.71855000000001],[-73.76212251984232,40.71705000000001],[-73.76039046903475,40.71705000000001],[-73.75952444363097,40.71855000000001],[-73.75779239282339,40.71855000000001],[-73.75692636741961,40.71705000000001],[-73.75519431661203,40.71705000000001],[-73.75432829120825,40.71555000000001],[-73.75519431661203,40.71405000000001],[-73.75432829120825,40.71255000000001],[-73.75259624040068,40.71255000000001],[-73.7517302149969,40.71105000000001],[-73.75259624040068,40.70955000000001],[-73.7517302149969,40.70805000000001],[-73.75259624040068,40.70655000000001],[-73.75432829120825,40.70655000000001],[-73.75519431661203,40.70505000000001],[-73.75692636741961,40.70505000000001],[-73.75779239282339,40.70355000000001],[-73.75952444363097,40.70355000000001],[-73.76039046903475,40.70205000000001]]],"type":"Polygon"}},{"id":"122","properties":{"borough":"queens","borocode":4,"neighborhood":"Oakland Gardens"},"type":"Feature","geometry":{"coordinates":[[[-73.75519431661203,40.72605000000001],[-73.75692636741961,40.72605000000001],[-73.75779239282339,40.72755000000001],[-73.75952444363097,40.72755000000001],[-73.76039046903475,40.72905000000001],[-73.76212251984232,40.72905000000001],[-73.7629885452461,40.73055000000001],[-73.76472059605368,40.73055000000001],[-73.76558662145746,40.73205000000001],[-73.76472059605368,40.73355000000001],[-73.76558662145746,40.73505000000001],[-73.76472059605368,40.73655000000001],[-73.76558662145746,40.73805000000001],[-73.76472059605368,40.73955000000001],[-73.76558662145746,40.74105000000001],[-73.76731867226503,40.74105000000001],[-73.76818469766881,40.74255000000001],[-73.76731867226503,40.74405000000001],[-73.76818469766881,40.74555000000001],[-73.76731867226503,40.74705000000001],[-73.76558662145746,40.74705000000001],[-73.76472059605368,40.74555000000001],[-73.7629885452461,40.74555000000001],[-73.76212251984232,40.74705000000001],[-73.76039046903475,40.74705000000001],[-73.75952444363097,40.74855000000001],[-73.75779239282339,40.74855000000001],[-73.75692636741961,40.75005000000001],[-73.75779239282339,40.75155000000001],[-73.75692636741961,40.75305000000001],[-73.75779239282339,40.75455000000001],[-73.75952444363097,40.75455000000001],[-73.76039046903475,40.75605000000001],[-73.75952444363097,40.75755000000001],[-73.76039046903475,40.75905000000001],[-73.75952444363097,40.76055000000001],[-73.75779239282339,40.76055000000001],[-73.75692636741961,40.75905000000001],[-73.75519431661203,40.75905000000001],[-73.75432829120825,40.76055000000001],[-73.75259624040068,40.76055000000001],[-73.7517302149969,40.76205000000001],[-73.74999816418932,40.76205000000001],[-73.74913213878554,40.76055000000001],[-73.74999816418932,40.75905000000001],[-73.74913213878554,40.75755000000001],[-73.74740008797797,40.75755000000001],[-73.74653406257418,40.75605000000001],[-73.74740008797797,40.75455000000001],[-73.74653406257418,40.75305000000001],[-73.74480201176661,40.75305000000001],[-73.74393598636283,40.75155000000001],[-73.74480201176661,40.75005000000001],[-73.74393598636283,40.74855000000001],[-73.74220393555525,40.74855000000001],[-73.74133791015147,40.74705000000001],[-73.74220393555525,40.74555000000001],[-73.74393598636283,40.74555000000001],[-73.74480201176661,40.74405000000001],[-73.74393598636283,40.74255000000001],[-73.74220393555525,40.74255000000001],[-73.74133791015147,40.74105000000001],[-73.74220393555525,40.73955000000001],[-73.74133791015147,40.73805000000001],[-73.74220393555525,40.73655000000001],[-73.74393598636283,40.73655000000001],[-73.74480201176661,40.73505000000001],[-73.74393598636283,40.73355000000001],[-73.74480201176661,40.73205000000001],[-73.74653406257418,40.73205000000001],[-73.74740008797797,40.73055000000001],[-73.74913213878554,40.73055000000001],[-73.74999816418932,40.72905000000001],[-73.7517302149969,40.72905000000001],[-73.75259624040068,40.72755000000001],[-73.75432829120825,40.72755000000001],[-73.75519431661203,40.72605000000001]]],"type":"Polygon"}},{"id":"94","properties":{"borough":"queens","borocode":4,"neighborhood":"Laurelton"},"type":"Feature","geometry":{"coordinates":[[[-73.74220393555525,40.664550000000006],[-73.74393598636283,40.664550000000006],[-73.74480201176661,40.666050000000006],[-73.74653406257418,40.666050000000006],[-73.74740008797797,40.667550000000006],[-73.74913213878554,40.667550000000006],[-73.74999816418932,40.666050000000006],[-73.7517302149969,40.666050000000006],[-73.75259624040068,40.664550000000006],[-73.75432829120825,40.664550000000006],[-73.75519431661203,40.666050000000006],[-73.75692636741961,40.666050000000006],[-73.75779239282339,40.667550000000006],[-73.75692636741961,40.669050000000006],[-73.75779239282339,40.670550000000006],[-73.75692636741961,40.672050000000006],[-73.75779239282339,40.673550000000006],[-73.75952444363097,40.673550000000006],[-73.76039046903475,40.675050000000006],[-73.75952444363097,40.676550000000006],[-73.75779239282339,40.676550000000006],[-73.75692636741961,40.678050000000006],[-73.75519431661203,40.678050000000006],[-73.75432829120825,40.679550000000006],[-73.75259624040068,40.679550000000006],[-73.7517302149969,40.681050000000006],[-73.75259624040068,40.682550000000006],[-73.7517302149969,40.684050000000006],[-73.74999816418932,40.684050000000006],[-73.74913213878554,40.685550000000006],[-73.74740008797797,40.685550000000006],[-73.74653406257418,40.687050000000006],[-73.74480201176661,40.687050000000006],[-73.74393598636283,40.685550000000006],[-73.74220393555525,40.685550000000006],[-73.74133791015147,40.687050000000006],[-73.7396058593439,40.687050000000006],[-73.73873983394012,40.685550000000006],[-73.73700778313254,40.685550000000006],[-73.73614175772876,40.684050000000006],[-73.73440970692118,40.684050000000006],[-73.7335436815174,40.685550000000006],[-73.73181163070983,40.685550000000006],[-73.73094560530605,40.684050000000006],[-73.72921355449847,40.684050000000006],[-73.72834752909469,40.685550000000006],[-73.72661547828712,40.685550000000006],[-73.72574945288333,40.684050000000006],[-73.72661547828712,40.682550000000006],[-73.72834752909469,40.682550000000006],[-73.72921355449847,40.681050000000006],[-73.72834752909469,40.679550000000006],[-73.72921355449847,40.678050000000006],[-73.73094560530605,40.678050000000006],[-73.73181163070983,40.676550000000006],[-73.7335436815174,40.676550000000006],[-73.73440970692118,40.675050000000006],[-73.7335436815174,40.673550000000006],[-73.73440970692118,40.672050000000006],[-73.73614175772876,40.672050000000006],[-73.73700778313254,40.670550000000006],[-73.73614175772876,40.669050000000006],[-73.73700778313254,40.667550000000006],[-73.73873983394012,40.667550000000006],[-73.7396058593439,40.666050000000006],[-73.74133791015147,40.666050000000006],[-73.74220393555525,40.664550000000006]]],"type":"Polygon"}},{"id":"137","properties":{"borough":"queens","borocode":4,"neighborhood":"Queens Village"},"type":"Feature","geometry":{"coordinates":[[[-73.72921355449847,40.70205000000001],[-73.73094560530605,40.70205000000001],[-73.73181163070983,40.70355000000001],[-73.7335436815174,40.70355000000001],[-73.73440970692118,40.70205000000001],[-73.73614175772876,40.70205000000001],[-73.73700778313254,40.70355000000001],[-73.73873983394012,40.70355000000001],[-73.7396058593439,40.70205000000001],[-73.74133791015147,40.70205000000001],[-73.74220393555525,40.70355000000001],[-73.74393598636283,40.70355000000001],[-73.74480201176661,40.70205000000001],[-73.74653406257418,40.70205000000001],[-73.74740008797797,40.70055000000001],[-73.74653406257418,40.69905000000001],[-73.74740008797797,40.69755000000001],[-73.74913213878554,40.69755000000001],[-73.74999816418932,40.69905000000001],[-73.74913213878554,40.70055000000001],[-73.74999816418932,40.70205000000001],[-73.7517302149969,40.70205000000001],[-73.75259624040068,40.70355000000001],[-73.7517302149969,40.70505000000001],[-73.75259624040068,40.70655000000001],[-73.7517302149969,40.70805000000001],[-73.75259624040068,40.70955000000001],[-73.7517302149969,40.71105000000001],[-73.75259624040068,40.71255000000001],[-73.75432829120825,40.71255000000001],[-73.75519431661203,40.71405000000001],[-73.75432829120825,40.71555000000001],[-73.75519431661203,40.71705000000001],[-73.75692636741961,40.71705000000001],[-73.75779239282339,40.71855000000001],[-73.75692636741961,40.72005000000001],[-73.75519431661203,40.72005000000001],[-73.75432829120825,40.72155000000001],[-73.75519431661203,40.72305000000001],[-73.75432829120825,40.72455000000001],[-73.75519431661203,40.72605000000001],[-73.75432829120825,40.72755000000001],[-73.75259624040068,40.72755000000001],[-73.7517302149969,40.72905000000001],[-73.74999816418932,40.72905000000001],[-73.74913213878554,40.73055000000001],[-73.74740008797797,40.73055000000001],[-73.74653406257418,40.73205000000001],[-73.74480201176661,40.73205000000001],[-73.74393598636283,40.73055000000001],[-73.74220393555525,40.73055000000001],[-73.74133791015147,40.72905000000001],[-73.7396058593439,40.72905000000001],[-73.73873983394012,40.72755000000001],[-73.73700778313254,40.72755000000001],[-73.73614175772876,40.72905000000001],[-73.73440970692118,40.72905000000001],[-73.7335436815174,40.72755000000001],[-73.73181163070983,40.72755000000001],[-73.73094560530605,40.72605000000001],[-73.73181163070983,40.72455000000001],[-73.73094560530605,40.72305000000001],[-73.72921355449847,40.72305000000001],[-73.72834752909469,40.72155000000001],[-73.72921355449847,40.72005000000001],[-73.72834752909469,40.71855000000001],[-73.72661547828712,40.71855000000001],[-73.72574945288333,40.71705000000001],[-73.72661547828712,40.71555000000001],[-73.72574945288333,40.71405000000001],[-73.72661547828712,40.71255000000001],[-73.72574945288333,40.71105000000001],[-73.72661547828712,40.70955000000001],[-73.72574945288333,40.70805000000001],[-73.72661547828712,40.70655000000001],[-73.72574945288333,40.70505000000001],[-73.72661547828712,40.70355000000001],[-73.72834752909469,40.70355000000001],[-73.72921355449847,40.70205000000001]]],"type":"Polygon"}},{"id":"44","properties":{"borough":"queens","borocode":4,"neighborhood":"Douglas Manor-Douglaston-Little Neck"},"type":"Feature","geometry":{"coordinates":[[[-73.73181163070983,40.74255000000001],[-73.7335436815174,40.74255000000001],[-73.73440970692118,40.74405000000001],[-73.73614175772876,40.74405000000001],[-73.73700778313254,40.74555000000001],[-73.73873983394012,40.74555000000001],[-73.7396058593439,40.74705000000001],[-73.73873983394012,40.74855000000001],[-73.7396058593439,40.75005000000001],[-73.74133791015147,40.75005000000001],[-73.74220393555525,40.75155000000001],[-73.74393598636283,40.75155000000001],[-73.74480201176661,40.75305000000001],[-73.74393598636283,40.75455000000001],[-73.74220393555525,40.75455000000001],[-73.74133791015147,40.75605000000001],[-73.74220393555525,40.75755000000001],[-73.74393598636283,40.75755000000001],[-73.74480201176661,40.75905000000001],[-73.74653406257418,40.75905000000001],[-73.74740008797797,40.76055000000001],[-73.74913213878554,40.76055000000001],[-73.74999816418932,40.76205000000001],[-73.7517302149969,40.76205000000001],[-73.75259624040068,40.76355000000001],[-73.7517302149969,40.76505000000001],[-73.75259624040068,40.76655000000001],[-73.75432829120825,40.76655000000001],[-73.75519431661203,40.76805000000001],[-73.75692636741961,40.76805000000001],[-73.75779239282339,40.76955000000001],[-73.75692636741961,40.77105000000001],[-73.75779239282339,40.77255000000001],[-73.75692636741961,40.77405000000001],[-73.75519431661203,40.77405000000001],[-73.75432829120825,40.77555000000001],[-73.75519431661203,40.77705000000001],[-73.75432829120825,40.77855000000001],[-73.75519431661203,40.78005000000001],[-73.75432829120825,40.78155000000001],[-73.75259624040068,40.78155000000001],[-73.7517302149969,40.78305000000001],[-73.74999816418932,40.78305000000001],[-73.74913213878554,40.78155000000001],[-73.74740008797797,40.78155000000001],[-73.74653406257418,40.78005000000001],[-73.74480201176661,40.78005000000001],[-73.74393598636283,40.77855000000001],[-73.74220393555525,40.77855000000001],[-73.74133791015147,40.77705000000001],[-73.7396058593439,40.77705000000001],[-73.73873983394012,40.77555000000001],[-73.73700778313254,40.77555000000001],[-73.73614175772876,40.77405000000001],[-73.73440970692118,40.77405000000001],[-73.7335436815174,40.77255000000001],[-73.73181163070983,40.77255000000001],[-73.73094560530605,40.77105000000001],[-73.72921355449847,40.77105000000001],[-73.72834752909469,40.76955000000001],[-73.72661547828712,40.76955000000001],[-73.72574945288333,40.76805000000001],[-73.72401740207576,40.76805000000001],[-73.72315137667198,40.76655000000001],[-73.7214193258644,40.76655000000001],[-73.72055330046062,40.76505000000001],[-73.71882124965305,40.76505000000001],[-73.71795522424927,40.76355000000001],[-73.71622317344169,40.76355000000001],[-73.71535714803791,40.76205000000001],[-73.71362509723033,40.76205000000001],[-73.71275907182655,40.76055000000001],[-73.71362509723033,40.75905000000001],[-73.71535714803791,40.75905000000001],[-73.71622317344169,40.75755000000001],[-73.71795522424927,40.75755000000001],[-73.71882124965305,40.75605000000001],[-73.72055330046062,40.75605000000001],[-73.7214193258644,40.75455000000001],[-73.72315137667198,40.75455000000001],[-73.72401740207576,40.75305000000001],[-73.72574945288333,40.75305000000001],[-73.72661547828712,40.75155000000001],[-73.72574945288333,40.75005000000001],[-73.72661547828712,40.74855000000001],[-73.72834752909469,40.74855000000001],[-73.72921355449847,40.74705000000001],[-73.72834752909469,40.74555000000001],[-73.72921355449847,40.74405000000001],[-73.73094560530605,40.74405000000001],[-73.73181163070983,40.74255000000001]]],"type":"Polygon"}},{"id":"143","properties":{"borough":"queens","borocode":4,"neighborhood":"Rosedale"},"type":"Feature","geometry":{"coordinates":[[[[-73.7396058593439,40.633050000000004],[-73.74133791015147,40.633050000000004],[-73.74220393555525,40.634550000000004],[-73.74393598636283,40.634550000000004],[-73.74480201176661,40.636050000000004],[-73.74653406257418,40.636050000000004],[-73.74740008797797,40.637550000000005],[-73.74653406257418,40.639050000000005],[-73.74480201176661,40.639050000000005],[-73.74393598636283,40.640550000000005],[-73.74480201176661,40.642050000000005],[-73.74653406257418,40.642050000000005],[-73.74740008797797,40.643550000000005],[-73.74653406257418,40.645050000000005],[-73.74740008797797,40.646550000000005],[-73.74653406257418,40.648050000000005],[-73.74740008797797,40.649550000000005],[-73.74653406257418,40.651050000000005],[-73.74480201176661,40.651050000000005],[-73.74393598636283,40.652550000000005],[-73.74480201176661,40.654050000000005],[-73.74393598636283,40.655550000000005],[-73.74480201176661,40.657050000000005],[-73.74653406257418,40.657050000000005],[-73.74740008797797,40.658550000000005],[-73.74653406257418,40.660050000000005],[-73.74480201176661,40.660050000000005],[-73.74393598636283,40.661550000000005],[-73.74220393555525,40.661550000000005],[-73.74133791015147,40.663050000000005],[-73.74220393555525,40.664550000000006],[-73.74133791015147,40.666050000000006],[-73.7396058593439,40.666050000000006],[-73.73873983394012,40.667550000000006],[-73.73700778313254,40.667550000000006],[-73.73614175772876,40.669050000000006],[-73.73700778313254,40.670550000000006],[-73.73614175772876,40.672050000000006],[-73.73440970692118,40.672050000000006],[-73.7335436815174,40.673550000000006],[-73.73440970692118,40.675050000000006],[-73.7335436815174,40.676550000000006],[-73.73181163070983,40.676550000000006],[-73.73094560530605,40.678050000000006],[-73.72921355449847,40.678050000000006],[-73.72834752909469,40.679550000000006],[-73.72921355449847,40.681050000000006],[-73.72834752909469,40.682550000000006],[-73.72661547828712,40.682550000000006],[-73.72574945288333,40.684050000000006],[-73.72401740207576,40.684050000000006],[-73.72315137667198,40.682550000000006],[-73.72401740207576,40.681050000000006],[-73.72315137667198,40.679550000000006],[-73.72401740207576,40.678050000000006],[-73.72574945288333,40.678050000000006],[-73.72661547828712,40.676550000000006],[-73.72574945288333,40.675050000000006],[-73.72661547828712,40.673550000000006],[-73.72574945288333,40.672050000000006],[-73.72661547828712,40.670550000000006],[-73.72574945288333,40.669050000000006],[-73.72661547828712,40.667550000000006],[-73.72574945288333,40.666050000000006],[-73.72661547828712,40.664550000000006],[-73.72574945288333,40.663050000000005],[-73.72661547828712,40.661550000000005],[-73.72574945288333,40.660050000000005],[-73.72401740207576,40.660050000000005],[-73.72315137667198,40.658550000000005],[-73.72401740207576,40.657050000000005],[-73.72315137667198,40.655550000000005],[-73.72401740207576,40.654050000000005],[-73.72315137667198,40.652550000000005],[-73.72401740207576,40.651050000000005],[-73.72574945288333,40.651050000000005],[-73.72661547828712,40.649550000000005],[-73.72834752909469,40.649550000000005],[-73.72921355449847,40.648050000000005],[-73.73094560530605,40.648050000000005],[-73.73181163070983,40.649550000000005],[-73.7335436815174,40.649550000000005],[-73.73440970692118,40.648050000000005],[-73.73614175772876,40.648050000000005],[-73.73700778313254,40.646550000000005],[-73.73873983394012,40.646550000000005],[-73.7396058593439,40.645050000000005],[-73.73873983394012,40.643550000000005],[-73.7396058593439,40.642050000000005],[-73.74133791015147,40.642050000000005],[-73.74220393555525,40.640550000000005],[-73.74133791015147,40.639050000000005],[-73.7396058593439,40.639050000000005],[-73.73873983394012,40.637550000000005],[-73.7396058593439,40.636050000000004],[-73.73873983394012,40.634550000000004],[-73.7396058593439,40.633050000000004]]],[[[-73.75432829120825,40.646550000000005],[-73.75519431661203,40.648050000000005],[-73.75692636741961,40.648050000000005],[-73.75779239282339,40.649550000000005],[-73.75952444363097,40.649550000000005],[-73.76039046903475,40.651050000000005],[-73.75952444363097,40.652550000000005],[-73.76039046903475,40.654050000000005],[-73.75952444363097,40.655550000000005],[-73.75779239282339,40.655550000000005],[-73.75692636741961,40.654050000000005],[-73.75519431661203,40.654050000000005],[-73.75432829120825,40.652550000000005],[-73.75259624040068,40.652550000000005],[-73.7517302149969,40.651050000000005],[-73.75259624040068,40.649550000000005],[-73.7517302149969,40.648050000000005],[-73.75259624040068,40.646550000000005],[-73.75432829120825,40.646550000000005]]]],"type":"MultiPolygon"}},{"id":"26","properties":{"borough":"queens","borocode":4,"neighborhood":"Cambria Heights"},"type":"Feature","geometry":{"coordinates":[[[-73.74220393555525,40.685550000000006],[-73.74393598636283,40.685550000000006],[-73.74480201176661,40.687050000000006],[-73.74653406257418,40.687050000000006],[-73.74740008797797,40.688550000000006],[-73.74653406257418,40.69005000000001],[-73.74740008797797,40.69155000000001],[-73.74653406257418,40.69305000000001],[-73.74480201176661,40.69305000000001],[-73.74393598636283,40.69455000000001],[-73.74480201176661,40.69605000000001],[-73.74653406257418,40.69605000000001],[-73.74740008797797,40.69755000000001],[-73.74653406257418,40.69905000000001],[-73.74740008797797,40.70055000000001],[-73.74653406257418,40.70205000000001],[-73.74480201176661,40.70205000000001],[-73.74393598636283,40.70355000000001],[-73.74220393555525,40.70355000000001],[-73.74133791015147,40.70205000000001],[-73.7396058593439,40.70205000000001],[-73.73873983394012,40.70355000000001],[-73.73700778313254,40.70355000000001],[-73.73614175772876,40.70205000000001],[-73.73440970692118,40.70205000000001],[-73.7335436815174,40.70355000000001],[-73.73181163070983,40.70355000000001],[-73.73094560530605,40.70205000000001],[-73.72921355449847,40.70205000000001],[-73.72834752909469,40.70355000000001],[-73.72661547828712,40.70355000000001],[-73.72574945288333,40.70205000000001],[-73.72661547828712,40.70055000000001],[-73.72574945288333,40.69905000000001],[-73.72661547828712,40.69755000000001],[-73.72574945288333,40.69605000000001],[-73.72661547828712,40.69455000000001],[-73.72574945288333,40.69305000000001],[-73.72661547828712,40.69155000000001],[-73.72574945288333,40.69005000000001],[-73.72661547828712,40.688550000000006],[-73.72574945288333,40.687050000000006],[-73.72661547828712,40.685550000000006],[-73.72834752909469,40.685550000000006],[-73.72921355449847,40.684050000000006],[-73.73094560530605,40.684050000000006],[-73.73181163070983,40.685550000000006],[-73.7335436815174,40.685550000000006],[-73.73440970692118,40.684050000000006],[-73.73614175772876,40.684050000000006],[-73.73700778313254,40.685550000000006],[-73.73873983394012,40.685550000000006],[-73.7396058593439,40.687050000000006],[-73.74133791015147,40.687050000000006],[-73.74220393555525,40.685550000000006]]],"type":"Polygon"}},{"id":"13","properties":{"borough":"queens","borocode":4,"neighborhood":"Bellerose"},"type":"Feature","geometry":{"coordinates":[[[-73.71102702101898,40.72455000000001],[-73.71275907182655,40.72455000000001],[-73.71362509723033,40.72605000000001],[-73.71535714803791,40.72605000000001],[-73.71622317344169,40.72455000000001],[-73.71795522424927,40.72455000000001],[-73.71882124965305,40.72305000000001],[-73.72055330046062,40.72305000000001],[-73.7214193258644,40.72455000000001],[-73.72315137667198,40.72455000000001],[-73.72401740207576,40.72305000000001],[-73.72574945288333,40.72305000000001],[-73.72661547828712,40.72155000000001],[-73.72834752909469,40.72155000000001],[-73.72921355449847,40.72305000000001],[-73.73094560530605,40.72305000000001],[-73.73181163070983,40.72455000000001],[-73.73094560530605,40.72605000000001],[-73.73181163070983,40.72755000000001],[-73.7335436815174,40.72755000000001],[-73.73440970692118,40.72905000000001],[-73.73614175772876,40.72905000000001],[-73.73700778313254,40.72755000000001],[-73.73873983394012,40.72755000000001],[-73.7396058593439,40.72905000000001],[-73.74133791015147,40.72905000000001],[-73.74220393555525,40.73055000000001],[-73.74393598636283,40.73055000000001],[-73.74480201176661,40.73205000000001],[-73.74393598636283,40.73355000000001],[-73.74480201176661,40.73505000000001],[-73.74393598636283,40.73655000000001],[-73.74220393555525,40.73655000000001],[-73.74133791015147,40.73805000000001],[-73.7396058593439,40.73805000000001],[-73.73873983394012,40.73955000000001],[-73.7396058593439,40.74105000000001],[-73.73873983394012,40.74255000000001],[-73.73700778313254,40.74255000000001],[-73.73614175772876,40.74405000000001],[-73.73440970692118,40.74405000000001],[-73.7335436815174,40.74255000000001],[-73.73181163070983,40.74255000000001],[-73.73094560530605,40.74405000000001],[-73.72921355449847,40.74405000000001],[-73.72834752909469,40.74555000000001],[-73.72921355449847,40.74705000000001],[-73.72834752909469,40.74855000000001],[-73.72661547828712,40.74855000000001],[-73.72574945288333,40.74705000000001],[-73.72401740207576,40.74705000000001],[-73.72315137667198,40.74855000000001],[-73.7214193258644,40.74855000000001],[-73.72055330046062,40.74705000000001],[-73.71882124965305,40.74705000000001],[-73.71795522424927,40.74555000000001],[-73.71882124965305,40.74405000000001],[-73.71795522424927,40.74255000000001],[-73.71622317344169,40.74255000000001],[-73.71535714803791,40.74105000000001],[-73.71622317344169,40.73955000000001],[-73.71535714803791,40.73805000000001],[-73.71362509723033,40.73805000000001],[-73.71275907182655,40.73655000000001],[-73.71362509723033,40.73505000000001],[-73.71275907182655,40.73355000000001],[-73.71102702101898,40.73355000000001],[-73.7101609956152,40.73205000000001],[-73.71102702101898,40.73055000000001],[-73.7101609956152,40.72905000000001],[-73.71102702101898,40.72755000000001],[-73.7101609956152,40.72605000000001],[-73.71102702101898,40.72455000000001]]],"type":"Polygon"}},{"id":"71","properties":{"borough":"queens","borocode":4,"neighborhood":"Glen Oaks-Floral Park-New Hyde Park"},"type":"Feature","geometry":{"coordinates":[[[-73.70842894480762,40.72605000000001],[-73.7101609956152,40.72605000000001],[-73.71102702101898,40.72755000000001],[-73.7101609956152,40.72905000000001],[-73.71102702101898,40.73055000000001],[-73.7101609956152,40.73205000000001],[-73.71102702101898,40.73355000000001],[-73.71275907182655,40.73355000000001],[-73.71362509723033,40.73505000000001],[-73.71275907182655,40.73655000000001],[-73.71362509723033,40.73805000000001],[-73.71535714803791,40.73805000000001],[-73.71622317344169,40.73955000000001],[-73.71535714803791,40.74105000000001],[-73.71622317344169,40.74255000000001],[-73.71795522424927,40.74255000000001],[-73.71882124965305,40.74405000000001],[-73.71795522424927,40.74555000000001],[-73.71882124965305,40.74705000000001],[-73.72055330046062,40.74705000000001],[-73.7214193258644,40.74855000000001],[-73.72315137667198,40.74855000000001],[-73.72401740207576,40.75005000000001],[-73.72574945288333,40.75005000000001],[-73.72661547828712,40.75155000000001],[-73.72574945288333,40.75305000000001],[-73.72401740207576,40.75305000000001],[-73.72315137667198,40.75455000000001],[-73.7214193258644,40.75455000000001],[-73.72055330046062,40.75605000000001],[-73.71882124965305,40.75605000000001],[-73.71795522424927,40.75755000000001],[-73.71622317344169,40.75755000000001],[-73.71535714803791,40.75605000000001],[-73.71362509723033,40.75605000000001],[-73.71275907182655,40.75455000000001],[-73.71102702101898,40.75455000000001],[-73.7101609956152,40.75605000000001],[-73.70842894480762,40.75605000000001],[-73.70756291940384,40.75455000000001],[-73.70583086859627,40.75455000000001],[-73.70496484319249,40.75605000000001],[-73.70323279238491,40.75605000000001],[-73.70236676698113,40.75455000000001],[-73.70063471617355,40.75455000000001],[-73.69976869076977,40.75305000000001],[-73.70063471617355,40.75155000000001],[-73.69976869076977,40.75005000000001],[-73.70063471617355,40.74855000000001],[-73.69976869076977,40.74705000000001],[-73.70063471617355,40.74555000000001],[-73.69976869076977,40.74405000000001],[-73.70063471617355,40.74255000000001],[-73.69976869076977,40.74105000000001],[-73.6980366399622,40.74105000000001],[-73.69717061455842,40.73955000000001],[-73.6980366399622,40.73805000000001],[-73.69976869076977,40.73805000000001],[-73.70063471617355,40.73655000000001],[-73.69976869076977,40.73505000000001],[-73.70063471617355,40.73355000000001],[-73.70236676698113,40.73355000000001],[-73.70323279238491,40.73205000000001],[-73.70496484319249,40.73205000000001],[-73.70583086859627,40.73055000000001],[-73.70496484319249,40.72905000000001],[-73.70583086859627,40.72755000000001],[-73.70756291940384,40.72755000000001],[-73.70842894480762,40.72605000000001]]],"type":"Polygon"}}]};exports.default=Neighborhoods;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(338);


/***/ },
/* 328 */
/***/ function(module, exports) {

	'use strict'
	
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	function init () {
	  var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	  for (var i = 0, len = code.length; i < len; ++i) {
	    lookup[i] = code[i]
	    revLookup[code.charCodeAt(i)] = i
	  }
	
	  revLookup['-'.charCodeAt(0)] = 62
	  revLookup['_'.charCodeAt(0)] = 63
	}
	
	init()
	
	function toByteArray (b64) {
	  var i, j, l, tmp, placeHolders, arr
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	
	  // base64 is 4/3 + up to two characters of the original data
	  arr = new Arr(len * 3 / 4 - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0, j = 0; i < l; i += 4, j += 3) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ },
/* 329 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 330 */
329,
/* 331 */
329,
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mode-toggle-small.38e0e770.gif";

/***/ },
/* 333 */
102,
/* 334 */
56,
/* 335 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(141);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(141);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(339);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(85)))

/***/ },
/* 340 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 341 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 342 */
66,
/* 343 */
[367, 31],
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(343);
	var ReactElement = __webpack_require__(30);
	
	var emptyFunction = __webpack_require__(11);
	var traverseAllChildren = __webpack_require__(352);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(31),
	    _assign = __webpack_require__(5);
	
	var ReactComponent = __webpack_require__(86);
	var ReactElement = __webpack_require__(30);
	var ReactPropTypeLocationNames = __webpack_require__(144);
	var ReactNoopUpdateQueue = __webpack_require__(87);
	
	var emptyObject = __webpack_require__(32);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(30);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(30);
	var ReactPropTypeLocationNames = __webpack_require__(144);
	var ReactPropTypesSecret = __webpack_require__(348);
	
	var emptyFunction = __webpack_require__(11);
	var getIteratorFn = __webpack_require__(146);
	var warning = __webpack_require__(3);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        if (props[propName] === null) {
	          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	        }
	        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 348 */
236,
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var ReactComponent = __webpack_require__(86);
	var ReactNoopUpdateQueue = __webpack_require__(87);
	
	var emptyObject = __webpack_require__(32);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 350 */
241,
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(31);
	
	var ReactElement = __webpack_require__(30);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(31);
	
	var ReactCurrentOwner = __webpack_require__(17);
	var REACT_ELEMENT_TYPE = __webpack_require__(143);
	
	var getIteratorFn = __webpack_require__(146);
	var invariant = __webpack_require__(2);
	var KeyEscapeUtils = __webpack_require__(342);
	var warning = __webpack_require__(3);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(148);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 354 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(149);
	
	var _isPlainObject = __webpack_require__(57);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(150);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  if (false) {
	    var unexpectedKeyCache = {};
	  }
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {"use strict"
	// Module export pattern from
	// https://github.com/umdjs/umd/blob/master/returnExports.js
	;(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.store = factory();
	  }
	}(this, function () {
		
		// Store.js
		var store = {},
			win = (typeof window != 'undefined' ? window : global),
			doc = win.document,
			localStorageName = 'localStorage',
			scriptTag = 'script',
			storage
	
		store.disabled = false
		store.version = '1.3.20'
		store.set = function(key, value) {}
		store.get = function(key, defaultVal) {}
		store.has = function(key) { return store.get(key) !== undefined }
		store.remove = function(key) {}
		store.clear = function() {}
		store.transact = function(key, defaultVal, transactionFn) {
			if (transactionFn == null) {
				transactionFn = defaultVal
				defaultVal = null
			}
			if (defaultVal == null) {
				defaultVal = {}
			}
			var val = store.get(key, defaultVal)
			transactionFn(val)
			store.set(key, val)
		}
		store.getAll = function() {}
		store.forEach = function() {}
	
		store.serialize = function(value) {
			return JSON.stringify(value)
		}
		store.deserialize = function(value) {
			if (typeof value != 'string') { return undefined }
			try { return JSON.parse(value) }
			catch(e) { return value || undefined }
		}
	
		// Functions to encapsulate questionable FireFox 3.6.13 behavior
		// when about.config::dom.storage.enabled === false
		// See https://github.com/marcuswestin/store.js/issues#issue/13
		function isLocalStorageNameSupported() {
			try { return (localStorageName in win && win[localStorageName]) }
			catch(err) { return false }
		}
	
		if (isLocalStorageNameSupported()) {
			storage = win[localStorageName]
			store.set = function(key, val) {
				if (val === undefined) { return store.remove(key) }
				storage.setItem(key, store.serialize(val))
				return val
			}
			store.get = function(key, defaultVal) {
				var val = store.deserialize(storage.getItem(key))
				return (val === undefined ? defaultVal : val)
			}
			store.remove = function(key) { storage.removeItem(key) }
			store.clear = function() { storage.clear() }
			store.getAll = function() {
				var ret = {}
				store.forEach(function(key, val) {
					ret[key] = val
				})
				return ret
			}
			store.forEach = function(callback) {
				for (var i=0; i<storage.length; i++) {
					var key = storage.key(i)
					callback(key, store.get(key))
				}
			}
		} else if (doc && doc.documentElement.addBehavior) {
			var storageOwner,
				storageContainer
			// Since #userData storage applies only to specific paths, we need to
			// somehow link our data to a specific path.  We choose /favicon.ico
			// as a pretty safe option, since all browsers already make a request to
			// this URL anyway and being a 404 will not hurt us here.  We wrap an
			// iframe pointing to the favicon in an ActiveXObject(htmlfile) object
			// (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
			// since the iframe access rules appear to allow direct access and
			// manipulation of the document element, even for a 404 page.  This
			// document can be used instead of the current document (which would
			// have been limited to the current path) to perform #userData storage.
			try {
				storageContainer = new ActiveXObject('htmlfile')
				storageContainer.open()
				storageContainer.write('<'+scriptTag+'>document.w=window</'+scriptTag+'><iframe src="/favicon.ico"></iframe>')
				storageContainer.close()
				storageOwner = storageContainer.w.frames[0].document
				storage = storageOwner.createElement('div')
			} catch(e) {
				// somehow ActiveXObject instantiation failed (perhaps some special
				// security settings or otherwse), fall back to per-path storage
				storage = doc.createElement('div')
				storageOwner = doc.body
			}
			var withIEStorage = function(storeFunction) {
				return function() {
					var args = Array.prototype.slice.call(arguments, 0)
					args.unshift(storage)
					// See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
					// and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
					storageOwner.appendChild(storage)
					storage.addBehavior('#default#userData')
					storage.load(localStorageName)
					var result = storeFunction.apply(store, args)
					storageOwner.removeChild(storage)
					return result
				}
			}
	
			// In IE7, keys cannot start with a digit or contain certain chars.
			// See https://github.com/marcuswestin/store.js/issues/40
			// See https://github.com/marcuswestin/store.js/issues/83
			var forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g")
			var ieKeyFix = function(key) {
				return key.replace(/^d/, '___$&').replace(forbiddenCharsRegex, '___')
			}
			store.set = withIEStorage(function(storage, key, val) {
				key = ieKeyFix(key)
				if (val === undefined) { return store.remove(key) }
				storage.setAttribute(key, store.serialize(val))
				storage.save(localStorageName)
				return val
			})
			store.get = withIEStorage(function(storage, key, defaultVal) {
				key = ieKeyFix(key)
				var val = store.deserialize(storage.getAttribute(key))
				return (val === undefined ? defaultVal : val)
			})
			store.remove = withIEStorage(function(storage, key) {
				key = ieKeyFix(key)
				storage.removeAttribute(key)
				storage.save(localStorageName)
			})
			store.clear = withIEStorage(function(storage) {
				var attributes = storage.XMLDocument.documentElement.attributes
				storage.load(localStorageName)
				for (var i=attributes.length-1; i>=0; i--) {
					storage.removeAttribute(attributes[i].name)
				}
				storage.save(localStorageName)
			})
			store.getAll = function(storage) {
				var ret = {}
				store.forEach(function(key, val) {
					ret[key] = val
				})
				return ret
			}
			store.forEach = withIEStorage(function(storage, callback) {
				var attributes = storage.XMLDocument.documentElement.attributes
				for (var i=0, attr; attr=attributes[i]; ++i) {
					callback(attr.name, store.deserialize(storage.getAttribute(attr.name)))
				}
			})
		}
	
		try {
			var testKey = '__storejs__'
			store.set(testKey, testKey)
			if (store.get(testKey) != testKey) { store.disabled = true }
			store.remove(testKey)
		} catch(e) {
			store.disabled = true
		}
		store.enabled = !store.disabled
		
		return store
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 357 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  console.warn("Using browser-only version of superagent in non-browser environment");
	  root = this;
	}
	
	var Emitter = __webpack_require__(153);
	var requestBase = __webpack_require__(359);
	var isObject = __webpack_require__(151);
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Expose `request`.
	 */
	
	var request = module.exports = __webpack_require__(360).bind(null, Request);
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  throw Error("Browser-only verison of superagent could not find XHR");
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    pushEncodedKeyValuePair(pairs, key, obj[key]);
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (val != null) {
	    if (Array.isArray(val)) {
	      val.forEach(function(v) {
	        pushEncodedKeyValuePair(pairs, key, v);
	      });
	    } else if (isObject(val)) {
	      for(var subkey in val) {
	        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
	      }
	    } else {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(val));
	    }
	  } else if (val === null) {
	    pairs.push(encodeURIComponent(key));
	  }
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var pair;
	  var pos;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    pos = pair.indexOf('=');
	    if (pos == -1) {
	      obj[decodeURIComponent(pair)] = '';
	    } else {
	      obj[decodeURIComponent(pair.slice(0, pos))] =
	        decodeURIComponent(pair.slice(pos + 1));
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return str.split(/ *; */).reduce(function(obj, str){
	    var parts = str.split(/ *= */),
	        key = parts.shift(),
	        val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this._setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this._setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this._parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype._setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype._parseBody = function(str){
	  var parse = request.parse[this.type];
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype._setStatusProperties = function(status){
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = this.statusCode = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
	      // issue #876: return the http status code if the response parsing fails
	      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    var new_err;
	    try {
	      if (res.status < 200 || res.status >= 300) {
	        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	        new_err.original = err;
	        new_err.response = res;
	        new_err.status = res.status;
	      }
	    } catch(e) {
	      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
	    }
	
	    // #1000 don't catch errors from the callback to avoid double calling it
	    if (new_err) {
	      self.callback(new_err, res);
	    } else {
	      self.callback(null, res);
	    }
	  });
	}
	
	/**
	 * Mixin `Emitter` and `requestBase`.
	 */
	
	Emitter(Request.prototype);
	for (var key in requestBase) {
	  Request.prototype[key] = requestBase[key];
	}
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set responseType to `val`. Presently valid responseTypes are 'blob' and
	 * 'arraybuffer'.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (!options) {
	    options = {
	      type: 'basic'
	    }
	  }
	
	  switch (options.type) {
	    case 'basic':
	      var str = btoa(user + ':' + pass);
	      this.set('Authorization', 'Basic ' + str);
	    break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	    break;
	  }
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  this._getFormData().append(field, file, filename || file.name);
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype._timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Compose querystring to append to req.url
	 *
	 * @api private
	 */
	
	Request.prototype._appendQueryString = function(){
	  var query = this._query.join('&');
	  if (query) {
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (0 == status) {
	      if (self.timedout) return self._timeoutError();
	      if (self._aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(direction, e) {
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = direction;
	    self.emit('progress', e);
	  }
	  if (this.hasListeners('progress')) {
	    try {
	      xhr.onprogress = handleProgress.bind(null, 'download');
	      if (xhr.upload) {
	        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
	      }
	    } catch(e) {
	      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	      // Reported here:
	      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	    }
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  this._appendQueryString();
	
	  // initiate request
	  if (this.username && this.password) {
	    xhr.open(this.method, this.url, true, this.username, this.password);
	  } else {
	    xhr.open(this.method, this.url, true);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * OPTIONS query to `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.options = function(url, data, fn){
	  var req = request('OPTIONS', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(151);
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.clearTimeout = function _clearTimeout(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Override default response body parser
	 *
	 * This function will be called to convert incoming data into request.body
	 *
	 * @param {Function}
	 * @api public
	 */
	
	exports.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Override default request body serializer
	 *
	 * This function will be called to convert data set via .send or .attach into payload to send
	 *
	 * @param {Function}
	 * @api public
	 */
	
	exports.serialize = function serialize(fn){
	  this._serializer = fn;
	  return this;
	};
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.timeout = function timeout(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Promise support
	 *
	 * @param {Function} resolve
	 * @param {Function} reject
	 * @return {Request}
	 */
	
	exports.then = function then(resolve, reject) {
	  if (!this._fullfilledPromise) {
	    var self = this;
	    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
	      self.end(function(err, res){
	        if (err) innerReject(err); else innerResolve(res);
	      });
	    });
	  }
	  return this._fullfilledPromise.then(resolve, reject);
	}
	
	exports.catch = function(cb) {
	  return this.then(undefined, cb);
	};
	
	/**
	 * Allow for extension
	 */
	
	exports.use = function use(fn) {
	  fn(this);
	  return this;
	}
	
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	exports.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	exports.getHeader = exports.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	exports.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val`, or multiple fields with one object
	 * for "multipart/form-data" request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 *
	 * request.post('/upload')
	 *   .field({ foo: 'bar', baz: 'qux' })
	 *   .end(callback);
	 * ```
	 *
	 * @param {String|Object} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	exports.field = function(name, val) {
	
	  // name should be either a string or an object.
	  if (null === name ||  undefined === name) {
	    throw new Error('.field(name, val) name can not be empty');
	  }
	
	  if (isObject(name)) {
	    for (var key in name) {
	      this.field(key, name[key]);
	    }
	    return this;
	  }
	
	  // val should be defined now
	  if (null === val || undefined === val) {
	    throw new Error('.field(name, val) val can not be empty');
	  }
	  this._getFormData().append(name, val);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	exports.abort = function(){
	  if (this._aborted) {
	    return this;
	  }
	  this._aborted = true;
	  this.xhr && this.xhr.abort(); // browser
	  this.req && this.req.abort(); // node
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	exports.withCredentials = function(){
	  // This is browser-only functionality. Node side is no-op.
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Set the max redirects to `n`. Does noting in browser XHR implementation.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.redirects = function(n){
	  this._maxRedirects = n;
	  return this;
	};
	
	/**
	 * Convert to a plain javascript object (not JSON string) of scalar properties.
	 * Note as this method is designed to return a useful non-this value,
	 * it cannot be chained.
	 *
	 * @return {Object} describing method, url, and data of this request
	 * @api public
	 */
	
	exports.toJSON = function(){
	  return {
	    method: this.method,
	    url: this.url,
	    data: this._data,
	    headers: this._header
	  };
	};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	exports._isHost = function _isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	 *      request.post('/user')
	 *        .send('name=tobi')
	 *        .send('species=ferret')
	 *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.send = function(data){
	  var obj = isObject(data);
	  var type = this._header['content-type'];
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    // default to x-www-form-urlencoded
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj || this._isHost(data)) return this;
	
	  // default to json
	  if (!type) this.type('json');
	  return this;
	};


/***/ },
/* 360 */
/***/ function(module, exports) {

	// The node and browser modules expose versions of this with the
	// appropriate constructor function bound as first argument
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(RequestConstructor, method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new RequestConstructor('GET', method).end(url);
	  }
	
	  // url first
	  if (2 == arguments.length) {
	    return new RequestConstructor('GET', method);
	  }
	
	  return new RequestConstructor(method, url);
	}
	
	module.exports = request;


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(362);


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(363);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(340)(module)))

/***/ },
/* 363 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	var each = __webpack_require__(365).coordEach;
	
	/**
	 * Takes any {@link GeoJSON} object, calculates the extent of all input features, and returns a bounding box.
	 *
	 * @module turf/extent
	 * @category measurement
	 * @param {GeoJSON} input any valid GeoJSON Object
	 * @return {Array<number>} the bounding box of `input` given
	 * as an array in WSEN order (west, south, east, north)
	 * @example
	 * var input = {
	 *   "type": "FeatureCollection",
	 *   "features": [
	 *     {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [114.175329, 22.2524]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [114.170007, 22.267969]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [114.200649, 22.274641]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [114.186744, 22.265745]
	 *       }
	 *     }
	 *   ]
	 * };
	 *
	 * var bbox = turf.extent(input);
	 *
	 * var bboxPolygon = turf.bboxPolygon(bbox);
	 *
	 * var resultFeatures = input.features.concat(bboxPolygon);
	 * var result = {
	 *   "type": "FeatureCollection",
	 *   "features": resultFeatures
	 * };
	 *
	 * //=result
	 */
	module.exports = function(layer) {
	    var extent = [Infinity, Infinity, -Infinity, -Infinity];
	    each(layer, function(coord) {
	      if (extent[0] > coord[0]) extent[0] = coord[0];
	      if (extent[1] > coord[1]) extent[1] = coord[1];
	      if (extent[2] < coord[0]) extent[2] = coord[0];
	      if (extent[3] < coord[1]) extent[3] = coord[1];
	    });
	    return extent;
	};


/***/ },
/* 365 */
/***/ function(module, exports) {

	/**
	 * Lazily iterate over coordinates in any GeoJSON object, similar to
	 * Array.forEach.
	 *
	 * @param {Object} layer any GeoJSON object
	 * @param {Function} callback a method that takes (value)
	 * @param {boolean=} excludeWrapCoord whether or not to include
	 * the final coordinate of LinearRings that wraps the ring in its iteration.
	 * @example
	 * var point = { type: 'Point', coordinates: [0, 0] };
	 * coordEach(point, function(coords) {
	 *   // coords is equal to [0, 0]
	 * });
	 */
	function coordEach(layer, callback, excludeWrapCoord) {
	  var i, j, k, g, geometry, stopG, coords,
	    geometryMaybeCollection,
	    wrapShrink = 0,
	    isGeometryCollection,
	    isFeatureCollection = layer.type === 'FeatureCollection',
	    isFeature = layer.type === 'Feature',
	    stop = isFeatureCollection ? layer.features.length : 1;
	
	  // This logic may look a little weird. The reason why it is that way
	  // is because it's trying to be fast. GeoJSON supports multiple kinds
	  // of objects at its root: FeatureCollection, Features, Geometries.
	  // This function has the responsibility of handling all of them, and that
	  // means that some of the `for` loops you see below actually just don't apply
	  // to certain inputs. For instance, if you give this just a
	  // Point geometry, then both loops are short-circuited and all we do
	  // is gradually rename the input until it's called 'geometry'.
	  //
	  // This also aims to allocate as few resources as possible: just a
	  // few numbers and booleans, rather than any temporary arrays as would
	  // be required with the normalization approach.
	  for (i = 0; i < stop; i++) {
	
	    geometryMaybeCollection = (isFeatureCollection ? layer.features[i].geometry :
	        (isFeature ? layer.geometry : layer));
	    isGeometryCollection = geometryMaybeCollection.type === 'GeometryCollection';
	    stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
	
	    for (g = 0; g < stopG; g++) {
	
	      geometry = isGeometryCollection ?
	          geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
	      coords = geometry.coordinates;
	
	      wrapShrink = (excludeWrapCoord &&
	        (geometry.type === 'Polygon' || geometry.type === 'MultiPolygon')) ?
	        1 : 0;
	
	      if (geometry.type === 'Point') {
	        callback(coords);
	      } else if (geometry.type === 'LineString' || geometry.type === 'MultiPoint') {
	        for (j = 0; j < coords.length; j++) callback(coords[j]);
	      } else if (geometry.type === 'Polygon' || geometry.type === 'MultiLineString') {
	        for (j = 0; j < coords.length; j++)
	          for (k = 0; k < coords[j].length - wrapShrink; k++)
	            callback(coords[j][k]);
	      } else if (geometry.type === 'MultiPolygon') {
	        for (j = 0; j < coords.length; j++)
	          for (k = 0; k < coords[j].length; k++)
	            for (l = 0; l < coords[j][k].length - wrapShrink; l++)
	              callback(coords[j][k][l]);
	      } else {
	        throw new Error('Unknown Geometry Type');
	      }
	    }
	  }
	}
	module.exports.coordEach = coordEach;
	
	/**
	 * Lazily reduce coordinates in any GeoJSON object into a single value,
	 * similar to how Array.reduce works. However, in this case we lazily run
	 * the reduction, so an array of all coordinates is unnecessary.
	 *
	 * @param {Object} layer any GeoJSON object
	 * @param {Function} callback a method that takes (memo, value) and returns
	 * a new memo
	 * @param {boolean=} excludeWrapCoord whether or not to include
	 * the final coordinate of LinearRings that wraps the ring in its iteration.
	 * @param {*} memo the starting value of memo: can be any type.
	 */
	function coordReduce(layer, callback, memo, excludeWrapCoord) {
	  coordEach(layer, function(coord) {
	    memo = callback(memo, coord);
	  }, excludeWrapCoord);
	  return memo;
	}
	module.exports.coordReduce = coordReduce;
	
	/**
	 * Lazily iterate over property objects in any GeoJSON object, similar to
	 * Array.forEach.
	 *
	 * @param {Object} layer any GeoJSON object
	 * @param {Function} callback a method that takes (value)
	 * @example
	 * var point = { type: 'Feature', geometry: null, properties: { foo: 1 } };
	 * propEach(point, function(props) {
	 *   // props is equal to { foo: 1}
	 * });
	 */
	function propEach(layer, callback) {
	  var i;
	  switch (layer.type) {
	      case 'FeatureCollection':
	        features = layer.features;
	        for (i = 0; i < layer.features.length; i++) {
	            callback(layer.features[i].properties);
	        }
	        break;
	      case 'Feature':
	        callback(layer.properties);
	        break;
	  }
	}
	module.exports.propEach = propEach;
	
	/**
	 * Lazily reduce properties in any GeoJSON object into a single value,
	 * similar to how Array.reduce works. However, in this case we lazily run
	 * the reduction, so an array of all properties is unnecessary.
	 *
	 * @param {Object} layer any GeoJSON object
	 * @param {Function} callback a method that takes (memo, coord) and returns
	 * a new memo
	 * @param {*} memo the starting value of memo: can be any type.
	 */
	function propReduce(layer, callback, memo) {
	  propEach(layer, function(prop) {
	    memo = callback(memo, prop);
	  });
	  return memo;
	}
	module.exports.propReduce = propReduce;


/***/ },
/* 366 */
13,
/* 367 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** static/js/main.a13251f9.js
 **/